import * as React$4 from 'react';
import React__default, { createContext, useContext, useLayoutEffect, useEffect, useRef, useCallback, useMemo, forwardRef, createElement, useState, cloneElement, Children, isValidElement, Component, useImperativeHandle, Fragment, useReducer } from 'react';

function ownKeys$i(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) {
      _defineProperty$h(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$3(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty$h(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$d() {
  _extends$d = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$d.apply(this, arguments);
}

function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$3(subClass, superClass);
}

function _getPrototypeOf$3(o) {
  _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$3(o);
}

function _setPrototypeOf$3(o, p) {
  _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$3(o, p);
}

function _isNativeReflectConstruct$4() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$3(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$3(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$3(self);
}

function _createSuper$4(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$4();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$3(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$3(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$3(this, result);
  };
}

function _slicedToArray$4(arr, i) {
  return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$7(arr, i) || _nonIterableRest$4();
}

function _toConsumableArray$5(arr) {
  return _arrayWithoutHoles$5(arr) || _iterableToArray$6(arr) || _unsupportedIterableToArray$7(arr) || _nonIterableSpread$5();
}

function _arrayWithoutHoles$5(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$7(arr);
}

function _arrayWithHoles$4(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray$6(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit$4(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$7(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$7(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen);
}

function _arrayLikeToArray$7(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread$5() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest$4() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function useDimensions$1() {
  var _React$useState = React$4.useState({
    width: undefined,
    height: undefined
  }),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      windowSize = _React$useState2[0],
      setWindowSize = _React$useState2[1];
  React$4.useEffect(function () {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
}

var Colors = {
  BLUE: '#0098DB',
  LIGHT_BLUE: '#E4F3FA',
  GREY: '#37424A',
  BLACK: '#333333',
  YELLOW: '#FEE000',
  ORANGE: '#FF9932',
  GREEN: '#00CA8B',
  WHITE: '#FFFFFF',
  PURPLE: '#FF3699',
  GRADIENT: '#E5F4FB',
  BLUE_GREY: '#F6F8FB',
  LIGHT_GREY: '#FBFBFB',
  MEDIUM_GREY: '#CCCCCC',
  LIGHT_WHITE: '#F5F5F5',
  DARK_GREY: '#88888D',
  MEDIUM_WHITE: '#EFEFEF',
  DARK_WHITE: '#898B8F',
  RED: '#EF6B6B',
  MEDIUM_BLUE: '#007DC1',
  LIGHT_GREEN: '#CCF4E8'
};

var keyObject = {
  BLUE: 'blue',
  GREEN: 'green',
  PURPLE: 'purple',
  WHITE: 'white',
  RED: 'red',
  GREY: 'grey',
  YELLOW: 'yellow',
  ORANGE: 'orange',
  CUSTOM_YELLOW_ORANGE: 'custom-yellow-orange',
  WHITE_INVERT: 'white-invert',
  PURPLE_INVERT: 'purple-invert'
};
var ColorSchemesArray = [{
  type: 'blue',
  vibrant: Colors.BLUE,
  delicate: "".concat(Colors.BLUE, "25"),
  dark_shade: '#4db7e6',
  text: Colors.WHITE,
  border: Colors.BLUE
}, {
  type: 'green',
  vibrant: Colors.GREEN,
  delicate: "".concat(Colors.GREEN, "25"),
  dark_shade: '#00AF78',
  text: Colors.WHITE,
  border: Colors.GREEN
}, {
  type: 'purple',
  vibrant: Colors.PURPLE,
  delicate: "".concat(Colors.PURPLE, "25"),
  dark_shade: '#ff72b8',
  text: Colors.WHITE,
  border: Colors.PURPLE
}, {
  type: 'white',
  vibrant: Colors.WHITE,
  delicate: "".concat(Colors.WHITE, "25"),
  dark_shade: Colors.MEDIUM_WHITE,
  text: Colors.MEDIUM_GREY,
  border: Colors.MEDIUM_WHITE
}, {
  type: 'red',
  vibrant: Colors.RED,
  delicate: "".concat(Colors.RED, "25"),
  dark_shade: Colors.RED,
  text: Colors.WHITE,
  border: Colors.RED
}, {
  type: 'grey',
  vibrant: Colors.MEDIUM_GREY,
  delicate: "".concat(Colors.MEDIUM_GREY, "25"),
  dark_shade: Colors.MEDIUM_GREY,
  text: Colors.DARK_GREY,
  border: Colors.MEDIUM_GREY
}, {
  type: 'yellow',
  vibrant: Colors.YELLOW,
  delicate: "".concat(Colors.YELLOW, "25"),
  dark_shade: Colors.YELLOW,
  text: Colors.WHITE,
  border: Colors.YELLOW
}, {
  type: 'orange',
  vibrant: Colors.ORANGE,
  delicate: "".concat(Colors.ORANGE, "25"),
  dark_shade: Colors.ORANGE,
  text: Colors.WHITE,
  border: Colors.ORANGE
}, {
  type: 'custom-yellow-orange',
  vibrant: Colors.WHITE,
  delicate: '#FABE38',
  dark_shade: Colors.MEDIUM_WHITE,
  text: '#FABE38',
  border: Colors.WHITE
}, {
  type: 'white-invert',
  vibrant: 'transparent',
  delicate: "".concat(Colors.WHITE, "25"),
  dark_shade: Colors.MEDIUM_WHITE,
  text: Colors.WHITE,
  border: Colors.WHITE
}, {
  type: 'purple-invert',
  vibrant: 'transparent',
  delicate: "".concat(Colors.PURPLE, "25"),
  dark_shade: Colors.PURPLE,
  text: Colors.PURPLE,
  border: Colors.PURPLE
}];

var getColorScheme$1 = function getColorScheme(name) {
  return ColorSchemesArray.find(function (e) {
    return e.type === name;
  });
};
var ColorSchemes = keyObject;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var htmlReactParser = {exports: {}};

var lib$2 = {};

var possibleStandardNamesOptimized$1 = {};

var SAME$1 = 0;
possibleStandardNamesOptimized$1.SAME = SAME$1;
var CAMELCASE$1 = 1;
possibleStandardNamesOptimized$1.CAMELCASE = CAMELCASE$1;
possibleStandardNamesOptimized$1.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  'accept-charset': 'acceptCharset',
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: 'className',
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: 'htmlFor',
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  'http-equiv': 'httpEquiv',
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  'accent-height': 'accentHeight',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  'alignment-baseline': 'alignmentBaseline',
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  'arabic-form': 'arabicForm',
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  'baseline-shift': 'baselineShift',
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  'cap-height': 'capHeight',
  clip: 0,
  clipPath: 1,
  'clip-path': 'clipPath',
  clipPathUnits: 1,
  clipRule: 1,
  'clip-rule': 'clipRule',
  color: 0,
  colorInterpolation: 1,
  'color-interpolation': 'colorInterpolation',
  colorInterpolationFilters: 1,
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorProfile: 1,
  'color-profile': 'colorProfile',
  colorRendering: 1,
  'color-rendering': 'colorRendering',
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  'dominant-baseline': 'dominantBaseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  'enable-background': 'enableBackground',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  'fill-opacity': 'fillOpacity',
  fillRule: 1,
  'fill-rule': 'fillRule',
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  'flood-opacity': 'floodOpacity',
  floodColor: 1,
  'flood-color': 'floodColor',
  focusable: 0,
  fontFamily: 1,
  'font-family': 'fontFamily',
  fontSize: 1,
  'font-size': 'fontSize',
  fontSizeAdjust: 1,
  'font-size-adjust': 'fontSizeAdjust',
  fontStretch: 1,
  'font-stretch': 'fontStretch',
  fontStyle: 1,
  'font-style': 'fontStyle',
  fontVariant: 1,
  'font-variant': 'fontVariant',
  fontWeight: 1,
  'font-weight': 'fontWeight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  'glyph-name': 'glyphName',
  glyphOrientationHorizontal: 1,
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphOrientationVertical: 1,
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  'horiz-adv-x': 'horizAdvX',
  horizOriginX: 1,
  'horiz-origin-x': 'horizOriginX',
  ideographic: 0,
  imageRendering: 1,
  'image-rendering': 'imageRendering',
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  'letter-spacing': 'letterSpacing',
  lightingColor: 1,
  'lighting-color': 'lightingColor',
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  'marker-end': 'markerEnd',
  markerHeight: 1,
  markerMid: 1,
  'marker-mid': 'markerMid',
  markerStart: 1,
  'marker-start': 'markerStart',
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  'overline-position': 'overlinePosition',
  overlineThickness: 1,
  'overline-thickness': 'overlineThickness',
  paintOrder: 1,
  'paint-order': 'paintOrder',
  panose1: 0,
  'panose-1': 'panose1',
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  'pointer-events': 'pointerEvents',
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  'rendering-intent': 'renderingIntent',
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  'shape-rendering': 'shapeRendering',
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  'stop-color': 'stopColor',
  stopOpacity: 1,
  'stop-opacity': 'stopOpacity',
  strikethroughPosition: 1,
  'strikethrough-position': 'strikethroughPosition',
  strikethroughThickness: 1,
  'strikethrough-thickness': 'strikethroughThickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  'stroke-dasharray': 'strokeDasharray',
  strokeDashoffset: 1,
  'stroke-dashoffset': 'strokeDashoffset',
  strokeLinecap: 1,
  'stroke-linecap': 'strokeLinecap',
  strokeLinejoin: 1,
  'stroke-linejoin': 'strokeLinejoin',
  strokeMiterlimit: 1,
  'stroke-miterlimit': 'strokeMiterlimit',
  strokeWidth: 1,
  'stroke-width': 'strokeWidth',
  strokeOpacity: 1,
  'stroke-opacity': 'strokeOpacity',
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  'text-anchor': 'textAnchor',
  textDecoration: 1,
  'text-decoration': 'textDecoration',
  textLength: 1,
  textRendering: 1,
  'text-rendering': 'textRendering',
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  'underline-position': 'underlinePosition',
  underlineThickness: 1,
  'underline-thickness': 'underlineThickness',
  unicode: 0,
  unicodeBidi: 1,
  'unicode-bidi': 'unicodeBidi',
  unicodeRange: 1,
  'unicode-range': 'unicodeRange',
  unitsPerEm: 1,
  'units-per-em': 'unitsPerEm',
  unselectable: 0,
  vAlphabetic: 1,
  'v-alphabetic': 'vAlphabetic',
  values: 0,
  vectorEffect: 1,
  'vector-effect': 'vectorEffect',
  version: 0,
  vertAdvY: 1,
  'vert-adv-y': 'vertAdvY',
  vertOriginX: 1,
  'vert-origin-x': 'vertOriginX',
  vertOriginY: 1,
  'vert-origin-y': 'vertOriginY',
  vHanging: 1,
  'v-hanging': 'vHanging',
  vIdeographic: 1,
  'v-ideographic': 'vIdeographic',
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  'v-mathematical': 'vMathematical',
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  'word-spacing': 'wordSpacing',
  writingMode: 1,
  'writing-mode': 'writingMode',
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  'x-height': 'xHeight',
  xlinkActuate: 1,
  'xlink:actuate': 'xlinkActuate',
  xlinkArcrole: 1,
  'xlink:arcrole': 'xlinkArcrole',
  xlinkHref: 1,
  'xlink:href': 'xlinkHref',
  xlinkRole: 1,
  'xlink:role': 'xlinkRole',
  xlinkShow: 1,
  'xlink:show': 'xlinkShow',
  xlinkTitle: 1,
  'xlink:title': 'xlinkTitle',
  xlinkType: 1,
  'xlink:type': 'xlinkType',
  xmlBase: 1,
  'xml:base': 'xmlBase',
  xmlLang: 1,
  'xml:lang': 'xmlLang',
  xmlns: 0,
  'xml:space': 'xmlSpace',
  xmlnsXlink: 1,
  'xmlns:xlink': 'xmlnsXlink',
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};

Object.defineProperty(lib$2, '__esModule', { value: true });
function _slicedToArray$3(arr, i) {
  return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$3();
}
function _arrayWithHoles$3(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$3(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray$6(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen);
}
function _arrayLikeToArray$6(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest$3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var RESERVED = 0;
var STRING = 1;
var BOOLEANISH_STRING = 2;
var BOOLEAN = 3;
var OVERLOADED_BOOLEAN = 4;
var NUMERIC = 5;
var POSITIVE_NUMERIC = 6;
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}
function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
}
var properties = {};
var reservedProps = ['children', 'dangerouslySetInnerHTML',
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
reservedProps.forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false,
  name,
  null,
  false,
  false);
});
[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
  var _ref2 = _slicedToArray$3(_ref, 2),
      name = _ref2[0],
      attributeName = _ref2[1];
  properties[name] = new PropertyInfoRecord(name, STRING, false,
  attributeName,
  null,
  false,
  false);
});
['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
  name.toLowerCase(),
  null,
  false,
  false);
});
['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
  name,
  null,
  false,
  false);
});
['allowFullScreen', 'async',
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless',
'itemScope'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false,
  name.toLowerCase(),
  null,
  false,
  false);
});
['checked',
'multiple', 'muted', 'selected'
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true,
  name,
  null,
  false,
  false);
});
['capture', 'download'
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false,
  name,
  null,
  false,
  false);
});
['cols', 'rows', 'size', 'span'
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false,
  name,
  null,
  false,
  false);
});
['rowSpan', 'start'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false,
  name.toLowerCase(),
  null,
  false,
  false);
});
var CAMELIZE = /[\-\:]([a-z])/g;
var capitalize$2 = function capitalize(token) {
  return token[1].toUpperCase();
};
['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height'
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize$2);
  properties[name] = new PropertyInfoRecord(name, STRING, false,
  attributeName, null,
  false,
  false);
});
['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type'
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize$2);
  properties[name] = new PropertyInfoRecord(name, STRING, false,
  attributeName, 'http://www.w3.org/1999/xlink', false,
  false);
});
['xml:base', 'xml:lang', 'xml:space'
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize$2);
  properties[name] = new PropertyInfoRecord(name, STRING, false,
  attributeName, 'http://www.w3.org/XML/1998/namespace', false,
  false);
});
['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
  attributeName.toLowerCase(),
  null,
  false,
  false);
});
var xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false,
'xlink:href', 'http://www.w3.org/1999/xlink', true,
false);
['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
  attributeName.toLowerCase(),
  null,
  true,
  true);
});
var _require$2 = possibleStandardNamesOptimized$1,
    CAMELCASE = _require$2.CAMELCASE,
    SAME = _require$2.SAME,
    possibleStandardNamesOptimized = _require$2.possibleStandardNames;
var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
var isCustomAttribute = RegExp.prototype.test.bind(
new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
var possibleStandardNames = Object.keys(possibleStandardNamesOptimized).reduce(function (accumulator, standardName) {
  var propName = possibleStandardNamesOptimized[standardName];
  if (propName === SAME) {
    accumulator[standardName] = standardName;
  } else if (propName === CAMELCASE) {
    accumulator[standardName.toLowerCase()] = standardName;
  } else {
    accumulator[standardName] = propName;
  }
  return accumulator;
}, {});
lib$2.BOOLEAN = BOOLEAN;
lib$2.BOOLEANISH_STRING = BOOLEANISH_STRING;
lib$2.NUMERIC = NUMERIC;
lib$2.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
lib$2.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
lib$2.RESERVED = RESERVED;
lib$2.STRING = STRING;
lib$2.getPropertyInfo = getPropertyInfo;
lib$2.isCustomAttribute = isCustomAttribute;
lib$2.possibleStandardNames = possibleStandardNames;

var cjs = {};

var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;
var TRIM_REGEX = /^\s+|\s+$/g;
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';
var inlineStyleParser = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (!style) return [];
  options = options || {};
  var lineno = 1;
  var column = 1;
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }
  Position.prototype.content = style;
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;
    if (options.silent) ; else {
      throw err;
    }
  }
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }
  function whitespace() {
    match(WHITESPACE_REGEX);
  }
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;
    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }
    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;
    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }
  function declaration() {
    var pos = position();
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();
    if (!match(COLON_REGEX)) return error("property missing ':'");
    var val = match(VALUE_REGEX);
    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });
    match(SEMICOLON_REGEX);
    return ret;
  }
  function declarations() {
    var decls = [];
    comments(decls);
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }
    return decls;
  }
  whitespace();
  return declarations();
};
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}

var parse$1 = inlineStyleParser;
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }
  var declaration;
  var declarations = parse$1(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;
  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;
    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }
  return output;
}
var styleToObject = StyleToObject;

var utilities$4 = {};

utilities$4.__esModule = true;
utilities$4.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var HYPHEN_REGEX = /-([a-z])/g;
var NO_HYPHEN_REGEX = /^[^-]+$/;
var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var skipCamelCase = function (property) {
    return !property ||
        NO_HYPHEN_REGEX.test(property) ||
        CUSTOM_PROPERTY_REGEX.test(property);
};
var capitalize$1 = function (match, character) {
    return character.toUpperCase();
};
var trimHyphen = function (match, prefix) { return "".concat(prefix, "-"); };
var camelCase = function (property, options) {
    if (options === void 0) { options = {}; }
    if (skipCamelCase(property)) {
        return property;
    }
    property = property.toLowerCase();
    if (options.reactCompat) {
        property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
    }
    else {
        property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    }
    return property.replace(HYPHEN_REGEX, capitalize$1);
};
utilities$4.camelCase = camelCase;

(function (exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var style_to_object_1 = __importDefault(styleToObject);
var utilities_1 = utilities$4;
function StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') {
        return output;
    }
    (0, style_to_object_1["default"])(style, function (property, value) {
        if (property && value) {
            output[(0, utilities_1.camelCase)(property, options)] = value;
        }
    });
    return output;
}
exports["default"] = StyleToJS;
}(cjs));
getDefaultExportFromCjs(cjs);

var React$3 = React__default;
var styleToJS = cjs.default;
function invertObject(obj, override) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('First argument must be an object');
  }
  var key;
  var value;
  var isOverridePresent = typeof override === 'function';
  var overrides = {};
  var result = {};
  for (key in obj) {
    value = obj[key];
    if (isOverridePresent) {
      overrides = override(key, value);
      if (overrides && overrides.length === 2) {
        result[overrides[0]] = overrides[1];
        continue;
      }
    }
    if (typeof value === 'string') {
      result[value] = key;
    }
  }
  return result;
}
function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return props && typeof props.is === 'string';
  }
  switch (tagName) {
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;
    default:
      return true;
  }
}
var styleToJSOptions = { reactCompat: true };
function setStyleProp$1(style, props) {
  if (style === null || style === undefined) {
    return;
  }
  try {
    props.style = styleToJS(style, styleToJSOptions);
  } catch (err) {
    props.style = {};
  }
}
var PRESERVE_CUSTOM_ATTRIBUTES = React$3.version.split('.')[0] >= 16;
var elementsWithNoTextChildren = new Set([
  'tr',
  'tbody',
  'thead',
  'tfoot',
  'colgroup',
  'table',
  'head',
  'html',
  'frameset'
]);
function canTextBeChildOfNode$1(node) {
  return !elementsWithNoTextChildren.has(node.name);
}
var utilities$3 = {
  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
  invertObject: invertObject,
  isCustomComponent: isCustomComponent,
  setStyleProp: setStyleProp$1,
  canTextBeChildOfNode: canTextBeChildOfNode$1,
  elementsWithNoTextChildren: elementsWithNoTextChildren
};

var reactProperty = lib$2;
var utilities$2 = utilities$3;
var attributesToProps$2 = function attributesToProps(attributes) {
  attributes = attributes || {};
  var valueOnlyInputs = {
    reset: true,
    submit: true
  };
  var attributeName;
  var attributeNameLowerCased;
  var attributeValue;
  var propName;
  var propertyInfo;
  var props = {};
  var inputIsValueOnly = attributes.type && valueOnlyInputs[attributes.type];
  for (attributeName in attributes) {
    attributeValue = attributes[attributeName];
    if (reactProperty.isCustomAttribute(attributeName)) {
      props[attributeName] = attributeValue;
      continue;
    }
    attributeNameLowerCased = attributeName.toLowerCase();
    propName = getPropName(attributeNameLowerCased);
    if (propName) {
      propertyInfo = reactProperty.getPropertyInfo(propName);
      if (
        (propName === 'checked' || propName === 'value') &&
        !inputIsValueOnly
      ) {
        propName = getPropName('default' + attributeNameLowerCased);
      }
      props[propName] = attributeValue;
      switch (propertyInfo && propertyInfo.type) {
        case reactProperty.BOOLEAN:
          props[propName] = true;
          break;
        case reactProperty.OVERLOADED_BOOLEAN:
          if (attributeValue === '') {
            props[propName] = true;
          }
          break;
      }
      continue;
    }
    if (utilities$2.PRESERVE_CUSTOM_ATTRIBUTES) {
      props[attributeName] = attributeValue;
    }
  }
  utilities$2.setStyleProp(attributes.style, props);
  return props;
};
function getPropName(attributeName) {
  return reactProperty.possibleStandardNames[attributeName];
}

var React$2 = React__default;
var attributesToProps$1 = attributesToProps$2;
var utilities$1 = utilities$3;
var setStyleProp = utilities$1.setStyleProp;
var canTextBeChildOfNode = utilities$1.canTextBeChildOfNode;
function domToReact$1(nodes, options) {
  options = options || {};
  var library = options.library || React$2;
  var cloneElement = library.cloneElement;
  var createElement = library.createElement;
  var isValidElement = library.isValidElement;
  var result = [];
  var node;
  var isWhitespace;
  var hasReplace = typeof options.replace === 'function';
  var replaceElement;
  var props;
  var children;
  var trim = options.trim;
  for (var i = 0, len = nodes.length; i < len; i++) {
    node = nodes[i];
    if (hasReplace) {
      replaceElement = options.replace(node);
      if (isValidElement(replaceElement)) {
        if (len > 1) {
          replaceElement = cloneElement(replaceElement, {
            key: replaceElement.key || i
          });
        }
        result.push(replaceElement);
        continue;
      }
    }
    if (node.type === 'text') {
      isWhitespace = !node.data.trim().length;
      if (isWhitespace && node.parent && !canTextBeChildOfNode(node.parent)) {
        continue;
      }
      if (trim && isWhitespace) {
        continue;
      }
      result.push(node.data);
      continue;
    }
    props = node.attribs;
    if (skipAttributesToProps(node)) {
      setStyleProp(props.style, props);
    } else if (props) {
      props = attributesToProps$1(props);
    }
    children = null;
    switch (node.type) {
      case 'script':
      case 'style':
        if (node.children[0]) {
          props.dangerouslySetInnerHTML = {
            __html: node.children[0].data
          };
        }
        break;
      case 'tag':
        if (node.name === 'textarea' && node.children[0]) {
          props.defaultValue = node.children[0].data;
        } else if (node.children && node.children.length) {
          children = domToReact$1(node.children, options);
        }
        break;
      default:
        continue;
    }
    if (len > 1) {
      props.key = i;
    }
    result.push(createElement(node.name, props, children));
  }
  return result.length === 1 ? result[0] : result;
}
function skipAttributesToProps(node) {
  return (
    utilities$1.PRESERVE_CUSTOM_ATTRIBUTES &&
    node.type === 'tag' &&
    utilities$1.isCustomComponent(node.name, node.attribs)
  );
}
var domToReact_1 = domToReact$1;

var Parser$2 = {};

var Tokenizer$1 = {};

var decode_codepoint = {};

Object.defineProperty(decode_codepoint, "__esModule", { value: true });
var decodeMap = new Map([
    [0, 65533],
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376],
]);
var fromCodePoint =
String.fromCodePoint ||
    function (codePoint) {
        var output = "";
        if (codePoint > 0xffff) {
            codePoint -= 0x10000;
            output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
            codePoint = 0xdc00 | (codePoint & 0x3ff);
        }
        output += String.fromCharCode(codePoint);
        return output;
    };
function decodeCodePoint(codePoint) {
    var _a;
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }
    return fromCodePoint((_a = decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint);
}
decode_codepoint.default = decodeCodePoint;

var decode = {};

var decodeDataHtml = {};

Object.defineProperty(decodeDataHtml, "__esModule", { value: true });
decodeDataHtml.default = new Uint16Array([14866, 60, 237, 340, 721, 1312, 1562, 1654, 1838, 1957, 2183, 2239, 2301, 2958, 3037, 3893, 4123, 4298, 4330, 4801, 5191, 5395, 5752, 5903, 5943, 5972, 6050, 0, 0, 0, 0, 0, 0, 6135, 6565, 7422, 8183, 8738, 9242, 9503, 9938, 10189, 10573, 10637, 10715, 11950, 12246, 13539, 13950, 14445, 14533, 15364, 16514, 16980, 17390, 17763, 17849, 18036, 18125, 4096, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 92, 100, 106, 115, 122, 137, 142, 151, 157, 163, 167, 182, 196, 204, 220, 229, 108, 105, 103, 33024, 198, 59, 32768, 198, 80, 33024, 38, 59, 32768, 38, 99, 117, 116, 101, 33024, 193, 59, 32768, 193, 114, 101, 118, 101, 59, 32768, 258, 512, 105, 121, 127, 134, 114, 99, 33024, 194, 59, 32768, 194, 59, 32768, 1040, 114, 59, 32896, 55349, 56580, 114, 97, 118, 101, 33024, 192, 59, 32768, 192, 112, 104, 97, 59, 32768, 913, 97, 99, 114, 59, 32768, 256, 100, 59, 32768, 10835, 512, 103, 112, 172, 177, 111, 110, 59, 32768, 260, 102, 59, 32896, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 32768, 8289, 105, 110, 103, 33024, 197, 59, 32768, 197, 512, 99, 115, 209, 214, 114, 59, 32896, 55349, 56476, 105, 103, 110, 59, 32768, 8788, 105, 108, 100, 101, 33024, 195, 59, 32768, 195, 109, 108, 33024, 196, 59, 32768, 196, 2048, 97, 99, 101, 102, 111, 114, 115, 117, 253, 278, 282, 310, 315, 321, 327, 332, 512, 99, 114, 258, 267, 107, 115, 108, 97, 115, 104, 59, 32768, 8726, 583, 271, 274, 59, 32768, 10983, 101, 100, 59, 32768, 8966, 121, 59, 32768, 1041, 768, 99, 114, 116, 289, 296, 306, 97, 117, 115, 101, 59, 32768, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 32768, 8492, 97, 59, 32768, 914, 114, 59, 32896, 55349, 56581, 112, 102, 59, 32896, 55349, 56633, 101, 118, 101, 59, 32768, 728, 99, 114, 59, 32768, 8492, 109, 112, 101, 113, 59, 32768, 8782, 3584, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 368, 373, 380, 426, 461, 466, 487, 491, 495, 533, 593, 695, 701, 707, 99, 121, 59, 32768, 1063, 80, 89, 33024, 169, 59, 32768, 169, 768, 99, 112, 121, 387, 393, 419, 117, 116, 101, 59, 32768, 262, 512, 59, 105, 398, 400, 32768, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 32768, 8517, 108, 101, 121, 115, 59, 32768, 8493, 1024, 97, 101, 105, 111, 435, 441, 449, 454, 114, 111, 110, 59, 32768, 268, 100, 105, 108, 33024, 199, 59, 32768, 199, 114, 99, 59, 32768, 264, 110, 105, 110, 116, 59, 32768, 8752, 111, 116, 59, 32768, 266, 512, 100, 110, 471, 478, 105, 108, 108, 97, 59, 32768, 184, 116, 101, 114, 68, 111, 116, 59, 32768, 183, 114, 59, 32768, 8493, 105, 59, 32768, 935, 114, 99, 108, 101, 1024, 68, 77, 80, 84, 508, 513, 520, 526, 111, 116, 59, 32768, 8857, 105, 110, 117, 115, 59, 32768, 8854, 108, 117, 115, 59, 32768, 8853, 105, 109, 101, 115, 59, 32768, 8855, 111, 512, 99, 115, 539, 562, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8754, 101, 67, 117, 114, 108, 121, 512, 68, 81, 573, 586, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 32768, 8221, 117, 111, 116, 101, 59, 32768, 8217, 1024, 108, 110, 112, 117, 602, 614, 648, 664, 111, 110, 512, 59, 101, 609, 611, 32768, 8759, 59, 32768, 10868, 768, 103, 105, 116, 621, 629, 634, 114, 117, 101, 110, 116, 59, 32768, 8801, 110, 116, 59, 32768, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8750, 512, 102, 114, 653, 656, 59, 32768, 8450, 111, 100, 117, 99, 116, 59, 32768, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8755, 111, 115, 115, 59, 32768, 10799, 99, 114, 59, 32896, 55349, 56478, 112, 512, 59, 67, 713, 715, 32768, 8915, 97, 112, 59, 32768, 8781, 2816, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 743, 758, 763, 768, 773, 795, 809, 821, 826, 910, 1295, 512, 59, 111, 748, 750, 32768, 8517, 116, 114, 97, 104, 100, 59, 32768, 10513, 99, 121, 59, 32768, 1026, 99, 121, 59, 32768, 1029, 99, 121, 59, 32768, 1039, 768, 103, 114, 115, 780, 786, 790, 103, 101, 114, 59, 32768, 8225, 114, 59, 32768, 8609, 104, 118, 59, 32768, 10980, 512, 97, 121, 800, 806, 114, 111, 110, 59, 32768, 270, 59, 32768, 1044, 108, 512, 59, 116, 815, 817, 32768, 8711, 97, 59, 32768, 916, 114, 59, 32896, 55349, 56583, 512, 97, 102, 831, 897, 512, 99, 109, 836, 891, 114, 105, 116, 105, 99, 97, 108, 1024, 65, 68, 71, 84, 852, 859, 877, 884, 99, 117, 116, 101, 59, 32768, 180, 111, 581, 864, 867, 59, 32768, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 32768, 733, 114, 97, 118, 101, 59, 32768, 96, 105, 108, 100, 101, 59, 32768, 732, 111, 110, 100, 59, 32768, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 32768, 8518, 2113, 920, 0, 0, 0, 925, 946, 0, 1139, 102, 59, 32896, 55349, 56635, 768, 59, 68, 69, 931, 933, 938, 32768, 168, 111, 116, 59, 32768, 8412, 113, 117, 97, 108, 59, 32768, 8784, 98, 108, 101, 1536, 67, 68, 76, 82, 85, 86, 961, 978, 996, 1080, 1101, 1125, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8751, 111, 1093, 985, 0, 0, 988, 59, 32768, 168, 110, 65, 114, 114, 111, 119, 59, 32768, 8659, 512, 101, 111, 1001, 1034, 102, 116, 768, 65, 82, 84, 1010, 1017, 1029, 114, 114, 111, 119, 59, 32768, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8660, 101, 101, 59, 32768, 10980, 110, 103, 512, 76, 82, 1041, 1068, 101, 102, 116, 512, 65, 82, 1049, 1056, 114, 114, 111, 119, 59, 32768, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10233, 105, 103, 104, 116, 512, 65, 84, 1089, 1096, 114, 114, 111, 119, 59, 32768, 8658, 101, 101, 59, 32768, 8872, 112, 1042, 1108, 0, 0, 1115, 114, 114, 111, 119, 59, 32768, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 32768, 8741, 110, 1536, 65, 66, 76, 82, 84, 97, 1152, 1179, 1186, 1236, 1272, 1288, 114, 114, 111, 119, 768, 59, 66, 85, 1163, 1165, 1170, 32768, 8595, 97, 114, 59, 32768, 10515, 112, 65, 114, 114, 111, 119, 59, 32768, 8693, 114, 101, 118, 101, 59, 32768, 785, 101, 102, 116, 1315, 1196, 0, 1209, 0, 1220, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 32768, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10590, 101, 99, 116, 111, 114, 512, 59, 66, 1229, 1231, 32768, 8637, 97, 114, 59, 32768, 10582, 105, 103, 104, 116, 805, 1245, 0, 1256, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10591, 101, 99, 116, 111, 114, 512, 59, 66, 1265, 1267, 32768, 8641, 97, 114, 59, 32768, 10583, 101, 101, 512, 59, 65, 1279, 1281, 32768, 8868, 114, 114, 111, 119, 59, 32768, 8615, 114, 114, 111, 119, 59, 32768, 8659, 512, 99, 116, 1300, 1305, 114, 59, 32896, 55349, 56479, 114, 111, 107, 59, 32768, 272, 4096, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1344, 1348, 1354, 1363, 1386, 1391, 1396, 1405, 1413, 1460, 1475, 1483, 1514, 1527, 1531, 1538, 71, 59, 32768, 330, 72, 33024, 208, 59, 32768, 208, 99, 117, 116, 101, 33024, 201, 59, 32768, 201, 768, 97, 105, 121, 1370, 1376, 1383, 114, 111, 110, 59, 32768, 282, 114, 99, 33024, 202, 59, 32768, 202, 59, 32768, 1069, 111, 116, 59, 32768, 278, 114, 59, 32896, 55349, 56584, 114, 97, 118, 101, 33024, 200, 59, 32768, 200, 101, 109, 101, 110, 116, 59, 32768, 8712, 512, 97, 112, 1418, 1423, 99, 114, 59, 32768, 274, 116, 121, 1060, 1431, 0, 0, 1444, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9643, 512, 103, 112, 1465, 1470, 111, 110, 59, 32768, 280, 102, 59, 32896, 55349, 56636, 115, 105, 108, 111, 110, 59, 32768, 917, 117, 512, 97, 105, 1489, 1504, 108, 512, 59, 84, 1495, 1497, 32768, 10869, 105, 108, 100, 101, 59, 32768, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 8652, 512, 99, 105, 1519, 1523, 114, 59, 32768, 8496, 109, 59, 32768, 10867, 97, 59, 32768, 919, 109, 108, 33024, 203, 59, 32768, 203, 512, 105, 112, 1543, 1549, 115, 116, 115, 59, 32768, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 32768, 8519, 1280, 99, 102, 105, 111, 115, 1572, 1576, 1581, 1620, 1648, 121, 59, 32768, 1060, 114, 59, 32896, 55349, 56585, 108, 108, 101, 100, 1060, 1591, 0, 0, 1604, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9642, 1601, 1628, 0, 1633, 0, 0, 1639, 102, 59, 32896, 55349, 56637, 65, 108, 108, 59, 32768, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 32768, 8497, 99, 114, 59, 32768, 8497, 3072, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1678, 1683, 1688, 1701, 1708, 1729, 1734, 1739, 1742, 1748, 1828, 1834, 99, 121, 59, 32768, 1027, 33024, 62, 59, 32768, 62, 109, 109, 97, 512, 59, 100, 1696, 1698, 32768, 915, 59, 32768, 988, 114, 101, 118, 101, 59, 32768, 286, 768, 101, 105, 121, 1715, 1721, 1726, 100, 105, 108, 59, 32768, 290, 114, 99, 59, 32768, 284, 59, 32768, 1043, 111, 116, 59, 32768, 288, 114, 59, 32896, 55349, 56586, 59, 32768, 8921, 112, 102, 59, 32896, 55349, 56638, 101, 97, 116, 101, 114, 1536, 69, 70, 71, 76, 83, 84, 1766, 1783, 1794, 1803, 1809, 1821, 113, 117, 97, 108, 512, 59, 76, 1775, 1777, 32768, 8805, 101, 115, 115, 59, 32768, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8807, 114, 101, 97, 116, 101, 114, 59, 32768, 10914, 101, 115, 115, 59, 32768, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 10878, 105, 108, 100, 101, 59, 32768, 8819, 99, 114, 59, 32896, 55349, 56482, 59, 32768, 8811, 2048, 65, 97, 99, 102, 105, 111, 115, 117, 1854, 1861, 1874, 1880, 1884, 1897, 1919, 1934, 82, 68, 99, 121, 59, 32768, 1066, 512, 99, 116, 1866, 1871, 101, 107, 59, 32768, 711, 59, 32768, 94, 105, 114, 99, 59, 32768, 292, 114, 59, 32768, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 32768, 8459, 833, 1902, 0, 1906, 102, 59, 32768, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 32768, 9472, 512, 99, 116, 1924, 1928, 114, 59, 32768, 8459, 114, 111, 107, 59, 32768, 294, 109, 112, 533, 1940, 1950, 111, 119, 110, 72, 117, 109, 112, 59, 32768, 8782, 113, 117, 97, 108, 59, 32768, 8783, 3584, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 1985, 1990, 1996, 2001, 2010, 2025, 2030, 2034, 2043, 2077, 2134, 2155, 2160, 2167, 99, 121, 59, 32768, 1045, 108, 105, 103, 59, 32768, 306, 99, 121, 59, 32768, 1025, 99, 117, 116, 101, 33024, 205, 59, 32768, 205, 512, 105, 121, 2015, 2022, 114, 99, 33024, 206, 59, 32768, 206, 59, 32768, 1048, 111, 116, 59, 32768, 304, 114, 59, 32768, 8465, 114, 97, 118, 101, 33024, 204, 59, 32768, 204, 768, 59, 97, 112, 2050, 2052, 2070, 32768, 8465, 512, 99, 103, 2057, 2061, 114, 59, 32768, 298, 105, 110, 97, 114, 121, 73, 59, 32768, 8520, 108, 105, 101, 115, 59, 32768, 8658, 837, 2082, 0, 2110, 512, 59, 101, 2086, 2088, 32768, 8748, 512, 103, 114, 2093, 2099, 114, 97, 108, 59, 32768, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 32768, 8898, 105, 115, 105, 98, 108, 101, 512, 67, 84, 2120, 2127, 111, 109, 109, 97, 59, 32768, 8291, 105, 109, 101, 115, 59, 32768, 8290, 768, 103, 112, 116, 2141, 2146, 2151, 111, 110, 59, 32768, 302, 102, 59, 32896, 55349, 56640, 97, 59, 32768, 921, 99, 114, 59, 32768, 8464, 105, 108, 100, 101, 59, 32768, 296, 828, 2172, 0, 2177, 99, 121, 59, 32768, 1030, 108, 33024, 207, 59, 32768, 207, 1280, 99, 102, 111, 115, 117, 2193, 2206, 2211, 2217, 2232, 512, 105, 121, 2198, 2203, 114, 99, 59, 32768, 308, 59, 32768, 1049, 114, 59, 32896, 55349, 56589, 112, 102, 59, 32896, 55349, 56641, 820, 2222, 0, 2227, 114, 59, 32896, 55349, 56485, 114, 99, 121, 59, 32768, 1032, 107, 99, 121, 59, 32768, 1028, 1792, 72, 74, 97, 99, 102, 111, 115, 2253, 2258, 2263, 2269, 2283, 2288, 2294, 99, 121, 59, 32768, 1061, 99, 121, 59, 32768, 1036, 112, 112, 97, 59, 32768, 922, 512, 101, 121, 2274, 2280, 100, 105, 108, 59, 32768, 310, 59, 32768, 1050, 114, 59, 32896, 55349, 56590, 112, 102, 59, 32896, 55349, 56642, 99, 114, 59, 32896, 55349, 56486, 2816, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2323, 2328, 2333, 2374, 2396, 2775, 2780, 2797, 2804, 2934, 2954, 99, 121, 59, 32768, 1033, 33024, 60, 59, 32768, 60, 1280, 99, 109, 110, 112, 114, 2344, 2350, 2356, 2360, 2370, 117, 116, 101, 59, 32768, 313, 98, 100, 97, 59, 32768, 923, 103, 59, 32768, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 32768, 8466, 114, 59, 32768, 8606, 768, 97, 101, 121, 2381, 2387, 2393, 114, 111, 110, 59, 32768, 317, 100, 105, 108, 59, 32768, 315, 59, 32768, 1051, 512, 102, 115, 2401, 2702, 116, 2560, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2423, 2470, 2479, 2530, 2537, 2561, 2618, 2666, 2683, 2690, 512, 110, 114, 2428, 2441, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10216, 114, 111, 119, 768, 59, 66, 82, 2451, 2453, 2458, 32768, 8592, 97, 114, 59, 32768, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8646, 101, 105, 108, 105, 110, 103, 59, 32768, 8968, 111, 838, 2485, 0, 2498, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10214, 110, 805, 2503, 0, 2514, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10593, 101, 99, 116, 111, 114, 512, 59, 66, 2523, 2525, 32768, 8643, 97, 114, 59, 32768, 10585, 108, 111, 111, 114, 59, 32768, 8970, 105, 103, 104, 116, 512, 65, 86, 2546, 2553, 114, 114, 111, 119, 59, 32768, 8596, 101, 99, 116, 111, 114, 59, 32768, 10574, 512, 101, 114, 2566, 2591, 101, 768, 59, 65, 86, 2574, 2576, 2583, 32768, 8867, 114, 114, 111, 119, 59, 32768, 8612, 101, 99, 116, 111, 114, 59, 32768, 10586, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 2604, 2606, 2611, 32768, 8882, 97, 114, 59, 32768, 10703, 113, 117, 97, 108, 59, 32768, 8884, 112, 768, 68, 84, 86, 2626, 2638, 2649, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 32768, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10592, 101, 99, 116, 111, 114, 512, 59, 66, 2659, 2661, 32768, 8639, 97, 114, 59, 32768, 10584, 101, 99, 116, 111, 114, 512, 59, 66, 2676, 2678, 32768, 8636, 97, 114, 59, 32768, 10578, 114, 114, 111, 119, 59, 32768, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8660, 115, 1536, 69, 70, 71, 76, 83, 84, 2716, 2730, 2741, 2750, 2756, 2768, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 32768, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8806, 114, 101, 97, 116, 101, 114, 59, 32768, 8822, 101, 115, 115, 59, 32768, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 10877, 105, 108, 100, 101, 59, 32768, 8818, 114, 59, 32896, 55349, 56591, 512, 59, 101, 2785, 2787, 32768, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 32768, 8666, 105, 100, 111, 116, 59, 32768, 319, 768, 110, 112, 119, 2811, 2899, 2904, 103, 1024, 76, 82, 108, 114, 2821, 2848, 2860, 2887, 101, 102, 116, 512, 65, 82, 2829, 2836, 114, 114, 111, 119, 59, 32768, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10230, 101, 102, 116, 512, 97, 114, 2868, 2875, 114, 114, 111, 119, 59, 32768, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10233, 102, 59, 32896, 55349, 56643, 101, 114, 512, 76, 82, 2911, 2922, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8600, 768, 99, 104, 116, 2941, 2945, 2948, 114, 59, 32768, 8466, 59, 32768, 8624, 114, 111, 107, 59, 32768, 321, 59, 32768, 8810, 2048, 97, 99, 101, 102, 105, 111, 115, 117, 2974, 2978, 2982, 3007, 3012, 3022, 3028, 3033, 112, 59, 32768, 10501, 121, 59, 32768, 1052, 512, 100, 108, 2987, 2998, 105, 117, 109, 83, 112, 97, 99, 101, 59, 32768, 8287, 108, 105, 110, 116, 114, 102, 59, 32768, 8499, 114, 59, 32896, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 32768, 8723, 112, 102, 59, 32896, 55349, 56644, 99, 114, 59, 32768, 8499, 59, 32768, 924, 2304, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3055, 3060, 3067, 3089, 3201, 3206, 3874, 3880, 3889, 99, 121, 59, 32768, 1034, 99, 117, 116, 101, 59, 32768, 323, 768, 97, 101, 121, 3074, 3080, 3086, 114, 111, 110, 59, 32768, 327, 100, 105, 108, 59, 32768, 325, 59, 32768, 1053, 768, 103, 115, 119, 3096, 3160, 3194, 97, 116, 105, 118, 101, 768, 77, 84, 86, 3108, 3121, 3145, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 32768, 8203, 104, 105, 512, 99, 110, 3128, 3137, 107, 83, 112, 97, 99, 101, 59, 32768, 8203, 83, 112, 97, 99, 101, 59, 32768, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 32768, 8203, 116, 101, 100, 512, 71, 76, 3168, 3184, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 32768, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 32768, 8810, 76, 105, 110, 101, 59, 32768, 10, 114, 59, 32896, 55349, 56593, 1024, 66, 110, 112, 116, 3215, 3222, 3238, 3242, 114, 101, 97, 107, 59, 32768, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 32768, 160, 102, 59, 32768, 8469, 3328, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3269, 3271, 3293, 3312, 3352, 3430, 3455, 3551, 3589, 3625, 3678, 3821, 3861, 32768, 10988, 512, 111, 117, 3276, 3286, 110, 103, 114, 117, 101, 110, 116, 59, 32768, 8802, 112, 67, 97, 112, 59, 32768, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 32768, 8742, 768, 108, 113, 120, 3319, 3327, 3345, 101, 109, 101, 110, 116, 59, 32768, 8713, 117, 97, 108, 512, 59, 84, 3335, 3337, 32768, 8800, 105, 108, 100, 101, 59, 32896, 8770, 824, 105, 115, 116, 115, 59, 32768, 8708, 114, 101, 97, 116, 101, 114, 1792, 59, 69, 70, 71, 76, 83, 84, 3373, 3375, 3382, 3394, 3404, 3410, 3423, 32768, 8815, 113, 117, 97, 108, 59, 32768, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32896, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 32896, 8811, 824, 101, 115, 115, 59, 32768, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32896, 10878, 824, 105, 108, 100, 101, 59, 32768, 8821, 117, 109, 112, 533, 3437, 3448, 111, 119, 110, 72, 117, 109, 112, 59, 32896, 8782, 824, 113, 117, 97, 108, 59, 32896, 8783, 824, 101, 512, 102, 115, 3461, 3492, 116, 84, 114, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 3477, 3479, 3485, 32768, 8938, 97, 114, 59, 32896, 10703, 824, 113, 117, 97, 108, 59, 32768, 8940, 115, 1536, 59, 69, 71, 76, 83, 84, 3506, 3508, 3515, 3524, 3531, 3544, 32768, 8814, 113, 117, 97, 108, 59, 32768, 8816, 114, 101, 97, 116, 101, 114, 59, 32768, 8824, 101, 115, 115, 59, 32896, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32896, 10877, 824, 105, 108, 100, 101, 59, 32768, 8820, 101, 115, 116, 101, 100, 512, 71, 76, 3561, 3578, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 32896, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 32896, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 768, 59, 69, 83, 3603, 3605, 3613, 32768, 8832, 113, 117, 97, 108, 59, 32896, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8928, 512, 101, 105, 3630, 3645, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 32768, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 3663, 3665, 3671, 32768, 8939, 97, 114, 59, 32896, 10704, 824, 113, 117, 97, 108, 59, 32768, 8941, 512, 113, 117, 3683, 3732, 117, 97, 114, 101, 83, 117, 512, 98, 112, 3694, 3712, 115, 101, 116, 512, 59, 69, 3702, 3705, 32896, 8847, 824, 113, 117, 97, 108, 59, 32768, 8930, 101, 114, 115, 101, 116, 512, 59, 69, 3722, 3725, 32896, 8848, 824, 113, 117, 97, 108, 59, 32768, 8931, 768, 98, 99, 112, 3739, 3757, 3801, 115, 101, 116, 512, 59, 69, 3747, 3750, 32896, 8834, 8402, 113, 117, 97, 108, 59, 32768, 8840, 99, 101, 101, 100, 115, 1024, 59, 69, 83, 84, 3771, 3773, 3781, 3793, 32768, 8833, 113, 117, 97, 108, 59, 32896, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8929, 105, 108, 100, 101, 59, 32896, 8831, 824, 101, 114, 115, 101, 116, 512, 59, 69, 3811, 3814, 32896, 8835, 8402, 113, 117, 97, 108, 59, 32768, 8841, 105, 108, 100, 101, 1024, 59, 69, 70, 84, 3834, 3836, 3843, 3854, 32768, 8769, 113, 117, 97, 108, 59, 32768, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8775, 105, 108, 100, 101, 59, 32768, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 32768, 8740, 99, 114, 59, 32896, 55349, 56489, 105, 108, 100, 101, 33024, 209, 59, 32768, 209, 59, 32768, 925, 3584, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 3921, 3927, 3936, 3951, 3958, 3963, 3972, 3996, 4002, 4034, 4037, 4055, 4071, 4078, 108, 105, 103, 59, 32768, 338, 99, 117, 116, 101, 33024, 211, 59, 32768, 211, 512, 105, 121, 3941, 3948, 114, 99, 33024, 212, 59, 32768, 212, 59, 32768, 1054, 98, 108, 97, 99, 59, 32768, 336, 114, 59, 32896, 55349, 56594, 114, 97, 118, 101, 33024, 210, 59, 32768, 210, 768, 97, 101, 105, 3979, 3984, 3989, 99, 114, 59, 32768, 332, 103, 97, 59, 32768, 937, 99, 114, 111, 110, 59, 32768, 927, 112, 102, 59, 32896, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 512, 68, 81, 4014, 4027, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 32768, 8220, 117, 111, 116, 101, 59, 32768, 8216, 59, 32768, 10836, 512, 99, 108, 4042, 4047, 114, 59, 32896, 55349, 56490, 97, 115, 104, 33024, 216, 59, 32768, 216, 105, 573, 4060, 4067, 100, 101, 33024, 213, 59, 32768, 213, 101, 115, 59, 32768, 10807, 109, 108, 33024, 214, 59, 32768, 214, 101, 114, 512, 66, 80, 4085, 4109, 512, 97, 114, 4090, 4094, 114, 59, 32768, 8254, 97, 99, 512, 101, 107, 4101, 4104, 59, 32768, 9182, 101, 116, 59, 32768, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 32768, 9180, 2304, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4141, 4150, 4154, 4159, 4163, 4166, 4176, 4198, 4284, 114, 116, 105, 97, 108, 68, 59, 32768, 8706, 121, 59, 32768, 1055, 114, 59, 32896, 55349, 56595, 105, 59, 32768, 934, 59, 32768, 928, 117, 115, 77, 105, 110, 117, 115, 59, 32768, 177, 512, 105, 112, 4181, 4194, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 32768, 8460, 102, 59, 32768, 8473, 1024, 59, 101, 105, 111, 4207, 4209, 4251, 4256, 32768, 10939, 99, 101, 100, 101, 115, 1024, 59, 69, 83, 84, 4223, 4225, 4232, 4244, 32768, 8826, 113, 117, 97, 108, 59, 32768, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8828, 105, 108, 100, 101, 59, 32768, 8830, 109, 101, 59, 32768, 8243, 512, 100, 112, 4261, 4267, 117, 99, 116, 59, 32768, 8719, 111, 114, 116, 105, 111, 110, 512, 59, 97, 4278, 4280, 32768, 8759, 108, 59, 32768, 8733, 512, 99, 105, 4289, 4294, 114, 59, 32896, 55349, 56491, 59, 32768, 936, 1024, 85, 102, 111, 115, 4306, 4313, 4318, 4323, 79, 84, 33024, 34, 59, 32768, 34, 114, 59, 32896, 55349, 56596, 112, 102, 59, 32768, 8474, 99, 114, 59, 32896, 55349, 56492, 3072, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4354, 4360, 4366, 4395, 4417, 4473, 4477, 4481, 4743, 4764, 4776, 4788, 97, 114, 114, 59, 32768, 10512, 71, 33024, 174, 59, 32768, 174, 768, 99, 110, 114, 4373, 4379, 4383, 117, 116, 101, 59, 32768, 340, 103, 59, 32768, 10219, 114, 512, 59, 116, 4389, 4391, 32768, 8608, 108, 59, 32768, 10518, 768, 97, 101, 121, 4402, 4408, 4414, 114, 111, 110, 59, 32768, 344, 100, 105, 108, 59, 32768, 342, 59, 32768, 1056, 512, 59, 118, 4422, 4424, 32768, 8476, 101, 114, 115, 101, 512, 69, 85, 4433, 4458, 512, 108, 113, 4438, 4446, 101, 109, 101, 110, 116, 59, 32768, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 10607, 114, 59, 32768, 8476, 111, 59, 32768, 929, 103, 104, 116, 2048, 65, 67, 68, 70, 84, 85, 86, 97, 4501, 4547, 4556, 4607, 4614, 4671, 4719, 4736, 512, 110, 114, 4506, 4519, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10217, 114, 111, 119, 768, 59, 66, 76, 4529, 4531, 4536, 32768, 8594, 97, 114, 59, 32768, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8644, 101, 105, 108, 105, 110, 103, 59, 32768, 8969, 111, 838, 4562, 0, 4575, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10215, 110, 805, 4580, 0, 4591, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10589, 101, 99, 116, 111, 114, 512, 59, 66, 4600, 4602, 32768, 8642, 97, 114, 59, 32768, 10581, 108, 111, 111, 114, 59, 32768, 8971, 512, 101, 114, 4619, 4644, 101, 768, 59, 65, 86, 4627, 4629, 4636, 32768, 8866, 114, 114, 111, 119, 59, 32768, 8614, 101, 99, 116, 111, 114, 59, 32768, 10587, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 4657, 4659, 4664, 32768, 8883, 97, 114, 59, 32768, 10704, 113, 117, 97, 108, 59, 32768, 8885, 112, 768, 68, 84, 86, 4679, 4691, 4702, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 32768, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10588, 101, 99, 116, 111, 114, 512, 59, 66, 4712, 4714, 32768, 8638, 97, 114, 59, 32768, 10580, 101, 99, 116, 111, 114, 512, 59, 66, 4729, 4731, 32768, 8640, 97, 114, 59, 32768, 10579, 114, 114, 111, 119, 59, 32768, 8658, 512, 112, 117, 4748, 4752, 102, 59, 32768, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 32768, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8667, 512, 99, 104, 4781, 4785, 114, 59, 32768, 8475, 59, 32768, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 32768, 10740, 3328, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 4827, 4842, 4849, 4856, 4889, 4894, 4949, 4955, 4967, 4973, 5059, 5065, 5070, 512, 67, 99, 4832, 4838, 72, 99, 121, 59, 32768, 1065, 121, 59, 32768, 1064, 70, 84, 99, 121, 59, 32768, 1068, 99, 117, 116, 101, 59, 32768, 346, 1280, 59, 97, 101, 105, 121, 4867, 4869, 4875, 4881, 4886, 32768, 10940, 114, 111, 110, 59, 32768, 352, 100, 105, 108, 59, 32768, 350, 114, 99, 59, 32768, 348, 59, 32768, 1057, 114, 59, 32896, 55349, 56598, 111, 114, 116, 1024, 68, 76, 82, 85, 4906, 4917, 4928, 4940, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8594, 112, 65, 114, 114, 111, 119, 59, 32768, 8593, 103, 109, 97, 59, 32768, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 32768, 8728, 112, 102, 59, 32896, 55349, 56650, 1091, 4979, 0, 0, 4983, 116, 59, 32768, 8730, 97, 114, 101, 1024, 59, 73, 83, 85, 4994, 4996, 5010, 5052, 32768, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 32768, 8851, 117, 512, 98, 112, 5016, 5033, 115, 101, 116, 512, 59, 69, 5024, 5026, 32768, 8847, 113, 117, 97, 108, 59, 32768, 8849, 101, 114, 115, 101, 116, 512, 59, 69, 5043, 5045, 32768, 8848, 113, 117, 97, 108, 59, 32768, 8850, 110, 105, 111, 110, 59, 32768, 8852, 99, 114, 59, 32896, 55349, 56494, 97, 114, 59, 32768, 8902, 1024, 98, 99, 109, 112, 5079, 5102, 5155, 5158, 512, 59, 115, 5084, 5086, 32768, 8912, 101, 116, 512, 59, 69, 5093, 5095, 32768, 8912, 113, 117, 97, 108, 59, 32768, 8838, 512, 99, 104, 5107, 5148, 101, 101, 100, 115, 1024, 59, 69, 83, 84, 5120, 5122, 5129, 5141, 32768, 8827, 113, 117, 97, 108, 59, 32768, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8829, 105, 108, 100, 101, 59, 32768, 8831, 84, 104, 97, 116, 59, 32768, 8715, 59, 32768, 8721, 768, 59, 101, 115, 5165, 5167, 5185, 32768, 8913, 114, 115, 101, 116, 512, 59, 69, 5176, 5178, 32768, 8835, 113, 117, 97, 108, 59, 32768, 8839, 101, 116, 59, 32768, 8913, 2816, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5213, 5221, 5227, 5241, 5252, 5274, 5279, 5323, 5362, 5368, 5378, 79, 82, 78, 33024, 222, 59, 32768, 222, 65, 68, 69, 59, 32768, 8482, 512, 72, 99, 5232, 5237, 99, 121, 59, 32768, 1035, 121, 59, 32768, 1062, 512, 98, 117, 5246, 5249, 59, 32768, 9, 59, 32768, 932, 768, 97, 101, 121, 5259, 5265, 5271, 114, 111, 110, 59, 32768, 356, 100, 105, 108, 59, 32768, 354, 59, 32768, 1058, 114, 59, 32896, 55349, 56599, 512, 101, 105, 5284, 5300, 835, 5289, 0, 5297, 101, 102, 111, 114, 101, 59, 32768, 8756, 97, 59, 32768, 920, 512, 99, 110, 5305, 5315, 107, 83, 112, 97, 99, 101, 59, 32896, 8287, 8202, 83, 112, 97, 99, 101, 59, 32768, 8201, 108, 100, 101, 1024, 59, 69, 70, 84, 5335, 5337, 5344, 5355, 32768, 8764, 113, 117, 97, 108, 59, 32768, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8773, 105, 108, 100, 101, 59, 32768, 8776, 112, 102, 59, 32896, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 32768, 8411, 512, 99, 116, 5383, 5388, 114, 59, 32896, 55349, 56495, 114, 111, 107, 59, 32768, 358, 5426, 5417, 5444, 5458, 5473, 0, 5480, 5485, 0, 0, 0, 0, 0, 5494, 5500, 5564, 5579, 0, 5726, 5732, 5738, 5745, 512, 99, 114, 5421, 5429, 117, 116, 101, 33024, 218, 59, 32768, 218, 114, 512, 59, 111, 5435, 5437, 32768, 8607, 99, 105, 114, 59, 32768, 10569, 114, 820, 5449, 0, 5453, 121, 59, 32768, 1038, 118, 101, 59, 32768, 364, 512, 105, 121, 5462, 5469, 114, 99, 33024, 219, 59, 32768, 219, 59, 32768, 1059, 98, 108, 97, 99, 59, 32768, 368, 114, 59, 32896, 55349, 56600, 114, 97, 118, 101, 33024, 217, 59, 32768, 217, 97, 99, 114, 59, 32768, 362, 512, 100, 105, 5504, 5548, 101, 114, 512, 66, 80, 5511, 5535, 512, 97, 114, 5516, 5520, 114, 59, 32768, 95, 97, 99, 512, 101, 107, 5527, 5530, 59, 32768, 9183, 101, 116, 59, 32768, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 32768, 9181, 111, 110, 512, 59, 80, 5555, 5557, 32768, 8899, 108, 117, 115, 59, 32768, 8846, 512, 103, 112, 5568, 5573, 111, 110, 59, 32768, 370, 102, 59, 32896, 55349, 56652, 2048, 65, 68, 69, 84, 97, 100, 112, 115, 5595, 5624, 5635, 5648, 5664, 5671, 5682, 5712, 114, 114, 111, 119, 768, 59, 66, 68, 5606, 5608, 5613, 32768, 8593, 97, 114, 59, 32768, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 10606, 101, 101, 512, 59, 65, 5655, 5657, 32768, 8869, 114, 114, 111, 119, 59, 32768, 8613, 114, 114, 111, 119, 59, 32768, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 32768, 8661, 101, 114, 512, 76, 82, 5689, 5700, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8599, 105, 512, 59, 108, 5718, 5720, 32768, 978, 111, 110, 59, 32768, 933, 105, 110, 103, 59, 32768, 366, 99, 114, 59, 32896, 55349, 56496, 105, 108, 100, 101, 59, 32768, 360, 109, 108, 33024, 220, 59, 32768, 220, 2304, 68, 98, 99, 100, 101, 102, 111, 115, 118, 5770, 5776, 5781, 5785, 5798, 5878, 5883, 5889, 5895, 97, 115, 104, 59, 32768, 8875, 97, 114, 59, 32768, 10987, 121, 59, 32768, 1042, 97, 115, 104, 512, 59, 108, 5793, 5795, 32768, 8873, 59, 32768, 10982, 512, 101, 114, 5803, 5806, 59, 32768, 8897, 768, 98, 116, 121, 5813, 5818, 5866, 97, 114, 59, 32768, 8214, 512, 59, 105, 5823, 5825, 32768, 8214, 99, 97, 108, 1024, 66, 76, 83, 84, 5837, 5842, 5848, 5859, 97, 114, 59, 32768, 8739, 105, 110, 101, 59, 32768, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 32768, 10072, 105, 108, 100, 101, 59, 32768, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 32768, 8202, 114, 59, 32896, 55349, 56601, 112, 102, 59, 32896, 55349, 56653, 99, 114, 59, 32896, 55349, 56497, 100, 97, 115, 104, 59, 32768, 8874, 1280, 99, 101, 102, 111, 115, 5913, 5919, 5925, 5930, 5936, 105, 114, 99, 59, 32768, 372, 100, 103, 101, 59, 32768, 8896, 114, 59, 32896, 55349, 56602, 112, 102, 59, 32896, 55349, 56654, 99, 114, 59, 32896, 55349, 56498, 1024, 102, 105, 111, 115, 5951, 5956, 5959, 5965, 114, 59, 32896, 55349, 56603, 59, 32768, 926, 112, 102, 59, 32896, 55349, 56655, 99, 114, 59, 32896, 55349, 56499, 2304, 65, 73, 85, 97, 99, 102, 111, 115, 117, 5990, 5995, 6000, 6005, 6014, 6027, 6032, 6038, 6044, 99, 121, 59, 32768, 1071, 99, 121, 59, 32768, 1031, 99, 121, 59, 32768, 1070, 99, 117, 116, 101, 33024, 221, 59, 32768, 221, 512, 105, 121, 6019, 6024, 114, 99, 59, 32768, 374, 59, 32768, 1067, 114, 59, 32896, 55349, 56604, 112, 102, 59, 32896, 55349, 56656, 99, 114, 59, 32896, 55349, 56500, 109, 108, 59, 32768, 376, 2048, 72, 97, 99, 100, 101, 102, 111, 115, 6066, 6071, 6078, 6092, 6097, 6119, 6123, 6128, 99, 121, 59, 32768, 1046, 99, 117, 116, 101, 59, 32768, 377, 512, 97, 121, 6083, 6089, 114, 111, 110, 59, 32768, 381, 59, 32768, 1047, 111, 116, 59, 32768, 379, 835, 6102, 0, 6116, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 32768, 8203, 97, 59, 32768, 918, 114, 59, 32768, 8488, 112, 102, 59, 32768, 8484, 99, 114, 59, 32896, 55349, 56501, 5938, 6159, 6168, 6175, 0, 6214, 6222, 6233, 0, 0, 0, 0, 6242, 6267, 6290, 6429, 6444, 0, 6495, 6503, 6531, 6540, 0, 6547, 99, 117, 116, 101, 33024, 225, 59, 32768, 225, 114, 101, 118, 101, 59, 32768, 259, 1536, 59, 69, 100, 105, 117, 121, 6187, 6189, 6193, 6196, 6203, 6210, 32768, 8766, 59, 32896, 8766, 819, 59, 32768, 8767, 114, 99, 33024, 226, 59, 32768, 226, 116, 101, 33024, 180, 59, 32768, 180, 59, 32768, 1072, 108, 105, 103, 33024, 230, 59, 32768, 230, 512, 59, 114, 6226, 6228, 32768, 8289, 59, 32896, 55349, 56606, 114, 97, 118, 101, 33024, 224, 59, 32768, 224, 512, 101, 112, 6246, 6261, 512, 102, 112, 6251, 6257, 115, 121, 109, 59, 32768, 8501, 104, 59, 32768, 8501, 104, 97, 59, 32768, 945, 512, 97, 112, 6271, 6284, 512, 99, 108, 6276, 6280, 114, 59, 32768, 257, 103, 59, 32768, 10815, 33024, 38, 59, 32768, 38, 1077, 6295, 0, 0, 6326, 1280, 59, 97, 100, 115, 118, 6305, 6307, 6312, 6315, 6322, 32768, 8743, 110, 100, 59, 32768, 10837, 59, 32768, 10844, 108, 111, 112, 101, 59, 32768, 10840, 59, 32768, 10842, 1792, 59, 101, 108, 109, 114, 115, 122, 6340, 6342, 6345, 6349, 6391, 6410, 6422, 32768, 8736, 59, 32768, 10660, 101, 59, 32768, 8736, 115, 100, 512, 59, 97, 6356, 6358, 32768, 8737, 2098, 6368, 6371, 6374, 6377, 6380, 6383, 6386, 6389, 59, 32768, 10664, 59, 32768, 10665, 59, 32768, 10666, 59, 32768, 10667, 59, 32768, 10668, 59, 32768, 10669, 59, 32768, 10670, 59, 32768, 10671, 116, 512, 59, 118, 6397, 6399, 32768, 8735, 98, 512, 59, 100, 6405, 6407, 32768, 8894, 59, 32768, 10653, 512, 112, 116, 6415, 6419, 104, 59, 32768, 8738, 59, 32768, 197, 97, 114, 114, 59, 32768, 9084, 512, 103, 112, 6433, 6438, 111, 110, 59, 32768, 261, 102, 59, 32896, 55349, 56658, 1792, 59, 69, 97, 101, 105, 111, 112, 6458, 6460, 6463, 6469, 6472, 6476, 6480, 32768, 8776, 59, 32768, 10864, 99, 105, 114, 59, 32768, 10863, 59, 32768, 8778, 100, 59, 32768, 8779, 115, 59, 32768, 39, 114, 111, 120, 512, 59, 101, 6488, 6490, 32768, 8776, 113, 59, 32768, 8778, 105, 110, 103, 33024, 229, 59, 32768, 229, 768, 99, 116, 121, 6509, 6514, 6517, 114, 59, 32896, 55349, 56502, 59, 32768, 42, 109, 112, 512, 59, 101, 6524, 6526, 32768, 8776, 113, 59, 32768, 8781, 105, 108, 100, 101, 33024, 227, 59, 32768, 227, 109, 108, 33024, 228, 59, 32768, 228, 512, 99, 105, 6551, 6559, 111, 110, 105, 110, 116, 59, 32768, 8755, 110, 116, 59, 32768, 10769, 4096, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 6597, 6602, 6673, 6688, 6701, 6707, 6768, 6773, 6891, 6898, 6999, 7023, 7309, 7316, 7334, 7383, 111, 116, 59, 32768, 10989, 512, 99, 114, 6607, 6652, 107, 1024, 99, 101, 112, 115, 6617, 6623, 6632, 6639, 111, 110, 103, 59, 32768, 8780, 112, 115, 105, 108, 111, 110, 59, 32768, 1014, 114, 105, 109, 101, 59, 32768, 8245, 105, 109, 512, 59, 101, 6646, 6648, 32768, 8765, 113, 59, 32768, 8909, 583, 6656, 6661, 101, 101, 59, 32768, 8893, 101, 100, 512, 59, 103, 6667, 6669, 32768, 8965, 101, 59, 32768, 8965, 114, 107, 512, 59, 116, 6680, 6682, 32768, 9141, 98, 114, 107, 59, 32768, 9142, 512, 111, 121, 6693, 6698, 110, 103, 59, 32768, 8780, 59, 32768, 1073, 113, 117, 111, 59, 32768, 8222, 1280, 99, 109, 112, 114, 116, 6718, 6731, 6738, 6743, 6749, 97, 117, 115, 512, 59, 101, 6726, 6728, 32768, 8757, 59, 32768, 8757, 112, 116, 121, 118, 59, 32768, 10672, 115, 105, 59, 32768, 1014, 110, 111, 117, 59, 32768, 8492, 768, 97, 104, 119, 6756, 6759, 6762, 59, 32768, 946, 59, 32768, 8502, 101, 101, 110, 59, 32768, 8812, 114, 59, 32896, 55349, 56607, 103, 1792, 99, 111, 115, 116, 117, 118, 119, 6789, 6809, 6834, 6850, 6872, 6879, 6884, 768, 97, 105, 117, 6796, 6800, 6805, 112, 59, 32768, 8898, 114, 99, 59, 32768, 9711, 112, 59, 32768, 8899, 768, 100, 112, 116, 6816, 6821, 6827, 111, 116, 59, 32768, 10752, 108, 117, 115, 59, 32768, 10753, 105, 109, 101, 115, 59, 32768, 10754, 1090, 6840, 0, 0, 6846, 99, 117, 112, 59, 32768, 10758, 97, 114, 59, 32768, 9733, 114, 105, 97, 110, 103, 108, 101, 512, 100, 117, 6862, 6868, 111, 119, 110, 59, 32768, 9661, 112, 59, 32768, 9651, 112, 108, 117, 115, 59, 32768, 10756, 101, 101, 59, 32768, 8897, 101, 100, 103, 101, 59, 32768, 8896, 97, 114, 111, 119, 59, 32768, 10509, 768, 97, 107, 111, 6905, 6976, 6994, 512, 99, 110, 6910, 6972, 107, 768, 108, 115, 116, 6918, 6927, 6935, 111, 122, 101, 110, 103, 101, 59, 32768, 10731, 113, 117, 97, 114, 101, 59, 32768, 9642, 114, 105, 97, 110, 103, 108, 101, 1024, 59, 100, 108, 114, 6951, 6953, 6959, 6965, 32768, 9652, 111, 119, 110, 59, 32768, 9662, 101, 102, 116, 59, 32768, 9666, 105, 103, 104, 116, 59, 32768, 9656, 107, 59, 32768, 9251, 770, 6981, 0, 6991, 771, 6985, 0, 6988, 59, 32768, 9618, 59, 32768, 9617, 52, 59, 32768, 9619, 99, 107, 59, 32768, 9608, 512, 101, 111, 7004, 7019, 512, 59, 113, 7009, 7012, 32896, 61, 8421, 117, 105, 118, 59, 32896, 8801, 8421, 116, 59, 32768, 8976, 1024, 112, 116, 119, 120, 7032, 7037, 7049, 7055, 102, 59, 32896, 55349, 56659, 512, 59, 116, 7042, 7044, 32768, 8869, 111, 109, 59, 32768, 8869, 116, 105, 101, 59, 32768, 8904, 3072, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7080, 7101, 7126, 7147, 7182, 7187, 7208, 7233, 7240, 7246, 7253, 7274, 1024, 76, 82, 108, 114, 7089, 7092, 7095, 7098, 59, 32768, 9559, 59, 32768, 9556, 59, 32768, 9558, 59, 32768, 9555, 1280, 59, 68, 85, 100, 117, 7112, 7114, 7117, 7120, 7123, 32768, 9552, 59, 32768, 9574, 59, 32768, 9577, 59, 32768, 9572, 59, 32768, 9575, 1024, 76, 82, 108, 114, 7135, 7138, 7141, 7144, 59, 32768, 9565, 59, 32768, 9562, 59, 32768, 9564, 59, 32768, 9561, 1792, 59, 72, 76, 82, 104, 108, 114, 7162, 7164, 7167, 7170, 7173, 7176, 7179, 32768, 9553, 59, 32768, 9580, 59, 32768, 9571, 59, 32768, 9568, 59, 32768, 9579, 59, 32768, 9570, 59, 32768, 9567, 111, 120, 59, 32768, 10697, 1024, 76, 82, 108, 114, 7196, 7199, 7202, 7205, 59, 32768, 9557, 59, 32768, 9554, 59, 32768, 9488, 59, 32768, 9484, 1280, 59, 68, 85, 100, 117, 7219, 7221, 7224, 7227, 7230, 32768, 9472, 59, 32768, 9573, 59, 32768, 9576, 59, 32768, 9516, 59, 32768, 9524, 105, 110, 117, 115, 59, 32768, 8863, 108, 117, 115, 59, 32768, 8862, 105, 109, 101, 115, 59, 32768, 8864, 1024, 76, 82, 108, 114, 7262, 7265, 7268, 7271, 59, 32768, 9563, 59, 32768, 9560, 59, 32768, 9496, 59, 32768, 9492, 1792, 59, 72, 76, 82, 104, 108, 114, 7289, 7291, 7294, 7297, 7300, 7303, 7306, 32768, 9474, 59, 32768, 9578, 59, 32768, 9569, 59, 32768, 9566, 59, 32768, 9532, 59, 32768, 9508, 59, 32768, 9500, 114, 105, 109, 101, 59, 32768, 8245, 512, 101, 118, 7321, 7326, 118, 101, 59, 32768, 728, 98, 97, 114, 33024, 166, 59, 32768, 166, 1024, 99, 101, 105, 111, 7343, 7348, 7353, 7364, 114, 59, 32896, 55349, 56503, 109, 105, 59, 32768, 8271, 109, 512, 59, 101, 7359, 7361, 32768, 8765, 59, 32768, 8909, 108, 768, 59, 98, 104, 7372, 7374, 7377, 32768, 92, 59, 32768, 10693, 115, 117, 98, 59, 32768, 10184, 573, 7387, 7399, 108, 512, 59, 101, 7392, 7394, 32768, 8226, 116, 59, 32768, 8226, 112, 768, 59, 69, 101, 7406, 7408, 7411, 32768, 8782, 59, 32768, 10926, 512, 59, 113, 7416, 7418, 32768, 8783, 59, 32768, 8783, 6450, 7448, 0, 7523, 7571, 7576, 7613, 0, 7618, 7647, 0, 0, 7764, 0, 0, 7779, 0, 0, 7899, 7914, 7949, 7955, 0, 8158, 0, 8176, 768, 99, 112, 114, 7454, 7460, 7509, 117, 116, 101, 59, 32768, 263, 1536, 59, 97, 98, 99, 100, 115, 7473, 7475, 7480, 7487, 7500, 7505, 32768, 8745, 110, 100, 59, 32768, 10820, 114, 99, 117, 112, 59, 32768, 10825, 512, 97, 117, 7492, 7496, 112, 59, 32768, 10827, 112, 59, 32768, 10823, 111, 116, 59, 32768, 10816, 59, 32896, 8745, 65024, 512, 101, 111, 7514, 7518, 116, 59, 32768, 8257, 110, 59, 32768, 711, 1024, 97, 101, 105, 117, 7531, 7544, 7552, 7557, 833, 7536, 0, 7540, 115, 59, 32768, 10829, 111, 110, 59, 32768, 269, 100, 105, 108, 33024, 231, 59, 32768, 231, 114, 99, 59, 32768, 265, 112, 115, 512, 59, 115, 7564, 7566, 32768, 10828, 109, 59, 32768, 10832, 111, 116, 59, 32768, 267, 768, 100, 109, 110, 7582, 7589, 7596, 105, 108, 33024, 184, 59, 32768, 184, 112, 116, 121, 118, 59, 32768, 10674, 116, 33280, 162, 59, 101, 7603, 7605, 32768, 162, 114, 100, 111, 116, 59, 32768, 183, 114, 59, 32896, 55349, 56608, 768, 99, 101, 105, 7624, 7628, 7643, 121, 59, 32768, 1095, 99, 107, 512, 59, 109, 7635, 7637, 32768, 10003, 97, 114, 107, 59, 32768, 10003, 59, 32768, 967, 114, 1792, 59, 69, 99, 101, 102, 109, 115, 7662, 7664, 7667, 7742, 7745, 7752, 7757, 32768, 9675, 59, 32768, 10691, 768, 59, 101, 108, 7674, 7676, 7680, 32768, 710, 113, 59, 32768, 8791, 101, 1074, 7687, 0, 0, 7709, 114, 114, 111, 119, 512, 108, 114, 7695, 7701, 101, 102, 116, 59, 32768, 8634, 105, 103, 104, 116, 59, 32768, 8635, 1280, 82, 83, 97, 99, 100, 7719, 7722, 7725, 7730, 7736, 59, 32768, 174, 59, 32768, 9416, 115, 116, 59, 32768, 8859, 105, 114, 99, 59, 32768, 8858, 97, 115, 104, 59, 32768, 8861, 59, 32768, 8791, 110, 105, 110, 116, 59, 32768, 10768, 105, 100, 59, 32768, 10991, 99, 105, 114, 59, 32768, 10690, 117, 98, 115, 512, 59, 117, 7771, 7773, 32768, 9827, 105, 116, 59, 32768, 9827, 1341, 7785, 7804, 7850, 0, 7871, 111, 110, 512, 59, 101, 7791, 7793, 32768, 58, 512, 59, 113, 7798, 7800, 32768, 8788, 59, 32768, 8788, 1086, 7809, 0, 0, 7820, 97, 512, 59, 116, 7814, 7816, 32768, 44, 59, 32768, 64, 768, 59, 102, 108, 7826, 7828, 7832, 32768, 8705, 110, 59, 32768, 8728, 101, 512, 109, 120, 7838, 7844, 101, 110, 116, 59, 32768, 8705, 101, 115, 59, 32768, 8450, 824, 7854, 0, 7866, 512, 59, 100, 7858, 7860, 32768, 8773, 111, 116, 59, 32768, 10861, 110, 116, 59, 32768, 8750, 768, 102, 114, 121, 7877, 7881, 7886, 59, 32896, 55349, 56660, 111, 100, 59, 32768, 8720, 33280, 169, 59, 115, 7892, 7894, 32768, 169, 114, 59, 32768, 8471, 512, 97, 111, 7903, 7908, 114, 114, 59, 32768, 8629, 115, 115, 59, 32768, 10007, 512, 99, 117, 7918, 7923, 114, 59, 32896, 55349, 56504, 512, 98, 112, 7928, 7938, 512, 59, 101, 7933, 7935, 32768, 10959, 59, 32768, 10961, 512, 59, 101, 7943, 7945, 32768, 10960, 59, 32768, 10962, 100, 111, 116, 59, 32768, 8943, 1792, 100, 101, 108, 112, 114, 118, 119, 7969, 7983, 7996, 8009, 8057, 8147, 8152, 97, 114, 114, 512, 108, 114, 7977, 7980, 59, 32768, 10552, 59, 32768, 10549, 1089, 7989, 0, 0, 7993, 114, 59, 32768, 8926, 99, 59, 32768, 8927, 97, 114, 114, 512, 59, 112, 8004, 8006, 32768, 8630, 59, 32768, 10557, 1536, 59, 98, 99, 100, 111, 115, 8022, 8024, 8031, 8044, 8049, 8053, 32768, 8746, 114, 99, 97, 112, 59, 32768, 10824, 512, 97, 117, 8036, 8040, 112, 59, 32768, 10822, 112, 59, 32768, 10826, 111, 116, 59, 32768, 8845, 114, 59, 32768, 10821, 59, 32896, 8746, 65024, 1024, 97, 108, 114, 118, 8066, 8078, 8116, 8123, 114, 114, 512, 59, 109, 8073, 8075, 32768, 8631, 59, 32768, 10556, 121, 768, 101, 118, 119, 8086, 8104, 8109, 113, 1089, 8093, 0, 0, 8099, 114, 101, 99, 59, 32768, 8926, 117, 99, 99, 59, 32768, 8927, 101, 101, 59, 32768, 8910, 101, 100, 103, 101, 59, 32768, 8911, 101, 110, 33024, 164, 59, 32768, 164, 101, 97, 114, 114, 111, 119, 512, 108, 114, 8134, 8140, 101, 102, 116, 59, 32768, 8630, 105, 103, 104, 116, 59, 32768, 8631, 101, 101, 59, 32768, 8910, 101, 100, 59, 32768, 8911, 512, 99, 105, 8162, 8170, 111, 110, 105, 110, 116, 59, 32768, 8754, 110, 116, 59, 32768, 8753, 108, 99, 116, 121, 59, 32768, 9005, 4864, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8221, 8226, 8231, 8267, 8282, 8296, 8327, 8351, 8366, 8379, 8466, 8471, 8487, 8621, 8647, 8676, 8697, 8712, 8720, 114, 114, 59, 32768, 8659, 97, 114, 59, 32768, 10597, 1024, 103, 108, 114, 115, 8240, 8246, 8252, 8256, 103, 101, 114, 59, 32768, 8224, 101, 116, 104, 59, 32768, 8504, 114, 59, 32768, 8595, 104, 512, 59, 118, 8262, 8264, 32768, 8208, 59, 32768, 8867, 572, 8271, 8278, 97, 114, 111, 119, 59, 32768, 10511, 97, 99, 59, 32768, 733, 512, 97, 121, 8287, 8293, 114, 111, 110, 59, 32768, 271, 59, 32768, 1076, 768, 59, 97, 111, 8303, 8305, 8320, 32768, 8518, 512, 103, 114, 8310, 8316, 103, 101, 114, 59, 32768, 8225, 114, 59, 32768, 8650, 116, 115, 101, 113, 59, 32768, 10871, 768, 103, 108, 109, 8334, 8339, 8344, 33024, 176, 59, 32768, 176, 116, 97, 59, 32768, 948, 112, 116, 121, 118, 59, 32768, 10673, 512, 105, 114, 8356, 8362, 115, 104, 116, 59, 32768, 10623, 59, 32896, 55349, 56609, 97, 114, 512, 108, 114, 8373, 8376, 59, 32768, 8643, 59, 32768, 8642, 1280, 97, 101, 103, 115, 118, 8390, 8418, 8421, 8428, 8433, 109, 768, 59, 111, 115, 8398, 8400, 8415, 32768, 8900, 110, 100, 512, 59, 115, 8407, 8409, 32768, 8900, 117, 105, 116, 59, 32768, 9830, 59, 32768, 9830, 59, 32768, 168, 97, 109, 109, 97, 59, 32768, 989, 105, 110, 59, 32768, 8946, 768, 59, 105, 111, 8440, 8442, 8461, 32768, 247, 100, 101, 33280, 247, 59, 111, 8450, 8452, 32768, 247, 110, 116, 105, 109, 101, 115, 59, 32768, 8903, 110, 120, 59, 32768, 8903, 99, 121, 59, 32768, 1106, 99, 1088, 8478, 0, 0, 8483, 114, 110, 59, 32768, 8990, 111, 112, 59, 32768, 8973, 1280, 108, 112, 116, 117, 119, 8498, 8504, 8509, 8556, 8570, 108, 97, 114, 59, 32768, 36, 102, 59, 32896, 55349, 56661, 1280, 59, 101, 109, 112, 115, 8520, 8522, 8535, 8542, 8548, 32768, 729, 113, 512, 59, 100, 8528, 8530, 32768, 8784, 111, 116, 59, 32768, 8785, 105, 110, 117, 115, 59, 32768, 8760, 108, 117, 115, 59, 32768, 8724, 113, 117, 97, 114, 101, 59, 32768, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 32768, 8966, 110, 768, 97, 100, 104, 8578, 8585, 8597, 114, 114, 111, 119, 59, 32768, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 32768, 8650, 97, 114, 112, 111, 111, 110, 512, 108, 114, 8608, 8614, 101, 102, 116, 59, 32768, 8643, 105, 103, 104, 116, 59, 32768, 8642, 563, 8625, 8633, 107, 97, 114, 111, 119, 59, 32768, 10512, 1088, 8638, 0, 0, 8643, 114, 110, 59, 32768, 8991, 111, 112, 59, 32768, 8972, 768, 99, 111, 116, 8654, 8666, 8670, 512, 114, 121, 8659, 8663, 59, 32896, 55349, 56505, 59, 32768, 1109, 108, 59, 32768, 10742, 114, 111, 107, 59, 32768, 273, 512, 100, 114, 8681, 8686, 111, 116, 59, 32768, 8945, 105, 512, 59, 102, 8692, 8694, 32768, 9663, 59, 32768, 9662, 512, 97, 104, 8702, 8707, 114, 114, 59, 32768, 8693, 97, 114, 59, 32768, 10607, 97, 110, 103, 108, 101, 59, 32768, 10662, 512, 99, 105, 8725, 8729, 121, 59, 32768, 1119, 103, 114, 97, 114, 114, 59, 32768, 10239, 4608, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 8774, 8788, 8807, 8844, 8849, 8852, 8866, 8895, 8929, 8977, 8989, 9004, 9046, 9136, 9151, 9171, 9184, 9199, 512, 68, 111, 8779, 8784, 111, 116, 59, 32768, 10871, 116, 59, 32768, 8785, 512, 99, 115, 8793, 8801, 117, 116, 101, 33024, 233, 59, 32768, 233, 116, 101, 114, 59, 32768, 10862, 1024, 97, 105, 111, 121, 8816, 8822, 8835, 8841, 114, 111, 110, 59, 32768, 283, 114, 512, 59, 99, 8828, 8830, 32768, 8790, 33024, 234, 59, 32768, 234, 108, 111, 110, 59, 32768, 8789, 59, 32768, 1101, 111, 116, 59, 32768, 279, 59, 32768, 8519, 512, 68, 114, 8857, 8862, 111, 116, 59, 32768, 8786, 59, 32896, 55349, 56610, 768, 59, 114, 115, 8873, 8875, 8883, 32768, 10906, 97, 118, 101, 33024, 232, 59, 32768, 232, 512, 59, 100, 8888, 8890, 32768, 10902, 111, 116, 59, 32768, 10904, 1024, 59, 105, 108, 115, 8904, 8906, 8914, 8917, 32768, 10905, 110, 116, 101, 114, 115, 59, 32768, 9191, 59, 32768, 8467, 512, 59, 100, 8922, 8924, 32768, 10901, 111, 116, 59, 32768, 10903, 768, 97, 112, 115, 8936, 8941, 8960, 99, 114, 59, 32768, 275, 116, 121, 768, 59, 115, 118, 8950, 8952, 8957, 32768, 8709, 101, 116, 59, 32768, 8709, 59, 32768, 8709, 112, 512, 49, 59, 8966, 8975, 516, 8970, 8973, 59, 32768, 8196, 59, 32768, 8197, 32768, 8195, 512, 103, 115, 8982, 8985, 59, 32768, 331, 112, 59, 32768, 8194, 512, 103, 112, 8994, 8999, 111, 110, 59, 32768, 281, 102, 59, 32896, 55349, 56662, 768, 97, 108, 115, 9011, 9023, 9028, 114, 512, 59, 115, 9017, 9019, 32768, 8917, 108, 59, 32768, 10723, 117, 115, 59, 32768, 10865, 105, 768, 59, 108, 118, 9036, 9038, 9043, 32768, 949, 111, 110, 59, 32768, 949, 59, 32768, 1013, 1024, 99, 115, 117, 118, 9055, 9071, 9099, 9128, 512, 105, 111, 9060, 9065, 114, 99, 59, 32768, 8790, 108, 111, 110, 59, 32768, 8789, 1082, 9077, 0, 0, 9081, 109, 59, 32768, 8770, 97, 110, 116, 512, 103, 108, 9088, 9093, 116, 114, 59, 32768, 10902, 101, 115, 115, 59, 32768, 10901, 768, 97, 101, 105, 9106, 9111, 9116, 108, 115, 59, 32768, 61, 115, 116, 59, 32768, 8799, 118, 512, 59, 68, 9122, 9124, 32768, 8801, 68, 59, 32768, 10872, 112, 97, 114, 115, 108, 59, 32768, 10725, 512, 68, 97, 9141, 9146, 111, 116, 59, 32768, 8787, 114, 114, 59, 32768, 10609, 768, 99, 100, 105, 9158, 9162, 9167, 114, 59, 32768, 8495, 111, 116, 59, 32768, 8784, 109, 59, 32768, 8770, 512, 97, 104, 9176, 9179, 59, 32768, 951, 33024, 240, 59, 32768, 240, 512, 109, 114, 9189, 9195, 108, 33024, 235, 59, 32768, 235, 111, 59, 32768, 8364, 768, 99, 105, 112, 9206, 9210, 9215, 108, 59, 32768, 33, 115, 116, 59, 32768, 8707, 512, 101, 111, 9220, 9230, 99, 116, 97, 116, 105, 111, 110, 59, 32768, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 32768, 8519, 4914, 9262, 0, 9276, 0, 9280, 9287, 0, 0, 9318, 9324, 0, 9331, 0, 9352, 9357, 9386, 0, 9395, 9497, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 32768, 8786, 121, 59, 32768, 1092, 109, 97, 108, 101, 59, 32768, 9792, 768, 105, 108, 114, 9293, 9299, 9313, 108, 105, 103, 59, 32768, 64259, 1082, 9305, 0, 0, 9309, 103, 59, 32768, 64256, 105, 103, 59, 32768, 64260, 59, 32896, 55349, 56611, 108, 105, 103, 59, 32768, 64257, 108, 105, 103, 59, 32896, 102, 106, 768, 97, 108, 116, 9337, 9341, 9346, 116, 59, 32768, 9837, 105, 103, 59, 32768, 64258, 110, 115, 59, 32768, 9649, 111, 102, 59, 32768, 402, 833, 9361, 0, 9366, 102, 59, 32896, 55349, 56663, 512, 97, 107, 9370, 9375, 108, 108, 59, 32768, 8704, 512, 59, 118, 9380, 9382, 32768, 8916, 59, 32768, 10969, 97, 114, 116, 105, 110, 116, 59, 32768, 10765, 512, 97, 111, 9399, 9491, 512, 99, 115, 9404, 9487, 1794, 9413, 9443, 9453, 9470, 9474, 0, 9484, 1795, 9421, 9426, 9429, 9434, 9437, 0, 9440, 33024, 189, 59, 32768, 189, 59, 32768, 8531, 33024, 188, 59, 32768, 188, 59, 32768, 8533, 59, 32768, 8537, 59, 32768, 8539, 772, 9447, 0, 9450, 59, 32768, 8532, 59, 32768, 8534, 1285, 9459, 9464, 0, 0, 9467, 33024, 190, 59, 32768, 190, 59, 32768, 8535, 59, 32768, 8540, 53, 59, 32768, 8536, 775, 9478, 0, 9481, 59, 32768, 8538, 59, 32768, 8541, 56, 59, 32768, 8542, 108, 59, 32768, 8260, 119, 110, 59, 32768, 8994, 99, 114, 59, 32896, 55349, 56507, 4352, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 9537, 9547, 9575, 9582, 9595, 9600, 9679, 9684, 9694, 9700, 9705, 9725, 9773, 9779, 9785, 9810, 9917, 512, 59, 108, 9542, 9544, 32768, 8807, 59, 32768, 10892, 768, 99, 109, 112, 9554, 9560, 9572, 117, 116, 101, 59, 32768, 501, 109, 97, 512, 59, 100, 9567, 9569, 32768, 947, 59, 32768, 989, 59, 32768, 10886, 114, 101, 118, 101, 59, 32768, 287, 512, 105, 121, 9587, 9592, 114, 99, 59, 32768, 285, 59, 32768, 1075, 111, 116, 59, 32768, 289, 1024, 59, 108, 113, 115, 9609, 9611, 9614, 9633, 32768, 8805, 59, 32768, 8923, 768, 59, 113, 115, 9621, 9623, 9626, 32768, 8805, 59, 32768, 8807, 108, 97, 110, 116, 59, 32768, 10878, 1024, 59, 99, 100, 108, 9642, 9644, 9648, 9667, 32768, 10878, 99, 59, 32768, 10921, 111, 116, 512, 59, 111, 9655, 9657, 32768, 10880, 512, 59, 108, 9662, 9664, 32768, 10882, 59, 32768, 10884, 512, 59, 101, 9672, 9675, 32896, 8923, 65024, 115, 59, 32768, 10900, 114, 59, 32896, 55349, 56612, 512, 59, 103, 9689, 9691, 32768, 8811, 59, 32768, 8921, 109, 101, 108, 59, 32768, 8503, 99, 121, 59, 32768, 1107, 1024, 59, 69, 97, 106, 9714, 9716, 9719, 9722, 32768, 8823, 59, 32768, 10898, 59, 32768, 10917, 59, 32768, 10916, 1024, 69, 97, 101, 115, 9734, 9737, 9751, 9768, 59, 32768, 8809, 112, 512, 59, 112, 9743, 9745, 32768, 10890, 114, 111, 120, 59, 32768, 10890, 512, 59, 113, 9756, 9758, 32768, 10888, 512, 59, 113, 9763, 9765, 32768, 10888, 59, 32768, 8809, 105, 109, 59, 32768, 8935, 112, 102, 59, 32896, 55349, 56664, 97, 118, 101, 59, 32768, 96, 512, 99, 105, 9790, 9794, 114, 59, 32768, 8458, 109, 768, 59, 101, 108, 9802, 9804, 9807, 32768, 8819, 59, 32768, 10894, 59, 32768, 10896, 34304, 62, 59, 99, 100, 108, 113, 114, 9824, 9826, 9838, 9843, 9849, 9856, 32768, 62, 512, 99, 105, 9831, 9834, 59, 32768, 10919, 114, 59, 32768, 10874, 111, 116, 59, 32768, 8919, 80, 97, 114, 59, 32768, 10645, 117, 101, 115, 116, 59, 32768, 10876, 1280, 97, 100, 101, 108, 115, 9867, 9882, 9887, 9906, 9912, 833, 9872, 0, 9879, 112, 114, 111, 120, 59, 32768, 10886, 114, 59, 32768, 10616, 111, 116, 59, 32768, 8919, 113, 512, 108, 113, 9893, 9899, 101, 115, 115, 59, 32768, 8923, 108, 101, 115, 115, 59, 32768, 10892, 101, 115, 115, 59, 32768, 8823, 105, 109, 59, 32768, 8819, 512, 101, 110, 9922, 9932, 114, 116, 110, 101, 113, 113, 59, 32896, 8809, 65024, 69, 59, 32896, 8809, 65024, 2560, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 9958, 9963, 10015, 10020, 10026, 10060, 10065, 10085, 10147, 10171, 114, 114, 59, 32768, 8660, 1024, 105, 108, 109, 114, 9972, 9978, 9982, 9988, 114, 115, 112, 59, 32768, 8202, 102, 59, 32768, 189, 105, 108, 116, 59, 32768, 8459, 512, 100, 114, 9993, 9998, 99, 121, 59, 32768, 1098, 768, 59, 99, 119, 10005, 10007, 10012, 32768, 8596, 105, 114, 59, 32768, 10568, 59, 32768, 8621, 97, 114, 59, 32768, 8463, 105, 114, 99, 59, 32768, 293, 768, 97, 108, 114, 10033, 10048, 10054, 114, 116, 115, 512, 59, 117, 10041, 10043, 32768, 9829, 105, 116, 59, 32768, 9829, 108, 105, 112, 59, 32768, 8230, 99, 111, 110, 59, 32768, 8889, 114, 59, 32896, 55349, 56613, 115, 512, 101, 119, 10071, 10078, 97, 114, 111, 119, 59, 32768, 10533, 97, 114, 111, 119, 59, 32768, 10534, 1280, 97, 109, 111, 112, 114, 10096, 10101, 10107, 10136, 10141, 114, 114, 59, 32768, 8703, 116, 104, 116, 59, 32768, 8763, 107, 512, 108, 114, 10113, 10124, 101, 102, 116, 97, 114, 114, 111, 119, 59, 32768, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8618, 102, 59, 32896, 55349, 56665, 98, 97, 114, 59, 32768, 8213, 768, 99, 108, 116, 10154, 10159, 10165, 114, 59, 32896, 55349, 56509, 97, 115, 104, 59, 32768, 8463, 114, 111, 107, 59, 32768, 295, 512, 98, 112, 10176, 10182, 117, 108, 108, 59, 32768, 8259, 104, 101, 110, 59, 32768, 8208, 5426, 10211, 0, 10220, 0, 10239, 10255, 10267, 0, 10276, 10312, 0, 0, 10318, 10371, 10458, 10485, 10491, 0, 10500, 10545, 10558, 99, 117, 116, 101, 33024, 237, 59, 32768, 237, 768, 59, 105, 121, 10226, 10228, 10235, 32768, 8291, 114, 99, 33024, 238, 59, 32768, 238, 59, 32768, 1080, 512, 99, 120, 10243, 10247, 121, 59, 32768, 1077, 99, 108, 33024, 161, 59, 32768, 161, 512, 102, 114, 10259, 10262, 59, 32768, 8660, 59, 32896, 55349, 56614, 114, 97, 118, 101, 33024, 236, 59, 32768, 236, 1024, 59, 105, 110, 111, 10284, 10286, 10300, 10306, 32768, 8520, 512, 105, 110, 10291, 10296, 110, 116, 59, 32768, 10764, 116, 59, 32768, 8749, 102, 105, 110, 59, 32768, 10716, 116, 97, 59, 32768, 8489, 108, 105, 103, 59, 32768, 307, 768, 97, 111, 112, 10324, 10361, 10365, 768, 99, 103, 116, 10331, 10335, 10357, 114, 59, 32768, 299, 768, 101, 108, 112, 10342, 10345, 10351, 59, 32768, 8465, 105, 110, 101, 59, 32768, 8464, 97, 114, 116, 59, 32768, 8465, 104, 59, 32768, 305, 102, 59, 32768, 8887, 101, 100, 59, 32768, 437, 1280, 59, 99, 102, 111, 116, 10381, 10383, 10389, 10403, 10409, 32768, 8712, 97, 114, 101, 59, 32768, 8453, 105, 110, 512, 59, 116, 10396, 10398, 32768, 8734, 105, 101, 59, 32768, 10717, 100, 111, 116, 59, 32768, 305, 1280, 59, 99, 101, 108, 112, 10420, 10422, 10427, 10444, 10451, 32768, 8747, 97, 108, 59, 32768, 8890, 512, 103, 114, 10432, 10438, 101, 114, 115, 59, 32768, 8484, 99, 97, 108, 59, 32768, 8890, 97, 114, 104, 107, 59, 32768, 10775, 114, 111, 100, 59, 32768, 10812, 1024, 99, 103, 112, 116, 10466, 10470, 10475, 10480, 121, 59, 32768, 1105, 111, 110, 59, 32768, 303, 102, 59, 32896, 55349, 56666, 97, 59, 32768, 953, 114, 111, 100, 59, 32768, 10812, 117, 101, 115, 116, 33024, 191, 59, 32768, 191, 512, 99, 105, 10504, 10509, 114, 59, 32896, 55349, 56510, 110, 1280, 59, 69, 100, 115, 118, 10521, 10523, 10526, 10531, 10541, 32768, 8712, 59, 32768, 8953, 111, 116, 59, 32768, 8949, 512, 59, 118, 10536, 10538, 32768, 8948, 59, 32768, 8947, 59, 32768, 8712, 512, 59, 105, 10549, 10551, 32768, 8290, 108, 100, 101, 59, 32768, 297, 828, 10562, 0, 10567, 99, 121, 59, 32768, 1110, 108, 33024, 239, 59, 32768, 239, 1536, 99, 102, 109, 111, 115, 117, 10585, 10598, 10603, 10609, 10615, 10630, 512, 105, 121, 10590, 10595, 114, 99, 59, 32768, 309, 59, 32768, 1081, 114, 59, 32896, 55349, 56615, 97, 116, 104, 59, 32768, 567, 112, 102, 59, 32896, 55349, 56667, 820, 10620, 0, 10625, 114, 59, 32896, 55349, 56511, 114, 99, 121, 59, 32768, 1112, 107, 99, 121, 59, 32768, 1108, 2048, 97, 99, 102, 103, 104, 106, 111, 115, 10653, 10666, 10680, 10685, 10692, 10697, 10702, 10708, 112, 112, 97, 512, 59, 118, 10661, 10663, 32768, 954, 59, 32768, 1008, 512, 101, 121, 10671, 10677, 100, 105, 108, 59, 32768, 311, 59, 32768, 1082, 114, 59, 32896, 55349, 56616, 114, 101, 101, 110, 59, 32768, 312, 99, 121, 59, 32768, 1093, 99, 121, 59, 32768, 1116, 112, 102, 59, 32896, 55349, 56668, 99, 114, 59, 32896, 55349, 56512, 5888, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 10761, 10783, 10789, 10799, 10804, 10957, 11011, 11047, 11094, 11349, 11372, 11382, 11409, 11414, 11451, 11478, 11526, 11698, 11711, 11755, 11823, 11910, 11929, 768, 97, 114, 116, 10768, 10773, 10777, 114, 114, 59, 32768, 8666, 114, 59, 32768, 8656, 97, 105, 108, 59, 32768, 10523, 97, 114, 114, 59, 32768, 10510, 512, 59, 103, 10794, 10796, 32768, 8806, 59, 32768, 10891, 97, 114, 59, 32768, 10594, 4660, 10824, 0, 10830, 0, 10838, 0, 0, 0, 0, 0, 10844, 10850, 0, 10867, 10870, 10877, 0, 10933, 117, 116, 101, 59, 32768, 314, 109, 112, 116, 121, 118, 59, 32768, 10676, 114, 97, 110, 59, 32768, 8466, 98, 100, 97, 59, 32768, 955, 103, 768, 59, 100, 108, 10857, 10859, 10862, 32768, 10216, 59, 32768, 10641, 101, 59, 32768, 10216, 59, 32768, 10885, 117, 111, 33024, 171, 59, 32768, 171, 114, 2048, 59, 98, 102, 104, 108, 112, 115, 116, 10894, 10896, 10907, 10911, 10915, 10919, 10923, 10928, 32768, 8592, 512, 59, 102, 10901, 10903, 32768, 8676, 115, 59, 32768, 10527, 115, 59, 32768, 10525, 107, 59, 32768, 8617, 112, 59, 32768, 8619, 108, 59, 32768, 10553, 105, 109, 59, 32768, 10611, 108, 59, 32768, 8610, 768, 59, 97, 101, 10939, 10941, 10946, 32768, 10923, 105, 108, 59, 32768, 10521, 512, 59, 115, 10951, 10953, 32768, 10925, 59, 32896, 10925, 65024, 768, 97, 98, 114, 10964, 10969, 10974, 114, 114, 59, 32768, 10508, 114, 107, 59, 32768, 10098, 512, 97, 107, 10979, 10991, 99, 512, 101, 107, 10985, 10988, 59, 32768, 123, 59, 32768, 91, 512, 101, 115, 10996, 10999, 59, 32768, 10635, 108, 512, 100, 117, 11005, 11008, 59, 32768, 10639, 59, 32768, 10637, 1024, 97, 101, 117, 121, 11020, 11026, 11040, 11044, 114, 111, 110, 59, 32768, 318, 512, 100, 105, 11031, 11036, 105, 108, 59, 32768, 316, 108, 59, 32768, 8968, 98, 59, 32768, 123, 59, 32768, 1083, 1024, 99, 113, 114, 115, 11056, 11060, 11072, 11090, 97, 59, 32768, 10550, 117, 111, 512, 59, 114, 11067, 11069, 32768, 8220, 59, 32768, 8222, 512, 100, 117, 11077, 11083, 104, 97, 114, 59, 32768, 10599, 115, 104, 97, 114, 59, 32768, 10571, 104, 59, 32768, 8626, 1280, 59, 102, 103, 113, 115, 11105, 11107, 11228, 11231, 11250, 32768, 8804, 116, 1280, 97, 104, 108, 114, 116, 11119, 11136, 11157, 11169, 11216, 114, 114, 111, 119, 512, 59, 116, 11128, 11130, 32768, 8592, 97, 105, 108, 59, 32768, 8610, 97, 114, 112, 111, 111, 110, 512, 100, 117, 11147, 11153, 111, 119, 110, 59, 32768, 8637, 112, 59, 32768, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 32768, 8647, 105, 103, 104, 116, 768, 97, 104, 115, 11180, 11194, 11204, 114, 114, 111, 119, 512, 59, 115, 11189, 11191, 32768, 8596, 59, 32768, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 32768, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 32768, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 32768, 8907, 59, 32768, 8922, 768, 59, 113, 115, 11238, 11240, 11243, 32768, 8804, 59, 32768, 8806, 108, 97, 110, 116, 59, 32768, 10877, 1280, 59, 99, 100, 103, 115, 11261, 11263, 11267, 11286, 11298, 32768, 10877, 99, 59, 32768, 10920, 111, 116, 512, 59, 111, 11274, 11276, 32768, 10879, 512, 59, 114, 11281, 11283, 32768, 10881, 59, 32768, 10883, 512, 59, 101, 11291, 11294, 32896, 8922, 65024, 115, 59, 32768, 10899, 1280, 97, 100, 101, 103, 115, 11309, 11317, 11322, 11339, 11344, 112, 112, 114, 111, 120, 59, 32768, 10885, 111, 116, 59, 32768, 8918, 113, 512, 103, 113, 11328, 11333, 116, 114, 59, 32768, 8922, 103, 116, 114, 59, 32768, 10891, 116, 114, 59, 32768, 8822, 105, 109, 59, 32768, 8818, 768, 105, 108, 114, 11356, 11362, 11368, 115, 104, 116, 59, 32768, 10620, 111, 111, 114, 59, 32768, 8970, 59, 32896, 55349, 56617, 512, 59, 69, 11377, 11379, 32768, 8822, 59, 32768, 10897, 562, 11386, 11405, 114, 512, 100, 117, 11391, 11394, 59, 32768, 8637, 512, 59, 108, 11399, 11401, 32768, 8636, 59, 32768, 10602, 108, 107, 59, 32768, 9604, 99, 121, 59, 32768, 1113, 1280, 59, 97, 99, 104, 116, 11425, 11427, 11432, 11440, 11446, 32768, 8810, 114, 114, 59, 32768, 8647, 111, 114, 110, 101, 114, 59, 32768, 8990, 97, 114, 100, 59, 32768, 10603, 114, 105, 59, 32768, 9722, 512, 105, 111, 11456, 11462, 100, 111, 116, 59, 32768, 320, 117, 115, 116, 512, 59, 97, 11470, 11472, 32768, 9136, 99, 104, 101, 59, 32768, 9136, 1024, 69, 97, 101, 115, 11487, 11490, 11504, 11521, 59, 32768, 8808, 112, 512, 59, 112, 11496, 11498, 32768, 10889, 114, 111, 120, 59, 32768, 10889, 512, 59, 113, 11509, 11511, 32768, 10887, 512, 59, 113, 11516, 11518, 32768, 10887, 59, 32768, 8808, 105, 109, 59, 32768, 8934, 2048, 97, 98, 110, 111, 112, 116, 119, 122, 11543, 11556, 11561, 11616, 11640, 11660, 11667, 11680, 512, 110, 114, 11548, 11552, 103, 59, 32768, 10220, 114, 59, 32768, 8701, 114, 107, 59, 32768, 10214, 103, 768, 108, 109, 114, 11569, 11596, 11604, 101, 102, 116, 512, 97, 114, 11577, 11584, 114, 114, 111, 119, 59, 32768, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10231, 97, 112, 115, 116, 111, 59, 32768, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10230, 112, 97, 114, 114, 111, 119, 512, 108, 114, 11627, 11633, 101, 102, 116, 59, 32768, 8619, 105, 103, 104, 116, 59, 32768, 8620, 768, 97, 102, 108, 11647, 11651, 11655, 114, 59, 32768, 10629, 59, 32896, 55349, 56669, 117, 115, 59, 32768, 10797, 105, 109, 101, 115, 59, 32768, 10804, 562, 11671, 11676, 115, 116, 59, 32768, 8727, 97, 114, 59, 32768, 95, 768, 59, 101, 102, 11687, 11689, 11695, 32768, 9674, 110, 103, 101, 59, 32768, 9674, 59, 32768, 10731, 97, 114, 512, 59, 108, 11705, 11707, 32768, 40, 116, 59, 32768, 10643, 1280, 97, 99, 104, 109, 116, 11722, 11727, 11735, 11747, 11750, 114, 114, 59, 32768, 8646, 111, 114, 110, 101, 114, 59, 32768, 8991, 97, 114, 512, 59, 100, 11742, 11744, 32768, 8651, 59, 32768, 10605, 59, 32768, 8206, 114, 105, 59, 32768, 8895, 1536, 97, 99, 104, 105, 113, 116, 11768, 11774, 11779, 11782, 11798, 11817, 113, 117, 111, 59, 32768, 8249, 114, 59, 32896, 55349, 56513, 59, 32768, 8624, 109, 768, 59, 101, 103, 11790, 11792, 11795, 32768, 8818, 59, 32768, 10893, 59, 32768, 10895, 512, 98, 117, 11803, 11806, 59, 32768, 91, 111, 512, 59, 114, 11812, 11814, 32768, 8216, 59, 32768, 8218, 114, 111, 107, 59, 32768, 322, 34816, 60, 59, 99, 100, 104, 105, 108, 113, 114, 11841, 11843, 11855, 11860, 11866, 11872, 11878, 11885, 32768, 60, 512, 99, 105, 11848, 11851, 59, 32768, 10918, 114, 59, 32768, 10873, 111, 116, 59, 32768, 8918, 114, 101, 101, 59, 32768, 8907, 109, 101, 115, 59, 32768, 8905, 97, 114, 114, 59, 32768, 10614, 117, 101, 115, 116, 59, 32768, 10875, 512, 80, 105, 11890, 11895, 97, 114, 59, 32768, 10646, 768, 59, 101, 102, 11902, 11904, 11907, 32768, 9667, 59, 32768, 8884, 59, 32768, 9666, 114, 512, 100, 117, 11916, 11923, 115, 104, 97, 114, 59, 32768, 10570, 104, 97, 114, 59, 32768, 10598, 512, 101, 110, 11934, 11944, 114, 116, 110, 101, 113, 113, 59, 32896, 8808, 65024, 69, 59, 32896, 8808, 65024, 3584, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 11978, 11984, 12061, 12075, 12081, 12095, 12100, 12104, 12170, 12181, 12188, 12204, 12207, 12223, 68, 111, 116, 59, 32768, 8762, 1024, 99, 108, 112, 114, 11993, 11999, 12019, 12055, 114, 33024, 175, 59, 32768, 175, 512, 101, 116, 12004, 12007, 59, 32768, 9794, 512, 59, 101, 12012, 12014, 32768, 10016, 115, 101, 59, 32768, 10016, 512, 59, 115, 12024, 12026, 32768, 8614, 116, 111, 1024, 59, 100, 108, 117, 12037, 12039, 12045, 12051, 32768, 8614, 111, 119, 110, 59, 32768, 8615, 101, 102, 116, 59, 32768, 8612, 112, 59, 32768, 8613, 107, 101, 114, 59, 32768, 9646, 512, 111, 121, 12066, 12072, 109, 109, 97, 59, 32768, 10793, 59, 32768, 1084, 97, 115, 104, 59, 32768, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 32768, 8737, 114, 59, 32896, 55349, 56618, 111, 59, 32768, 8487, 768, 99, 100, 110, 12111, 12118, 12146, 114, 111, 33024, 181, 59, 32768, 181, 1024, 59, 97, 99, 100, 12127, 12129, 12134, 12139, 32768, 8739, 115, 116, 59, 32768, 42, 105, 114, 59, 32768, 10992, 111, 116, 33024, 183, 59, 32768, 183, 117, 115, 768, 59, 98, 100, 12155, 12157, 12160, 32768, 8722, 59, 32768, 8863, 512, 59, 117, 12165, 12167, 32768, 8760, 59, 32768, 10794, 564, 12174, 12178, 112, 59, 32768, 10971, 114, 59, 32768, 8230, 112, 108, 117, 115, 59, 32768, 8723, 512, 100, 112, 12193, 12199, 101, 108, 115, 59, 32768, 8871, 102, 59, 32896, 55349, 56670, 59, 32768, 8723, 512, 99, 116, 12212, 12217, 114, 59, 32896, 55349, 56514, 112, 111, 115, 59, 32768, 8766, 768, 59, 108, 109, 12230, 12232, 12240, 32768, 956, 116, 105, 109, 97, 112, 59, 32768, 8888, 97, 112, 59, 32768, 8888, 6144, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 12294, 12315, 12364, 12376, 12393, 12472, 12496, 12547, 12553, 12636, 12641, 12703, 12725, 12747, 12752, 12876, 12881, 12957, 13033, 13089, 13294, 13359, 13384, 13499, 512, 103, 116, 12299, 12303, 59, 32896, 8921, 824, 512, 59, 118, 12308, 12311, 32896, 8811, 8402, 59, 32896, 8811, 824, 768, 101, 108, 116, 12322, 12348, 12352, 102, 116, 512, 97, 114, 12329, 12336, 114, 114, 111, 119, 59, 32768, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8654, 59, 32896, 8920, 824, 512, 59, 118, 12357, 12360, 32896, 8810, 8402, 59, 32896, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8655, 512, 68, 100, 12381, 12387, 97, 115, 104, 59, 32768, 8879, 97, 115, 104, 59, 32768, 8878, 1280, 98, 99, 110, 112, 116, 12404, 12409, 12415, 12420, 12452, 108, 97, 59, 32768, 8711, 117, 116, 101, 59, 32768, 324, 103, 59, 32896, 8736, 8402, 1280, 59, 69, 105, 111, 112, 12431, 12433, 12437, 12442, 12446, 32768, 8777, 59, 32896, 10864, 824, 100, 59, 32896, 8779, 824, 115, 59, 32768, 329, 114, 111, 120, 59, 32768, 8777, 117, 114, 512, 59, 97, 12459, 12461, 32768, 9838, 108, 512, 59, 115, 12467, 12469, 32768, 9838, 59, 32768, 8469, 836, 12477, 0, 12483, 112, 33024, 160, 59, 32768, 160, 109, 112, 512, 59, 101, 12489, 12492, 32896, 8782, 824, 59, 32896, 8783, 824, 1280, 97, 101, 111, 117, 121, 12507, 12519, 12525, 12540, 12544, 833, 12512, 0, 12515, 59, 32768, 10819, 111, 110, 59, 32768, 328, 100, 105, 108, 59, 32768, 326, 110, 103, 512, 59, 100, 12532, 12534, 32768, 8775, 111, 116, 59, 32896, 10861, 824, 112, 59, 32768, 10818, 59, 32768, 1085, 97, 115, 104, 59, 32768, 8211, 1792, 59, 65, 97, 100, 113, 115, 120, 12568, 12570, 12575, 12596, 12602, 12608, 12623, 32768, 8800, 114, 114, 59, 32768, 8663, 114, 512, 104, 114, 12581, 12585, 107, 59, 32768, 10532, 512, 59, 111, 12590, 12592, 32768, 8599, 119, 59, 32768, 8599, 111, 116, 59, 32896, 8784, 824, 117, 105, 118, 59, 32768, 8802, 512, 101, 105, 12613, 12618, 97, 114, 59, 32768, 10536, 109, 59, 32896, 8770, 824, 105, 115, 116, 512, 59, 115, 12631, 12633, 32768, 8708, 59, 32768, 8708, 114, 59, 32896, 55349, 56619, 1024, 69, 101, 115, 116, 12650, 12654, 12688, 12693, 59, 32896, 8807, 824, 768, 59, 113, 115, 12661, 12663, 12684, 32768, 8817, 768, 59, 113, 115, 12670, 12672, 12676, 32768, 8817, 59, 32896, 8807, 824, 108, 97, 110, 116, 59, 32896, 10878, 824, 59, 32896, 10878, 824, 105, 109, 59, 32768, 8821, 512, 59, 114, 12698, 12700, 32768, 8815, 59, 32768, 8815, 768, 65, 97, 112, 12710, 12715, 12720, 114, 114, 59, 32768, 8654, 114, 114, 59, 32768, 8622, 97, 114, 59, 32768, 10994, 768, 59, 115, 118, 12732, 12734, 12744, 32768, 8715, 512, 59, 100, 12739, 12741, 32768, 8956, 59, 32768, 8954, 59, 32768, 8715, 99, 121, 59, 32768, 1114, 1792, 65, 69, 97, 100, 101, 115, 116, 12767, 12772, 12776, 12781, 12785, 12853, 12858, 114, 114, 59, 32768, 8653, 59, 32896, 8806, 824, 114, 114, 59, 32768, 8602, 114, 59, 32768, 8229, 1024, 59, 102, 113, 115, 12794, 12796, 12821, 12842, 32768, 8816, 116, 512, 97, 114, 12802, 12809, 114, 114, 111, 119, 59, 32768, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8622, 768, 59, 113, 115, 12828, 12830, 12834, 32768, 8816, 59, 32896, 8806, 824, 108, 97, 110, 116, 59, 32896, 10877, 824, 512, 59, 115, 12847, 12850, 32896, 10877, 824, 59, 32768, 8814, 105, 109, 59, 32768, 8820, 512, 59, 114, 12863, 12865, 32768, 8814, 105, 512, 59, 101, 12871, 12873, 32768, 8938, 59, 32768, 8940, 105, 100, 59, 32768, 8740, 512, 112, 116, 12886, 12891, 102, 59, 32896, 55349, 56671, 33536, 172, 59, 105, 110, 12899, 12901, 12936, 32768, 172, 110, 1024, 59, 69, 100, 118, 12911, 12913, 12917, 12923, 32768, 8713, 59, 32896, 8953, 824, 111, 116, 59, 32896, 8949, 824, 818, 12928, 12931, 12934, 59, 32768, 8713, 59, 32768, 8951, 59, 32768, 8950, 105, 512, 59, 118, 12942, 12944, 32768, 8716, 818, 12949, 12952, 12955, 59, 32768, 8716, 59, 32768, 8958, 59, 32768, 8957, 768, 97, 111, 114, 12964, 12992, 12999, 114, 1024, 59, 97, 115, 116, 12974, 12976, 12983, 12988, 32768, 8742, 108, 108, 101, 108, 59, 32768, 8742, 108, 59, 32896, 11005, 8421, 59, 32896, 8706, 824, 108, 105, 110, 116, 59, 32768, 10772, 768, 59, 99, 101, 13006, 13008, 13013, 32768, 8832, 117, 101, 59, 32768, 8928, 512, 59, 99, 13018, 13021, 32896, 10927, 824, 512, 59, 101, 13026, 13028, 32768, 8832, 113, 59, 32896, 10927, 824, 1024, 65, 97, 105, 116, 13042, 13047, 13066, 13077, 114, 114, 59, 32768, 8655, 114, 114, 768, 59, 99, 119, 13056, 13058, 13062, 32768, 8603, 59, 32896, 10547, 824, 59, 32896, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8603, 114, 105, 512, 59, 101, 13084, 13086, 32768, 8939, 59, 32768, 8941, 1792, 99, 104, 105, 109, 112, 113, 117, 13104, 13128, 13151, 13169, 13174, 13179, 13194, 1024, 59, 99, 101, 114, 13113, 13115, 13120, 13124, 32768, 8833, 117, 101, 59, 32768, 8929, 59, 32896, 10928, 824, 59, 32896, 55349, 56515, 111, 114, 116, 1086, 13137, 0, 0, 13142, 105, 100, 59, 32768, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 32768, 8742, 109, 512, 59, 101, 13157, 13159, 32768, 8769, 512, 59, 113, 13164, 13166, 32768, 8772, 59, 32768, 8772, 105, 100, 59, 32768, 8740, 97, 114, 59, 32768, 8742, 115, 117, 512, 98, 112, 13186, 13190, 101, 59, 32768, 8930, 101, 59, 32768, 8931, 768, 98, 99, 112, 13201, 13241, 13254, 1024, 59, 69, 101, 115, 13210, 13212, 13216, 13219, 32768, 8836, 59, 32896, 10949, 824, 59, 32768, 8840, 101, 116, 512, 59, 101, 13226, 13229, 32896, 8834, 8402, 113, 512, 59, 113, 13235, 13237, 32768, 8840, 59, 32896, 10949, 824, 99, 512, 59, 101, 13247, 13249, 32768, 8833, 113, 59, 32896, 10928, 824, 1024, 59, 69, 101, 115, 13263, 13265, 13269, 13272, 32768, 8837, 59, 32896, 10950, 824, 59, 32768, 8841, 101, 116, 512, 59, 101, 13279, 13282, 32896, 8835, 8402, 113, 512, 59, 113, 13288, 13290, 32768, 8841, 59, 32896, 10950, 824, 1024, 103, 105, 108, 114, 13303, 13307, 13315, 13319, 108, 59, 32768, 8825, 108, 100, 101, 33024, 241, 59, 32768, 241, 103, 59, 32768, 8824, 105, 97, 110, 103, 108, 101, 512, 108, 114, 13330, 13344, 101, 102, 116, 512, 59, 101, 13338, 13340, 32768, 8938, 113, 59, 32768, 8940, 105, 103, 104, 116, 512, 59, 101, 13353, 13355, 32768, 8939, 113, 59, 32768, 8941, 512, 59, 109, 13364, 13366, 32768, 957, 768, 59, 101, 115, 13373, 13375, 13380, 32768, 35, 114, 111, 59, 32768, 8470, 112, 59, 32768, 8199, 2304, 68, 72, 97, 100, 103, 105, 108, 114, 115, 13403, 13409, 13415, 13420, 13426, 13439, 13446, 13476, 13493, 97, 115, 104, 59, 32768, 8877, 97, 114, 114, 59, 32768, 10500, 112, 59, 32896, 8781, 8402, 97, 115, 104, 59, 32768, 8876, 512, 101, 116, 13431, 13435, 59, 32896, 8805, 8402, 59, 32896, 62, 8402, 110, 102, 105, 110, 59, 32768, 10718, 768, 65, 101, 116, 13453, 13458, 13462, 114, 114, 59, 32768, 10498, 59, 32896, 8804, 8402, 512, 59, 114, 13467, 13470, 32896, 60, 8402, 105, 101, 59, 32896, 8884, 8402, 512, 65, 116, 13481, 13486, 114, 114, 59, 32768, 10499, 114, 105, 101, 59, 32896, 8885, 8402, 105, 109, 59, 32896, 8764, 8402, 768, 65, 97, 110, 13506, 13511, 13532, 114, 114, 59, 32768, 8662, 114, 512, 104, 114, 13517, 13521, 107, 59, 32768, 10531, 512, 59, 111, 13526, 13528, 32768, 8598, 119, 59, 32768, 8598, 101, 97, 114, 59, 32768, 10535, 9252, 13576, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 13579, 0, 13596, 13617, 13653, 13659, 13673, 13695, 13708, 0, 0, 13713, 13750, 0, 13788, 13794, 0, 13815, 13890, 13913, 13937, 13944, 59, 32768, 9416, 512, 99, 115, 13583, 13591, 117, 116, 101, 33024, 243, 59, 32768, 243, 116, 59, 32768, 8859, 512, 105, 121, 13600, 13613, 114, 512, 59, 99, 13606, 13608, 32768, 8858, 33024, 244, 59, 32768, 244, 59, 32768, 1086, 1280, 97, 98, 105, 111, 115, 13627, 13632, 13638, 13642, 13646, 115, 104, 59, 32768, 8861, 108, 97, 99, 59, 32768, 337, 118, 59, 32768, 10808, 116, 59, 32768, 8857, 111, 108, 100, 59, 32768, 10684, 108, 105, 103, 59, 32768, 339, 512, 99, 114, 13663, 13668, 105, 114, 59, 32768, 10687, 59, 32896, 55349, 56620, 1600, 13680, 0, 0, 13684, 0, 13692, 110, 59, 32768, 731, 97, 118, 101, 33024, 242, 59, 32768, 242, 59, 32768, 10689, 512, 98, 109, 13699, 13704, 97, 114, 59, 32768, 10677, 59, 32768, 937, 110, 116, 59, 32768, 8750, 1024, 97, 99, 105, 116, 13721, 13726, 13741, 13746, 114, 114, 59, 32768, 8634, 512, 105, 114, 13731, 13735, 114, 59, 32768, 10686, 111, 115, 115, 59, 32768, 10683, 110, 101, 59, 32768, 8254, 59, 32768, 10688, 768, 97, 101, 105, 13756, 13761, 13766, 99, 114, 59, 32768, 333, 103, 97, 59, 32768, 969, 768, 99, 100, 110, 13773, 13779, 13782, 114, 111, 110, 59, 32768, 959, 59, 32768, 10678, 117, 115, 59, 32768, 8854, 112, 102, 59, 32896, 55349, 56672, 768, 97, 101, 108, 13800, 13804, 13809, 114, 59, 32768, 10679, 114, 112, 59, 32768, 10681, 117, 115, 59, 32768, 8853, 1792, 59, 97, 100, 105, 111, 115, 118, 13829, 13831, 13836, 13869, 13875, 13879, 13886, 32768, 8744, 114, 114, 59, 32768, 8635, 1024, 59, 101, 102, 109, 13845, 13847, 13859, 13864, 32768, 10845, 114, 512, 59, 111, 13853, 13855, 32768, 8500, 102, 59, 32768, 8500, 33024, 170, 59, 32768, 170, 33024, 186, 59, 32768, 186, 103, 111, 102, 59, 32768, 8886, 114, 59, 32768, 10838, 108, 111, 112, 101, 59, 32768, 10839, 59, 32768, 10843, 768, 99, 108, 111, 13896, 13900, 13908, 114, 59, 32768, 8500, 97, 115, 104, 33024, 248, 59, 32768, 248, 108, 59, 32768, 8856, 105, 573, 13917, 13924, 100, 101, 33024, 245, 59, 32768, 245, 101, 115, 512, 59, 97, 13930, 13932, 32768, 8855, 115, 59, 32768, 10806, 109, 108, 33024, 246, 59, 32768, 246, 98, 97, 114, 59, 32768, 9021, 5426, 13972, 0, 14013, 0, 14017, 14053, 0, 14058, 14086, 0, 0, 14107, 14199, 0, 14202, 0, 0, 14229, 14425, 0, 14438, 114, 1024, 59, 97, 115, 116, 13981, 13983, 13997, 14009, 32768, 8741, 33280, 182, 59, 108, 13989, 13991, 32768, 182, 108, 101, 108, 59, 32768, 8741, 1082, 14003, 0, 0, 14007, 109, 59, 32768, 10995, 59, 32768, 11005, 59, 32768, 8706, 121, 59, 32768, 1087, 114, 1280, 99, 105, 109, 112, 116, 14028, 14033, 14038, 14043, 14046, 110, 116, 59, 32768, 37, 111, 100, 59, 32768, 46, 105, 108, 59, 32768, 8240, 59, 32768, 8869, 101, 110, 107, 59, 32768, 8241, 114, 59, 32896, 55349, 56621, 768, 105, 109, 111, 14064, 14074, 14080, 512, 59, 118, 14069, 14071, 32768, 966, 59, 32768, 981, 109, 97, 116, 59, 32768, 8499, 110, 101, 59, 32768, 9742, 768, 59, 116, 118, 14092, 14094, 14103, 32768, 960, 99, 104, 102, 111, 114, 107, 59, 32768, 8916, 59, 32768, 982, 512, 97, 117, 14111, 14132, 110, 512, 99, 107, 14117, 14128, 107, 512, 59, 104, 14123, 14125, 32768, 8463, 59, 32768, 8462, 118, 59, 32768, 8463, 115, 2304, 59, 97, 98, 99, 100, 101, 109, 115, 116, 14152, 14154, 14160, 14163, 14168, 14179, 14182, 14188, 14193, 32768, 43, 99, 105, 114, 59, 32768, 10787, 59, 32768, 8862, 105, 114, 59, 32768, 10786, 512, 111, 117, 14173, 14176, 59, 32768, 8724, 59, 32768, 10789, 59, 32768, 10866, 110, 33024, 177, 59, 32768, 177, 105, 109, 59, 32768, 10790, 119, 111, 59, 32768, 10791, 59, 32768, 177, 768, 105, 112, 117, 14208, 14216, 14221, 110, 116, 105, 110, 116, 59, 32768, 10773, 102, 59, 32896, 55349, 56673, 110, 100, 33024, 163, 59, 32768, 163, 2560, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 14249, 14251, 14254, 14258, 14263, 14336, 14348, 14367, 14413, 14418, 32768, 8826, 59, 32768, 10931, 112, 59, 32768, 10935, 117, 101, 59, 32768, 8828, 512, 59, 99, 14268, 14270, 32768, 10927, 1536, 59, 97, 99, 101, 110, 115, 14283, 14285, 14293, 14302, 14306, 14331, 32768, 8826, 112, 112, 114, 111, 120, 59, 32768, 10935, 117, 114, 108, 121, 101, 113, 59, 32768, 8828, 113, 59, 32768, 10927, 768, 97, 101, 115, 14313, 14321, 14326, 112, 112, 114, 111, 120, 59, 32768, 10937, 113, 113, 59, 32768, 10933, 105, 109, 59, 32768, 8936, 105, 109, 59, 32768, 8830, 109, 101, 512, 59, 115, 14343, 14345, 32768, 8242, 59, 32768, 8473, 768, 69, 97, 115, 14355, 14358, 14362, 59, 32768, 10933, 112, 59, 32768, 10937, 105, 109, 59, 32768, 8936, 768, 100, 102, 112, 14374, 14377, 14402, 59, 32768, 8719, 768, 97, 108, 115, 14384, 14390, 14396, 108, 97, 114, 59, 32768, 9006, 105, 110, 101, 59, 32768, 8978, 117, 114, 102, 59, 32768, 8979, 512, 59, 116, 14407, 14409, 32768, 8733, 111, 59, 32768, 8733, 105, 109, 59, 32768, 8830, 114, 101, 108, 59, 32768, 8880, 512, 99, 105, 14429, 14434, 114, 59, 32896, 55349, 56517, 59, 32768, 968, 110, 99, 115, 112, 59, 32768, 8200, 1536, 102, 105, 111, 112, 115, 117, 14457, 14462, 14467, 14473, 14480, 14486, 114, 59, 32896, 55349, 56622, 110, 116, 59, 32768, 10764, 112, 102, 59, 32896, 55349, 56674, 114, 105, 109, 101, 59, 32768, 8279, 99, 114, 59, 32896, 55349, 56518, 768, 97, 101, 111, 14493, 14513, 14526, 116, 512, 101, 105, 14499, 14508, 114, 110, 105, 111, 110, 115, 59, 32768, 8461, 110, 116, 59, 32768, 10774, 115, 116, 512, 59, 101, 14520, 14522, 32768, 63, 113, 59, 32768, 8799, 116, 33024, 34, 59, 32768, 34, 5376, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 14575, 14597, 14603, 14608, 14775, 14829, 14865, 14901, 14943, 14966, 15000, 15139, 15159, 15176, 15182, 15236, 15261, 15267, 15309, 15352, 15360, 768, 97, 114, 116, 14582, 14587, 14591, 114, 114, 59, 32768, 8667, 114, 59, 32768, 8658, 97, 105, 108, 59, 32768, 10524, 97, 114, 114, 59, 32768, 10511, 97, 114, 59, 32768, 10596, 1792, 99, 100, 101, 110, 113, 114, 116, 14623, 14637, 14642, 14650, 14672, 14679, 14751, 512, 101, 117, 14628, 14632, 59, 32896, 8765, 817, 116, 101, 59, 32768, 341, 105, 99, 59, 32768, 8730, 109, 112, 116, 121, 118, 59, 32768, 10675, 103, 1024, 59, 100, 101, 108, 14660, 14662, 14665, 14668, 32768, 10217, 59, 32768, 10642, 59, 32768, 10661, 101, 59, 32768, 10217, 117, 111, 33024, 187, 59, 32768, 187, 114, 2816, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 14703, 14705, 14709, 14720, 14723, 14727, 14731, 14735, 14739, 14744, 14748, 32768, 8594, 112, 59, 32768, 10613, 512, 59, 102, 14714, 14716, 32768, 8677, 115, 59, 32768, 10528, 59, 32768, 10547, 115, 59, 32768, 10526, 107, 59, 32768, 8618, 112, 59, 32768, 8620, 108, 59, 32768, 10565, 105, 109, 59, 32768, 10612, 108, 59, 32768, 8611, 59, 32768, 8605, 512, 97, 105, 14756, 14761, 105, 108, 59, 32768, 10522, 111, 512, 59, 110, 14767, 14769, 32768, 8758, 97, 108, 115, 59, 32768, 8474, 768, 97, 98, 114, 14782, 14787, 14792, 114, 114, 59, 32768, 10509, 114, 107, 59, 32768, 10099, 512, 97, 107, 14797, 14809, 99, 512, 101, 107, 14803, 14806, 59, 32768, 125, 59, 32768, 93, 512, 101, 115, 14814, 14817, 59, 32768, 10636, 108, 512, 100, 117, 14823, 14826, 59, 32768, 10638, 59, 32768, 10640, 1024, 97, 101, 117, 121, 14838, 14844, 14858, 14862, 114, 111, 110, 59, 32768, 345, 512, 100, 105, 14849, 14854, 105, 108, 59, 32768, 343, 108, 59, 32768, 8969, 98, 59, 32768, 125, 59, 32768, 1088, 1024, 99, 108, 113, 115, 14874, 14878, 14885, 14897, 97, 59, 32768, 10551, 100, 104, 97, 114, 59, 32768, 10601, 117, 111, 512, 59, 114, 14892, 14894, 32768, 8221, 59, 32768, 8221, 104, 59, 32768, 8627, 768, 97, 99, 103, 14908, 14934, 14938, 108, 1024, 59, 105, 112, 115, 14918, 14920, 14925, 14931, 32768, 8476, 110, 101, 59, 32768, 8475, 97, 114, 116, 59, 32768, 8476, 59, 32768, 8477, 116, 59, 32768, 9645, 33024, 174, 59, 32768, 174, 768, 105, 108, 114, 14950, 14956, 14962, 115, 104, 116, 59, 32768, 10621, 111, 111, 114, 59, 32768, 8971, 59, 32896, 55349, 56623, 512, 97, 111, 14971, 14990, 114, 512, 100, 117, 14977, 14980, 59, 32768, 8641, 512, 59, 108, 14985, 14987, 32768, 8640, 59, 32768, 10604, 512, 59, 118, 14995, 14997, 32768, 961, 59, 32768, 1009, 768, 103, 110, 115, 15007, 15123, 15127, 104, 116, 1536, 97, 104, 108, 114, 115, 116, 15022, 15039, 15060, 15086, 15099, 15111, 114, 114, 111, 119, 512, 59, 116, 15031, 15033, 32768, 8594, 97, 105, 108, 59, 32768, 8611, 97, 114, 112, 111, 111, 110, 512, 100, 117, 15050, 15056, 111, 119, 110, 59, 32768, 8641, 112, 59, 32768, 8640, 101, 102, 116, 512, 97, 104, 15068, 15076, 114, 114, 111, 119, 115, 59, 32768, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 32768, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 32768, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 32768, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 32768, 8908, 103, 59, 32768, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 32768, 8787, 768, 97, 104, 109, 15146, 15151, 15156, 114, 114, 59, 32768, 8644, 97, 114, 59, 32768, 8652, 59, 32768, 8207, 111, 117, 115, 116, 512, 59, 97, 15168, 15170, 32768, 9137, 99, 104, 101, 59, 32768, 9137, 109, 105, 100, 59, 32768, 10990, 1024, 97, 98, 112, 116, 15191, 15204, 15209, 15229, 512, 110, 114, 15196, 15200, 103, 59, 32768, 10221, 114, 59, 32768, 8702, 114, 107, 59, 32768, 10215, 768, 97, 102, 108, 15216, 15220, 15224, 114, 59, 32768, 10630, 59, 32896, 55349, 56675, 117, 115, 59, 32768, 10798, 105, 109, 101, 115, 59, 32768, 10805, 512, 97, 112, 15241, 15253, 114, 512, 59, 103, 15247, 15249, 32768, 41, 116, 59, 32768, 10644, 111, 108, 105, 110, 116, 59, 32768, 10770, 97, 114, 114, 59, 32768, 8649, 1024, 97, 99, 104, 113, 15276, 15282, 15287, 15290, 113, 117, 111, 59, 32768, 8250, 114, 59, 32896, 55349, 56519, 59, 32768, 8625, 512, 98, 117, 15295, 15298, 59, 32768, 93, 111, 512, 59, 114, 15304, 15306, 32768, 8217, 59, 32768, 8217, 768, 104, 105, 114, 15316, 15322, 15328, 114, 101, 101, 59, 32768, 8908, 109, 101, 115, 59, 32768, 8906, 105, 1024, 59, 101, 102, 108, 15338, 15340, 15343, 15346, 32768, 9657, 59, 32768, 8885, 59, 32768, 9656, 116, 114, 105, 59, 32768, 10702, 108, 117, 104, 97, 114, 59, 32768, 10600, 59, 32768, 8478, 6706, 15391, 15398, 15404, 15499, 15516, 15592, 0, 15606, 15660, 0, 0, 15752, 15758, 0, 15827, 15863, 15886, 16000, 16006, 16038, 16086, 0, 16467, 0, 0, 16506, 99, 117, 116, 101, 59, 32768, 347, 113, 117, 111, 59, 32768, 8218, 2560, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 15424, 15426, 15429, 15441, 15446, 15458, 15463, 15482, 15490, 15495, 32768, 8827, 59, 32768, 10932, 833, 15434, 0, 15437, 59, 32768, 10936, 111, 110, 59, 32768, 353, 117, 101, 59, 32768, 8829, 512, 59, 100, 15451, 15453, 32768, 10928, 105, 108, 59, 32768, 351, 114, 99, 59, 32768, 349, 768, 69, 97, 115, 15470, 15473, 15477, 59, 32768, 10934, 112, 59, 32768, 10938, 105, 109, 59, 32768, 8937, 111, 108, 105, 110, 116, 59, 32768, 10771, 105, 109, 59, 32768, 8831, 59, 32768, 1089, 111, 116, 768, 59, 98, 101, 15507, 15509, 15512, 32768, 8901, 59, 32768, 8865, 59, 32768, 10854, 1792, 65, 97, 99, 109, 115, 116, 120, 15530, 15535, 15556, 15562, 15566, 15572, 15587, 114, 114, 59, 32768, 8664, 114, 512, 104, 114, 15541, 15545, 107, 59, 32768, 10533, 512, 59, 111, 15550, 15552, 32768, 8600, 119, 59, 32768, 8600, 116, 33024, 167, 59, 32768, 167, 105, 59, 32768, 59, 119, 97, 114, 59, 32768, 10537, 109, 512, 105, 110, 15578, 15584, 110, 117, 115, 59, 32768, 8726, 59, 32768, 8726, 116, 59, 32768, 10038, 114, 512, 59, 111, 15597, 15600, 32896, 55349, 56624, 119, 110, 59, 32768, 8994, 1024, 97, 99, 111, 121, 15614, 15619, 15632, 15654, 114, 112, 59, 32768, 9839, 512, 104, 121, 15624, 15629, 99, 121, 59, 32768, 1097, 59, 32768, 1096, 114, 116, 1086, 15640, 0, 0, 15645, 105, 100, 59, 32768, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 32768, 8741, 33024, 173, 59, 32768, 173, 512, 103, 109, 15664, 15681, 109, 97, 768, 59, 102, 118, 15673, 15675, 15678, 32768, 963, 59, 32768, 962, 59, 32768, 962, 2048, 59, 100, 101, 103, 108, 110, 112, 114, 15698, 15700, 15705, 15715, 15725, 15735, 15739, 15745, 32768, 8764, 111, 116, 59, 32768, 10858, 512, 59, 113, 15710, 15712, 32768, 8771, 59, 32768, 8771, 512, 59, 69, 15720, 15722, 32768, 10910, 59, 32768, 10912, 512, 59, 69, 15730, 15732, 32768, 10909, 59, 32768, 10911, 101, 59, 32768, 8774, 108, 117, 115, 59, 32768, 10788, 97, 114, 114, 59, 32768, 10610, 97, 114, 114, 59, 32768, 8592, 1024, 97, 101, 105, 116, 15766, 15788, 15796, 15808, 512, 108, 115, 15771, 15783, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 32768, 8726, 104, 112, 59, 32768, 10803, 112, 97, 114, 115, 108, 59, 32768, 10724, 512, 100, 108, 15801, 15804, 59, 32768, 8739, 101, 59, 32768, 8995, 512, 59, 101, 15813, 15815, 32768, 10922, 512, 59, 115, 15820, 15822, 32768, 10924, 59, 32896, 10924, 65024, 768, 102, 108, 112, 15833, 15839, 15857, 116, 99, 121, 59, 32768, 1100, 512, 59, 98, 15844, 15846, 32768, 47, 512, 59, 97, 15851, 15853, 32768, 10692, 114, 59, 32768, 9023, 102, 59, 32896, 55349, 56676, 97, 512, 100, 114, 15868, 15882, 101, 115, 512, 59, 117, 15875, 15877, 32768, 9824, 105, 116, 59, 32768, 9824, 59, 32768, 8741, 768, 99, 115, 117, 15892, 15921, 15977, 512, 97, 117, 15897, 15909, 112, 512, 59, 115, 15903, 15905, 32768, 8851, 59, 32896, 8851, 65024, 112, 512, 59, 115, 15915, 15917, 32768, 8852, 59, 32896, 8852, 65024, 117, 512, 98, 112, 15927, 15952, 768, 59, 101, 115, 15934, 15936, 15939, 32768, 8847, 59, 32768, 8849, 101, 116, 512, 59, 101, 15946, 15948, 32768, 8847, 113, 59, 32768, 8849, 768, 59, 101, 115, 15959, 15961, 15964, 32768, 8848, 59, 32768, 8850, 101, 116, 512, 59, 101, 15971, 15973, 32768, 8848, 113, 59, 32768, 8850, 768, 59, 97, 102, 15984, 15986, 15996, 32768, 9633, 114, 566, 15991, 15994, 59, 32768, 9633, 59, 32768, 9642, 59, 32768, 9642, 97, 114, 114, 59, 32768, 8594, 1024, 99, 101, 109, 116, 16014, 16019, 16025, 16031, 114, 59, 32896, 55349, 56520, 116, 109, 110, 59, 32768, 8726, 105, 108, 101, 59, 32768, 8995, 97, 114, 102, 59, 32768, 8902, 512, 97, 114, 16042, 16053, 114, 512, 59, 102, 16048, 16050, 32768, 9734, 59, 32768, 9733, 512, 97, 110, 16058, 16081, 105, 103, 104, 116, 512, 101, 112, 16067, 16076, 112, 115, 105, 108, 111, 110, 59, 32768, 1013, 104, 105, 59, 32768, 981, 115, 59, 32768, 175, 1280, 98, 99, 109, 110, 112, 16096, 16221, 16288, 16291, 16295, 2304, 59, 69, 100, 101, 109, 110, 112, 114, 115, 16115, 16117, 16120, 16125, 16137, 16143, 16154, 16160, 16166, 32768, 8834, 59, 32768, 10949, 111, 116, 59, 32768, 10941, 512, 59, 100, 16130, 16132, 32768, 8838, 111, 116, 59, 32768, 10947, 117, 108, 116, 59, 32768, 10945, 512, 69, 101, 16148, 16151, 59, 32768, 10955, 59, 32768, 8842, 108, 117, 115, 59, 32768, 10943, 97, 114, 114, 59, 32768, 10617, 768, 101, 105, 117, 16173, 16206, 16210, 116, 768, 59, 101, 110, 16181, 16183, 16194, 32768, 8834, 113, 512, 59, 113, 16189, 16191, 32768, 8838, 59, 32768, 10949, 101, 113, 512, 59, 113, 16201, 16203, 32768, 8842, 59, 32768, 10955, 109, 59, 32768, 10951, 512, 98, 112, 16215, 16218, 59, 32768, 10965, 59, 32768, 10963, 99, 1536, 59, 97, 99, 101, 110, 115, 16235, 16237, 16245, 16254, 16258, 16283, 32768, 8827, 112, 112, 114, 111, 120, 59, 32768, 10936, 117, 114, 108, 121, 101, 113, 59, 32768, 8829, 113, 59, 32768, 10928, 768, 97, 101, 115, 16265, 16273, 16278, 112, 112, 114, 111, 120, 59, 32768, 10938, 113, 113, 59, 32768, 10934, 105, 109, 59, 32768, 8937, 105, 109, 59, 32768, 8831, 59, 32768, 8721, 103, 59, 32768, 9834, 3328, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 16322, 16327, 16332, 16337, 16339, 16342, 16356, 16368, 16382, 16388, 16394, 16405, 16411, 33024, 185, 59, 32768, 185, 33024, 178, 59, 32768, 178, 33024, 179, 59, 32768, 179, 32768, 8835, 59, 32768, 10950, 512, 111, 115, 16347, 16351, 116, 59, 32768, 10942, 117, 98, 59, 32768, 10968, 512, 59, 100, 16361, 16363, 32768, 8839, 111, 116, 59, 32768, 10948, 115, 512, 111, 117, 16374, 16378, 108, 59, 32768, 10185, 98, 59, 32768, 10967, 97, 114, 114, 59, 32768, 10619, 117, 108, 116, 59, 32768, 10946, 512, 69, 101, 16399, 16402, 59, 32768, 10956, 59, 32768, 8843, 108, 117, 115, 59, 32768, 10944, 768, 101, 105, 117, 16418, 16451, 16455, 116, 768, 59, 101, 110, 16426, 16428, 16439, 32768, 8835, 113, 512, 59, 113, 16434, 16436, 32768, 8839, 59, 32768, 10950, 101, 113, 512, 59, 113, 16446, 16448, 32768, 8843, 59, 32768, 10956, 109, 59, 32768, 10952, 512, 98, 112, 16460, 16463, 59, 32768, 10964, 59, 32768, 10966, 768, 65, 97, 110, 16473, 16478, 16499, 114, 114, 59, 32768, 8665, 114, 512, 104, 114, 16484, 16488, 107, 59, 32768, 10534, 512, 59, 111, 16493, 16495, 32768, 8601, 119, 59, 32768, 8601, 119, 97, 114, 59, 32768, 10538, 108, 105, 103, 33024, 223, 59, 32768, 223, 5938, 16538, 16552, 16557, 16579, 16584, 16591, 0, 16596, 16692, 0, 0, 0, 0, 0, 16731, 16780, 0, 16787, 16908, 0, 0, 0, 16938, 1091, 16543, 0, 0, 16549, 103, 101, 116, 59, 32768, 8982, 59, 32768, 964, 114, 107, 59, 32768, 9140, 768, 97, 101, 121, 16563, 16569, 16575, 114, 111, 110, 59, 32768, 357, 100, 105, 108, 59, 32768, 355, 59, 32768, 1090, 111, 116, 59, 32768, 8411, 108, 114, 101, 99, 59, 32768, 8981, 114, 59, 32896, 55349, 56625, 1024, 101, 105, 107, 111, 16604, 16641, 16670, 16684, 835, 16609, 0, 16624, 101, 512, 52, 102, 16614, 16617, 59, 32768, 8756, 111, 114, 101, 59, 32768, 8756, 97, 768, 59, 115, 118, 16631, 16633, 16638, 32768, 952, 121, 109, 59, 32768, 977, 59, 32768, 977, 512, 99, 110, 16646, 16665, 107, 512, 97, 115, 16652, 16660, 112, 112, 114, 111, 120, 59, 32768, 8776, 105, 109, 59, 32768, 8764, 115, 112, 59, 32768, 8201, 512, 97, 115, 16675, 16679, 112, 59, 32768, 8776, 105, 109, 59, 32768, 8764, 114, 110, 33024, 254, 59, 32768, 254, 829, 16696, 16701, 16727, 100, 101, 59, 32768, 732, 101, 115, 33536, 215, 59, 98, 100, 16710, 16712, 16723, 32768, 215, 512, 59, 97, 16717, 16719, 32768, 8864, 114, 59, 32768, 10801, 59, 32768, 10800, 116, 59, 32768, 8749, 768, 101, 112, 115, 16737, 16741, 16775, 97, 59, 32768, 10536, 1024, 59, 98, 99, 102, 16750, 16752, 16757, 16762, 32768, 8868, 111, 116, 59, 32768, 9014, 105, 114, 59, 32768, 10993, 512, 59, 111, 16767, 16770, 32896, 55349, 56677, 114, 107, 59, 32768, 10970, 97, 59, 32768, 10537, 114, 105, 109, 101, 59, 32768, 8244, 768, 97, 105, 112, 16793, 16798, 16899, 100, 101, 59, 32768, 8482, 1792, 97, 100, 101, 109, 112, 115, 116, 16813, 16868, 16873, 16876, 16883, 16889, 16893, 110, 103, 108, 101, 1280, 59, 100, 108, 113, 114, 16828, 16830, 16836, 16850, 16853, 32768, 9653, 111, 119, 110, 59, 32768, 9663, 101, 102, 116, 512, 59, 101, 16844, 16846, 32768, 9667, 113, 59, 32768, 8884, 59, 32768, 8796, 105, 103, 104, 116, 512, 59, 101, 16862, 16864, 32768, 9657, 113, 59, 32768, 8885, 111, 116, 59, 32768, 9708, 59, 32768, 8796, 105, 110, 117, 115, 59, 32768, 10810, 108, 117, 115, 59, 32768, 10809, 98, 59, 32768, 10701, 105, 109, 101, 59, 32768, 10811, 101, 122, 105, 117, 109, 59, 32768, 9186, 768, 99, 104, 116, 16914, 16926, 16931, 512, 114, 121, 16919, 16923, 59, 32896, 55349, 56521, 59, 32768, 1094, 99, 121, 59, 32768, 1115, 114, 111, 107, 59, 32768, 359, 512, 105, 111, 16942, 16947, 120, 116, 59, 32768, 8812, 104, 101, 97, 100, 512, 108, 114, 16956, 16967, 101, 102, 116, 97, 114, 114, 111, 119, 59, 32768, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8608, 4608, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 17016, 17021, 17026, 17043, 17057, 17072, 17095, 17110, 17119, 17139, 17172, 17187, 17202, 17290, 17330, 17336, 17365, 17381, 114, 114, 59, 32768, 8657, 97, 114, 59, 32768, 10595, 512, 99, 114, 17031, 17039, 117, 116, 101, 33024, 250, 59, 32768, 250, 114, 59, 32768, 8593, 114, 820, 17049, 0, 17053, 121, 59, 32768, 1118, 118, 101, 59, 32768, 365, 512, 105, 121, 17062, 17069, 114, 99, 33024, 251, 59, 32768, 251, 59, 32768, 1091, 768, 97, 98, 104, 17079, 17084, 17090, 114, 114, 59, 32768, 8645, 108, 97, 99, 59, 32768, 369, 97, 114, 59, 32768, 10606, 512, 105, 114, 17100, 17106, 115, 104, 116, 59, 32768, 10622, 59, 32896, 55349, 56626, 114, 97, 118, 101, 33024, 249, 59, 32768, 249, 562, 17123, 17135, 114, 512, 108, 114, 17128, 17131, 59, 32768, 8639, 59, 32768, 8638, 108, 107, 59, 32768, 9600, 512, 99, 116, 17144, 17167, 1088, 17150, 0, 0, 17163, 114, 110, 512, 59, 101, 17156, 17158, 32768, 8988, 114, 59, 32768, 8988, 111, 112, 59, 32768, 8975, 114, 105, 59, 32768, 9720, 512, 97, 108, 17177, 17182, 99, 114, 59, 32768, 363, 33024, 168, 59, 32768, 168, 512, 103, 112, 17192, 17197, 111, 110, 59, 32768, 371, 102, 59, 32896, 55349, 56678, 1536, 97, 100, 104, 108, 115, 117, 17215, 17222, 17233, 17257, 17262, 17280, 114, 114, 111, 119, 59, 32768, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 32768, 8597, 97, 114, 112, 111, 111, 110, 512, 108, 114, 17244, 17250, 101, 102, 116, 59, 32768, 8639, 105, 103, 104, 116, 59, 32768, 8638, 117, 115, 59, 32768, 8846, 105, 768, 59, 104, 108, 17270, 17272, 17275, 32768, 965, 59, 32768, 978, 111, 110, 59, 32768, 965, 112, 97, 114, 114, 111, 119, 115, 59, 32768, 8648, 768, 99, 105, 116, 17297, 17320, 17325, 1088, 17303, 0, 0, 17316, 114, 110, 512, 59, 101, 17309, 17311, 32768, 8989, 114, 59, 32768, 8989, 111, 112, 59, 32768, 8974, 110, 103, 59, 32768, 367, 114, 105, 59, 32768, 9721, 99, 114, 59, 32896, 55349, 56522, 768, 100, 105, 114, 17343, 17348, 17354, 111, 116, 59, 32768, 8944, 108, 100, 101, 59, 32768, 361, 105, 512, 59, 102, 17360, 17362, 32768, 9653, 59, 32768, 9652, 512, 97, 109, 17370, 17375, 114, 114, 59, 32768, 8648, 108, 33024, 252, 59, 32768, 252, 97, 110, 103, 108, 101, 59, 32768, 10663, 3840, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 17420, 17425, 17437, 17443, 17613, 17617, 17623, 17667, 17672, 17678, 17693, 17699, 17705, 17711, 17754, 114, 114, 59, 32768, 8661, 97, 114, 512, 59, 118, 17432, 17434, 32768, 10984, 59, 32768, 10985, 97, 115, 104, 59, 32768, 8872, 512, 110, 114, 17448, 17454, 103, 114, 116, 59, 32768, 10652, 1792, 101, 107, 110, 112, 114, 115, 116, 17469, 17478, 17485, 17494, 17515, 17526, 17578, 112, 115, 105, 108, 111, 110, 59, 32768, 1013, 97, 112, 112, 97, 59, 32768, 1008, 111, 116, 104, 105, 110, 103, 59, 32768, 8709, 768, 104, 105, 114, 17501, 17505, 17508, 105, 59, 32768, 981, 59, 32768, 982, 111, 112, 116, 111, 59, 32768, 8733, 512, 59, 104, 17520, 17522, 32768, 8597, 111, 59, 32768, 1009, 512, 105, 117, 17531, 17537, 103, 109, 97, 59, 32768, 962, 512, 98, 112, 17542, 17560, 115, 101, 116, 110, 101, 113, 512, 59, 113, 17553, 17556, 32896, 8842, 65024, 59, 32896, 10955, 65024, 115, 101, 116, 110, 101, 113, 512, 59, 113, 17571, 17574, 32896, 8843, 65024, 59, 32896, 10956, 65024, 512, 104, 114, 17583, 17589, 101, 116, 97, 59, 32768, 977, 105, 97, 110, 103, 108, 101, 512, 108, 114, 17600, 17606, 101, 102, 116, 59, 32768, 8882, 105, 103, 104, 116, 59, 32768, 8883, 121, 59, 32768, 1074, 97, 115, 104, 59, 32768, 8866, 768, 101, 108, 114, 17630, 17648, 17654, 768, 59, 98, 101, 17637, 17639, 17644, 32768, 8744, 97, 114, 59, 32768, 8891, 113, 59, 32768, 8794, 108, 105, 112, 59, 32768, 8942, 512, 98, 116, 17659, 17664, 97, 114, 59, 32768, 124, 59, 32768, 124, 114, 59, 32896, 55349, 56627, 116, 114, 105, 59, 32768, 8882, 115, 117, 512, 98, 112, 17685, 17689, 59, 32896, 8834, 8402, 59, 32896, 8835, 8402, 112, 102, 59, 32896, 55349, 56679, 114, 111, 112, 59, 32768, 8733, 116, 114, 105, 59, 32768, 8883, 512, 99, 117, 17716, 17721, 114, 59, 32896, 55349, 56523, 512, 98, 112, 17726, 17740, 110, 512, 69, 101, 17732, 17736, 59, 32896, 10955, 65024, 59, 32896, 8842, 65024, 110, 512, 69, 101, 17746, 17750, 59, 32896, 10956, 65024, 59, 32896, 8843, 65024, 105, 103, 122, 97, 103, 59, 32768, 10650, 1792, 99, 101, 102, 111, 112, 114, 115, 17777, 17783, 17815, 17820, 17826, 17829, 17842, 105, 114, 99, 59, 32768, 373, 512, 100, 105, 17788, 17809, 512, 98, 103, 17793, 17798, 97, 114, 59, 32768, 10847, 101, 512, 59, 113, 17804, 17806, 32768, 8743, 59, 32768, 8793, 101, 114, 112, 59, 32768, 8472, 114, 59, 32896, 55349, 56628, 112, 102, 59, 32896, 55349, 56680, 59, 32768, 8472, 512, 59, 101, 17834, 17836, 32768, 8768, 97, 116, 104, 59, 32768, 8768, 99, 114, 59, 32896, 55349, 56524, 5428, 17871, 17891, 0, 17897, 0, 17902, 17917, 0, 0, 17920, 17935, 17940, 17945, 0, 0, 17977, 17992, 0, 18008, 18024, 18029, 768, 97, 105, 117, 17877, 17881, 17886, 112, 59, 32768, 8898, 114, 99, 59, 32768, 9711, 112, 59, 32768, 8899, 116, 114, 105, 59, 32768, 9661, 114, 59, 32896, 55349, 56629, 512, 65, 97, 17906, 17911, 114, 114, 59, 32768, 10234, 114, 114, 59, 32768, 10231, 59, 32768, 958, 512, 65, 97, 17924, 17929, 114, 114, 59, 32768, 10232, 114, 114, 59, 32768, 10229, 97, 112, 59, 32768, 10236, 105, 115, 59, 32768, 8955, 768, 100, 112, 116, 17951, 17956, 17970, 111, 116, 59, 32768, 10752, 512, 102, 108, 17961, 17965, 59, 32896, 55349, 56681, 117, 115, 59, 32768, 10753, 105, 109, 101, 59, 32768, 10754, 512, 65, 97, 17981, 17986, 114, 114, 59, 32768, 10233, 114, 114, 59, 32768, 10230, 512, 99, 113, 17996, 18001, 114, 59, 32896, 55349, 56525, 99, 117, 112, 59, 32768, 10758, 512, 112, 116, 18012, 18018, 108, 117, 115, 59, 32768, 10756, 114, 105, 59, 32768, 9651, 101, 101, 59, 32768, 8897, 101, 100, 103, 101, 59, 32768, 8896, 2048, 97, 99, 101, 102, 105, 111, 115, 117, 18052, 18068, 18081, 18087, 18092, 18097, 18103, 18109, 99, 512, 117, 121, 18058, 18065, 116, 101, 33024, 253, 59, 32768, 253, 59, 32768, 1103, 512, 105, 121, 18073, 18078, 114, 99, 59, 32768, 375, 59, 32768, 1099, 110, 33024, 165, 59, 32768, 165, 114, 59, 32896, 55349, 56630, 99, 121, 59, 32768, 1111, 112, 102, 59, 32896, 55349, 56682, 99, 114, 59, 32896, 55349, 56526, 512, 99, 109, 18114, 18118, 121, 59, 32768, 1102, 108, 33024, 255, 59, 32768, 255, 2560, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 18145, 18152, 18166, 18171, 18186, 18191, 18196, 18204, 18210, 18216, 99, 117, 116, 101, 59, 32768, 378, 512, 97, 121, 18157, 18163, 114, 111, 110, 59, 32768, 382, 59, 32768, 1079, 111, 116, 59, 32768, 380, 512, 101, 116, 18176, 18182, 116, 114, 102, 59, 32768, 8488, 97, 59, 32768, 950, 114, 59, 32896, 55349, 56631, 99, 121, 59, 32768, 1078, 103, 114, 97, 114, 114, 59, 32768, 8669, 112, 102, 59, 32896, 55349, 56683, 99, 114, 59, 32896, 55349, 56527, 512, 106, 110, 18221, 18224, 59, 32768, 8205, 106, 59, 32768, 8204]);

var decodeDataXml = {};

Object.defineProperty(decodeDataXml, "__esModule", { value: true });
decodeDataXml.default = new Uint16Array([1024, 97, 103, 108, 113, 9, 23, 27, 31, 1086, 15, 0, 0, 19, 112, 59, 32768, 38, 111, 115, 59, 32768, 39, 116, 59, 32768, 62, 116, 59, 32768, 60, 117, 111, 116, 59, 32768, 34]);

(function (exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeXML = exports.decodeHTMLStrict = exports.decodeHTML = exports.determineBranch = exports.JUMP_OFFSET_BASE = exports.BinTrieFlags = exports.xmlDecodeTree = exports.htmlDecodeTree = void 0;
var decode_data_html_1 = __importDefault(decodeDataHtml);
exports.htmlDecodeTree = decode_data_html_1.default;
var decode_data_xml_1 = __importDefault(decodeDataXml);
exports.xmlDecodeTree = decode_data_xml_1.default;
var decode_codepoint_1 = __importDefault(decode_codepoint);
var BinTrieFlags;
(function (BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["HAS_VALUE"] = 32768] = "HAS_VALUE";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 32512] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["MULTI_BYTE"] = 128] = "MULTI_BYTE";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})(BinTrieFlags = exports.BinTrieFlags || (exports.BinTrieFlags = {}));
exports.JUMP_OFFSET_BASE = 48  - 1;
function getDecoder(decodeTree) {
    return function decodeHTMLBinary(str, strict) {
        var ret = "";
        var lastIdx = 0;
        var strIdx = 0;
        while ((strIdx = str.indexOf("&", strIdx)) >= 0) {
            ret += str.slice(lastIdx, strIdx);
            lastIdx = strIdx;
            strIdx += 1;
            if (str.charCodeAt(strIdx) === 35 ) {
                var start = strIdx + 1;
                var base = 10;
                var cp = str.charCodeAt(start);
                if ((cp | 32 ) === 120 ) {
                    base = 16;
                    strIdx += 1;
                    start += 1;
                }
                while (((cp = str.charCodeAt(++strIdx)) >= 48  &&
                    cp <= 57 ) ||
                    (base === 16 &&
                        (cp | 32 ) >= 97  &&
                        (cp | 32 ) <= 102 ))
                    ;
                if (start !== strIdx) {
                    var entity = str.substring(start, strIdx);
                    var parsed = parseInt(entity, base);
                    if (str.charCodeAt(strIdx) === 59 ) {
                        strIdx += 1;
                    }
                    else if (strict) {
                        continue;
                    }
                    ret += decode_codepoint_1.default(parsed);
                    lastIdx = strIdx;
                }
                continue;
            }
            var result = null;
            var excess = 1;
            var treeIdx = 0;
            var current = decodeTree[treeIdx];
            for (; strIdx < str.length; strIdx++, excess++) {
                treeIdx = determineBranch(decodeTree, current, treeIdx + 1, str.charCodeAt(strIdx));
                if (treeIdx < 0)
                    break;
                current = decodeTree[treeIdx];
                if (current & BinTrieFlags.HAS_VALUE) {
                    if (strict && str.charCodeAt(strIdx) !== 59 ) {
                        treeIdx += 1;
                    }
                    else {
                        result =
                            current & BinTrieFlags.MULTI_BYTE
                                ? String.fromCharCode(decodeTree[++treeIdx], decodeTree[++treeIdx])
                                : String.fromCharCode(decodeTree[++treeIdx]);
                        excess = 0;
                    }
                }
            }
            if (result != null) {
                ret += result;
                lastIdx = strIdx - excess + 1;
            }
        }
        return ret + str.slice(lastIdx);
    };
}
function determineBranch(decodeTree, current, nodeIdx, char) {
    if (current <= 128) {
        return char === current ? nodeIdx : -1;
    }
    var branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 8;
    if (branchCount === 0) {
        return -1;
    }
    if (branchCount === 1) {
        return char === decodeTree[nodeIdx] ? nodeIdx + 1 : -1;
    }
    var jumpOffset = current & BinTrieFlags.JUMP_TABLE;
    if (jumpOffset) {
        var value = char - exports.JUMP_OFFSET_BASE - jumpOffset;
        return value < 0 || value > branchCount
            ? -1
            : decodeTree[nodeIdx + value] - 1;
    }
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while (lo <= hi) {
        var mid = (lo + hi) >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) {
            lo = mid + 1;
        }
        else if (midVal > char) {
            hi = mid - 1;
        }
        else {
            return decodeTree[mid + branchCount];
        }
    }
    return -1;
}
exports.determineBranch = determineBranch;
var htmlDecoder = getDecoder(decode_data_html_1.default);
var xmlDecoder = getDecoder(decode_data_xml_1.default);
function decodeHTML(str) {
    return htmlDecoder(str, false);
}
exports.decodeHTML = decodeHTML;
function decodeHTMLStrict(str) {
    return htmlDecoder(str, true);
}
exports.decodeHTMLStrict = decodeHTMLStrict;
function decodeXML(str) {
    return xmlDecoder(str, true);
}
exports.decodeXML = decodeXML;
}(decode));
getDefaultExportFromCjs(decode);

var __importDefault$2 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Tokenizer$1, "__esModule", { value: true });
var decode_codepoint_1 = __importDefault$2(decode_codepoint);
var decode_1 = decode;
function isWhitespace(c) {
    return (c === 32  ||
        c === 10  ||
        c === 9  ||
        c === 12  ||
        c === 13 );
}
function isEndOfTagSection(c) {
    return c === 47  || c === 62  || isWhitespace(c);
}
function isNumber(c) {
    return c >= 48  && c <= 57 ;
}
function isASCIIAlpha(c) {
    return ((c >= 97  && c <= 122 ) ||
        (c >= 65  && c <= 90 ));
}
var Sequences = {
    Cdata: new Uint16Array([0x43, 0x44, 0x41, 0x54, 0x41, 0x5b]),
    CdataEnd: new Uint16Array([0x5d, 0x5d, 0x3e]),
    CommentEnd: new Uint16Array([0x2d, 0x2d, 0x3e]),
    ScriptEnd: new Uint16Array([
        0x3c, 0x2f, 0x73, 0x63, 0x72, 0x69, 0x70, 0x74,
    ]),
    StyleEnd: new Uint16Array([0x3c, 0x2f, 0x73, 0x74, 0x79, 0x6c, 0x65]),
    TitleEnd: new Uint16Array([0x3c, 0x2f, 0x74, 0x69, 0x74, 0x6c, 0x65]),
};
var Tokenizer =  (function () {
    function Tokenizer(_a, cbs) {
        var _b = _a.xmlMode, xmlMode = _b === void 0 ? false : _b, _c = _a.decodeEntities, decodeEntities = _c === void 0 ? true : _c;
        this.cbs = cbs;
        this._state = 1 ;
        this.buffer = "";
        this.sectionStart = 0;
        this._index = 0;
        this.bufferOffset = 0;
        this.baseState = 1 ;
        this.isSpecial = false;
        this.running = true;
        this.ended = false;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        this.trieResult = null;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? decode_1.xmlDecodeTree : decode_1.htmlDecodeTree;
    }
    Tokenizer.prototype.reset = function () {
        this._state = 1 ;
        this.buffer = "";
        this.sectionStart = 0;
        this._index = 0;
        this.bufferOffset = 0;
        this.baseState = 1 ;
        this.currentSequence = undefined;
        this.running = true;
        this.ended = false;
    };
    Tokenizer.prototype.write = function (chunk) {
        if (this.ended)
            return this.cbs.onerror(Error(".write() after done!"));
        this.buffer += chunk;
        this.parse();
    };
    Tokenizer.prototype.end = function (chunk) {
        if (this.ended)
            return this.cbs.onerror(Error(".end() after done!"));
        if (chunk)
            this.write(chunk);
        this.ended = true;
        if (this.running)
            this.finish();
    };
    Tokenizer.prototype.pause = function () {
        this.running = false;
    };
    Tokenizer.prototype.resume = function () {
        this.running = true;
        if (this._index < this.buffer.length) {
            this.parse();
        }
        if (this.ended) {
            this.finish();
        }
    };
    Tokenizer.prototype.getAbsoluteSectionStart = function () {
        return this.sectionStart + this.bufferOffset;
    };
    Tokenizer.prototype.getAbsoluteIndex = function () {
        return this.bufferOffset + this._index;
    };
    Tokenizer.prototype.stateText = function (c) {
        if (c === 60  ||
            (!this.decodeEntities && this.fastForwardTo(60 ))) {
            if (this._index > this.sectionStart) {
                this.cbs.ontext(this.getSection());
            }
            this._state = 2 ;
            this.sectionStart = this._index;
        }
        else if (this.decodeEntities && c === 38 ) {
            this._state = 25 ;
        }
    };
    Tokenizer.prototype.stateSpecialStartSequence = function (c) {
        var isEnd = this.sequenceIndex === this.currentSequence.length;
        var isMatch = isEnd
            ?
                isEndOfTagSection(c)
            :
                (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) {
            this.isSpecial = false;
        }
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this._state = 3 ;
        this.stateInTagName(c);
    };
    Tokenizer.prototype.stateInSpecialTag = function (c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === 62  || isWhitespace(c)) {
                var endOfText = this._index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    var actualIndex = this._index;
                    this._index = endOfText;
                    this.cbs.ontext(this.getSection());
                    this._index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2;
                this.stateInClosingTagName(c);
                return;
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) {
            this.sequenceIndex += 1;
        }
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === Sequences.TitleEnd) {
                if (this.decodeEntities && c === 38 ) {
                    this._state = 25 ;
                }
            }
            else if (this.fastForwardTo(60 )) {
                this.sequenceIndex = 1;
            }
        }
        else {
            this.sequenceIndex = Number(c === 60 );
        }
    };
    Tokenizer.prototype.stateCDATASequence = function (c) {
        if (c === Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === Sequences.Cdata.length) {
                this._state = 21 ;
                this.currentSequence = Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this._index + 1;
            }
        }
        else {
            this.sequenceIndex = 0;
            this._state = 16 ;
            this.stateInDeclaration(c);
        }
    };
    Tokenizer.prototype.fastForwardTo = function (c) {
        while (++this._index < this.buffer.length) {
            if (this.buffer.charCodeAt(this._index) === c) {
                return true;
            }
        }
        this._index = this.buffer.length - 1;
        return false;
    };
    Tokenizer.prototype.stateInCommentLike = function (c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                var section = this.buffer.slice(this.sectionStart, this._index - 2);
                if (this.currentSequence === Sequences.CdataEnd) {
                    this.cbs.oncdata(section);
                }
                else {
                    this.cbs.oncomment(section);
                }
                this.sequenceIndex = 0;
                this.sectionStart = this._index + 1;
                this._state = 1 ;
            }
        }
        else if (this.sequenceIndex === 0) {
            if (this.fastForwardTo(this.currentSequence[0])) {
                this.sequenceIndex = 1;
            }
        }
        else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
            this.sequenceIndex = 0;
        }
    };
    Tokenizer.prototype.isTagStartChar = function (c) {
        return this.xmlMode ? !isEndOfTagSection(c) : isASCIIAlpha(c);
    };
    Tokenizer.prototype.startSpecial = function (sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this._state = 23 ;
    };
    Tokenizer.prototype.stateBeforeTagName = function (c) {
        if (c === 33 ) {
            this._state = 15 ;
            this.sectionStart = this._index + 1;
        }
        else if (c === 63 ) {
            this._state = 17 ;
            this.sectionStart = this._index + 1;
        }
        else if (this.isTagStartChar(c)) {
            var lower = c | 0x20;
            this.sectionStart = this._index;
            if (!this.xmlMode && lower === Sequences.TitleEnd[2]) {
                this.startSpecial(Sequences.TitleEnd, 3);
            }
            else {
                this._state =
                    !this.xmlMode && lower === Sequences.ScriptEnd[2]
                        ? 22
                        : 3 ;
            }
        }
        else if (c === 47 ) {
            this._state = 5 ;
        }
        else {
            this._state = 1 ;
            this.stateText(c);
        }
    };
    Tokenizer.prototype.stateInTagName = function (c) {
        if (isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.getSection());
            this.sectionStart = -1;
            this._state = 8 ;
            this.stateBeforeAttributeName(c);
        }
    };
    Tokenizer.prototype.stateBeforeClosingTagName = function (c) {
        if (isWhitespace(c)) ;
        else if (c === 62 ) {
            this._state = 1 ;
        }
        else {
            this._state = this.isTagStartChar(c)
                ? 6
                : 20 ;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInClosingTagName = function (c) {
        if (c === 62  || isWhitespace(c)) {
            this.cbs.onclosetag(this.getSection());
            this.sectionStart = -1;
            this._state = 7 ;
            this.stateAfterClosingTagName(c);
        }
    };
    Tokenizer.prototype.stateAfterClosingTagName = function (c) {
        if (c === 62  || this.fastForwardTo(62 )) {
            this._state = 1 ;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeName = function (c) {
        if (c === 62 ) {
            this.cbs.onopentagend();
            if (this.isSpecial) {
                this._state = 24 ;
                this.sequenceIndex = 0;
            }
            else {
                this._state = 1 ;
            }
            this.baseState = this._state;
            this.sectionStart = this._index + 1;
        }
        else if (c === 47 ) {
            this._state = 4 ;
        }
        else if (!isWhitespace(c)) {
            this._state = 9 ;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInSelfClosingTag = function (c) {
        if (c === 62 ) {
            this.cbs.onselfclosingtag();
            this._state = 1 ;
            this.baseState = 1 ;
            this.sectionStart = this._index + 1;
            this.isSpecial = false;
        }
        else if (!isWhitespace(c)) {
            this._state = 8 ;
            this.stateBeforeAttributeName(c);
        }
    };
    Tokenizer.prototype.stateInAttributeName = function (c) {
        if (c === 61  || isEndOfTagSection(c)) {
            this.cbs.onattribname(this.getSection());
            this.sectionStart = -1;
            this._state = 10 ;
            this.stateAfterAttributeName(c);
        }
    };
    Tokenizer.prototype.stateAfterAttributeName = function (c) {
        if (c === 61 ) {
            this._state = 11 ;
        }
        else if (c === 47  || c === 62 ) {
            this.cbs.onattribend(undefined);
            this._state = 8 ;
            this.stateBeforeAttributeName(c);
        }
        else if (!isWhitespace(c)) {
            this.cbs.onattribend(undefined);
            this._state = 9 ;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeValue = function (c) {
        if (c === 34 ) {
            this._state = 12 ;
            this.sectionStart = this._index + 1;
        }
        else if (c === 39 ) {
            this._state = 13 ;
            this.sectionStart = this._index + 1;
        }
        else if (!isWhitespace(c)) {
            this.sectionStart = this._index;
            this._state = 14 ;
            this.stateInAttributeValueNoQuotes(c);
        }
    };
    Tokenizer.prototype.handleInAttributeValue = function (c, quote) {
        if (c === quote ||
            (!this.decodeEntities && this.fastForwardTo(quote))) {
            this.cbs.onattribdata(this.getSection());
            this.sectionStart = -1;
            this.cbs.onattribend(String.fromCharCode(quote));
            this._state = 8 ;
        }
        else if (this.decodeEntities && c === 38 ) {
            this.baseState = this._state;
            this._state = 25 ;
        }
    };
    Tokenizer.prototype.stateInAttributeValueDoubleQuotes = function (c) {
        this.handleInAttributeValue(c, 34 );
    };
    Tokenizer.prototype.stateInAttributeValueSingleQuotes = function (c) {
        this.handleInAttributeValue(c, 39 );
    };
    Tokenizer.prototype.stateInAttributeValueNoQuotes = function (c) {
        if (isWhitespace(c) || c === 62 ) {
            this.cbs.onattribdata(this.getSection());
            this.sectionStart = -1;
            this.cbs.onattribend(null);
            this._state = 8 ;
            this.stateBeforeAttributeName(c);
        }
        else if (this.decodeEntities && c === 38 ) {
            this.baseState = this._state;
            this._state = 25 ;
        }
    };
    Tokenizer.prototype.stateBeforeDeclaration = function (c) {
        if (c === 91 ) {
            this._state = 19 ;
            this.sequenceIndex = 0;
        }
        else {
            this._state =
                c === 45
                    ? 18
                    : 16 ;
        }
    };
    Tokenizer.prototype.stateInDeclaration = function (c) {
        if (c === 62  || this.fastForwardTo(62 )) {
            this.cbs.ondeclaration(this.getSection());
            this._state = 1 ;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateInProcessingInstruction = function (c) {
        if (c === 62  || this.fastForwardTo(62 )) {
            this.cbs.onprocessinginstruction(this.getSection());
            this._state = 1 ;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeComment = function (c) {
        if (c === 45 ) {
            this._state = 21 ;
            this.currentSequence = Sequences.CommentEnd;
            this.sequenceIndex = 2;
            this.sectionStart = this._index + 1;
        }
        else {
            this._state = 16 ;
        }
    };
    Tokenizer.prototype.stateInSpecialComment = function (c) {
        if (c === 62  || this.fastForwardTo(62 )) {
            this.cbs.oncomment(this.getSection());
            this._state = 1 ;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeSpecialS = function (c) {
        var lower = c | 0x20;
        if (lower === Sequences.ScriptEnd[3]) {
            this.startSpecial(Sequences.ScriptEnd, 4);
        }
        else if (lower === Sequences.StyleEnd[3]) {
            this.startSpecial(Sequences.StyleEnd, 4);
        }
        else {
            this._state = 3 ;
            this.stateInTagName(c);
        }
    };
    Tokenizer.prototype.stateBeforeEntity = function (c) {
        this.entityExcess = 1;
        if (c === 35 ) {
            this._state = 26 ;
        }
        else if (c === 38 ) ;
        else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.trieResult = null;
            this._state = 27 ;
            this.stateInNamedEntity(c);
        }
    };
    Tokenizer.prototype.stateInNamedEntity = function (c) {
        this.entityExcess += 1;
        this.trieIndex = (0, decode_1.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
        if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this._index--;
            return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        if (this.trieCurrent & decode_1.BinTrieFlags.HAS_VALUE) {
            if (!this.allowLegacyEntity() && c !== 59 ) {
                this.trieIndex += 1;
            }
            else {
                var entityStart = this._index - this.entityExcess + 1;
                if (entityStart > this.sectionStart) {
                    this.emitPartial(this.buffer.substring(this.sectionStart, entityStart));
                }
                this.trieResult =
                    this.trieCurrent & decode_1.BinTrieFlags.MULTI_BYTE
                        ? String.fromCharCode(this.entityTrie[++this.trieIndex], this.entityTrie[++this.trieIndex])
                        : String.fromCharCode(this.entityTrie[++this.trieIndex]);
                this.entityExcess = 0;
                this.sectionStart = this._index + 1;
            }
        }
    };
    Tokenizer.prototype.emitNamedEntity = function () {
        if (this.trieResult) {
            this.emitPartial(this.trieResult);
        }
        this._state = this.baseState;
    };
    Tokenizer.prototype.stateBeforeNumericEntity = function (c) {
        if ((c | 0x20) === 120 ) {
            this.entityExcess++;
            this._state = 29 ;
        }
        else {
            this._state = 28 ;
            this.stateInNumericEntity(c);
        }
    };
    Tokenizer.prototype.decodeNumericEntity = function (base, strict) {
        var entityStart = this._index - this.entityExcess - 1;
        var numberStart = entityStart + 2 + (base >> 4);
        if (numberStart !== this._index) {
            if (entityStart > this.sectionStart) {
                this.emitPartial(this.buffer.substring(this.sectionStart, entityStart));
            }
            var entity = this.buffer.substring(numberStart, this._index);
            var parsed = parseInt(entity, base);
            this.emitPartial((0, decode_codepoint_1.default)(parsed));
            this.sectionStart = this._index + Number(strict);
        }
        this._state = this.baseState;
    };
    Tokenizer.prototype.stateInNumericEntity = function (c) {
        if (c === 59 ) {
            this.decodeNumericEntity(10, true);
        }
        else if (!isNumber(c)) {
            if (this.allowLegacyEntity()) {
                this.decodeNumericEntity(10, false);
            }
            else {
                this._state = this.baseState;
            }
            this._index--;
        }
        else {
            this.entityExcess++;
        }
    };
    Tokenizer.prototype.stateInHexEntity = function (c) {
        if (c === 59 ) {
            this.decodeNumericEntity(16, true);
        }
        else if ((c < 97  || c > 102 ) &&
            (c < 65  || c > 70 ) &&
            !isNumber(c)) {
            if (this.allowLegacyEntity()) {
                this.decodeNumericEntity(16, false);
            }
            else {
                this._state = this.baseState;
            }
            this._index--;
        }
        else {
            this.entityExcess++;
        }
    };
    Tokenizer.prototype.allowLegacyEntity = function () {
        return (!this.xmlMode &&
            (this.baseState === 1  ||
                this.baseState === 24 ));
    };
    Tokenizer.prototype.cleanup = function () {
        if (this.running &&
            this.sectionStart !== this._index &&
            (this._state === 1  ||
                (this._state === 24  &&
                    this.sequenceIndex === 0))) {
            this.cbs.ontext(this.buffer.substr(this.sectionStart));
            this.sectionStart = this._index;
        }
        var start = this.sectionStart < 0 ? this._index : this.sectionStart;
        this.buffer =
            start === this.buffer.length ? "" : this.buffer.substr(start);
        this._index -= start;
        this.bufferOffset += start;
        if (this.sectionStart > 0) {
            this.sectionStart = 0;
        }
    };
    Tokenizer.prototype.shouldContinue = function () {
        return this._index < this.buffer.length && this.running;
    };
    Tokenizer.prototype.parse = function () {
        while (this.shouldContinue()) {
            var c = this.buffer.charCodeAt(this._index);
            if (this._state === 1 ) {
                this.stateText(c);
            }
            else if (this._state === 23 ) {
                this.stateSpecialStartSequence(c);
            }
            else if (this._state === 24 ) {
                this.stateInSpecialTag(c);
            }
            else if (this._state === 19 ) {
                this.stateCDATASequence(c);
            }
            else if (this._state === 12 ) {
                this.stateInAttributeValueDoubleQuotes(c);
            }
            else if (this._state === 9 ) {
                this.stateInAttributeName(c);
            }
            else if (this._state === 21 ) {
                this.stateInCommentLike(c);
            }
            else if (this._state === 20 ) {
                this.stateInSpecialComment(c);
            }
            else if (this._state === 8 ) {
                this.stateBeforeAttributeName(c);
            }
            else if (this._state === 3 ) {
                this.stateInTagName(c);
            }
            else if (this._state === 6 ) {
                this.stateInClosingTagName(c);
            }
            else if (this._state === 2 ) {
                this.stateBeforeTagName(c);
            }
            else if (this._state === 10 ) {
                this.stateAfterAttributeName(c);
            }
            else if (this._state === 13 ) {
                this.stateInAttributeValueSingleQuotes(c);
            }
            else if (this._state === 11 ) {
                this.stateBeforeAttributeValue(c);
            }
            else if (this._state === 5 ) {
                this.stateBeforeClosingTagName(c);
            }
            else if (this._state === 7 ) {
                this.stateAfterClosingTagName(c);
            }
            else if (this._state === 22 ) {
                this.stateBeforeSpecialS(c);
            }
            else if (this._state === 14 ) {
                this.stateInAttributeValueNoQuotes(c);
            }
            else if (this._state === 4 ) {
                this.stateInSelfClosingTag(c);
            }
            else if (this._state === 16 ) {
                this.stateInDeclaration(c);
            }
            else if (this._state === 15 ) {
                this.stateBeforeDeclaration(c);
            }
            else if (this._state === 18 ) {
                this.stateBeforeComment(c);
            }
            else if (this._state === 17 ) {
                this.stateInProcessingInstruction(c);
            }
            else if (this._state === 27 ) {
                this.stateInNamedEntity(c);
            }
            else if (this._state === 25 ) {
                this.stateBeforeEntity(c);
            }
            else if (this._state === 29 ) {
                this.stateInHexEntity(c);
            }
            else if (this._state === 28 ) {
                this.stateInNumericEntity(c);
            }
            else {
                this.stateBeforeNumericEntity(c);
            }
            this._index++;
        }
        this.cleanup();
    };
    Tokenizer.prototype.finish = function () {
        if (this._state === 27 ) {
            this.emitNamedEntity();
        }
        if (this.sectionStart < this._index) {
            this.handleTrailingData();
        }
        this.cbs.onend();
    };
    Tokenizer.prototype.handleTrailingData = function () {
        var data = this.buffer.substr(this.sectionStart);
        if (this._state === 21 ) {
            if (this.currentSequence === Sequences.CdataEnd) {
                this.cbs.oncdata(data);
            }
            else {
                this.cbs.oncomment(data);
            }
        }
        else if (this._state === 28  &&
            this.allowLegacyEntity()) {
            this.decodeNumericEntity(10, false);
        }
        else if (this._state === 29  &&
            this.allowLegacyEntity()) {
            this.decodeNumericEntity(16, false);
        }
        else if (this._state === 3  ||
            this._state === 8  ||
            this._state === 11  ||
            this._state === 10  ||
            this._state === 9  ||
            this._state === 13  ||
            this._state === 12  ||
            this._state === 14  ||
            this._state === 6 ) ;
        else {
            this.cbs.ontext(data);
        }
    };
    Tokenizer.prototype.getSection = function () {
        return this.buffer.substring(this.sectionStart, this._index);
    };
    Tokenizer.prototype.emitPartial = function (value) {
        if (this.baseState !== 1  &&
            this.baseState !== 24 ) {
            this.cbs.onattribdata(value);
        }
        else {
            this.cbs.ontext(value);
        }
    };
    return Tokenizer;
}());
Tokenizer$1.default = Tokenizer;

var __importDefault$1 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Parser$2, "__esModule", { value: true });
Parser$2.Parser = void 0;
var Tokenizer_1 = __importDefault$1(Tokenizer$1);
var formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea",
]);
var pTag = new Set(["p"]);
var tableSectionTags = new Set(["thead", "tbody"]);
var ddtTags = new Set(["dd", "dt"]);
var rtpTags = new Set(["rt", "rp"]);
var openImpliesClose = new Map([
    ["tr", new Set(["tr", "th", "td"])],
    ["th", new Set(["th"])],
    ["td", new Set(["thead", "th", "td"])],
    ["body", new Set(["head", "link", "script"])],
    ["li", new Set(["li"])],
    ["p", pTag],
    ["h1", pTag],
    ["h2", pTag],
    ["h3", pTag],
    ["h4", pTag],
    ["h5", pTag],
    ["h6", pTag],
    ["select", formTags],
    ["input", formTags],
    ["output", formTags],
    ["button", formTags],
    ["datalist", formTags],
    ["textarea", formTags],
    ["option", new Set(["option"])],
    ["optgroup", new Set(["optgroup", "option"])],
    ["dd", ddtTags],
    ["dt", ddtTags],
    ["address", pTag],
    ["article", pTag],
    ["aside", pTag],
    ["blockquote", pTag],
    ["details", pTag],
    ["div", pTag],
    ["dl", pTag],
    ["fieldset", pTag],
    ["figcaption", pTag],
    ["figure", pTag],
    ["footer", pTag],
    ["form", pTag],
    ["header", pTag],
    ["hr", pTag],
    ["main", pTag],
    ["nav", pTag],
    ["ol", pTag],
    ["pre", pTag],
    ["section", pTag],
    ["table", pTag],
    ["ul", pTag],
    ["rt", rtpTags],
    ["rp", rtpTags],
    ["tbody", tableSectionTags],
    ["tfoot", tableSectionTags],
]);
var voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
]);
var foreignContextElements = new Set(["math", "svg"]);
var htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title",
]);
var reNameEnd = /\s|\//;
var Parser$1 =  (function () {
    function Parser(cbs, options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c, _d, _e;
        this.options = options;
        this.startIndex = 0;
        this.endIndex = 0;
        this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames =
            (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_1.default)(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
    }
    Parser.prototype.ontext = function (data) {
        var _a, _b;
        var idx = this.tokenizer.getAbsoluteIndex();
        this.endIndex = idx - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data);
        this.startIndex = idx;
    };
    Parser.prototype.isVoidElement = function (name) {
        return !this.options.xmlMode && voidElements.has(name);
    };
    Parser.prototype.onopentagname = function (name) {
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        this.emitOpenTag(name);
    };
    Parser.prototype.emitOpenTag = function (name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        var impliesClose = !this.options.xmlMode && openImpliesClose.get(name);
        if (impliesClose) {
            while (this.stack.length > 0 &&
                impliesClose.has(this.stack[this.stack.length - 1])) {
                var el = this.stack.pop();
                (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, el, true);
            }
        }
        if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if (foreignContextElements.has(name)) {
                this.foreignContext.push(true);
            }
            else if (htmlIntegrationElements.has(name)) {
                this.foreignContext.push(false);
            }
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name);
        if (this.cbs.onopentag)
            this.attribs = {};
    };
    Parser.prototype.endOpenTag = function (isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
            this.cbs.onclosetag(this.tagname, true);
        }
        this.tagname = "";
    };
    Parser.prototype.onopentagend = function () {
        this.endOpenTag(false);
        this.startIndex = this.endIndex + 1;
    };
    Parser.prototype.onclosetag = function (name) {
        var _a, _b, _c, _d, _e, _f;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        if (foreignContextElements.has(name) ||
            htmlIntegrationElements.has(name)) {
            this.foreignContext.pop();
        }
        if (!this.isVoidElement(name)) {
            var pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    var count = this.stack.length - pos;
                    while (count--) {
                        this.cbs.onclosetag(this.stack.pop(), count !== 0);
                    }
                }
                else
                    this.stack.length = pos;
            }
            else if (!this.options.xmlMode && name === "p") {
                this.emitOpenTag(name);
                this.closeCurrentTag(true);
            }
        }
        else if (!this.options.xmlMode && name === "br") {
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, name);
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 ? void 0 : _d.call(_c, name, {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e, name, false);
        }
        this.startIndex = this.endIndex + 1;
    };
    Parser.prototype.onselfclosingtag = function () {
        if (this.options.xmlMode ||
            this.options.recognizeSelfClosing ||
            this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            this.startIndex = this.endIndex + 1;
        }
        else {
            this.onopentagend();
        }
    };
    Parser.prototype.closeCurrentTag = function (isOpenImplied) {
        var _a, _b;
        var name = this.tagname;
        this.endOpenTag(isOpenImplied);
        if (this.stack[this.stack.length - 1] === name) {
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
        }
    };
    Parser.prototype.onattribname = function (name) {
        this.startIndex = this.tokenizer.getAbsoluteSectionStart();
        if (this.lowerCaseAttributeNames) {
            name = name.toLowerCase();
        }
        this.attribname = name;
    };
    Parser.prototype.onattribdata = function (value) {
        this.attribvalue += value;
    };
    Parser.prototype.onattribend = function (quote) {
        var _a, _b;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote);
        if (this.attribs &&
            !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
            this.attribs[this.attribname] = this.attribvalue;
        }
        this.attribname = "";
        this.attribvalue = "";
    };
    Parser.prototype.getInstructionName = function (value) {
        var idx = value.search(reNameEnd);
        var name = idx < 0 ? value : value.substr(0, idx);
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        return name;
    };
    Parser.prototype.ondeclaration = function (value) {
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.cbs.onprocessinginstruction) {
            var name_1 = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("!" + name_1, "!" + value);
        }
        this.startIndex = this.endIndex + 1;
    };
    Parser.prototype.onprocessinginstruction = function (value) {
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.cbs.onprocessinginstruction) {
            var name_2 = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("?" + name_2, "?" + value);
        }
        this.startIndex = this.endIndex + 1;
    };
    Parser.prototype.oncomment = function (value) {
        var _a, _b, _c, _d;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, value);
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
        this.startIndex = this.endIndex + 1;
    };
    Parser.prototype.oncdata = function (value) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
        }
        else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, "[CDATA[" + value + "]]");
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
        }
        this.startIndex = this.endIndex + 1;
    };
    Parser.prototype.onerror = function (err) {
        var _a, _b;
        (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    };
    Parser.prototype.onend = function () {
        var _a, _b;
        if (this.cbs.onclosetag) {
            this.endIndex = this.startIndex;
            for (var i = this.stack.length; i > 0; this.cbs.onclosetag(this.stack[--i], true))
                ;
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    Parser.prototype.reset = function () {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack = [];
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
    };
    Parser.prototype.parseComplete = function (data) {
        this.reset();
        this.end(data);
    };
    Parser.prototype.write = function (chunk) {
        this.tokenizer.write(chunk);
    };
    Parser.prototype.end = function (chunk) {
        this.tokenizer.end(chunk);
    };
    Parser.prototype.pause = function () {
        this.tokenizer.pause();
    };
    Parser.prototype.resume = function () {
        this.tokenizer.resume();
    };
    Parser.prototype.parseChunk = function (chunk) {
        this.write(chunk);
    };
    Parser.prototype.done = function (chunk) {
        this.end(chunk);
    };
    return Parser;
}());
Parser$2.Parser = Parser$1;

var lib$1 = {};

var lib = {};

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
var ElementType;
(function (ElementType) {
    ElementType["Root"] = "root";
    ElementType["Text"] = "text";
    ElementType["Directive"] = "directive";
    ElementType["Comment"] = "comment";
    ElementType["Script"] = "script";
    ElementType["Style"] = "style";
    ElementType["Tag"] = "tag";
    ElementType["CDATA"] = "cdata";
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
exports.Root = ElementType.Root;
exports.Text = ElementType.Text;
exports.Directive = ElementType.Directive;
exports.Comment = ElementType.Comment;
exports.Script = ElementType.Script;
exports.Style = ElementType.Style;
exports.Tag = ElementType.Tag;
exports.CDATA = ElementType.CDATA;
exports.Doctype = ElementType.Doctype;
}(lib));
getDefaultExportFromCjs(lib);

var node$1 = {};

var __extends$1 = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$3 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$3 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};
Object.defineProperty(node$1, "__esModule", { value: true });
node$1.cloneNode = node$1.hasChildren = node$1.isDocument = node$1.isDirective = node$1.isComment = node$1.isText = node$1.isCDATA = node$1.isTag = node$1.Element = node$1.Document = node$1.NodeWithChildren = node$1.ProcessingInstruction = node$1.Comment = node$1.Text = node$1.DataNode = node$1.Node = void 0;
var domelementtype_1 = lib;
var nodeTypes = new Map([
    [domelementtype_1.ElementType.Tag, 1],
    [domelementtype_1.ElementType.Script, 1],
    [domelementtype_1.ElementType.Style, 1],
    [domelementtype_1.ElementType.Directive, 1],
    [domelementtype_1.ElementType.Text, 3],
    [domelementtype_1.ElementType.CDATA, 4],
    [domelementtype_1.ElementType.Comment, 8],
    [domelementtype_1.ElementType.Root, 9],
]);
var Node =  (function () {
    function Node(type) {
        this.type = type;
        this.parent = null;
        this.prev = null;
        this.next = null;
        this.startIndex = null;
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "nodeType", {
        get: function () {
            var _a;
            return (_a = nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "parentNode", {
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode(this, recursive);
    };
    return Node;
}());
node$1.Node = Node;
var DataNode =  (function (_super) {
    __extends$1(DataNode, _super);
    function DataNode(type, data) {
        var _this = _super.call(this, type) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node));
node$1.DataNode = DataNode;
var Text$1 =  (function (_super) {
    __extends$1(Text, _super);
    function Text(data) {
        return _super.call(this, domelementtype_1.ElementType.Text, data) || this;
    }
    return Text;
}(DataNode));
node$1.Text = Text$1;
var Comment =  (function (_super) {
    __extends$1(Comment, _super);
    function Comment(data) {
        return _super.call(this, domelementtype_1.ElementType.Comment, data) || this;
    }
    return Comment;
}(DataNode));
node$1.Comment = Comment;
var ProcessingInstruction =  (function (_super) {
    __extends$1(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, domelementtype_1.ElementType.Directive, data) || this;
        _this.name = name;
        return _this;
    }
    return ProcessingInstruction;
}(DataNode));
node$1.ProcessingInstruction = ProcessingInstruction;
var NodeWithChildren =  (function (_super) {
    __extends$1(NodeWithChildren, _super);
    function NodeWithChildren(type, children) {
        var _this = _super.call(this, type) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node));
node$1.NodeWithChildren = NodeWithChildren;
var Document =  (function (_super) {
    __extends$1(Document, _super);
    function Document(children) {
        return _super.call(this, domelementtype_1.ElementType.Root, children) || this;
    }
    return Document;
}(NodeWithChildren));
node$1.Document = Document;
var Element$1 =  (function (_super) {
    __extends$1(Element, _super);
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1.ElementType.Script
            : name === "style"
                ? domelementtype_1.ElementType.Style
                : domelementtype_1.ElementType.Tag; }
        var _this = _super.call(this, type, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        return _this;
    }
    Object.defineProperty(Element.prototype, "tagName", {
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
node$1.Element = Element$1;
function isTag(node) {
    return (0, domelementtype_1.isTag)(node);
}
node$1.isTag = isTag;
function isCDATA(node) {
    return node.type === domelementtype_1.ElementType.CDATA;
}
node$1.isCDATA = isCDATA;
function isText(node) {
    return node.type === domelementtype_1.ElementType.Text;
}
node$1.isText = isText;
function isComment(node) {
    return node.type === domelementtype_1.ElementType.Comment;
}
node$1.isComment = isComment;
function isDirective(node) {
    return node.type === domelementtype_1.ElementType.Directive;
}
node$1.isDirective = isDirective;
function isDocument(node) {
    return node.type === domelementtype_1.ElementType.Root;
}
node$1.isDocument = isDocument;
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
node$1.hasChildren = hasChildren;
function cloneNode(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text$1(node.data);
    }
    else if (isComment(node)) {
        result = new Comment(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element$1(node.name, __assign$3({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign$3({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign$3({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new NodeWithChildren(domelementtype_1.ElementType.CDATA, children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
node$1.cloneNode = cloneNode;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomHandler = void 0;
var domelementtype_1 = lib;
var node_1 = node$1;
__exportStar(node$1, exports);
var reWhitespace = /\s+/g;
var defaultOpts = {
    normalizeWhitespace: false,
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
var DomHandler =  (function () {
    function DomHandler(callback, options, elementCB) {
        this.dom = [];
        this.root = new node_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this.parser = parser;
    };
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this.root = new node_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    };
    DomHandler.prototype.onend = function () {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
        var element = new node_1.Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var normalizeWhitespace = this.options.normalizeWhitespace;
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            if (normalizeWhitespace) {
                lastNode.data = (lastNode.data + data).replace(reWhitespace, " ");
            }
            else {
                lastNode.data += data;
            }
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            if (normalizeWhitespace) {
                data = data.replace(reWhitespace, " ");
            }
            var node = new node_1.Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new node_1.Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_1.Text("");
        var node = new node_1.NodeWithChildren(domelementtype_1.ElementType.CDATA, [text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports.default = DomHandler;
}(lib$1));
getDefaultExportFromCjs(lib$1);

function unsetRootParent$1(nodes) {
  for (var index = 0, len = nodes.length; index < len; index++) {
    var node = nodes[index];
    node.parent = null;
  }
  return nodes;
}
var utilities = {
  unsetRootParent: unsetRootParent$1
};

var Parser = Parser$2.Parser;
var DomHandler = lib$1.DomHandler;
var unsetRootParent = utilities.unsetRootParent;
function HTMLDOMParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string.');
  }
  if (html === '') {
    return [];
  }
  var handler = new DomHandler(undefined, options);
  new Parser(handler, options).end(html);
  return unsetRootParent(handler.dom);
}
var htmlToDom = HTMLDOMParser;

var htmlDomParser = htmlToDom;

var domToReact = domToReact_1;
var attributesToProps = attributesToProps$2;
var htmlToDOM = htmlDomParser;
htmlToDOM =
  typeof htmlToDOM.default === 'function' ? htmlToDOM.default : htmlToDOM;
var domParserOptions = { lowerCaseAttributeNames: false };
function HTMLReactParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (html === '') {
    return [];
  }
  options = options || {};
  return domToReact(
    htmlToDOM(html, options.htmlparser2 || domParserOptions),
    options
  );
}
HTMLReactParser.domToReact = domToReact;
HTMLReactParser.htmlToDOM = htmlToDOM;
HTMLReactParser.attributesToProps = attributesToProps;
HTMLReactParser.Element = lib$1.Element;
htmlReactParser.exports = HTMLReactParser;
htmlReactParser.exports.default = HTMLReactParser;
var HTMLReactParser$1 = htmlReactParser.exports;

HTMLReactParser$1.domToReact;
HTMLReactParser$1.htmlToDOM;
HTMLReactParser$1.attributesToProps;
HTMLReactParser$1.Element;

var Currency = [{iso:"EUR",symbol:"&#8364;"},{iso:"USD",symbol:"&#36;"},{iso:"GBP",symbol:"&#163;"}];

function getCurrency(iso, type) {
  var currency = Currency.find(function (e) {
    return e.iso === iso;
  });
  switch (type) {
    case 'iso':
      return HTMLReactParser$1(currency.iso);
    case 'symbol':
      return HTMLReactParser$1(currency.symbol);
    default:
      return HTMLReactParser$1(currency.iso);
  }
}

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var createDefinition = function (propNames) { return ({
    isEnabled: function (props) { return propNames.some(function (name) { return !!props[name]; }); },
}); };
var featureDefinitions = {
    measureLayout: createDefinition(["layout", "layoutId", "drag"]),
    animation: createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView",
    ]),
    exit: createDefinition(["exit"]),
    drag: createDefinition(["drag", "dragControls"]),
    focus: createDefinition(["whileFocus"]),
    hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
    tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
    pan: createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd",
    ]),
    inView: createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave",
    ]),
};
function loadFeatures(features) {
    for (var key in features) {
        if (features[key] === null)
            continue;
        if (key === "projectionNodeConstructor") {
            featureDefinitions.projectionNodeConstructor = features[key];
        }
        else {
            featureDefinitions[key].Component = features[key];
        }
    }
}

var warning$3 = function () { };
var invariant = function () { };
if (process.env.NODE_ENV !== 'production') {
    warning$3 = function (check, message) {
        if (!check && typeof console !== 'undefined') {
            console.warn(message);
        }
    };
    invariant = function (check, message) {
        if (!check) {
            throw new Error(message);
        }
    };
}

var LazyContext = createContext({ strict: false });

var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
function useFeatures(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = useContext(LazyContext);
    if (!visualElement)
        return null;
    if (process.env.NODE_ENV !== "production" &&
        preloadedFeatures &&
        lazyContext.strict) {
        invariant(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
    }
    for (var i = 0; i < numFeatures; i++) {
        var name_1 = featureNames[i];
        var _a = featureDefinitions[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        if (isEnabled(props) && Component) {
            features.push(React$4.createElement(Component, __assign$2({ key: name_1 }, props, { visualElement: visualElement })));
        }
    }
    return features;
}

var MotionConfigContext = createContext({
    transformPagePoint: function (p) { return p; },
    isStatic: false,
});

var MotionContext = createContext({});
function useVisualElementContext() {
    return useContext(MotionContext).visualElement;
}

var PresenceContext = createContext(null);

var isBrowser = typeof window !== "undefined";

var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;

function useVisualElement(Component, visualState, props, createVisualElement) {
    var lazyContext = useContext(LazyContext);
    var parent = useVisualElementContext();
    var presenceContext = useContext(PresenceContext);
    var visualElementRef = useRef(undefined);
    if (!createVisualElement)
        createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState: visualState,
            parent: parent,
            props: props,
            presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
            blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
        });
    }
    var visualElement = visualElementRef.current;
    useIsomorphicLayoutEffect(function () {
        visualElement === null || visualElement === void 0 ? void 0 : visualElement.syncRender();
    });
    useEffect(function () {
        var _a;
        (_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.animationState) === null || _a === void 0 ? void 0 : _a.animateChanges();
    });
    useIsomorphicLayoutEffect(function () { return function () { return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount(); }; }, []);
    return visualElement;
}

function isRefObject(ref) {
    return (typeof ref === "object" &&
        Object.prototype.hasOwnProperty.call(ref, "current"));
}

function useMotionRef(visualState, visualElement, externalRef) {
    return useCallback(function (instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 ? void 0 : _a.call(visualState, instance));
        if (visualElement) {
            instance
                ? visualElement.mount(instance)
                : visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") {
                externalRef(instance);
            }
            else if (isRefObject(externalRef)) {
                externalRef.current = instance;
            }
        }
    },
    [visualElement]);
}

function isVariantLabels(v) {
    return Array.isArray(v);
}
function isVariantLabel(v) {
    return typeof v === "string" || isVariantLabels(v);
}
function getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function (value, key) { return (current[key] = value.get()); });
    return current;
}
function getVelocity$1(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function (value, key) { return (velocity[key] = value.getVelocity()); });
    return velocity;
}
function resolveVariantFromProps(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) { currentValues = {}; }
    if (currentVelocity === void 0) { currentVelocity = {}; }
    if (typeof definition === "function") {
        definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    }
    if (typeof definition === "string") {
        definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    }
    if (typeof definition === "function") {
        definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    }
    return definition;
}
function resolveVariant(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, getCurrent(visualElement), getVelocity$1(visualElement));
}
function checkIfControllingVariants(props) {
    var _a;
    return (typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" ||
        isVariantLabel(props.initial) ||
        isVariantLabel(props.animate) ||
        isVariantLabel(props.whileHover) ||
        isVariantLabel(props.whileDrag) ||
        isVariantLabel(props.whileTap) ||
        isVariantLabel(props.whileFocus) ||
        isVariantLabel(props.exit));
}
function checkIfVariantNode(props) {
    return Boolean(checkIfControllingVariants(props) || props.variants);
}

function getCurrentTreeVariants(props, context) {
    if (checkIfControllingVariants(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || isVariantLabel(initial)
                ? initial
                : undefined,
            animate: isVariantLabel(animate) ? animate : undefined,
        };
    }
    return props.inherit !== false ? context : {};
}

function useCreateMotionContext(props) {
    var _a = getCurrentTreeVariants(props, useContext(MotionContext)), initial = _a.initial, animate = _a.animate;
    return useMemo(function () { return ({ initial: initial, animate: animate }); }, [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

function useConstant(init) {
    var ref = useRef(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref.current;
}

const defaultTimestep = (1 / 60) * 1000;
const getCurrentTime = typeof performance !== "undefined"
    ? () => performance.now()
    : () => Date.now();
const onNextFrame = typeof window !== "undefined"
    ? (callback) => window.requestAnimationFrame(callback)
    : (callback) => setTimeout(() => callback(getCurrentTime()), defaultTimestep);

function createRenderStep(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false) => {
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing)
                    numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback) => {
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1)
                toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData) => {
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [toRunNextFrame, toRun];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) {
                for (let i = 0; i < numToRun; i++) {
                    const callback = toRun[i];
                    callback(frameData);
                    if (toKeepAlive.has(callback)) {
                        step.schedule(callback);
                        runNextFrame();
                    }
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        },
    };
    return step;
}

const maxElapsed = 40;
let useDefaultElapsed = true;
let runNextFrame = false;
let isProcessing = false;
const frame = {
    delta: 0,
    timestamp: 0,
};
const stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender",
];
const steps = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(() => (runNextFrame = true));
    return acc;
}, {});
const sync = stepsOrder.reduce((acc, key) => {
    const step = steps[key];
    acc[key] = (process, keepAlive = false, immediate = false) => {
        if (!runNextFrame)
            startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const cancelSync = stepsOrder.reduce((acc, key) => {
    acc[key] = steps[key].cancel;
    return acc;
}, {});
const flushSync = stepsOrder.reduce((acc, key) => {
    acc[key] = () => steps[key].process(frame);
    return acc;
}, {});
const processStep = (stepId) => steps[stepId].process(frame);
const processFrame = (timestamp) => {
    runNextFrame = false;
    frame.delta = useDefaultElapsed
        ? defaultTimestep
        : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
    frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (runNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
const startLoop = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing)
        onNextFrame(processFrame);
};
const getFrameData = () => frame;

const clamp$1 = (min, max, v) => Math.min(Math.max(v, min), max);

const safeMin = 0.001;
const minDuration = 0.01;
const maxDuration = 10.0;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1, }) {
    let envelope;
    let derivative;
    warning$3(duration <= maxDuration * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    dampingRatio = clamp$1(minDamping, maxDamping, dampingRatio);
    duration = clamp$1(minDuration, maxDuration, duration / 1000);
    if (dampingRatio < 1) {
        envelope = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - (a / b) * c;
        };
        derivative = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return (factor * ((d - e) * f)) / g;
        };
    }
    else {
        envelope = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) {
        return {
            stiffness: 100,
            damping: 10,
            duration,
        };
    }
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration,
        };
    }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for (let i = 1; i < rootIterations; i++) {
        result = result - envelope(result) / derivative(result);
    }
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

const durationKeys = ["duration", "bounce"];
const physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
    return keys.some((key) => options[key] !== undefined);
}
function getSpringOptions(options) {
    let springOptions = Object.assign({ velocity: 0.0, stiffness: 100, damping: 10, mass: 1.0, isResolvedFromDuration: false }, options);
    if (!isSpringType(options, physicsKeys) &&
        isSpringType(options, durationKeys)) {
        const derived = findSpring(options);
        springOptions = Object.assign(Object.assign(Object.assign({}, springOptions), derived), { velocity: 0.0, mass: 1.0 });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function spring(_a) {
    var { from = 0.0, to = 1.0, restSpeed = 2, restDelta } = _a, options = __rest(_a, ["from", "to", "restSpeed", "restDelta"]);
    const state = { done: false, value: from };
    let { stiffness, damping, mass, velocity, duration, isResolvedFromDuration, } = getSpringOptions(options);
    let resolveSpring = zero$2;
    let resolveVelocity = zero$2;
    function createSpring() {
        const initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        const initialDelta = to - from;
        const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        if (restDelta === undefined) {
            restDelta = Math.min(Math.abs(to - from) / 100, 0.4);
        }
        if (dampingRatio < 1) {
            const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
            resolveSpring = (t) => {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return (to -
                    envelope *
                        (((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) /
                            angularFreq) *
                            Math.sin(angularFreq * t) +
                            initialDelta * Math.cos(angularFreq * t)));
            };
            resolveVelocity = (t) => {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return (dampingRatio *
                    undampedAngularFreq *
                    envelope *
                    ((Math.sin(angularFreq * t) *
                        (initialVelocity +
                            dampingRatio *
                                undampedAngularFreq *
                                initialDelta)) /
                        angularFreq +
                        initialDelta * Math.cos(angularFreq * t)) -
                    envelope *
                        (Math.cos(angularFreq * t) *
                            (initialVelocity +
                                dampingRatio *
                                    undampedAngularFreq *
                                    initialDelta) -
                            angularFreq *
                                initialDelta *
                                Math.sin(angularFreq * t)));
            };
        }
        else if (dampingRatio === 1) {
            resolveSpring = (t) => to -
                Math.exp(-undampedAngularFreq * t) *
                    (initialDelta +
                        (initialVelocity + undampedAngularFreq * initialDelta) *
                            t);
        }
        else {
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t) => {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return (to -
                    (envelope *
                        ((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) *
                            Math.sinh(freqForT) +
                            dampedAngularFreq *
                                initialDelta *
                                Math.cosh(freqForT))) /
                        dampedAngularFreq);
            };
        }
    }
    createSpring();
    return {
        next: (t) => {
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = resolveVelocity(t) * 1000;
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done =
                    isBelowVelocityThreshold && isBelowDisplacementThreshold;
            }
            else {
                state.done = t >= duration;
            }
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: () => {
            velocity = -velocity;
            [from, to] = [to, from];
            createSpring();
        },
    };
}
spring.needsInterpolation = (a, b) => typeof a === "string" || typeof b === "string";
const zero$2 = (_t) => 0;

const progress = (from, to, value) => {
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

const mix = (from, to, progress) => -progress * from + progress * to + from;

const clamp = (min, max) => (v) => Math.max(Math.min(v, max), min);
const sanitize = (v) => (v % 1 ? Number(v.toFixed(5)) : v);
const floatRegex = /(-)?([\d]*\.?[\d])+/g;
const colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
const singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString(v) {
    return typeof v === 'string';
}

const number$2 = {
    test: (v) => typeof v === 'number',
    parse: parseFloat,
    transform: (v) => v,
};
const alpha = Object.assign(Object.assign({}, number$2), { transform: clamp(0, 1) });
const scale = Object.assign(Object.assign({}, number$2), { default: 1 });

const createUnitType = (unit) => ({
    test: (v) => isString(v) && v.endsWith(unit) && v.split(' ').length === 1,
    parse: parseFloat,
    transform: (v) => `${v}${unit}`,
});
const degrees = createUnitType('deg');
const percent = createUnitType('%');
const px = createUnitType('px');
const vh = createUnitType('vh');
const vw = createUnitType('vw');
const progressPercentage = Object.assign(Object.assign({}, percent), { parse: (v) => percent.parse(v) / 100, transform: (v) => percent.transform(v * 100) });

const isColorString = (type, testProp) => (v) => {
    return Boolean((isString(v) && singleColorRegex.test(v) && v.startsWith(type)) ||
        (testProp && Object.prototype.hasOwnProperty.call(v, testProp)));
};
const splitColor = (aName, bName, cName) => (v) => {
    if (!isString(v))
        return v;
    const [a, b, c, alpha] = v.match(floatRegex);
    return {
        [aName]: parseFloat(a),
        [bName]: parseFloat(b),
        [cName]: parseFloat(c),
        alpha: alpha !== undefined ? parseFloat(alpha) : 1,
    };
};

const hsla$1 = {
    test: isColorString('hsl', 'hue'),
    parse: splitColor('hue', 'saturation', 'lightness'),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
        return ('hsla(' +
            Math.round(hue) +
            ', ' +
            percent.transform(sanitize(saturation)) +
            ', ' +
            percent.transform(sanitize(lightness)) +
            ', ' +
            sanitize(alpha.transform(alpha$1)) +
            ')');
    },
};

const clampRgbUnit = clamp(0, 255);
const rgbUnit = Object.assign(Object.assign({}, number$2), { transform: (v) => Math.round(clampRgbUnit(v)) });
const rgba$1 = {
    test: isColorString('rgb', 'red'),
    parse: splitColor('red', 'green', 'blue'),
    transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => 'rgba(' +
        rgbUnit.transform(red) +
        ', ' +
        rgbUnit.transform(green) +
        ', ' +
        rgbUnit.transform(blue) +
        ', ' +
        sanitize(alpha.transform(alpha$1)) +
        ')',
};

function parseHex(v) {
    let r = '';
    let g = '';
    let b = '';
    let a = '';
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    }
    else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1,
    };
}
const hex$1 = {
    test: isColorString('#'),
    parse: parseHex,
    transform: rgba$1.transform,
};

const color$1 = {
    test: (v) => rgba$1.test(v) || hex$1.test(v) || hsla$1.test(v),
    parse: (v) => {
        if (rgba$1.test(v)) {
            return rgba$1.parse(v);
        }
        else if (hsla$1.test(v)) {
            return hsla$1.parse(v);
        }
        else {
            return hex$1.parse(v);
        }
    },
    transform: (v) => {
        return isString(v)
            ? v
            : v.hasOwnProperty('red')
                ? rgba$1.transform(v)
                : hsla$1.transform(v);
    },
};

const colorToken = '${c}';
const numberToken = '${n}';
function test(v) {
    var _a, _b, _c, _d;
    return (isNaN(v) &&
        isString(v) &&
        ((_b = (_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match(colorRegex)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0);
}
function analyse$1(v) {
    if (typeof v === 'number')
        v = `${v}`;
    const values = [];
    let numColors = 0;
    const colors = v.match(colorRegex);
    if (colors) {
        numColors = colors.length;
        v = v.replace(colorRegex, colorToken);
        values.push(...colors.map(color$1.parse));
    }
    const numbers = v.match(floatRegex);
    if (numbers) {
        v = v.replace(floatRegex, numberToken);
        values.push(...numbers.map(number$2.parse));
    }
    return { values, numColors, tokenised: v };
}
function parse(v) {
    return analyse$1(v).values;
}
function createTransformer(v) {
    const { values, numColors, tokenised } = analyse$1(v);
    const numValues = values.length;
    return (v) => {
        let output = tokenised;
        for (let i = 0; i < numValues; i++) {
            output = output.replace(i < numColors ? colorToken : numberToken, i < numColors ? color$1.transform(v[i]) : sanitize(v[i]));
        }
        return output;
    };
}
const convertNumbersToZero = (v) => typeof v === 'number' ? 0 : v;
function getAnimatableNone$1(v) {
    const parsed = parse(v);
    const transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
const complex = { test, parse, createTransformer, getAnimatableNone: getAnimatableNone$1 };

const maxDefaults = new Set(['brightness', 'contrast', 'saturate', 'opacity']);
function applyDefaultFilter(v) {
    let [name, value] = v.slice(0, -1).split('(');
    if (name === 'drop-shadow')
        return v;
    const [number] = value.match(floatRegex) || [];
    if (!number)
        return v;
    const unit = value.replace(number, '');
    let defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value)
        defaultValue *= 100;
    return name + '(' + defaultValue + unit + ')';
}
const functionRegex = /([a-z-]*)\(.*?\)/g;
const filter$3 = Object.assign(Object.assign({}, complex), { getAnimatableNone: (v) => {
        const functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(' ') : v;
    } });

function hueToRgb(p, q, t) {
    if (t < 0)
        t += 1;
    if (t > 1)
        t -= 1;
    if (t < 1 / 6)
        return p + (q - p) * 6 * t;
    if (t < 1 / 2)
        return q;
    if (t < 2 / 3)
        return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) {
        red = green = blue = lightness;
    }
    else {
        const q = lightness < 0.5
            ? lightness * (1 + saturation)
            : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha,
    };
}

const mixLinearColor = (from, to, v) => {
    const fromExpo = from * from;
    const toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
const colorTypes = [hex$1, rgba$1, hsla$1];
const getColorType = (v) => colorTypes.find((type) => type.test(v));
const notAnimatable = (color) => `'${color}' is not an animatable color. Use the equivalent color code instead.`;
const mixColor = (from, to) => {
    let fromColorType = getColorType(from);
    let toColorType = getColorType(to);
    invariant(!!fromColorType, notAnimatable(from));
    invariant(!!toColorType, notAnimatable(to));
    let fromColor = fromColorType.parse(from);
    let toColor = toColorType.parse(to);
    if (fromColorType === hsla$1) {
        fromColor = hslaToRgba(fromColor);
        fromColorType = rgba$1;
    }
    if (toColorType === hsla$1) {
        toColor = hslaToRgba(toColor);
        toColorType = rgba$1;
    }
    const blended = Object.assign({}, fromColor);
    return (v) => {
        for (const key in blended) {
            if (key !== "alpha") {
                blended[key] = mixLinearColor(fromColor[key], toColor[key], v);
            }
        }
        blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};

const isNum = (v) => typeof v === 'number';

const combineFunctions = (a, b) => (v) => b(a(v));
const pipe = (...transformers) => transformers.reduce(combineFunctions);

function getMixer(origin, target) {
    if (isNum(origin)) {
        return (v) => mix(origin, target, v);
    }
    else if (color$1.test(origin)) {
        return mixColor(origin, target);
    }
    else {
        return mixComplex(origin, target);
    }
}
const mixArray = (from, to) => {
    const output = [...from];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i) => getMixer(fromThis, to[i]));
    return (v) => {
        for (let i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
const mixObject = (origin, target) => {
    const output = Object.assign(Object.assign({}, origin), target);
    const blendValue = {};
    for (const key in output) {
        if (origin[key] !== undefined && target[key] !== undefined) {
            blendValue[key] = getMixer(origin[key], target[key]);
        }
    }
    return (v) => {
        for (const key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
};
function analyse(value) {
    const parsed = complex.parse(value);
    const numValues = parsed.length;
    let numNumbers = 0;
    let numRGB = 0;
    let numHSL = 0;
    for (let i = 0; i < numValues; i++) {
        if (numNumbers || typeof parsed[i] === "number") {
            numNumbers++;
        }
        else {
            if (parsed[i].hue !== undefined) {
                numHSL++;
            }
            else {
                numRGB++;
            }
        }
    }
    return { parsed, numNumbers, numRGB, numHSL };
}
const mixComplex = (origin, target) => {
    const template = complex.createTransformer(target);
    const originStats = analyse(origin);
    const targetStats = analyse(target);
    const canInterpolate = originStats.numHSL === targetStats.numHSL &&
        originStats.numRGB === targetStats.numRGB &&
        originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) {
        return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
    }
    else {
        warning$3(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p) => `${p > 0 ? target : origin}`;
    }
};

const mixNumber = (from, to) => (p) => mix(from, to, p);
function detectMixerFactory(v) {
    if (typeof v === 'number') {
        return mixNumber;
    }
    else if (typeof v === 'string') {
        if (color$1.test(v)) {
            return mixColor;
        }
        else {
            return mixComplex;
        }
    }
    else if (Array.isArray(v)) {
        return mixArray;
    }
    else if (typeof v === 'object') {
        return mixObject;
    }
}
function createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for (let i = 0; i < numMixers; i++) {
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = pipe(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function fastInterpolate([from, to], [mixer]) {
    return (v) => mixer(progress(from, to, v));
}
function slowInterpolate(input, mixers) {
    const inputLength = input.length;
    const lastInputIndex = inputLength - 1;
    return (v) => {
        let mixerIndex = 0;
        let foundMixerIndex = false;
        if (v <= input[0]) {
            foundMixerIndex = true;
        }
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            let i = 1;
            for (; i < inputLength; i++) {
                if (input[i] > v || i === lastInputIndex) {
                    break;
                }
            }
            mixerIndex = i - 1;
        }
        const progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function interpolate$1(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
    const inputLength = input.length;
    invariant(inputLength === output.length, 'Both input and output ranges must be the same length');
    invariant(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    const mixers = createMixers(output, ease, mixer);
    const interpolator = inputLength === 2
        ? fastInterpolate(input, mixers)
        : slowInterpolate(input, mixers);
    return isClamp
        ? (v) => interpolator(clamp$1(input[0], input[inputLength - 1], v))
        : interpolator;
}

const reverseEasing = easing => p => 1 - easing(1 - p);
const mirrorEasing = easing => p => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
const createExpoIn = (power) => p => Math.pow(p, power);
const createBackIn = (power) => p => p * p * ((power + 1) * p - power);
const createAnticipate = (power) => {
    const backEasing = createBackIn(power);
    return p => (p *= 2) < 1
        ? 0.5 * backEasing(p)
        : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};

const DEFAULT_OVERSHOOT_STRENGTH = 1.525;
const BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
const BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
const BOUNCE_THIRD_THRESHOLD = 9.0 / 10.0;
const linear$2 = p => p;
const easeIn = createExpoIn(2);
const easeOut = reverseEasing(easeIn);
const easeInOut = mirrorEasing(easeIn);
const circIn = p => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circOut);
const backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
const backOut = reverseEasing(backIn);
const backInOut = mirrorEasing(backIn);
const anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH);
const ca = 4356.0 / 361.0;
const cb = 35442.0 / 1805.0;
const cc = 16061.0 / 1805.0;
const bounceOut = (p) => {
    if (p === 1 || p === 0)
        return p;
    const p2 = p * p;
    return p < BOUNCE_FIRST_THRESHOLD
        ? 7.5625 * p2
        : p < BOUNCE_SECOND_THRESHOLD
            ? 9.075 * p2 - 9.9 * p + 3.4
            : p < BOUNCE_THIRD_THRESHOLD
                ? ca * p2 - cb * p + cc
                : 10.8 * p * p - 20.52 * p + 10.72;
};
const bounceIn = reverseEasing(bounceOut);
const bounceInOut = (p) => p < 0.5
    ? 0.5 * (1.0 - bounceOut(1.0 - p * 2.0))
    : 0.5 * bounceOut(p * 2.0 - 1.0) + 0.5;

function defaultEasing(values, easing) {
    return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function defaultOffset(values) {
    const numValues = values.length;
    return values.map((_value, i) => i !== 0 ? i / (numValues - 1) : 0);
}
function convertOffsetToTimes(offset, duration) {
    return offset.map((o) => o * duration);
}
function keyframes$1({ from = 0, to = 1, ease, offset, duration = 300, }) {
    const state = { done: false, value: from };
    const values = Array.isArray(to) ? to : [from, to];
    const times = convertOffsetToTimes(offset && offset.length === values.length
        ? offset
        : defaultOffset(values), duration);
    function createInterpolator() {
        return interpolate$1(times, values, {
            ease: Array.isArray(ease) ? ease : defaultEasing(values, ease),
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t) => {
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: () => {
            values.reverse();
            interpolator = createInterpolator();
        },
    };
}

function decay({ velocity = 0, from = 0, power = 0.8, timeConstant = 350, restDelta = 0.5, modifyTarget, }) {
    const state = { done: false, value: from };
    let amplitude = power * velocity;
    const ideal = from + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal)
        amplitude = target - from;
    return {
        next: (t) => {
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: () => { },
    };
}

const types = { keyframes: keyframes$1, spring, decay };
function detectAnimationFromOptions(config) {
    if (Array.isArray(config.to)) {
        return keyframes$1;
    }
    else if (types[config.type]) {
        return types[config.type];
    }
    const keys = new Set(Object.keys(config));
    if (keys.has("ease") ||
        (keys.has("duration") && !keys.has("dampingRatio"))) {
        return keyframes$1;
    }
    else if (keys.has("dampingRatio") ||
        keys.has("stiffness") ||
        keys.has("mass") ||
        keys.has("damping") ||
        keys.has("restSpeed") ||
        keys.has("restDelta")) {
        return spring;
    }
    return keyframes$1;
}

function loopElapsed(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback
        ? loopElapsed(duration + -elapsed, duration, delay)
        : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}

const framesync = (update) => {
    const passTimestamp = ({ delta }) => update(delta);
    return {
        start: () => sync.update(passTimestamp, true),
        stop: () => cancelSync.update(passTimestamp),
    };
};
function animate$1(_a) {
    var _b, _c;
    var { from, autoplay = true, driver = framesync, elapsed = 0, repeat: repeatMax = 0, repeatType = "loop", repeatDelay = 0, onPlay, onStop, onComplete, onRepeat, onUpdate } = _a, options = __rest(_a, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
    let { to } = options;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = options.duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = detectAnimationFromOptions(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = interpolate$1([0, 100], [from, to], {
            clamp: false,
        });
        from = 0;
        to = 100;
    }
    const animation = animator(Object.assign(Object.assign({}, options), { from, to }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        }
        else {
            elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror")
                animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback)
            delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber)
                latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0)
                computedDuration !== null && computedDuration !== void 0 ? computedDuration : (computedDuration = elapsed);
            if (repeatCount < repeatMax) {
                hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            }
            else {
                complete();
            }
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 ? void 0 : onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: () => {
            onStop === null || onStop === void 0 ? void 0 : onStop();
            driverControls.stop();
        },
    };
}

function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

function inertia({ from = 0, velocity = 0, min, max, power = 0.8, timeConstant = 750, bounceStiffness = 500, bounceDamping = 10, restDelta = 1, modifyTarget, driver, onUpdate, onComplete, onStop, }) {
    let currentAnimation;
    function isOutOfBounds(v) {
        return (min !== undefined && v < min) || (max !== undefined && v > max);
    }
    function boundaryNearest(v) {
        if (min === undefined)
            return max;
        if (max === undefined)
            return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        currentAnimation = animate$1(Object.assign(Object.assign({}, options), { driver, onUpdate: (v) => {
                var _a;
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, v);
            }, onComplete,
            onStop }));
    }
    function startSpring(options) {
        startAnimation(Object.assign({ type: "spring", stiffness: bounceStiffness, damping: bounceDamping, restDelta }, options));
    }
    if (isOutOfBounds(from)) {
        startSpring({ from, velocity, to: boundaryNearest(from) });
    }
    else {
        let target = power * velocity + from;
        if (typeof modifyTarget !== "undefined")
            target = modifyTarget(target);
        const boundary = boundaryNearest(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v) => {
            prev = current;
            current = v;
            velocity = velocityPerSecond(v - prev, getFrameData().delta);
            if ((heading === 1 && v > boundary) ||
                (heading === -1 && v < boundary)) {
                startSpring({ from: v, to: boundary, velocity });
            }
        };
        startAnimation({
            type: "decay",
            from,
            velocity,
            timeConstant,
            power,
            restDelta,
            modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined,
        });
    }
    return {
        stop: () => currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop(),
    };
}

const isPoint = (point) => point.hasOwnProperty('x') && point.hasOwnProperty('y');

const isPoint3D = (point) => isPoint(point) && point.hasOwnProperty('z');

const distance1D = (a, b) => Math.abs(a - b);
function distance(a, b) {
    if (isNum(a) && isNum(b)) {
        return distance1D(a, b);
    }
    else if (isPoint(a) && isPoint(b)) {
        const xDelta = distance1D(a.x, b.x);
        const yDelta = distance1D(a.y, b.y);
        const zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}

const a = (a1, a2) => 1.0 - 3.0 * a2 + 3.0 * a1;
const b$1 = (a1, a2) => 3.0 * a2 - 6.0 * a1;
const c$1 = (a1) => 3.0 * a1;
const calcBezier = (t, a1, a2) => ((a(a1, a2) * t + b$1(a1, a2)) * t + c$1(a1)) * t;
const getSlope = (t, a1, a2) => 3.0 * a(a1, a2) * t * t + 2.0 * b$1(a1, a2) * t + c$1(a1);
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 10;
function binarySubdivide(aX, aA, aB, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) {
            aB = currentT;
        }
        else {
            aA = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision &&
        ++i < subdivisionMaxIterations);
    return currentT;
}
const newtonIterations = 8;
const newtonMinSlope = 0.001;
function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (let i = 0; i < newtonIterations; ++i) {
        const currentSlope = getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) {
            return aGuessT;
        }
        const currentX = calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
const kSplineTableSize = 11;
const kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
function cubicBezier(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2)
        return linear$2;
    const sampleValues = new Float32Array(kSplineTableSize);
    for (let i = 0; i < kSplineTableSize; ++i) {
        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
    function getTForX(aX) {
        let intervalStart = 0.0;
        let currentSample = 1;
        const lastSample = kSplineTableSize - 1;
        for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += kSampleStepSize;
        }
        --currentSample;
        const dist = (aX - sampleValues[currentSample]) /
            (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        const guessForT = intervalStart + dist * kSampleStepSize;
        const initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= newtonMinSlope) {
            return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        }
        else if (initialSlope === 0.0) {
            return guessForT;
        }
        else {
            return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
    }
    return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

function addUniqueItem(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function removeItem(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}

var SubscriptionManager =  (function () {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function (handler) {
        var _this = this;
        addUniqueItem(this.subscriptions, handler);
        return function () { return removeItem(_this.subscriptions, handler); };
    };
    SubscriptionManager.prototype.notify = function (a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions)
            return;
        if (numSubscriptions === 1) {
            this.subscriptions[0](a, b, c);
        }
        else {
            for (var i = 0; i < numSubscriptions; i++) {
                var handler = this.subscriptions[i];
                handler && handler(a, b, c);
            }
        }
    };
    SubscriptionManager.prototype.getSize = function () {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function () {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}());

var isFloat = function (value) {
    return !isNaN(parseFloat(value));
};
var MotionValue =  (function () {
    function MotionValue(init) {
        var _this = this;
        this.timeDelta = 0;
        this.lastUpdated = 0;
        this.updateSubscribers = new SubscriptionManager();
        this.velocityUpdateSubscribers = new SubscriptionManager();
        this.renderSubscribers = new SubscriptionManager();
        this.canTrackVelocity = false;
        this.updateAndNotify = function (v, render) {
            if (render === void 0) { render = true; }
            _this.prev = _this.current;
            _this.current = v;
            var _a = getFrameData(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                sync.postRender(_this.scheduleVelocityCheck);
            }
            if (_this.prev !== _this.current) {
                _this.updateSubscribers.notify(_this.current);
            }
            if (_this.velocityUpdateSubscribers.getSize()) {
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
            if (render) {
                _this.renderSubscribers.notify(_this.current);
            }
        };
        this.scheduleVelocityCheck = function () { return sync.postRender(_this.velocityCheck); };
        this.velocityCheck = function (_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = isFloat(this.current);
    }
    MotionValue.prototype.onChange = function (subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function () {
        this.updateSubscribers.clear();
    };
    MotionValue.prototype.onRenderRequest = function (subscription) {
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    MotionValue.prototype.attach = function (passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    MotionValue.prototype.set = function (v, render) {
        if (render === void 0) { render = true; }
        if (!render || !this.passiveEffect) {
            this.updateAndNotify(v, render);
        }
        else {
            this.passiveEffect(v, this.updateAndNotify);
        }
    };
    MotionValue.prototype.get = function () {
        return this.current;
    };
    MotionValue.prototype.getPrevious = function () {
        return this.prev;
    };
    MotionValue.prototype.getVelocity = function () {
        return this.canTrackVelocity
            ?
                velocityPerSecond(parseFloat(this.current) -
                    parseFloat(this.prev), this.timeDelta)
            : 0;
    };
    MotionValue.prototype.start = function (animation) {
        var _this = this;
        this.stop();
        return new Promise(function (resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function () { return _this.clearAnimation(); });
    };
    MotionValue.prototype.stop = function () {
        if (this.stopAnimation)
            this.stopAnimation();
        this.clearAnimation();
    };
    MotionValue.prototype.isAnimating = function () {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function () {
        this.stopAnimation = null;
    };
    MotionValue.prototype.destroy = function () {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}());
function motionValue(init) {
    return new MotionValue(init);
}

var isMotionValue = function (value) {
    return Boolean(value !== null && typeof value === "object" && value.getVelocity);
};

var secondsToMilliseconds = function (seconds) { return seconds * 1000; };

var easingLookup = {
    linear: linear$2,
    easeIn: easeIn,
    easeInOut: easeInOut,
    easeOut: easeOut,
    circIn: circIn,
    circInOut: circInOut,
    circOut: circOut,
    backIn: backIn,
    backInOut: backInOut,
    backOut: backOut,
    anticipate: anticipate,
    bounceIn: bounceIn,
    bounceInOut: bounceInOut,
    bounceOut: bounceOut,
};
var easingDefinitionToFunction = function (definition) {
    if (Array.isArray(definition)) {
        invariant(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = __read(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return cubicBezier(x1, y1, x2, y2);
    }
    else if (typeof definition === "string") {
        invariant(easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"));
        return easingLookup[definition];
    }
    return definition;
};
var isEasingArray = function (ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

var isAnimatable = function (key, value) {
    if (key === "zIndex")
        return false;
    if (typeof value === "number" || Array.isArray(value))
        return true;
    if (typeof value === "string" &&
        complex.test(value) &&
        !value.startsWith("url(")
    ) {
        return true;
    }
    return false;
};

var isKeyframesTarget = function (v) {
    return Array.isArray(v);
};

var underDampedSpring = function () { return ({
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10,
}); };
var criticallyDampedSpring = function (to) { return ({
    type: "spring",
    stiffness: 550,
    damping: to === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10,
}); };
var linearTween = function () { return ({
    type: "keyframes",
    ease: "linear",
    duration: 0.3,
}); };
var keyframes = function (values) { return ({
    type: "keyframes",
    duration: 0.8,
    values: values,
}); };
var defaultTransitions = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: criticallyDampedSpring,
    scaleY: criticallyDampedSpring,
    scale: criticallyDampedSpring,
    opacity: linearTween,
    backgroundColor: linearTween,
    color: linearTween,
    default: criticallyDampedSpring,
};
var getDefaultTransition = function (valueKey, to) {
    var transitionFactory;
    if (isKeyframesTarget(to)) {
        transitionFactory = keyframes;
    }
    else {
        transitionFactory =
            defaultTransitions[valueKey] || defaultTransitions.default;
    }
    return __assign$2({ to: to }, transitionFactory(to));
};

var int = __assign$2(__assign$2({}, number$2), { transform: Math.round });

var numberValueTypes = {
    borderWidth: px,
    borderTopWidth: px,
    borderRightWidth: px,
    borderBottomWidth: px,
    borderLeftWidth: px,
    borderRadius: px,
    radius: px,
    borderTopLeftRadius: px,
    borderTopRightRadius: px,
    borderBottomRightRadius: px,
    borderBottomLeftRadius: px,
    width: px,
    maxWidth: px,
    height: px,
    maxHeight: px,
    size: px,
    top: px,
    right: px,
    bottom: px,
    left: px,
    padding: px,
    paddingTop: px,
    paddingRight: px,
    paddingBottom: px,
    paddingLeft: px,
    margin: px,
    marginTop: px,
    marginRight: px,
    marginBottom: px,
    marginLeft: px,
    rotate: degrees,
    rotateX: degrees,
    rotateY: degrees,
    rotateZ: degrees,
    scale: scale,
    scaleX: scale,
    scaleY: scale,
    scaleZ: scale,
    skew: degrees,
    skewX: degrees,
    skewY: degrees,
    distance: px,
    translateX: px,
    translateY: px,
    translateZ: px,
    x: px,
    y: px,
    z: px,
    perspective: px,
    transformPerspective: px,
    opacity: alpha,
    originX: progressPercentage,
    originY: progressPercentage,
    originZ: px,
    zIndex: int,
    fillOpacity: alpha,
    strokeOpacity: alpha,
    numOctaves: int,
};

var defaultValueTypes = __assign$2(__assign$2({}, numberValueTypes), {
    color: color$1, backgroundColor: color$1, outlineColor: color$1, fill: color$1, stroke: color$1,
    borderColor: color$1, borderTopColor: color$1, borderRightColor: color$1, borderBottomColor: color$1, borderLeftColor: color$1, filter: filter$3, WebkitFilter: filter$3 });
var getDefaultValueType = function (key) { return defaultValueTypes[key]; };

function getAnimatableNone(key, value) {
    var _a;
    var defaultValueType = getDefaultValueType(key);
    if (defaultValueType !== filter$3)
        defaultValueType = complex;
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}

var instantAnimationState = {
    current: false,
};

var isCustomValue = function (v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var resolveFinalValueInKeyframes = function (v) {
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

function isTransitionDefined(_a) {
    _a.when; _a.delay; _a.delayChildren; _a.staggerChildren; _a.staggerDirection; _a.repeat; _a.repeatType; _a.repeatDelay; _a.from; var transition = __rest(_a, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
    return !!Object.keys(transition).length;
}
var legacyRepeatWarning = false;
function convertTransitionToAnimationOptions(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = __rest(_a, ["ease", "times", "yoyo", "flip", "loop"]);
    var options = __assign$2({}, transition);
    if (times)
        options["offset"] = times;
    if (transition.duration)
        options["duration"] = secondsToMilliseconds(transition.duration);
    if (transition.repeatDelay)
        options.repeatDelay = secondsToMilliseconds(transition.repeatDelay);
    if (ease) {
        options["ease"] = isEasingArray(ease)
            ? ease.map(easingDefinitionToFunction)
            : easingDefinitionToFunction(ease);
    }
    if (transition.type === "tween")
        options.type = "keyframes";
    if (yoyo || loop || flip) {
        warning$3(!legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        legacyRepeatWarning = true;
        if (yoyo) {
            options.repeatType = "reverse";
        }
        else if (loop) {
            options.repeatType = "loop";
        }
        else if (flip) {
            options.repeatType = "mirror";
        }
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    if (transition.type !== "spring")
        options.type = "keyframes";
    return options;
}
function getDelayFromTransition(transition, key) {
    var _a, _b;
    var valueTransition = getValueTransition(transition, key) || {};
    return (_b = (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : transition.delay) !== null && _b !== void 0 ? _b : 0;
}
function hydrateKeyframes(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = __spreadArray([], __read(options.to), false);
        options.to[0] = options.from;
    }
    return options;
}
function getPopmotionAnimationOptions(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) {
        (_a = transition.duration) !== null && _a !== void 0 ? _a : (transition.duration = 0.8);
    }
    hydrateKeyframes(options);
    if (!isTransitionDefined(transition)) {
        transition = __assign$2(__assign$2({}, transition), getDefaultTransition(key, options.to));
    }
    return __assign$2(__assign$2({}, options), convertTransitionToAnimationOptions(transition));
}
function getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = getValueTransition(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = isAnimatable(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") {
        origin = getAnimatableNone(key, target);
    }
    else if (isZero(origin) && typeof target === "string") {
        origin = getZeroUnit(target);
    }
    else if (!Array.isArray(target) &&
        isZero(target) &&
        typeof origin === "string") {
        target = getZeroUnit(origin);
    }
    var isOriginAnimatable = isAnimatable(key, origin);
    warning$3(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(key, " from \"").concat(origin, "\" to \"").concat(target, "\". ").concat(origin, " is not an animatable value - to enable this animation set ").concat(origin, " to a value animatable to ").concat(target, " via the `style` property."));
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function (v) { return value.set(v); },
        };
        return valueTransition.type === "inertia" ||
            valueTransition.type === "decay"
            ? inertia(__assign$2(__assign$2({}, options), valueTransition))
            : animate$1(__assign$2(__assign$2({}, getPopmotionAnimationOptions(valueTransition, options, key)), { onUpdate: function (v) {
                    var _a;
                    options.onUpdate(v);
                    (_a = valueTransition.onUpdate) === null || _a === void 0 ? void 0 : _a.call(valueTransition, v);
                }, onComplete: function () {
                    var _a;
                    options.onComplete();
                    (_a = valueTransition.onComplete) === null || _a === void 0 ? void 0 : _a.call(valueTransition);
                } }));
    }
    function set() {
        var _a, _b;
        var finalTarget = resolveFinalValueInKeyframes(target);
        value.set(finalTarget);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onUpdate) === null || _a === void 0 ? void 0 : _a.call(valueTransition, finalTarget);
        (_b = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _b === void 0 ? void 0 : _b.call(valueTransition);
        return { stop: function () { } };
    }
    return !isOriginAnimatable ||
        !isTargetAnimatable ||
        valueTransition.type === false
        ? set
        : start;
}
function isZero(value) {
    return (value === 0 ||
        (typeof value === "string" &&
            parseFloat(value) === 0 &&
            value.indexOf(" ") === -1));
}
function getZeroUnit(potentialUnitType) {
    return typeof potentialUnitType === "number"
        ? 0
        : getAnimatableNone("", potentialUnitType);
}
function getValueTransition(transition, key) {
    return transition[key] || transition["default"] || transition;
}
function startAnimation(key, value, target, transition) {
    if (transition === void 0) { transition = {}; }
    if (instantAnimationState.current) {
        transition = { type: false };
    }
    return value.start(function (onComplete) {
        var delayTimer;
        var controls;
        var animation = getAnimation(key, value, target, transition, onComplete);
        var delay = getDelayFromTransition(transition, key);
        var start = function () { return (controls = animation()); };
        if (delay) {
            delayTimer = setTimeout(start, secondsToMilliseconds(delay));
        }
        else {
            start();
        }
        return function () {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 ? void 0 : controls.stop();
        };
    });
}

function animate(from, to, transition) {
    if (transition === void 0) { transition = {}; }
    var value = isMotionValue(from) ? from : motionValue(from);
    startAnimation("", value, to, transition);
    return {
        stop: function () { return value.stop(); },
        isAnimating: function () { return value.isAnimating(); },
    };
}

var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
var numBorders = borders.length;
var asNumber = function (value) {
    return typeof value === "string" ? parseFloat(value) : value;
};
var isPx = function (value) {
    return typeof value === "number" || px.test(value);
};
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _a, _b, _c, _d;
    if (shouldCrossfadeOpacity) {
        target.opacity = mix(0,
        (_a = lead.opacity) !== null && _a !== void 0 ? _a : 1, easeCrossfadeIn(progress));
        target.opacityExit = mix((_b = follow.opacity) !== null && _b !== void 0 ? _b : 1, 0, easeCrossfadeOut(progress));
    }
    else if (isOnlyMember) {
        target.opacity = mix((_c = follow.opacity) !== null && _c !== void 0 ? _c : 1, (_d = lead.opacity) !== null && _d !== void 0 ? _d : 1, progress);
    }
    for (var i = 0; i < numBorders; i++) {
        var borderLabel = "border".concat(borders[i], "Radius");
        var followRadius = getRadius(follow, borderLabel);
        var leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined)
            continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        var canMix = followRadius === 0 ||
            leadRadius === 0 ||
            isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max(mix(asNumber(followRadius), asNumber(leadRadius), progress), 0);
            if (percent.test(leadRadius) || percent.test(followRadius)) {
                target[borderLabel] += "%";
            }
        }
        else {
            target[borderLabel] = leadRadius;
        }
    }
    if (follow.rotate || lead.rotate) {
        target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress);
    }
}
function getRadius(values, radiusName) {
    var _a;
    return (_a = values[radiusName]) !== null && _a !== void 0 ? _a : values.borderRadius;
}
var easeCrossfadeIn = compress(0, 0.5, circOut);
var easeCrossfadeOut = compress(0.5, 0.95, linear$2);
function compress(min, max, easing) {
    return function (p) {
        if (p < min)
            return 0;
        if (p > max)
            return 1;
        return easing(progress(min, max, p));
    };
}

function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}

function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale(_a) {
    var scale = _a.scale, scaleX = _a.scaleX, scaleY = _a.scaleY;
    return (!isIdentityScale(scale) ||
        !isIdentityScale(scaleX) ||
        !isIdentityScale(scaleY));
}
function hasTransform(values) {
    return (hasScale(values) ||
        hasTranslate(values.x) ||
        hasTranslate(values.y) ||
        values.z ||
        values.rotate ||
        values.rotateX ||
        values.rotateY);
}
function hasTranslate(value) {
    return value && value !== "0%";
}

function scalePoint(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) {
        point = scalePoint(point, boxScale, originPoint);
    }
    return scalePoint(point, scale, originPoint) + translate;
}
function applyAxisDelta(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) { translate = 0; }
    if (scale === void 0) { scale = 1; }
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
function applyBoxDelta(box, _a) {
    var x = _a.x, y = _a.y;
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition) {
    var _a, _b;
    if (isSharedTransition === void 0) { isSharedTransition = false; }
    var treeLength = treePath.length;
    if (!treeLength)
        return;
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for (var i = 0; i < treeLength; i++) {
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents")
            continue;
        if (isSharedTransition &&
            node.options.layoutScroll &&
            node.scroll &&
            node !== node.root) {
            transformBox(box, { x: -node.scroll.x, y: -node.scroll.y });
        }
        if (delta) {
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && hasTransform(node.latestValues)) {
            transformBox(box, node.latestValues);
        }
    }
}
function translateAxis(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
function transformAxis(axis, transforms, _a) {
    var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = mix(axis.min, axis.max, axisOrigin);
    applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
var xKeys$1 = ["x", "scaleX", "originX"];
var yKeys$1 = ["y", "scaleY", "originY"];
function transformBox(box, transform) {
    transformAxis(box.x, transform, xKeys$1);
    transformAxis(box.y, transform, yKeys$1);
}

function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target, maxDistance) {
    if (target === void 0) { target = 0; }
    if (maxDistance === void 0) { maxDistance = 0.01; }
    return distance(value, target) < maxDistance;
}
function calcAxisDelta(delta, source, target, origin) {
    if (origin === void 0) { origin = 0.5; }
    delta.origin = origin;
    delta.originPoint = mix(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    if (isNear(delta.scale, 1, 0.0001) || isNaN(delta.scale))
        delta.scale = 1;
    delta.translate =
        mix(target.min, target.max, delta.origin) - delta.originPoint;
    if (isNear(delta.translate) || isNaN(delta.translate))
        delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    calcAxisDelta(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
    calcRelativeAxis(target.x, relative.x, parent.x);
    calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y);
}

function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = scalePoint(point, 1 / scale, originPoint);
    if (boxScale !== undefined) {
        point = scalePoint(point, 1 / boxScale, originPoint);
    }
    return point;
}
function removeAxisDelta(axis, translate, scale, origin, boxScale, originAxis, sourceAxis) {
    if (translate === void 0) { translate = 0; }
    if (scale === void 0) { scale = 1; }
    if (origin === void 0) { origin = 0.5; }
    if (originAxis === void 0) { originAxis = axis; }
    if (sourceAxis === void 0) { sourceAxis = axis; }
    if (percent.test(translate)) {
        translate = parseFloat(translate);
        var relativeProgress = mix(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number")
        return;
    var originPoint = mix(originAxis.min, originAxis.max, origin);
    if (axis === originAxis)
        originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
function removeAxisTransforms(axis, transforms, _a, origin, sourceAxis) {
    var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    removeAxisTransforms(box.y, transforms, yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}

var createAxisDelta = function () { return ({
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0,
}); };
var createDelta = function () { return ({
    x: createAxisDelta(),
    y: createAxisDelta(),
}); };
var createAxis = function () { return ({ min: 0, max: 0 }); };
var createBox = function () { return ({
    x: createAxis(),
    y: createAxis(),
}); };

function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
    return (a.x.min === b.x.min &&
        a.x.max === b.x.max &&
        a.y.min === b.y.min &&
        a.y.max === b.y.max);
}

var NodeStack =  (function () {
    function NodeStack() {
        this.members = [];
    }
    NodeStack.prototype.add = function (node) {
        addUniqueItem(this.members, node);
        node.scheduleRender();
    };
    NodeStack.prototype.remove = function (node) {
        removeItem(this.members, node);
        if (node === this.prevLead) {
            this.prevLead = undefined;
        }
        if (node === this.lead) {
            var prevLead = this.members[this.members.length - 1];
            if (prevLead) {
                this.promote(prevLead);
            }
        }
    };
    NodeStack.prototype.relegate = function (node) {
        var indexOfNode = this.members.findIndex(function (member) { return node === member; });
        if (indexOfNode === 0)
            return false;
        var prevLead;
        for (var i = indexOfNode; i >= 0; i--) {
            var member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        }
        else {
            return false;
        }
    };
    NodeStack.prototype.promote = function (node, preserveFollowOpacity) {
        var _a;
        var prevLead = this.lead;
        if (node === prevLead)
            return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) {
                node.resumeFrom.preserveOpacity = true;
            }
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues =
                    prevLead.animationValues || prevLead.latestValues;
                node.snapshot.isShared = true;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) {
                node.isLayoutDirty = true;
            }
            var crossfade = node.options.crossfade;
            if (crossfade === false) {
                prevLead.hide();
            }
        }
    };
    NodeStack.prototype.exitAnimationComplete = function () {
        this.members.forEach(function (node) {
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 ? void 0 : _e.call(_d);
        });
    };
    NodeStack.prototype.scheduleRender = function () {
        this.members.forEach(function (node) {
            node.instance && node.scheduleRender(false);
        });
    };
    NodeStack.prototype.removeLeadSnapshot = function () {
        if (this.lead && this.lead.snapshot) {
            this.lead.snapshot = undefined;
        }
    };
    return NodeStack;
}());

var scaleCorrectors = {};
function addScaleCorrector(correctors) {
    Object.assign(scaleCorrectors, correctors);
}

var identityProjection = "translate3d(0px, 0px, 0) scale(1, 1)";
function buildProjectionTransform(delta, treeScale, latestTransform) {
    var xTranslate = delta.x.translate / treeScale.x;
    var yTranslate = delta.y.translate / treeScale.y;
    var transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, 0) ");
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate)
            transform += "rotate(".concat(rotate, "deg) ");
        if (rotateX)
            transform += "rotateX(".concat(rotateX, "deg) ");
        if (rotateY)
            transform += "rotateY(".concat(rotateY, "deg) ");
    }
    transform += "scale(".concat(delta.x.scale, ", ").concat(delta.y.scale, ")");
    return transform === identityProjection ? "none" : transform;
}

function eachAxis(callback) {
    return [callback("x"), callback("y")];
}

var transformAxes = ["", "X", "Y", "Z"];
var order = ["translate", "scale", "rotate", "skew"];
var transformProps = ["transformPerspective", "x", "y", "z"];
order.forEach(function (operationKey) {
    return transformAxes.forEach(function (axesKey) {
        return transformProps.push(operationKey + axesKey);
    });
});
function sortTransformProps(a, b) {
    return transformProps.indexOf(a) - transformProps.indexOf(b);
}
var transformPropSet = new Set(transformProps);
function isTransformProp(key) {
    return transformPropSet.has(key);
}
var transformOriginProps = new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp(key) {
    return transformOriginProps.has(key);
}

var compareByDepth = function (a, b) {
    return a.depth - b.depth;
};

var FlatTree =  (function () {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function (child) {
        addUniqueItem(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function (child) {
        removeItem(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function (callback) {
        this.isDirty && this.children.sort(compareByDepth);
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}());

function resolveMotionValue(value) {
    var unwrappedValue = isMotionValue(value) ? value.get() : value;
    return isCustomValue(unwrappedValue)
        ? unwrappedValue.toValue()
        : unwrappedValue;
}

var animationTarget = 1000;
var globalProjectionState = {
    hasAnimatedSinceResize: true,
    hasEverUpdated: false,
};
function createProjectionNode(_a) {
    var attachResizeListener = _a.attachResizeListener, defaultParent = _a.defaultParent, measureScroll = _a.measureScroll, resetTransform = _a.resetTransform;
    return  (function () {
        function ProjectionNode(id, latestValues, parent) {
            var _this = this;
            if (latestValues === void 0) { latestValues = {}; }
            if (parent === void 0) { parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent(); }
            this.children = new Set();
            this.options = {};
            this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            this.isLayoutDirty = false;
            this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            this.isUpdating = false;
            this.isSVG = false;
            this.needsReset = false;
            this.shouldResetTransform = false;
            this.treeScale = { x: 1, y: 1 };
            this.eventHandlers = new Map();
            this.potentialNodes = new Map();
            this.checkUpdateFailed = function () {
                if (_this.isUpdating) {
                    _this.isUpdating = false;
                    _this.clearAllSnapshots();
                }
            };
            this.updateProjection = function () {
                _this.nodes.forEach(resolveTargetDelta);
                _this.nodes.forEach(calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            this.sharedNodes = new Map();
            this.id = id;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? __spreadArray(__spreadArray([], __read(parent.path), false), [parent], false) : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            id && this.root.registerPotentialNode(id, this);
            for (var i = 0; i < this.path.length; i++) {
                this.path[i].shouldResetTransform = true;
            }
            if (this.root === this)
                this.nodes = new FlatTree();
        }
        ProjectionNode.prototype.addEventListener = function (name, handler) {
            if (!this.eventHandlers.has(name)) {
                this.eventHandlers.set(name, new SubscriptionManager());
            }
            return this.eventHandlers.get(name).add(handler);
        };
        ProjectionNode.prototype.notifyListeners = function (name) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 ? void 0 : subscriptionManager.notify.apply(subscriptionManager, __spreadArray([], __read(args), false));
        };
        ProjectionNode.prototype.hasListeners = function (name) {
            return this.eventHandlers.has(name);
        };
        ProjectionNode.prototype.registerPotentialNode = function (id, node) {
            this.potentialNodes.set(id, node);
        };
        ProjectionNode.prototype.mount = function (instance, isLayoutDirty) {
            var _this = this;
            var _a;
            if (isLayoutDirty === void 0) { isLayoutDirty = false; }
            if (this.instance)
                return;
            this.isSVG =
                instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            var _b = this.options, layoutId = _b.layoutId, layout = _b.layout, visualElement = _b.visualElement;
            if (visualElement && !visualElement.getInstance()) {
                visualElement.mount(instance);
            }
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 ? void 0 : _a.children.add(this);
            this.id && this.root.potentialNodes.delete(this.id);
            if (isLayoutDirty && (layout || layoutId)) {
                this.isLayoutDirty = true;
            }
            if (attachResizeListener) {
                var unblockTimeout_1;
                var resizeUnblockUpdate_1 = function () {
                    return (_this.root.updateBlockedByResize = false);
                };
                attachResizeListener(instance, function () {
                    _this.root.updateBlockedByResize = true;
                    clearTimeout(unblockTimeout_1);
                    unblockTimeout_1 = setTimeout(resizeUnblockUpdate_1, 250);
                    if (globalProjectionState.hasAnimatedSinceResize) {
                        globalProjectionState.hasAnimatedSinceResize = false;
                        _this.nodes.forEach(finishAnimation);
                    }
                });
            }
            if (layoutId) {
                this.root.registerSharedNode(layoutId, this);
            }
            if (this.options.animate !== false &&
                visualElement &&
                (layoutId || layout)) {
                this.addEventListener("didUpdate", function (_a) {
                    var _b, _c, _d, _e, _f;
                    var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged, hasRelativeTargetChanged = _a.hasRelativeTargetChanged, newLayout = _a.layout;
                    if (_this.isTreeAnimationBlocked()) {
                        _this.target = undefined;
                        _this.relativeTarget = undefined;
                        return;
                    }
                    var layoutTransition = (_c = (_b = _this.options.transition) !== null && _b !== void 0 ? _b : visualElement.getDefaultTransition()) !== null && _c !== void 0 ? _c : defaultLayoutTransition;
                    var onLayoutAnimationComplete = visualElement.getProps().onLayoutAnimationComplete;
                    var targetChanged = !_this.targetLayout ||
                        !boxEquals(_this.targetLayout, newLayout) ||
                        hasRelativeTargetChanged;
                    var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                    if (((_d = _this.resumeFrom) === null || _d === void 0 ? void 0 : _d.instance) ||
                        hasOnlyRelativeTargetChanged ||
                        (hasLayoutChanged &&
                            (targetChanged || !_this.currentAnimation))) {
                        if (_this.resumeFrom) {
                            _this.resumingFrom = _this.resumeFrom;
                            _this.resumingFrom.resumingFrom = undefined;
                        }
                        _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                        _this.startAnimation(__assign$2(__assign$2({}, getValueTransition(layoutTransition, "layout")), { onComplete: onLayoutAnimationComplete }));
                    }
                    else {
                        _this.isLead() && ((_f = (_e = _this.options).onExitComplete) === null || _f === void 0 ? void 0 : _f.call(_e));
                    }
                    _this.targetLayout = newLayout;
                });
            }
        };
        ProjectionNode.prototype.unmount = function () {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.remove(this);
            (_b = this.parent) === null || _b === void 0 ? void 0 : _b.children.delete(this);
            this.instance = undefined;
            cancelSync.preRender(this.updateProjection);
        };
        ProjectionNode.prototype.blockUpdate = function () {
            this.updateManuallyBlocked = true;
        };
        ProjectionNode.prototype.unblockUpdate = function () {
            this.updateManuallyBlocked = false;
        };
        ProjectionNode.prototype.isUpdateBlocked = function () {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        };
        ProjectionNode.prototype.isTreeAnimationBlocked = function () {
            var _a;
            return (this.isAnimationBlocked ||
                ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) ||
                false);
        };
        ProjectionNode.prototype.startUpdate = function () {
            var _a;
            if (this.isUpdateBlocked())
                return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 ? void 0 : _a.forEach(resetRotation);
        };
        ProjectionNode.prototype.willUpdate = function (shouldNotifyListeners) {
            var _a, _b, _c;
            if (shouldNotifyListeners === void 0) { shouldNotifyListeners = true; }
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty)
                return;
            this.isLayoutDirty = true;
            for (var i = 0; i < this.path.length; i++) {
                var node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll();
            }
            var _d = this.options, layoutId = _d.layoutId, layout = _d.layout;
            if (layoutId === undefined && !layout)
                return;
            var transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        };
        ProjectionNode.prototype.didUpdate = function () {
            var updateWasBlocked = this.isUpdateBlocked();
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach(clearMeasurements);
                return;
            }
            if (!this.isUpdating)
                return;
            this.isUpdating = false;
            if (this.potentialNodes.size) {
                this.potentialNodes.forEach(mountNodeEarly);
                this.potentialNodes.clear();
            }
            this.nodes.forEach(resetTransformStyle);
            this.nodes.forEach(updateLayout);
            this.nodes.forEach(notifyLayoutUpdate);
            this.clearAllSnapshots();
            flushSync.update();
            flushSync.preRender();
            flushSync.render();
        };
        ProjectionNode.prototype.clearAllSnapshots = function () {
            this.nodes.forEach(clearSnapshot);
            this.sharedNodes.forEach(removeLeadSnapshots);
        };
        ProjectionNode.prototype.scheduleUpdateProjection = function () {
            sync.preRender(this.updateProjection, false, true);
        };
        ProjectionNode.prototype.scheduleCheckAfterUnmount = function () {
            var _this = this;
            sync.postRender(function () {
                if (_this.isLayoutDirty) {
                    _this.root.didUpdate();
                }
                else {
                    _this.root.checkUpdateFailed();
                }
            });
        };
        ProjectionNode.prototype.updateSnapshot = function () {
            if (this.snapshot || !this.instance)
                return;
            var measured = this.measure();
            var layout = this.removeTransform(this.removeElementScroll(measured));
            roundBox(layout);
            this.snapshot = {
                measured: measured,
                layout: layout,
                latestValues: {},
            };
        };
        ProjectionNode.prototype.updateLayout = function () {
            var _a;
            if (!this.instance)
                return;
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) &&
                !this.isLayoutDirty) {
                return;
            }
            if (this.resumeFrom && !this.resumeFrom.instance) {
                for (var i = 0; i < this.path.length; i++) {
                    var node = this.path[i];
                    node.updateScroll();
                }
            }
            var measured = this.measure();
            roundBox(measured);
            var prevLayout = this.layout;
            this.layout = {
                measured: measured,
                actual: this.removeElementScroll(measured),
            };
            this.layoutCorrected = createBox();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.actual);
            (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.notifyLayoutMeasure(this.layout.actual, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.actual);
        };
        ProjectionNode.prototype.updateScroll = function () {
            if (this.options.layoutScroll && this.instance) {
                this.scroll = measureScroll(this.instance);
            }
        };
        ProjectionNode.prototype.resetTransform = function () {
            var _a;
            if (!resetTransform)
                return;
            var isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            var hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            var transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested &&
                (hasProjection ||
                    hasTransform(this.latestValues) ||
                    transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        };
        ProjectionNode.prototype.measure = function () {
            var visualElement = this.options.visualElement;
            if (!visualElement)
                return createBox();
            var box = visualElement.measureViewportBox();
            var scroll = this.root.scroll;
            if (scroll) {
                translateAxis(box.x, scroll.x);
                translateAxis(box.y, scroll.y);
            }
            return box;
        };
        ProjectionNode.prototype.removeElementScroll = function (box) {
            var boxWithoutScroll = createBox();
            copyBoxInto(boxWithoutScroll, box);
            for (var i = 0; i < this.path.length; i++) {
                var node = this.path[i];
                var scroll_1 = node.scroll, options = node.options;
                if (node !== this.root && scroll_1 && options.layoutScroll) {
                    translateAxis(boxWithoutScroll.x, scroll_1.x);
                    translateAxis(boxWithoutScroll.y, scroll_1.y);
                }
            }
            return boxWithoutScroll;
        };
        ProjectionNode.prototype.applyTransform = function (box, transformOnly) {
            if (transformOnly === void 0) { transformOnly = false; }
            var withTransforms = createBox();
            copyBoxInto(withTransforms, box);
            for (var i = 0; i < this.path.length; i++) {
                var node = this.path[i];
                if (!transformOnly &&
                    node.options.layoutScroll &&
                    node.scroll &&
                    node !== node.root) {
                    transformBox(withTransforms, {
                        x: -node.scroll.x,
                        y: -node.scroll.y,
                    });
                }
                if (!hasTransform(node.latestValues))
                    continue;
                transformBox(withTransforms, node.latestValues);
            }
            if (hasTransform(this.latestValues)) {
                transformBox(withTransforms, this.latestValues);
            }
            return withTransforms;
        };
        ProjectionNode.prototype.removeTransform = function (box) {
            var _a;
            var boxWithoutTransform = createBox();
            copyBoxInto(boxWithoutTransform, box);
            for (var i = 0; i < this.path.length; i++) {
                var node = this.path[i];
                if (!node.instance)
                    continue;
                if (!hasTransform(node.latestValues))
                    continue;
                hasScale(node.latestValues) && node.updateSnapshot();
                var sourceBox = createBox();
                var nodeBox = node.measure();
                copyBoxInto(sourceBox, nodeBox);
                removeBoxTransforms(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layout, sourceBox);
            }
            if (hasTransform(this.latestValues)) {
                removeBoxTransforms(boxWithoutTransform, this.latestValues);
            }
            return boxWithoutTransform;
        };
        ProjectionNode.prototype.setTargetDelta = function (delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
        };
        ProjectionNode.prototype.setOptions = function (options) {
            var _a;
            this.options = __assign$2(__assign$2(__assign$2({}, this.options), options), { crossfade: (_a = options.crossfade) !== null && _a !== void 0 ? _a : true });
        };
        ProjectionNode.prototype.clearMeasurements = function () {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        };
        ProjectionNode.prototype.resolveTargetDelta = function () {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            if (!this.layout || !(layout || layoutId))
                return;
            if (!this.targetDelta && !this.relativeTarget) {
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && this.relativeParent.layout) {
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
            if (!this.relativeTarget && !this.targetDelta)
                return;
            if (!this.target) {
                this.target = createBox();
                this.targetWithTransforms = createBox();
            }
            if (this.relativeTarget &&
                this.relativeTargetOrigin &&
                ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) {
                calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
            }
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) {
                    this.target = this.applyTransform(this.layout.actual);
                }
                else {
                    copyBoxInto(this.target, this.layout.actual);
                }
                applyBoxDelta(this.target, this.targetDelta);
            }
            else {
                copyBoxInto(this.target, this.layout.actual);
            }
            if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent &&
                    Boolean(this.relativeParent.resumingFrom) ===
                        Boolean(this.resumingFrom) &&
                    !this.relativeParent.options.layoutScroll &&
                    this.relativeParent.target) {
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.target, this.relativeParent.target);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
        };
        ProjectionNode.prototype.getClosestProjectingParent = function () {
            if (!this.parent || hasTransform(this.parent.latestValues))
                return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) &&
                this.parent.layout) {
                return this.parent;
            }
            else {
                return this.parent.getClosestProjectingParent();
            }
        };
        ProjectionNode.prototype.calcProjection = function () {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) ||
                this.currentAnimation ||
                this.pendingAnimation);
            if (!this.isTreeAnimating) {
                this.targetDelta = this.relativeTarget = undefined;
            }
            if (!this.layout || !(layout || layoutId))
                return;
            var lead = this.getLead();
            copyBoxInto(this.layoutCorrected, this.layout.actual);
            applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, Boolean(this.resumingFrom) || this !== lead);
            var target = lead.target;
            if (!target)
                return;
            if (!this.projectionDelta) {
                this.projectionDelta = createDelta();
                this.projectionDeltaWithTransform = createDelta();
            }
            var prevTreeScaleX = this.treeScale.x;
            var prevTreeScaleY = this.treeScale.y;
            var prevProjectionTransform = this.projectionTransform;
            calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform ||
                this.treeScale.x !== prevTreeScaleX ||
                this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        };
        ProjectionNode.prototype.hide = function () {
            this.isVisible = false;
        };
        ProjectionNode.prototype.show = function () {
            this.isVisible = true;
        };
        ProjectionNode.prototype.scheduleRender = function (notifyAll) {
            var _a, _b, _c;
            if (notifyAll === void 0) { notifyAll = true; }
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 ? void 0 : _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 ? void 0 : _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) {
                this.resumingFrom = undefined;
            }
        };
        ProjectionNode.prototype.setAnimationOrigin = function (delta, hasOnlyRelativeTargetChanged) {
            var _this = this;
            var _a;
            if (hasOnlyRelativeTargetChanged === void 0) { hasOnlyRelativeTargetChanged = false; }
            var snapshot = this.snapshot;
            var snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            var mixedValues = __assign$2({}, this.latestValues);
            var targetDelta = createDelta();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            var relativeLayout = createBox();
            var isSharedLayoutAnimation = snapshot === null || snapshot === void 0 ? void 0 : snapshot.isShared;
            var isOnlyMember = (((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.members.length) || 0) <= 1;
            var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation &&
                !isOnlyMember &&
                this.options.crossfade === true &&
                !this.path.some(hasOpacityCrossfade));
            this.mixTargetDelta = function (latest) {
                var _a;
                var progress = latest / 1000;
                mixAxisDelta(targetDelta.x, delta.x, progress);
                mixAxisDelta(targetDelta.y, delta.y, progress);
                _this.setTargetDelta(targetDelta);
                if (_this.relativeTarget &&
                    _this.relativeTargetOrigin &&
                    _this.layout &&
                    ((_a = _this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    calcRelativePosition(relativeLayout, _this.layout.actual, _this.relativeParent.layout.actual);
                    mixBox(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    _this.animationValues = mixedValues;
                    mixValues(mixedValues, snapshotLatestValues, _this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                _this.root.scheduleUpdateProjection();
                _this.scheduleRender();
            };
            this.mixTargetDelta(0);
        };
        ProjectionNode.prototype.startAnimation = function (options) {
            var _this = this;
            var _a, _b;
            (_a = this.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            if (this.resumingFrom) {
                (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 ? void 0 : _b.stop();
            }
            if (this.pendingAnimation) {
                cancelSync.update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            this.pendingAnimation = sync.update(function () {
                globalProjectionState.hasAnimatedSinceResize = true;
                _this.currentAnimation = animate(0, animationTarget, __assign$2(__assign$2({}, options), { onUpdate: function (latest) {
                        var _a;
                        _this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, latest);
                    }, onComplete: function () {
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 ? void 0 : _a.call(options);
                        _this.completeAnimation();
                    } }));
                if (_this.resumingFrom) {
                    _this.resumingFrom.currentAnimation = _this.currentAnimation;
                }
                _this.pendingAnimation = undefined;
            });
        };
        ProjectionNode.prototype.completeAnimation = function () {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.exitAnimationComplete();
            this.resumingFrom =
                this.currentAnimation =
                    this.animationValues =
                        undefined;
            this.notifyListeners("animationComplete");
        };
        ProjectionNode.prototype.finishAnimation = function () {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 ? void 0 : _a.call(this, animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        };
        ProjectionNode.prototype.applyTransformsToTarget = function () {
            var _a = this.getLead(), targetWithTransforms = _a.targetWithTransforms, target = _a.target, layout = _a.layout, latestValues = _a.latestValues;
            if (!targetWithTransforms || !target || !layout)
                return;
            copyBoxInto(targetWithTransforms, target);
            transformBox(targetWithTransforms, latestValues);
            calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        };
        ProjectionNode.prototype.registerSharedNode = function (layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) {
                this.sharedNodes.set(layoutId, new NodeStack());
            }
            var stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node),
            });
        };
        ProjectionNode.prototype.isLead = function () {
            var stack = this.getStack();
            return stack ? stack.lead === this : true;
        };
        ProjectionNode.prototype.getLead = function () {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        };
        ProjectionNode.prototype.getPrevLead = function () {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        };
        ProjectionNode.prototype.getStack = function () {
            var layoutId = this.options.layoutId;
            if (layoutId)
                return this.root.sharedNodes.get(layoutId);
        };
        ProjectionNode.prototype.promote = function (_a) {
            var _b = _a === void 0 ? {} : _a, needsReset = _b.needsReset, transition = _b.transition, preserveFollowOpacity = _b.preserveFollowOpacity;
            var stack = this.getStack();
            if (stack)
                stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition)
                this.setOptions({ transition: transition });
        };
        ProjectionNode.prototype.relegate = function () {
            var stack = this.getStack();
            if (stack) {
                return stack.relegate(this);
            }
            else {
                return false;
            }
        };
        ProjectionNode.prototype.resetRotation = function () {
            var visualElement = this.options.visualElement;
            if (!visualElement)
                return;
            var hasRotate = false;
            var resetValues = {};
            for (var i = 0; i < transformAxes.length; i++) {
                var axis = transformAxes[i];
                var key = "rotate" + axis;
                if (!visualElement.getStaticValue(key)) {
                    continue;
                }
                hasRotate = true;
                resetValues[key] = visualElement.getStaticValue(key);
                visualElement.setStaticValue(key, 0);
            }
            if (!hasRotate)
                return;
            visualElement === null || visualElement === void 0 ? void 0 : visualElement.syncRender();
            for (var key in resetValues) {
                visualElement.setStaticValue(key, resetValues[key]);
            }
            visualElement.scheduleRender();
        };
        ProjectionNode.prototype.getProjectionStyles = function (styleProp) {
            var _a, _b, _c, _d, _e, _f;
            if (styleProp === void 0) { styleProp = {}; }
            var styles = {};
            if (!this.instance || this.isSVG)
                return styles;
            if (!this.isVisible) {
                return { visibility: "hidden" };
            }
            else {
                styles.visibility = "";
            }
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents =
                    resolveMotionValue(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate
                    ? transformTemplate(this.latestValues, "")
                    : "none";
                return styles;
            }
            var lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                var emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = (_b = this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1;
                    emptyStyles.pointerEvents =
                        resolveMotionValue(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !hasTransform(this.latestValues)) {
                    emptyStyles.transform = transformTemplate
                        ? transformTemplate({}, "")
                        : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            var valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) {
                styles.transform = transformTemplate(valuesToRender, styles.transform);
            }
            var _g = this.projectionDelta, x = _g.x, y = _g.y;
            styles.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
            if (lead.animationValues) {
                styles.opacity =
                    lead === this
                        ? (_d = (_c = valuesToRender.opacity) !== null && _c !== void 0 ? _c : this.latestValues.opacity) !== null && _d !== void 0 ? _d : 1
                        : this.preserveOpacity
                            ? this.latestValues.opacity
                            : valuesToRender.opacityExit;
            }
            else {
                styles.opacity =
                    lead === this
                        ? (_e = valuesToRender.opacity) !== null && _e !== void 0 ? _e : ""
                        : (_f = valuesToRender.opacityExit) !== null && _f !== void 0 ? _f : 0;
            }
            for (var key in scaleCorrectors) {
                if (valuesToRender[key] === undefined)
                    continue;
                var _h = scaleCorrectors[key], correct = _h.correct, applyTo = _h.applyTo;
                var corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    var num = applyTo.length;
                    for (var i = 0; i < num; i++) {
                        styles[applyTo[i]] = corrected;
                    }
                }
                else {
                    styles[key] = corrected;
                }
            }
            if (this.options.layoutId) {
                styles.pointerEvents =
                    lead === this
                        ? resolveMotionValue(styleProp.pointerEvents) || ""
                        : "none";
            }
            return styles;
        };
        ProjectionNode.prototype.clearSnapshot = function () {
            this.resumeFrom = this.snapshot = undefined;
        };
        ProjectionNode.prototype.resetTree = function () {
            this.root.nodes.forEach(function (node) { var _a; return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop(); });
            this.root.nodes.forEach(clearMeasurements);
            this.root.sharedNodes.clear();
        };
        return ProjectionNode;
    }());
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    var _a, _b, _c, _d;
    var snapshot = (_b = (_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) !== null && _b !== void 0 ? _b : node.snapshot;
    if (node.isLead() &&
        node.layout &&
        snapshot &&
        node.hasListeners("didUpdate")) {
        var _e = node.layout, layout_1 = _e.actual, measuredLayout = _e.measured;
        if (node.options.animationType === "size") {
            eachAxis(function (axis) {
                var axisSnapshot = snapshot.isShared
                    ? snapshot.measured[axis]
                    : snapshot.layout[axis];
                var length = calcLength(axisSnapshot);
                axisSnapshot.min = layout_1[axis].min;
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        else if (node.options.animationType === "position") {
            eachAxis(function (axis) {
                var axisSnapshot = snapshot.isShared
                    ? snapshot.measured[axis]
                    : snapshot.layout[axis];
                var length = calcLength(layout_1[axis]);
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        var layoutDelta = createDelta();
        calcBoxDelta(layoutDelta, layout_1, snapshot.layout);
        var visualDelta = createDelta();
        if (snapshot.isShared) {
            calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measured);
        }
        else {
            calcBoxDelta(visualDelta, layout_1, snapshot.layout);
        }
        var hasLayoutChanged = !isDeltaZero(layoutDelta);
        var hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            node.relativeParent = node.getClosestProjectingParent();
            if (node.relativeParent && !node.relativeParent.resumeFrom) {
                var _f = node.relativeParent, parentSnapshot = _f.snapshot, parentLayout = _f.layout;
                if (parentSnapshot && parentLayout) {
                    var relativeSnapshot = createBox();
                    calcRelativePosition(relativeSnapshot, snapshot.layout, parentSnapshot.layout);
                    var relativeLayout = createBox();
                    calcRelativePosition(relativeLayout, layout_1, parentLayout.actual);
                    if (!boxEquals(relativeSnapshot, relativeLayout)) {
                        hasRelativeTargetChanged = true;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout_1,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged,
        });
    }
    else if (node.isLead()) {
        (_d = (_c = node.options).onExitComplete) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
    node.options.transition = undefined;
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function resetTransformStyle(node) {
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetRotation(node) {
    node.resetRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = mix(delta.translate, 0, p);
    output.scale = mix(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = mix(from.min, to.min, p);
    output.max = mix(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return (node.animationValues && node.animationValues.opacityExit !== undefined);
}
var defaultLayoutTransition = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1],
};
function mountNodeEarly(node, id) {
    var searchNode = node.root;
    for (var i = node.path.length - 1; i >= 0; i--) {
        if (Boolean(node.path[i].instance)) {
            searchNode = node.path[i];
            break;
        }
    }
    var searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    var element = searchElement.querySelector("[data-projection-id=\"".concat(id, "\"]"));
    if (element)
        node.mount(element, true);
}
function roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}

var id = 1;
function useProjectionId() {
    return useConstant(function () {
        if (globalProjectionState.hasEverUpdated) {
            return id++;
        }
    });
}

var LayoutGroupContext = createContext({});

var SwitchLayoutGroupContext = createContext({});

function useProjection(projectionId, _a, visualElement, ProjectionNodeConstructor) {
    var _b;
    var layoutId = _a.layoutId, layout = _a.layout, drag = _a.drag, dragConstraints = _a.dragConstraints, layoutScroll = _a.layoutScroll;
    var initialPromotionConfig = useContext(SwitchLayoutGroupContext);
    if (!ProjectionNodeConstructor ||
        !visualElement ||
        (visualElement === null || visualElement === void 0 ? void 0 : visualElement.projection)) {
        return;
    }
    visualElement.projection = new ProjectionNodeConstructor(projectionId, visualElement.getLatestValues(), (_b = visualElement.parent) === null || _b === void 0 ? void 0 : _b.projection);
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || (dragConstraints && isRefObject(dragConstraints)),
        visualElement: visualElement,
        scheduleRender: function () { return visualElement.scheduleRender(); },
        animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
    });
}

var VisualElementHandler =  (function (_super) {
    __extends(VisualElementHandler, _super);
    function VisualElementHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VisualElementHandler.prototype.getSnapshotBeforeUpdate = function () {
        this.updateProps();
        return null;
    };
    VisualElementHandler.prototype.componentDidUpdate = function () { };
    VisualElementHandler.prototype.updateProps = function () {
        var _a = this.props, visualElement = _a.visualElement, props = _a.props;
        if (visualElement)
            visualElement.setProps(props);
    };
    VisualElementHandler.prototype.render = function () {
        return this.props.children;
    };
    return VisualElementHandler;
}(React__default.Component));

function createMotionComponent(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, projectionNodeConstructor = _a.projectionNodeConstructor, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && loadFeatures(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        var layoutId = useLayoutId(props);
        props = __assign$2(__assign$2({}, props), { layoutId: layoutId });
        var config = useContext(MotionConfigContext);
        var features = null;
        var context = useCreateMotionContext(props);
        var projectionId = config.isStatic ? undefined : useProjectionId();
        var visualState = useVisualState(props, config.isStatic);
        if (!config.isStatic && isBrowser) {
            context.visualElement = useVisualElement(Component, visualState, __assign$2(__assign$2({}, config), props), createVisualElement);
            useProjection(projectionId, props, context.visualElement, projectionNodeConstructor ||
                featureDefinitions.projectionNodeConstructor);
            features = useFeatures(props, context.visualElement, preloadedFeatures);
        }
        return (React$4.createElement(VisualElementHandler, { visualElement: context.visualElement, props: __assign$2(__assign$2({}, config), props) },
            features,
            React$4.createElement(MotionContext.Provider, { value: context }, useRender(Component, props, projectionId, useMotionRef(visualState, context.visualElement, externalRef), visualState, config.isStatic, context.visualElement))));
    }
    return forwardRef(MotionComponent);
}
function useLayoutId(_a) {
    var _b;
    var layoutId = _a.layoutId;
    var layoutGroupId = (_b = useContext(LayoutGroupContext)) === null || _b === void 0 ? void 0 : _b.id;
    return layoutGroupId && layoutId !== undefined
        ? layoutGroupId + "-" + layoutId
        : layoutId;
}

function createMotionProxy(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) { customMotionComponentConfig = {}; }
        return createMotionComponent(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") {
        return custom;
    }
    var componentCache = new Map();
    return new Proxy(custom, {
        get: function (_target, key) {
            if (!componentCache.has(key)) {
                componentCache.set(key, custom(key));
            }
            return componentCache.get(key);
        },
    });
}

var lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view",
];

function isSVGComponent(Component) {
    if (
    typeof Component !== "string" ||
        Component.includes("-")) {
        return false;
    }
    else if (
    lowercaseSVGElements.indexOf(Component) > -1 ||
        /[A-Z]/.test(Component)) {
        return true;
    }
    return false;
}

function isForcedMotionValue(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (isTransformProp(key) ||
        isTransformOriginProp(key) ||
        ((layout || layoutId !== undefined) &&
            (!!scaleCorrectors[key] || key === "opacity")));
}

var translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
};
function buildTransform(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    var transformString = "";
    transformKeys.sort(sortTransformProps);
    var transformHasZ = false;
    var numTransformKeys = transformKeys.length;
    for (var i = 0; i < numTransformKeys; i++) {
        var key = transformKeys[i];
        transformString += "".concat(translateAlias[key] || key, "(").concat(transform[key], ") ");
        if (key === "z")
            transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) {
        transformString += "translateZ(0)";
    }
    else {
        transformString = transformString.trim();
    }
    if (transformTemplate) {
        transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    }
    else if (allowTransformNone && transformIsDefault) {
        transformString = "none";
    }
    return transformString;
}
function buildTransformOrigin(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return "".concat(originX, " ").concat(originY, " ").concat(originZ);
}

function isCSSVariable$1(key) {
    return key.startsWith("--");
}

var getValueAsType = function (value, type) {
    return type && typeof value === "number"
        ? type.transform(value)
        : value;
};

function buildHTMLStyles(state, latestValues, options, transformTemplate) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    transformKeys.length = 0;
    var hasTransform = false;
    var hasTransformOrigin = false;
    var transformIsNone = true;
    for (var key in latestValues) {
        var value = latestValues[key];
        if (isCSSVariable$1(key)) {
            vars[key] = value;
            continue;
        }
        var valueType = numberValueTypes[key];
        var valueAsType = getValueAsType(value, valueType);
        if (isTransformProp(key)) {
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            if (!transformIsNone)
                continue;
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0))
                transformIsNone = false;
        }
        else if (isTransformOriginProp(key)) {
            transformOrigin[key] = valueAsType;
            hasTransformOrigin = true;
        }
        else {
            style[key] = valueAsType;
        }
    }
    if (hasTransform) {
        style.transform = buildTransform(state, options, transformIsNone, transformTemplate);
    }
    else if (transformTemplate) {
        style.transform = transformTemplate({}, "");
    }
    else if (!latestValues.transform && style.transform) {
        style.transform = "none";
    }
    if (hasTransformOrigin) {
        style.transformOrigin = buildTransformOrigin(transformOrigin);
    }
}

var createHtmlRenderState = function () { return ({
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {},
}); };

function copyRawValuesOnly(target, source, props) {
    for (var key in source) {
        if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
            target[key] = source[key];
        }
    }
}
function useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return useMemo(function () {
        var state = createHtmlRenderState();
        buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
        var vars = state.vars, style = state.style;
        return __assign$2(__assign$2({}, vars), style);
    }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) {
        style = props.transformValues(style);
    }
    return style;
}
function useHTMLProps(props, visualState, isStatic) {
    var htmlProps = {};
    var style = useStyle(props, visualState, isStatic);
    if (Boolean(props.drag) && props.dragListener !== false) {
        htmlProps.draggable = false;
        style.userSelect =
            style.WebkitUserSelect =
                style.WebkitTouchCallout =
                    "none";
        style.touchAction =
            props.drag === true
                ? "none"
                : "pan-".concat(props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}

var validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover",
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport",
    "layoutScroll",
]);
function isValidMotionProp(key) {
    return validMotionProps.has(key);
}

var shouldForward = function (key) { return !isValidMotionProp(key); };
function loadExternalIsValidProp(isValidProp) {
    if (!isValidProp)
        return;
    shouldForward = function (key) {
        return key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
    };
}
try {
    loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
}
catch (_a) {
}
function filterProps(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for (var key in props) {
        if (shouldForward(key) ||
            (forwardMotionProps === true && isValidMotionProp(key)) ||
            (!isDom && !isValidMotionProp(key)) ||
            (props["draggable"] && key.startsWith("onDrag"))) {
            filteredProps[key] = props[key];
        }
    }
    return filteredProps;
}

function calcOrigin$1(origin, offset, size) {
    return typeof origin === "string"
        ? origin
        : px.transform(offset + size * origin);
}
function calcSVGTransformOrigin(dimensions, originX, originY) {
    var pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
    var pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
    return "".concat(pxOriginX, " ").concat(pxOriginY);
}

var dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray",
};
var camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray",
};
function buildSVGPath(attrs, length, spacing, offset, useDashCase) {
    if (spacing === void 0) { spacing = 1; }
    if (offset === void 0) { offset = 0; }
    if (useDashCase === void 0) { useDashCase = true; }
    attrs.pathLength = 1;
    var keys = useDashCase ? dashKeys : camelKeys;
    attrs[keys.offset] = px.transform(-offset);
    var pathLength = px.transform(length);
    var pathSpacing = px.transform(spacing);
    attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}

function buildSVGAttrs(state, _a, options, transformTemplate) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c,
    latest = __rest(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
    buildHTMLStyles(state, latest, options, transformTemplate);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions;
    if (attrs.transform) {
        if (dimensions)
            style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (dimensions &&
        (originX !== undefined || originY !== undefined || style.transform)) {
        style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    }
    if (attrX !== undefined)
        attrs.x = attrX;
    if (attrY !== undefined)
        attrs.y = attrY;
    if (pathLength !== undefined) {
        buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
    }
}

var createSvgRenderState = function () { return (__assign$2(__assign$2({}, createHtmlRenderState()), { attrs: {} })); };

function useSVGProps(props, visualState) {
    var visualProps = useMemo(function () {
        var state = createSvgRenderState();
        buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, props.transformTemplate);
        return __assign$2(__assign$2({}, state.attrs), { style: __assign$2({}, state.style) });
    }, [visualState]);
    if (props.style) {
        var rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = __assign$2(__assign$2({}, rawStyles), visualProps.style);
    }
    return visualProps;
}

function createUseRender(forwardMotionProps) {
    if (forwardMotionProps === void 0) { forwardMotionProps = false; }
    var useRender = function (Component, props, projectionId, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = isSVGComponent(Component)
            ? useSVGProps
            : useHTMLProps;
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
        var elementProps = __assign$2(__assign$2(__assign$2({}, filteredProps), visualProps), { ref: ref });
        if (projectionId) {
            elementProps["data-projection-id"] = projectionId;
        }
        return createElement(Component, elementProps);
    };
    return useRender;
}

var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = "$1-$2";
var camelToDash = function (str) {
    return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};

function renderHTML(element, _a, styleProp, projection) {
    var style = _a.style, vars = _a.vars;
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    for (var key in vars) {
        element.style.setProperty(key, vars[key]);
    }
}

var camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
]);

function renderSVG(element, renderState) {
    renderHTML(element, renderState);
    for (var key in renderState.attrs) {
        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
    }
}

function scrapeMotionValuesFromProps$1(props) {
    var style = props.style;
    var newValues = {};
    for (var key in style) {
        if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) {
            newValues[key] = style[key];
        }
    }
    return newValues;
}

function scrapeMotionValuesFromProps(props) {
    var newValues = scrapeMotionValuesFromProps$1(props);
    for (var key in props) {
        if (isMotionValue(props[key])) {
            var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
            newValues[targetKey] = props[key];
        }
    }
    return newValues;
}

function isAnimationControls(v) {
    return typeof v === "object" && typeof v.start === "function";
}

function makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState(),
    };
    if (onMount) {
        state.mount = function (instance) { return onMount(props, instance, state); };
    }
    return state;
}
var makeUseVisualState = function (config) {
    return function (props, isStatic) {
        var context = useContext(MotionContext);
        var presenceContext = useContext(PresenceContext);
        return isStatic
            ? makeState(config, props, context, presenceContext)
            : useConstant(function () {
                return makeState(config, props, context, presenceContext);
            });
    };
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for (var key in motionValues) {
        values[key] = resolveMotionValue(motionValues[key]);
    }
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = checkIfControllingVariants(props);
    var isVariantNode = checkIfVariantNode(props);
    if (context &&
        isVariantNode &&
        !isControllingVariants &&
        props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : (initial = context.initial);
        animate !== null && animate !== void 0 ? animate : (animate = context.animate);
    }
    var initialAnimationIsBlocked = blockInitialAnimation || initial === false;
    var variantToSet = initialAnimationIsBlocked ? animate : initial;
    if (variantToSet &&
        typeof variantToSet !== "boolean" &&
        !isAnimationControls(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
        list.forEach(function (definition) {
            var resolved = resolveVariantFromProps(props, definition);
            if (!resolved)
                return;
            var transitionEnd = resolved.transitionEnd; resolved.transition; var target = __rest(resolved, ["transitionEnd", "transition"]);
            for (var key in target) {
                var valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    var index = initialAnimationIsBlocked
                        ? valueTarget.length - 1
                        : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) {
                    values[key] = valueTarget;
                }
            }
            for (var key in transitionEnd)
                values[key] = transitionEnd[key];
        });
    }
    return values;
}

var svgMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createSvgRenderState,
        onMount: function (props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions =
                    typeof instance.getBBox ===
                        "function"
                        ? instance.getBBox()
                        : instance.getBoundingClientRect();
            }
            catch (e) {
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                };
            }
            buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, props.transformTemplate);
            renderSVG(instance, renderState);
        },
    }),
};

var htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
        createRenderState: createHtmlRenderState,
    }),
};

function createDomMotionConfig(Component, _a, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = isSVGComponent(Component)
        ? svgMotionConfig
        : htmlMotionConfig;
    return __assign$2(__assign$2({}, baseConfig), { preloadedFeatures: preloadedFeatures, useRender: createUseRender(forwardMotionProps), createVisualElement: createVisualElement, projectionNodeConstructor: projectionNodeConstructor, Component: Component });
}

var AnimationType;
(function (AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})(AnimationType || (AnimationType = {}));

function addDomEvent(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function () { return target.removeEventListener(eventName, handler, options); };
}
function useDomEvent(ref, eventName, handler, options) {
    useEffect(function () {
        var element = ref.current;
        if (handler && element) {
            return addDomEvent(element, eventName, handler, options);
        }
    }, [ref, eventName, handler, options]);
}

function useFocusGesture(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function () {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, true);
    };
    var onBlur = function () {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, false);
    };
    useDomEvent(visualElement, "focus", whileFocus ? onFocus : undefined);
    useDomEvent(visualElement, "blur", whileFocus ? onBlur : undefined);
}

function isMouseEvent(event) {
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
        return !!(event.pointerType === "mouse");
    }
    return event instanceof MouseEvent;
}
function isTouchEvent(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}

function filterPrimaryPointer(eventHandler) {
    return function (event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent ||
            (isMouseEvent && event.button === 0);
        if (isPrimaryPointer) {
            eventHandler(event);
        }
    };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function pointFromMouse(point, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function extractEventInfo(event, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    return {
        point: isTouchEvent(event)
            ? pointFromTouch(event, pointType)
            : pointFromMouse(event, pointType),
    };
}
var wrapHandler = function (handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) { shouldFilterPrimaryPointer = false; }
    var listener = function (event) {
        return handler(event, extractEventInfo(event));
    };
    return shouldFilterPrimaryPointer
        ? filterPrimaryPointer(listener)
        : listener;
};

var supportsPointerEvents = function () {
    return isBrowser && window.onpointerdown === null;
};
var supportsTouchEvents = function () {
    return isBrowser && window.ontouchstart === null;
};
var supportsMouseEvents = function () {
    return isBrowser && window.onmousedown === null;
};

var mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave",
};
var touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel",
};
function getPointerEventName(name) {
    if (supportsPointerEvents()) {
        return name;
    }
    else if (supportsTouchEvents()) {
        return touchEventNames[name];
    }
    else if (supportsMouseEvents()) {
        return mouseEventNames[name];
    }
    return name;
}
function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
function usePointerEvent(ref, eventName, handler, options) {
    return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
}

function createLock(name) {
    var lock = null;
    return function () {
        var openLock = function () {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    var lock = false;
    if (drag === "y") {
        lock = globalVerticalLock();
    }
    else if (drag === "x") {
        lock = globalHorizontalLock();
    }
    else {
        var openHorizontal_1 = globalHorizontalLock();
        var openVertical_1 = globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) {
            lock = function () {
                openHorizontal_1();
                openVertical_1();
            };
        }
        else {
            if (openHorizontal_1)
                openHorizontal_1();
            if (openVertical_1)
                openVertical_1();
        }
    }
    return lock;
}
function isDragActive() {
    var openGestureLock = getGlobalLock(true);
    if (!openGestureLock)
        return true;
    openGestureLock();
    return false;
}

function createHoverEvent(visualElement, isActive, callback) {
    return function (event, info) {
        var _a;
        if (!isMouseEvent(event) || isDragActive())
            return;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Hover, isActive);
        callback === null || callback === void 0 ? void 0 : callback(event, info);
    };
}
function useHoverGesture(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    usePointerEvent(visualElement, "pointerenter", onHoverStart || whileHover
        ? createHoverEvent(visualElement, true, onHoverStart)
        : undefined);
    usePointerEvent(visualElement, "pointerleave", onHoverEnd || whileHover
        ? createHoverEvent(visualElement, false, onHoverEnd)
        : undefined);
}

var isNodeOrChild = function (parent, child) {
    if (!child) {
        return false;
    }
    else if (parent === child) {
        return true;
    }
    else {
        return isNodeOrChild(parent, child.parentElement);
    }
};

function useUnmountEffect(callback) {
    return useEffect(function () { return function () { return callback(); }; }, []);
}

function useTapGesture(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = useRef(false);
    var cancelPointerEndListeners = useRef(null);
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 ? void 0 : _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Tap, false);
        return !isDragActive();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd())
            return;
        !isNodeOrChild(visualElement.getInstance(), event.target)
            ? onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info)
            : onTap === null || onTap === void 0 ? void 0 : onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd())
            return;
        onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current)
            return;
        isPressing.current = true;
        cancelPointerEndListeners.current = pipe(addPointerEvent(window, "pointerup", onPointerUp), addPointerEvent(window, "pointercancel", onPointerCancel));
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Tap, true);
        onTapStart === null || onTapStart === void 0 ? void 0 : onTapStart(event, info);
    }
    usePointerEvent(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined);
    useUnmountEffect(removePointerEndListener);
}

var warned = new Set();
function warnOnce$1(condition, message, element) {
    if (condition || warned.has(message))
        return;
    console.warn(message);
    if (element)
        console.warn(element);
    warned.add(message);
}

var observerCallbacks = new WeakMap();
var observers = new WeakMap();
var fireObserverCallback = function (entry) {
    var _a;
    (_a = observerCallbacks.get(entry.target)) === null || _a === void 0 ? void 0 : _a(entry);
};
var fireAllObserverCallbacks = function (entries) {
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver(_a) {
    var root = _a.root, options = __rest(_a, ["root"]);
    var lookupRoot = root || document;
    if (!observers.has(lookupRoot)) {
        observers.set(lookupRoot, {});
    }
    var rootObservers = observers.get(lookupRoot);
    var key = JSON.stringify(options);
    if (!rootObservers[key]) {
        rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, __assign$2({ root: root }, options));
    }
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    var rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return function () {
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

function useViewport(_a) {
    var visualElement = _a.visualElement, whileInView = _a.whileInView, onViewportEnter = _a.onViewportEnter, onViewportLeave = _a.onViewportLeave, _b = _a.viewport, viewport = _b === void 0 ? {} : _b;
    var state = useRef({
        hasEnteredView: false,
        isInView: false,
    });
    var shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView)
        shouldObserve = false;
    var useObserver = typeof IntersectionObserver === "undefined"
        ? useMissingIntersectionObserver
        : useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
var thresholdNames = {
    some: 0,
    all: 1,
};
function useIntersectionObserver(shouldObserve, state, visualElement, _a) {
    var root = _a.root, rootMargin = _a.margin, _b = _a.amount, amount = _b === void 0 ? "some" : _b, once = _a.once;
    useEffect(function () {
        if (!shouldObserve)
            return;
        var options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : thresholdNames[amount],
        };
        var intersectionCallback = function (entry) {
            var _a;
            var isIntersecting = entry.isIntersecting;
            if (state.isInView === isIntersecting)
                return;
            state.isInView = isIntersecting;
            if (once && !isIntersecting && state.hasEnteredView) {
                return;
            }
            else if (isIntersecting) {
                state.hasEnteredView = true;
            }
            (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.InView, isIntersecting);
            var props = visualElement.getProps();
            var callback = isIntersecting
                ? props.onViewportEnter
                : props.onViewportLeave;
            callback === null || callback === void 0 ? void 0 : callback(entry);
        };
        return observeIntersection(visualElement.getInstance(), options, intersectionCallback);
    }, [shouldObserve, root, rootMargin, amount]);
}
function useMissingIntersectionObserver(shouldObserve, state, visualElement) {
    useEffect(function () {
        if (!shouldObserve)
            return;
        if (process.env.NODE_ENV !== "production") {
            warnOnce$1(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
        }
        requestAnimationFrame(function () {
            var _a;
            state.hasEnteredView = true;
            var onViewportEnter = visualElement.getProps().onViewportEnter;
            onViewportEnter === null || onViewportEnter === void 0 ? void 0 : onViewportEnter(null);
            (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.InView, true);
        });
    }, [shouldObserve]);
}

var makeRenderlessComponent = function (hook) { return function (props) {
    hook(props);
    return null;
}; };

var gestureAnimations = {
    inView: makeRenderlessComponent(useViewport),
    tap: makeRenderlessComponent(useTapGesture),
    focus: makeRenderlessComponent(useFocusGesture),
    hover: makeRenderlessComponent(useHoverGesture),
};

function usePresence() {
    var context = useContext(PresenceContext);
    if (context === null)
        return [true, null];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    var id = useUniqueId();
    useEffect(function () { return register(id); }, []);
    var safeToRemove = function () { return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id); };
    return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
var counter$2 = 0;
var incrementId = function () { return counter$2++; };
var useUniqueId = function () { return useConstant(incrementId); };

function shallowCompare(next, prev) {
    if (!Array.isArray(prev))
        return false;
    var prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (var i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}

var isNumericalString = function (v) { return /^\-?\d*\.?\d+$/.test(v); };

var isZeroValueString = function (v) { return /^0[^.\s]+$/.test(v); };

var testValueType = function (v) { return function (type) { return type.test(v); }; };

var auto = {
    test: function (v) { return v === "auto"; },
    parse: function (v) { return v; },
};

var dimensionValueTypes = [number$2, px, percent, degrees, vw, vh, auto];
var findDimensionValueType = function (v) {
    return dimensionValueTypes.find(testValueType(v));
};

var valueTypes = __spreadArray(__spreadArray([], __read(dimensionValueTypes), false), [color$1, complex], false);
var findValueType = function (v) { return valueTypes.find(testValueType(v)); };

function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) {
        visualElement.getValue(key).set(value);
    }
    else {
        visualElement.addValue(key, motionValue(value));
    }
}
function setTarget(visualElement, definition) {
    var resolved = resolveVariant(visualElement, definition);
    var _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b; _a.transition; var target = __rest(_a, ["transitionEnd", "transition"]);
    target = __assign$2(__assign$2({}, target), transitionEnd);
    for (var key in target) {
        var value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
    }
}
function checkTargetForNewValues(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function (key) { return !visualElement.hasValue(key); });
    var numNewValues = newValueKeys.length;
    if (!numNewValues)
        return;
    for (var i = 0; i < numNewValues; i++) {
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        if (Array.isArray(targetValue)) {
            value = targetValue[0];
        }
        if (value === null) {
            value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        }
        if (value === undefined || value === null)
            continue;
        if (typeof value === "string" &&
            (isNumericalString(value) || isZeroValueString(value))) {
            value = parseFloat(value);
        }
        else if (!findValueType(value) && complex.test(targetValue)) {
            value = getAnimatableNone(key, targetValue);
        }
        visualElement.addValue(key, motionValue(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : (_d[key] = value);
        visualElement.setBaseTarget(key, value);
    }
}
function getOriginFromTransition(key, transition) {
    if (!transition)
        return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for (var key in target) {
        origin[key] =
            (_a = getOriginFromTransition(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    }
    return origin;
}

function animateVisualElement(visualElement, definition, options) {
    if (options === void 0) { options = {}; }
    visualElement.notifyAnimationStart(definition);
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function (variant) {
            return animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    }
    else if (typeof definition === "string") {
        animation = animateVariant(visualElement, definition, options);
    }
    else {
        var resolvedDefinition = typeof definition === "function"
            ? resolveVariant(visualElement, definition, options.custom)
            : definition;
        animation = animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function () {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var resolved = resolveVariant(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) {
        transition = options.transitionOverride;
    }
    var getAnimation = resolved
        ? function () { return animateTarget(visualElement, resolved, options); }
        : function () { return Promise.resolve(); };
    var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size)
        ? function (forwardDelay) {
            if (forwardDelay === void 0) { forwardDelay = 0; }
            var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
            return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
        }
        : function () { return Promise.resolve(); };
    var when = transition.when;
    if (when) {
        var _c = __read(when === "beforeChildren"
            ? [getAnimation, getChildAnimations]
            : [getChildAnimations, getAnimation], 2), first = _c[0], last = _c[1];
        return first().then(last);
    }
    else {
        return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
    }
}
function animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = __rest(_e, ["transition", "transitionEnd"]);
    if (transitionOverride)
        transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for (var key in target) {
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value ||
            valueTarget === undefined ||
            (animationTypeState &&
                shouldBlockAnimation(animationTypeState, key))) {
            continue;
        }
        var animation = startAnimation(key, value, valueTarget, __assign$2({ delay: delay }, transition));
        animations.push(animation);
    }
    return Promise.all(animations).then(function () {
        transitionEnd && setTarget(visualElement, transitionEnd);
    });
}
function animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) { delayChildren = 0; }
    if (staggerChildren === void 0) { staggerChildren = 0; }
    if (staggerDirection === void 0) { staggerDirection = 1; }
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1
        ? function (i) {
            if (i === void 0) { i = 0; }
            return i * staggerChildren;
        }
        : function (i) {
            if (i === void 0) { i = 0; }
            return maxStaggerDuration - i * staggerChildren;
        };
    Array.from(visualElement.variantChildren)
        .sort(sortByTreeOrder)
        .forEach(function (child, i) {
        animations.push(animateVariant(child, variant, __assign$2(__assign$2({}, options), { delay: delayChildren + generateStaggerDuration(i) })).then(function () { return child.notifyAnimationComplete(variant); }));
    });
    return Promise.all(animations);
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}
function shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}

var variantPriorityOrder = [
    AnimationType.Animate,
    AnimationType.InView,
    AnimationType.Focus,
    AnimationType.Hover,
    AnimationType.Tap,
    AnimationType.Drag,
    AnimationType.Exit,
];
var reversePriorityOrder = __spreadArray([], __read(variantPriorityOrder), false).reverse();
var numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
    return function (animations) {
        return Promise.all(animations.map(function (_a) {
            var animation = _a.animation, options = _a.options;
            return animateVisualElement(visualElement, animation, options);
        }));
    };
}
function createAnimationState(visualElement) {
    var animate = animateList(visualElement);
    var state = createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    var buildResolvedTypeValues = function (acc, definition) {
        var resolved = resolveVariant(visualElement, definition);
        if (resolved) {
            resolved.transition; var transitionEnd = resolved.transitionEnd, target = __rest(resolved, ["transition", "transitionEnd"]);
            acc = __assign$2(__assign$2(__assign$2({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        var animations = [];
        var removedKeys = new Set();
        var encounteredKeys = {};
        var removedVariantIndex = Infinity;
        var _loop_1 = function (i) {
            var type = reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = isVariantLabel(prop);
            var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false)
                removedVariantIndex = i;
            var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited &&
                isInitialRender &&
                visualElement.manuallyAnimateOnMount) {
                isInherited = false;
            }
            typeState.protectedKeys = __assign$2({}, encounteredKeys);
            if (
            (!typeState.isActive && activeDelta === null) ||
                (!prop && !typeState.prevProp) ||
                isAnimationControls(prop) ||
                typeof prop === "boolean") {
                return "continue";
            }
            var variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            var shouldAnimateType = variantDidChange ||
                (type === changedActiveType &&
                    typeState.isActive &&
                    !isInherited &&
                    propIsVariant) ||
                (i > removedVariantIndex && propIsVariant);
            var definitionList = Array.isArray(prop) ? prop : [prop];
            var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false)
                resolvedValues = {};
            var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = __assign$2(__assign$2({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function (key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for (var key in allKeys) {
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                if (encounteredKeys.hasOwnProperty(key))
                    continue;
                if (next !== prev) {
                    if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
                        if (!shallowCompare(next, prev) || variantDidChange) {
                            markToAnimate(key);
                        }
                        else {
                            typeState.protectedKeys[key] = true;
                        }
                    }
                    else if (next !== undefined) {
                        markToAnimate(key);
                    }
                    else {
                        removedKeys.add(key);
                    }
                }
                else if (next !== undefined && removedKeys.has(key)) {
                    markToAnimate(key);
                }
                else {
                    typeState.protectedKeys[key] = true;
                }
            }
            typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) {
                encounteredKeys = __assign$2(__assign$2({}, encounteredKeys), resolvedValues);
            }
            if (isInitialRender && visualElement.blockInitialAnimation) {
                shouldAnimateType = false;
            }
            if (shouldAnimateType && !isInherited) {
                animations.push.apply(animations, __spreadArray([], __read(definitionList.map(function (animation) { return ({
                    animation: animation,
                    options: __assign$2({ type: type }, options),
                }); })), false));
            }
        };
        for (var i = 0; i < numAnimationTypes; i++) {
            _loop_1(i);
        }
        allAnimatedKeys = __assign$2({}, encounteredKeys);
        if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function (key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) {
                    fallbackAnimation_1[key] = fallbackTarget;
                }
            });
            animations.push({ animation: fallbackAnimation_1 });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender &&
            props.initial === false &&
            !visualElement.manuallyAnimateOnMount) {
            shouldAnimate = false;
        }
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    function setActive(type, isActive, options) {
        var _a;
        if (state[type].isActive === isActive)
            return Promise.resolve();
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
        state[type].isActive = isActive;
        return animateChanges(options, type);
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function () { return state; },
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") {
        return next !== prev;
    }
    else if (isVariantLabels(next)) {
        return !shallowCompare(next, prev);
    }
    return false;
}
function createTypeState(isActive) {
    if (isActive === void 0) { isActive = false; }
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {},
    };
}
function createState() {
    var _a;
    return _a = {},
        _a[AnimationType.Animate] = createTypeState(true),
        _a[AnimationType.InView] = createTypeState(),
        _a[AnimationType.Hover] = createTypeState(),
        _a[AnimationType.Tap] = createTypeState(),
        _a[AnimationType.Drag] = createTypeState(),
        _a[AnimationType.Focus] = createTypeState(),
        _a[AnimationType.Exit] = createTypeState(),
        _a;
}

var animations = {
    animation: makeRenderlessComponent(function (_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        visualElement.animationState || (visualElement.animationState = createAnimationState(visualElement));
        if (isAnimationControls(animate)) {
            useEffect(function () { return animate.subscribe(visualElement); }, [animate]);
        }
    }),
    exit: makeRenderlessComponent(function (props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = __read(usePresence(), 2), isPresent = _a[0], safeToRemove = _a[1];
        var presenceContext = useContext(PresenceContext);
        useEffect(function () {
            var _a, _b;
            visualElement.isPresent = isPresent;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Exit, !isPresent, { custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom });
            !isPresent && (animation === null || animation === void 0 ? void 0 : animation.then(safeToRemove));
        }, [isPresent]);
    }),
};

var PanSession =  (function () {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        this.startEvent = null;
        this.lastMoveEvent = null;
        this.lastMoveEventInfo = null;
        this.handlers = {};
        this.updatePoint = function () {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo))
                return;
            var info = getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            var isDistancePastThreshold = distance(info.offset, { x: 0, y: 0 }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold)
                return;
            var point = info.point;
            var timestamp = getFrameData().timestamp;
            _this.history.push(__assign$2(__assign$2({}, point), { timestamp: timestamp }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function (event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = transformPoint(info, _this.transformPagePoint);
            if (isMouseEvent(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            sync.update(_this.updatePoint, true);
        };
        this.handlePointerUp = function (event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = getPanInfo(transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) {
                onEnd(event, panInfo);
            }
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        if (isTouchEvent(event) && event.touches.length > 1)
            return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = extractEventInfo(event);
        var initialInfo = transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = getFrameData().timestamp;
        this.history = [__assign$2(__assign$2({}, point), { timestamp: timestamp })];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart &&
            onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function (handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function () {
        this.removeListeners && this.removeListeners();
        cancelSync.update(this.updatePoint);
    };
    return PanSession;
}());
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity(history, 0.1),
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
    if (history.length < 2) {
        return { x: 0, y: 0 };
    }
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = lastDevicePoint(history);
    while (i >= 0) {
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp >
            secondsToMilliseconds(timeDelta)) {
            break;
        }
        i--;
    }
    if (!timestampedPoint) {
        return { x: 0, y: 0 };
    }
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) {
        return { x: 0, y: 0 };
    }
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time,
    };
    if (currentVelocity.x === Infinity) {
        currentVelocity.x = 0;
    }
    if (currentVelocity.y === Infinity) {
        currentVelocity.y = 0;
    }
    return currentVelocity;
}

function applyConstraints(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) {
        point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
    }
    else if (max !== undefined && point > max) {
        point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
    }
    return point;
}
function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined
            ? axis.max + max - (axis.max - axis.min)
            : undefined,
    };
}
function calcRelativeConstraints(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
    };
}
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    if (constraintsAxis.max - constraintsAxis.min <
        layoutAxis.max - layoutAxis.min) {
        _a = __read([max, min], 2), min = _a[0], max = _a[1];
    }
    return { min: min, max: max };
}
function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
    };
}
function calcOrigin(source, target) {
    var origin = 0.5;
    var sourceLength = calcLength(source);
    var targetLength = calcLength(target);
    if (targetLength > sourceLength) {
        origin = progress(target.min, target.max - sourceLength, source.min);
    }
    else if (sourceLength > targetLength) {
        origin = progress(source.min, source.max - targetLength, target.min);
    }
    return clamp$1(0, 1, origin);
}
function rebaseAxisConstraints(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) {
        relativeConstraints.min = constraints.min - layout.min;
    }
    if (constraints.max !== undefined) {
        relativeConstraints.max = constraints.max - layout.min;
    }
    return relativeConstraints;
}
var defaultElastic = 0.35;
function resolveDragElastic(dragElastic) {
    if (dragElastic === void 0) { dragElastic = defaultElastic; }
    if (dragElastic === false) {
        dragElastic = 0;
    }
    else if (dragElastic === true) {
        dragElastic = defaultElastic;
    }
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom"),
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel),
    };
}
function resolvePointElastic(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number"
        ? dragElastic
        : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}

function convertBoundingBoxToBox(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: { min: left, max: right },
        y: { min: top, max: bottom },
    };
}
function convertBoxToBoundingBox(_a) {
    var x = _a.x, y = _a.y;
    return { top: y.min, right: x.max, bottom: y.max, left: x.min };
}
function transformBoxPoints(point, transformPoint) {
    if (!transformPoint)
        return point;
    var topLeft = transformPoint({ x: point.left, y: point.top });
    var bottomRight = transformPoint({ x: point.right, y: point.bottom });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x,
    };
}

function measureViewportBox(instance, transformPoint) {
    return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = measureViewportBox(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        translateAxis(viewportBox.x, scroll.x);
        translateAxis(viewportBox.y, scroll.y);
    }
    return viewportBox;
}

var elementDragControls = new WeakMap();
var VisualElementDragControls =  (function () {
    function VisualElementDragControls(visualElement) {
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = { x: 0, y: 0 };
        this.constraints = false;
        this.hasMutatedConstraints = false;
        this.elastic = createBox();
        this.visualElement = visualElement;
    }
    VisualElementDragControls.prototype.start = function (originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c;
        if (this.visualElement.isPresent === false)
            return;
        var onSessionStart = function (event) {
            _this.stopAnimation();
            if (snapToCursor) {
                _this.snapToCursor(extractEventInfo(event, "page").point);
            }
        };
        var onStart = function (event, info) {
            var _a;
            var _b = _this.getProps(), drag = _b.drag, dragPropagation = _b.dragPropagation, onDragStart = _b.onDragStart;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock)
                    _this.openGlobalLock();
                _this.openGlobalLock = getGlobalLock(drag);
                if (!_this.openGlobalLock)
                    return;
            }
            _this.isDragging = true;
            _this.currentDirection = null;
            _this.resolveConstraints();
            if (_this.visualElement.projection) {
                _this.visualElement.projection.isAnimationBlocked = true;
                _this.visualElement.projection.target = undefined;
            }
            eachAxis(function (axis) {
                var _a, _b;
                var current = _this.getAxisMotionValue(axis).get() || 0;
                if (percent.test(current)) {
                    var measuredAxis = (_b = (_a = _this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.actual[axis];
                    if (measuredAxis) {
                        var length_1 = calcLength(measuredAxis);
                        current = length_1 * (parseFloat(current) / 100);
                    }
                }
                _this.originPoint[axis] = current;
            });
            onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(event, info);
            (_a = _this.visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Drag, true);
        };
        var onMove = function (event, info) {
            var _a = _this.getProps(), dragPropagation = _a.dragPropagation, dragDirectionLock = _a.dragDirectionLock, onDirectionLock = _a.onDirectionLock, onDrag = _a.onDrag;
            if (!dragPropagation && !_this.openGlobalLock)
                return;
            var offset = info.offset;
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = getCurrentDirection(offset);
                if (_this.currentDirection !== null) {
                    onDirectionLock === null || onDirectionLock === void 0 ? void 0 : onDirectionLock(_this.currentDirection);
                }
                return;
            }
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            _this.visualElement.syncRender();
            onDrag === null || onDrag === void 0 ? void 0 : onDrag(event, info);
        };
        var onSessionEnd = function (event, info) {
            return _this.stop(event, info);
        };
        this.panSession = new PanSession(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
    };
    VisualElementDragControls.prototype.stop = function (event, info) {
        var isDragging = this.isDragging;
        this.cancel();
        if (!isDragging)
            return;
        var velocity = info.velocity;
        this.startAnimation(velocity);
        var onDragEnd = this.getProps().onDragEnd;
        onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(event, info);
    };
    VisualElementDragControls.prototype.cancel = function () {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) {
            this.visualElement.projection.isAnimationBlocked = false;
        }
        (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
        this.panSession = undefined;
        var dragPropagation = this.getProps().dragPropagation;
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(AnimationType.Drag, false);
    };
    VisualElementDragControls.prototype.updateAxis = function (axis, _point, offset) {
        var drag = this.getProps().drag;
        if (!offset || !shouldDrag(axis, drag, this.currentDirection))
            return;
        var axisValue = this.getAxisMotionValue(axis);
        var next = this.originPoint[axis] + offset[axis];
        if (this.constraints && this.constraints[axis]) {
            next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
        }
        axisValue.set(next);
    };
    VisualElementDragControls.prototype.resolveConstraints = function () {
        var _this = this;
        var _a = this.getProps(), dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = (this.visualElement.projection || {}).layout;
        var prevConstraints = this.constraints;
        if (dragConstraints && isRefObject(dragConstraints)) {
            if (!this.constraints) {
                this.constraints = this.resolveRefConstraints();
            }
        }
        else {
            if (dragConstraints && layout) {
                this.constraints = calcRelativeConstraints(layout.actual, dragConstraints);
            }
            else {
                this.constraints = false;
            }
        }
        this.elastic = resolveDragElastic(dragElastic);
        if (prevConstraints !== this.constraints &&
            layout &&
            this.constraints &&
            !this.hasMutatedConstraints) {
            eachAxis(function (axis) {
                if (_this.getAxisMotionValue(axis)) {
                    _this.constraints[axis] = rebaseAxisConstraints(layout.actual[axis], _this.constraints[axis]);
                }
            });
        }
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function () {
        var _a = this.getProps(), constraints = _a.dragConstraints, onMeasureDragConstraints = _a.onMeasureDragConstraints;
        if (!constraints || !isRefObject(constraints))
            return false;
        var constraintsElement = constraints.current;
        invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        var projection = this.visualElement.projection;
        if (!projection || !projection.layout)
            return false;
        var constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        var measuredConstraints = calcViewportConstraints(projection.layout.actual, constraintsBox);
        if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) {
                measuredConstraints = convertBoundingBoxToBox(userConstraints);
            }
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.startAnimation = function (velocity) {
        var _this = this;
        var _a = this.getProps(), drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition, dragSnapToOrigin = _a.dragSnapToOrigin, onDragTransitionEnd = _a.onDragTransitionEnd;
        var constraints = this.constraints || {};
        var momentumAnimations = eachAxis(function (axis) {
            var _a;
            if (!shouldDrag(axis, drag, _this.currentDirection)) {
                return;
            }
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            if (dragSnapToOrigin)
                transition = { min: 0, max: 0 };
            var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = __assign$2(__assign$2({ type: "inertia", velocity: dragMomentum ? velocity[axis] : 0, bounceStiffness: bounceStiffness, bounceDamping: bounceDamping, timeConstant: 750, restDelta: 1, restSpeed: 10 }, dragTransition), transition);
            return _this.startAxisValueAnimation(axis, inertia);
        });
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function (axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        return startAnimation(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.stopAnimation = function () {
        var _this = this;
        eachAxis(function (axis) { return _this.getAxisMotionValue(axis).stop(); });
    };
    VisualElementDragControls.prototype.getAxisMotionValue = function (axis) {
        var _a, _b;
        var dragKey = "_drag" + axis.toUpperCase();
        var externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue
            ? externalMotionValue
            : this.visualElement.getValue(axis, (_b = (_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) !== null && _b !== void 0 ? _b : 0);
    };
    VisualElementDragControls.prototype.snapToCursor = function (point) {
        var _this = this;
        eachAxis(function (axis) {
            var drag = _this.getProps().drag;
            if (!shouldDrag(axis, drag, _this.currentDirection))
                return;
            var projection = _this.visualElement.projection;
            var axisValue = _this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                var _a = projection.layout.actual[axis], min = _a.min, max = _a.max;
                axisValue.set(point[axis] - mix(min, max, 0.5));
            }
        });
    };
    VisualElementDragControls.prototype.scalePositionWithinConstraints = function () {
        var _this = this;
        var _a;
        var _b = this.getProps(), drag = _b.drag, dragConstraints = _b.dragConstraints;
        var projection = this.visualElement.projection;
        if (!isRefObject(dragConstraints) || !projection || !this.constraints)
            return;
        this.stopAnimation();
        var boxProgress = { x: 0, y: 0 };
        eachAxis(function (axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var latest = axisValue.get();
                boxProgress[axis] = calcOrigin({ min: latest, max: latest }, _this.constraints[axis]);
            }
        });
        var transformTemplate = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        eachAxis(function (axis) {
            if (!shouldDrag(axis, drag, null))
                return;
            var axisValue = _this.getAxisMotionValue(axis);
            var _a = _this.constraints[axis], min = _a.min, max = _a.max;
            axisValue.set(mix(min, max, boxProgress[axis]));
        });
    };
    VisualElementDragControls.prototype.addListeners = function () {
        var _this = this;
        var _a;
        elementDragControls.set(this.visualElement, this);
        var element = this.visualElement.getInstance();
        var stopPointerListener = addPointerEvent(element, "pointerdown", function (event) {
            var _a = _this.getProps(), drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        var measureDragConstraints = function () {
            var dragConstraints = _this.getProps().dragConstraints;
            if (isRefObject(dragConstraints)) {
                _this.constraints = _this.resolveRefConstraints();
            }
        };
        var projection = this.visualElement.projection;
        var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        var stopResizeListener = addDomEvent(window, "resize", function () {
            _this.scalePositionWithinConstraints();
        });
        projection.addEventListener("didUpdate", (function (_a) {
            var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged;
            if (_this.isDragging && hasLayoutChanged) {
                eachAxis(function (axis) {
                    var motionValue = _this.getAxisMotionValue(axis);
                    if (!motionValue)
                        return;
                    _this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                _this.visualElement.syncRender();
            }
        }));
        return function () {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
        };
    };
    VisualElementDragControls.prototype.getProps = function () {
        var props = this.visualElement.getProps();
        var _a = props.drag, drag = _a === void 0 ? false : _a, _b = props.dragDirectionLock, dragDirectionLock = _b === void 0 ? false : _b, _c = props.dragPropagation, dragPropagation = _c === void 0 ? false : _c, _d = props.dragConstraints, dragConstraints = _d === void 0 ? false : _d, _e = props.dragElastic, dragElastic = _e === void 0 ? defaultElastic : _e, _f = props.dragMomentum, dragMomentum = _f === void 0 ? true : _f;
        return __assign$2(__assign$2({}, props), { drag: drag, dragDirectionLock: dragDirectionLock, dragPropagation: dragPropagation, dragConstraints: dragConstraints, dragElastic: dragElastic, dragMomentum: dragMomentum });
    };
    return VisualElementDragControls;
}());
function shouldDrag(direction, drag, currentDirection) {
    return ((drag === true || drag === direction) &&
        (currentDirection === null || currentDirection === direction));
}
function getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) { lockThreshold = 10; }
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) {
        direction = "y";
    }
    else if (Math.abs(offset.x) > lockThreshold) {
        direction = "x";
    }
    return direction;
}

function useDrag(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var dragControls = useConstant(function () { return new VisualElementDragControls(visualElement); });
    useEffect(function () { return groupDragControls && groupDragControls.subscribe(dragControls); }, [dragControls, groupDragControls]);
    useEffect(function () { return dragControls.addListeners(); }, [dragControls]);
}

function usePanGesture(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = useRef(null);
    var transformPagePoint = useContext(MotionConfigContext).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function (event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        },
    };
    useEffect(function () {
        if (panSession.current !== null) {
            panSession.current.updateHandlers(handlers);
        }
    });
    function onPointerDown(event) {
        panSession.current = new PanSession(event, handlers, {
            transformPagePoint: transformPagePoint,
        });
    }
    usePointerEvent(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    useUnmountEffect(function () { return panSession.current && panSession.current.end(); });
}

var drag = {
    pan: makeRenderlessComponent(usePanGesture),
    drag: makeRenderlessComponent(useDrag),
};

var names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "SetAxisTarget",
    "Unmount",
];
function createLifecycles() {
    var managers = names.map(function () { return new SubscriptionManager(); });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function () { return managers.forEach(function (manager) { return manager.clear(); }); },
        updatePropListeners: function (props) {
            names.forEach(function (name) {
                var _a;
                var on = "on" + name;
                var propListener = props[on];
                (_a = propSubscriptions[name]) === null || _a === void 0 ? void 0 : _a.call(propSubscriptions);
                if (propListener) {
                    propSubscriptions[name] = lifecycles[on](propListener);
                }
            });
        },
    };
    managers.forEach(function (manager, i) {
        lifecycles["on" + names[i]] = function (handler) { return manager.add(handler); };
        lifecycles["notify" + names[i]] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            manager.notify.apply(manager, __spreadArray([], __read(args), false));
        };
    });
    return lifecycles;
}

function updateMotionValuesFromProps(element, next, prev) {
    var _a;
    for (var key in next) {
        var nextValue = next[key];
        var prevValue = prev[key];
        if (isMotionValue(nextValue)) {
            element.addValue(key, nextValue);
        }
        else if (isMotionValue(prevValue)) {
            element.addValue(key, motionValue(nextValue));
        }
        else if (prevValue !== nextValue) {
            if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                !existingValue.hasAnimated && existingValue.set(nextValue);
            }
            else {
                element.addValue(key, motionValue((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
            }
        }
    }
    for (var key in prev) {
        if (next[key] === undefined)
            element.removeValue(key);
    }
    return next;
}

var visualElement = function (_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function (_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState;
        if (options === void 0) { options = {}; }
        var isMounted = false;
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        var instance;
        var lifecycles = createLifecycles();
        var values = new Map();
        var valueSubscriptions = new Map();
        var prevMotionValues = {};
        var baseTarget = __assign$2({}, latestValues);
        var removeFromVariantTree;
        function render() {
            if (!instance || !isMounted)
                return;
            triggerBuild();
            renderInstance(instance, renderState, props.style, element.projection);
        }
        function triggerBuild() {
            build(element, renderState, latestValues, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function (latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && sync.update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function () {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        var initialMotionValues = scrapeMotionValuesFromProps(props);
        for (var key in initialMotionValues) {
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && isMotionValue(value)) {
                value.set(latestValues[key], false);
            }
        }
        var isControllingVariants = checkIfControllingVariants(props);
        var isVariantNode = checkIfVariantNode(props);
        var element = __assign$2(__assign$2({ treeType: treeType,
            current: null,
            depth: parent ? parent.depth + 1 : 0, parent: parent, children: new Set(),
            presenceId: presenceId,
            variantChildren: isVariantNode ? new Set() : undefined,
            isVisible: undefined,
            manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            blockInitialAnimation: blockInitialAnimation,
            isMounted: function () { return Boolean(instance); }, mount: function (newInstance) {
                isMounted = true;
                instance = element.current = newInstance;
                if (element.projection) {
                    element.projection.mount(newInstance);
                }
                if (isVariantNode && parent && !isControllingVariants) {
                    removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                }
                parent === null || parent === void 0 ? void 0 : parent.children.add(element);
                element.setProps(props);
            },
            unmount: function () {
                var _a;
                (_a = element.projection) === null || _a === void 0 ? void 0 : _a.unmount();
                cancelSync.update(update);
                cancelSync.render(render);
                valueSubscriptions.forEach(function (remove) { return remove(); });
                removeFromVariantTree === null || removeFromVariantTree === void 0 ? void 0 : removeFromVariantTree();
                parent === null || parent === void 0 ? void 0 : parent.children.delete(element);
                lifecycles.clearAllListeners();
                instance = undefined;
                isMounted = false;
            },
            addVariantChild: function (child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 ? void 0 : _a.add(child);
                    return function () {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            }, sortNodePosition: function (other) {
                if (!sortNodePosition || treeType !== other.treeType)
                    return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            getClosestVariantNode: function () {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            },
            getLayoutId: function () { return props.layoutId; },
            getInstance: function () { return instance; },
            getStaticValue: function (key) { return latestValues[key]; }, setStaticValue: function (key, value) { return (latestValues[key] = value); },
            getLatestValues: function () { return latestValues; },
            setVisibility: function (visibility) {
                if (element.isVisible === visibility)
                    return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            makeTargetAnimatable: function (target, canMutate) {
                if (canMutate === void 0) { canMutate = true; }
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            measureViewportBox: function () {
                return measureViewportBox(instance, props);
            },
            addValue: function (key, value) {
                if (element.hasValue(key))
                    element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            removeValue: function (key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 ? void 0 : _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            hasValue: function (key) { return values.has(key); },
            getValue: function (key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = motionValue(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            forEachValue: function (callback) { return values.forEach(callback); },
            readValue: function (key) {
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            setBaseTarget: function (key, value) {
                baseTarget[key] = value;
            },
            getBaseTarget: function (key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !isMotionValue(target))
                        return target;
                }
                return baseTarget[key];
            } }, lifecycles), {
            build: function () {
                triggerBuild();
                return renderState;
            },
            scheduleRender: function () {
                sync.render(render, false, true);
            },
            syncRender: render,
            setProps: function (newProps) {
                if (newProps.transformTemplate || props.transformTemplate) {
                    element.scheduleRender();
                }
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = updateMotionValuesFromProps(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            }, getProps: function () { return props; },
            getVariant: function (name) { var _a; return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name]; },
            getDefaultTransition: function () { return props.transition; }, getTransformPagePoint: function () {
                return props.transformPagePoint;
            },
            getVariantContext: function (startAtParent) {
                if (startAtParent === void 0) { startAtParent = false; }
                if (startAtParent)
                    return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) {
                        context_1.initial = props.initial;
                    }
                    return context_1;
                }
                var context = {};
                for (var i = 0; i < numVariantProps; i++) {
                    var name_1 = variantProps[i];
                    var prop = props[name_1];
                    if (isVariantLabel(prop) || prop === false) {
                        context[name_1] = prop;
                    }
                }
                return context;
            } });
        return element;
    };
};
var variantProps = __spreadArray(["initial"], __read(variantPriorityOrder), false);
var numVariantProps = variantProps.length;

function isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
    var match = cssVariableRegex.exec(current);
    if (!match)
        return [,];
    var _a = __read(match, 3), token = _a[1], fallback = _a[2];
    return [token, fallback];
}
var maxDepth = 4;
function getVariableValue(current, element, depth) {
    if (depth === void 0) { depth = 1; }
    invariant(depth <= maxDepth, "Max CSS variable fallback depth detected in property \"".concat(current, "\". This may indicate a circular fallback dependency."));
    var _a = __read(parseCSSVariable(current), 2), token = _a[0], fallback = _a[1];
    if (!token)
        return;
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        return resolved.trim();
    }
    else if (isCSSVariable(fallback)) {
        return getVariableValue(fallback, element, depth + 1);
    }
    else {
        return fallback;
    }
}
function resolveCSSVariables(visualElement, _a, transitionEnd) {
    var _b;
    var target = __rest(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof Element))
        return { target: target, transitionEnd: transitionEnd };
    if (transitionEnd) {
        transitionEnd = __assign$2({}, transitionEnd);
    }
    visualElement.forEachValue(function (value) {
        var current = value.get();
        if (!isCSSVariable(current))
            return;
        var resolved = getVariableValue(current, element);
        if (resolved)
            value.set(resolved);
    });
    for (var key in target) {
        var current = target[key];
        if (!isCSSVariable(current))
            continue;
        var resolved = getVariableValue(current, element);
        if (!resolved)
            continue;
        target[key] = resolved;
        if (transitionEnd)
            (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : (transitionEnd[key] = current);
    }
    return { target: target, transitionEnd: transitionEnd };
}

var positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
]);
var isPositionalKey = function (key) { return positionalKeys.has(key); };
var hasPositionalKey = function (target) {
    return Object.keys(target).some(isPositionalKey);
};
var setAndResetVelocity = function (value, to) {
    value.set(to, false);
    value.set(to);
};
var isNumOrPxType = function (v) {
    return v === number$2 || v === px;
};
var BoundingBoxDimension;
(function (BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function (matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var getTranslateFromMatrix = function (pos2, pos3) {
    return function (_bbox, _a) {
        var transform = _a.transform;
        if (transform === "none" || !transform)
            return 0;
        var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) {
            return getPosFromMatrix(matrix3d[1], pos3);
        }
        else {
            var matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) {
                return getPosFromMatrix(matrix[1], pos2);
            }
            else {
                return 0;
            }
        }
    };
};
var transformKeys = new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformProps.filter(function (key) { return !transformKeys.has(key); });
function removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    nonTranslationalTransformKeys.forEach(function (key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([key, value.get()]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    if (removedTransforms.length)
        visualElement.syncRender();
    return removedTransforms;
}
var positionalValues = {
    width: function (_a, _b) {
        var x = _a.x;
        var _c = _b.paddingLeft, paddingLeft = _c === void 0 ? "0" : _c, _d = _b.paddingRight, paddingRight = _d === void 0 ? "0" : _d;
        return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: function (_a, _b) {
        var y = _a.y;
        var _c = _b.paddingTop, paddingTop = _c === void 0 ? "0" : _c, _d = _b.paddingBottom, paddingBottom = _d === void 0 ? "0" : _d;
        return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: function (_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function (_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function (_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function (_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14),
};
var convertChangedValueTypes = function (target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display;
    var origin = {};
    if (display === "none") {
        visualElement.setStaticValue("display", target.display || "block");
    }
    changedKeys.forEach(function (key) {
        origin[key] = positionalValues[key](originBbox, elementComputedStyle);
    });
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function (key) {
        var value = visualElement.getValue(key);
        setAndResetVelocity(value, origin[key]);
        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var checkAndConvertChangedValueTypes = function (visualElement, target, origin, transitionEnd) {
    if (origin === void 0) { origin = {}; }
    if (transitionEnd === void 0) { transitionEnd = {}; }
    target = __assign$2({}, target);
    transitionEnd = __assign$2({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function (key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key))
            return;
        var from = origin[key];
        var fromType = findDimensionValueType(from);
        var to = target[key];
        var toType;
        if (isKeyframesTarget(to)) {
            var numKeyframes = to.length;
            var fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = findDimensionValueType(from);
            for (var i = fromIndex; i < numKeyframes; i++) {
                if (!toType) {
                    toType = findDimensionValueType(to[i]);
                    invariant(toType === fromType ||
                        (isNumOrPxType(fromType) && isNumOrPxType(toType)), "Keyframes must be of the same dimension as the current value");
                }
                else {
                    invariant(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
                }
            }
        }
        else {
            toType = findDimensionValueType(to);
        }
        if (fromType !== toType) {
            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") {
                    value.set(parseFloat(current));
                }
                if (typeof to === "string") {
                    target[key] = parseFloat(to);
                }
                else if (Array.isArray(to) && toType === px) {
                    target[key] = to.map(parseFloat);
                }
            }
            else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) &&
                (toType === null || toType === void 0 ? void 0 : toType.transform) &&
                (from === 0 || to === 0)) {
                if (from === 0) {
                    value.set(toType.transform(from));
                }
                else {
                    target[key] = fromType.transform(to);
                }
            }
            else {
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues =
                        removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] =
                    transitionEnd[key] !== undefined
                        ? transitionEnd[key]
                        : target[key];
                setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        if (removedTransformValues.length) {
            removedTransformValues.forEach(function (_a) {
                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                visualElement.getValue(key).set(value);
            });
        }
        visualElement.syncRender();
        return { target: convertedTarget, transitionEnd: transitionEnd };
    }
    else {
        return { target: target, transitionEnd: transitionEnd };
    }
};
function unitConversion(visualElement, target, origin, transitionEnd) {
    return hasPositionalKey(target)
        ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
        : { target: target, transitionEnd: transitionEnd };
}

var parseDomVariant = function (visualElement, target, origin, transitionEnd) {
    var resolved = resolveCSSVariables(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return unitConversion(visualElement, target, origin, transitionEnd);
};

function getComputedStyle$1(element) {
    return window.getComputedStyle(element);
}
var htmlConfig = {
    treeType: "dom",
    readValueFromInstance: function (domElement, key) {
        if (isTransformProp(key)) {
            var defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        else {
            var computedStyle = getComputedStyle$1(domElement);
            return ((isCSSVariable$1(key)
                ? computedStyle.getPropertyValue(key)
                : computedStyle[key]) || 0);
        }
    },
    sortNodePosition: function (a, b) {
        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function (props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function (element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return measureViewportBox(element, transformPagePoint);
    },
    resetTransform: function (element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        element.scheduleRender();
    },
    restoreTransform: function (instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function (key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    makeTargetAnimatable: function (element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) { isMounted = true; }
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = __rest(_a, ["transition", "transitionEnd"]);
        var origin = getOrigin(target, transition || {}, element);
        if (transformValues) {
            if (transitionEnd)
                transitionEnd = transformValues(transitionEnd);
            if (target)
                target = transformValues(target);
            if (origin)
                origin = transformValues(origin);
        }
        if (isMounted) {
            checkTargetForNewValues(element, target, origin);
            var parsed = parseDomVariant(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return __assign$2({ transition: transition, transitionEnd: transitionEnd }, target);
    },
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    build: function (element, renderState, latestValues, options, props) {
        if (element.isVisible !== undefined) {
            renderState.style.visibility = element.isVisible
                ? "visible"
                : "hidden";
        }
        buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
    },
    render: renderHTML,
};
var htmlVisualElement = visualElement(htmlConfig);

var svgVisualElement = visualElement(__assign$2(__assign$2({}, htmlConfig), { getBaseTarget: function (props, key) {
        return props[key];
    }, readValueFromInstance: function (domElement, key) {
        var _a;
        if (isTransformProp(key)) {
            return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        }
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return domElement.getAttribute(key);
    }, scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, build: function (_element, renderState, latestValues, options, props) {
        buildSVGAttrs(renderState, latestValues, options, props.transformTemplate);
    }, render: renderSVG }));

var createDomVisualElement = function (Component, options) {
    return isSVGComponent(Component)
        ? svgVisualElement(options, { enableHardwareAcceleration: false })
        : htmlVisualElement(options, { enableHardwareAcceleration: true });
};

function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min)
        return 0;
    return (pixels / (axis.max - axis.min)) * 100;
}
var correctBorderRadius = {
    correct: function (latest, node) {
        if (!node.target)
            return latest;
        if (typeof latest === "string") {
            if (px.test(latest)) {
                latest = parseFloat(latest);
            }
            else {
                return latest;
            }
        }
        var x = pixelsToPercent(latest, node.target.x);
        var y = pixelsToPercent(latest, node.target.y);
        return "".concat(x, "% ").concat(y, "%");
    },
};

var varToken = "_$css";
var correctBoxShadow = {
    correct: function (latest, _a) {
        var treeScale = _a.treeScale, projectionDelta = _a.projectionDelta;
        var original = latest;
        var containsCSSVariables = latest.includes("var(");
        var cssVariables = [];
        if (containsCSSVariables) {
            latest = latest.replace(cssVariableRegex, function (match) {
                cssVariables.push(match);
                return varToken;
            });
        }
        var shadow = complex.parse(latest);
        if (shadow.length > 5)
            return original;
        var template = complex.createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        var averageScale = mix(xScale, yScale, 0.5);
        if (typeof shadow[2 + offset] === "number")
            shadow[2 + offset] /= averageScale;
        if (typeof shadow[3 + offset] === "number")
            shadow[3 + offset] /= averageScale;
        var output = template(shadow);
        if (containsCSSVariables) {
            var i_1 = 0;
            output = output.replace(varToken, function () {
                var cssVariable = cssVariables[i_1];
                i_1++;
                return cssVariable;
            });
        }
        return output;
    },
};

var MeasureLayoutWithContext =  (function (_super) {
    __extends(MeasureLayoutWithContext, _super);
    function MeasureLayoutWithContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MeasureLayoutWithContext.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, switchLayoutGroup = _a.switchLayoutGroup, layoutId = _a.layoutId;
        var projection = visualElement.projection;
        addScaleCorrector(defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group)
                layoutGroup.group.add(projection);
            if ((switchLayoutGroup === null || switchLayoutGroup === void 0 ? void 0 : switchLayoutGroup.register) && layoutId) {
                switchLayoutGroup.register(projection);
            }
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", function () {
                _this.safeToRemove();
            });
            projection.setOptions(__assign$2(__assign$2({}, projection.options), { onExitComplete: function () { return _this.safeToRemove(); } }));
        }
        globalProjectionState.hasEverUpdated = true;
    };
    MeasureLayoutWithContext.prototype.getSnapshotBeforeUpdate = function (prevProps) {
        var _this = this;
        var _a = this.props, layoutDependency = _a.layoutDependency, visualElement = _a.visualElement, drag = _a.drag, isPresent = _a.isPresent;
        var projection = visualElement.projection;
        if (!projection)
            return null;
        projection.isPresent = isPresent;
        if (drag ||
            prevProps.layoutDependency !== layoutDependency ||
            layoutDependency === undefined) {
            projection.willUpdate();
        }
        else {
            this.safeToRemove();
        }
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) {
                projection.promote();
            }
            else if (!projection.relegate()) {
                sync.postRender(function () {
                    var _a;
                    if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) {
                        _this.safeToRemove();
                    }
                });
            }
        }
        return null;
    };
    MeasureLayoutWithContext.prototype.componentDidUpdate = function () {
        var projection = this.props.visualElement.projection;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) {
                this.safeToRemove();
            }
        }
    };
    MeasureLayoutWithContext.prototype.componentWillUnmount = function () {
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, promoteContext = _a.switchLayoutGroup;
        var projection = visualElement.projection;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group)
                layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister)
                promoteContext.deregister(projection);
        }
    };
    MeasureLayoutWithContext.prototype.safeToRemove = function () {
        var safeToRemove = this.props.safeToRemove;
        safeToRemove === null || safeToRemove === void 0 ? void 0 : safeToRemove();
    };
    MeasureLayoutWithContext.prototype.render = function () {
        return null;
    };
    return MeasureLayoutWithContext;
}(React__default.Component));
function MeasureLayout(props) {
    var _a = __read(usePresence(), 2), isPresent = _a[0], safeToRemove = _a[1];
    var layoutGroup = useContext(LayoutGroupContext);
    return (React__default.createElement(MeasureLayoutWithContext, __assign$2({}, props, { layoutGroup: layoutGroup, switchLayoutGroup: useContext(SwitchLayoutGroupContext), isPresent: isPresent, safeToRemove: safeToRemove })));
}
var defaultScaleCorrectors = {
    borderRadius: __assign$2(__assign$2({}, correctBorderRadius), { applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
        ] }),
    borderTopLeftRadius: correctBorderRadius,
    borderTopRightRadius: correctBorderRadius,
    borderBottomLeftRadius: correctBorderRadius,
    borderBottomRightRadius: correctBorderRadius,
    boxShadow: correctBoxShadow,
};

var layoutFeatures = {
    measureLayout: MeasureLayout,
};

var DocumentProjectionNode = createProjectionNode({
    attachResizeListener: function (ref, notify) {
        ref.addEventListener("resize", notify, { passive: true });
        return function () { return ref.removeEventListener("resize", notify); };
    },
    measureScroll: function () { return ({
        x: document.documentElement.scrollLeft || document.body.scrollLeft,
        y: document.documentElement.scrollTop || document.body.scrollTop,
    }); },
});

var rootProjectionNode = {
    current: undefined,
};
var HTMLProjectionNode = createProjectionNode({
    measureScroll: function (instance) { return ({
        x: instance.scrollLeft,
        y: instance.scrollTop,
    }); },
    defaultParent: function () {
        if (!rootProjectionNode.current) {
            var documentNode = new DocumentProjectionNode(0, {});
            documentNode.mount(window);
            documentNode.setOptions({ layoutScroll: true });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: function (instance, value) {
        instance.style.transform = value !== null && value !== void 0 ? value : "none";
    },
});

var featureBundle = __assign$2(__assign$2(__assign$2(__assign$2({}, animations), gestureAnimations), drag), layoutFeatures);
var motion =  createMotionProxy(function (Component, config) {
    return createDomMotionConfig(Component, config, featureBundle, createDomVisualElement, HTMLProjectionNode);
});

function useForceUpdate() {
    var isUnmountingRef = useRef(false);
    var _a = __read(useState(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    useUnmountEffect(function () { return (isUnmountingRef.current = true); });
    var forceRender = useCallback(function () {
        !isUnmountingRef.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [forcedRenderCount]);
    var deferredForceRender = useCallback(function () { return sync.postRender(forceRender); }, [forceRender]);
    return [deferredForceRender, forcedRenderCount];
}

var presenceId = 0;
function getPresenceId() {
    var id = presenceId;
    presenceId++;
    return id;
}
var PresenceChild = function (_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = useConstant(newChildrenMap);
    var id = useConstant(getPresenceId);
    var context = useMemo(function () { return ({
        id: id,
        initial: initial,
        isPresent: isPresent,
        custom: custom,
        onExitComplete: function (childId) {
            var e_1, _a;
            presenceChildren.set(childId, true);
            try {
                for (var _b = __values(presenceChildren.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var isComplete = _c.value;
                    if (!isComplete)
                        return;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete();
        },
        register: function (childId) {
            presenceChildren.set(childId, false);
            return function () { return presenceChildren.delete(childId); };
        },
    }); },
    presenceAffectsLayout ? undefined : [isPresent]);
    useMemo(function () {
        presenceChildren.forEach(function (_, key) { return presenceChildren.set(key, false); });
    }, [isPresent]);
    React$4.useEffect(function () {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
    }, [isPresent]);
    return (React$4.createElement(PresenceContext.Provider, { value: context }, children));
};
function newChildrenMap() {
    return new Map();
}

function getChildKey(child) {
    return child.key || "";
}
function updateChildLookup(children, allChildren) {
    var seenChildren = process.env.NODE_ENV !== "production" ? new Set() : null;
    children.forEach(function (child) {
        var key = getChildKey(child);
        if (process.env.NODE_ENV !== "production" && seenChildren) {
            if (seenChildren.has(key)) {
                console.warn("Children of AnimatePresence require unique keys. \"".concat(key, "\" is a duplicate."));
            }
            seenChildren.add(key);
        }
        allChildren.set(key, child);
    });
}
function onlyElements(children) {
    var filtered = [];
    Children.forEach(children, function (child) {
        if (isValidElement(child))
            filtered.push(child);
    });
    return filtered;
}
var AnimatePresence = function (_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    var _d = __read(useForceUpdate(), 1), forceRender = _d[0];
    var forceRenderLayoutGroup = useContext(LayoutGroupContext).forceRender;
    if (forceRenderLayoutGroup)
        forceRender = forceRenderLayoutGroup;
    var isInitialRender = useRef(true);
    var isMounted = useRef(true);
    useEffect(function () { return function () {
        isMounted.current = false;
    }; }, []);
    var filteredChildren = onlyElements(children);
    var presentChildren = useRef(filteredChildren);
    var allChildren = useRef(new Map()).current;
    var exiting = useRef(new Set()).current;
    updateChildLookup(filteredChildren, allChildren);
    if (isInitialRender.current) {
        isInitialRender.current = false;
        return (React$4.createElement(React$4.Fragment, null, filteredChildren.map(function (child) { return (React$4.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout }, child)); })));
    }
    var childrenToRender = __spreadArray([], __read(filteredChildren), false);
    var presentKeys = presentChildren.current.map(getChildKey);
    var targetKeys = filteredChildren.map(getChildKey);
    var numPresent = presentKeys.length;
    for (var i = 0; i < numPresent; i++) {
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) {
            exiting.add(key);
        }
        else {
            exiting.delete(key);
        }
    }
    if (exitBeforeEnter && exiting.size) {
        childrenToRender = [];
    }
    exiting.forEach(function (key) {
        if (targetKeys.indexOf(key) !== -1)
            return;
        var child = allChildren.get(key);
        if (!child)
            return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function () {
            allChildren.delete(key);
            exiting.delete(key);
            var removeIndex = presentChildren.current.findIndex(function (presentChild) { return presentChild.key === key; });
            presentChildren.current.splice(removeIndex, 1);
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false) {
                    return;
                }
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, React$4.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    childrenToRender = childrenToRender.map(function (child) {
        var key = child.key;
        return exiting.has(key) ? (child) : (React$4.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    presentChildren.current = childrenToRender;
    if (process.env.NODE_ENV !== "production" &&
        exitBeforeEnter &&
        childrenToRender.length > 1) {
        console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour.");
    }
    return (React$4.createElement(React$4.Fragment, null, exiting.size
        ? childrenToRender
        : childrenToRender.map(function (child) { return cloneElement(child); })));
};

function counter$1(from, to, duration, toFixed) {
  var _React$useState = React__default.useState(from),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      currentValue = _React$useState2[0],
      setValue = _React$useState2[1];
  React__default.useEffect(function () {
    var controls = animate(from, to, {
      duration: duration !== null && duration !== void 0 ? duration : 1,
      onUpdate: function onUpdate(value) {
        setValue(value.toFixed(toFixed));
      }
    });
    return function () {
      return controls.stop();
    };
  }, [from, to]);
  return currentValue;
}

function truncate(input) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  if (input.length > length) {
    return "".concat(input.substring(0, length), "...");
  }
  return input;
}

var useDidMountEffect = function useDidMountEffect(func, deps) {
  var didMount = React$4.useRef(false);
  React$4.useEffect(function () {
    if (didMount.current) func();else didMount.current = true;
  }, deps);
};

function getScrollHeight() {
  var _React$useState = React$4.useState(0),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      scrollHeight = _React$useState2[0],
      setScrollHeight = _React$useState2[1];
  React$4.useEffect(function () {
    function handleScroll() {
      setScrollHeight(window.pageYOffset);
    }
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return scrollHeight;
}

function getScrollDirection() {
  var _React$useState = React$4.useState(0),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      y = _React$useState2[0],
      setY = _React$useState2[1];
  var _React$useState3 = React$4.useState(''),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      direction = _React$useState4[0],
      setDirection = _React$useState4[1];
  var handleNavigation = React$4.useCallback(function (e) {
    var window = e.currentTarget;
    if (y > window.scrollY) {
      setDirection('up');
    } else if (y < window.scrollY) {
      setDirection('down');
    }
    setY(window.scrollY);
  }, [y]);
  React$4.useEffect(function () {
    setY(window.scrollY);
    window.addEventListener('scroll', handleNavigation);
    return function () {
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [handleNavigation]);
  return direction;
}

function filterBasedOnId(data) {
  for (var _len = arguments.length, ids = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    ids[_key - 1] = arguments[_key];
  }
  return data.filter(function (e) {
    return ids.includes(e._id);
  }).sort(function (a, b) {
    return ids.indexOf(a._id) - ids.indexOf(b._id);
  });
}

function filterBasedOnType(data, type) {
  return data.filter(function (e) {
    return e._type === type;
  });
}

function currencyFormat(amount, locale, currency) {
  var _React$useState = React__default.useState(amount),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      currentAmount = _React$useState2[0],
      setCurrentAmount = _React$useState2[1];
  React__default.useEffect(function () {
    var e = Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      maximumSignificantDigits: 10
    });
    setCurrentAmount(e.format(amount));
  }, [amount]);
  return currentAmount;
}

function easeOutQuart(x) {
  return 1 - Math.pow(1 - x, 4);
}
function animateScroll(_ref) {
  var targetPosition = _ref.targetPosition,
      initialPosition = _ref.initialPosition,
      duration = _ref.duration;
  var start;
  var position;
  var animationFrame;
  var _window = window,
      requestAnimationFrame = _window.requestAnimationFrame;
  var _window2 = window,
      cancelAnimationFrame = _window2.cancelAnimationFrame;
  var maxAvailableScroll = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var amountOfPixelsToScroll = initialPosition - targetPosition;
  function step(timestamp) {
    if (start === undefined) {
      start = timestamp;
    }
    var elapsed = timestamp - start;
    var relativeProgress = elapsed / duration;
    var easedProgress = easeOutQuart(relativeProgress);
    position = initialPosition - amountOfPixelsToScroll * Math.min(easedProgress, 1);
    window.scrollTo(0, position);
    if (initialPosition !== maxAvailableScroll && window.scrollY === maxAvailableScroll) {
      cancelAnimationFrame(animationFrame);
      return;
    }
    if (elapsed < duration) {
      animationFrame = requestAnimationFrame(step);
    }
  }
  animationFrame = requestAnimationFrame(step);
}

var getElementPosition = function getElementPosition(element) {
  return element.offsetTop;
};
function scrollTo(_ref) {
  var id = _ref.id,
      _ref$ref = _ref.ref,
      ref = _ref$ref === void 0 ? null : _ref$ref,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 3000 : _ref$duration;
  var initialPosition = window.scrollY;
  var element = ref ? ref.current : id ? document.getElementById(id) : null;
  if (!element) {
    console.error('[BCU Library]: Invalid element, are you sure you\'ve provided element id or react ref?');
    return;
  }
  animateScroll({
    targetPosition: getElementPosition(element),
    initialPosition: initialPosition,
    duration: duration
  });
}

var toCapital = (function (str) {
  return str.replace(/(^\w|\s\w)/g, function (m) {
    return m.toUpperCase();
  });
});

var useSweetName = function useSweetName(_) {
  return function (name) {
    return {
      HIDDEN: _('name.hidden', {
        ns: 'chargepoint'
      }),
      UMOVE: _('name.umove', {
        ns: 'chargepoint'
      }),
      NANOCHARGE: _('name.nanocharge', {
        ns: 'chargepoint'
      })
    }[name];
  };
};

var Breakpoint = {
  fd: 330,
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1100,
  xl: 1400,
  xxl: 1440,
  max: 1800
};

function useDimensions() {
  var _React$useState = React$4.useState({
    width: undefined,
    height: undefined
  }),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      windowSize = _React$useState2[0],
      setWindowSize = _React$useState2[1];
  React$4.useEffect(function () {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
}

function Row$1(props) {
  var _props$breakpoint;
  var size = useDimensions();
  var breakpoint = Number.isInteger(props.breakpoint) ? props.breakpoint : Breakpoint[(_props$breakpoint = props.breakpoint) !== null && _props$breakpoint !== void 0 ? _props$breakpoint : 'xs'];
  var calcChildWidth = "".concat(props.children.map(function () {
    return "".concat(100 / props.children.length, "%");
  }), " ");
  var renderChild = function renderChild(child, key) {
    return React$4.createElement("div", {
      key: key,
      style: {
        height: '100%',
        width: '100%',
        gridRow: props.invert ? 'unset' : size.width < breakpoint ? key + 1 : size.width <= Breakpoint.xxl && props.children.length === 4 ? key >= 2 ? 1 : 2 : 1
      }
    }, child);
  };
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      display: 'grid',
      gridTemplateColumns: size.width < breakpoint ? '100%' : size.width <= Breakpoint.xxl ? props.disableAuto && props.share ? "".concat(props.share.toString().split(',').join('% '), "%") : '50% 50%' : props.share ? "".concat(props.share.toString().split(',').join('% '), "%") : calcChildWidth.replace(/[,]+/g, ' ')
    }
  }, props.invert ? props.children.map(function (child, key) {
    return renderChild(child, key);
  }).reverse() : props.children.map(function (child, key) {
    return renderChild(child, key);
  }));
}

function Auto(props) {
  var isEven = function isEven(e) {
    if (e % 2 === 0) return true;
    return false;
  };
  var renderChild = function renderChild(child, key) {
    var _ref, _props$gap;
    return React$4.createElement("div", {
      key: key,
      className: "FlexGapLeft FlexGapRight FlexGapTop",
      style: {
        width: props.spacing ? props.children.length === 3 ? "".concat(isEven(key) ? 40 : 20, "%") : "".concat(100 / props.children.length, "%") : "".concat(100 / props.children.length, "%"),
        flex: "1 0 ".concat((_ref = "".concat(props.minWidth, "px")) !== null && _ref !== void 0 ? _ref : '290px'),
        alignSelf: 'stretch',
        marginBottom: (_props$gap = props.gap) !== null && _props$gap !== void 0 ? _props$gap : 0
      }
    }, child);
  };
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      display: 'flex',
      flexWrap: 'wrap'
    }
  }, props.invert ? props.children.map(function (child, key) {
    return renderChild(child, key);
  }).reverse() : props.children.map(function (child, key) {
    return renderChild(child, key);
  }));
}

function Container(props) {
  var render = function render(e) {
    switch (e) {
      case 'row':
        return React$4.createElement(Row$1, {
          share: props.share,
          invert: props.invert,
          breakpoint: props.breakpoint,
          disableAuto: props.disableAuto
        }, props.children);
      case 'auto':
        return React$4.createElement(Auto, {
          invert: props.invert,
          minWidth: props.minWidth,
          gap: props.gap,
          spacing: props.spacing
        }, props.children);
      default:
        return React$4.createElement(Row$1, {
          share: props.share,
          invert: props.invert,
          breakpoint: props.breakpoint,
          disableAuto: props.disableAuto
        }, props.children);
    }
  };
  return React$4.createElement("div", null, render(props.type));
}

function MainContainer$1(props) {
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      width: size.width < Breakpoint.xxl ? '94%' : '75%',
      maxWidth: 1600,
      marginLeft: size.width < Breakpoint.xxl ? '3%' : size.width < Breakpoint.max ? '12.5%' : 'auto',
      marginRight: size.width < Breakpoint.xxl ? '3%' : size.width < Breakpoint.max ? '12.5%' : 'auto'
    }
  }, props.children);
}

function LargeContainer(props) {
  var _props$height;
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      width: size.width < Breakpoint.xxl ? '100%' : '80%',
      maxWidth: 1650,
      height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 'auto',
      marginLeft: size.width < Breakpoint.xxl ? 0 : size.width < Breakpoint.max ? '10%' : 'auto',
      marginRight: size.width < Breakpoint.xxl ? 0 : size.width < Breakpoint.max ? '10%' : 'auto'
    }
  }, props.children);
}

function MainContainer(props) {
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      width: size.width < Breakpoint.xxl ? '94%' : '65%',
      maxWidth: 1400,
      marginLeft: size.width < Breakpoint.xxl ? '3%' : size.width < Breakpoint.max ? '17.5%' : 'auto',
      marginRight: size.width < Breakpoint.xxl ? '3%' : size.width < Breakpoint.max ? '17.5%' : 'auto'
    }
  }, props.children);
}

function Spinner(props) {
  var _props$size, _props$size2, _props$thickness, _props$color, _props$thickness2, _props$color2, _props$thickness3, _props$color3, _props$thickness4;
  return React$4.createElement("div", {
    style: {
      height: (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 30,
      width: (_props$size2 = props.size) !== null && _props$size2 !== void 0 ? _props$size2 : 30,
      borderLeft: "solid ".concat((_props$thickness = props.thickness) !== null && _props$thickness !== void 0 ? _props$thickness : 3, "px ").concat((_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY),
      borderRight: "solid ".concat((_props$thickness2 = props.thickness) !== null && _props$thickness2 !== void 0 ? _props$thickness2 : 3, "px ").concat((_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY),
      borderBottom: "solid ".concat((_props$thickness3 = props.thickness) !== null && _props$thickness3 !== void 0 ? _props$thickness3 : 3, "px ").concat((_props$color3 = props.color) !== null && _props$color3 !== void 0 ? _props$color3 : Colors.GREY),
      borderTop: "solid ".concat((_props$thickness4 = props.thickness) !== null && _props$thickness4 !== void 0 ? _props$thickness4 : 3, "px transparent"),
      borderRadius: '100%',
      backgroundColor: 'transparent',
      animation: 'spinner 1.3s linear infinite'
    }
  });
}

function Loaders(props) {
  var renderLoader = function renderLoader() {
    switch (props.type) {
      case 'spinner':
        return React$4.createElement(Spinner, {
          size: props.size,
          thickness: props.thickness,
          color: props.color
        });
      default:
        return React$4.createElement(Spinner, {
          size: props.size,
          thickness: props.thickness,
          color: props.color
        });
    }
  };
  return React$4.createElement(React$4.Fragment, null, renderLoader());
}

function SmallRound(props) {
  var _props$size, _props$size2, _props$fontSize;
  return React$4.createElement("button", {
    id: props.id,
    onClick: props.onClick,
    type: props.type === 'submit' ? 'submit' : 'button',
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: props.selected ? Colors.BLUE : Colors.MEDIUM_WHITE,
      color: props.selected ? Colors.WHITE : Colors.BLACK,
      borderWidth: 0,
      borderRadius: '100%',
      width: (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 50,
      height: (_props$size2 = props.size) !== null && _props$size2 !== void 0 ? _props$size2 : 50,
      margin: 5,
      paddingLeft: 20,
      paddingRight: 20,
      fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : 'medium',
      fontWeight: 500,
      cursor: 'pointer'
    }
  }, props.loading ? React$4.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Loaders, {
    type: "spinner",
    size: 20,
    color: !props.disabled ? props.colorScheme.vibrant : props.colorScheme.text
  })) : props.text);
}

var getColorScheme = function getColorScheme(name) {
  return ColorSchemesArray.find(function (e) {
    return e.type === name;
  });
};

function Button(props) {
  var _props$height, _props$height2, _props$borderRadius, _props$border, _props$fontSize;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    id: props.id,
    className: "".concat(props.disabled || props.loading ? 'Disabled' : 'Hover', " DisableSelection"),
    type: props.type === 'submit' ? 'submit' : 'button',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: props.disabled || props.loading ? null : props.onClick,
    "aria-label": props.ariaLabel,
    style: {
      width: '100%',
      minWidth: 150,
      minHeight: props.size === 'medium' ? (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40 : (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : 50,
      borderRadius: ((_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : props.size === 'medium') ? 5 : 10,
      border: (_props$border = props.border) !== null && _props$border !== void 0 ? _props$border : props.disabled ? "solid 2px ".concat(props.loading ? props.colorScheme.vibrant : Colors.MEDIUM_WHITE) : props.selectable ? props.selected ? "solid 2px ".concat(props.colorScheme.border) : 'solid 2px transparent' : "solid 2px ".concat(props.colorScheme.border),
      backgroundColor: props.disabled || hover ? props.colorScheme.delicate : props.selectable ? 'transparent' : props.colorScheme.vibrant,
      paddingLeft: 20,
      paddingRight: 20,
      color: !props.disabled && hover ? props.colorScheme.type === 'white' || props.colorScheme.type === 'white-invert' ? hover ? props.colorScheme.type === 'white-invert' ? Colors.WHITE : Colors.GREY : props.colorScheme.text : props.colorScheme.vibrant : props.disabled ? props.disabled.color ? props.disabled.color : Colors.MEDIUM_WHITE : props.colorScheme.type === 'white' ? Colors.DARK_GREY : props.colorScheme.text,
      fontSize: props.size === 'medium' ? '1em' : (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1.1em',
      fontWeight: 500,
      transition: 'all 0.3s linear'
    }
  }, props.loading ? React$4.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Loaders, {
    type: "spinner",
    size: 20,
    color: !props.disabled && hover ? props.colorScheme.vibrant : props.colorScheme.text
  })) : props.text);
}

var IconSetFA = [{name:"AngleDown",type:"light",viewBox:"0 0 256 512",path:[{d:"M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"}]},{name:"AngleRight",type:"light",viewBox:"0 0 192 512",path:[{d:"M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z"}]},{name:"ArrowDown",type:"light",viewBox:"0 0 448 512",path:[{d:"M441.9 250.1l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L250 385.4V44c0-6.6-5.4-12-12-12h-28c-6.6 0-12 5.4-12 12v341.4L42.9 230.3c-4.7-4.7-12.3-4.7-17 0L6.1 250.1c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"}]},{name:"ArrowLeft",type:"light",viewBox:"0 0 448 512",path:[{d:"M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"}]},{name:"ArrowRight",type:"light",viewBox:"0 0 448 512",path:[{d:"M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"}]},{name:"Bomb",type:"light",viewBox:"0 0 512 512",path:[{d:"M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"}]},{name:"Check",type:"light",viewBox:"0 0 512 512",path:[{d:"M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"}]},{name:"CheckCircle",type:"light",viewBox:"0 0 512 512",path:[{d:"M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"}]},{name:"Headset",type:"light",viewBox:"0 0 512 512",path:[{d:"M224 336V192.36c0-17.67-14.33-32-32-32h-48c-35.35 0-64 28.65-64 64V304c0 35.35 28.65 64 64 64h48c17.67 0 32-14.33 32-32zm-48-16h-32c-8.82 0-16-7.18-16-16v-79.64c0-8.82 7.18-16 16-16h32V320zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0zm112 368c35.35 0 64-28.65 64-64v-79.64c0-35.35-28.65-64-64-64h-48c-17.67 0-32 14.33-32 32V336c0 17.67 14.33 32 32 32h48zm-32-159.64h32c8.82 0 16 7.18 16 16V304c0 8.82-7.18 16-16 16h-32V208.36z"}]},{name:"Heart",type:"solid",viewBox:"0 0 512 512",path:[{d:"M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"}]},{name:"Heart",type:"light",viewBox:"0 0 512 512",path:[{d:"M462.3 62.7c-54.5-46.4-136-38.7-186.6 13.5L256 96.6l-19.7-20.3C195.5 34.1 113.2 8.7 49.7 62.7c-62.8 53.6-66.1 149.8-9.9 207.8l193.5 199.8c6.2 6.4 14.4 9.7 22.6 9.7 8.2 0 16.4-3.2 22.6-9.7L472 270.5c56.4-58 53.1-154.2-9.7-207.8zm-13.1 185.6L256.4 448.1 62.8 248.3c-38.4-39.6-46.4-115.1 7.7-161.2 54.8-46.8 119.2-12.9 142.8 11.5l42.7 44.1 42.7-44.1c23.2-24 88.2-58 142.8-11.5 54 46 46.1 121.5 7.7 161.2z"}]},{name:"House",type:"light",viewBox:"0 0 576 512",path:[{d:"M541 229.16l-232.85-190a32.16 32.16 0 0 0-40.38 0L35 229.16a8 8 0 0 0-1.16 11.24l10.1 12.41a8 8 0 0 0 11.2 1.19L96 220.62v243a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-128l64 .3V464a16 16 0 0 0 16 16l128-.33a16 16 0 0 0 16-16V220.62L520.86 254a8 8 0 0 0 11.25-1.16l10.1-12.41a8 8 0 0 0-1.21-11.27zm-93.11 218.59h.1l-96 .3V319.88a16.05 16.05 0 0 0-15.95-16l-96-.27a16 16 0 0 0-16.05 16v128.14H128V194.51L288 63.94l160 130.57z"}]},{name:"Language",type:"light",viewBox:"0 0 640 512",path:[{d:"M184 119.2c0-7-5.7-12.7-12.7-12.7h-.1c-3.4 0-6.6 1.3-8.9 3.7l-28.5 28.5c-2.4 2.4-3.7 5.6-3.7 8.9v.1c0 7 5.7 12.7 12.7 12.7h18c3.4 0 6.6-1.3 8.9-3.7l10.5-10.5c2.4-2.4 3.7-5.6 3.7-8.9v-18.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm48 458.4V432c0-26.5-21.5-48-48-48h-20.2c-3.9 0-13.1-3.1-16.2-5.4l-22.2-16.7c-3.4-2.5-5.4-6.6-5.4-10.8v-23.9c0-4.7 2.5-9.1 6.5-11.6l42.9-25.7c2.1-1.3 4.5-1.9 6.9-1.9h31.2c3.2 0 6.3 1.2 8.8 3.2l52.2 44.8h30.2l17.3 17.3c9.5 9.5 22.1 14.7 35.5 14.7h16.8c-29.9 49.1-78.7 85.3-136.3 98.4zM448.5 336h-32.9c-4.8 0-9.5-1.9-12.9-5.3l-17.3-17.3c-6-6-14.1-9.4-22.6-9.4h-18.3l-43.2-37.1c-8.2-7.1-18.7-10.9-29.6-10.9h-31.2c-8.2 0-16.3 2.2-23.4 6.5l-42.9 25.7c-13.7 8.2-22.1 23-22.1 39v23.9c0 14.3 6.7 27.8 18.2 36.4l22.2 16.7c8.6 6.5 24.6 11.8 35.4 11.8h20.2c8.8 0 16 7.2 16 16v39.2c-5.3.4-10.6.8-16 .8-119.1 0-216-96.9-216-216 0-118.9 96.5-215.6 215.3-216L232 51.1c-10.2 7.7-16 19.2-16 31.4v23.2c0 6.4 3.1 17 5.9 22.3-.8 2.1-21.1 15-24.6 18.5-8.6 8.6-13.3 20-13.3 32.1V195c0 25 20.4 45.4 45.4 45.4h25.3c11 0 21.2-3.9 29.2-10.6 3.9 1.4 8.2 2.1 12.6 2.1h13.4c25.6 0 32.2-20.2 36.1-21.5 5.1 9.1 13.5 16.2 23.5 19.5-4.3 14.2-.9 30.3 10.1 41.6l18.2 19.1c8.7 8.9 20.6 13.9 32.7 13.9h27.7c-2.4 10.8-5.7 21.3-9.7 31.5zm-17.8-63.6c-3.6 0-7.1-1.5-9.6-4L402.6 249a9.93 9.93 0 0 1 .1-14c12.6-12.6 10.5-8.6 10.5-17.8 0-2.5-1-4.9-2.8-6.7l-7.9-7.9c-1.8-1.8-4.2-2.8-6.7-2.8h-13.4c-8.5 0-12.6-10.3-6.7-16.2l7.9-7.3c1.8-1.8 4.2-2.8 6.7-2.8h8.3c5.2 0 9.5-4.2 9.5-9.5v-10.2c0-5.2-4.2-9.5-9.5-9.5h-28.2c-7.4 0-13.4 6-13.4 13.4v5.6c0 5.8-3.7 10.9-9.2 12.7l-26.5 8.8c-4.3 1.4-4.6 5-4.6 8.2 0 3.7-3 6.7-6.7 6.7h-13.4c-3.7 0-6.7-3-6.7-6.7 0-8.4-12.5-8.6-15.3-3-9 12.4-11.5 18.2-19.9 18.2h-25.3c-7.4 0-13.4-6-13.4-13.4v-16.4c0-3.6 1.4-7 3.9-9.5 19.5-14 29.6-17.6 29.6-31.5 0-2.9 1.8-5.5 4.6-6.4l33.6-11.2c1.4-.5 2.7-1.2 3.7-2.3L313.9 95c5-5 3.5-14.9-6.7-14.9h-17.4L276.4 99v6.7c0 3.7-3 6.7-6.7 6.7h-15c-3.7 0-6.7-3-6.7-6.7V82.5c0-2.1 1-4.1 2.7-5.4l44-31.9C391.4 66.7 464 153 464 256c0 5.5-.4 11-.8 16.4h-32.5z"}]},{name:"Leaf",type:"light",viewBox:"0 0 576 512",path:[{d:"M546.2 9.7c-2.9-6.5-8.6-9.7-14.3-9.7-5.3 0-10.7 2.8-14 8.5C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 20.9 3.4 40.9 9.6 59.7C29.3 413 1.4 489.4.9 490.7c-2.9 8.3 1.5 17.5 9.8 20.4 7.9 2.8 17.4-1.1 20.4-9.8.4-1.2 23.9-65.1 87.6-122.7C151.1 438.9 214.7 480 288 480c6.9 0 13.7-.4 20.4-1.1C465.5 467.5 576 326.8 576 154.3c0-50.2-10.8-102.2-29.8-144.6zM305 447.1c-5.9.6-11.6.9-17 .9-63.3 0-117.6-37.2-143.5-90.6C196.3 319 268.6 288 368 288c8.8 0 16-7.2 16-16s-7.2-16-16-16c-102.8 0-179 31-234.8 70.4-3.1-12.4-5.2-25.1-5.2-38.4 0-88.2 71.8-160 160-160h80c63.3 0 121-28.4 159.7-77.2 10.5 32.3 16.3 68.7 16.3 103.5 0 159.6-100.1 282.7-239 292.8z"}]},{name:"MagicWand",type:"light",viewBox:"0 0 512 512",path:[{d:"M80 160l26.66-53.33L160 80l-53.33-26.67L80 0 53.33 53.33 0 80l53.33 26.67L80 160zm351.99 128l-26.66 53.33L351.99 368l53.33 26.67L431.99 448l26.66-53.33L511.98 368l-53.33-26.67L431.99 288zm-208-192l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zm208 96c8.84 0 16-7.16 16-16v-34.11L502.02 82c13.81-15.22 13.22-38.53-1.31-53.09l-17.66-17.63c-14.5-14.52-37.84-15.08-53-1.36L157.28 256H112c-8.84 0-16 7.16-16 16v39.28l-78.53 70.84-.06.05C6.72 391.86.38 405.69.04 420.12c-.37 14.44 5.28 28.58 15.5 38.81l37.53 37.52c9.87 9.92 23.5 15.55 37.5 15.55 22.17 0 35.57-13.37 39.28-17.47L402.78 192h29.21zM94.22 462.36c-.82.91-4.23 3.24-7.22.17l-37.53-37.52c-2.97-3.01-.73-6.44.16-7.27L455.49 51.61l4.91 4.88L94.22 462.36z"}]},{name:"Minus",type:"light",viewBox:"0 0 384 512",path:[{d:"M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"}]},{name:"Office",type:"light",viewBox:"0 0 448 512",path:[{d:"M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"}]},{name:"Pause",type:"light",viewBox:"0 0 448 512",path:[{d:"M192 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm-48 346V85c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h84c3.3 0 6-2.7 6-6zM448 79v352c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm-48 346V85c0-3.3-2.7-6-6-6h-84c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h84c3.3 0 6-2.7 6-6z"}]},{name:"Play",type:"light",viewBox:"0 0 448 512",path:[{d:"M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6zM48 453.5v-395c0-4.6 5.1-7.5 9.1-5.2l334.2 197.5c3.9 2.3 3.9 8 0 10.3L57.1 458.7c-4 2.3-9.1-.6-9.1-5.2z"}]},{name:"Required",type:"light",viewBox:"0 0 480 512",path:[{d:"M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"}]},{name:"YouTube",type:"light",viewBox:"0 0 576 512",path:[{d:"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}]},{name:"Linkedin",type:"light",viewBox:"0 0 448 512",path:[{d:"M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"}]},{name:"Instagram",type:"light",viewBox:"0 0 448 512",path:[{d:"M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"}]},{name:"At",type:"light",viewBox:"0 0 512 512",path:[{d:"M256 8C118.941 8 8 118.919 8 256c0 137.058 110.919 248 248 248 52.925 0 104.68-17.078 147.092-48.319 5.501-4.052 6.423-11.924 2.095-17.211l-5.074-6.198c-4.018-4.909-11.193-5.883-16.307-2.129C346.93 457.208 301.974 472 256 472c-119.373 0-216-96.607-216-216 0-119.375 96.607-216 216-216 118.445 0 216 80.024 216 200 0 72.873-52.819 108.241-116.065 108.241-19.734 0-23.695-10.816-19.503-33.868l32.07-164.071c1.449-7.411-4.226-14.302-11.777-14.302h-12.421a12 12 0 0 0-11.781 9.718c-2.294 11.846-2.86 13.464-3.861 25.647-11.729-27.078-38.639-43.023-73.375-43.023-68.044 0-133.176 62.95-133.176 157.027 0 61.587 33.915 98.354 90.723 98.354 39.729 0 70.601-24.278 86.633-46.982-1.211 27.786 17.455 42.213 45.975 42.213C453.089 378.954 504 321.729 504 240 504 103.814 393.863 8 256 8zm-37.92 342.627c-36.681 0-58.58-25.108-58.58-67.166 0-74.69 50.765-121.545 97.217-121.545 38.857 0 58.102 27.79 58.102 65.735 0 58.133-38.369 122.976-96.739 122.976z"}]},{name:"User",type:"light",viewBox:"0 0 512 512",path:[{d:"M256 32c61.8 0 112 50.2 112 112s-50.2 112-112 112-112-50.2-112-112S194.2 32 256 32m128 320c52.9 0 96 43.1 96 96v32H32v-32c0-52.9 43.1-96 96-96 85 0 67.3 16 128 16 60.9 0 42.9-16 128-16M256 0c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144S335.5 0 256 0zm128 320c-92.4 0-71 16-128 16-56.8 0-35.7-16-128-16C57.3 320 0 377.3 0 448v32c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-32c0-70.7-57.3-128-128-128z"}]},{name:"Bell",type:"light",viewBox:"0 0 512 512",path:[{d:"M224 480c-17.66 0-32-14.38-32-32.03h-32c0 35.31 28.72 64.03 64 64.03s64-28.72 64-64.03h-32c0 17.65-14.34 32.03-32 32.03zm209.38-145.19c-27.96-26.62-49.34-54.48-49.34-148.91 0-79.59-63.39-144.5-144.04-152.35V16c0-8.84-7.16-16-16-16s-16 7.16-16 16v17.56C127.35 41.41 63.96 106.31 63.96 185.9c0 94.42-21.39 122.29-49.35 148.91-13.97 13.3-18.38 33.41-11.25 51.23C10.64 404.24 28.16 416 48 416h352c19.84 0 37.36-11.77 44.64-29.97 7.13-17.82 2.71-37.92-11.26-51.22zM400 384H48c-14.23 0-21.34-16.47-11.32-26.01 34.86-33.19 59.28-70.34 59.28-172.08C95.96 118.53 153.23 64 224 64c70.76 0 128.04 54.52 128.04 121.9 0 101.35 24.21 138.7 59.28 172.08C421.38 367.57 414.17 384 400 384z"}]},{name:"SignOut",type:"light",viewBox:"0 0 512 512",path:[{d:"M48 64h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48zm279 19.5l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l132 131.4H172c-6.6 0-12 5.4-12 12v10c0 6.6 5.4 12 12 12h279.9L320 404.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l164.5-164c4.7-4.7 4.7-12.3 0-17L344 83.5c-4.7-4.7-12.3-4.7-17 0z"}]},{name:"TabMenu",type:"light",viewBox:"0 0 512 512",path:[{d:"M442,176L6,176C2.708,176 0,173.292 0,170L0,146C-0,142.708 2.708,140 6,140L442,140C445.292,140 448,142.708 448,146L448,170C448,173.292 445.292,176 442,176ZM442,366L110,366C106.708,366 104,363.292 104,360L104,336C104,332.708 106.708,330 110,330L442,330C445.292,330 448,332.708 448,336L448,360C448,363.292 445.292,366 442,366Z"}]},{name:"TabHome",type:"light",viewBox:"0 0 512 512",path:[{d:"M128,136C114.75,136 104,146.74 104,160C104,173.25 114.75,184 128,184C141.25,184 152,173.25 152,160C152,146.74 141.25,136 128,136ZM128,328C114.75,328 104,338.74 104,352C104,365.25 114.75,376 128,376C141.25,376 152,365.25 152,352C152,338.74 141.25,328 128,328ZM320,136C306.75,136 296,146.74 296,160C296,173.25 306.75,184 320,184C333.25,184 344,173.25 344,160C344,146.74 333.25,136 320,136ZM320,328C306.75,328 296,338.74 296,352C296,365.25 306.75,376 320,376C333.25,376 344,365.25 344,352C344,338.74 333.25,328 320,328Z"}]},{name:"CalendarCheck",type:"light",viewBox:"0 0 448 512",path:[{d:"M400 64h-48V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H128V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM48 96h352c8.822 0 16 7.178 16 16v48H32v-48c0-8.822 7.178-16 16-16zm352 384H48c-8.822 0-16-7.178-16-16V192h384v272c0 8.822-7.178 16-16 16zm-66.467-194.937l-134.791 133.71c-4.7 4.663-12.288 4.642-16.963-.046l-67.358-67.552c-4.683-4.697-4.672-12.301.024-16.985l8.505-8.48c4.697-4.683 12.301-4.672 16.984.024l50.442 50.587 117.782-116.837c4.709-4.671 12.313-4.641 16.985.068l8.458 8.527c4.672 4.709 4.641 12.313-.068 16.984z"}]},{name:"ChevronRight",type:"light",viewBox:"0 0 256 512",path:[{d:"M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"}]},{name:"ChevronLeft",type:"light",viewBox:"0 0 256 512",path:[{d:"M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"}]},{name:"Search",type:"light",viewBox:"0 0 512 512",path:[{d:"M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"}]},{name:"Ellipsis-H",type:"light",viewBox:"0 0 320 512",path:[{d:"M192 256c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm88-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-240 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}]},{name:"Bin",type:"light",viewBox:"0 0 448 512",path:[{d:"M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z"}]},{name:"BuildingWithCar",type:"light",viewBox:"0 0 640 512",path:[{d:"M595.4 294.44l-15.88-68.83A63.71 63.71 0 0 0 517.16 176H344.07a63.7 63.7 0 0 0-62.36 49.61l-16.28 70.55C241 308.44 224 333.49 224 362.67v55.11a46.14 46.14 0 0 0 32 43.75V496a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-32h256v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-34.47a46.14 46.14 0 0 0 32-43.75v-55.11a74.7 74.7 0 0 0-44.6-68.23zM312.89 232.8a32 32 0 0 1 31.18-24.8h173.09a32 32 0 0 1 31.18 24.8l12.73 55.2H300.15zM608 417.78A14.24 14.24 0 0 1 593.78 432H270.22A14.24 14.24 0 0 1 256 417.78v-55.11A42.72 42.72 0 0 1 298.67 320h266.66A42.72 42.72 0 0 1 608 362.67zM320 48v96h32V48a48 48 0 0 0-48-48H48A48 48 0 0 0 0 48v392a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V48a16 16 0 0 1 16-16h256a16 16 0 0 1 16 16zM204 96a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm-56 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm160 64a20 20 0 1 0 20 20 20 20 0 0 0-20-20zm248 0a20 20 0 1 0 20 20 20 20 0 0 0-20-20zM148 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm102.53 122.42a96.81 96.81 0 0 1 5.16-15.95A11.86 11.86 0 0 0 244 192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h37.85z"}]},{name:"Garage",type:"light",viewBox:"0 0 640 512",path:[{d:"M368,416H272a16,16,0,0,0,0,32h96a16,16,0,0,0,0-32ZM610.59,118.33,338.59,3.75a48,48,0,0,0-37.18,0l-272,114.58A47.84,47.84,0,0,0,0,162.53V504a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V162.53a16,16,0,0,1,9.81-14.79l272-114.6a15.75,15.75,0,0,1,12.38,0l272,114.6A15.91,15.91,0,0,1,608,162.53V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V162.53A47.84,47.84,0,0,0,610.59,118.33ZM512,192H128a32,32,0,0,0-32,32V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V352H512V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V224A32,32,0,0,0,512,192Zm0,128H128V224H512Z"}]},{name:"Parking",type:"light",viewBox:"0 0 496 512",path:[{d:"M268.1 127.91H176c-4.42 0-8 3.58-8 8v240c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72h72c51.43 0 92.68-44.32 87.57-96.78-4.45-45.71-45.54-79.22-91.47-79.22zm3.9 144h-72v-112h72c30.88 0 56 25.12 56 56s-25.12 56-56 56zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216z"}]},{name:"Warehouse",type:"light",viewBox:"0 0 640 512",path:[{d:"M512 224H128c-17.7 0-32 14.4-32 32v248c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56h384v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V256c0-17.6-14.3-32-32-32zm0 192H128v-64h384v64zm0-96H128v-64h384v64zm98.6-201.7L338.6 3.7c-11.8-5-25.3-5-37.2 0l-272 114.6C11.5 125.8 0 143.2 0 162.5V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V162.5c0-6.5 3.8-12.2 9.8-14.8l272-114.6c3.9-1.7 8.5-1.7 12.4 0l272 114.6c6 2.5 9.8 8.3 9.8 14.8V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V162.5c0-19.3-11.5-36.7-29.4-44.2z"}]},{name:"WarehouseBoxes",type:"light",viewBox:"0 0 640 512",path:[{d:"M528 352H352V240c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM320 480H128v-96h192v96zm0-128H128v-96h192v96zm192 128H352v-96h160v96zm98.6-361.7L338.6 3.7c-11.8-5-25.3-5-37.2 0l-272 114.6C11.5 125.8 0 143.2 0 162.5V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V162.5c0-6.5 3.8-12.2 9.8-14.8l272-114.6c3.9-1.7 8.5-1.7 12.4 0l272 114.6c6 2.5 9.8 8.3 9.8 14.8V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V162.5c0-19.3-11.5-36.7-29.4-44.2z"}]},{name:"Plug",type:"light",viewBox:"0 0 384 512",path:[{d:"M352,128H304V16a16,16,0,0,0-32,0V128H112V16a16,16,0,0,0-32,0V128H32A32,32,0,0,0,0,160v32a32,32,0,0,0,32,32v32c0,82.75,63.37,150.22,144,158.38V512h32V414.38c80.63-8.16,144-75.63,144-158.38V224a32,32,0,0,0,32-32V160A32,32,0,0,0,352,128ZM320,256a128,128,0,0,1-256,0V224H320Zm32-64H32V160H352Z"}]},{name:"HouseSignal",type:"light",viewBox:"0 0 640 512",path:[{d:"M0,224v32c141.38,0,256,114.62,256,256h32C288,352.94,159.06,224,0,224Zm0,96v32A160,160,0,0,1,160,512h32C192,406,106,320,0,320Zm0,96v32a64,64,0,0,1,64,64H96A96,96,0,0,0,0,416ZM634.53,200,576,148.76V48a16,16,0,1,0-32,0v72.74L410.53,4a16,16,0,0,0-21.06,0L224,148.76h0L165.47,200a16,16,0,1,0,21.06,24.09L224,191.29h0v70.79a337.37,337.37,0,0,1,32,32.61V168a15.35,15.35,0,0,0-.81-4L400,37.27l144,126V368a16,16,0,0,1-16,16H310.61a333,333,0,0,1,11.29,32H528a48.05,48.05,0,0,0,48-48V191.28l37.46,32.79A16,16,0,0,0,634.53,200ZM442.67,288A21.39,21.39,0,0,0,464,266.67V181.34A21.39,21.39,0,0,0,442.67,160h-85.3A21.39,21.39,0,0,0,336,181.34v85.33A21.39,21.39,0,0,0,357.37,288ZM368,192H432v64H368Z"}]},{name:"Ballot",type:"light",viewBox:"0 0 448 512",path:[{d:"M144 80h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32zm0 64h-32v-32h32v32zM416 0H32C14.3 0 0 14.4 0 32v448c0 17.6 14.3 32 32 32h384c17.7 0 32-14.4 32-32V32c0-17.6-14.3-32-32-32zm0 480H32V32h384v448zm-72-240H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-200 96h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32zm0 64h-32v-32h32v32zm200-32H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0-256H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-200 96h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32zm0 64h-32v-32h32v32z"}]},{name:"Card",type:"light",viewBox:"0 0 576 512",path:[{d:"M528 31H48C21.5 31 0 52.5 0 79v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V79c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V79c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v352zm-352-68v8c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v8c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"}]},{name:"CalendarDay",type:"light",viewBox:"0 0 448 512",path:[{d:"M400 64h-48V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56H128V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V192h384v272zm0-304H32v-48c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v48zM112 384h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm16-96h64v64h-64v-64z"}]},{name:"Cog",type:"light",viewBox:"0 0 512 512",path:[{d:"M482.696 299.276l-32.61-18.827a195.168 195.168 0 0 0 0-48.899l32.61-18.827c9.576-5.528 14.195-16.902 11.046-27.501-11.214-37.749-31.175-71.728-57.535-99.595-7.634-8.07-19.817-9.836-29.437-4.282l-32.562 18.798a194.125 194.125 0 0 0-42.339-24.48V38.049c0-11.13-7.652-20.804-18.484-23.367-37.644-8.909-77.118-8.91-114.77 0-10.831 2.563-18.484 12.236-18.484 23.367v37.614a194.101 194.101 0 0 0-42.339 24.48L105.23 81.345c-9.621-5.554-21.804-3.788-29.437 4.282-26.36 27.867-46.321 61.847-57.535 99.595-3.149 10.599 1.47 21.972 11.046 27.501l32.61 18.827a195.168 195.168 0 0 0 0 48.899l-32.61 18.827c-9.576 5.528-14.195 16.902-11.046 27.501 11.214 37.748 31.175 71.728 57.535 99.595 7.634 8.07 19.817 9.836 29.437 4.283l32.562-18.798a194.08 194.08 0 0 0 42.339 24.479v37.614c0 11.13 7.652 20.804 18.484 23.367 37.645 8.909 77.118 8.91 114.77 0 10.831-2.563 18.484-12.236 18.484-23.367v-37.614a194.138 194.138 0 0 0 42.339-24.479l32.562 18.798c9.62 5.554 21.803 3.788 29.437-4.283 26.36-27.867 46.321-61.847 57.535-99.595 3.149-10.599-1.47-21.972-11.046-27.501zm-65.479 100.461l-46.309-26.74c-26.988 23.071-36.559 28.876-71.039 41.059v53.479a217.145 217.145 0 0 1-87.738 0v-53.479c-33.621-11.879-43.355-17.395-71.039-41.059l-46.309 26.74c-19.71-22.09-34.689-47.989-43.929-75.958l46.329-26.74c-6.535-35.417-6.538-46.644 0-82.079l-46.329-26.74c9.24-27.969 24.22-53.869 43.929-75.969l46.309 26.76c27.377-23.434 37.063-29.065 71.039-41.069V44.464a216.79 216.79 0 0 1 87.738 0v53.479c33.978 12.005 43.665 17.637 71.039 41.069l46.309-26.76c19.709 22.099 34.689 47.999 43.929 75.969l-46.329 26.74c6.536 35.426 6.538 46.644 0 82.079l46.329 26.74c-9.24 27.968-24.219 53.868-43.929 75.957zM256 160c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"}]},{name:"Scroll",type:"light",viewBox:"0 0 640 512",path:[{d:"M608 352h-64V112C544 50.25 493.75 0 432 0H80C35.88 0 0 35.89 0 80v80c0 17.64 14.34 32 32 32h96v224c0 51.11 40.25 92.62 90.66 95.46v.54h312C590.94 512 640 462.95 640 402.67V384c0-17.64-14.34-32-32-32zM128 160H32V80c0-26.47 21.53-48 48-48s48 21.53 48 48v80zm160 256c0 35.3-28.72 64-64 64s-64-28.7-64-64V80c0-18-5.97-34.62-16.03-48H432c44.12 0 80 35.89 80 80v240H320c-17.66 0-32 14.36-32 32v32zm320-13.33c0 42.64-34.69 77.33-77.34 77.33H295.03c15.35-17.02 24.97-39.32 24.97-64v-32h288v18.67z"}]},{name:"Pencil",type:"light",viewBox:"0 0 512 512",path:[{d:"M493.255 56.236l-37.49-37.49c-24.993-24.993-65.515-24.994-90.51 0L12.838 371.162.151 485.346c-1.698 15.286 11.22 28.203 26.504 26.504l114.184-12.687 352.417-352.417c24.992-24.994 24.992-65.517-.001-90.51zM164.686 347.313c6.249 6.249 16.379 6.248 22.627 0L368 166.627l30.059 30.059L174 420.745V386h-48v-48H91.255l224.059-224.059L345.373 144 164.686 324.687c-6.249 6.248-6.249 16.378 0 22.626zm-38.539 121.285l-58.995 6.555-30.305-30.305 6.555-58.995L63.255 366H98v48h48v34.745l-19.853 19.853zm344.48-344.48l-49.941 49.941-82.745-82.745 49.941-49.941c12.505-12.505 32.748-12.507 45.255 0l37.49 37.49c12.506 12.506 12.507 32.747 0 45.255z"}]},{name:"Info",type:"light",viewBox:"0 0 192 512",path:[{d:"M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"}]},{name:"Folder",type:"light",viewBox:"0 0 512 512",path:[{d:"M194.74 96l54.63 54.63c6 6 14.14 9.37 22.63 9.37h192c8.84 0 16 7.16 16 16v224c0 8.84-7.16 16-16 16H48c-8.84 0-16-7.16-16-16V112c0-8.84 7.16-16 16-16h146.74M48 64C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48z"}]},{name:"InfoCircle",type:"light",viewBox:"0 0 512 512",path:[{d:"M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"}]},{name:"ExclamationCircle",type:"light",viewBox:"0 0 512 512",path:[{d:"M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"}]},{name:"Plus",type:"light",viewBox:"0 0 384 512",path:[{d:"M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"}]},{name:"RocketLaunch",type:"light",viewBox:"0 0 512 512",path:[{d:"M368.05829,88.0293a55.99512,55.99512,0,1,0,55.99215,55.99414A56.01694,56.01694,0,0,0,368.05829,88.0293Zm0,79.99218a23.998,23.998,0,1,1,23.99608-23.998A24.02247,24.02247,0,0,1,368.05829,168.02148ZM505.1656,19.29492C503.98982,13.832,498.18123,8.0293,492.71835,6.86133,460.63244,0,435.48793,0,410.45084,0,307.26342,0,245.38261,55.19727,199.18734,127.98828H95.01555c-16.293,0-35.58786,11.92188-42.87692,26.4961L2.73242,253.27344A28.4,28.4,0,0,0,.2168,263.97656a24.00493,24.00493,0,0,0,23.99607,23.998H128.13466a95.98845,95.98845,0,0,1,95.98625,95.99023V487.95508a24.00243,24.00243,0,0,0,23.99608,23.998,28.53884,28.53884,0,0,0,10.70116-2.51562l98.71671-49.40039c14.55663-7.28516,26.46678-26.5625,26.46678-42.83984V312.76758C456.568,266.46094,511.982,204.37109,511.982,101.69336,512.0738,76.54492,512.0738,51.39648,505.1656,19.29492ZM37.15427,255.97656l43.60152-87.18164c1.85156-3.70508,10.11523-8.81054,14.25976-8.81054h85.08c-13.93554,28.06054-31.71287,63.99609-47.55465,95.99218l.0664.45313C131.08778,256.377,61.01753,255.97656,37.15427,255.97656Zm314.8513,161.22071c0,4.13085-5.09179,12.375-8.789,14.22461L256.115,475.01172c0-23.90234-.4043-94.06055-.46094-95.60938l.36719.04688c31.99606-15.82617,67.80267-33.58984,95.85929-47.541l.125.002Zm-102.078-70.51368a127.62739,127.62739,0,0,0-84.6347-84.55468c52.02731-103.98633,99.76945-230.13282,245.158-230.13282,21.164,0,41.29684,0,65.41987,4.1875,4.26562,24.377,4.1914,44.38477,4.11523,65.50977C479.98594,246.66406,353.00752,295.1543,249.92753,346.68359Zm-147.494-26.71289C54.35347,319.9707,2.03125,359.31836.168,480H0v32H32v-.23242C203.617,508.42969,216.8885,396.74414,165.80065,345.40039,150.85925,330.38477,127.22255,319.9707,102.43351,319.9707Zm52.914,109.39844c-12.83593,31.14844-57.63667,49.42969-123.36709,50.55078.06446-3.55469-1.11914-127.88867,70.45307-127.88867,15.09569,0,31.11521,6.29492,40.81051,16.03906C156.05456,380.94336,164.6483,406.80273,155.34753,429.36914Z"}]},{name:"QuestionMarkCircle",type:"light",viewBox:"0 0 512 512",path:[{d:"M256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28zm7.67-24h-16c-6.627 0-12-5.373-12-12v-.381c0-70.343 77.44-63.619 77.44-107.408 0-20.016-17.761-40.211-57.44-40.211-29.144 0-44.265 9.649-59.211 28.692-3.908 4.98-11.054 5.995-16.248 2.376l-13.134-9.15c-5.625-3.919-6.86-11.771-2.645-17.177C185.658 133.514 210.842 116 255.67 116c52.32 0 97.44 29.751 97.44 80.211 0 67.414-77.44 63.849-77.44 107.408V304c0 6.627-5.373 12-12 12zM256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8z"}]},{name:"HandHoldingSeedling",type:"light",viewBox:"0 0 576 512",path:[{d:"M248.9 192H272v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56h23.1C411.4 192 480 113 480 16V0h-55.1C364.9 0 313 40.1 288 98.1 263 40.1 211.1 0 151.1 0H96v16c0 97 68.6 176 152.9 176zm176-160h22.4c-6.7 71.9-58 128-120.1 128h-22.4c6.6-71.9 58-128 120.1-128zm-273.8 0c62.1 0 113.4 56.1 120.1 128h-22.4c-62.1 0-113.4-56.1-120.1-128h22.4zm407.2 301.6c-9.6-8.6-22.1-13.4-35.2-13.4-12.5 0-24.8 4.3-34.6 12.2l-61.6 49.3c-1.9 1.5-4.2 2.3-6.7 2.3h-41.6c4.6-9.6 6.5-20.7 4.8-32.3-4-27.9-29.6-47.7-57.8-47.7H181.3c-20.8 0-41 6.7-57.6 19.2L85.3 352H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88l46.9-35.2c11.1-8.3 24.6-12.8 38.4-12.8H328c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88c-8.8 0-16 7.2-16 16s7.2 16 16 16h180.2c9.7 0 19.1-3.3 26.7-9.3l61.6-49.2c4.2-3.4 9.5-5.2 14.6-5.2 5 0 9.9 1.7 13.8 5.2 10.1 9.1 9.3 24.5-.9 32.6l-100.8 80.7c-7.6 6.1-17 9.3-26.7 9.3H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h400.5c17 0 33.4-5.8 46.6-16.4L556 415c12.2-9.8 19.5-24.4 20-40s-6-30.8-17.7-41.4z"}]},{name:"Phone",type:"light",viewBox:"0 0 512 512",path:[{d:"M493.09 351.3L384.7 304.8a31.36 31.36 0 0 0-36.5 8.9l-44.1 53.9A350 350 0 0 1 144.5 208l53.9-44.1a31.35 31.35 0 0 0 8.9-36.49l-46.5-108.5A31.33 31.33 0 0 0 125 .81L24.2 24.11A31.05 31.05 0 0 0 0 54.51C0 307.8 205.3 512 457.49 512A31.23 31.23 0 0 0 488 487.7L511.19 387a31.21 31.21 0 0 0-18.1-35.7zM456.89 480C222.4 479.7 32.3 289.7 32.1 55.21l99.6-23 46 107.39-72.8 59.5C153.3 302.3 209.4 358.6 313 407.2l59.5-72.8 107.39 46z"}]},{name:"Envelope",type:"light",viewBox:"0 0 512 512",path:[{d:"M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z"}]},{name:"EnvelopeOpen",type:"light",viewBox:"0 0 512 512",path:[{d:"M349.32 52.26C328.278 35.495 292.938 0 256 0c-36.665 0-71.446 34.769-93.31 52.26-34.586 27.455-109.525 87.898-145.097 117.015A47.99 47.99 0 0 0 0 206.416V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V206.413a47.989 47.989 0 0 0-17.597-37.144C458.832 140.157 383.906 79.715 349.32 52.26zM464 480H48c-8.837 0-16-7.163-16-16V206.161c0-4.806 2.155-9.353 5.878-12.392C64.16 172.315 159.658 95.526 182.59 77.32 200.211 63.27 232.317 32 256 32c23.686 0 55.789 31.27 73.41 45.32 22.932 18.207 118.436 95.008 144.714 116.468a15.99 15.99 0 0 1 5.876 12.39V464c0 8.837-7.163 16-16 16zm-8.753-216.312c4.189 5.156 3.393 12.732-1.776 16.905-22.827 18.426-55.135 44.236-104.156 83.148-21.045 16.8-56.871 52.518-93.318 52.258-36.58.264-72.826-35.908-93.318-52.263-49.015-38.908-81.321-64.716-104.149-83.143-5.169-4.173-5.966-11.749-1.776-16.905l5.047-6.212c4.169-5.131 11.704-5.925 16.848-1.772 22.763 18.376 55.014 44.143 103.938 82.978 16.85 13.437 50.201 45.69 73.413 45.315 23.219.371 56.562-31.877 73.413-45.315 48.929-38.839 81.178-64.605 103.938-82.978 5.145-4.153 12.679-3.359 16.848 1.772l5.048 6.212z"}]},{name:"Bug",viewBox:"0 0 576 512",type:"solid",path:[{d:"M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"}]},{name:"Flag",viewBox:"0 0 512 512",type:"solid",path:[{d:"M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm430.6 4.2C291.3 91.5 305.4-62.2 96 32.4V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8V30.8c0-25.1-26.8-38.1-49.4-26.6z"}]}];

var IconSetFeather = [{name:"Eye",viewBox:"0 0 24 24",path:[{d:"M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"}],circle:[{cx:"12",cy:"12",r:"3"}]},{name:"EyeSlash",viewBox:"0 0 24 24",path:[{d:"M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"}],line:[{x1:"1",y1:"1",x2:"23",y2:"23"}]},{name:"ChevronLeft",viewBox:"0 0 24 24",points:[{points:"15 18 9 12 15 6"}]},{name:"ChevronRight",viewBox:"0 0 24 24",points:[{points:"9 18 15 12 9 6"}]},{name:"Times",viewBox:"0 0 24 24",line:[{x1:"18",y1:"6",x2:"6",y2:"18"},{x1:"6",y1:"6",x2:"18",y2:"18"}]},{name:"List",viewBox:"0 0 24 24",line:[{x1:"8",y1:"6",x2:"21",y2:"6"},{x1:"8",y1:"12",x2:"21",y2:"12"},{x1:"8",y1:"18",x2:"21",y2:"18"},{x1:"3",y1:"6",x2:"3.01",y2:"6"},{x1:"3",y1:"12",x2:"3.01",y2:"12"},{x1:"3",y1:"18",x2:"3.01",y2:"18"}]},{name:"Grid",viewBox:"0 0 24 24",rect:[{x:"3",y:"3",width:"7",height:"7"},{x:"14",y:"3",width:"7",height:"7"},{x:"14",y:"14",width:"7",height:"7"},{x:"3",y:"14",width:"7",height:"7"}]},{name:"Map",viewBox:"0 0 24 24",points:[{points:"1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"}],line:[{x1:"8",y1:"2",x2:"8",y2:"18"},{x1:"16",y1:"6",x2:"16",y2:"22"}]},{name:"MapPin",viewBox:"0 0 24 24",path:[{d:"M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"}],circle:[{cx:"12",cy:"10",r:"3"}]},{name:"Download",viewBox:"0 0 24 24",path:[{d:"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"}],points:[{points:"7 10 12 15 17 10"}],line:[{x1:"12",y1:"15",x2:"12",y2:"3"}]},{name:"Filter",viewBox:"0 0 24 24",points:[{points:"22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"}]},{name:"Edit",viewBox:"0 0 24 24",path:[{d:"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"},{d:"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"}]},{name:"Upload",viewBox:"0 0 24 24",path:[{d:"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"}],points:[{points:"17 8 12 3 7 8"}],line:[{x1:"12",y1:"3",x2:"12",y2:"15"}]},{name:"Bin",viewBox:"0 0 24 24",points:[{points:"3 6 5 6 21 6"}],path:[{d:"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"}]}];

var IconSetBlueCurrent = [{name:"UMOVE",viewBox:"0 0 2500 2500",path:[{d:"M1142.36 2441.48h214.286c458.809-18.976 573.762-163.321 573.762-338.333v-1706c0-187.899-186.078-340.453-680.905-340.453S568.598 209.248 568.598 397.147v1706c.517 182.246 116.264 337.72 573.762 338.333m107.143-700.262c147.833 0 267.857 120.024 267.857 267.857 0 147.834-120.024 267.857-267.857 267.857-147.833 0-267.857-120.023-267.857-267.857 0-147.833 120.024-267.857 267.857-267.857Z",style:{fill:"none",fillRule:"nonzero",stroke:"#37424A",strokeWidth:"113.39px"}},{d:"M1666.17 294.79h-54.167c-29.256 0-52.976 23.721-52.976 52.977v435.119c0 131.494-106.601 238.095-238.095 238.095h-142.858c-131.494 0-238.095-106.601-238.095-238.095V347.808c0-29.279-23.738-53.018-53.018-53.018h-54.125v500c0 184.096 149.238 333.334 333.334 333.334h166.666c96.792 0 183.953-41.256 244.846-107.143 54.928-59.429 88.488-138.887 88.488-226.191v-500Z",style:{fill:"#37424A",fillRule:"nonzero",stroke:"none"}}]}];

var Icon = function (_React$PureComponent) {
  _inherits$3(Icon, _React$PureComponent);
  var _super = _createSuper$4(Icon);
  function Icon() {
    _classCallCheck$3(this, Icon);
    return _super.apply(this, arguments);
  }
  _createClass$3(Icon, [{
    key: "render",
    value: function render() {
      var _this = this,
          _this$props$height,
          _this$props$width,
          _this$props$color,
          _this$props$color2,
          _this$props$position,
          _this$props$marginLef,
          _this$props$marginRig,
          _this$props$marginTop,
          _this$props$marginBot,
          _this$props$opacity,
          _this$props$left,
          _this$props$right;
      var GrabIcon = function GrabIcon() {
        var e = null;
        switch (_this.props.iconSet) {
          case 'FA':
            e = IconSetFA.find(function (item) {
              return _this.props.type ? item.name === _this.props.name && item.type === _this.props.type : item.name === _this.props.name;
            });
            break;
          case 'Feather':
            e = IconSetFeather.find(function (item) {
              return item.name === _this.props.name;
            });
            break;
          case 'BlueCurrent':
            e = IconSetBlueCurrent.find(function (item) {
              return item.name === _this.props.name;
            });
            break;
          default:
            e = IconSetFA.find(function (item) {
              return item.name === _this.props.name;
            });
            break;
        }
        if (!e) {
          console.warn("[BCU Library]: props.name is undefined: Name: ".concat(_this.props.name, ", Height: ").concat(_this.props.height, ", Width: ").concat(_this.props.width, ", Color: ").concat(_this.props.color, ", IconSet: ").concat(_this.props.iconSet));
          return {
            viewBox: '0 0 0 0',
            path: false,
            circle: false,
            line: false,
            points: false,
            rect: false
          };
        }
        return {
          viewBox: e.viewBox,
          path: e.path,
          circle: e.circle,
          line: e.line,
          points: e.points,
          rect: e.rect
        };
      };
      return React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: GrabIcon().viewBox,
        height: (_this$props$height = this.props.height) !== null && _this$props$height !== void 0 ? _this$props$height : '10px',
        width: (_this$props$width = this.props.width) !== null && _this$props$width !== void 0 ? _this$props$width : '10px',
        fill: this.props.iconSet === 'Feather' || this.props.iconSet === 'BlueCurrent' ? 'transparent' : (_this$props$color = this.props.color) !== null && _this$props$color !== void 0 ? _this$props$color : Colors.RED,
        stroke: this.props.iconSet === 'Feather' ? (_this$props$color2 = this.props.color) !== null && _this$props$color2 !== void 0 ? _this$props$color2 : Colors.RED : 'transparent',
        strokeWidth: this.props.iconSet === 'Feather' ? 2 : this.props.strokeWidth,
        strokeLinejoin: this.props.iconSet === 'Feather' ? 'round' : 'none',
        strokeLinecap: this.props.iconSet === 'Feather' ? 'round' : 'none',
        style: {
          position: (_this$props$position = this.props.position) !== null && _this$props$position !== void 0 ? _this$props$position : 'relative',
          marginLeft: (_this$props$marginLef = this.props.marginLeft) !== null && _this$props$marginLef !== void 0 ? _this$props$marginLef : 0,
          marginRight: (_this$props$marginRig = this.props.marginRight) !== null && _this$props$marginRig !== void 0 ? _this$props$marginRig : 0,
          marginTop: (_this$props$marginTop = this.props.marginTop) !== null && _this$props$marginTop !== void 0 ? _this$props$marginTop : 0,
          marginBottom: (_this$props$marginBot = this.props.marginBottom) !== null && _this$props$marginBot !== void 0 ? _this$props$marginBot : 0,
          transition: this.props.transition,
          opacity: (_this$props$opacity = this.props.opacity) !== null && _this$props$opacity !== void 0 ? _this$props$opacity : 1,
          left: (_this$props$left = this.props.left) !== null && _this$props$left !== void 0 ? _this$props$left : 0,
          right: (_this$props$right = this.props.right) !== null && _this$props$right !== void 0 ? _this$props$right : 0,
          transform: this.props.transform,
          zIndex: this.props.zIndex
        }
      }, this.props.name === false ? React__default.createElement("div", {
        style: {
          height: 200,
          width: 200,
          backgroundColor: Colors.RED
        }
      }, React__default.createElement("p", null, "ERROR")) : React__default.createElement(React__default.Fragment, null, GrabIcon().path && GrabIcon().path.map(function (e, i) {
        return React__default.createElement("path", {
          key: i,
          d: e.d,
          style: {
            fill: _this.props.iconSet === 'BlueCurrent' ? e.style !== undefined && e.style.fill !== 'none' && e.style.fill ? _this.props.color : 'transparent' : e.style !== undefined && e.style.fill,
            fillRule: e.style !== undefined && e.style.fillRule,
            stroke: _this.props.iconSet === 'BlueCurrent' ? e.style !== undefined && e.style.stroke !== 'none' && e.style.stroke ? _this.props.color : 'transparent' : e.style !== undefined && e.style.stroke,
            strokeWidth: e.style !== undefined && e.style.strokeWidth
          }
        });
      }), GrabIcon().circle && GrabIcon().circle.map(function (e, i) {
        return React__default.createElement("circle", {
          key: i,
          cx: e.cx,
          cy: e.cy,
          r: e.r
        });
      }), GrabIcon().line && GrabIcon().line.map(function (e, i) {
        return React__default.createElement("line", {
          key: i,
          x1: e.x1,
          y1: e.y1,
          x2: e.x2,
          y2: e.y2
        });
      }), GrabIcon().points && GrabIcon().points.map(function (e, i) {
        return React__default.createElement("polyline", {
          key: i,
          points: e.points
        });
      }), GrabIcon().rect && GrabIcon().rect.map(function (e, i) {
        return React__default.createElement("rect", {
          key: i,
          x: e.x,
          y: e.y,
          height: e.height,
          width: e.width
        });
      })));
    }
  }]);
  return Icon;
}(React__default.PureComponent);

function Link$1(props) {
  var _props$borderRadius, _props$icon$width, _props$icon$height, _props$icon$color, _props$color;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    className: "".concat(props.disabled ? 'Disabled' : props.selected ? 'Default' : 'Hover', " DisableSelection"),
    type: "button",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: props.disabled ? null : props.onClick,
    style: {
      height: 40,
      width: '100%',
      backgroundColor: props.selected ? Colors.LIGHT_WHITE : 'transparent',
      border: 'solid 0px transparent',
      textAlign: 'left',
      fontFamily: 'Museo-Sans',
      fontSize: '1.1em',
      fontWeight: 300,
      color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY,
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: (_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : 10
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      height: 40,
      width: 30,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingLeft: 5,
      marginRight: 10
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    width: (_props$icon$width = props.icon.width) !== null && _props$icon$width !== void 0 ? _props$icon$width : 15,
    height: (_props$icon$height = props.icon.height) !== null && _props$icon$height !== void 0 ? _props$icon$height : 15,
    color: props.disabled ? Colors.MEDIUM_GREY : (_props$icon$color = props.icon.color) !== null && _props$icon$color !== void 0 ? _props$icon$color : Colors.RED,
    iconSet: props.icon.iconSet
  })), props.text, React$4.createElement(AnimatePresence, null, !props.disabled && !props.selected && hover && React$4.createElement(motion.div, {
    style: {
      position: 'absolute',
      top: 10,
      marginRight: 15
    },
    initial: {
      right: 20,
      opacity: 0
    },
    animate: {
      right: 0,
      opacity: 1
    },
    exit: {
      right: 20,
      opacity: 0
    },
    transition: {
      duration: 0.2
    }
  }, React$4.createElement(Icon, {
    name: "ArrowRight",
    width: 15,
    height: 15,
    color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
  }))));
}

function IconButton(props) {
  var _props$height, _props$height2, _props$height3, _props$height4, _props$border, _props$borderRadius, _props$icon$width, _props$icon$height, _props$colorScheme$te;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    className: "".concat(props.disabled ? 'Disabled' : 'Hover', " DisableSelection"),
    type: "button",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: props.disabled ? null : props.onClick,
    style: {
      height: props.size === 'medium' ? (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40 : (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : 50,
      width: props.size === 'medium' ? (_props$height3 = props.height) !== null && _props$height3 !== void 0 ? _props$height3 : 40 : (_props$height4 = props.height) !== null && _props$height4 !== void 0 ? _props$height4 : 50,
      border: (_props$border = props.border) !== null && _props$border !== void 0 ? _props$border : props.disabled ? "solid 2px ".concat(Colors.MEDIUM_WHITE) : "solid 2px ".concat(props.colorScheme.border),
      backgroundColor: props.disabled || hover ? props.colorScheme.delicate : props.selectable ? 'transparent' : props.colorScheme.vibrant,
      borderRadius: ((_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : props.size === 'medium') ? 5 : 10,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.3s linear'
    }
  }, props.loading ? React$4.createElement(Loaders, {
    size: 20
  }) : React$4.createElement(Icon, {
    name: props.icon.name,
    width: (_props$icon$width = props.icon.width) !== null && _props$icon$width !== void 0 ? _props$icon$width : 15,
    height: (_props$icon$height = props.icon.height) !== null && _props$icon$height !== void 0 ? _props$icon$height : 15,
    color: hover ? props.icon.color : (_props$colorScheme$te = props.colorScheme.text) !== null && _props$colorScheme$te !== void 0 ? _props$colorScheme$te : Colors.RED,
    iconSet: props.icon.iconSet
  }));
}

function Buttons$1(props) {
  var renderButtons = function renderButtons() {
    var _props$colorScheme, _props$colorScheme2, _props$colorScheme3;
    switch (props.type) {
      case 'link':
        return React$4.createElement(Link$1, {
          text: props.text,
          colorScheme: getColorScheme("".concat((_props$colorScheme = props.colorScheme) !== null && _props$colorScheme !== void 0 ? _props$colorScheme : 'blue')),
          disabled: props.disabled,
          onClick: props.onClick,
          loading: props.loading,
          icon: props.icon,
          selected: props.selected,
          borderRadius: props.borderRadius
        });
      case 'icon':
        return React$4.createElement(IconButton, {
          disabled: props.disabled,
          onClick: props.onClick,
          icon: props.icon,
          selected: props.selected,
          height: props.height,
          size: props.size,
          styling: props.styling,
          border: props.border,
          colorScheme: getColorScheme("".concat((_props$colorScheme2 = props.colorScheme) !== null && _props$colorScheme2 !== void 0 ? _props$colorScheme2 : 'blue')),
          borderRadius: props.borderRadius,
          loading: props.loading
        });
      default:
        return React$4.createElement(Button, {
          id: props.id,
          type: props.type,
          text: props.text,
          colorScheme: getColorScheme("".concat((_props$colorScheme3 = props.colorScheme) !== null && _props$colorScheme3 !== void 0 ? _props$colorScheme3 : 'blue')),
          disabled: props.disabled,
          onClick: props.onClick,
          loading: props.loading,
          size: props.size,
          height: props.height,
          border: props.border,
          selectable: props.selectable,
          selected: props.selected,
          fontSize: props.fontSize,
          ariaLabel: props.ariaLabel,
          borderRadius: props.borderRadius
        });
    }
  };
  return React$4.createElement(React$4.Fragment, null, renderButtons());
}

function _typeof$4(obj) {
  "@babel/helpers - typeof";
  return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$4(obj);
}

function _defineProperty$g(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"'
};
var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};
var unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$h(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape
};
var i18nInstance;
var I18nContext = createContext();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread$h(_objectSpread$h({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck$2(this, ReportNamespaces);
    this.usedNamespaces = {};
  }
  _createClass$2(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;
      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);
  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

function warn() {
  if (console && console.warn) {
    var _console;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };
      i18n.on('initialized', initialized);
    }
  });
}
function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;
  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };
  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}
function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }
  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }
  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}

function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$2(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _unsupportedIterableToArray$5(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen);
}

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$2();
}

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$g(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var usePrevious = function usePrevious(value, ignore) {
  var ref = useRef();
  useEffect(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};
function useTranslation$1(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;
  var _ref = useContext(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;
  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');
    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };
    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
  var i18nOptions = _objectSpread$g(_objectSpread$g(_objectSpread$g({}, getDefaults()), i18n.options.react), props);
  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });
  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }
  var _useState = useState(getT),
      _useState2 = _slicedToArray$2(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];
  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = useRef(true);
  useEffect(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }
    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }
    function boundReset() {
      if (isMounted.current) setT(getT);
    }
    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = useRef(true);
  useEffect(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }
    isInitial.current = false;
  }, [i18n]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}

var useTranslation = function useTranslation() {
  var _useTranslationNext = useTranslation$1.apply(void 0, arguments),
      t = _useTranslationNext.t,
      i18n = _useTranslationNext.i18n;
  var _ = function _(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return HTMLReactParser$1(t(key, options));
  };
  return {
    _: _,
    i18n: i18n
  };
};

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$2(o, p);
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _possibleConstructorReturn$2(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$2(self);
}

function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$2(o);
}

function _iterableToArray$5(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _toArray(arr) {
  return _arrayWithHoles$2(arr) || _iterableToArray$5(arr) || _unsupportedIterableToArray$5(arr) || _nonIterableRest$2();
}

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$f(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};
var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck$2(this, Logger);
    this.init(concreteLogger, options);
  }
  _createClass$2(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$f(_objectSpread$f({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }]);
  return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck$2(this, EventEmitter);
    this.observers = {};
  }
  _createClass$2(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;
      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];
        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;
      if (!listener) {
        delete this.observers[event];
        return;
      }
      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }
      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);
        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);
  return EventEmitter;
}();
function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy$1(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}
function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }
  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }
  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }
  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}
function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;
  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;
  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;
  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }
  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);
  if (!matched) {
    var ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
}
function ownKeys$1$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;
  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }
    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];
      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }
      if (mix === undefined) return undefined;
      if (mix === null) return null;
      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }
      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }
    current = current[paths[i]];
  }
  return current;
}
var ResourceStore = function (_EventEmitter) {
  _inherits$2(ResourceStore, _EventEmitter);
  var _super = _createSuper$2(ResourceStore);
  function ResourceStore(data) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };
    _classCallCheck$2(this, ResourceStore);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$2(_this));
    }
    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }
    return _this;
  }
  _createClass$2(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);
      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }
      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};
      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1$1(_objectSpread$1$1({}, pack), resources);
      }
      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }
      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1$1(_objectSpread$1$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);
  return ResourceStore;
}(EventEmitter);
var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;
    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};
function ownKeys$2$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _createSuper$1$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }
function _isNativeReflectConstruct$1$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};
var Translator = function (_EventEmitter) {
  _inherits$2(Translator, _EventEmitter);
  var _super = _createSuper$1$1(Translator);
  function Translator(services) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck$2(this, Translator);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$2(_this));
    }
    copy$1(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized$2(_this));
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    _this.logger = baseLogger.create('translator');
    return _this;
  }
  _createClass$2(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      if (key === undefined || key === null) {
        return false;
      }
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);
        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }
      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;
      if (_typeof$4(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }
      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;
      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }
          return "".concat(namespace).concat(nsSeparator).concat(key);
        }
        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }
        return key;
      }
      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }
          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2$1(_objectSpread$2$1({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }
          return r;
        }
        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2$1(_objectSpread$2$1({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }
          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }
        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }
        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2$1(_objectSpread$2$1({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }
          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }
            _this2.emit('missingKey', l, namespace, k, res);
          };
          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }
        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }
      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }
      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;
      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2$1(_objectSpread$2$1({}, options), {
          interpolation: _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;
        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }
        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }
        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
            return null;
          }
          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }
      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2$1({
          i18nResolved: resolved
        }, options) : options, this);
      }
      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;
        var extracted = _this4.extractFromKey(k, options);
        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;
          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }
          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];
            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);
                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }
              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);
                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);
                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }
            var possibleKey;
            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';
      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }
      return false;
    }
  }]);
  return Translator;
}(EventEmitter);
function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck$2(this, LanguageUtil);
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  _createClass$2(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');
        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }
        return p.join('-');
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }
      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;
      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;
        var cleanedLng = _this.formatLanguageCode(code);
        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });
      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;
          var lngOnly = _this.getLanguagePartFromCode(code);
          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }
      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;
      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];
      var addCode = function addCode(c) {
        if (!c) return;
        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }
      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);
  return LanguageUtil;
}();
var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}
var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck$2(this, PluralResolver);
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }
    this.rules = createRules();
  }
  _createClass$2(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (!rule) {
        return [];
      }
      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }
      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);
      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }
        return this.getSuffixRetroCompatible(rule, count);
      }
      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;
      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }
      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);
  return PluralResolver;
}();
function ownKeys$3$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck$2(this, Interpolator);
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };
    this.init(options);
  }
  _createClass$2(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;
      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }
      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3$1(_objectSpread$3$1(_objectSpread$3$1({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }
        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3$1(_objectSpread$3$1(_objectSpread$3$1({}, options), data), {}, {
          interpolationkey: k
        }));
      };
      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;
        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);
          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }
          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);
          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }
          replaces++;
          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;
      var clonedOptions = _objectSpread$3$1({}, options);
      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;
      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');
        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3$1(_objectSpread$3$1({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }
        delete clonedOptions.defaultValue;
        return key;
      }
      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;
        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);
        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }
        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3$1(_objectSpread$3$1({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }
      return str;
    }
  }]);
  return Interpolator;
}();
function ownKeys$4$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;
        var _opt$split = opt.split(':'),
            _opt$split2 = _toArray(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);
        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }
  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}
var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck$2(this, Formatter);
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: function number(val, lng, options) {
        return new Intl.NumberFormat(lng, options).format(val);
      },
      currency: function currency(val, lng, options) {
        return new Intl.NumberFormat(lng, _objectSpread$4$1(_objectSpread$4$1({}, options), {}, {
          style: 'currency'
        })).format(val);
      },
      datetime: function datetime(val, lng, options) {
        return new Intl.DateTimeFormat(lng, _objectSpread$4$1({}, options)).format(val);
      },
      relativetime: function relativetime(val, lng, options) {
        return new Intl.RelativeTimeFormat(lng, _objectSpread$4$1({}, options)).format(val, options.range || 'day');
      },
      list: function list(val, lng, options) {
        return new Intl.ListFormat(lng, _objectSpread$4$1({}, options)).format(val);
      }
    };
    this.init(options);
  }
  _createClass$2(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;
      var formats = _format.split(this.formatSeparator);
      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;
        if (_this.formats[formatName]) {
          var formatted = mem;
          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4$1(_objectSpread$4$1(_objectSpread$4$1({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }
          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }
        return mem;
      }, value);
      return result;
    }
  }]);
  return Formatter;
}();
function ownKeys$5$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _createSuper$2$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }
function _isNativeReflectConstruct$2$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}
var Connector = function (_EventEmitter) {
  _inherits$2(Connector, _EventEmitter);
  var _super = _createSuper$2$1(Connector);
  function Connector(backend, store, services) {
    var _this;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck$2(this, Connector);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$2(_this));
    }
    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.state = {};
    _this.queue = [];
    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }
  _createClass$2(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;
      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);
          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });
      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }
      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);
      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }
      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);
        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];
            if (loadedKeys.length) {
              loadedKeys.forEach(function (ns) {
                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
              });
            }
          });
          q.done = true;
          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;
      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }
      this.readingCalls++;
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }
        _this3.readingCalls--;
        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();
          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }
        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;
      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }
      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);
      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }
      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }
      if (key === undefined || key === null || key === '') return;
      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5$1(_objectSpread$5$1({}, options), {}, {
          isUpdate: isUpdate
        }));
      }
      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);
  return Connector;
}(EventEmitter);
function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof$4(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];
      if (_typeof$4(args[2]) === 'object' || _typeof$4(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  return options;
}
function ownKeys$6$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function noop$1() {}
function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}
var I18n = function (_EventEmitter) {
  _inherits$2(I18n, _EventEmitter);
  var _super = _createSuper$3(I18n);
  function I18n() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck$2(this, I18n);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$2(_this));
    }
    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized$2(_this));
    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);
        return _possibleConstructorReturn$2(_this, _assertThisInitialized$2(_this));
      }
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }
  _createClass$2(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      if (!options.defaultNS && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }
      var defOpts = get();
      this.options = _objectSpread$6$1(_objectSpread$6$1(_objectSpread$6$1({}, defOpts), this.options), transformOptions(options));
      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6$1(_objectSpread$6$1({}, defOpts.interpolation), this.options.interpolation);
      }
      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }
      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }
      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }
      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }
        var formatter;
        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }
        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }
        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }
        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop$1;
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }
      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }
      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;
          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;
          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
          return _this2;
        };
      });
      var deferred = defer();
      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
          _this2.emit('initialized', _this2.options);
          deferred.resolve(t);
          callback(err, t);
        };
        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
        _this2.changeLanguage(_this2.options.lng, finish);
      };
      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }
      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;
      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];
        var append = function append(lng) {
          if (!lng) return;
          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };
        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }
        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }
        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop$1;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
      if (module.type === 'backend') {
        this.modules.backend = module;
      }
      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }
      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }
      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }
      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }
      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }
      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }
      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;
      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;
      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);
      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;
        _this4.setResolvedLanguage(l);
      };
      var done = function done(err, l) {
        if (l) {
          setLngProps(l);
          _this4.translator.changeLanguage(l);
          _this4.isLanguageChangingTo = undefined;
          _this4.emit('languageChanged', l);
          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }
        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };
      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }
          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }
        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };
      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }
      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;
      var fixedT = function fixedT(key, opts) {
        var options;
        if (_typeof$4(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }
          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6$1({}, opts);
        }
        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };
      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }
      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;
      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;
      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }
      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }
      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;
      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
      };
      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }
      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;
      var deferred = defer();
      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }
      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });
      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }
      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
      var mergedOptions = _objectSpread$6$1(_objectSpread$6$1(_objectSpread$6$1({}, this.options), options), {
        isClone: true
      });
      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6$1({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);
  return I18n;
}(EventEmitter);
_defineProperty$g(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
instance.createInstance;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;

var email$5="E-mail";var password$2="Wachtwoord";var login$2="Log in";var forgotPassword$2="Wachtwoord vergeten";var errors$5={invalidCredentials:"Foutieve inloggegevens",emailRequired:"E-mail is verplicht",passwordRequired:"Wachtwoord is verplicht",invalidEmail:"Dit zou een geldig e-mail adres moeten zijn",invalidPassword:"Incorrect wachtwoord",usernameRequired:"Gebruikersnaam is verplicht"};var account$2="Account";var logout$2="Log uit";var content$2={subtitle:"Log in met je Blue Current account."};var updatePassword$2="Wachtwoord aanpassen";var oldPassword$2="Oude wachtwoord";var newPassword$2="Nieuw wachtwoord";var confirmNewPassword$2="Bevestig nieuw wachtwoord";var phone$2="Telefoonnummer";var confirmEnterPassword$2="Om deze instelling te bevestigen, voer je wachtwoord in";var resetPassword$2="Je wachtwoord opnieuw instellen";var enterEmailToResetPassword$2="Voer het e-mailadres van je account in. We sturen je dan een link om je wachtwoord opnieuw in te stellen";var backToLogin$2="Terug naar inloggen";var accountInformation$2="Accountinformatie";var forgotPasswordEnterPassword$2="Voer alstublieft uw nieuwe wachtwoord in.";var username$2="Gebruikersnaam";var accountUpdated$2="Account bijgewerkt";var AuthenticationNL = {email:email$5,password:password$2,login:login$2,forgotPassword:forgotPassword$2,errors:errors$5,account:account$2,logout:logout$2,content:content$2,updatePassword:updatePassword$2,oldPassword:oldPassword$2,newPassword:newPassword$2,confirmNewPassword:confirmNewPassword$2,phone:phone$2,confirmEnterPassword:confirmEnterPassword$2,resetPassword:resetPassword$2,enterEmailToResetPassword:enterEmailToResetPassword$2,backToLogin:backToLogin$2,accountInformation:accountInformation$2,forgotPasswordEnterPassword:forgotPasswordEnterPassword$2,username:username$2,accountUpdated:accountUpdated$2};

var email$4="E-mail";var password$1="Password";var login$1="Login";var forgotPassword$1="Forgot password";var errors$4={invalidCredentials:"Invalid username or password",emailRequired:"E-mail is required",passwordRequired:"Password is required",invalidEmail:"This should be a valid e-mail address",invalidPassword:"Invalid password",usernameRequired:"Username is required"};var account$1="Account";var logout$1="Logout";var content$1={subtitle:"Sign in with your Blue Current account."};var updatePassword$1="Update password";var oldPassword$1="Old password";var newPassword$1="New password";var confirmNewPassword$1="Confirm new password";var phone$1="Phone number";var confirmEnterPassword$1="To confirm this setting please enter your password";var resetPassword$1="Reset your password";var enterEmailToResetPassword$1="Enter your account email address. We will then send you a link to reset your password";var backToLogin$1="Back to login";var accountInformation$1="Account Information";var forgotPasswordEnterPassword$1="Please enter your new password.";var username$1="Username";var accountUpdated$1="Account updated";var AuthenticationEN = {email:email$4,password:password$1,login:login$1,forgotPassword:forgotPassword$1,errors:errors$4,account:account$1,logout:logout$1,content:content$1,updatePassword:updatePassword$1,oldPassword:oldPassword$1,newPassword:newPassword$1,confirmNewPassword:confirmNewPassword$1,phone:phone$1,confirmEnterPassword:confirmEnterPassword$1,resetPassword:resetPassword$1,enterEmailToResetPassword:enterEmailToResetPassword$1,backToLogin:backToLogin$1,accountInformation:accountInformation$1,forgotPasswordEnterPassword:forgotPasswordEnterPassword$1,username:username$1,accountUpdated:accountUpdated$1};

var email$3="[EEEE-måååîîîļ]";var password="[PPåååššwöööŕď]";var login="[LLöööǧîîîกี้]";var forgotPassword="[FFöööŕǧöööṫ þåååššwöööŕď]";var errors$3={invalidCredentials:"[IIIIกี้våååļîîîď ūūūšéééŕกี้åååmééé öööŕ þåååššwöööŕď]",emailRequired:"[EEEE-måååîîîļ îîîš ŕéééqūūūîîîŕéééď]",passwordRequired:"[PPåååššwöööŕď îîîš ŕéééqūūūîîîŕéééď]",invalidEmail:"[TTḥîîîš šḥöööūūūļď bééé ååå våååļîîîď ééé-måååîîîļ åååďďŕéééšš]",invalidPassword:"[IIIIกี้våååļîîîď þåååššwöööŕď]",usernameRequired:"[UUUUšéééŕกี้åååmééé îîîš ŕéééqūūūîîîŕéééď]"};var account="[AAAAççöööūūūกี้ṫ]";var logout="[LLöööǧöööūūūṫ]";var content={subtitle:"[SSîîîǧกี้ îîîกี้ wîîîṫḥ Ýöööūūūŕ Bļūūūééé Cūūūŕŕéééกี้ṫ åååççöööūūūกี้ṫ.]"};var updatePassword="[UUUUþďåååṫééé þåååššwöööŕď]";var oldPassword="[OOOOļď þåååššwöööŕď]";var newPassword="[NNéééw þåååššwöööŕď]";var confirmNewPassword="[CCöööกี้ḟîîîŕm กี้éééw þåååššwöööŕď]";var phone="[PPḥöööกี้ééé กี้ūūūmbéééŕ]";var confirmEnterPassword="[TTööö çöööกี้ḟîîîŕm ṫḥîîîš šéééṫṫîîîกี้ǧ þļéééåååšééé éééกี้ṫéééŕ Ýöööūūūŕ þåååššwöööŕď]";var resetPassword="[RRéééšéééṫ Ýöööūūūŕ þåååššwöööŕď]";var enterEmailToResetPassword="[EEEEกี้ṫéééŕ Ýöööūūūŕ åååççöööūūūกี้ṫ ééémåååîîîļ åååďďŕéééšš. Wééé wîîîļļ ṫḥéééกี้ šéééกี้ď Ýöööūūū ååå ļîîîกี้ḱ ṫööö ŕéééšéééṫ Ýöööūūūŕ þåååššwöööŕď]";var backToLogin="[BBåååçḱ ṫööö ļöööǧîîîกี้]";var accountInformation="[AAAAççöööūūūกี้ṫ IIIกี้ḟöööŕmåååṫîîîöööกี้]";var forgotPasswordEnterPassword="[PPļéééåååšééé éééกี้ṫéééŕ Ýöööūūūŕ กี้éééw þåååššwöööŕď.]";var username="[UUUUšéééŕกี้åååmééé]";var accountUpdated="[AAAAççöööūūūกี้ṫ ūūūþďåååṫéééď]";var AuthenticationPSEUDO = {email:email$3,password:password,login:login,forgotPassword:forgotPassword,errors:errors$3,account:account,logout:logout,content:content,updatePassword:updatePassword,oldPassword:oldPassword,newPassword:newPassword,confirmNewPassword:confirmNewPassword,phone:phone,confirmEnterPassword:confirmEnterPassword,resetPassword:resetPassword,enterEmailToResetPassword:enterEmailToResetPassword,backToLogin:backToLogin,accountInformation:accountInformation,forgotPasswordEnterPassword:forgotPasswordEnterPassword,username:username,accountUpdated:accountUpdated};

var language$2="Taal";var nl$2="Nederlands";var en$2="English";var settings$5="Instellingen";var preferences$2="Voorkeuren";var personalInformation$2="Persoonlijke informatie";var changePassword$2="Wachtwoord wijzigen";var privacy$2="Privacy";var analytics$2="Analytics";var languageDescription$2="Selecteer de taal die wordt gebruikt voor het weergeven van menu's, berichten en notificaties.";var firstName$2="Voornaam";var lastName$2="Achternaam";var analyticsDescription$2="Analytics helpt ons onze diensten te verbeteren door informatie over het gebruik ervan te verzamelen en te rapporteren.";var iban$2="IBAN";var agreement$2="Contract";var ibanError$2={invalidCode:"IBAN is niet valide",noAcceptedCountry:"Alleen IBAN's uit {{accepted}} zijn mogelijk"};var developerMode$2="Ontwikkelaar modus";var developers$2="Ontwikkelaars";var api$2="API";var apiKey$2="API Key";var generateApiKey$2="API key genereren";var locationManagement$2="Locatiebeheer";var SettingsNL = {language:language$2,nl:nl$2,en:en$2,settings:settings$5,preferences:preferences$2,personalInformation:personalInformation$2,changePassword:changePassword$2,privacy:privacy$2,analytics:analytics$2,languageDescription:languageDescription$2,firstName:firstName$2,lastName:lastName$2,analyticsDescription:analyticsDescription$2,iban:iban$2,agreement:agreement$2,ibanError:ibanError$2,developerMode:developerMode$2,developers:developers$2,api:api$2,apiKey:apiKey$2,generateApiKey:generateApiKey$2,locationManagement:locationManagement$2};

var language$1="Language";var nl$1="Nederlands";var en$1="English";var settings$4="Settings";var preferences$1="Preferences";var personalInformation$1="Personal information";var changePassword$1="Change password";var privacy$1="Privacy";var analytics$1="Analytics";var languageDescription$1="Select the language that is used for menu's, messages and notifications.";var firstName$1="First name";var lastName$1="Last name";var analyticsDescription$1="Analytics help us to improve our services by collecting and reporting information of its usage.";var iban$1="IBAN";var agreement$1="Agreement";var ibanError$1={invalidCode:"IBAN is not valid",noAcceptedCountry:"Only IBAN's from {{accepted}} are accepted"};var developerMode$1="Developer mode";var developers$1="Developers";var api$1="API";var apiKey$1="API Key";var generateApiKey$1="Generate API key";var locationManagement$1="Location management";var SettingsEN = {language:language$1,nl:nl$1,en:en$1,settings:settings$4,preferences:preferences$1,personalInformation:personalInformation$1,changePassword:changePassword$1,privacy:privacy$1,analytics:analytics$1,languageDescription:languageDescription$1,firstName:firstName$1,lastName:lastName$1,analyticsDescription:analyticsDescription$1,iban:iban$1,agreement:agreement$1,ibanError:ibanError$1,developerMode:developerMode$1,developers:developers$1,api:api$1,apiKey:apiKey$1,generateApiKey:generateApiKey$1,locationManagement:locationManagement$1};

var language="[LLåååกี้ǧūūūåååǧééé]";var nl="[NNéééďéééŕļåååกี้ďš]";var en="[EEEEกี้ǧļîîîšḥ]";var settings$3="[SSéééṫṫîîîกี้ǧš]";var preferences="[PPŕéééḟéééŕéééกี้çéééš]";var personalInformation="[PPéééŕšöööกี้åååļ îîîกี้ḟöööŕmåååṫîîîöööกี้]";var changePassword="[CCḥåååกี้ǧééé þåååššwöööŕď]";var privacy="[PPŕîîîvåååçÝ]";var analytics="[AAAAกี้åååļÝṫîîîçš]";var languageDescription="[SSéééļéééçṫ ṫḥééé ļåååกี้ǧūūūåååǧééé ṫḥåååṫ îîîš ūūūšéééď ḟöööŕ méééกี้ūūū'š, méééššåååǧéééš åååกี้ď กี้öööṫîîîḟîîîçåååṫîîîöööกี้š.]";var firstName="[FFîîîŕšṫ กี้åååmééé]";var lastName="[LLåååšṫ กี้åååmééé]";var analyticsDescription="[AAAAกี้åååļÝṫîîîçš ḥéééļþ ūūūš ṫööö îîîmþŕööövééé öööūūūŕ šéééŕvîîîçéééš bÝ çöööļļéééçṫîîîกี้ǧ åååกี้ď ŕéééþöööŕṫîîîกี้ǧ îîîกี้ḟöööŕmåååṫîîîöööกี้ öööḟ îîîṫš ūūūšåååǧééé.]";var iban="[IIIIBAAAN]";var agreement="[AAAAǧŕééééééméééกี้ṫ]";var ibanError={invalidCode:"[IIIIBAAAN îîîš กี้öööṫ våååļîîîď]",noAcceptedCountry:"[OOOOกี้ļÝ IIIBAAAN'š ḟŕöööm {{åååççéééþṫéééď}} åååŕééé åååççéééþṫéééď]"};var developerMode="[DDééévéééļöööþéééŕ möööďééé]";var developers="[DDééévéééļöööþéééŕš]";var api="[AAAAPIII]";var apiKey="[AAAAPIII KéééÝ]";var generateApiKey="[GGéééกี้éééŕåååṫééé AAAPIII ḱéééÝ]";var locationManagement="[LLöööçåååṫîîîöööกี้ måååกี้åååǧéééméééกี้ṫ]";var SettingsPSEUDO = {language:language,nl:nl,en:en,settings:settings$3,preferences:preferences,personalInformation:personalInformation,changePassword:changePassword,privacy:privacy,analytics:analytics,languageDescription:languageDescription,firstName:firstName,lastName:lastName,analyticsDescription:analyticsDescription,iban:iban,agreement:agreement,ibanError:ibanError,developerMode:developerMode,developers:developers,api:api,apiKey:apiKey,generateApiKey:generateApiKey,locationManagement:locationManagement};

var welcome$2="Welkom {{name}}";var welcomeBack$2="Welkom terug!";var dashboard$2="Dashboard";var totalCO2Emission$2="CO<sub>2</sub> uitstoot bespaard";var totalTrees$2="Bomen geplant";var cookie$2={title:"Tijd voor koekjes",text:"Deze website slaat cookies op uw computer op. Deze cookies worden gebruikt om uw website-ervaring te verbeteren en u meer gepersonaliseerde diensten aan te bieden, zowel op deze website als via andere media. Voor meer informatie over de cookies die wij gebruiken, zie ons <a target=\"_blank\" href=\"https://www.bluecurrent.nl/legal/cookies\" style=\"text-decoration:underline;\">cookiebeleid</a>.",button:"Accepteren",closeCookiePopup:"Cookie pop-up sluiten"};var quickAccess$2="Snel regelen";var active$2="Actief";var totalEnergyUsage$2="Totaal energieverbruik";var contact$2="Contact";var learnMore$2="Leer meer";var chargepoints$2="Laadpunten";var pages$2="Pagina's";var other$2="Overige";var search$2="Zoeken";var filter$2="Filter";var list$2="Lijst";var symbols$2="Pictogrammen";var all$2="Alles";var map$3="Kaart";var help$2="Help";var support$2="Ondersteuning";var pppsstIamHere$2="Pppsst ik zit hier!";var selected$2="Geselecteerd";var optional$2="Optioneel";var your$2="Jouw";var group$2={create:"Groep maken",none:"Je hebt nog geen groep aangemaakt. Je ziet je groepen hier. ",groups:"Groepen",group:"Groep",update:"Bijwerken",edit:"Groep aanpassen",editGroups:"Groepen aanpassen"};var delayedCharging$2={edit:"Schema aanpassen"};var name$5="Naam";var symbol$2="Pictogram";var example$3="Voorbeeld";var garage$2="Garage";var back$2="Vorige";var chargepoint$2="Laadpunt";var disabled$2="Uitgeschakeld";var selectedChargecard$2="Geselecteerde laadpas";var notifications$2="Notificaties";var errors$2={somethingWrong:"Er is iets misgegaan",noConnectionBackend:"Het lukt niet te verbinden met onze servers, probeer het later opnieuw.","firstname-empty":"Voornaam is een verplicht veld","lastname-empty":"Achternaam is een verplicht veld","email-empty":"E-mail is een verplicht veld","phone-empty":"Telefoonnummer is een verplicht veld","email-invalid":"Gelieve een geldig e-mailadres in te geven","phone-invalid":"Gelieve een geldig telefoonnummer in te geven","password-empty":"Wachtwoord is een verplicht veld","passwords-match":"De wachtwoorden komen niet overeen",emailSentIfExists:"Een e-mail is verstuurd als er een account met dat e-mail adres bestaat.",passwordUpdated:"Je wachtwoord is succesvol aangepast."};var transactions$2="Transacties";var duration$2="Tijdsduur";var totalCost$2="Totale kosten";var inclusive$2="Inclusief ";var exclusive$2="Exclusief";var incl$2="Incl.";var excl$2="Excl.";var charge$2="Laad";var information$2="Informatie";var company$2="Bedrijf";var street$2="Straat";var houseNumber$2="Huisnummer";var zipCode$2="Postcode";var place$2="Plaats";var country$2="Land";var reference$2="Referentie";var address$2="Adres";var edit$2="Aanpassen";var download$2="Download";var grids$2="Grids";var getOnPlayStore$2="Ontdek het op Google Play";var chargeEvenFaster$2="Nog sneller laden?";var downloadApp$2="Download de app!";var mobileApp$2={app:"App",description:"Wij maken elektrisch rijden nog makkelijker. Met onze app pak jij in handomdraai de controle over je laadpunt.",feature_adjustSettings:"Laadpunt instellingen aanpassen",feature_howMuchYouAreCharging:"Zie hoeveel je aan het laden bent",feature_checkBuildingEnergy:"Bekijk de stroom die in je huis of gebouw wordt gebruikt"};var features$2="Kenmerken";var screenshots$2="Schermafbeeldingen";var my$2="Mijn";var cancel$2="Annuleren";var areYouSure$2="Weet je het zeker";var confirm$2="Bevestigen";var send$2="Verzenden";var noSettlement$2="Geen vergoeding";var location$2="Locatie";var selectAll$2="Alles selecteren";var linkedChargeCards$2="Gekoppelde laadpassen";var chargeCardNotOnThisList$2="Laadpas niet gekoppeld? Vul het serienummer hieronder in";var serialNumber$2="Serienummer";var add$2="Toevoegen";var deselectAll$2="Selectie ongedaan maken";var viewAll$2="Toon alles";var requestChargeCard$2="Laadpas aanvragen";var chargeCard$2="Laadpas";var chargeCards$2="Laadpassen";var invalidChargeCard$2="Ongeldige laadpas";var linkedChargepoints$2="Gekoppelde laadpunten";var addChargeCard$2="Laadpas toevoegen";var faq$2="Veelgestelde vragen";var home$2="Home";var amount$2="Bedrag";var products$2="Producten";var close$2="Sluiten";var lastUpdate$2="Laatste wijziging";var viewLess$2="Toon minder";var currency$2={inEuro:"in €"};var accessibility$2={button:"Knop",input:"Invoerveld"};var watchVideo$2="Video bekijken";var next$2="Volgende";var previous$2="Vorige";var or$2="Of";var save$2="Opslaan";var noUpcomingEvent$2="Geen aankomend evenement";var units$8={megaton:"Megaton",ton:"Ton",kiloton:"Kiloton"};var additionalInformation$2="Extra informatie";var addChargePoint$2="Laadpaal toevoegen";var editChargeCard$2="Laadpas wijzigen";var usefullLinks$2="Handige linkjes";var payAttention$2="Let op";var myChargeCards$2="Mijn laadpassen";var allChargepoints$2="Alle laadpunten";var arrangeThisYourselfOnline$2="Dit kan je direct zelf online regelen!";var removeFilters$2="Wis filters";var transaction$2="Transactie";var tip$2="Tip";var dragDropFiles$2="Zet bestanden neer of klik hier om te uploaden";var signUp$2="Inschrijven";var advanced$2="Geadvanceerd";var change$2="Wijzigen";var UiNL = {welcome:welcome$2,welcomeBack:welcomeBack$2,dashboard:dashboard$2,totalCO2Emission:totalCO2Emission$2,totalTrees:totalTrees$2,cookie:cookie$2,quickAccess:quickAccess$2,active:active$2,totalEnergyUsage:totalEnergyUsage$2,contact:contact$2,learnMore:learnMore$2,chargepoints:chargepoints$2,pages:pages$2,other:other$2,search:search$2,filter:filter$2,list:list$2,symbols:symbols$2,all:all$2,map:map$3,help:help$2,support:support$2,pppsstIamHere:pppsstIamHere$2,selected:selected$2,optional:optional$2,your:your$2,group:group$2,delayedCharging:delayedCharging$2,name:name$5,symbol:symbol$2,example:example$3,garage:garage$2,"continue":"Volgende",back:back$2,chargepoint:chargepoint$2,disabled:disabled$2,selectedChargecard:selectedChargecard$2,notifications:notifications$2,errors:errors$2,transactions:transactions$2,duration:duration$2,totalCost:totalCost$2,inclusive:inclusive$2,exclusive:exclusive$2,incl:incl$2,excl:excl$2,charge:charge$2,information:information$2,company:company$2,street:street$2,houseNumber:houseNumber$2,zipCode:zipCode$2,place:place$2,country:country$2,reference:reference$2,address:address$2,edit:edit$2,download:download$2,grids:grids$2,getOnPlayStore:getOnPlayStore$2,chargeEvenFaster:chargeEvenFaster$2,downloadApp:downloadApp$2,mobileApp:mobileApp$2,features:features$2,screenshots:screenshots$2,my:my$2,cancel:cancel$2,areYouSure:areYouSure$2,confirm:confirm$2,send:send$2,noSettlement:noSettlement$2,location:location$2,selectAll:selectAll$2,linkedChargeCards:linkedChargeCards$2,chargeCardNotOnThisList:chargeCardNotOnThisList$2,serialNumber:serialNumber$2,add:add$2,deselectAll:deselectAll$2,viewAll:viewAll$2,requestChargeCard:requestChargeCard$2,chargeCard:chargeCard$2,chargeCards:chargeCards$2,invalidChargeCard:invalidChargeCard$2,linkedChargepoints:linkedChargepoints$2,addChargeCard:addChargeCard$2,faq:faq$2,home:home$2,amount:amount$2,products:products$2,close:close$2,lastUpdate:lastUpdate$2,viewLess:viewLess$2,currency:currency$2,accessibility:accessibility$2,watchVideo:watchVideo$2,next:next$2,previous:previous$2,or:or$2,save:save$2,noUpcomingEvent:noUpcomingEvent$2,units:units$8,additionalInformation:additionalInformation$2,addChargePoint:addChargePoint$2,editChargeCard:editChargeCard$2,usefullLinks:usefullLinks$2,payAttention:payAttention$2,myChargeCards:myChargeCards$2,allChargepoints:allChargepoints$2,arrangeThisYourselfOnline:arrangeThisYourselfOnline$2,removeFilters:removeFilters$2,transaction:transaction$2,tip:tip$2,dragDropFiles:dragDropFiles$2,signUp:signUp$2,advanced:advanced$2,change:change$2};

var welcome$1="Welcome {{name}}";var welcomeBack$1="Welcome back!";var dashboard$1="Dashboard";var totalCO2Emission$1="CO<sub>2</sub> emissions saved";var totalTrees$1="Trees planted";var cookie$1={title:"Time for cookies",text:"This website stores cookies on your computer. These cookies are used to improve your website experience and provide more personalized services to you, both on this website and through other media. To find out more about the cookies we use, see our <a target=\"_blank\" href=\"https://www.bluecurrent.nl/legal/cookies\" style=\"text-decoration:underline;\">cookie policy</a>.",button:"Accept",closeCookiePopup:"Close cookie popup"};var quickAccess$1="Quick access";var active$1="Active";var totalEnergyUsage$1="Total energy usage";var contact$1="Contact";var learnMore$1="Learn more";var chargepoints$1="Charge points";var pages$1="Pages";var other$1="Other";var search$1="Search";var filter$1="Filter";var list$1="List";var symbols$1="Symbols";var all$1="All";var map$2="Map";var help$1="Help";var support$1="Support";var pppsstIamHere$1="Pppsst I'm here!";var selected$1="Selected";var optional$1="Optional";var your$1="Your";var group$1={create:"Create group",none:"You haven't created a group yet, you will see your created groups here.",groups:"Groups",group:"Group",update:"Update",edit:"Edit group",editGroups:"Edit groups"};var delayedCharging$1={edit:"Change schedule"};var name$4="Name";var symbol$1="Symbol";var example$2="Example";var garage$1="Garage";var back$1="Back";var chargepoint$1="Charge point";var disabled$1="Disabled";var selectedChargecard$1="Selected charge card";var notifications$1="Notifications";var errors$1={noConnectionBackend:"We are unable to connect to our servers, please try again later.",somethingWrong:"Something went wrong","firstname-empty":"Firstname is a required field","lastname-empty":"Lastname is a required field","email-empty":"E-mail is a required field","phone-empty":"Phone number is a required field","email-invalid":"Please enter a valid e-mail address","phone-invalid":"Please enter a valid phone number","password-empty":"Password is a required field","passwords-match":"Passwords must match",emailSentIfExists:"If an account with that email exists, an email has been sent to it.",passwordUpdated:"Your password has been updated succesfully."};var transactions$1="Transactions";var duration$1="Duration";var totalCost$1="Total cost";var inclusive$1="Incusive";var exclusive$1="Exclusive";var incl$1="Incl.";var excl$1="Excl.";var charge$1="Charge";var information$1="Information";var company$1="Company";var street$1="Street";var houseNumber$1="House number";var zipCode$1="Zip code";var place$1="City";var country$1="Country";var reference$1="Reference";var address$1="Address";var edit$1="Edit";var download$1="Download";var grids$1="Grids";var getOnPlayStore$1="Get it on Google Play";var chargeEvenFaster$1="Charge even faster!";var downloadApp$1="Download the app!";var mobileApp$1={app:"App",description:"We make electric driving even easier. With our app, you can take charge of your charge point in no time at all. ",feature_adjustSettings:"Adjust charge point settings",feature_howMuchYouAreCharging:"See how much you are charging",feature_checkBuildingEnergy:"Insight into the power consumption of the building"};var features$1="Features";var screenshots$1="Screenshots";var my$1="My";var cancel$1="Cancel";var areYouSure$1="Are you sure";var confirm$1="Confirm";var send$1="Send";var noSettlement$1="No settlement";var location$1="Location";var selectAll$1="Select all";var linkedChargeCards$1="Linked charge cards";var chargeCardNotOnThisList$1="Charge card not linked? Enter the serial number below";var serialNumber$1="Serial number";var add$1="Add";var deselectAll$1="Deselect all";var viewAll$1="View all";var requestChargeCard$1="Request charge card";var chargeCard$1="Charge card";var chargeCards$1="Charge cards";var invalidChargeCard$1="Invalid charge card";var linkedChargepoints$1="Linked charge points";var addChargeCard$1="Add charge card";var faq$1="FAQ";var home$1="Home";var amount$1="Amount";var products$1="Products";var close$1="Close";var lastUpdate$1="Last update";var viewLess$1="View le";var currency$1={inEuro:"in €"};var accessibility$1={button:"Button",input:"Input"};var watchVideo$1="Watch video";var next$1="Next";var previous$1="Previous";var or$1="Or";var save$1="Save";var noUpcomingEvent$1="No upcoming event";var units$7={megaton:"Megato",ton:"Ton",kiloton:"Kiloton"};var additionalInformation$1="Additional information";var addChargePoint$1="Add charge point";var editChargeCard$1="Edit charge card";var usefullLinks$1="Usefull links";var payAttention$1="Pay attention";var myChargeCards$1="My charge cards";var allChargepoints$1="All charge points";var arrangeThisYourselfOnline$1="You can arrange this yourself online!";var removeFilters$1="Remove filters";var transaction$1="Transaction";var tip$1="Tip";var dragDropFiles$1="Drop files or click here to upload";var signUp$1="Sign up";var advanced$1="Advanced";var change$1="Change";var UiEN = {welcome:welcome$1,welcomeBack:welcomeBack$1,dashboard:dashboard$1,totalCO2Emission:totalCO2Emission$1,totalTrees:totalTrees$1,cookie:cookie$1,quickAccess:quickAccess$1,active:active$1,totalEnergyUsage:totalEnergyUsage$1,contact:contact$1,learnMore:learnMore$1,chargepoints:chargepoints$1,pages:pages$1,other:other$1,search:search$1,filter:filter$1,list:list$1,symbols:symbols$1,all:all$1,map:map$2,help:help$1,support:support$1,pppsstIamHere:pppsstIamHere$1,selected:selected$1,optional:optional$1,your:your$1,group:group$1,delayedCharging:delayedCharging$1,name:name$4,symbol:symbol$1,example:example$2,garage:garage$1,"continue":"Continue",back:back$1,chargepoint:chargepoint$1,disabled:disabled$1,selectedChargecard:selectedChargecard$1,notifications:notifications$1,errors:errors$1,transactions:transactions$1,duration:duration$1,totalCost:totalCost$1,inclusive:inclusive$1,exclusive:exclusive$1,incl:incl$1,excl:excl$1,charge:charge$1,information:information$1,company:company$1,street:street$1,houseNumber:houseNumber$1,zipCode:zipCode$1,place:place$1,country:country$1,reference:reference$1,address:address$1,edit:edit$1,download:download$1,grids:grids$1,getOnPlayStore:getOnPlayStore$1,chargeEvenFaster:chargeEvenFaster$1,downloadApp:downloadApp$1,mobileApp:mobileApp$1,features:features$1,screenshots:screenshots$1,my:my$1,cancel:cancel$1,areYouSure:areYouSure$1,confirm:confirm$1,send:send$1,noSettlement:noSettlement$1,location:location$1,selectAll:selectAll$1,linkedChargeCards:linkedChargeCards$1,chargeCardNotOnThisList:chargeCardNotOnThisList$1,serialNumber:serialNumber$1,add:add$1,deselectAll:deselectAll$1,viewAll:viewAll$1,requestChargeCard:requestChargeCard$1,chargeCard:chargeCard$1,chargeCards:chargeCards$1,invalidChargeCard:invalidChargeCard$1,linkedChargepoints:linkedChargepoints$1,addChargeCard:addChargeCard$1,faq:faq$1,home:home$1,amount:amount$1,products:products$1,close:close$1,lastUpdate:lastUpdate$1,viewLess:viewLess$1,currency:currency$1,accessibility:accessibility$1,watchVideo:watchVideo$1,next:next$1,previous:previous$1,or:or$1,save:save$1,noUpcomingEvent:noUpcomingEvent$1,units:units$7,additionalInformation:additionalInformation$1,addChargePoint:addChargePoint$1,editChargeCard:editChargeCard$1,usefullLinks:usefullLinks$1,payAttention:payAttention$1,myChargeCards:myChargeCards$1,allChargepoints:allChargepoints$1,arrangeThisYourselfOnline:arrangeThisYourselfOnline$1,removeFilters:removeFilters$1,transaction:transaction$1,tip:tip$1,dragDropFiles:dragDropFiles$1,signUp:signUp$1,advanced:advanced$1,change:change$1};

var welcome="[WWéééļçööömééé {{กี้åååmééé}}]";var welcomeBack="[WWéééļçööömééé båååçḱ!]";var dashboard="[DDåååšḥböööåååŕď]";var totalCO2Emission="CO<sub>2</sub> emissions saved";var totalTrees="[TTŕééééééš þļåååกี้ṫéééď]";var cookie={title:"[TTîîîmééé ḟöööŕ çööööööḱîîîéééš]",text:"This website stores cookies on your computer. These cookies are used to improve your website experience and provide more personalized services to you, both on this website and through other media. To find out more about the cookies we use, see our <a target=\"_blank\" href=\"https://www.bluecurrent.nl/legal/cookies\" style=\"text-decoration:underline;\">cookie policy</a>.",button:"[AAAAççéééþṫ]",closeCookiePopup:"[CCļöööšééé çööööööḱîîîééé þöööþūūūþ]"};var quickAccess="[QQūūūîîîçḱ åååççéééšš]";var active="[AAAAçṫîîîvééé]";var totalEnergyUsage="[TTöööṫåååļ éééกี้éééŕǧÝ ūūūšåååǧééé]";var contact="[CCöööกี้ṫåååçṫ]";var learnMore="[LLéééåååŕกี้ möööŕééé]";var chargepoints="[CCḥåååŕǧééé þöööîîîกี้ṫš]";var pages="[PPåååǧéééš]";var other="[OOOOṫḥéééŕ]";var search="[SSéééåååŕçḥ]";var filter="[FFîîîļṫéééŕ]";var list="[LLîîîšṫ]";var symbols="[SSÝmböööļš]";var all="[AAAAļļ]";var map$1="[MMåååþ]";var help="[HHéééļþ]";var support="[SSūūūþþöööŕṫ]";var pppsstIamHere="[PPþþššṫ III'm ḥéééŕééé!]";var selected="[SSéééļéééçṫéééď]";var optional="[OOOOþṫîîîöööกี้åååļ]";var your="[YYöööūūūŕ]";var group={create:"[CCŕéééåååṫééé ǧŕöööūūūþ]",none:"[YYöööūūū ḥåååvéééกี้'ṫ çŕéééåååṫéééď ååå ǧŕöööūūūþ Ýéééṫ, Ýöööūūū wîîîļļ šéééééé Ýöööūūūŕ çŕéééåååṫéééď ǧŕöööūūūþš ḥéééŕééé.]",groups:"[GGŕöööūūūþš]",group:"[GGŕöööūūūþ]",update:"[UUUUþďåååṫééé]",edit:"[EEEEďîîîṫ ǧŕöööūūūþ]",editGroups:"[EEEEďîîîṫ ǧŕöööūūūþš]"};var delayedCharging={edit:"[CCḥåååกี้ǧééé šçḥéééďūūūļééé]"};var name$3="[NNåååmééé]";var symbol="[SSÝmböööļ]";var example$1="[EEEExåååmþļééé]";var garage="[GGåååŕåååǧééé]";var back="[BBåååçḱ]";var chargepoint="[CCḥåååŕǧééé þöööîîîกี้ṫ]";var disabled="[DDîîîšåååbļéééď]";var selectedChargecard="[SSéééļéééçṫéééď çḥåååŕǧééé çåååŕď]";var notifications="[NNöööṫîîîḟîîîçåååṫîîîöööกี้š]";var errors={noConnectionBackend:"[WWééé åååŕééé ūūūกี้åååbļééé ṫööö çöööกี้กี้éééçṫ ṫööö öööūūūŕ šéééŕvéééŕš, þļéééåååšééé ṫŕÝ åååǧåååîîîกี้ ļåååṫéééŕ.]",somethingWrong:"[SSöööméééṫḥîîîกี้ǧ wéééกี้ṫ wŕöööกี้ǧ]","firstname-empty":"[FFîîîŕšṫกี้åååmééé îîîš ååå ŕéééqūūūîîîŕéééď ḟîîîéééļď]","lastname-empty":"[LLåååšṫกี้åååmééé îîîš ååå ŕéééqūūūîîîŕéééď ḟîîîéééļď]","email-empty":"[EEEE-måååîîîļ îîîš ååå ŕéééqūūūîîîŕéééď ḟîîîéééļď]","phone-empty":"[PPḥöööกี้ééé กี้ūūūmbéééŕ îîîš ååå ŕéééqūūūîîîŕéééď ḟîîîéééļď]","email-invalid":"[PPļéééåååšééé éééกี้ṫéééŕ ååå våååļîîîď ééé-måååîîîļ åååďďŕéééšš]","phone-invalid":"[PPļéééåååšééé éééกี้ṫéééŕ ååå våååļîîîď þḥöööกี้ééé กี้ūūūmbéééŕ]","password-empty":"[PPåååššwöööŕď îîîš ååå ŕéééqūūūîîîŕéééď ḟîîîéééļď]","passwords-match":"[PPåååššwöööŕďš mūūūšṫ måååṫçḥ]",emailSentIfExists:"[IIIIḟ åååกี้ åååççöööūūūกี้ṫ wîîîṫḥ ṫḥåååṫ ééémåååîîîļ éééxîîîšṫš, åååกี้ ééémåååîîîļ ḥåååš bééééééกี้ šéééกี้ṫ ṫööö îîîṫ.]",passwordUpdated:"[YYöööūūūŕ þåååššwöööŕď ḥåååš bééééééกี้ ūūūþďåååṫéééď šūūūççéééšḟūūūļļÝ.]"};var transactions="[TTŕåååกี้šåååçṫîîîöööกี้š]";var duration="[DDūūūŕåååṫîîîöööกี้]";var totalCost="[TTöööṫåååļ çöööšṫ]";var inclusive="[IIIIกี้çūūūšîîîvééé]";var exclusive="[EEEExçļūūūšîîîvééé]";var incl="[IIIIกี้çļ.]";var excl="[EEEExçļ.]";var charge="[CCḥåååŕǧééé]";var information="[IIIIกี้ḟöööŕmåååṫîîîöööกี้]";var company="[CCööömþåååกี้Ý]";var street="[SSṫŕééééééṫ]";var houseNumber="[HHöööūūūšééé กี้ūūūmbéééŕ]";var zipCode="[ZZîîîþ çöööďééé]";var place="[CCîîîṫÝ]";var country="[CCöööūūūกี้ṫŕÝ]";var reference="[RRéééḟéééŕéééกี้çééé]";var address="[AAAAďďŕéééšš]";var edit="[EEEEďîîîṫ]";var download="[DDöööwกี้ļöööåååď]";var grids="[GGŕîîîďš]";var getOnPlayStore="[GGéééṫ îîîṫ öööกี้ Gööööööǧļééé PļåååÝ]";var chargeEvenFaster="[CCḥåååŕǧééé ééévéééกี้ ḟåååšṫéééŕ!]";var downloadApp="[DDöööwกี้ļöööåååď ṫḥééé åååþþ!]";var mobileApp={app:"[AAAAþþ]",description:"[WWééé måååḱééé éééļéééçṫŕîîîç ďŕîîîvîîîกี้ǧ ééévéééกี้ éééåååšîîîéééŕ. Wîîîṫḥ öööūūūŕ åååþþ, Ýöööūūū çåååกี้ ṫåååḱééé çḥåååŕǧééé öööḟ Ýöööūūūŕ çḥåååŕǧééé þöööîîîกี้ṫ îîîกี้ กี้ööö ṫîîîmééé åååṫ åååļļ. ]",feature_adjustSettings:"[AAAAďĵūūūšṫ çḥåååŕǧééé þöööîîîกี้ṫ šéééṫṫîîîกี้ǧš]",feature_howMuchYouAreCharging:"[SSéééééé ḥöööw mūūūçḥ Ýöööūūū åååŕééé çḥåååŕǧîîîกี้ǧ]",feature_checkBuildingEnergy:"[IIIIกี้šîîîǧḥṫ îîîกี้ṫööö ṫḥééé þöööwéééŕ çöööกี้šūūūmþṫîîîöööกี้ öööḟ ṫḥééé būūūîîîļďîîîกี้ǧ]"};var features="[FFéééåååṫūūūŕéééš]";var screenshots="[SSçŕééééééกี้šḥöööṫš]";var my="[MMÝ]";var cancel="[CCåååกี้çéééļ]";var areYouSure="[AAAAŕééé Ýöööūūū šūūūŕééé]";var confirm="[CCöööกี้ḟîîîŕm]";var send="[SSéééกี้ď]";var noSettlement="[NNööö šéééṫṫļéééméééกี้ṫ]";var location="[LLöööçåååṫîîîöööกี้]";var selectAll="[SSéééļéééçṫ åååļļ]";var linkedChargeCards="[LLîîîกี้ḱéééď çḥåååŕǧééé çåååŕďš]";var chargeCardNotOnThisList="[CCḥåååŕǧééé çåååŕď กี้öööṫ ļîîîกี้ḱéééď? EEEกี้ṫéééŕ ṫḥééé šéééŕîîîåååļ กี้ūūūmbéééŕ béééļöööw]";var serialNumber="[SSéééŕîîîåååļ กี้ūūūmbéééŕ]";var add="[AAAAďď]";var deselectAll="[DDéééšéééļéééçṫ åååļļ]";var viewAll="[VVîîîéééw åååļļ]";var requestChargeCard="[RRéééqūūūéééšṫ çḥåååŕǧééé çåååŕď]";var chargeCard="[CCḥåååŕǧééé çåååŕď]";var chargeCards="[CCḥåååŕǧééé çåååŕďš]";var invalidChargeCard="[IIIIกี้våååļîîîď çḥåååŕǧééé çåååŕď]";var linkedChargepoints="[LLîîîกี้ḱéééď çḥåååŕǧééé þöööîîîกี้ṫš]";var addChargeCard="[AAAAďď çḥåååŕǧééé çåååŕď]";var faq="[FFAAAQ]";var home="[HHööömééé]";var amount="[AAAAmöööūūūกี้ṫ]";var products="[PPŕöööďūūūçṫš]";var close="[CCļöööšééé]";var lastUpdate="[LLåååšṫ ūūūþďåååṫééé]";var viewLess="[VVîîîéééw ļééé]";var currency={inEuro:"[îîîîกี้ €]"};var accessibility={button:"[BBūūūṫṫöööกี้]",input:"[IIIIกี้þūūūṫ]"};var watchVideo="[WWåååṫçḥ vîîîďéééööö]";var next="[NNéééxṫ]";var previous="[PPŕééévîîîöööūūūš]";var or="[OOOOŕ]";var save="[SSåååvééé]";var noUpcomingEvent="[NNööö ūūūþçööömîîîกี้ǧ ééévéééกี้ṫ]";var units$6={megaton:"[MMéééǧåååṫööö]",ton:"[TTöööกี้]",kiloton:"[KKîîîļöööṫöööกี้]"};var additionalInformation="[AAAAďďîîîṫîîîöööกี้åååļ îîîกี้ḟöööŕmåååṫîîîöööกี้]";var addChargePoint="[AAAAďď çḥåååŕǧééé þöööîîîกี้ṫ]";var editChargeCard="[EEEEďîîîṫ çḥåååŕǧééé çåååŕď]";var usefullLinks="[UUUUšéééḟūūūļļ ļîîîกี้ḱš]";var payAttention="[PPåååÝ åååṫṫéééกี้ṫîîîöööกี้]";var myChargeCards="[MMÝ çḥåååŕǧééé çåååŕďš]";var allChargepoints="[AAAAļļ çḥåååŕǧééé þöööîîîกี้ṫš]";var arrangeThisYourselfOnline="[YYöööūūū çåååกี้ åååŕŕåååกี้ǧééé ṫḥîîîš Ýöööūūūŕšéééļḟ öööกี้ļîîîกี้ééé!]";var removeFilters="[RRééémööövééé ḟîîîļṫéééŕš]";var transaction="[TTŕåååกี้šåååçṫîîîöööกี้]";var tip="[TTîîîþ]";var dragDropFiles="[DDŕöööþ ḟîîîļéééš öööŕ çļîîîçḱ ḥéééŕééé ṫööö ūūūþļöööåååď]";var signUp="[SSîîîǧกี้ ūūūþ]";var advanced="[AAAAďvåååกี้çéééď]";var change="[CCḥåååกี้ǧééé]";var UiPSEUDO = {welcome:welcome,welcomeBack:welcomeBack,dashboard:dashboard,totalCO2Emission:totalCO2Emission,totalTrees:totalTrees,cookie:cookie,quickAccess:quickAccess,active:active,totalEnergyUsage:totalEnergyUsage,contact:contact,learnMore:learnMore,chargepoints:chargepoints,pages:pages,other:other,search:search,filter:filter,list:list,symbols:symbols,all:all,map:map$1,help:help,support:support,pppsstIamHere:pppsstIamHere,selected:selected,optional:optional,your:your,group:group,delayedCharging:delayedCharging,name:name$3,symbol:symbol,example:example$1,garage:garage,"continue":"[CCöööกี้ṫîîîกี้ūūūééé]",back:back,chargepoint:chargepoint,disabled:disabled,selectedChargecard:selectedChargecard,notifications:notifications,errors:errors,transactions:transactions,duration:duration,totalCost:totalCost,inclusive:inclusive,exclusive:exclusive,incl:incl,excl:excl,charge:charge,information:information,company:company,street:street,houseNumber:houseNumber,zipCode:zipCode,place:place,country:country,reference:reference,address:address,edit:edit,download:download,grids:grids,getOnPlayStore:getOnPlayStore,chargeEvenFaster:chargeEvenFaster,downloadApp:downloadApp,mobileApp:mobileApp,features:features,screenshots:screenshots,my:my,cancel:cancel,areYouSure:areYouSure,confirm:confirm,send:send,noSettlement:noSettlement,location:location,selectAll:selectAll,linkedChargeCards:linkedChargeCards,chargeCardNotOnThisList:chargeCardNotOnThisList,serialNumber:serialNumber,add:add,deselectAll:deselectAll,viewAll:viewAll,requestChargeCard:requestChargeCard,chargeCard:chargeCard,chargeCards:chargeCards,invalidChargeCard:invalidChargeCard,linkedChargepoints:linkedChargepoints,addChargeCard:addChargeCard,faq:faq,home:home,amount:amount,products:products,close:close,lastUpdate:lastUpdate,viewLess:viewLess,currency:currency,accessibility:accessibility,watchVideo:watchVideo,next:next,previous:previous,or:or,save:save,noUpcomingEvent:noUpcomingEvent,units:units$6,additionalInformation:additionalInformation,addChargePoint:addChargePoint,editChargeCard:editChargeCard,usefullLinks:usefullLinks,payAttention:payAttention,myChargeCards:myChargeCards,allChargepoints:allChargepoints,arrangeThisYourselfOnline:arrangeThisYourselfOnline,removeFilters:removeFilters,transaction:transaction,tip:tip,dragDropFiles:dragDropFiles,signUp:signUp,advanced:advanced,change:change};

var weekdays$2={monday:"Maandag",tuesday:"Dinsdag",wednesday:"Woensdag",thursday:"Donderdag",friday:"Vrijdag",saturday:"Zaterdag",sunday:"Zondag",mon:"Ma",tue:"Di",wed:"Wo",thur:"Do",fri:"Vr",sat:"Za",sun:"Zo"};var today$2="Vandaag";var yesterday$2="Gisteren";var units$5={month:"Maand",week:"Week",year:"Yaar",day:"Dag",hour:"Uur",minute:"Minuut",second:"Seconde",min:"Min"};var monthly$2="Maandelijks";var weekly$2="Wekelijks";var date$3="Datum";var time$2="Tijd";var startDate$2="Begindatum";var endDate$2="Einddatum";var startTime$2="Starttijd";var endTime$2="Eindtijd";var period$2="Periode";var month$2="Maand";var year$2="Jaar";var yearly$2="Jaarlijks";var quarterly$2="Per kwartaal";var quarter$2="Kwartaal";var dateTime$2="Datum & Tijd";var DatesNL = {weekdays:weekdays$2,today:today$2,yesterday:yesterday$2,units:units$5,monthly:monthly$2,weekly:weekly$2,date:date$3,time:time$2,startDate:startDate$2,endDate:endDate$2,startTime:startTime$2,endTime:endTime$2,period:period$2,month:month$2,year:year$2,yearly:yearly$2,quarterly:quarterly$2,quarter:quarter$2,dateTime:dateTime$2};

var weekdays$1={monday:"Monday",tuesday:"Tuesday",wednesday:"Wednesday",thursday:"Thursday",friday:"Friday",saturday:"Saturday",sunday:"Sunday",mon:"Mon",tue:"Tue",wed:"Wed",thur:"Thu",fri:"Fri",sat:"Sat",sun:"Sun"};var today$1="Today";var yesterday$1="Yesterday";var units$4={month:"Month",week:"Week",year:"Year",day:"Day",hour:"Hour",minute:"Minute",second:"Second",min:"Min"};var monthly$1="Monthly";var weekly$1="Weekly";var date$2="Date";var time$1="Time";var startDate$1="Start date ";var endDate$1="End date";var startTime$1="Starttijd";var endTime$1="Eindtijd";var period$1="Period";var month$1="Month";var year$1="Year";var yearly$1="Yearly";var quarterly$1="Quarterly";var quarter$1="Quarter";var dateTime$1="Date & Time";var DatesEN = {weekdays:weekdays$1,today:today$1,yesterday:yesterday$1,units:units$4,monthly:monthly$1,weekly:weekly$1,date:date$2,time:time$1,startDate:startDate$1,endDate:endDate$1,startTime:startTime$1,endTime:endTime$1,period:period$1,month:month$1,year:year$1,yearly:yearly$1,quarterly:quarterly$1,quarter:quarter$1,dateTime:dateTime$1};

var weekdays={monday:"[MMöööกี้ďåååÝ]",tuesday:"[TTūūūéééšďåååÝ]",wednesday:"[WWéééďกี้éééšďåååÝ]",thursday:"[TTḥūūūŕšďåååÝ]",friday:"[FFŕîîîďåååÝ]",saturday:"[SSåååṫūūūŕďåååÝ]",sunday:"[SSūūūกี้ďåååÝ]",mon:"[MMöööกี้]",tue:"[TTūūūééé]",wed:"[WWéééď]",thur:"[TTḥūūū]",fri:"[FFŕîîî]",sat:"[SSåååṫ]",sun:"[SSūūūกี้]"};var today="[TTöööďåååÝ]";var yesterday="[YYéééšṫéééŕďåååÝ]";var units$3={month:"[MMöööกี้ṫḥ]",week:"[WWééééééḱ]",year:"[YYéééåååŕ]",day:"[DDåååÝ]",hour:"[HHöööūūūŕ]",minute:"[MMîîîกี้ūūūṫééé]",second:"[SSéééçöööกี้ď]",min:"[MMîîîกี้]"};var monthly="[MMöööกี้ṫḥļÝ]";var weekly="[WWééééééḱļÝ]";var date$1="[DDåååṫééé]";var time="[TTîîîmééé]";var startDate="[SSṫåååŕṫ ďåååṫééé ]";var endDate="[EEEEกี้ď ďåååṫééé]";var startTime="[SSṫåååŕṫṫîîîĵď]";var endTime="[EEEEîîîกี้ďṫîîîĵď]";var period="[PPéééŕîîîöööď]";var month="[MMöööกี้ṫḥ]";var year="[YYéééåååŕ]";var yearly="[YYéééåååŕļÝ]";var quarterly="[QQūūūåååŕṫéééŕļÝ]";var quarter="[QQūūūåååŕṫéééŕ]";var dateTime="[DDåååṫééé & Tîîîmééé]";var DatesPSEUDO = {weekdays:weekdays,today:today,yesterday:yesterday,units:units$3,monthly:monthly,weekly:weekly,date:date$1,time:time,startDate:startDate,endDate:endDate,startTime:startTime,endTime:endTime,period:period,month:month,year:year,yearly:yearly,quarterly:quarterly,quarter:quarter,dateTime:dateTime};

var status$2={available:"Beschikbaar",charging:"Laden",offline:"Offline",unavailable:"Niet beschikbaar",error:"Error",delayedChargingSet:"Uitgesteld laden is ingesteld tot: "};var error$2={somethingWrong:"Er is iets misgegaan!",resetFailed:"Kon laadpunt {{id}} niet resetten!",availableFailed:"Kan de beschikbaarheid van laadpunt {{id}} niet veranderen",rebootFailed:"Kan laadpunt {{id}} niet herstarten!",nameFailed:"Kan laadpunt naam niet aanpassen",publicChargingFailed:"Kan publiek laden instelling niet aanpassen",plugAndChargeFailed:"Kan plug & charge instelling niet aanpassen",smartChargingFailed:"Kan slim laden instelling niet aanpassen",plugAndChargeNotificationFailed:"Kan plug & charge notificatie instelling niet aanpassen",startChargingFailed:"Kon de transactie niet starten op {{id}}!",stopChargingFailed:"Transactie op {{id}} is niet gestopt!",ledInteractionFailed:"Kan led interactie instelling niet aanpassen",vehicleNotFound:"Er is geen voertuig gekoppeld",offline:"{{model}} is offline, of er is een tijdelijke communicatieprobleem",unavailable:"{{model}} is niet beschikbaar, dit kan je aanpassen door je {{model}} op beschikbaar te zetten",error:"Je laadpunt is in error, of er is een tijdelijke communicatiestoring",availableFailedStillCharging:"Kan niet de beschikbaarheid van laadpunt {{id}} veranderen. Laadtransactie bezig.",vehicleError:"Je auto geeft een error, of er is een tijdelijke communicatiestoring"};var units$2={voltage:"Voltage",volt:"Volt",kwh:"kWh",ampere:"Ampère"};var charged$2="Geladen";var settings$2={smartCharging:"Slim laden",plugCharge:"Plug & charge",publicCharging:"Publiekelijk laden",publishLocation:"Publiceer locatie",ledInteraction:"Led's alleen aan bij interactie"};var chargingProfiles$2={name:"Profielen",offPeakCharging:"Uitgesteld laden"};var offline$2={lastOnline:"Laatst online",maxOfflineCharging:"Max. offline laden"};var actions$2={startSession:"Start sessie",stopSession:"Stop sessie",overrideTimeout:"Overschrijf timeout",reboot:"Opnieuw opstarten",reset:"Reset",makeUnavailable:"Zet niet beschikbaar",makeAvailable:"Zet beschikbaar",availabilityChanged:"De beschikbaarheid van laadpunt {{id}} is aangepast",rebooted:"Laadpunt {{id}} is geherstart",resetSuccess:"{{id}} is gereset"};var name$2={hidden:"Hidden",nanocharge:"NanoCharge",umove:"U:MOVE"};var activityStatus$2="Status";var warning$2={publicCharging:"<b>Let op:</b> Iedereen met een geldige laadpas kan bij jouw {{model}} zijn auto opladen.\n<br />\n<br />\nSta je dit liever niet toe? Dan moet je de passen die wel gebruikt mogen worden opvoeren in <a href=\"{{url}}\" rel=\"noreferrer\">\"Laadpassen\"</a>.",ledInteraction:"<b>Let op:</b> Iedereen met een geldige laadpas kan bij jouw {{model}} zijn auto opladen.\n<br />\n<br />\nSta je dit liever niet toe? Dan moet je de passen die wel gebruikt mogen worden opvoeren in <a href=\"{{url}}\" rel=\"noreferrer\">\"Laadpassen\"</a>.",plugAndCharge:"<b>Let op:</b> Iedereen met een geldige laadpas kan bij jouw {{model}} zijn auto opladen.\n<br />\n<br />\nSta je dit liever niet toe? Dan moet je de passen die wel gebruikt mogen worden opvoeren in <a href=\"{{url}}\" rel=\"noreferrer\">\"Laadpassen\"</a>.",plugAndChargeNotification:"<b>Let op:</b> Iedereen met een geldige laadpas kan bij jouw {{model}} zijn auto opladen.\n<br />\n<br />\nSta je dit liever niet toe? Dan moet je de passen die wel gebruikt mogen worden opvoeren in <a href=\"{{url}}\" rel=\"noreferrer\">\"Laadpassen\"</a>.",publishLocation:"<b>Let op:</b> Iedereen met een geldige laadpas kan bij jouw {{model}} zijn auto opladen.\n<br />\n<br />\nSta je dit liever niet toe? Dan moet je de passen die wel gebruikt mogen worden opvoeren in <a href=\"{{url}}\" rel=\"noreferrer\">\"Laadpassen\"</a>."};var plugChargeEnabled$2="Plug & charge ingeschakeld";var updates$2={resetting:"{{id} resetten...",resetSuccess:"{{id}} is gereset!",resetFailed:"{{id}} kon niet resetten!",stopChargingSuccess:"{{id}} is gestopt met laden!",startCharging:"Transactie starten op {{id}}...",stopCharging:"Transactie op {{id}} aan het stoppen...",startChargingSuccess:"{{id}} is aan het laden!"};var ChargePointNL = {status:status$2,error:error$2,units:units$2,charged:charged$2,settings:settings$2,chargingProfiles:chargingProfiles$2,offline:offline$2,actions:actions$2,name:name$2,activityStatus:activityStatus$2,warning:warning$2,plugChargeEnabled:plugChargeEnabled$2,updates:updates$2};

var status$1={available:"Available",charging:"Charging",offline:"Offline",unavailable:"Unavailable",error:"Error",delayedChargingSet:"Delayed charging is set until: "};var error$1={somethingWrong:"Something went wrong!",resetFailed:"Couldn't reset chargepoint {{id}}!",availableFailed:"Couldn't set availability of chargepoint {{id}}",rebootFailed:"Couldn't reboot chargepoint {{id}}!",nameFailed:"Couldn't change chargepoint name",publicChargingFailed:"Coulnd't update public charging setting",plugAndChargeFailed:"Coulnd't update plug & charge setting",smartChargingFailed:"Coulnd't update smart charging setting",plugAndChargeNotificationFailed:"Coulnd't update plug & charge notification setting",startChargingFailed:"Couldn't start the transaction on {{id}}!",stopChargingFailed:"Transaction on {{id}} failed to stop!",ledInteractionFailed:"Coulnd't update led interaction setting",vehicleNotFound:"No vehicle is connected",offline:"{{model}} may be offline, or there could be a temporary communication issue",unavailable:"{{model}} is unavailable, you can adjust this by setting your {{model}} to available",error:"Your charge point is in error, or there could be a temporary communication issue",availableFailedStillCharging:"Can't change the availability of chargepoint {{id}}. Transaction in progress.",vehicleError:"Your car has an error, or there could be a temporary communication issue"};var units$1={voltage:"Voltage",volt:"Volt",kwh:"kWh",ampere:"Ampère"};var charged$1="Charged";var settings$1={smartCharging:"Smart charging",plugCharge:"Plug & charge",publicCharging:"Public charging",publishLocation:"Publish location",ledInteraction:"Turn led's only on when interacting"};var chargingProfiles$1={name:"Profiles",offPeakCharging:"Off-peak charging"};var offline$1={lastOnline:"Last online",maxOfflineCharging:"Max. offline charging"};var actions$1={startSession:"Start session",stopSession:"Stop session",overrideTimeout:"Override timeout",reboot:"Reboot",reset:"Reset",makeUnavailable:"Set unavailable",makeAvailable:"Set available",availabilityChanged:"Updated the availability of chargepoint {{id}}",rebooted:"Chargepoint {{id}} has been rebooted",resetSuccess:"{{id}} has been resetted"};var name$1={hidden:"Hidden",nanocharge:"NanoCharge",umove:"U:MOVE"};var activityStatus$1="Status";var warning$1={publicCharging:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>.",ledInteraction:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>.",plugAndCharge:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>.",plugAndChargeNotification:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>.",publishLocation:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>."};var plugChargeEnabled$1="Plug & charge enabled";var updates$1={resetting:"Resetting {{id}}...",resetSuccess:"{{id}} has been reset!",resetFailed:"{{id}} failed to reset!",stopChargingSuccess:"{{id}} stopped charging!",startCharging:"Starting transaction on {{id}}...",stopCharging:"Stopping transaction on {{id}}...",startChargingSuccess:"{{id}} started charging!"};var ChargePointEN = {status:status$1,error:error$1,units:units$1,charged:charged$1,settings:settings$1,chargingProfiles:chargingProfiles$1,offline:offline$1,actions:actions$1,name:name$1,activityStatus:activityStatus$1,warning:warning$1,plugChargeEnabled:plugChargeEnabled$1,updates:updates$1};

var status={available:"[AAAAvåååîîîļåååbļééé]",charging:"[CCḥåååŕǧîîîกี้ǧ]",offline:"[OOOOḟḟļîîîกี้ééé]",unavailable:"[UUUUกี้åååvåååîîîļåååbļééé]",error:"[EEEEŕŕöööŕ]",delayedChargingSet:"[DDéééļåååÝéééď çḥåååŕǧîîîกี้ǧ îîîš šéééṫ ūūūกี้ṫîîîļ: ]"};var error={somethingWrong:"[SSöööméééṫḥîîîกี้ǧ wéééกี้ṫ wŕöööกี้ǧ!]",resetFailed:"[CCöööūūūļďกี้'ṫ ŕéééšéééṫ çḥåååŕǧéééþöööîîîกี้ṫ {{îîîď}}!]",availableFailed:"[CCöööūūūļďกี้'ṫ šéééṫ åååvåååîîîļåååbîîîļîîîṫÝ öööḟ çḥåååŕǧéééþöööîîîกี้ṫ {{îîîď}}]",rebootFailed:"[CCöööūūūļďกี้'ṫ ŕééébööööööṫ çḥåååŕǧéééþöööîîîกี้ṫ {{îîîď}}!]",nameFailed:"[CCöööūūūļďกี้'ṫ çḥåååกี้ǧééé çḥåååŕǧéééþöööîîîกี้ṫ กี้åååmééé]",publicChargingFailed:"[CCöööūūūļกี้ď'ṫ ūūūþďåååṫééé þūūūbļîîîç çḥåååŕǧîîîกี้ǧ šéééṫṫîîîกี้ǧ]",plugAndChargeFailed:"[CCöööūūūļกี้ď'ṫ ūūūþďåååṫééé þļūūūǧ & çḥåååŕǧééé šéééṫṫîîîกี้ǧ]",smartChargingFailed:"[CCöööūūūļกี้ď'ṫ ūūūþďåååṫééé šmåååŕṫ çḥåååŕǧîîîกี้ǧ šéééṫṫîîîกี้ǧ]",plugAndChargeNotificationFailed:"[CCöööūūūļกี้ď'ṫ ūūūþďåååṫééé þļūūūǧ & çḥåååŕǧééé กี้öööṫîîîḟîîîçåååṫîîîöööกี้ šéééṫṫîîîกี้ǧ]",startChargingFailed:"[CCöööūūūļďกี้'ṫ šṫåååŕṫ ṫḥééé ṫŕåååกี้šåååçṫîîîöööกี้ öööกี้ {{îîîď}}!]",stopChargingFailed:"[TTŕåååกี้šåååçṫîîîöööกี้ öööกี้ {{îîîď}} ḟåååîîîļéééď ṫööö šṫöööþ!]",ledInteractionFailed:"[CCöööūūūļกี้ď'ṫ ūūūþďåååṫééé ļéééď îîîกี้ṫéééŕåååçṫîîîöööกี้ šéééṫṫîîîกี้ǧ]",vehicleNotFound:"[NNööö véééḥîîîçļééé îîîš çöööกี้กี้éééçṫéééď]",offline:"[{{{möööďéééļ}} måååÝ bééé öööḟḟļîîîกี้ééé, öööŕ ṫḥéééŕééé çöööūūūļď bééé ååå ṫééémþöööŕåååŕÝ çööömmūūūกี้îîîçåååṫîîîöööกี้ îîîššūūūééé]",unavailable:"[{{{möööďéééļ}} îîîš ūūūกี้åååvåååîîîļåååbļééé, Ýöööūūū çåååกี้ åååďĵūūūšṫ ṫḥîîîš bÝ šéééṫṫîîîกี้ǧ Ýöööūūūŕ {{möööďéééļ}} ṫööö åååvåååîîîļåååbļééé]",error:"[YYöööūūūŕ çḥåååŕǧééé þöööîîîกี้ṫ îîîš îîîกี้ éééŕŕöööŕ, öööŕ ṫḥéééŕééé çöööūūūļď bééé ååå ṫééémþöööŕåååŕÝ çööömmūūūกี้îîîçåååṫîîîöööกี้ îîîššūūūééé]",availableFailedStillCharging:"[CCåååกี้'ṫ çḥåååกี้ǧééé ṫḥééé åååvåååîîîļåååbîîîļîîîṫÝ öööḟ çḥåååŕǧéééþöööîîîกี้ṫ {{îîîď}}. Tŕåååกี้šåååçṫîîîöööกี้ îîîกี้ þŕöööǧŕéééšš.]",vehicleError:"[YYöööūūūŕ çåååŕ ḥåååš åååกี้ éééŕŕöööŕ, öööŕ ṫḥéééŕééé çöööūūūļď bééé ååå ṫééémþöööŕåååŕÝ çööömmūūūกี้îîîçåååṫîîîöööกี้ îîîššūūūééé]"};var units={voltage:"[VVöööļṫåååǧééé]",volt:"[VVöööļṫ]",kwh:"[ḱḱWḥ]",ampere:"[AAAAmþèŕééé]"};var charged="[CCḥåååŕǧéééď]";var settings={smartCharging:"[SSmåååŕṫ çḥåååŕǧîîîกี้ǧ]",plugCharge:"[PPļūūūǧ & çḥåååŕǧééé]",publicCharging:"[PPūūūbļîîîç çḥåååŕǧîîîกี้ǧ]",publishLocation:"[PPūūūbļîîîšḥ ļöööçåååṫîîîöööกี้]",ledInteraction:"[TTūūūŕกี้ ļéééď'š öööกี้ļÝ öööกี้ wḥéééกี้ îîîกี้ṫéééŕåååçṫîîîกี้ǧ]"};var chargingProfiles={name:"[PPŕöööḟîîîļéééš]",offPeakCharging:"[OOOOḟḟ-þéééåååḱ çḥåååŕǧîîîกี้ǧ]"};var offline={lastOnline:"[LLåååšṫ öööกี้ļîîîกี้ééé]",maxOfflineCharging:"[MMåååx. öööḟḟļîîîกี้ééé çḥåååŕǧîîîกี้ǧ]"};var actions={startSession:"[SSṫåååŕṫ šéééššîîîöööกี้]",stopSession:"[SSṫöööþ šéééššîîîöööกี้]",overrideTimeout:"[OOOOvéééŕŕîîîďééé ṫîîîméééöööūūūṫ]",reboot:"[RRééébööööööṫ]",reset:"[RRéééšéééṫ]",makeUnavailable:"[SSéééṫ ūūūกี้åååvåååîîîļåååbļééé]",makeAvailable:"[SSéééṫ åååvåååîîîļåååbļééé]",availabilityChanged:"[UUUUþďåååṫéééď ṫḥééé åååvåååîîîļåååbîîîļîîîṫÝ öööḟ çḥåååŕǧéééþöööîîîกี้ṫ {{îîîď}}]",rebooted:"[CCḥåååŕǧéééþöööîîîกี้ṫ {{îîîď}} ḥåååš bééééééกี้ ŕééébööööööṫéééď]",resetSuccess:"[{{{îîîď}} ḥåååš bééééééกี้ ŕéééšéééṫṫéééď]"};var name={hidden:"[HHîîîďďéééกี้]",nanocharge:"[NNåååกี้öööCḥåååŕǧééé]",umove:"[UUUU:MOOOVEEE]"};var activityStatus="[SSṫåååṫūūūš]";var warning={publicCharging:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>.",ledInteraction:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>.",plugAndCharge:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>.",plugAndChargeNotification:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>.",publishLocation:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>."};var plugChargeEnabled="[PPļūūūǧ & çḥåååŕǧééé éééกี้åååbļéééď]";var updates={resetting:"[RRéééšéééṫṫîîîกี้ǧ {{îîîď}}...]",resetSuccess:"[{{{îîîď}} ḥåååš bééééééกี้ ŕéééšéééṫ!]",resetFailed:"[{{{îîîď}} ḟåååîîîļéééď ṫööö ŕéééšéééṫ!]",stopChargingSuccess:"[{{{îîîď}} šṫöööþþéééď çḥåååŕǧîîîกี้ǧ!]",startCharging:"[SSṫåååŕṫîîîกี้ǧ ṫŕåååกี้šåååçṫîîîöööกี้ öööกี้ {{îîîď}}...]",stopCharging:"[SSṫöööþþîîîกี้ǧ ṫŕåååกี้šåååçṫîîîöööกี้ öööกี้ {{îîîď}}...]",startChargingSuccess:"[{{{îîîď}} šṫåååŕṫéééď çḥåååŕǧîîîกี้ǧ!]"};var ChargePointPSEUDO = {status:status,error:error,units:units,charged:charged,settings:settings,chargingProfiles:chargingProfiles,offline:offline,actions:actions,name:name,activityStatus:activityStatus,warning:warning,plugChargeEnabled:plugChargeEnabled,updates:updates};

var reimbursement$2="Terugbetaling";var declarationOverview$2="Declaratieoverzicht";var vat$2="BTW";var rate$2="Tarief";var declaration$2="Declaratie";var noTransactionsFound$2="Geen transacties gevonden";var tariff$2="Tarief";var FinanceNL = {reimbursement:reimbursement$2,declarationOverview:declarationOverview$2,vat:vat$2,rate:rate$2,declaration:declaration$2,noTransactionsFound:noTransactionsFound$2,tariff:tariff$2};

var reimbursement$1="Reimbursement";var declarationOverview$1="Declaration overview";var vat$1="VAT";var rate$1="Rate";var declaration$1="Declaration";var noTransactionsFound$1="No transactions found";var tariff$1="Tariff";var FinanceEN = {reimbursement:reimbursement$1,declarationOverview:declarationOverview$1,vat:vat$1,rate:rate$1,declaration:declaration$1,noTransactionsFound:noTransactionsFound$1,tariff:tariff$1};

var reimbursement="[RRéééîîîmbūūūŕšéééméééกี้ṫ]";var declarationOverview="[DDéééçļåååŕåååṫîîîöööกี้ ööövéééŕvîîîéééw]";var vat="[VVAAAT]";var rate="[RRåååṫééé]";var declaration="[DDéééçļåååŕåååṫîîîöööกี้]";var noTransactionsFound="[NNööö ṫŕåååกี้šåååçṫîîîöööกี้š ḟöööūūūกี้ď]";var tariff="[TTåååŕîîîḟḟ]";var FinancePSEUDO = {reimbursement:reimbursement,declarationOverview:declarationOverview,vat:vat,rate:rate,declaration:declaration,noTransactionsFound:noTransactionsFound,tariff:tariff};

var blueCurrent$2="Blue Current";var toBlueCurrentWebsite$2="Naar bluecurrent.nl";var invest$2={ourMission:"Onze missie",whyInvest:"Waarom investeren",reserveAShare:"Aandelen reserveren",email:"investeren@bluecurrent.nl",tel:"change tel invest",emailFormatted:"investeren@bluecurrent.nl",telFormatted:"change tel invest",hasAlreadyReserved:"Al voor <span style=\"font-family: 'Caveat';font-size: 1.25em; padding-right: 3px; color: #FFFFFF; font-weight: 700;\">{{amount}}</span> aan aandelen gereserveerd!",downloadPitchDeck:"Download pitch deck",watchVideo:"Bekijk de video",togetherToSustainableMobility:"Samen op weg naar volledig duurzame elektrische mobiliteit",reserve:"Reserveer",seoTitle:"Word mede-eigenaar van Blue Current",seoDescription:"Help mee de transitie naar duurzame mobiliteit te versnellen",invest:"Investeer",investNow:"Investeer nu",success:"Onze eerste fundingronde is succesvol afgerond met <span style=\"font-family: 'Caveat';font-size: 1.25em; padding-right: 3px; color: #FFFFFF; font-weight: 700;\">{{amount}}</span>!",stayInformed:"Geïnformeerd blijven"};var email$2="samen@bluecurrent.nl";var tel$2="+31 (0) 85 04 66 050";var notFormatted$2={tel:"+310850466050",email:"samen@bluecurrent.nl"};var openingHours$2={week:"07:59 - 20:02",weekend:"08:59 - 17:03"};var slogan$2="Samen de transitie naar duurzame mobiliteit versnellen";var BrandingNL = {blueCurrent:blueCurrent$2,toBlueCurrentWebsite:toBlueCurrentWebsite$2,invest:invest$2,email:email$2,tel:tel$2,notFormatted:notFormatted$2,openingHours:openingHours$2,slogan:slogan$2};

var blueCurrent$1="Blue Current";var toBlueCurrentWebsite$1="To bluecurrent.nl";var invest$1={ourMission:"Our mission",whyInvest:"Why invest",reserveAShare:"Reserve shares",email:"invest@bluecurrent.nl",tel:"change tel invest",emailFormatted:"invest@bluecurrent.nl",telFormatted:"change tel invest",hasAlreadyReserved:"Already for <span style=\"font-family: 'Caveat';font-size: 1.25em; padding-right: 3px; color: #FFFFFF; font-weight: 700;\">{{amount}}</span> in shares reserved!",downloadPitchDeck:"Download pitch deck",watchVideo:"Watch the video",togetherToSustainableMobility:"Working together towards fully sustainable mobility",reserve:"Reserve",seoTitle:"Become co-owner of Blue Current",seoDescription:"Help accelerate the transition towards sustainable mobility",invest:"Invest",investNow:"Invest now",success:"Successfully completed our first funding round with <span style=\"font-family: 'Caveat';font-size: 1.25em; padding-right: 3px; color: #FFFFFF; font-weight: 700;\">{{amount}}</span>!",stayInformed:"Stay informed"};var email$1="samen@bluecurrent.nl";var tel$1="+31 (0) 85 04 66 050";var notFormatted$1={tel:"+310850466050",email:"samen@bluecurrent.nl"};var openingHours$1={week:"07:59 - 20:02",weekend:"08:59 - 17:03"};var slogan$1="Accelerate the transition to sustainable mobility together";var BrandingEN = {blueCurrent:blueCurrent$1,toBlueCurrentWebsite:toBlueCurrentWebsite$1,invest:invest$1,email:email$1,tel:tel$1,notFormatted:notFormatted$1,openingHours:openingHours$1,slogan:slogan$1};

var blueCurrent="[BBļūūūééé Cūūūŕŕéééกี้ṫ]";var toBlueCurrentWebsite="[TTööö bļūūūéééçūūūŕŕéééกี้ṫ.กี้ļ]";var invest={ourMission:"[OOOOūūūŕ mîîîššîîîöööกี้]",whyInvest:"[WWḥÝ îîîกี้véééšṫ]",reserveAShare:"[RRéééšéééŕvééé šḥåååŕéééš]",email:"[îîîîกี้véééšṫ@bļūūūéééçūūūŕŕéééกี้ṫ.กี้ļ]",tel:"[ççḥåååกี้ǧééé ṫéééļ îîîกี้véééšṫ]",emailFormatted:"[îîîîกี้véééšṫ@bļūūūéééçūūūŕŕéééกี้ṫ.กี้ļ]",telFormatted:"[ççḥåååกี้ǧééé ṫéééļ îîîกี้véééšṫ]",hasAlreadyReserved:"Already for <span style=\"font-family: 'Caveat';font-size: 1.25em; padding-right: 3px; color: #FFFFFF; font-weight: 700;\">{{amount}}</span> in shares reserved!",downloadPitchDeck:"[DDöööwกี้ļöööåååď þîîîṫçḥ ďéééçḱ]",watchVideo:"[WWåååṫçḥ ṫḥééé vîîîďéééööö]",togetherToSustainableMobility:"[WWöööŕḱîîîกี้ǧ ṫöööǧéééṫḥéééŕ ṫöööwåååŕďš ḟūūūļļÝ šūūūšṫåååîîîกี้åååbļééé möööbîîîļîîîṫÝ]",reserve:"[RRéééšéééŕvééé]",seoTitle:"[BBéééçööömééé çööö-öööwกี้éééŕ öööḟ Bļūūūééé Cūūūŕŕéééกี้ṫ]",seoDescription:"[HHéééļþ åååççéééļéééŕåååṫééé ṫḥééé ṫŕåååกี้šîîîṫîîîöööกี้ ṫöööwåååŕďš šūūūšṫåååîîîกี้åååbļééé möööbîîîļîîîṫÝ]",invest:"[IIIIกี้véééšṫ]",investNow:"[IIIIกี้véééšṫ กี้öööw]",success:"Successfully completed our first funding round with <span style=\"font-family: 'Caveat';font-size: 1.25em; padding-right: 3px; color: #FFFFFF; font-weight: 700;\">{{amount}}</span>!",stayInformed:"[SSṫåååÝ îîîกี้ḟöööŕméééď]"};var email="[ššåååméééกี้@bļūūūéééçūūūŕŕéééกี้ṫ.กี้ļ]";var tel="[++31 (0) 85 04 66 050]";var notFormatted={tel:"[++310850466050]",email:"[ššåååméééกี้@bļūūūéééçūūūŕŕéééกี้ṫ.กี้ļ]"};var openingHours={week:"[007:59 - 20:02]",weekend:"[008:59 - 17:03]"};var slogan="[AAAAççéééļéééŕåååṫééé ṫḥééé ṫŕåååกี้šîîîṫîîîöööกี้ ṫööö šūūūšṫåååîîîกี้åååbļééé möööbîîîļîîîṫÝ ṫöööǧéééṫḥéééŕ]";var BrandingPSEUDO = {blueCurrent:blueCurrent,toBlueCurrentWebsite:toBlueCurrentWebsite,invest:invest,email:email,tel:tel,notFormatted:notFormatted,openingHours:openingHours,slogan:slogan};

var byPressingYouAccept$2="Door op '{{button}}' te drukken accepteer je onze <a href=\"{{href}}\" target=\"_blank\">{{link}}</a>";var privacyPolicy$2="Privacy policy";var termsConditions$2="Algemene voorwaarden";var allRightsReserved$2="Alle rechten voorbehouden";var LegalNL = {byPressingYouAccept:byPressingYouAccept$2,privacyPolicy:privacyPolicy$2,termsConditions:termsConditions$2,allRightsReserved:allRightsReserved$2};

var byPressingYouAccept$1="By pressing '{{button}}' you agree to our <a href=\"{{href}}\" target=\"_blank\">{{link}}</a>";var privacyPolicy$1="Privacy policy";var termsConditions$1="Terms & conditions";var allRightsReserved$1="All rights reserved";var LegalEN = {byPressingYouAccept:byPressingYouAccept$1,privacyPolicy:privacyPolicy$1,termsConditions:termsConditions$1,allRightsReserved:allRightsReserved$1};

var byPressingYouAccept="By pressing '{{button}}' you agree to our <a href=\"{{href}}\" target=\"_blank\">{{link}}</a>";var privacyPolicy="[PPŕîîîvåååçÝ þöööļîîîçÝ]";var termsConditions="[TTéééŕmš & çöööกี้ďîîîṫîîîöööกี้š]";var allRightsReserved="[AAAAļļ ŕîîîǧḥṫš ŕéééšéééŕvéééď]";var LegalPSEUDO = {byPressingYouAccept:byPressingYouAccept,privacyPolicy:privacyPolicy,termsConditions:termsConditions,allRightsReserved:allRightsReserved};

var serialNumberEmpty$2="Serienummer kan niet leeg zijn";var invalidCardNumber$2="Serienummer bestaat niet";var duplicateCard$2="Kaart al toegevoegd";var noCardsFound$2="Geen laadpassen gevonden";var notMyChargeCards$2="Niet mijn laadpassen";var ChargeCardNL = {serialNumberEmpty:serialNumberEmpty$2,invalidCardNumber:invalidCardNumber$2,duplicateCard:duplicateCard$2,noCardsFound:noCardsFound$2,notMyChargeCards:notMyChargeCards$2};

var serialNumberEmpty$1="Serial number can't be empty";var invalidCardNumber$1="Serial number is invalid";var duplicateCard$1="Card already added";var noCardsFound$1="No charge cards found";var notMyChargeCards$1="Not my charge cards";var ChargeCardEN = {serialNumberEmpty:serialNumberEmpty$1,invalidCardNumber:invalidCardNumber$1,duplicateCard:duplicateCard$1,noCardsFound:noCardsFound$1,notMyChargeCards:notMyChargeCards$1};

var serialNumberEmpty="[SSéééŕîîîåååļ กี้ūūūmbéééŕ çåååกี้'ṫ bééé ééémþṫÝ]";var invalidCardNumber="[SSéééŕîîîåååļ กี้ūūūmbéééŕ îîîš îîîกี้våååļîîîď]";var duplicateCard="[CCåååŕď åååļŕéééåååďÝ åååďďéééď]";var noCardsFound="[NNööö çḥåååŕǧééé çåååŕďš ḟöööūūūกี้ď]";var notMyChargeCards="[NNöööṫ mÝ çḥåååŕǧééé çåååŕďš]";var ChargeCardPSEUDO = {serialNumberEmpty:serialNumberEmpty,invalidCardNumber:invalidCardNumber,duplicateCard:duplicateCard,noCardsFound:noCardsFound,notMyChargeCards:notMyChargeCards};

instance.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  ns: ['authentication', 'settings', 'ui', 'dates', 'finance', 'branding', 'legal', 'chargecard', 'chargepoint'],
  detection: {
    caches: []
  },
  resources: {
    nl: {
      authentication: AuthenticationNL,
      settings: SettingsNL,
      ui: UiNL,
      dates: DatesNL,
      chargepoint: ChargePointNL,
      finance: FinanceNL,
      branding: BrandingNL,
      legal: LegalNL,
      chargecard: ChargeCardNL
    },
    en: {
      authentication: AuthenticationEN,
      settings: SettingsEN,
      ui: UiEN,
      dates: DatesEN,
      chargepoint: ChargePointEN,
      finance: FinanceEN,
      branding: BrandingEN,
      legal: LegalEN,
      chargecard: ChargeCardEN
    },
    pseudo: {
      authentication: AuthenticationPSEUDO,
      settings: SettingsPSEUDO,
      ui: UiPSEUDO,
      dates: DatesPSEUDO,
      chargepoint: ChargePointPSEUDO,
      finance: FinancePSEUDO,
      branding: BrandingPSEUDO,
      legal: LegalPSEUDO,
      chargecard: ChargeCardPSEUDO
    }
  }
});

var Lang = {
  useTranslation: useTranslation
};

var dist = {};

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (process.env.NODE_ENV !== "production") {
  (function() {
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}
function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;
        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;
          default:
            var $$typeofType = type && type.$$typeof;
            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;
              default:
                return $$typeof;
            }
        }
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }
  return undefined;
}
var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true;
      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }
  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}
reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}
	return Object(val);
}
function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}
		var test1 = new String('abc');
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}
		return true;
	} catch (err) {
		return false;
	}
}
var objectAssign$6 = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;
	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);
		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}
		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}
	return to;
};

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1 = function() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {  }
  };
}
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes$1;

var ReactIs$1 = reactIs.exports;
var assign = objectAssign$6;
var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;
var printWarning = function() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes$1 = propTypes.exports;

var baseUrl = 'https://docs.sanity.io/help/';
var generateHelpUrl$1 = function generateHelpUrl(slug) {
  return baseUrl + slug
};

var builder = {};

var urlForImage = {};

var parseAssetId$1 = {};

Object.defineProperty(parseAssetId$1, "__esModule", { value: true });
var example = 'image-Tb9Ew8CXIwaY6R1kjMvI0uRR-2000x3000-jpg';
function parseAssetId(ref) {
    var _a = ref.split('-'), id = _a[1], dimensionString = _a[2], format = _a[3];
    if (!id || !dimensionString || !format) {
        throw new Error("Malformed asset _ref '" + ref + "'. Expected an id like \"" + example + "\".");
    }
    var _b = dimensionString.split('x'), imgWidthStr = _b[0], imgHeightStr = _b[1];
    var width = +imgWidthStr;
    var height = +imgHeightStr;
    var isValidAssetId = isFinite(width) && isFinite(height);
    if (!isValidAssetId) {
        throw new Error("Malformed asset _ref '" + ref + "'. Expected an id like \"" + example + "\".");
    }
    return { id: id, width: width, height: height, format: format };
}
parseAssetId$1.default = parseAssetId;

var parseSource$1 = {};

var __assign$1 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
Object.defineProperty(parseSource$1, "__esModule", { value: true });
var isRef$1 = function (src) {
    var source = src;
    return source ? typeof source._ref === 'string' : false;
};
var isAsset = function (src) {
    var source = src;
    return source ? typeof source._id === 'string' : false;
};
var isAssetStub = function (src) {
    var source = src;
    return source && source.asset ? typeof source.asset.url === 'string' : false;
};
function parseSource(source) {
    if (!source) {
        return null;
    }
    var image;
    if (typeof source === 'string' && isUrl(source)) {
        image = {
            asset: { _ref: urlToId(source) },
        };
    }
    else if (typeof source === 'string') {
        image = {
            asset: { _ref: source },
        };
    }
    else if (isRef$1(source)) {
        image = {
            asset: source,
        };
    }
    else if (isAsset(source)) {
        image = {
            asset: {
                _ref: source._id || '',
            },
        };
    }
    else if (isAssetStub(source)) {
        image = {
            asset: {
                _ref: urlToId(source.asset.url),
            },
        };
    }
    else if (typeof source.asset === 'object') {
        image = source;
    }
    else {
        return null;
    }
    var img = source;
    if (img.crop) {
        image.crop = img.crop;
    }
    if (img.hotspot) {
        image.hotspot = img.hotspot;
    }
    return applyDefaults(image);
}
parseSource$1.default = parseSource;
function isUrl(url) {
    return /^https?:\/\//.test("" + url);
}
function urlToId(url) {
    var parts = url.split('/').slice(-1);
    return ("image-" + parts[0]).replace(/\.([a-z]+)$/, '-$1');
}
function applyDefaults(image) {
    if (image.crop && image.hotspot) {
        return image;
    }
    var result = __assign$1({}, image);
    if (!result.crop) {
        result.crop = {
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
        };
    }
    if (!result.hotspot) {
        result.hotspot = {
            x: 0.5,
            y: 0.5,
            height: 1.0,
            width: 1.0,
        };
    }
    return result;
}

(function (exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var parseAssetId_1 = __importDefault(parseAssetId$1);
var parseSource_1 = __importDefault(parseSource$1);
exports.parseSource = parseSource_1.default;
exports.SPEC_NAME_TO_URL_NAME_MAPPINGS = [
    ['width', 'w'],
    ['height', 'h'],
    ['format', 'fm'],
    ['download', 'dl'],
    ['blur', 'blur'],
    ['sharpen', 'sharp'],
    ['invert', 'invert'],
    ['orientation', 'or'],
    ['minHeight', 'min-h'],
    ['maxHeight', 'max-h'],
    ['minWidth', 'min-w'],
    ['maxWidth', 'max-w'],
    ['quality', 'q'],
    ['fit', 'fit'],
    ['crop', 'crop'],
    ['saturation', 'sat'],
    ['auto', 'auto'],
    ['dpr', 'dpr'],
    ['pad', 'pad'],
];
function urlForImage(options) {
    var spec = __assign({}, (options || {}));
    var source = spec.source;
    delete spec.source;
    var image = parseSource_1.default(source);
    if (!image) {
        return null;
    }
    var id = image.asset._ref || image.asset._id || '';
    var asset = parseAssetId_1.default(id);
    var cropLeft = Math.round(image.crop.left * asset.width);
    var cropTop = Math.round(image.crop.top * asset.height);
    var crop = {
        left: cropLeft,
        top: cropTop,
        width: Math.round(asset.width - image.crop.right * asset.width - cropLeft),
        height: Math.round(asset.height - image.crop.bottom * asset.height - cropTop),
    };
    var hotSpotVerticalRadius = (image.hotspot.height * asset.height) / 2;
    var hotSpotHorizontalRadius = (image.hotspot.width * asset.width) / 2;
    var hotSpotCenterX = image.hotspot.x * asset.width;
    var hotSpotCenterY = image.hotspot.y * asset.height;
    var hotspot = {
        left: hotSpotCenterX - hotSpotHorizontalRadius,
        top: hotSpotCenterY - hotSpotVerticalRadius,
        right: hotSpotCenterX + hotSpotHorizontalRadius,
        bottom: hotSpotCenterY + hotSpotVerticalRadius,
    };
    if (!(spec.rect || spec.focalPoint || spec.ignoreImageParams || spec.crop)) {
        spec = __assign(__assign({}, spec), fit({ crop: crop, hotspot: hotspot }, spec));
    }
    return specToImageUrl(__assign(__assign({}, spec), { asset: asset }));
}
exports.default = urlForImage;
function specToImageUrl(spec) {
    var cdnUrl = spec.baseUrl || 'https://cdn.sanity.io';
    var filename = spec.asset.id + "-" + spec.asset.width + "x" + spec.asset.height + "." + spec.asset.format;
    var baseUrl = cdnUrl + "/images/" + spec.projectId + "/" + spec.dataset + "/" + filename;
    var params = [];
    if (spec.rect) {
        var _a = spec.rect, left = _a.left, top_1 = _a.top, width = _a.width, height = _a.height;
        var isEffectiveCrop = left !== 0 || top_1 !== 0 || height !== spec.asset.height || width !== spec.asset.width;
        if (isEffectiveCrop) {
            params.push("rect=" + left + "," + top_1 + "," + width + "," + height);
        }
    }
    if (spec.bg) {
        params.push("bg=" + spec.bg);
    }
    if (spec.focalPoint) {
        params.push("fp-x=" + spec.focalPoint.x);
        params.push("fp-y=" + spec.focalPoint.y);
    }
    var flip = [spec.flipHorizontal && 'h', spec.flipVertical && 'v'].filter(Boolean).join('');
    if (flip) {
        params.push("flip=" + flip);
    }
    exports.SPEC_NAME_TO_URL_NAME_MAPPINGS.forEach(function (mapping) {
        var specName = mapping[0], param = mapping[1];
        if (typeof spec[specName] !== 'undefined') {
            params.push(param + "=" + encodeURIComponent(spec[specName]));
        }
        else if (typeof spec[param] !== 'undefined') {
            params.push(param + "=" + encodeURIComponent(spec[param]));
        }
    });
    if (params.length === 0) {
        return baseUrl;
    }
    return baseUrl + "?" + params.join('&');
}
function fit(source, spec) {
    var cropRect;
    var imgWidth = spec.width;
    var imgHeight = spec.height;
    if (!(imgWidth && imgHeight)) {
        return { width: imgWidth, height: imgHeight, rect: source.crop };
    }
    var crop = source.crop;
    var hotspot = source.hotspot;
    var desiredAspectRatio = imgWidth / imgHeight;
    var cropAspectRatio = crop.width / crop.height;
    if (cropAspectRatio > desiredAspectRatio) {
        var height = crop.height;
        var width = height * desiredAspectRatio;
        var top_2 = crop.top;
        var hotspotXCenter = (hotspot.right - hotspot.left) / 2 + hotspot.left;
        var left = hotspotXCenter - width / 2;
        if (left < crop.left) {
            left = crop.left;
        }
        else if (left + width > crop.left + crop.width) {
            left = crop.left + crop.width - width;
        }
        cropRect = {
            left: Math.round(left),
            top: Math.round(top_2),
            width: Math.round(width),
            height: Math.round(height),
        };
    }
    else {
        var width = crop.width;
        var height = width / desiredAspectRatio;
        var left = crop.left;
        var hotspotYCenter = (hotspot.bottom - hotspot.top) / 2 + hotspot.top;
        var top_3 = hotspotYCenter - height / 2;
        if (top_3 < crop.top) {
            top_3 = crop.top;
        }
        else if (top_3 + height > crop.top + crop.height) {
            top_3 = crop.top + crop.height - height;
        }
        cropRect = {
            left: Math.max(0, Math.floor(left)),
            top: Math.max(0, Math.floor(top_3)),
            width: Math.round(width),
            height: Math.round(height),
        };
    }
    return {
        width: imgWidth,
        height: imgHeight,
        rect: cropRect,
    };
}
}(urlForImage));
getDefaultExportFromCjs(urlForImage);

var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(builder, "__esModule", { value: true });
var urlForImage_1 = __importStar(urlForImage);
var validFits = ['clip', 'crop', 'fill', 'fillmax', 'max', 'scale', 'min'];
var validCrops = ['top', 'bottom', 'left', 'right', 'center', 'focalpoint', 'entropy'];
var validAutoModes = ['format'];
function isSanityClientLike(client) {
    return client ? typeof client.clientConfig === 'object' : false;
}
function rewriteSpecName(key) {
    var specs = urlForImage_1.SPEC_NAME_TO_URL_NAME_MAPPINGS;
    for (var _i = 0, specs_1 = specs; _i < specs_1.length; _i++) {
        var entry = specs_1[_i];
        var specName = entry[0], param = entry[1];
        if (key === specName || key === param) {
            return specName;
        }
    }
    return key;
}
function urlBuilder$1(options) {
    var client = options;
    if (isSanityClientLike(client)) {
        var _a = client.clientConfig, apiUrl = _a.apiHost, projectId = _a.projectId, dataset = _a.dataset;
        var apiHost = apiUrl || 'https://api.sanity.io';
        return new ImageUrlBuilder(null, {
            baseUrl: apiHost.replace(/^https:\/\/api\./, 'https://cdn.'),
            projectId: projectId,
            dataset: dataset,
        });
    }
    return new ImageUrlBuilder(null, options);
}
builder.default = urlBuilder$1;
var ImageUrlBuilder =  (function () {
    function ImageUrlBuilder(parent, options) {
        this.options = parent
            ? __assign(__assign({}, (parent.options || {})), (options || {})) : __assign({}, (options || {}));
    }
    ImageUrlBuilder.prototype.withOptions = function (options) {
        var baseUrl = options.baseUrl || this.options.baseUrl;
        var newOptions = { baseUrl: baseUrl };
        for (var key in options) {
            if (options.hasOwnProperty(key)) {
                var specKey = rewriteSpecName(key);
                newOptions[specKey] = options[key];
            }
        }
        return new ImageUrlBuilder(this, __assign({ baseUrl: baseUrl }, newOptions));
    };
    ImageUrlBuilder.prototype.image = function (source) {
        return this.withOptions({ source: source });
    };
    ImageUrlBuilder.prototype.dataset = function (dataset) {
        return this.withOptions({ dataset: dataset });
    };
    ImageUrlBuilder.prototype.projectId = function (projectId) {
        return this.withOptions({ projectId: projectId });
    };
    ImageUrlBuilder.prototype.bg = function (bg) {
        return this.withOptions({ bg: bg });
    };
    ImageUrlBuilder.prototype.dpr = function (dpr) {
        return this.withOptions({ dpr: dpr });
    };
    ImageUrlBuilder.prototype.width = function (width) {
        return this.withOptions({ width: width });
    };
    ImageUrlBuilder.prototype.height = function (height) {
        return this.withOptions({ height: height });
    };
    ImageUrlBuilder.prototype.focalPoint = function (x, y) {
        return this.withOptions({ focalPoint: { x: x, y: y } });
    };
    ImageUrlBuilder.prototype.maxWidth = function (maxWidth) {
        return this.withOptions({ maxWidth: maxWidth });
    };
    ImageUrlBuilder.prototype.minWidth = function (minWidth) {
        return this.withOptions({ minWidth: minWidth });
    };
    ImageUrlBuilder.prototype.maxHeight = function (maxHeight) {
        return this.withOptions({ maxHeight: maxHeight });
    };
    ImageUrlBuilder.prototype.minHeight = function (minHeight) {
        return this.withOptions({ minHeight: minHeight });
    };
    ImageUrlBuilder.prototype.size = function (width, height) {
        return this.withOptions({ width: width, height: height });
    };
    ImageUrlBuilder.prototype.blur = function (blur) {
        return this.withOptions({ blur: blur });
    };
    ImageUrlBuilder.prototype.sharpen = function (sharpen) {
        return this.withOptions({ sharpen: sharpen });
    };
    ImageUrlBuilder.prototype.rect = function (left, top, width, height) {
        return this.withOptions({ rect: { left: left, top: top, width: width, height: height } });
    };
    ImageUrlBuilder.prototype.format = function (format) {
        return this.withOptions({ format: format });
    };
    ImageUrlBuilder.prototype.invert = function (invert) {
        return this.withOptions({ invert: invert });
    };
    ImageUrlBuilder.prototype.orientation = function (orientation) {
        return this.withOptions({ orientation: orientation });
    };
    ImageUrlBuilder.prototype.quality = function (quality) {
        return this.withOptions({ quality: quality });
    };
    ImageUrlBuilder.prototype.forceDownload = function (download) {
        return this.withOptions({ download: download });
    };
    ImageUrlBuilder.prototype.flipHorizontal = function () {
        return this.withOptions({ flipHorizontal: true });
    };
    ImageUrlBuilder.prototype.flipVertical = function () {
        return this.withOptions({ flipVertical: true });
    };
    ImageUrlBuilder.prototype.ignoreImageParams = function () {
        return this.withOptions({ ignoreImageParams: true });
    };
    ImageUrlBuilder.prototype.fit = function (value) {
        if (validFits.indexOf(value) === -1) {
            throw new Error("Invalid fit mode \"" + value + "\"");
        }
        return this.withOptions({ fit: value });
    };
    ImageUrlBuilder.prototype.crop = function (value) {
        if (validCrops.indexOf(value) === -1) {
            throw new Error("Invalid crop mode \"" + value + "\"");
        }
        return this.withOptions({ crop: value });
    };
    ImageUrlBuilder.prototype.saturation = function (saturation) {
        return this.withOptions({ saturation: saturation });
    };
    ImageUrlBuilder.prototype.auto = function (value) {
        if (validAutoModes.indexOf(value) === -1) {
            throw new Error("Invalid auto mode \"" + value + "\"");
        }
        return this.withOptions({ auto: value });
    };
    ImageUrlBuilder.prototype.pad = function (pad) {
        return this.withOptions({ pad: pad });
    };
    ImageUrlBuilder.prototype.url = function () {
        return urlForImage_1.default(this.options);
    };
    ImageUrlBuilder.prototype.toString = function () {
        return this.url();
    };
    return ImageUrlBuilder;
}());
builder.ImageUrlBuilder = ImageUrlBuilder;

var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var builder_1 = __importDefault(builder);
var node = builder_1.default;

var generateHelpUrl = generateHelpUrl$1;
var urlBuilder = node;
var objectAssign$5 = objectAssign$6;
var enc = encodeURIComponent;
var materializeError = "You must either:\n  - Pass `projectId` and `dataset` to the block renderer\n  - Materialize images to include the `url` field.\n\nFor more information, see ".concat(generateHelpUrl('block-content-image-materializing'));
var getQueryString = function getQueryString(options) {
  var query = options.imageOptions;
  var keys = Object.keys(query);
  if (!keys.length) {
    return '';
  }
  var params = keys.map(function (key) {
    return "".concat(enc(key), "=").concat(enc(query[key]));
  });
  return "?".concat(params.join('&'));
};
var buildUrl = function buildUrl(props) {
  var node = props.node,
      options = props.options;
  var projectId = options.projectId,
      dataset = options.dataset;
  var asset = node.asset;
  if (!asset) {
    throw new Error('Image does not have required `asset` property');
  }
  if (asset.url) {
    return asset.url + getQueryString(options);
  }
  if (!projectId || !dataset) {
    throw new Error(materializeError);
  }
  var ref = asset._ref;
  if (!ref) {
    throw new Error('Invalid image reference in block, no `_ref` found on `asset`');
  }
  return urlBuilder(objectAssign$5({
    projectId: projectId,
    dataset: dataset
  }, options.imageOptions || {})).image(node).toString();
};
var getImageUrl$3 = buildUrl;

var objectAssign$4 = objectAssign$6;
var getImageUrl$2 = getImageUrl$3;
var serializers$1 = function (h, serializerOpts) {
  var serializeOptions = serializerOpts || {
    useDashedStyles: false
  };
  function BlockSerializer(props) {
    var node = props.node,
        serializers = props.serializers,
        options = props.options,
        isInline = props.isInline,
        children = props.children;
    var blockType = node._type;
    var serializer = serializers.types[blockType];
    if (!serializer) {
      throw new Error("Unknown block type \"".concat(blockType, "\", please specify a serializer for it in the `serializers.types` prop"));
    }
    return h(serializer, {
      node: node,
      options: options,
      isInline: isInline
    }, children);
  }
  function SpanSerializer(props) {
    var _props$node = props.node,
        mark = _props$node.mark,
        children = _props$node.children;
    var isPlain = typeof mark === 'string';
    var markType = isPlain ? mark : mark._type;
    var serializer = props.serializers.marks[markType];
    if (!serializer) {
      console.warn("Unknown mark type \"".concat(markType, "\", please specify a serializer for it in the `serializers.marks` prop"));
      return h(props.serializers.markFallback, null, children);
    }
    return h(serializer, props.node, children);
  }
  function ListSerializer(props) {
    var tag = props.type === 'bullet' ? 'ul' : 'ol';
    return h(tag, null, props.children);
  }
  function ListItemSerializer(props) {
    var children = !props.node.style || props.node.style === 'normal' ?
    props.children :
    h(props.serializers.types.block, props, props.children);
    return h('li', null, children);
  }
  function BlockTypeSerializer(props) {
    var style = props.node.style || 'normal';
    if (/^h\d/.test(style)) {
      return h(style, null, props.children);
    }
    return style === 'blockquote' ? h('blockquote', null, props.children) : h('p', null, props.children);
  }
  function RawMarkSerializer(tag, props) {
    return h(tag, null, props.children);
  }
  function UnderlineSerializer(props) {
    var style = serializeOptions.useDashedStyles ? {
      'text-decoration': 'underline'
    } : {
      textDecoration: 'underline'
    };
    return h('span', {
      style: style
    }, props.children);
  }
  function StrikeThroughSerializer(props) {
    return h('del', null, props.children);
  }
  function LinkSerializer(props) {
    return h('a', {
      href: props.mark.href
    }, props.children);
  }
  function ImageSerializer(props) {
    if (!props.node.asset) {
      return null;
    }
    var img = h('img', {
      src: getImageUrl$2(props)
    });
    return props.isInline ? img : h('figure', null, img);
  }
  function serializeSpan(span, serializers, index, options) {
    if (span === '\n' && serializers.hardBreak) {
      return h(serializers.hardBreak, {
        key: "hb-".concat(index)
      });
    }
    if (typeof span === 'string') {
      return serializers.text ? h(serializers.text, {
        key: "text-".concat(index)
      }, span) : span;
    }
    var children;
    if (span.children) {
      children = {
        children: span.children.map(function (child, i) {
          return options.serializeNode(child, i, span.children, true);
        })
      };
    }
    var serializedNode = objectAssign$4({}, span, children);
    return h(serializers.span, {
      key: span._key || "span-".concat(index),
      node: serializedNode,
      serializers: serializers
    });
  }
  var HardBreakSerializer = function HardBreakSerializer() {
    return h('br');
  };
  var defaultMarkSerializers = {
    strong: RawMarkSerializer.bind(null, 'strong'),
    em: RawMarkSerializer.bind(null, 'em'),
    code: RawMarkSerializer.bind(null, 'code'),
    underline: UnderlineSerializer,
    'strike-through': StrikeThroughSerializer,
    link: LinkSerializer
  };
  var defaultSerializers = {
    types: {
      block: BlockTypeSerializer,
      image: ImageSerializer
    },
    marks: defaultMarkSerializers,
    list: ListSerializer,
    listItem: ListItemSerializer,
    block: BlockSerializer,
    span: SpanSerializer,
    hardBreak: HardBreakSerializer,
    container: 'div',
    markFallback: 'span',
    text: undefined,
    empty: ''
  };
  return {
    defaultSerializers: defaultSerializers,
    serializeSpan: serializeSpan
  };
};

var defaultMarks = ['strong', 'em', 'code', 'underline', 'strike-through'];
var buildMarksTree$1 = function buildMarksTree(block) {
  var children = block.children,
      markDefs = block.markDefs;
  if (!children || !children.length) {
    return [];
  }
  var sortedMarks = children.map(sortMarksByOccurences);
  var rootNode = {
    _type: 'span',
    children: []
  };
  var nodeStack = [rootNode];
  children.forEach(function (span, i) {
    var marksNeeded = sortedMarks[i];
    if (!marksNeeded) {
      var lastNode = nodeStack[nodeStack.length - 1];
      lastNode.children.push(span);
      return;
    }
    var pos = 1;
    if (nodeStack.length > 1) {
      for (pos; pos < nodeStack.length; pos++) {
        var mark = nodeStack[pos].markKey;
        var index = marksNeeded.indexOf(mark);
        if (index === -1) {
          break;
        }
        marksNeeded.splice(index, 1);
      }
    }
    nodeStack = nodeStack.slice(0, pos);
    var currentNode = findLastParentNode(nodeStack);
    marksNeeded.forEach(function (mark) {
      var node = {
        _type: 'span',
        _key: span._key,
        children: [],
        mark: markDefs.find(function (def) {
          return def._key === mark;
        }) || mark,
        markKey: mark
      };
      currentNode.children.push(node);
      nodeStack.push(node);
      currentNode = node;
    });
    if (isTextSpan(span)) {
      var lines = span.text.split('\n');
      for (var line = lines.length; line-- > 1;) {
        lines.splice(line, 0, '\n');
      }
      currentNode.children = currentNode.children.concat(lines);
    } else {
      currentNode.children = currentNode.children.concat(span);
    }
  });
  return rootNode.children;
};
function sortMarksByOccurences(span, i, spans) {
  if (!span.marks || span.marks.length === 0) {
    return span.marks || [];
  }
  var markOccurences = span.marks.reduce(function (occurences, mark) {
    occurences[mark] = occurences[mark] ? occurences[mark] + 1 : 1;
    for (var siblingIndex = i + 1; siblingIndex < spans.length; siblingIndex++) {
      var sibling = spans[siblingIndex];
      if (sibling.marks && Array.isArray(sibling.marks) && sibling.marks.indexOf(mark) !== -1) {
        occurences[mark]++;
      } else {
        break;
      }
    }
    return occurences;
  }, {});
  var sortByOccurence = sortMarks.bind(null, markOccurences);
  return span.marks.slice().sort(sortByOccurence);
}
function sortMarks(occurences, markA, markB) {
  var aOccurences = occurences[markA] || 0;
  var bOccurences = occurences[markB] || 0;
  if (aOccurences !== bOccurences) {
    return bOccurences - aOccurences;
  }
  var aDefaultPos = defaultMarks.indexOf(markA);
  var bDefaultPos = defaultMarks.indexOf(markB);
  if (aDefaultPos !== bDefaultPos) {
    return aDefaultPos - bDefaultPos;
  }
  if (markA < markB) {
    return -1;
  } else if (markA > markB) {
    return 1;
  }
  return 0;
}
function isTextSpan(node) {
  return node._type === 'span' && typeof node.text === 'string' && (Array.isArray(node.marks) || typeof node.marks === 'undefined');
}
function findLastParentNode(nodes) {
  for (var i = nodes.length - 1; i >= 0; i--) {
    var node = nodes[i];
    if (node._type === 'span' && node.children) {
      return node;
    }
  }
  return undefined;
}
var buildMarksTree_1 = buildMarksTree$1;

var objectAssign$3 = objectAssign$6;
function nestLists$1(blocks) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'html';
  var tree = [];
  var currentList;
  for (var i = 0; i < blocks.length; i++) {
    var block = blocks[i];
    if (!isListBlock(block)) {
      tree.push(block);
      currentList = null;
      continue;
    }
    if (!currentList) {
      currentList = listFromBlock(block);
      tree.push(currentList);
      continue;
    }
    if (blockMatchesList(block, currentList)) {
      currentList.children.push(block);
      continue;
    }
    if (block.level > currentList.level) {
      var newList = listFromBlock(block);
      if (mode === 'html') {
        var lastListItem = lastChild(currentList);
        var newLastChild = objectAssign$3({}, lastListItem, {
          children: lastListItem.children.concat(newList)
        });
        currentList.children[currentList.children.length - 1] = newLastChild;
      } else {
        currentList.children.push(newList);
      }
      currentList = newList;
      continue;
    }
    if (block.level < currentList.level) {
      var match = findListMatching(tree[tree.length - 1], block);
      if (match) {
        currentList = match;
        currentList.children.push(block);
        continue;
      }
      currentList = listFromBlock(block);
      tree.push(currentList);
      continue;
    }
    if (block.listItem !== currentList.listItem) {
      var _match = findListMatching(tree[tree.length - 1], {
        level: block.level
      });
      if (_match && _match.listItem === block.listItem) {
        currentList = _match;
        currentList.children.push(block);
        continue;
      } else {
        currentList = listFromBlock(block);
        tree.push(currentList);
        continue;
      }
    }
    console.warn('Unknown state encountered for block', block);
    tree.push(block);
  }
  return tree;
}
function isListBlock(block) {
  return Boolean(block.listItem);
}
function blockMatchesList(block, list) {
  return block.level === list.level && block.listItem === list.listItem;
}
function listFromBlock(block) {
  return {
    _type: 'list',
    _key: "".concat(block._key, "-parent"),
    level: block.level,
    listItem: block.listItem,
    children: [block]
  };
}
function lastChild(block) {
  return block.children && block.children[block.children.length - 1];
}
function findListMatching(rootNode, matching) {
  var filterOnType = typeof matching.listItem === 'string';
  if (rootNode._type === 'list' && rootNode.level === matching.level && filterOnType && rootNode.listItem === matching.listItem) {
    return rootNode;
  }
  var node = lastChild(rootNode);
  if (!node) {
    return false;
  }
  return findListMatching(node, matching);
}
var nestLists_1 = nestLists$1;

var objectAssign$2 = objectAssign$6;
var generateKeys$1 = function (blocks) {
  return blocks.map(function (block) {
    if (block._key) {
      return block;
    }
    return objectAssign$2({
      _key: getStaticKey(block)
    }, block);
  });
};
function getStaticKey(item) {
  return checksum(JSON.stringify(item)).toString(36).replace(/[^A-Za-z0-9]/g, '');
}
function checksum(str) {
  var hash = 0;
  var strlen = str.length;
  if (strlen === 0) {
    return hash;
  }
  for (var i = 0; i < strlen; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash &= hash;
  }
  return hash;
}

function _typeof$3(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }
var objectAssign$1 = objectAssign$6;
var isDefined$2 = function isDefined(val) {
  return typeof val !== 'undefined';
};
var mergeSerializers$3 = function mergeSerializers(defaultSerializers, userSerializers) {
  return Object.keys(defaultSerializers).reduce(function (acc, key) {
    var type = _typeof$3(defaultSerializers[key]);
    if (type === 'function') {
      acc[key] = isDefined$2(userSerializers[key]) ? userSerializers[key] : defaultSerializers[key];
    } else if (type === 'object') {
      acc[key] = objectAssign$1({}, defaultSerializers[key], userSerializers[key]);
    } else {
      acc[key] = typeof userSerializers[key] === 'undefined' ? defaultSerializers[key] : userSerializers[key];
    }
    return acc;
  }, {});
};

var objectAssign = objectAssign$6;
var buildMarksTree = buildMarksTree_1;
var nestLists = nestLists_1;
var generateKeys = generateKeys$1;
var mergeSerializers$2 = mergeSerializers$3;
var optionProps = ['projectId', 'dataset', 'imageOptions'];
var isDefined$1 = function isDefined(val) {
  return typeof val !== 'undefined';
};
var defaults = {
  imageOptions: {}
};
function blocksToNodes$1(h, properties, defaultSerializers, serializeSpan) {
  var props = objectAssign({}, defaults, properties);
  var rawBlocks = Array.isArray(props.blocks) ? props.blocks : [props.blocks];
  var keyedBlocks = generateKeys(rawBlocks);
  var blocks = nestLists(keyedBlocks, props.listNestMode);
  var serializers = mergeSerializers$2(defaultSerializers, props.serializers || {});
  var options = optionProps.reduce(function (opts, key) {
    var value = props[key];
    if (isDefined$1(value)) {
      opts[key] = value;
    }
    return opts;
  }, {});
  function serializeNode(node, index, siblings, isInline) {
    if (isList(node)) {
      return serializeList(node);
    }
    if (isListItem(node)) {
      return serializeListItem(node, findListItemIndex(node, siblings));
    }
    if (isSpan(node)) {
      return serializeSpan(node, serializers, index, {
        serializeNode: serializeNode
      });
    }
    return serializeBlock(node, index, isInline);
  }
  function findListItemIndex(node, siblings) {
    var index = 0;
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] === node) {
        return index;
      }
      if (!isListItem(siblings[i])) {
        continue;
      }
      index++;
    }
    return index;
  }
  function serializeBlock(block, index, isInline) {
    var tree = buildMarksTree(block);
    var children = tree.map(function (node, i, siblings) {
      return serializeNode(node, i, siblings, true);
    });
    var blockProps = {
      key: block._key || "block-".concat(index),
      node: block,
      isInline: isInline,
      serializers: serializers,
      options: options
    };
    return h(serializers.block, blockProps, children);
  }
  function serializeListItem(block, index) {
    var key = block._key;
    var tree = buildMarksTree(block);
    var children = tree.map(serializeNode);
    return h(serializers.listItem, {
      node: block,
      serializers: serializers,
      index: index,
      key: key,
      options: options
    }, children);
  }
  function serializeList(list) {
    var type = list.listItem;
    var level = list.level;
    var key = list._key;
    var children = list.children.map(serializeNode);
    return h(serializers.list, {
      key: key,
      level: level,
      type: type,
      options: options
    }, children);
  }
  var renderContainerOnSingleChild = Boolean(props.renderContainerOnSingleChild);
  var nodes = blocks.map(serializeNode);
  if (renderContainerOnSingleChild || nodes.length > 1) {
    var containerProps = props.className ? {
      className: props.className
    } : {};
    return h(serializers.container, containerProps, nodes);
  }
  if (nodes[0]) {
    return nodes[0];
  }
  return typeof serializers.empty === 'function' ? h(serializers.empty) : serializers.empty;
}
function isList(block) {
  return block._type === 'list' && block.listItem;
}
function isListItem(block) {
  return block._type === 'block' && block.listItem;
}
function isSpan(block) {
  return typeof block === 'string' || block.marks || block._type === 'span';
}
var blocksToNodes_1 = blocksToNodes$1;

var getSerializers$1 = serializers$1;
var _blocksToNodes = blocksToNodes_1;
var getImageUrl$1 = getImageUrl$3;
var mergeSerializers$1 = mergeSerializers$3;
var internals$2 = {
  blocksToNodes: function blocksToNodes(renderNode, props, defaultSerializers, serializeSpan) {
    if (defaultSerializers) {
      return _blocksToNodes(renderNode, props, defaultSerializers, serializeSpan);
    }
    var serializers = getSerializers$1(renderNode);
    return _blocksToNodes(renderNode, props, serializers.defaultSerializers, serializers.serializeSpan);
  },
  getSerializers: getSerializers$1,
  getImageUrl: getImageUrl$1,
  mergeSerializers: mergeSerializers$1
};

var internals$1 = internals$2;

var React$1 = React__default;
var _require$1 = internals$1,
    getSerializers = _require$1.getSerializers;
var renderNode$1 = React$1.createElement;
var _getSerializers = getSerializers(renderNode$1),
    defaultSerializers = _getSerializers.defaultSerializers,
    serializeSpan$1 = _getSerializers.serializeSpan;
var dom = {
  serializeSpan: serializeSpan$1,
  serializers: defaultSerializers,
  renderProps: { nestMarks: true }
};

var React = React__default;
var PropTypes = propTypes.exports;
var internals = internals$1;
var _require = dom,
    serializers = _require.serializers,
    serializeSpan = _require.serializeSpan,
    renderProps = _require.renderProps;
var getImageUrl = internals.getImageUrl,
    blocksToNodes = internals.blocksToNodes,
    mergeSerializers = internals.mergeSerializers;
var renderNode = React.createElement;
var SanityBlockContent = function SanityBlockContent(props) {
  var customSerializers = mergeSerializers(SanityBlockContent.defaultSerializers, props.serializers);
  var blockProps = Object.assign({}, renderProps, props, {
    serializers: customSerializers,
    blocks: props.blocks || []
  });
  return blocksToNodes(renderNode, blockProps, serializers, serializeSpan);
};
SanityBlockContent.defaultSerializers = serializers;
SanityBlockContent.getImageUrl = getImageUrl;
SanityBlockContent.propTypes = {
  className: PropTypes.string,
  renderContainerOnSingleChild: PropTypes.bool,
  projectId: PropTypes.string,
  dataset: PropTypes.string,
  imageOptions: PropTypes.object,
  serializers: PropTypes.shape({
    types: PropTypes.object,
    marks: PropTypes.object,
    list: PropTypes.func,
    listItem: PropTypes.func,
    block: PropTypes.func,
    span: PropTypes.func
  }),
  blocks: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    _type: PropTypes.string.isRequired
  })), PropTypes.shape({
    _type: PropTypes.string.isRequired
  })]).isRequired
};
SanityBlockContent.defaultProps = {
  renderContainerOnSingleChild: false,
  serializers: {},
  imageOptions: {}
};
var BlockContent = SanityBlockContent;

(function (exports) {
var K=Object.create,f=Object.defineProperty,R=Object.getPrototypeOf,E=Object.prototype.hasOwnProperty,A=Object.getOwnPropertyNames,G=Object.getOwnPropertyDescriptor,I=Object.getOwnPropertySymbols,J=Object.prototype.propertyIsEnumerable;var S=Object.assign,O=e=>f(e,"__esModule",{value:!0});var m=(e,n)=>{var l={};for(var r in e)E.call(e,r)&&n.indexOf(r)<0&&(l[r]=e[r]);if(e!=null&&I)for(var r of I(e))n.indexOf(r)<0&&J.call(e,r)&&(l[r]=e[r]);return l};var L=(e,n)=>{for(var l in n)f(e,l,{get:n[l],enumerable:!0});},Q=(e,n,l)=>{if(n&&typeof n=="object"||typeof n=="function")for(let r of A(n))!E.call(e,r)&&r!=="default"&&f(e,r,{get:()=>n[r],enumerable:!(l=G(n,r))||l.enumerable});return e},P=e=>Q(O(f(e!=null?K(R(e)):{},"default",e&&e.__esModule&&"default"in e?{get:()=>e.default,enumerable:!0}:{value:e,enumerable:!0})),e);O(exports);L(exports,{blockContentToPlainText:()=>Z,default:()=>X});var w=P(React__default),t=P(propTypes.exports),s=P(BlockContent),z=s.default.defaultSerializers,q=y=>{var{content:e,className:n,serializers:l={},dataset:r,projectId:p}=y,T=m(y,["content","className","serializers","dataset","projectId"]);if(!e)throw new Error("No `content` provided to PortableText.");return w.default.createElement(s.default,S({blocks:e,className:n,serializers:V(l),renderContainerOnSingleChild:!0,dataset:r,projectId:p},T))},X=q;q.propTypes={content:t.default.array.isRequired,className:t.default.string,projectId:t.default.string,dataset:t.default.string,serializers:t.default.shape({link:t.default.elementType,strong:t.default.elementType,em:t.default.elementType,underline:t.default.elementType,del:t.default.elementType,code:t.default.elementType,ul:t.default.elementType,ol:t.default.elementType,li:t.default.elementType,h1:t.default.elementType,h2:t.default.elementType,h3:t.default.elementType,h4:t.default.elementType,h5:t.default.elementType,h6:t.default.elementType,blockquote:t.default.elementType,container:t.default.elementType,block:t.default.elementType,span:t.default.elementType,hardBreak:t.default.elementType,unknownType:t.default.elementType,unknownMark:t.default.elementType})};var V=e=>{let{link:n,strong:l,em:r,underline:p,del:T,code:y,ul:a,ol:B,li:u,h1:h,h2:k,h3:C,h4:N,h5:j,h6:g,blockquote:x,container:M="div",block:U=z.BlockSerializer,span:W=z.SpanSerializer,hardBreak:$=z.HardBreakSerializer,unknownType:D=z.DefaultUnknownTypeSerializer,unknownMark:F="span"}=e,b=m(e,["link","strong","em","underline","del","code","ul","ol","li","h1","h2","h3","h4","h5","h6","blockquote","container","block","span","hardBreak","unknownType","unknownMark"]),_={h1:h,h2:k,h3:C,h4:N,h5:j,h6:g,blockquote:x};return {container:M,block:U,span:W,hardBreak:$,unknownType:D,unknownMark:F,marks:Y(S({link:n,strong:l,em:r,underline:p,code:y,"strike-through":T},b)),list:o=>{let{type:i,children:c}=o,d=i==="bullet"?a:B;return d?d({children:c}):s.default.defaultSerializers.list(o)},listItem:o=>{let{children:i}=o;return u?u({children:i}):s.default.defaultSerializers.listItem(o)},types:S({block:o=>{let{node:{style:i},children:c}=o;return _[i]?_[i]({children:c}):b[i]?b[i]({children:c}):s.default.defaultSerializers.types.block(o)}},Object.entries(b).reduce((o,[i,c])=>{let d=({node:H})=>w.default.createElement(c,H);return d.displayName=`${v(i)}Wrapper`,o[i]=d,o},{}))}},Y=e=>Object.entries(e).reduce((n,[l,r])=>{if(r){let p=k=>{var{_type:T,_key:y,mark:a,markKey:B,children:u}=k,h=m(k,["_type","_key","mark","markKey","children"]);if(typeof a=="object"){let j=m(a,["_type","_key"]);Object.entries(j).forEach(([g,x])=>{h[g]=x;});}return w.default.createElement(r,h,u)};p.displayName=`${v(l)}Wrapper`,n[l]=p;}return n},{}),Z=(e=[])=>e.map(n=>n._type==="block"&&n.children?n.children.map(l=>l.text).join(""):"").join(`

`),v=e=>e.slice(0,1).toUpperCase()+e.slice(1);
}(dist));
var PortableText = getDefaultExportFromCjs(dist);

function PortableTextComponent(props) {
  var _props$fontFamily, _props$fontSize, _props$fontWeight, _props$color, _props$textAlign, _props$lineHeight, _props$textTransform, _props$textDecoration, _props$whiteSpace, _props$fontFamily2, _props$fontSize2, _props$color2, _props$textAlign2, _props$lineHeight2, _props$textTransform2, _props$textDecoration2, _props$whiteSpace2, _props$color3;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _normal = {
    fontFamily: (_props$fontFamily = props.fontFamily) !== null && _props$fontFamily !== void 0 ? _props$fontFamily : 'Museo-Sans',
    fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1.2em',
    fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : 300,
    color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    textAlign: (_props$textAlign = props.textAlign) !== null && _props$textAlign !== void 0 ? _props$textAlign : 'left',
    lineHeight: (_props$lineHeight = props.lineHeight) !== null && _props$lineHeight !== void 0 ? _props$lineHeight : 1.1,
    height: 'auto',
    position: 'relative',
    textTransform: (_props$textTransform = props.textTransform) !== null && _props$textTransform !== void 0 ? _props$textTransform : 'none',
    textDecoration: (_props$textDecoration = props.textDecoration) !== null && _props$textDecoration !== void 0 ? _props$textDecoration : 'none',
    whiteSpace: (_props$whiteSpace = props.whiteSpace) !== null && _props$whiteSpace !== void 0 ? _props$whiteSpace : 'normal'
  };
  var h3Style = {
    fontFamily: (_props$fontFamily2 = props.fontFamily) !== null && _props$fontFamily2 !== void 0 ? _props$fontFamily2 : 'Museo-Sans',
    fontSize: (_props$fontSize2 = props.fontSize) !== null && _props$fontSize2 !== void 0 ? _props$fontSize2 : '1.2em',
    fontWeight: 500,
    color: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
    textAlign: (_props$textAlign2 = props.textAlign) !== null && _props$textAlign2 !== void 0 ? _props$textAlign2 : 'left',
    lineHeight: (_props$lineHeight2 = props.lineHeight) !== null && _props$lineHeight2 !== void 0 ? _props$lineHeight2 : 1.1,
    height: 'auto',
    position: 'relative',
    textTransform: (_props$textTransform2 = props.textTransform) !== null && _props$textTransform2 !== void 0 ? _props$textTransform2 : 'none',
    textDecoration: (_props$textDecoration2 = props.textDecoration) !== null && _props$textDecoration2 !== void 0 ? _props$textDecoration2 : 'none',
    whiteSpace: (_props$whiteSpace2 = props.whiteSpace) !== null && _props$whiteSpace2 !== void 0 ? _props$whiteSpace2 : 'normal',
    paddingTop: 25
  };
  var strongStyle = {
    fontWeight: 700
  };
  var semistrongStyle = {
    fontWeight: 500
  };
  var linkStyle = {
    textDecoration: 'underline'
  };
  var subscriptStyle = {
    fontSize: '0.7em',
    color: (_props$color3 = props.color) !== null && _props$color3 !== void 0 ? _props$color3 : Colors.GREY,
    position: 'absolute',
    marginTop: 10
  };
  return React__default.createElement(PortableText, {
    content: props.content,
    className: "PortableText",
    serializers: {
      normal: function normal(props) {
        return React__default.createElement("p", _extends$d({
          style: _normal
        }, props));
      },
      h3: function h3(props) {
        return React__default.createElement("h3", _extends$d({
          style: h3Style
        }, props));
      },
      strong: function strong(props) {
        return React__default.createElement("span", _extends$d({
          style: strongStyle
        }, props));
      },
      semistrong: function semistrong(props) {
        return React__default.createElement("span", _extends$d({
          style: semistrongStyle
        }, props));
      },
      subscript: function subscript(props) {
        return React__default.createElement("span", {
          style: {
            paddingRight: 8
          }
        }, React__default.createElement("sub", _extends$d({
          style: subscriptStyle
        }, props)));
      },
      link: function link(props) {
        return React__default.createElement("a", _extends$d({
          style: linkStyle
        }, props));
      },
      hardBreak: function hardBreak(props) {
        return React__default.createElement("br", null);
      },
      payAttention: function payAttention(props) {
        return React__default.createElement("div", {
          style: {
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 15,
            paddingBottom: 15,
            backgroundColor: Colors.GRADIENT,
            border: "solid 2px ".concat(Colors.BLUE),
            borderRadius: 10,
            marginTop: 12
          }
        }, React__default.createElement("p", {
          style: {
            color: Colors.BLUE,
            fontSize: '1.2em',
            fontWeight: 500,
            lineHeight: 1.1,
            fontFamily: 'Museo-Sans'
          }
        }, "".concat(_('payAttention', {
          ns: 'ui'
        }), ":")), React__default.createElement("p", _extends$d({
          style: {
            color: Colors.BLUE,
            fontSize: '1.2em',
            fontWeight: 300,
            lineHeight: 1.3,
            fontFamily: 'Museo-Sans'
          }
        }, props)));
      },
      checkItem: function checkItem(props) {
        return React__default.createElement("div", {
          style: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            marginTop: 12
          }
        }, React__default.createElement("div", {
          style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            paddingTop: 12,
            paddingRight: 10
          }
        }, React__default.createElement(Icon, {
          name: "Check",
          height: 25,
          width: 25,
          color: Colors.GREEN,
          iconSet: "FA"
        })), React__default.createElement("p", _extends$d({
          style: {
            color: Colors.GREY,
            fontSize: '1.2em',
            fontWeight: 300,
            lineHeight: 1.3,
            fontFamily: 'Museo-Sans'
          }
        }, props)));
      }
    }
  });
}

function Text(props) {
  var _props$fontFamily, _props$fontSize, _props$fontWeight, _props$color, _props$textAlign, _props$lineHeight, _props$textTransform, _props$textDecoration, _props$whiteSpace;
  var _React$useState = React$4.useState(props.children),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      text = _React$useState2[0],
      setText = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      dotsAnimation = _React$useState4[0],
      setDotsAnimation = _React$useState4[1];
  React$4.useEffect(function () {
    var dots = '...';
    if (props.animate && text.slice(text.length - 3) === dots) {
      setDotsAnimation(true);
      setText(text.slice(text, -3));
    } else setText(props.children);
  }, [props.children]);
  return props.portableText ? React$4.createElement(PortableTextComponent, {
    content: props.children,
    fontFamily: props.fontFamily,
    fontSize: props.fontSize,
    fontWeight: props.fontWeight,
    color: props.color,
    textAlign: props.textAlign,
    lineHeight: props.lineHeight,
    textTransform: props.textTransform,
    textDecoration: props.textDecoration,
    whiteSpace: props.whiteSpace
  }) : React$4.createElement("p", {
    className: "TextComponent",
    style: {
      fontFamily: (_props$fontFamily = props.fontFamily) !== null && _props$fontFamily !== void 0 ? _props$fontFamily : 'Museo-Sans',
      fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1.2em',
      fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : 300,
      color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
      textAlign: (_props$textAlign = props.textAlign) !== null && _props$textAlign !== void 0 ? _props$textAlign : 'left',
      lineHeight: (_props$lineHeight = props.lineHeight) !== null && _props$lineHeight !== void 0 ? _props$lineHeight : 1.1,
      height: 'auto',
      position: 'relative',
      textTransform: (_props$textTransform = props.textTransform) !== null && _props$textTransform !== void 0 ? _props$textTransform : 'none',
      textDecoration: (_props$textDecoration = props.textDecoration) !== null && _props$textDecoration !== void 0 ? _props$textDecoration : 'none',
      whiteSpace: (_props$whiteSpace = props.whiteSpace) !== null && _props$whiteSpace !== void 0 ? _props$whiteSpace : 'normal'
    }
  }, text, props.animate && dotsAnimation && React$4.createElement("span", {
    className: "TextDots"
  }, React$4.createElement("span", null, "."), React$4.createElement("span", null, "."), React$4.createElement("span", null, ".")));
}

function TextInput(props) {
  var _props$backgroundColo;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      hasFeatures = _React$useState4[0],
      setFeatures = _React$useState4[1];
  var _React$useState5 = React$4.useState(false),
      _React$useState6 = _slicedToArray$4(_React$useState5, 2),
      passwordMask = _React$useState6[0],
      setPasswordMask = _React$useState6[1];
  var _React$useState7 = React$4.useState(false),
      _React$useState8 = _slicedToArray$4(_React$useState7, 2),
      hoverPasswordMask = _React$useState8[0],
      setHoverPasswordMask = _React$useState8[1];
  React$4.useEffect(function () {
    switch (props.type) {
      case 'password':
        setFeatures(true);
        break;
      default:
        setFeatures(false);
    }
    if (props.max) setFeatures(true);
  });
  var onKeyUp = function onKeyUp(event) {
    switch (event.key) {
      case 'Enter':
        if (props.onEnter) props.onEnter();
        break;
      case 'Tab':
        if (props.onTab) props.onTab();
        break;
      default:
        if (props.onKeyUp) props.onKeyUp();
    }
  };
  return React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: 'auto'
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto'
    }
  }, props.label && React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      position: 'relative',
      height: props.label || !props.required ? 20 : 0,
      display: 'inline-block'
    }
  }, props.label && props.label, !props.required && !props.disabled && React$4.createElement("span", {
    style: {
      fontSize: '0.8em',
      position: 'absolute',
      marginTop: 2,
      paddingLeft: 6,
      color: Colors.MEDIUM_GREY,
      whiteSpace: 'nowrap',
      width: 'auto'
    }
  }, "- ".concat(_('optional', {
    ns: 'ui'
  })))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: 'auto'
    }
  }, React$4.createElement("input", {
    className: props.disabled ? 'Disabled' : 'Hover Text',
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    },
    value: props.value,
    onChange: props.onChange,
    onKeyUp: onKeyUp,
    disabled: props.disabled,
    autoComplete: props.autocomplete,
    "aria-label": props.ariaLabel,
    "aria-required": props.required,
    type: props.type === 'password' ? passwordMask ? 'text' : 'password' : props.type,
    id: props.id,
    name: props.name,
    placeholder: props.placeholder,
    required: props.required,
    maxLength: props.max,
    style: {
      height: 50,
      width: '100%',
      backgroundColor: (_props$backgroundColo = props.backgroundColor) !== null && _props$backgroundColo !== void 0 ? _props$backgroundColo : Colors.WHITE,
      borderTopRightRadius: hasFeatures ? 0 : 5,
      borderTopLeftRadius: 5,
      borderBottomRightRadius: hasFeatures ? 0 : 5,
      borderBottomLeftRadius: 5,
      borderTop: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderLeft: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: hasFeatures ? 'solid 2px transparent' : props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderBottom: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      outline: 'none',
      fontSize: '1.25em',
      fontFamily: 'Museo-Sans',
      fontWeight: 300,
      color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY,
      padding: 10,
      marginTop: 5
    }
  }), props.max && React$4.createElement("div", {
    type: "button",
    className: "DisableSelection",
    style: {
      backgroundColor: Colors.WHITE,
      height: 50,
      width: 'auto',
      marginTop: 5,
      marginLeft: -2,
      paddingRight: 7,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      borderTop: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderBottom: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: props.error ? "solid 2px ".concat(Colors.RED) : props.type === 'password' || !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderLeft: 'solid 0px transparent',
      borderTopRightRadius: props.type === 'password' ? 0 : 5,
      borderBottomRightRadius: props.type === 'password' ? 0 : 5
    }
  }, React$4.createElement("div", {
    style: {
      backgroundColor: Colors.LIGHT_WHITE,
      padding: 5,
      borderRadius: 5
    }
  }, React$4.createElement(Text, {
    fontSize: "1.1em",
    fontWeight: 500,
    color: props.value && props.max - props.value.length < props.max / 100 * 20 + 1 ? Colors.RED : Colors.DARK_GREY
  }, props.value ? props.max - props.value.length : props.max))), props.type === 'password' && React$4.createElement("button", {
    type: "button",
    className: "Hover Text",
    onMouseEnter: function onMouseEnter() {
      setHoverPasswordMask(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHoverPasswordMask(false);
    },
    onClick: function onClick() {
      setPasswordMask(!passwordMask);
    },
    style: {
      backgroundColor: Colors.WHITE,
      height: 50,
      width: 47,
      marginTop: 5,
      marginLeft: -2,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      borderTop: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderBottom: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderLeft: 'solid 0px transparent',
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5
    }
  }, React$4.createElement(Icon, {
    name: passwordMask ? 'Eye' : 'EyeSlash',
    iconSet: "Feather",
    height: 23,
    width: 23,
    color: hoverPasswordMask || passwordMask ? Colors.GREY : Colors.MEDIUM_GREY
  }))), props.error && React$4.createElement("div", {
    style: {
      marginTop: 5
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.RED
  }, props.error))));
}

function RadioInput(props) {
  return React$4.createElement("div", {
    style: {
      height: 20,
      width: 20,
      marginRight: 10,
      border: "solid 2px ".concat(!props.disabled && props.selected ? Colors.PURPLE : Colors.MEDIUM_WHITE),
      borderRadius: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: props.disabled ? Colors.LIGHT_WHITE : 'transparent'
    }
  }, !props.disabled && props.selected && React$4.createElement("div", {
    style: {
      marginTop: 3
    }
  }, React$4.createElement(Icon, {
    name: "CheckCircle",
    height: 13,
    width: 13,
    color: Colors.PURPLE
  })));
}

function Checkbox(props) {
  return (
    React$4.createElement("div", {
      onClick: props.disabled ? null : props.onClick,
      role: "button",
      tabIndex: 0,
      className: "Hover",
      "aria-label": props.ariaLabel,
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        height: 26,
        backgroundColor: 'transparent',
        border: 'solid 0px transparent',
        fontSize: '1em'
      }
    }, React$4.createElement("div", {
      style: {
        height: 27,
        width: 27,
        marginRight: props.label ? 15 : 10,
        border: "solid 2px ".concat(!props.disabled && props.selected ? Colors.BLUE : Colors.MEDIUM_WHITE),
        borderRadius: 5,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: !props.disabled && props.selected ? Colors.BLUE : props.disabled ? Colors.LIGHT_WHITE : 'transparent',
        marginTop: -1
      }
    }, props.selected && React$4.createElement("div", {
      style: {
        marginTop: 3
      }
    }, React$4.createElement(Icon, {
      name: "Check",
      height: 13,
      width: 13,
      color: Colors.WHITE
    }))), props.label && React$4.createElement("div", {
      style: {
        paddingTop: 1
      }
    }, React$4.createElement(Text, {
      color: !props.disabled && props.selected ? Colors.BLUE : Colors.GREY
    }, props.label)))
  );
}

function Switch(props) {
  return React$4.createElement("button", {
    type: "button",
    className: "".concat(props.disabled || props.loading ? 'Disabled' : 'Hover', " DisableSelection"),
    onClick: props.disabled ? null : props.onClick,
    "aria-label": props.ariaLabel,
    style: {
      height: 30,
      width: 50,
      borderRadius: 20,
      backgroundColor: !props.disabled && props.value ? Colors.GREEN : props.disabled ? props.value ? "".concat(Colors.GREEN, "70") : Colors.WHITE : Colors.MEDIUM_WHITE,
      border: "solid 2px ".concat(!props.disabled && props.value ? Colors.GREEN : props.disabled ? props.value ? "".concat(Colors.GREEN, "70") : Colors.MEDIUM_WHITE : Colors.MEDIUM_WHITE),
      paddingTop: 2,
      paddingBottom: 2,
      paddingLeft: 2,
      paddingRight: 2,
      transition: 'all .2s linear',
      whiteSpace: 'nowrap'
    }
  }, React$4.createElement("div", {
    style: {
      height: 21,
      width: 21,
      backgroundColor: Colors.WHITE,
      borderRadius: '100%',
      border: "solid 2px ".concat(Colors.WHITE),
      boxShadow: "0px 0px 10px 1px ".concat(props.disabled ? "".concat(Colors.MEDIUM_GREY) : Colors.MEDIUM_GREY),
      transform: "translateX(".concat(props.value ? '22px' : '0px', ")"),
      transition: 'all .2s ease-in-out'
    }
  }));
}

function mergeClassNames() {
  return Array.prototype.slice.call(arguments).reduce(function (classList, arg) {
    return classList.concat(arg);
  }, []).filter(function (arg) {
    return typeof arg === 'string';
  }).join(' ');
}

var FUNC_ERROR_TEXT = 'Expected a function';
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;
var symbolTag = '[object Symbol]';
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var objectProto = Object.prototype;
var objectToString = objectProto.toString;
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}
function once(func) {
  return before(2, func);
}
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;
  return result === result ? (remainder ? result - remainder : result) : 0;
}
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}
var lodash_once = once;

function filterDuplicates(arr) {
  return arr.filter(function (el, index, self) {
    return self.indexOf(el) === index;
  });
}
function fixLowercaseProperties(arr) {
  return arr.map(function (el) {
    if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) {
      return el;
    }
    var splitEl = el.split('-');
    return "".concat(splitEl[0], "-").concat(splitEl[1].toUpperCase());
  });
}
function getUserLocalesInternal() {
  var languageList = [];
  if (typeof window !== 'undefined') {
    if (window.navigator.languages) {
      languageList = languageList.concat(window.navigator.languages);
    }
    if (window.navigator.language) {
      languageList.push(window.navigator.language);
    }
    if (window.navigator.userLanguage) {
      languageList.push(window.navigator.userLanguage);
    }
    if (window.navigator.browserLanguage) {
      languageList.push(window.navigator.browserLanguage);
    }
    if (window.navigator.systemLanguage) {
      languageList.push(window.navigator.systemLanguage);
    }
  }
  languageList.push('en-US');
  return fixLowercaseProperties(filterDuplicates(languageList));
}
var getUserLocales = lodash_once(getUserLocalesInternal);
function getUserLocaleInternal() {
  return getUserLocales()[0];
}
var getUserLocale = lodash_once(getUserLocaleInternal);

function makeGetEdgeOfNeighbor(getPeriod, getEdgeOfPeriod, defaultOffset) {
  return function makeGetEdgeOfNeighborInternal(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
    var previousPeriod = getPeriod(date) + offset;
    return getEdgeOfPeriod(previousPeriod);
  };
}
function makeGetEnd(getBeginOfNextPeriod) {
  return function makeGetEndInternal(date) {
    return new Date(getBeginOfNextPeriod(date).getTime() - 1);
  };
}
function makeGetRange(functions) {
  return function makeGetRangeInternal(date) {
    return functions.map(function (fn) {
      return fn(date);
    });
  };
}
function getYear(date) {
  if (date instanceof Date) {
    return date.getFullYear();
  }
  if (typeof date === 'number') {
    return date;
  }
  var year = parseInt(date, 10);
  if (typeof date === 'string' && !isNaN(year)) {
    return year;
  }
  throw new Error("Failed to get year from date: ".concat(date, "."));
}
function getMonth(date) {
  if (date instanceof Date) {
    return date.getMonth();
  }
  throw new Error("Failed to get month from date: ".concat(date, "."));
}
function getDate(date) {
  if (date instanceof Date) {
    return date.getDate();
  }
  throw new Error("Failed to get year from date: ".concat(date, "."));
}
function getCenturyStart(date) {
  var year = getYear(date);
  var centuryStartYear = year + (-year + 1) % 100;
  var centuryStartDate = new Date();
  centuryStartDate.setFullYear(centuryStartYear, 0, 1);
  centuryStartDate.setHours(0, 0, 0, 0);
  return centuryStartDate;
}
var getPreviousCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, -100);
var getNextCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, 100);
var getCenturyEnd = makeGetEnd(getNextCenturyStart);
var getPreviousCenturyEnd = makeGetEdgeOfNeighbor(getYear, getCenturyEnd, -100);
var getCenturyRange = makeGetRange([getCenturyStart, getCenturyEnd]);
function getDecadeStart(date) {
  var year = getYear(date);
  var decadeStartYear = year + (-year + 1) % 10;
  var decadeStartDate = new Date();
  decadeStartDate.setFullYear(decadeStartYear, 0, 1);
  decadeStartDate.setHours(0, 0, 0, 0);
  return decadeStartDate;
}
var getPreviousDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, -10);
var getNextDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, 10);
var getDecadeEnd = makeGetEnd(getNextDecadeStart);
var getPreviousDecadeEnd = makeGetEdgeOfNeighbor(getYear, getDecadeEnd, -10);
var getDecadeRange = makeGetRange([getDecadeStart, getDecadeEnd]);
function getYearStart(date) {
  var year = getYear(date);
  var yearStartDate = new Date();
  yearStartDate.setFullYear(year, 0, 1);
  yearStartDate.setHours(0, 0, 0, 0);
  return yearStartDate;
}
var getPreviousYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, -1);
var getNextYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, 1);
var getYearEnd = makeGetEnd(getNextYearStart);
var getPreviousYearEnd = makeGetEdgeOfNeighbor(getYear, getYearEnd, -1);
var getYearRange = makeGetRange([getYearStart, getYearEnd]);
function makeGetEdgeOfNeighborMonth(getEdgeOfPeriod, defaultOffset) {
  return function makeGetEdgeOfNeighborMonthInternal(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
    var year = getYear(date);
    var month = getMonth(date) + offset;
    var previousPeriod = new Date();
    previousPeriod.setFullYear(year, month, 1);
    previousPeriod.setHours(0, 0, 0, 0);
    return getEdgeOfPeriod(previousPeriod);
  };
}
function getMonthStart(date) {
  var year = getYear(date);
  var month = getMonth(date);
  var monthStartDate = new Date();
  monthStartDate.setFullYear(year, month, 1);
  monthStartDate.setHours(0, 0, 0, 0);
  return monthStartDate;
}
var getPreviousMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, -1);
var getNextMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, 1);
var getMonthEnd = makeGetEnd(getNextMonthStart);
var getPreviousMonthEnd = makeGetEdgeOfNeighborMonth(getMonthEnd, -1);
var getMonthRange = makeGetRange([getMonthStart, getMonthEnd]);
function makeGetEdgeOfNeighborDay(getEdgeOfPeriod, defaultOffset) {
  return function makeGetEdgeOfNeighborDayInternal(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
    var year = getYear(date);
    var month = getMonth(date);
    var day = getDate(date) + offset;
    var previousPeriod = new Date();
    previousPeriod.setFullYear(year, month, day);
    previousPeriod.setHours(0, 0, 0, 0);
    return getEdgeOfPeriod(previousPeriod);
  };
}
function getDayStart(date) {
  var year = getYear(date);
  var month = getMonth(date);
  var day = getDate(date);
  var dayStartDate = new Date();
  dayStartDate.setFullYear(year, month, day);
  dayStartDate.setHours(0, 0, 0, 0);
  return dayStartDate;
}
var getNextDayStart = makeGetEdgeOfNeighborDay(getDayStart, 1);
var getDayEnd = makeGetEnd(getNextDayStart);
var getDayRange = makeGetRange([getDayStart, getDayEnd]);
function getDaysInMonth(date) {
  return getDate(getMonthEnd(date));
}

var _CALENDAR_TYPE_LOCALE;
function _toConsumableArray$4(arr) { return _arrayWithoutHoles$4(arr) || _iterableToArray$4(arr) || _unsupportedIterableToArray$4(arr) || _nonIterableSpread$4(); }
function _nonIterableSpread$4() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }
function _iterableToArray$4(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$4(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$4(arr); }
function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _defineProperty$f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var CALENDAR_TYPES = {
  ARABIC: 'Arabic',
  HEBREW: 'Hebrew',
  ISO_8601: 'ISO 8601',
  US: 'US'
};
var CALENDAR_TYPE_LOCALES = (_CALENDAR_TYPE_LOCALE = {}, _defineProperty$f(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.US, ['en-CA', 'en-US', 'es-AR', 'es-BO', 'es-CL', 'es-CO', 'es-CR', 'es-DO', 'es-EC', 'es-GT', 'es-HN', 'es-MX', 'es-NI', 'es-PA', 'es-PE', 'es-PR', 'es-SV', 'es-VE', 'pt-BR']), _defineProperty$f(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.ARABIC, [
'ar', 'ar-AE', 'ar-BH', 'ar-DZ', 'ar-EG', 'ar-IQ', 'ar-JO', 'ar-KW', 'ar-LY', 'ar-OM', 'ar-QA', 'ar-SA', 'ar-SD', 'ar-SY', 'ar-YE', 'dv', 'dv-MV', 'ps', 'ps-AR']), _defineProperty$f(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.HEBREW, ['he', 'he-IL']), _CALENDAR_TYPE_LOCALE);
var WEEKDAYS = _toConsumableArray$4(Array(7)).map(function (el, index) {
  return index;
});

var formatterCache = new Map();
function getFormatter(options) {
  return function (locale, date) {
    var localeWithDefault = locale || getUserLocale();
    if (!formatterCache.has(localeWithDefault)) {
      formatterCache.set(localeWithDefault, new Map());
    }
    var formatterCacheLocale = formatterCache.get(localeWithDefault);
    if (!formatterCacheLocale.has(options)) {
      formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault, options).format);
    }
    return formatterCacheLocale.get(options)(date);
  };
}
function toSafeHour(date) {
  var safeDate = new Date(date);
  return new Date(safeDate.setHours(12));
}
function getSafeFormatter(options) {
  return function (locale, date) {
    return getFormatter(options)(locale, toSafeHour(date));
  };
}
var formatDayOptions = {
  day: 'numeric'
};
var formatLongDateOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric'
};
var formatMonthOptions = {
  month: 'long'
};
var formatMonthYearOptions = {
  month: 'long',
  year: 'numeric'
};
var formatShortWeekdayOptions = {
  weekday: 'short'
};
var formatWeekdayOptions = {
  weekday: 'long'
};
var formatYearOptions = {
  year: 'numeric'
};
var formatDay = getSafeFormatter(formatDayOptions);
var formatLongDate = getSafeFormatter(formatLongDateOptions);
var formatMonth = getSafeFormatter(formatMonthOptions);
var formatMonthYear = getSafeFormatter(formatMonthYearOptions);
var formatShortWeekday = getSafeFormatter(formatShortWeekdayOptions);
var formatWeekday = getSafeFormatter(formatWeekdayOptions);
var formatYear = getSafeFormatter(formatYearOptions);

var SUNDAY = WEEKDAYS[0];
var FRIDAY = WEEKDAYS[5];
var SATURDAY = WEEKDAYS[6];
function getDayOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var weekday = date.getDay();
  switch (calendarType) {
    case CALENDAR_TYPES.ISO_8601:
      return (weekday + 6) % 7;
    case CALENDAR_TYPES.ARABIC:
      return (weekday + 1) % 7;
    case CALENDAR_TYPES.HEBREW:
    case CALENDAR_TYPES.US:
      return weekday;
    default:
      throw new Error('Unsupported calendar type.');
  }
}
function getBeginOfCenturyYear(date) {
  var beginOfCentury = getCenturyStart(date);
  return getYear(beginOfCentury);
}
function getBeginOfDecadeYear(date) {
  var beginOfDecade = getDecadeStart(date);
  return getYear(beginOfDecade);
}
function getBeginOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var year = getYear(date);
  var monthIndex = getMonth(date);
  var day = date.getDate() - getDayOfWeek(date, calendarType);
  return new Date(year, monthIndex, day);
}
function getWeekNumber(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var calendarTypeForWeekNumber = calendarType === CALENDAR_TYPES.US ? CALENDAR_TYPES.US : CALENDAR_TYPES.ISO_8601;
  var beginOfWeek = getBeginOfWeek(date, calendarType);
  var year = getYear(date) + 1;
  var dayInWeekOne;
  var beginOfFirstWeek;
  do {
    dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === CALENDAR_TYPES.ISO_8601 ? 4 : 1);
    beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarType);
    year -= 1;
  } while (date < beginOfFirstWeek);
  return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
}
function getBegin(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyStart(date);
    case 'decade':
      return getDecadeStart(date);
    case 'year':
      return getYearStart(date);
    case 'month':
      return getMonthStart(date);
    case 'day':
      return getDayStart(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getBeginPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getPreviousCenturyStart(date);
    case 'decade':
      return getPreviousDecadeStart(date);
    case 'year':
      return getPreviousYearStart(date);
    case 'month':
      return getPreviousMonthStart(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getBeginNext(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getNextCenturyStart(date);
    case 'decade':
      return getNextDecadeStart(date);
    case 'year':
      return getNextYearStart(date);
    case 'month':
      return getNextMonthStart(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
var getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getPreviousDecadeStart(date, -100);
    case 'year':
      return getPreviousYearStart(date, -10);
    case 'month':
      return getPreviousMonthStart(date, -12);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
var getBeginNext2 = function getBeginNext2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getNextDecadeStart(date, 100);
    case 'year':
      return getNextYearStart(date, 10);
    case 'month':
      return getNextMonthStart(date, 12);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
function getEnd(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyEnd(date);
    case 'decade':
      return getDecadeEnd(date);
    case 'year':
      return getYearEnd(date);
    case 'month':
      return getMonthEnd(date);
    case 'day':
      return getDayEnd(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getEndPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getPreviousCenturyEnd(date);
    case 'decade':
      return getPreviousDecadeEnd(date);
    case 'year':
      return getPreviousYearEnd(date);
    case 'month':
      return getPreviousMonthEnd(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
var getEndPrevious2 = function getEndPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getPreviousDecadeEnd(date, -100);
    case 'year':
      return getPreviousYearEnd(date, -10);
    case 'month':
      return getPreviousMonthEnd(date, -12);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
function getRange(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyRange(date);
    case 'decade':
      return getDecadeRange(date);
    case 'year':
      return getYearRange(date);
    case 'month':
      return getMonthRange(date);
    case 'day':
      return getDayRange(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getValueRange(rangeType, date1, date2) {
  var rawNextValue = [date1, date2].sort(function (a, b) {
    return a - b;
  });
  return [getBegin(rangeType, rawNextValue[0]), getEnd(rangeType, rawNextValue[1])];
}
function toYearLabel(locale) {
  var formatYear$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : formatYear;
  var dates = arguments.length > 2 ? arguments[2] : undefined;
  return dates.map(function (date) {
    return formatYear$1(locale, date);
  }).join(' – ');
}
function getCenturyLabel(locale, formatYear, date) {
  return toYearLabel(locale, formatYear, getCenturyRange(date));
}
function getDecadeLabel(locale, formatYear, date) {
  return toYearLabel(locale, formatYear, getDecadeRange(date));
}
function isWeekend(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var weekday = date.getDay();
  switch (calendarType) {
    case CALENDAR_TYPES.ARABIC:
    case CALENDAR_TYPES.HEBREW:
      return weekday === FRIDAY || weekday === SATURDAY;
    case CALENDAR_TYPES.ISO_8601:
    case CALENDAR_TYPES.US:
      return weekday === SATURDAY || weekday === SUNDAY;
    default:
      throw new Error('Unsupported calendar type.');
  }
}

function _typeof$2(obj) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$2(obj); }
var calendarTypes = Object.values(CALENDAR_TYPES);
var allViews$1 = ['century', 'decade', 'year', 'month'];
var isCalendarType = PropTypes$1.oneOf(calendarTypes);
var isClassName = PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(PropTypes$1.string)]);
var isMinDate = function isMinDate(props, propName, componentName) {
  var minDate = props[propName];
  if (!minDate) {
    return null;
  }
  if (!(minDate instanceof Date)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$2(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
  }
  var maxDate = props.maxDate;
  if (maxDate && minDate > maxDate) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$2(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
  }
  return null;
};
var isMaxDate = function isMaxDate(props, propName, componentName) {
  var maxDate = props[propName];
  if (!maxDate) {
    return null;
  }
  if (!(maxDate instanceof Date)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$2(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
  }
  var minDate = props.minDate;
  if (minDate && maxDate < minDate) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$2(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
  }
  return null;
};
var isRef = PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.shape({
  current: PropTypes$1.any
})]);
var isValue = PropTypes$1.oneOfType([PropTypes$1.instanceOf(Date), PropTypes$1.arrayOf(PropTypes$1.instanceOf(Date))]);
var isViews = PropTypes$1.arrayOf(PropTypes$1.oneOf(allViews$1));
var isView = function isView(props, propName, componentName) {
  var view = props[propName];
  var views = props.views;
  var allowedViews = views || allViews$1;
  if (view !== undefined && allowedViews.indexOf(view) === -1) {
    return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function (a) {
      return "\"".concat(a, "\"");
    }).join(', '), "]."));
  }
  return null;
};
isView.isRequired = function (props, propName, componentName) {
  var view = props[propName];
  if (!view) {
    return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
  }
  return isView(props, propName, componentName);
};
var tileGroupProps = {
  activeStartDate: PropTypes$1.instanceOf(Date).isRequired,
  hover: PropTypes$1.instanceOf(Date),
  locale: PropTypes$1.string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: PropTypes$1.func,
  onMouseOver: PropTypes$1.func,
  tileClassName: PropTypes$1.oneOfType([PropTypes$1.func, isClassName]),
  tileContent: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.node]),
  value: isValue,
  valueType: PropTypes$1.string
};
var tileProps = {
  activeStartDate: PropTypes$1.instanceOf(Date).isRequired,
  classes: PropTypes$1.arrayOf(PropTypes$1.string).isRequired,
  date: PropTypes$1.instanceOf(Date).isRequired,
  locale: PropTypes$1.string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: PropTypes$1.func,
  onMouseOver: PropTypes$1.func,
  style: PropTypes$1.objectOf(PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number])),
  tileClassName: PropTypes$1.oneOfType([PropTypes$1.func, isClassName]),
  tileContent: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.node]),
  tileDisabled: PropTypes$1.func
};

var className$6 = 'react-calendar__navigation';
function Navigation(_ref) {
  var activeStartDate = _ref.activeStartDate,
      drillUp = _ref.drillUp,
      _ref$formatMonthYear = _ref.formatMonthYear,
      formatMonthYear$1 = _ref$formatMonthYear === void 0 ? formatMonthYear : _ref$formatMonthYear,
      _ref$formatYear = _ref.formatYear,
      formatYear$1 = _ref$formatYear === void 0 ? formatYear : _ref$formatYear,
      locale = _ref.locale,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      _ref$navigationAriaLa = _ref.navigationAriaLabel,
      navigationAriaLabel = _ref$navigationAriaLa === void 0 ? '' : _ref$navigationAriaLa,
      navigationAriaLive = _ref.navigationAriaLive,
      navigationLabel = _ref.navigationLabel,
      _ref$next2AriaLabel = _ref.next2AriaLabel,
      next2AriaLabel = _ref$next2AriaLabel === void 0 ? '' : _ref$next2AriaLabel,
      _ref$next2Label = _ref.next2Label,
      next2Label = _ref$next2Label === void 0 ? '»' : _ref$next2Label,
      _ref$nextAriaLabel = _ref.nextAriaLabel,
      nextAriaLabel = _ref$nextAriaLabel === void 0 ? '' : _ref$nextAriaLabel,
      _ref$nextLabel = _ref.nextLabel,
      nextLabel = _ref$nextLabel === void 0 ? '›' : _ref$nextLabel,
      _ref$prev2AriaLabel = _ref.prev2AriaLabel,
      prev2AriaLabel = _ref$prev2AriaLabel === void 0 ? '' : _ref$prev2AriaLabel,
      _ref$prev2Label = _ref.prev2Label,
      prev2Label = _ref$prev2Label === void 0 ? '«' : _ref$prev2Label,
      _ref$prevAriaLabel = _ref.prevAriaLabel,
      prevAriaLabel = _ref$prevAriaLabel === void 0 ? '' : _ref$prevAriaLabel,
      _ref$prevLabel = _ref.prevLabel,
      prevLabel = _ref$prevLabel === void 0 ? '‹' : _ref$prevLabel,
      setActiveStartDate = _ref.setActiveStartDate,
      showDoubleView = _ref.showDoubleView,
      view = _ref.view,
      views = _ref.views;
  var drillUpAvailable = views.indexOf(view) > 0;
  var shouldShowPrevNext2Buttons = view !== 'century';
  var previousActiveStartDate = getBeginPrevious(view, activeStartDate);
  var previousActiveStartDate2 = shouldShowPrevNext2Buttons && getBeginPrevious2(view, activeStartDate);
  var nextActiveStartDate = getBeginNext(view, activeStartDate);
  var nextActiveStartDate2 = shouldShowPrevNext2Buttons && getBeginNext2(view, activeStartDate);
  var prevButtonDisabled = function () {
    if (previousActiveStartDate.getFullYear() < 0) {
      return true;
    }
    var previousActiveEndDate = getEndPrevious(view, activeStartDate);
    return minDate && minDate >= previousActiveEndDate;
  }();
  var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function () {
    if (previousActiveStartDate2.getFullYear() < 0) {
      return true;
    }
    var previousActiveEndDate = getEndPrevious2(view, activeStartDate);
    return minDate && minDate >= previousActiveEndDate;
  }();
  var nextButtonDisabled = maxDate && maxDate < nextActiveStartDate;
  var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate < nextActiveStartDate2;
  function onClickPrevious() {
    setActiveStartDate(previousActiveStartDate, 'prev');
  }
  function onClickPrevious2() {
    setActiveStartDate(previousActiveStartDate2, 'prev2');
  }
  function onClickNext() {
    setActiveStartDate(nextActiveStartDate, 'next');
  }
  function onClickNext2() {
    setActiveStartDate(nextActiveStartDate2, 'next2');
  }
  function renderLabel(date) {
    var label = function () {
      switch (view) {
        case 'century':
          return getCenturyLabel(locale, formatYear$1, date);
        case 'decade':
          return getDecadeLabel(locale, formatYear$1, date);
        case 'year':
          return formatYear$1(locale, date);
        case 'month':
          return formatMonthYear$1(locale, date);
        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }();
    return navigationLabel ? navigationLabel({
      date: date,
      label: label,
      locale: locale || getUserLocale(),
      view: view
    }) : label;
  }
  function renderButton() {
    var labelClassName = "".concat(className$6, "__label");
    return React__default.createElement("button", {
      "aria-label": navigationAriaLabel,
      "aria-live": navigationAriaLive,
      className: labelClassName,
      disabled: !drillUpAvailable,
      onClick: drillUp,
      style: {
        flexGrow: 1
      },
      type: "button"
    }, React__default.createElement("span", {
      className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--from")
    }, renderLabel(activeStartDate)), showDoubleView && React__default.createElement(React__default.Fragment, null, React__default.createElement("span", {
      className: "".concat(labelClassName, "__divider")
    }, " \u2013 "), React__default.createElement("span", {
      className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--to")
    }, renderLabel(nextActiveStartDate))));
  }
  return React__default.createElement("div", {
    className: className$6
  }, prev2Label !== null && shouldShowPrevNext2Buttons && React__default.createElement("button", {
    "aria-label": prev2AriaLabel,
    className: "".concat(className$6, "__arrow ").concat(className$6, "__prev2-button"),
    disabled: prev2ButtonDisabled,
    onClick: onClickPrevious2,
    type: "button"
  }, prev2Label), prevLabel !== null && React__default.createElement("button", {
    "aria-label": prevAriaLabel,
    className: "".concat(className$6, "__arrow ").concat(className$6, "__prev-button"),
    disabled: prevButtonDisabled,
    onClick: onClickPrevious,
    type: "button"
  }, prevLabel), renderButton(), nextLabel !== null && React__default.createElement("button", {
    "aria-label": nextAriaLabel,
    className: "".concat(className$6, "__arrow ").concat(className$6, "__next-button"),
    disabled: nextButtonDisabled,
    onClick: onClickNext,
    type: "button"
  }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && React__default.createElement("button", {
    "aria-label": next2AriaLabel,
    className: "".concat(className$6, "__arrow ").concat(className$6, "__next2-button"),
    disabled: next2ButtonDisabled,
    onClick: onClickNext2,
    type: "button"
  }, next2Label));
}
Navigation.propTypes = {
  activeStartDate: PropTypes$1.instanceOf(Date).isRequired,
  drillUp: PropTypes$1.func.isRequired,
  formatMonthYear: PropTypes$1.func,
  formatYear: PropTypes$1.func,
  locale: PropTypes$1.string,
  maxDate: PropTypes$1.instanceOf(Date),
  minDate: PropTypes$1.instanceOf(Date),
  navigationAriaLabel: PropTypes$1.string,
  navigationAriaLive: PropTypes$1.string,
  navigationLabel: PropTypes$1.func,
  next2AriaLabel: PropTypes$1.string,
  next2Label: PropTypes$1.node,
  nextAriaLabel: PropTypes$1.string,
  nextLabel: PropTypes$1.node,
  prev2AriaLabel: PropTypes$1.string,
  prev2Label: PropTypes$1.node,
  prevAriaLabel: PropTypes$1.string,
  prevLabel: PropTypes$1.node,
  setActiveStartDate: PropTypes$1.func.isRequired,
  showDoubleView: PropTypes$1.bool,
  view: isView.isRequired,
  views: isViews.isRequired
};

var _excluded$a = ["children", "className", "direction", "count", "offset", "style", "wrap"];
function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty$e(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$a(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$a(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$a(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function toPercent(num) {
  return "".concat(num, "%");
}
function Flex(_ref) {
  var children = _ref.children,
      className = _ref.className,
      direction = _ref.direction,
      count = _ref.count,
      offset = _ref.offset,
      style = _ref.style,
      wrap = _ref.wrap,
      otherProps = _objectWithoutProperties$a(_ref, _excluded$a);
  return React__default.createElement("div", _extends$c({
    className: className,
    style: _objectSpread$e({
      display: 'flex',
      flexDirection: direction,
      flexWrap: wrap ? 'wrap' : 'no-wrap'
    }, style)
  }, otherProps), React__default.Children.map(children, function (child, index) {
    return React__default.cloneElement(child, _objectSpread$e(_objectSpread$e({}, child.props), {}, {
      style: {
        flexBasis: toPercent(100 / count),
        flexShrink: 0,
        flexGrow: 0,
        overflow: 'hidden',
        marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
      }
    }));
  }));
}
Flex.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  count: PropTypes$1.number.isRequired,
  direction: PropTypes$1.string,
  offset: PropTypes$1.number,
  style: PropTypes$1.objectOf(PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number])),
  wrap: PropTypes$1.bool
};

function _toConsumableArray$3(arr) { return _arrayWithoutHoles$3(arr) || _iterableToArray$3(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread$3(); }
function _nonIterableSpread$3() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }
function _iterableToArray$3(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$3(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$3(arr); }
function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function between(value, min, max) {
  if (min && min > value) {
    return min;
  }
  if (max && max < value) {
    return max;
  }
  return value;
}
function isValueWithinRange(value, range) {
  return range[0] <= value && range[1] >= value;
}
function isRangeWithinRange(greaterRange, smallerRange) {
  return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
}
function doRangesOverlap(range1, range2) {
  return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
}
function getRangeClassNames(valueRange, dateRange, baseClassName) {
  var isRange = doRangesOverlap(dateRange, valueRange);
  var classes = [];
  if (isRange) {
    classes.push(baseClassName);
    var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
    var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);
    if (isRangeStart) {
      classes.push("".concat(baseClassName, "Start"));
    }
    if (isRangeEnd) {
      classes.push("".concat(baseClassName, "End"));
    }
    if (isRangeStart && isRangeEnd) {
      classes.push("".concat(baseClassName, "BothEnds"));
    }
  }
  return classes;
}
function getTileClasses() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      value = _ref.value,
      valueType = _ref.valueType,
      date = _ref.date,
      dateType = _ref.dateType,
      hover = _ref.hover;
  var className = 'react-calendar__tile';
  var classes = [className];
  if (!date) {
    return classes;
  }
  if (!Array.isArray(date) && !dateType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }
  var now = new Date();
  var dateRange = Array.isArray(date) ? date : getRange(dateType, date);
  if (isValueWithinRange(now, dateRange)) {
    classes.push("".concat(className, "--now"));
  }
  if (!value) {
    return classes;
  }
  if (!Array.isArray(value) && !valueType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }
  var valueRange = Array.isArray(value) ? value : getRange(valueType, value);
  if (isRangeWithinRange(valueRange, dateRange)) {
    classes.push("".concat(className, "--active"));
  } else if (doRangesOverlap(valueRange, dateRange)) {
    classes.push("".concat(className, "--hasActive"));
  }
  var valueRangeClassNames = getRangeClassNames(valueRange, dateRange, "".concat(className, "--range"));
  classes.push.apply(classes, _toConsumableArray$3(valueRangeClassNames));
  var valueArray = [].concat(value);
  if (hover && valueArray.length === 1) {
    var hoverRange = hover > valueRange[0] ? [valueRange[0], hover] : [hover, valueRange[0]];
    var hoverRangeClassNames = getRangeClassNames(hoverRange, dateRange, "".concat(className, "--hover"));
    classes.push.apply(classes, _toConsumableArray$3(hoverRangeClassNames));
  }
  return classes;
}

var _excluded$9 = ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"];
function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty$d(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
function _objectWithoutProperties$9(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$9(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$9(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function TileGroup(_ref) {
  var className = _ref.className,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 3 : _ref$count,
      dateTransform = _ref.dateTransform,
      dateType = _ref.dateType,
      end = _ref.end,
      hover = _ref.hover,
      offset = _ref.offset,
      start = _ref.start,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      Tile = _ref.tile,
      value = _ref.value,
      valueType = _ref.valueType,
      tileProps = _objectWithoutProperties$9(_ref, _excluded$9);
  var tiles = [];
  for (var point = start; point <= end; point += step) {
    var date = dateTransform(point);
    tiles.push( React__default.createElement(Tile, _extends$b({
      key: date.getTime(),
      classes: getTileClasses({
        value: value,
        valueType: valueType,
        date: date,
        dateType: dateType,
        hover: hover
      }),
      date: date,
      point: point
    }, tileProps)));
  }
  return React__default.createElement(Flex, {
    className: className,
    count: count,
    offset: offset,
    wrap: true
  }, tiles);
}
TileGroup.propTypes = _objectSpread$d(_objectSpread$d({}, tileGroupProps), {}, {
  activeStartDate: PropTypes$1.instanceOf(Date),
  count: PropTypes$1.number,
  dateTransform: PropTypes$1.func.isRequired,
  dateType: PropTypes$1.string,
  offset: PropTypes$1.number,
  step: PropTypes$1.number,
  tile: PropTypes$1.func.isRequired
});

function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }
function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty$c(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$1(subClass, superClass); }
function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }
function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _possibleConstructorReturn$1(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$1(self); }
function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }
function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function datesAreDifferent(date1, date2) {
  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
}
function getValue$1(nextProps, prop) {
  var activeStartDate = nextProps.activeStartDate,
      date = nextProps.date,
      view = nextProps.view;
  return typeof prop === 'function' ? prop({
    activeStartDate: activeStartDate,
    date: date,
    view: view
  }) : prop;
}
var Tile = function (_Component) {
  _inherits$1(Tile, _Component);
  var _super = _createSuper$1(Tile);
  function Tile() {
    var _this;
    _classCallCheck$1(this, Tile);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$c(_assertThisInitialized$1(_this), "state", {});
    return _this;
  }
  _createClass$1(Tile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeStartDate = _this$props.activeStartDate,
          children = _this$props.children,
          classes = _this$props.classes,
          date = _this$props.date,
          formatAbbr = _this$props.formatAbbr,
          locale = _this$props.locale,
          maxDate = _this$props.maxDate,
          maxDateTransform = _this$props.maxDateTransform,
          minDate = _this$props.minDate,
          minDateTransform = _this$props.minDateTransform,
          onClick = _this$props.onClick,
          onMouseOver = _this$props.onMouseOver,
          style = _this$props.style,
          tileDisabled = _this$props.tileDisabled,
          view = _this$props.view;
      var _this$state = this.state,
          tileClassName = _this$state.tileClassName,
          tileContent = _this$state.tileContent;
      return React__default.createElement("button", {
        className: mergeClassNames(classes, tileClassName),
        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
          activeStartDate: activeStartDate,
          date: date,
          view: view
        }),
        onClick: onClick && function (event) {
          return onClick(date, event);
        },
        onFocus: onMouseOver && function () {
          return onMouseOver(date);
        },
        onMouseOver: onMouseOver && function () {
          return onMouseOver(date);
        },
        style: style,
        type: "button"
      }, formatAbbr ? React__default.createElement("abbr", {
        "aria-label": formatAbbr(locale, date)
      }, children) : children, tileContent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var activeStartDate = nextProps.activeStartDate,
          tileClassName = nextProps.tileClassName,
          tileContent = nextProps.tileContent;
      var nextState = {};
      if (tileClassName !== prevState.tileClassNameProps || datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
        nextState.tileClassName = getValue$1(nextProps, tileClassName);
        nextState.tileClassNameProps = tileClassName;
      }
      if (tileContent !== prevState.tileContentProps || datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
        nextState.tileContent = getValue$1(nextProps, tileContent);
        nextState.tileContentProps = tileContent;
      }
      nextState.activeStartDateProps = activeStartDate;
      return nextState;
    }
  }]);
  return Tile;
}(Component);
Tile.propTypes = _objectSpread$c(_objectSpread$c({}, tileProps), {}, {
  children: PropTypes$1.node.isRequired,
  formatAbbr: PropTypes$1.func,
  maxDateTransform: PropTypes$1.func.isRequired,
  minDateTransform: PropTypes$1.func.isRequired
});

var _excluded$8 = ["classes", "formatYear"];
function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty$b(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
function _objectWithoutProperties$8(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$8(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$8(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var className$5 = 'react-calendar__century-view__decades__decade';
function Decade(_ref) {
  var classes = _ref.classes,
      _ref$formatYear = _ref.formatYear,
      formatYear$1 = _ref$formatYear === void 0 ? formatYear : _ref$formatYear,
      otherProps = _objectWithoutProperties$8(_ref, _excluded$8);
  var date = otherProps.date,
      locale = otherProps.locale;
  return React__default.createElement(Tile, _extends$a({}, otherProps, {
    classes: [].concat(classes, className$5),
    maxDateTransform: getDecadeEnd,
    minDateTransform: getDecadeStart,
    view: "century"
  }), getDecadeLabel(locale, formatYear$1, date));
}
Decade.propTypes = _objectSpread$b(_objectSpread$b({}, tileProps), {}, {
  formatYear: PropTypes$1.func
});

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty$a(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
function Decades(props) {
  var activeStartDate = props.activeStartDate;
  var start = getBeginOfCenturyYear(activeStartDate);
  var end = start + 99;
  return React__default.createElement(TileGroup, _extends$9({}, props, {
    className: "react-calendar__century-view__decades",
    dateTransform: getDecadeStart,
    dateType: "decade",
    end: end,
    start: start,
    step: 10,
    tile: Decade
  }));
}
Decades.propTypes = _objectSpread$a({}, tileGroupProps);

function CenturyView(props) {
  function renderDecades() {
    return React__default.createElement(Decades, props);
  }
  return React__default.createElement("div", {
    className: "react-calendar__century-view"
  }, renderDecades());
}

var _excluded$7 = ["classes", "formatYear"];
function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty$9(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
function _objectWithoutProperties$7(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$7(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$7(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var className$4 = 'react-calendar__decade-view__years__year';
function Year(_ref) {
  var classes = _ref.classes,
      _ref$formatYear = _ref.formatYear,
      formatYear$1 = _ref$formatYear === void 0 ? formatYear : _ref$formatYear,
      otherProps = _objectWithoutProperties$7(_ref, _excluded$7);
  var date = otherProps.date,
      locale = otherProps.locale;
  return React__default.createElement(Tile, _extends$8({}, otherProps, {
    classes: [].concat(classes, className$4),
    maxDateTransform: getYearEnd,
    minDateTransform: getYearStart,
    view: "decade"
  }), formatYear$1(locale, date));
}
Year.propTypes = _objectSpread$9(_objectSpread$9({}, tileProps), {}, {
  formatYear: PropTypes$1.func
});

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty$8(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
function Years(props) {
  var activeStartDate = props.activeStartDate;
  var start = getBeginOfDecadeYear(activeStartDate);
  var end = start + 9;
  return React__default.createElement(TileGroup, _extends$7({}, props, {
    className: "react-calendar__decade-view__years",
    dateTransform: function dateTransform(year) {
      var date = new Date();
      date.setFullYear(year, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "year",
    end: end,
    start: start,
    tile: Year
  }));
}
Years.propTypes = _objectSpread$8({}, tileGroupProps);

function DecadeView(props) {
  function renderYears() {
    return React__default.createElement(Years, props);
  }
  return React__default.createElement("div", {
    className: "react-calendar__decade-view"
  }, renderYears());
}

var _excluded$6 = ["classes", "formatMonth", "formatMonthYear"];
function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty$7(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$6(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$6(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var className$3 = 'react-calendar__year-view__months__month';
function Month(_ref) {
  var classes = _ref.classes,
      _ref$formatMonth = _ref.formatMonth,
      formatMonth$1 = _ref$formatMonth === void 0 ? formatMonth : _ref$formatMonth,
      _ref$formatMonthYear = _ref.formatMonthYear,
      formatMonthYear$1 = _ref$formatMonthYear === void 0 ? formatMonthYear : _ref$formatMonthYear,
      otherProps = _objectWithoutProperties$6(_ref, _excluded$6);
  var date = otherProps.date,
      locale = otherProps.locale;
  return React__default.createElement(Tile, _extends$6({}, otherProps, {
    classes: [].concat(classes, className$3),
    formatAbbr: formatMonthYear$1,
    maxDateTransform: getMonthEnd,
    minDateTransform: getMonthStart,
    view: "year"
  }), formatMonth$1(locale, date));
}
Month.propTypes = _objectSpread$7(_objectSpread$7({}, tileProps), {}, {
  formatMonth: PropTypes$1.func,
  formatMonthYear: PropTypes$1.func
});

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty$6(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
function Months(props) {
  var activeStartDate = props.activeStartDate;
  var start = 0;
  var end = 11;
  var year = getYear(activeStartDate);
  return React__default.createElement(TileGroup, _extends$5({}, props, {
    className: "react-calendar__year-view__months",
    dateTransform: function dateTransform(monthIndex) {
      var date = new Date();
      date.setFullYear(year, monthIndex, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "month",
    end: end,
    start: start,
    tile: Month
  }));
}
Months.propTypes = _objectSpread$6(_objectSpread$6({}, tileGroupProps), {}, {
  locale: PropTypes$1.string
});

function YearView(props) {
  function renderMonths() {
    return React__default.createElement(Months, props);
  }
  return React__default.createElement("div", {
    className: "react-calendar__year-view"
  }, renderMonths());
}

var _excluded$5 = ["formatDay", "formatLongDate", "calendarType", "classes", "currentMonthIndex"];
function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty$5(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var className$2 = 'react-calendar__month-view__days__day';
function Day(_ref) {
  var _ref$formatDay = _ref.formatDay,
      formatDay$1 = _ref$formatDay === void 0 ? formatDay : _ref$formatDay,
      _ref$formatLongDate = _ref.formatLongDate,
      formatLongDate$1 = _ref$formatLongDate === void 0 ? formatLongDate : _ref$formatLongDate,
      calendarType = _ref.calendarType,
      classes = _ref.classes,
      currentMonthIndex = _ref.currentMonthIndex,
      otherProps = _objectWithoutProperties$5(_ref, _excluded$5);
  var date = otherProps.date,
      locale = otherProps.locale;
  return React__default.createElement(Tile, _extends$4({}, otherProps, {
    classes: [].concat(classes, className$2, isWeekend(date, calendarType) ? "".concat(className$2, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat(className$2, "--neighboringMonth") : null),
    formatAbbr: formatLongDate$1,
    maxDateTransform: getDayEnd,
    minDateTransform: getDayStart,
    view: "month"
  }), formatDay$1(locale, date));
}
Day.propTypes = _objectSpread$5(_objectSpread$5({}, tileProps), {}, {
  currentMonthIndex: PropTypes$1.number.isRequired,
  formatDay: PropTypes$1.func,
  formatLongDate: PropTypes$1.func
});

var _excluded$4 = ["showFixedNumberOfWeeks", "showNeighboringMonth"];
function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$4(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function Days(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType;
  var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks,
      showNeighboringMonth = props.showNeighboringMonth,
      otherProps = _objectWithoutProperties$4(props, _excluded$4);
  var year = getYear(activeStartDate);
  var monthIndex = getMonth(activeStartDate);
  var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
  var dayOfWeek = getDayOfWeek(activeStartDate, calendarType);
  var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
  var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
  var end = function () {
    if (showFixedNumberOfWeeks) {
      return start + 6 * 7 - 1;
    }
    var daysInMonth = getDaysInMonth(activeStartDate);
    if (showNeighboringMonth) {
      var activeEndDate = new Date();
      activeEndDate.setFullYear(year, monthIndex, daysInMonth);
      activeEndDate.setHours(0, 0, 0, 0);
      var daysUntilEndOfTheWeek = 7 - getDayOfWeek(activeEndDate, calendarType) - 1;
      return daysInMonth + daysUntilEndOfTheWeek;
    }
    return daysInMonth;
  }();
  return React__default.createElement(TileGroup, _extends$3({}, otherProps, {
    className: "react-calendar__month-view__days",
    count: 7,
    currentMonthIndex: monthIndex,
    dateTransform: function dateTransform(day) {
      var date = new Date();
      date.setFullYear(year, monthIndex, day);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "day",
    end: end,
    offset: offset,
    start: start,
    tile: Day
  }));
}
Days.propTypes = _objectSpread$4({
  calendarType: isCalendarType.isRequired,
  showFixedNumberOfWeeks: PropTypes$1.bool,
  showNeighboringMonth: PropTypes$1.bool
}, tileGroupProps);

var className$1 = 'react-calendar__month-view__weekdays';
function Weekdays(props) {
  var calendarType = props.calendarType,
      _props$formatShortWee = props.formatShortWeekday,
      formatShortWeekday$1 = _props$formatShortWee === void 0 ? formatShortWeekday : _props$formatShortWee,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave;
  var anyDate = new Date();
  var beginOfMonth = getMonthStart(anyDate);
  var year = getYear(beginOfMonth);
  var monthIndex = getMonth(beginOfMonth);
  var weekdays = [];
  for (var weekday = 1; weekday <= 7; weekday += 1) {
    var weekdayDate = new Date(year, monthIndex, weekday - getDayOfWeek(beginOfMonth, calendarType));
    var abbr = formatWeekday(locale, weekdayDate);
    weekdays.push( React__default.createElement("div", {
      key: weekday,
      className: "".concat(className$1, "__weekday")
    }, React__default.createElement("abbr", {
      "aria-label": abbr,
      title: abbr
    }, formatShortWeekday$1(locale, weekdayDate).replace('.', ''))));
  }
  return React__default.createElement(Flex, {
    className: className$1,
    count: 7,
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave
  }, weekdays);
}
Weekdays.propTypes = {
  calendarType: isCalendarType.isRequired,
  formatShortWeekday: PropTypes$1.func,
  locale: PropTypes$1.string,
  onMouseLeave: PropTypes$1.func
};

var _excluded$3 = ["date", "onClickWeekNumber", "weekNumber"];
function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$3(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var className = 'react-calendar__tile';
function WeekNumber(_ref) {
  var date = _ref.date,
      onClickWeekNumber = _ref.onClickWeekNumber,
      weekNumber = _ref.weekNumber,
      otherProps = _objectWithoutProperties$3(_ref, _excluded$3);
  var props = _objectSpread$3({
    className: className
  }, otherProps);
  var children = React__default.createElement("span", null, weekNumber);
  return onClickWeekNumber ? React__default.createElement("button", _extends$2({}, props, {
    onClick: function onClick(event) {
      return onClickWeekNumber(weekNumber, date, event);
    },
    type: "button"
  }), children) : React__default.createElement("div", props, children);
}
WeekNumber.propTypes = {
  date: PropTypes$1.instanceOf(Date).isRequired,
  onClickWeekNumber: PropTypes$1.func,
  weekNumber: PropTypes$1.node.isRequired
};

function WeekNumbers(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType,
      onClickWeekNumber = props.onClickWeekNumber,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
  var numberOfWeeks = function () {
    if (showFixedNumberOfWeeks) {
      return 6;
    }
    var numberOfDays = getDaysInMonth(activeStartDate);
    var startWeekday = getDayOfWeek(activeStartDate, calendarType);
    var days = numberOfDays - (7 - startWeekday);
    return 1 + Math.ceil(days / 7);
  }();
  var dates = function () {
    var year = getYear(activeStartDate);
    var monthIndex = getMonth(activeStartDate);
    var day = getDate(activeStartDate);
    var result = [];
    for (var index = 0; index < numberOfWeeks; index += 1) {
      result.push(getBeginOfWeek(new Date(year, monthIndex, day + index * 7), calendarType));
    }
    return result;
  }();
  var weekNumbers = dates.map(function (date) {
    return getWeekNumber(date, calendarType);
  });
  return React__default.createElement(Flex, {
    className: "react-calendar__month-view__weekNumbers",
    count: numberOfWeeks,
    direction: "column",
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave,
    style: {
      flexBasis: 'calc(100% * (1 / 8)',
      flexShrink: 0
    }
  }, weekNumbers.map(function (weekNumber, weekIndex) {
    return React__default.createElement(WeekNumber, {
      key: weekNumber,
      date: dates[weekIndex],
      onClickWeekNumber: onClickWeekNumber,
      weekNumber: weekNumber
    });
  }));
}
WeekNumbers.propTypes = {
  activeStartDate: PropTypes$1.instanceOf(Date).isRequired,
  calendarType: isCalendarType.isRequired,
  onClickWeekNumber: PropTypes$1.func,
  onMouseLeave: PropTypes$1.func,
  showFixedNumberOfWeeks: PropTypes$1.bool
};

var _excluded$2 = ["calendarType", "formatShortWeekday", "onClickWeekNumber", "showWeekNumbers"];
function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function getCalendarTypeFromLocale(locale) {
  return Object.keys(CALENDAR_TYPE_LOCALES).find(function (calendarType) {
    return CALENDAR_TYPE_LOCALES[calendarType].includes(locale);
  }) || CALENDAR_TYPES.ISO_8601;
}
function MonthView(props) {
  var activeStartDate = props.activeStartDate,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
  var _props$calendarType = props.calendarType,
      calendarType = _props$calendarType === void 0 ? getCalendarTypeFromLocale(locale) : _props$calendarType,
      formatShortWeekday = props.formatShortWeekday,
      onClickWeekNumber = props.onClickWeekNumber,
      showWeekNumbers = props.showWeekNumbers,
      childProps = _objectWithoutProperties$2(props, _excluded$2);
  function renderWeekdays() {
    return React__default.createElement(Weekdays, {
      calendarType: calendarType,
      formatShortWeekday: formatShortWeekday,
      locale: locale,
      onMouseLeave: onMouseLeave
    });
  }
  function renderWeekNumbers() {
    if (!showWeekNumbers) {
      return null;
    }
    return React__default.createElement(WeekNumbers, {
      activeStartDate: activeStartDate,
      calendarType: calendarType,
      onClickWeekNumber: onClickWeekNumber,
      onMouseLeave: onMouseLeave,
      showFixedNumberOfWeeks: showFixedNumberOfWeeks
    });
  }
  function renderDays() {
    return React__default.createElement(Days, _extends$1({
      calendarType: calendarType
    }, childProps));
  }
  var className = 'react-calendar__month-view';
  return React__default.createElement("div", {
    className: mergeClassNames(className, showWeekNumbers ? "".concat(className, "--weekNumbers") : '')
  }, React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, renderWeekNumbers(), React__default.createElement("div", {
    style: {
      flexGrow: 1,
      width: '100%'
    }
  }, renderWeekdays(), renderDays())));
}
MonthView.propTypes = {
  activeStartDate: PropTypes$1.instanceOf(Date).isRequired,
  calendarType: isCalendarType,
  formatShortWeekday: PropTypes$1.func,
  locale: PropTypes$1.string,
  onClickWeekNumber: PropTypes$1.func,
  onMouseLeave: PropTypes$1.func,
  showFixedNumberOfWeeks: PropTypes$1.bool,
  showWeekNumbers: PropTypes$1.bool
};

var _excluded$1 = ["activeStartDate", "defaultActiveStartDate", "defaultValue", "defaultView", "maxDetail", "minDetail", "value", "view"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray$2(arr) { return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$2(); }
function _nonIterableSpread$2() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _iterableToArray$2(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$2(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$2(arr); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var defaultMinDate = new Date();
defaultMinDate.setFullYear(1, 0, 1);
defaultMinDate.setHours(0, 0, 0, 0);
var defaultMaxDate = new Date(8.64e15);
var baseClassName = 'react-calendar';
var allViews = ['century', 'decade', 'year', 'month'];
var allValueTypes = [].concat(_toConsumableArray$2(allViews.slice(1)), ['day']);
function toDate(value) {
  if (value instanceof Date) {
    return value;
  }
  return new Date(value);
}
function getLimitedViews(minDetail, maxDetail) {
  return allViews.slice(allViews.indexOf(minDetail), allViews.indexOf(maxDetail) + 1);
}
function isViewAllowed(view, minDetail, maxDetail) {
  var views = getLimitedViews(minDetail, maxDetail);
  return views.indexOf(view) !== -1;
}
function getView(view, minDetail, maxDetail) {
  if (isViewAllowed(view, minDetail, maxDetail)) {
    return view;
  }
  return maxDetail;
}
function getValueType(maxDetail) {
  return allValueTypes[allViews.indexOf(maxDetail)];
}
function getValue(value, index) {
  if (!value) {
    return null;
  }
  var rawValue = Array.isArray(value) && value.length === 2 ? value[index] : value;
  if (!rawValue) {
    return null;
  }
  var valueDate = toDate(rawValue);
  if (isNaN(valueDate.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }
  return valueDate;
}
function getDetailValue(_ref, index) {
  var value = _ref.value,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      maxDetail = _ref.maxDetail;
  var valuePiece = getValue(value, index);
  if (!valuePiece) {
    return null;
  }
  var valueType = getValueType(maxDetail);
  var detailValueFrom = [getBegin, getEnd][index](valueType, valuePiece);
  return between(detailValueFrom, minDate, maxDate);
}
var getDetailValueFrom = function getDetailValueFrom(args) {
  return getDetailValue(args, 0);
};
var getDetailValueTo = function getDetailValueTo(args) {
  return getDetailValue(args, 1);
};
var getDetailValueArray = function getDetailValueArray(args) {
  var value = args.value;
  if (Array.isArray(value)) {
    return value;
  }
  return [getDetailValueFrom, getDetailValueTo].map(function (fn) {
    return fn(args);
  });
};
function getActiveStartDate(props) {
  var maxDate = props.maxDate,
      maxDetail = props.maxDetail,
      minDate = props.minDate,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view;
  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = getDetailValueFrom({
    value: value,
    minDate: minDate,
    maxDate: maxDate,
    maxDetail: maxDetail
  }) || new Date();
  return getBegin(rangeType, valueFrom);
}
function getInitialActiveStartDate(props) {
  var activeStartDate = props.activeStartDate,
      defaultActiveStartDate = props.defaultActiveStartDate,
      defaultValue = props.defaultValue,
      defaultView = props.defaultView,
      maxDetail = props.maxDetail,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view,
      otherProps = _objectWithoutProperties$1(props, _excluded$1);
  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = activeStartDate || defaultActiveStartDate;
  if (valueFrom) {
    return getBegin(rangeType, valueFrom);
  }
  return getActiveStartDate(_objectSpread$2({
    maxDetail: maxDetail,
    minDetail: minDetail,
    value: value || defaultValue,
    view: view || defaultView
  }, otherProps));
}
var getIsSingleValue = function getIsSingleValue(value) {
  return value && [].concat(value).length === 1;
};
var Calendar$1 = function (_Component) {
  _inherits(Calendar, _Component);
  var _super = _createSuper(Calendar);
  function Calendar() {
    var _this;
    _classCallCheck(this, Calendar);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(_args));
    _defineProperty$2(_assertThisInitialized(_this), "state", {
      activeStartDate: _this.props.defaultActiveStartDate,
      value: _this.props.defaultValue,
      view: _this.props.defaultView
    });
    _defineProperty$2(_assertThisInitialized(_this), "setStateAndCallCallbacks", function (nextState, event, callback) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          previousActiveStartDate = _assertThisInitialize.activeStartDate,
          previousView = _assertThisInitialize.view;
      var _this$props = _this.props,
          allowPartialRange = _this$props.allowPartialRange,
          onActiveStartDateChange = _this$props.onActiveStartDateChange,
          onChange = _this$props.onChange,
          onViewChange = _this$props.onViewChange,
          selectRange = _this$props.selectRange;
      var prevArgs = {
        activeStartDate: previousActiveStartDate,
        view: previousView
      };
      _this.setState(nextState, function () {
        var args = {
          action: nextState.action,
          activeStartDate: nextState.activeStartDate || _this.activeStartDate,
          value: nextState.value || _this.value,
          view: nextState.view || _this.view
        };
        function shouldUpdate(key) {
          return (
            key in nextState && (
            _typeof(nextState[key]) !== _typeof(prevArgs[key]) || (
            nextState[key] instanceof Date ? nextState[key].getTime() !== prevArgs[key].getTime() : nextState[key] !== prevArgs[key]))
          );
        }
        if (shouldUpdate('activeStartDate')) {
          if (onActiveStartDateChange) onActiveStartDateChange(args);
        }
        if (shouldUpdate('view')) {
          if (onViewChange) onViewChange(args);
        }
        if (shouldUpdate('value')) {
          if (onChange) {
            if (selectRange) {
              var isSingleValue = getIsSingleValue(nextState.value);
              if (!isSingleValue) {
                onChange(nextState.value, event);
              } else if (allowPartialRange) {
                onChange([nextState.value], event);
              }
            } else {
              onChange(nextState.value, event);
            }
          }
        }
        if (callback) callback(args);
      });
    });
    _defineProperty$2(_assertThisInitialized(_this), "setActiveStartDate", function (nextActiveStartDate, action) {
      _this.setStateAndCallCallbacks({
        action: action,
        activeStartDate: nextActiveStartDate
      });
    });
    _defineProperty$2(_assertThisInitialized(_this), "drillDown", function (nextActiveStartDate, event) {
      if (!_this.drillDownAvailable) {
        return;
      }
      _this.onClickTile(nextActiveStartDate, event);
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          view = _assertThisInitialize2.view,
          views = _assertThisInitialize2.views;
      var onDrillDown = _this.props.onDrillDown;
      var nextView = views[views.indexOf(view) + 1];
      _this.setStateAndCallCallbacks({
        action: 'drillDown',
        activeStartDate: nextActiveStartDate,
        view: nextView
      }, undefined, onDrillDown);
    });
    _defineProperty$2(_assertThisInitialized(_this), "drillUp", function () {
      if (!_this.drillUpAvailable) {
        return;
      }
      var _assertThisInitialize3 = _assertThisInitialized(_this),
          activeStartDate = _assertThisInitialize3.activeStartDate,
          view = _assertThisInitialize3.view,
          views = _assertThisInitialize3.views;
      var onDrillUp = _this.props.onDrillUp;
      var nextView = views[views.indexOf(view) - 1];
      var nextActiveStartDate = getBegin(nextView, activeStartDate);
      _this.setStateAndCallCallbacks({
        action: 'drillUp',
        activeStartDate: nextActiveStartDate,
        view: nextView
      }, undefined, onDrillUp);
    });
    _defineProperty$2(_assertThisInitialized(_this), "onChange", function (value, event) {
      var selectRange = _this.props.selectRange;
      _this.onClickTile(value, event);
      var nextValue;
      if (selectRange) {
        var _assertThisInitialize4 = _assertThisInitialized(_this),
            previousValue = _assertThisInitialize4.value,
            valueType = _assertThisInitialize4.valueType;
        if (!getIsSingleValue(previousValue)) {
          nextValue = getBegin(valueType, value);
        } else {
          nextValue = getValueRange(valueType, previousValue, value);
        }
      } else {
        nextValue = _this.getProcessedValue(value);
      }
      var nextActiveStartDate = getActiveStartDate(_objectSpread$2(_objectSpread$2({}, _this.props), {}, {
        value: nextValue
      }));
      event.persist();
      _this.setStateAndCallCallbacks({
        action: 'onChange',
        activeStartDate: nextActiveStartDate,
        value: nextValue
      }, event);
    });
    _defineProperty$2(_assertThisInitialized(_this), "onClickTile", function (value, event) {
      var _assertThisInitialize5 = _assertThisInitialized(_this),
          view = _assertThisInitialize5.view;
      var _this$props2 = _this.props,
          onClickDay = _this$props2.onClickDay,
          onClickDecade = _this$props2.onClickDecade,
          onClickMonth = _this$props2.onClickMonth,
          onClickYear = _this$props2.onClickYear;
      var callback = function () {
        switch (view) {
          case 'century':
            return onClickDecade;
          case 'decade':
            return onClickYear;
          case 'year':
            return onClickMonth;
          case 'month':
            return onClickDay;
          default:
            throw new Error("Invalid view: ".concat(view, "."));
        }
      }();
      if (callback) callback(value, event);
    });
    _defineProperty$2(_assertThisInitialized(_this), "onMouseOver", function (value) {
      _this.setState(function (prevState) {
        if (prevState.hover && prevState.hover.getTime() === value.getTime()) {
          return null;
        }
        return {
          hover: value
        };
      });
    });
    _defineProperty$2(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.setState({
        hover: null
      });
    });
    return _this;
  }
  _createClass(Calendar, [{
    key: "activeStartDate",
    get: function get() {
      var activeStartDateProps = this.props.activeStartDate;
      var activeStartDateState = this.state.activeStartDate;
      return activeStartDateProps || activeStartDateState || getInitialActiveStartDate(this.props);
    }
  }, {
    key: "value",
    get: function get() {
      var _this$props3 = this.props,
          selectRange = _this$props3.selectRange,
          valueProps = _this$props3.value;
      var valueState = this.state.value;
      if (selectRange && getIsSingleValue(valueState)) {
        return valueState;
      }
      return valueProps !== undefined ? valueProps : valueState;
    }
  }, {
    key: "valueType",
    get: function get() {
      var maxDetail = this.props.maxDetail;
      return getValueType(maxDetail);
    }
  }, {
    key: "view",
    get: function get() {
      var _this$props4 = this.props,
          minDetail = _this$props4.minDetail,
          maxDetail = _this$props4.maxDetail,
          viewProps = _this$props4.view;
      var viewState = this.state.view;
      return getView(viewProps || viewState, minDetail, maxDetail);
    }
  }, {
    key: "views",
    get: function get() {
      var _this$props5 = this.props,
          minDetail = _this$props5.minDetail,
          maxDetail = _this$props5.maxDetail;
      return getLimitedViews(minDetail, maxDetail);
    }
  }, {
    key: "hover",
    get: function get() {
      var selectRange = this.props.selectRange;
      var hover = this.state.hover;
      return selectRange ? hover : null;
    }
  }, {
    key: "drillDownAvailable",
    get: function get() {
      var view = this.view,
          views = this.views;
      return views.indexOf(view) < views.length - 1;
    }
  }, {
    key: "drillUpAvailable",
    get: function get() {
      var view = this.view,
          views = this.views;
      return views.indexOf(view) > 0;
    }
  }, {
    key: "getProcessedValue",
    value: function getProcessedValue(value) {
      var _this$props6 = this.props,
          minDate = _this$props6.minDate,
          maxDate = _this$props6.maxDate,
          maxDetail = _this$props6.maxDetail,
          returnValue = _this$props6.returnValue;
      var processFunction = function () {
        switch (returnValue) {
          case 'start':
            return getDetailValueFrom;
          case 'end':
            return getDetailValueTo;
          case 'range':
            return getDetailValueArray;
          default:
            throw new Error('Invalid returnValue.');
        }
      }();
      return processFunction({
        value: value,
        minDate: minDate,
        maxDate: maxDate,
        maxDetail: maxDetail
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent(next) {
      var currentActiveStartDate = this.activeStartDate,
          onMouseOver = this.onMouseOver,
          valueType = this.valueType,
          value = this.value,
          view = this.view;
      var _this$props7 = this.props,
          calendarType = _this$props7.calendarType,
          locale = _this$props7.locale,
          maxDate = _this$props7.maxDate,
          minDate = _this$props7.minDate,
          selectRange = _this$props7.selectRange,
          tileClassName = _this$props7.tileClassName,
          tileContent = _this$props7.tileContent,
          tileDisabled = _this$props7.tileDisabled;
      var hover = this.hover;
      var activeStartDate = next ? getBeginNext(view, currentActiveStartDate) : getBegin(view, currentActiveStartDate);
      var onClick = this.drillDownAvailable ? this.drillDown : this.onChange;
      var commonProps = {
        activeStartDate: activeStartDate,
        hover: hover,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        onClick: onClick,
        onMouseOver: selectRange ? onMouseOver : null,
        tileClassName: tileClassName,
        tileContent: tileContent,
        tileDisabled: tileDisabled,
        value: value,
        valueType: valueType
      };
      switch (view) {
        case 'century':
          {
            var formatYear = this.props.formatYear;
            return React__default.createElement(CenturyView, _extends({
              formatYear: formatYear
            }, commonProps));
          }
        case 'decade':
          {
            var _formatYear = this.props.formatYear;
            return React__default.createElement(DecadeView, _extends({
              formatYear: _formatYear
            }, commonProps));
          }
        case 'year':
          {
            var _this$props8 = this.props,
                formatMonth = _this$props8.formatMonth,
                formatMonthYear = _this$props8.formatMonthYear;
            return React__default.createElement(YearView, _extends({
              formatMonth: formatMonth,
              formatMonthYear: formatMonthYear
            }, commonProps));
          }
        case 'month':
          {
            var _this$props9 = this.props,
                formatDay = _this$props9.formatDay,
                formatLongDate = _this$props9.formatLongDate,
                formatShortWeekday = _this$props9.formatShortWeekday,
                onClickWeekNumber = _this$props9.onClickWeekNumber,
                showDoubleView = _this$props9.showDoubleView,
                showFixedNumberOfWeeks = _this$props9.showFixedNumberOfWeeks,
                showNeighboringMonth = _this$props9.showNeighboringMonth,
                showWeekNumbers = _this$props9.showWeekNumbers;
            var onMouseLeave = this.onMouseLeave;
            return React__default.createElement(MonthView, _extends({
              calendarType: calendarType,
              formatDay: formatDay,
              formatLongDate: formatLongDate,
              formatShortWeekday: formatShortWeekday,
              onClickWeekNumber: onClickWeekNumber,
              onMouseLeave: selectRange ? onMouseLeave : null,
              showFixedNumberOfWeeks: typeof showFixedNumberOfWeeks !== 'undefined' ? showFixedNumberOfWeeks : showDoubleView,
              showNeighboringMonth: showNeighboringMonth,
              showWeekNumbers: showWeekNumbers
            }, commonProps));
          }
        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      var showNavigation = this.props.showNavigation;
      if (!showNavigation) {
        return null;
      }
      var activeStartDate = this.activeStartDate,
          view = this.view,
          views = this.views;
      var _this$props10 = this.props,
          formatMonthYear = _this$props10.formatMonthYear,
          formatYear = _this$props10.formatYear,
          locale = _this$props10.locale,
          maxDate = _this$props10.maxDate,
          minDate = _this$props10.minDate,
          navigationAriaLabel = _this$props10.navigationAriaLabel,
          navigationAriaLive = _this$props10.navigationAriaLive,
          navigationLabel = _this$props10.navigationLabel,
          next2AriaLabel = _this$props10.next2AriaLabel,
          next2Label = _this$props10.next2Label,
          nextAriaLabel = _this$props10.nextAriaLabel,
          nextLabel = _this$props10.nextLabel,
          prev2AriaLabel = _this$props10.prev2AriaLabel,
          prev2Label = _this$props10.prev2Label,
          prevAriaLabel = _this$props10.prevAriaLabel,
          prevLabel = _this$props10.prevLabel,
          showDoubleView = _this$props10.showDoubleView;
      return React__default.createElement(Navigation, {
        activeStartDate: activeStartDate,
        drillUp: this.drillUp,
        formatMonthYear: formatMonthYear,
        formatYear: formatYear,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        navigationAriaLabel: navigationAriaLabel,
        navigationAriaLive: navigationAriaLive,
        navigationLabel: navigationLabel,
        next2AriaLabel: next2AriaLabel,
        next2Label: next2Label,
        nextAriaLabel: nextAriaLabel,
        nextLabel: nextLabel,
        prev2AriaLabel: prev2AriaLabel,
        prev2Label: prev2Label,
        prevAriaLabel: prevAriaLabel,
        prevLabel: prevLabel,
        setActiveStartDate: this.setActiveStartDate,
        showDoubleView: showDoubleView,
        view: view,
        views: views
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
          className = _this$props11.className,
          inputRef = _this$props11.inputRef,
          selectRange = _this$props11.selectRange,
          showDoubleView = _this$props11.showDoubleView;
      var onMouseLeave = this.onMouseLeave,
          value = this.value;
      var valueArray = [].concat(value);
      return React__default.createElement("div", {
        className: mergeClassNames(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), showDoubleView && "".concat(baseClassName, "--doubleView"), className),
        ref: inputRef
      }, this.renderNavigation(), React__default.createElement("div", {
        className: "".concat(baseClassName, "__viewContainer"),
        onBlur: selectRange ? onMouseLeave : null,
        onMouseLeave: selectRange ? onMouseLeave : null
      }, this.renderContent(), showDoubleView && this.renderContent(true)));
    }
  }]);
  return Calendar;
}(Component);
Calendar$1.defaultProps = {
  maxDate: defaultMaxDate,
  maxDetail: 'month',
  minDate: defaultMinDate,
  minDetail: 'century',
  returnValue: 'start',
  showNavigation: true,
  showNeighboringMonth: true
};
var isActiveStartDate = PropTypes$1.instanceOf(Date);
var isLooseValue = PropTypes$1.oneOfType([PropTypes$1.string, isValue]);
Calendar$1.propTypes = {
  activeStartDate: isActiveStartDate,
  allowPartialRange: PropTypes$1.bool,
  calendarType: isCalendarType,
  className: isClassName,
  defaultActiveStartDate: isActiveStartDate,
  defaultValue: isLooseValue,
  defaultView: isView,
  formatDay: PropTypes$1.func,
  formatLongDate: PropTypes$1.func,
  formatMonth: PropTypes$1.func,
  formatMonthYear: PropTypes$1.func,
  formatShortWeekday: PropTypes$1.func,
  formatYear: PropTypes$1.func,
  inputRef: isRef,
  locale: PropTypes$1.string,
  maxDate: isMaxDate,
  maxDetail: PropTypes$1.oneOf(allViews),
  minDate: isMinDate,
  minDetail: PropTypes$1.oneOf(allViews),
  navigationAriaLabel: PropTypes$1.string,
  navigationAriaLive: PropTypes$1.oneOf(['off', 'polite', 'assertive']),
  navigationLabel: PropTypes$1.func,
  next2AriaLabel: PropTypes$1.string,
  next2Label: PropTypes$1.node,
  nextAriaLabel: PropTypes$1.string,
  nextLabel: PropTypes$1.node,
  onActiveStartDateChange: PropTypes$1.func,
  onChange: PropTypes$1.func,
  onClickDay: PropTypes$1.func,
  onClickDecade: PropTypes$1.func,
  onClickMonth: PropTypes$1.func,
  onClickWeekNumber: PropTypes$1.func,
  onClickYear: PropTypes$1.func,
  onDrillDown: PropTypes$1.func,
  onDrillUp: PropTypes$1.func,
  onViewChange: PropTypes$1.func,
  prev2AriaLabel: PropTypes$1.string,
  prev2Label: PropTypes$1.node,
  prevAriaLabel: PropTypes$1.string,
  prevLabel: PropTypes$1.node,
  returnValue: PropTypes$1.oneOf(['start', 'end', 'range']),
  selectRange: PropTypes$1.bool,
  showDoubleView: PropTypes$1.bool,
  showFixedNumberOfWeeks: PropTypes$1.bool,
  showNavigation: PropTypes$1.bool,
  showNeighboringMonth: PropTypes$1.bool,
  showWeekNumbers: PropTypes$1.bool,
  tileClassName: PropTypes$1.oneOfType([PropTypes$1.func, isClassName]),
  tileContent: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.node]),
  tileDisabled: PropTypes$1.func,
  value: isLooseValue,
  view: isView
};

var Calendar = Calendar$1;

function Date$1(props) {
  var _props$height, _props$height2;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      dropdownMenu = _React$useState2[0],
      setDropdownMenu = _React$useState2[1];
  var dropdownButton = React$4.useRef();
  var ref = React$4.useRef(null);
  React$4.useEffect(function () {
    function clickHandler(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setDropdownMenu(false);
      }
    }
    document.addEventListener('mousedown', clickHandler);
    return function () {
      document.removeEventListener('mousedown', clickHandler);
    };
  }, [ref]);
  var click = function click() {
    if (props.onClick && !props.disabled) props.onClick();
    setDropdownMenu(!dropdownMenu);
  };
  var parse = function parse(number) {
    if (number < 10) {
      return "0".concat(number);
    }
    return number;
  };
  var getPlaceholder = function getPlaceholder() {
    switch (props.maxDetail) {
      case 'year':
        return '.. / ..';
      case 'decade':
        return '....';
      case 'century':
        return '.. - ..';
      default:
        return '.. / .. / ..';
    }
  };
  var parseValue = function parseValue(date) {
    switch (props.maxDetail) {
      case 'year':
        return "".concat(parse(date.getMonth() + 1), " / ").concat(date.getFullYear().toString().substr(-2));
      case 'decade':
        return date.getFullYear();
      case 'century':
        return "".concat(date.getFullYear(), " - ").concat(date.getFullYear() + 10);
      default:
        return "".concat(parse(date.getDate()), " / ").concat(parse(date.getMonth() + 1), " / ").concat(date.getFullYear().toString().substr(-2));
    }
  };
  return React$4.createElement("div", {
    ref: ref,
    style: {
      position: 'relative',
      width: '100%'
    }
  }, React$4.createElement("button", {
    ref: dropdownButton,
    className: "".concat(props.disabled || props.loading ? 'Disabled' : 'Hover', " DisableSelection"),
    type: "button",
    onClick: click,
    "aria-label": props.ariaLabel,
    style: _objectSpread2({
      width: '100%',
      height: props.size === 'medium' ? (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40 : (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : 50,
      borderRadius: props.borderRadius ? props.borderRadius : props.size === 'medium' ? 7 : 10,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      backgroundColor: props.disabled ? Colors.MEDIUM_WHITE : Colors.WHITE,
      paddingLeft: 7,
      paddingRight: 7,
      fontSize: props.size === 'medium' ? '1em' : '1.1em',
      fontWeight: 500,
      transition: 'all 0.3s linear',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }, props.style)
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      height: '100%',
      width: 30,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      marginRight: 0
    }
  }, React$4.createElement(Icon, {
    name: "CalendarDay",
    height: 27,
    width: 27,
    color: Colors.GREY,
    iconSet: "FA"
  })), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      paddingTop: 4,
      paddingBottom: 4,
      marginLeft: 5,
      height: '100%'
    }
  }, props.title && React$4.createElement(Text, {
    fontSize: "0.8em",
    fontWeight: 500
  }, "".concat(props.title, ":")), React$4.createElement("div", {
    style: {
      marginTop: props.title ? 0 : 2
    }
  }, React$4.createElement(Text, {
    fontSize: props.title ? '1em' : '1.25em'
  }, props.value ? parseValue(props.value) : getPlaceholder())))), React$4.createElement("div", {
    style: {
      width: 40,
      height: 40,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: dropdownMenu ? 'flex-start' : 'flex-end',
      transform: "rotate(".concat(dropdownMenu ? 180 : 0, "deg)")
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    height: 25,
    width: 25,
    color: dropdownMenu ? Colors.GREY : Colors.MEDIUM_GREY
  }))), dropdownMenu && React$4.createElement("div", {
    style: {
      position: 'absolute',
      paddingTop: 5,
      zIndex: 1000,
      right: props.right ? 0 : 'initial',
      left: props.right ? 'initial' : 0
    }
  }, React$4.createElement(Calendar, {
    value: props.value,
    onChange: props.onChange,
    maxDate: props.maxDate,
    maxDetail: props.maxDetail,
    className: "Blur"
  }), props.removeFilters && React$4.createElement("div", {
    style: {
      marginTop: 5,
      backgroundColor: Colors.WHITE,
      borderRadius: 15,
      width: 'auto',
      position: 'relative',
      zIndex: 2
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: 'auto'
    }
  }, React$4.createElement(Buttons$1, {
    text: _('removeFilters', {
      ns: 'ui'
    }),
    colorScheme: "white",
    onClick: props.removeFilters
  })))));
}

function Range(props) {
  var _props$max, _props$min, _props$step, _props$orient;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var max = (_props$max = props.max) !== null && _props$max !== void 0 ? _props$max : 100;
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto'
    }
  }, React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      backgroundColor: 'transparent',
      position: 'relative'
    }
  }, props.label, !props.required && !props.disabled && React$4.createElement("span", {
    style: {
      fontSize: '0.8em',
      position: 'absolute',
      marginTop: 2,
      paddingLeft: 6,
      color: Colors.MEDIUM_GREY,
      whiteSpace: 'nowrap'
    }
  }, "- ".concat(_('optional', {
    ns: 'ui'
  })))), React$4.createElement("div", {
    style: {
      width: '100%',
      marginTop: 10
    }
  }, React$4.createElement("input", {
    type: "range",
    id: props.id,
    name: props.name,
    "aria-label": props.ariaLabel,
    min: (_props$min = props.min) !== null && _props$min !== void 0 ? _props$min : 1,
    max: max,
    step: (_props$step = props.step) !== null && _props$step !== void 0 ? _props$step : 'any',
    orient: (_props$orient = props.orient) !== null && _props$orient !== void 0 ? _props$orient : 'horizontal',
    onChange: props.onChange,
    value: props.value,
    style: {
      width: '100%',
      backgroundSize: "".concat(props.value * 100 / max, "% 100%")
    }
  })), React$4.createElement("div", {
    style: {
      width: '100%',
      marginTop: 15
    }
  }, React$4.createElement(Text, {
    textAlign: "center",
    fontWeight: 500
  }, props.formattedValue)));
}

function NumberInput(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];
  var onKeyUp = function onKeyUp(event) {
    switch (event.key) {
      case 'Enter':
        if (props.onEnter) props.onEnter();
        break;
      case 'Tab':
        if (props.onTab) props.onTab();
        break;
      default:
        if (props.onKeyUp) props.onKeyUp();
    }
  };
  return React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%'
    }
  }, React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      backgroundColor: 'transparent',
      position: 'relative'
    }
  }, props.label, !props.required && !props.disabled && React$4.createElement("span", {
    style: {
      fontSize: '0.8em',
      position: 'absolute',
      marginTop: 2,
      paddingLeft: 6,
      color: Colors.MEDIUM_GREY,
      whiteSpace: 'nowrap'
    }
  }, "- ".concat(_('optional', {
    ns: 'ui'
  })))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%'
    }
  }, React$4.createElement("input", {
    className: props.disabled ? 'Disabled' : 'Hover',
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    },
    onWheel: function onWheel() {
      return document.activeElement.blur();
    },
    value: props.value,
    onChange: props.onChange,
    onKeyUp: onKeyUp,
    disabled: props.disabled,
    autoComplete: props.autocomplete,
    "aria-label": props.ariaLabel,
    "aria-required": props.required,
    id: props.id,
    name: props.name,
    placeholder: props.placeholder,
    required: props.required,
    max: props.max,
    min: props.min,
    step: props.step,
    type: "number",
    style: {
      height: 50,
      width: '100%',
      backgroundColor: Colors.WHITE,
      borderTopRightRadius: 5,
      borderTopLeftRadius: 5,
      borderBottomRightRadius: 5,
      borderBottomLeftRadius: 5,
      borderTop: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderLeft: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderBottom: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      outline: 'none',
      fontSize: '1.25em',
      fontFamily: 'Museo-Sans',
      fontWeight: 300,
      color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY,
      padding: 10,
      marginTop: 5
    }
  }))));
}

var COMMON_MIME_TYPES = new Map([
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    '.DS_Store',
    'Thumbs.db'
];
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
                return [2 , getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 , getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 , getFsHandleFiles(evt)];
            }
            return [2 , []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 , Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 , files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 , 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    if (type !== 'drop') {
                        return [2 , items];
                    }
                    return [4 , Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 , noIgnoredFiles(flatten(files))];
                case 2: return [2 , noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spreadArray(__spreadArray([], __read(acc), false), __read((Array.isArray(files) ? flatten(files) : [files])), false); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject("".concat(item, " is not a File"));
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 , entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 , 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 , Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 , 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 , 4];
                        case 4: return [3 , 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 ];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 , new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var _default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();
      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        return baseMimeType === validType.replace(/\/.*$/, '');
      }
      return mimeType === validType;
    });
  }
  return true;
};

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1(); }
function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1(arr); }
function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }
function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || _default(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }
  return [true, null];
}
function isDefined(value) {
  return value !== undefined && value !== null;
}
function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;
  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }
  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];
    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];
    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
}
function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }
  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  }
  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}
function onDocumentDragOver(event) {
  event.preventDefault();
}
function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }
      return isPropagationStopped(event);
    });
  };
}
function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray$1(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];
      var ok = true;
      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }
      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }
      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray$1(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];
      return _objectSpread$1(_objectSpread$1({}, agg), {}, _defineProperty$1({}, mimeType, ext));
    }, {});
    return [{
      accept: acceptForPicker
    }];
  }
  return accept;
}
function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray$1(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];
      return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
    }, [])
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }
  return undefined;
}
function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}

var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Dropzone = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);
  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);
  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]);
  return React__default.createElement(Fragment, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone";
var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  children: PropTypes$1.func,
  accept: PropTypes$1.objectOf(PropTypes$1.arrayOf(PropTypes$1.string)),
  multiple: PropTypes$1.bool,
  preventDropOnDocument: PropTypes$1.bool,
  noClick: PropTypes$1.bool,
  noKeyboard: PropTypes$1.bool,
  noDrag: PropTypes$1.bool,
  noDragEventsBubbling: PropTypes$1.bool,
  minSize: PropTypes$1.number,
  maxSize: PropTypes$1.number,
  maxFiles: PropTypes$1.number,
  disabled: PropTypes$1.bool,
  getFilesFromEvent: PropTypes$1.func,
  onFileDialogCancel: PropTypes$1.func,
  onFileDialogOpen: PropTypes$1.func,
  useFsAccessApi: PropTypes$1.bool,
  autoFocus: PropTypes$1.bool,
  onDragEnter: PropTypes$1.func,
  onDragLeave: PropTypes$1.func,
  onDragOver: PropTypes$1.func,
  onDrop: PropTypes$1.func,
  onDropAccepted: PropTypes$1.func,
  onDropRejected: PropTypes$1.func,
  onError: PropTypes$1.func,
  validator: PropTypes$1.func
};
var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;
  var acceptAttr = useMemo(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = useMemo(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = useMemo(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  var rootRef = useRef(null);
  var inputRef = useRef(null);
  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];
  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI());
  var onWindowFocus = function onWindowFocus() {
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;
          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };
  useEffect(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]);
  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      return;
    }
    event.preventDefault();
    dragTargetsRef.current = [];
  };
  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }
    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  useEffect(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }
    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = useCallback(function (e) {
    if (onError) {
      onError(e);
    } else {
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });
        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);
    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
    }
    if (hasFiles && onDragOver) {
      onDragOver(event);
    }
    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    });
    var targetIdx = targets.indexOf(event.target);
    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }
    dragTargetsRef.current = targets;
    if (targets.length > 0) {
      return;
    }
    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });
    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];
      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];
      var customErrors = validator ? validator(file) : null;
      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];
        if (customErrors) {
          errors = errors.concat(customErrors);
        }
        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });
    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }
    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });
    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }
    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }
    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]);
  var openFileDialog = useCallback(function () {
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false;
          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }
    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]);
  var onKeyDownCb = useCallback(function (event) {
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }
    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]);
  var onFocusCb = useCallback(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: "blur"
    });
  }, []);
  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    }
    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);
  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };
  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };
  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };
  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };
  var getRootProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);
      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);
      var inputProps = _defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);
      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread(_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
function reducer(state, action) {
  switch (action.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });
    case "blur":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });
    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });
    case "closeDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });
    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });
    case "setFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });
    case "reset":
      return _objectSpread({}, initialState);
    default:
      return state;
  }
}
function noop() {}

function File(props) {
  var _props$file;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var dropzone = React$4.useRef(0);
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _useDropzone = useDropzone({
    onDrop: props.onDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps;
  function change() {
    setHover(true);
  }
  function reset() {
    setHover(false);
  }
  React$4.useEffect(function () {
    if (dropzone.current !== null) {
      dropzone.current.addEventListener('dragover', change, false);
      dropzone.current.addEventListener('dragleave', reset, false);
      return function () {
        dropzone.current.removeEventListener('dragover', change);
        dropzone.current.removeEventListener('dragleave', reset);
      };
    }
    return null;
  }, []);
  return React$4.createElement("div", {
    style: {
      height: '100%',
      width: '100%',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      height: 'auto'
    }
  }, React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      position: 'relative',
      height: props.label || !props.required ? 20 : 0,
      display: 'inline-block'
    }
  }, props.label && props.label, !props.required && !props.disabled && React$4.createElement("span", {
    style: {
      fontSize: '0.8em',
      position: 'absolute',
      marginTop: 2,
      paddingLeft: 6,
      color: Colors.MEDIUM_GREY,
      whiteSpace: 'nowrap',
      width: 'auto'
    }
  }, "- ".concat(_('optional', {
    ns: 'ui'
  }))))), React$4.createElement("div", {
    style: {
      position: 'relative',
      height: '100%',
      width: '100%'
    }
  }, React$4.createElement("div", {
    className: "Hover DisableSelection",
    style: {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: props.file || hover ? Colors.MEDIUM_WHITE : Colors.LIGHT_GREY,
      paddingTop: 50,
      paddingBottom: 50,
      borderRadius: 10
    }
  }, React$4.createElement(Icon, {
    name: "Upload",
    height: 50,
    width: 50,
    color: props.file || hover ? Colors.DARK_GREY : Colors.MEDIUM_GREY,
    iconSet: "Feather"
  }), React$4.createElement("div", {
    style: {
      marginTop: 15
    }
  }, React$4.createElement(Text, {
    color: props.file || hover ? Colors.DARK_GREY : Colors.MEDIUM_GREY
  }, (_props$file = props.file) !== null && _props$file !== void 0 ? _props$file : _('dragDropFiles', {
    ns: 'ui'
  }), "i"))), React$4.createElement("div", _extends$d({}, getRootProps(), {
    ref: dropzone,
    "aria-label": props.ariaLabel,
    className: "Hover DisableSelection",
    style: {
      height: '100%',
      width: '100%',
      border: "dashed 2px ".concat(props.file || hover ? Colors.DARK_GREY : Colors.MEDIUM_WHITE),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      top: 0,
      paddingTop: 50,
      paddingBottom: 50,
      borderRadius: 10
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    }
  }), React$4.createElement("input", _extends$d({}, getInputProps(), {
    id: props.id,
    name: props.name,
    accept: props.accept,
    required: props.required,
    className: "Hover",
    style: {
      opacity: 0,
      height: 0,
      width: 0
    }
  })))));
}

function Time(props) {
  var _props$height, _props$width;
  var _React$useState = React$4.useState(props.init || ''),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      time = _React$useState2[0],
      setTime = _React$useState2[1];
  var lastVal = '';
  var isValid = function isValid(val) {
    var regexp = /^\d{0,2}?:?\d{0,2}$/;
    var _val$split = val.split(':'),
        _val$split2 = _slicedToArray$4(_val$split, 2),
        hoursStr = _val$split2[0],
        minutesStr = _val$split2[1];
    if (!regexp.test(val)) {
      return false;
    }
    var hours = Number(hoursStr);
    var minutes = Number(minutesStr);
    var isValidHour = function isValidHour(hour) {
      return Number.isInteger(hour) && hour >= 0 && hour < 24;
    };
    var isValidMinutes = function isValidMinutes(min) {
      return Number.isInteger(min) && hours >= 0 && hours < 24 || Number.isNaN(min);
    };
    if (!isValidHour(hours) || !isValidMinutes(minutes)) {
      return false;
    }
    if (minutes < 10 && Number(minutesStr[0]) > 5) {
      return false;
    }
    var valArr = val.indexOf(':') !== -1 ? val.split(':') : [val];
    if (valArr[0] && valArr[0].length && (parseInt(valArr[0], 10) < 0 || parseInt(valArr[0], 10) > 23)) {
      return false;
    }
    return !(valArr[1] && valArr[1].length && (parseInt(valArr[1], 10) < 0 || parseInt(valArr[1], 10) > 59));
  };
  var onChangeHandler = function onChangeHandler(pval) {
    var lval = pval.target.value;
    if (lval === time) {
      return;
    }
    if (isValid(lval) && lval.charAt(0) !== ':') {
      if (lval.length === 2 && lastVal.length !== 3 && lval.indexOf(':') !== 1) {
        lval = "".concat(lval, ":");
      }
      if (lval.length === 2 && lval.charAt(1) === ':') {
        lval = "0".concat(lval);
      }
      if (lval.length === 1 && lval.charAt(0) > 2 && lastVal.length !== 2 && lval.indexOf(':') !== 1) {
        lval = "0".concat(lval, ":");
      }
      if (lval.length === 2 && lastVal.length === 3) {
        lval = lval.slice(0, 1);
      }
      lastVal = lval;
      setTime(lval);
      props.onChange(lval);
    }
  };
  return React$4.createElement("div", {
    style: {
      position: 'relative',
      width: '100%'
    }
  }, React$4.createElement("input", {
    name: props.name,
    value: props.init,
    onChange: onChangeHandler,
    style: {
      height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 50,
      width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : '100%',
      borderRadius: 5,
      border: '1px solid grey',
      outline: 'none',
      fontSize: '1.25em',
      fontFamily: 'Museo-Sans',
      fontWeight: 300,
      color: Colors.GREY,
      padding: 10,
      marginTop: 5,
      textAlign: 'center'
    }
  }));
}

function Copy(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      position: 'relative'
    },
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    }
  }, props.label && React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      position: 'relative',
      height: 20,
      display: 'inline-block'
    }
  }, props.label), React$4.createElement(AnimatePresence, null, hover && React$4.createElement(motion.div, {
    style: {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      top: -5,
      width: '100%'
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }, React$4.createElement("div", {
    style: {
      height: 'auto',
      width: 'auto',
      backgroundColor: Colors.GREY,
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 10,
      paddingRight: 10,
      borderRadius: 5
    }
  }, React$4.createElement(Text, {
    fontSize: "0.9em",
    color: Colors.WHITE,
    fontWeight: 100
  }, "Copy")))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: 'auto',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    className: "HoverText",
    type: "button",
    onClick: function onClick() {
      console.log('test');
      navigator.clipboard.writeText(props.value);
    },
    style: {
      height: 50,
      width: '100%',
      marginTop: 5,
      backgroundColor: Colors.WHITE,
      fontSize: '1em',
      padding: 10,
      border: "".concat(hover ? 'dashed' : 'solid', " 2px ").concat(Colors.MEDIUM_WHITE),
      borderRadius: 5
    },
    "aria-label": "Copy"
  }, React$4.createElement(Text, null, props.value))));
}

var Backgrounds = {
  BLUR: 'rgba(255,255,255,0.85)'
};

function DropdownItem(props) {
  var _props$onClick, _props$icon$iconSet, _props$color, _props$color2;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    onMouseEnter: function onMouseEnter() {
      return props.disabled ? null : setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return props.disabled ? null : setHover(false);
    },
    type: "button",
    className: "Hover",
    onClick: props.disabled ? null : props.onClick,
    style: {
      height: 50,
      width: '100%',
      backgroundColor: 'transparent',
      border: 'none',
      fontSize: '1em',
      padding: 0,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left',
      alignItems: 'center',
      paddingLeft: 5,
      paddingRight: 5,
      position: 'relative'
    }
  }, (props.type === 'radio' || props.type === 'checkbox') && React$4.createElement("span", {
    style: {
      marginTop: -0.7
    }
  }, React$4.createElement(Input, {
    type: props.type,
    selected: props.selected,
    onClick: (_props$onClick = props.onClick) !== null && _props$onClick !== void 0 ? _props$onClick : null,
    disabled: props.disabled
  })), props.icon && React$4.createElement("span", {
    style: {
      marginTop: 2,
      paddingRight: 7
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: props.icon.height,
    width: props.icon.width,
    color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY,
    iconSet: (_props$icon$iconSet = props.icon.iconSet) !== null && _props$icon$iconSet !== void 0 ? _props$icon$iconSet : 'FA'
  })), React$4.createElement(Text, {
    fontSize: "1.1em",
    fontWeight: 300,
    color: props.disabled ? Colors.MEDIUM_GREY : (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
  }, props.title), React$4.createElement(AnimatePresence, null, hover && React$4.createElement(motion.div, {
    style: {
      position: 'absolute',
      paddingTop: 3
    },
    initial: {
      right: 20,
      opacity: 0
    },
    animate: {
      right: 0,
      opacity: 1
    },
    exit: {
      right: 20,
      opacity: 0
    },
    transition: {
      duration: 0.2
    }
  }, React$4.createElement(Icon, {
    name: "ArrowRight",
    width: 15,
    height: 15,
    color: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY
  }))));
}

function DropdownMenu(props) {
  var ref = React$4.useRef(null);
  React$4.useEffect(function () {
    function clickHandler(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        props.onClose();
      }
    }
    document.addEventListener('mousedown', clickHandler);
    return function () {
      document.removeEventListener('mousedown', clickHandler);
    };
  }, [ref]);
  return React$4.createElement("div", {
    ref: ref,
    className: "Blur",
    style: {
      height: 'auto',
      minHeight: 50,
      width: props.width,
      minWidth: 240,
      border: "solid 1px ".concat(Colors.MEDIUM_WHITE),
      position: 'absolute',
      top: 70,
      borderRadius: 10,
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      zIndex: 2147483004,
      boxShadow: "0px 0px 25px 0px ".concat(Colors.GREY, "25"),
      overflow: 'hidden',
      backgroundColor: Backgrounds.BLUR
    }
  }, props.items.map(function (event, index) {
    return React$4.createElement(React$4.Fragment, {
      key: index
    }, event.hr ? React$4.createElement("hr", {
      style: {
        border: "solid 1px ".concat(Colors.MEDIUM_WHITE)
      }
    }) : React$4.createElement(DropdownItem, {
      type: event.type,
      title: event.title,
      color: event.color,
      onClick: function onClick() {
        event.onClick();
        if (props.onClick) {
          props.onClick();
        }
      },
      selected: event.selected,
      icon: event.icon,
      disabled: event.disabled
    }));
  }));
}

function Dropdown(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      dropdownMenu = _React$useState4[0],
      setDropdownMenu = _React$useState4[1];
  var _React$useState5 = React$4.useState(240),
      _React$useState6 = _slicedToArray$4(_React$useState5, 2),
      menuWidth = _React$useState6[0],
      setMenuWidth = _React$useState6[1];
  var dropdownButton = React$4.useRef();
  React$4.useEffect(function () {
    if (dropdownButton.current.clientWidth >= 240) {
      setMenuWidth(dropdownButton.current.clientWidth);
    }
  }, [dropdownButton]);
  return React$4.createElement("div", {
    style: {
      position: 'relative'
    }
  }, React$4.createElement("button", {
    type: "button",
    onClick: function onClick() {
      setDropdownMenu(!dropdownMenu);
    },
    className: "Hover",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    ref: dropdownButton,
    "aria-label": props.ariaLabel,
    style: {
      height: 50,
      width: '100%',
      minWidth: 50,
      backgroundColor: Colors.WHITE,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 5,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: '1em',
      marginBottom: 0,
      padding: 0
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  }, (props.icon || props.selected) && React$4.createElement("div", {
    style: {
      width: 35,
      height: 35,
      maxWidth: 35,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, props.icon && React$4.createElement(Icon, {
    name: props.icon.name,
    height: props.icon.height,
    width: props.icon.width,
    color: hover ? Colors.GREY : props.icon.color,
    iconSet: props.icon.iconSet
  }), !props.icon && props.selected.icon && React$4.createElement(Icon, {
    name: props.selected.icon.name,
    height: props.selected.icon.height,
    width: props.selected.icon.width,
    color: dropdownMenu || hover ? Colors.GREY : props.selected.icon.color,
    iconSet: props.selected.icon.iconSet
  })), props.text && React$4.createElement("div", {
    style: {
      paddingLeft: props.icon || props.selected ? 0 : 10,
      paddingRight: 5
    }
  }, React$4.createElement(Text, {
    color: Colors.GREY
  }, props.text))), React$4.createElement("div", {
    style: {
      width: 25,
      height: 25,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      transform: "rotate(".concat(dropdownMenu ? 180 : 0, "deg)")
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    height: 25,
    width: 25,
    color: dropdownMenu || hover ? Colors.GREY : Colors.MEDIUM_GREY
  }))), dropdownMenu && React$4.createElement("div", {
    style: {
      position: 'absolute',
      top: -15,
      right: props.right ? menuWidth : 'initial',
      left: props.right ? 'initial' : 0,
      zIndex: 10
    }
  }, React$4.createElement(DropdownMenu, {
    items: props.items,
    width: menuWidth,
    onClose: function onClose() {
      return setDropdownMenu(!dropdownMenu);
    },
    visible: dropdownMenu,
    right: props.right
  })));
}

function Input(props) {
  var renderInput = function renderInput() {
    var _props$colorScheme;
    switch (props.type) {
      case 'text':
        return React$4.createElement(TextInput, {
          type: "text",
          id: props.id,
          name: props.name,
          label: props.label,
          placeholder: props.placeholder,
          required: props.required,
          error: props.error,
          onChange: props.onChange,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          styling: props.styling,
          max: props.max,
          value: props.value,
          disabled: props.disabled,
          autocomplete: props.autocomplete,
          ariaLabel: props.ariaLabel,
          backgroundColor: props.backgroundColor
        });
      case 'email':
        return React$4.createElement(TextInput, {
          type: "email",
          id: props.id,
          name: props.name,
          label: props.label,
          placeholder: props.placeholder,
          required: props.required,
          error: props.error,
          onChange: props.onChange,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          styling: props.styling,
          max: props.max,
          value: props.value,
          disabled: props.disabled,
          autocomplete: props.autocomplete,
          ariaLabel: props.ariaLabel,
          backgroundColor: props.backgroundColor
        });
      case 'password':
        return React$4.createElement(TextInput, {
          type: "password",
          id: props.id,
          name: props.name,
          label: props.label,
          placeholder: props.placeholder,
          required: props.required,
          error: props.error,
          onChange: props.onChange,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          styling: props.styling,
          max: props.max,
          value: props.value,
          disabled: props.disabled,
          autocomplete: props.autocomplete,
          ariaLabel: props.ariaLabel,
          backgroundColor: props.backgroundColor
        });
      case 'radio':
        return React$4.createElement(RadioInput, {
          type: "radio",
          selected: props.selected,
          onClick: props.onClick,
          ariaLabel: props.ariaLabel,
          disabled: props.disabled
        });
      case 'checkbox':
        return React$4.createElement(Checkbox, {
          type: "checkbox",
          selected: props.selected,
          onClick: props.onClick,
          label: props.label,
          ariaLabel: props.ariaLabel,
          disabled: props.disabled
        });
      case 'range':
        return React$4.createElement(Range, {
          type: "range",
          label: props.label,
          required: props.required,
          disabled: props.disabled,
          min: props.min,
          max: props.max,
          step: props.step,
          orient: props.orient,
          name: props.name,
          value: props.value,
          onChange: props.onChange,
          formattedValue: props.formattedValue,
          ariaLabel: props.ariaLabel
        });
      case 'dropdown':
        return React$4.createElement(Dropdown, {
          type: "dropdown",
          onClick: props.onClick,
          items: props.items,
          selected: props.selected,
          icon: props.icon,
          text: props.text,
          right: props.right,
          ariaLabel: props.ariaLabel
        });
      case 'switch':
        return React$4.createElement(Switch, {
          type: "switch",
          value: props.value,
          onClick: props.onClick,
          disabled: props.disabled,
          ariaLabel: props.ariaLabel
        });
      case 'date':
        return React$4.createElement(Date$1, {
          title: props.title,
          onClick: props.onClick,
          size: props.size,
          disabled: props.disabled,
          colorScheme: getColorScheme$1("".concat((_props$colorScheme = props.colorScheme) !== null && _props$colorScheme !== void 0 ? _props$colorScheme : 'blue')),
          height: props.height,
          style: props.style,
          value: props.value,
          onChange: props.onChange,
          maxDate: props.maxDate,
          right: props.right,
          maxDetail: props.maxDetail,
          ariaLabel: props.ariaLabel,
          borderRadius: props.borderRadius,
          icon: props.icon,
          removeFilters: props.removeFilters
        });
      case 'number':
        return React$4.createElement(NumberInput, {
          type: "number",
          id: props.id,
          name: props.name,
          label: props.label,
          placeholder: props.placeholder,
          required: props.required,
          error: props.error,
          onChange: props.onChange,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          styling: props.styling,
          min: props.min,
          max: props.max,
          step: props.step,
          value: props.value,
          autocomplete: props.autocomplete,
          ariaLabel: props.ariaLabel,
          backgroundColor: props.backgroundColor,
          disabled: props.disabled
        });
      case 'file':
        return React$4.createElement(File, {
          type: "file",
          id: props.id,
          name: props.name,
          label: props.label,
          required: props.required,
          error: props.error,
          ariaLabel: props.ariaLabel,
          disabled: props.disabled,
          accept: props.accept,
          file: props.file,
          onDrop: props.onDrop
        });
      case 'time':
        return React$4.createElement(Time, {
          style: props.style,
          name: props.name,
          init: props.init,
          onChange: props.onChange,
          onBlurHandler: props.onBlurHandler
        });
      case 'copy':
        return React$4.createElement(Copy, {
          label: props.label,
          id: props.id,
          value: props.value,
          ariaLabel: props.ariaLabel,
          name: props.name,
          placeholder: props.placeholder,
          backgroundColor: props.backgroundColor
        });
      default:
        return React$4.createElement(TextInput, {
          type: "text",
          id: props.id,
          name: props.name,
          label: props.label,
          placeholder: props.placeholder,
          required: props.required,
          error: props.error,
          onChange: props.onChange,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          styling: props.styling,
          max: props.max,
          value: props.value,
          disabled: props.disabled,
          autocomplete: props.autocomplete,
          ariaLabel: props.ariaLabel,
          backgroundColor: props.backgroundColor
        });
    }
  };
  return React$4.createElement(React$4.Fragment, null, renderInput());
}

function ArrowButton(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement(motion.button, {
    className: "Hover",
    type: "button",
    "aria-label": props.ariaLabel,
    onClick: props.onClick,
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      height: 50,
      width: 50,
      position: 'absolute',
      backgroundColor: props.colorScheme.vibrant,
      left: props.left ? 0 : 'inherit',
      right: props.right ? 0 : 'inherit',
      top: '50%',
      transform: 'translateY(-50%)',
      borderRadius: 10,
      border: "solid 2px ".concat(props.colorScheme.dark_shade),
      paddingLeft: props.left ? 0 : 6
    },
    initial: {
      opacity: props.visisble ? 1 : 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: props.visisble ? 1 : 0
    },
    transition: {
      duration: 0.3
    }
  }, React$4.createElement("div", {
    style: {
      position: 'absolute',
      top: 12,
      left: props.left ? hover ? 5 : 9 : hover ? 16 : 12,
      transition: 'all 0.05s linear'
    }
  }, React$4.createElement(Icon, {
    name: props.left ? 'ChevronLeft' : 'ChevronRight',
    iconSet: "Feather",
    height: 25,
    width: 25,
    color: props.colorScheme.type === 'white' ? Colors.DARK_GREY : props.colorScheme.text
  })));
}

function Carousel(props) {
  var _childRef$current, _props$height, _props$width;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(0),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      active = _React$useState2[0],
      setActive = _React$useState2[1];
  var _React$useState3 = React$4.useState(0),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      childOffsetWidth = _React$useState4[0],
      setChildOffsetWidth = _React$useState4[1];
  var _React$useState5 = React$4.useState(0),
      _React$useState6 = _slicedToArray$4(_React$useState5, 2),
      wrapperOffsetWidth = _React$useState6[0],
      setWrapperOffsetWidth = _React$useState6[1];
  var _React$useState7 = React$4.useState(false),
      _React$useState8 = _slicedToArray$4(_React$useState7, 2),
      hover = _React$useState8[0],
      setHover = _React$useState8[1];
  var childRef = React$4.useRef(props.height);
  var wrapperRef = React$4.useRef();
  var getWrapperOffsetWidth = function getWrapperOffsetWidth() {
    var _wrapperRef$current;
    if ((_wrapperRef$current = wrapperRef.current) !== null && _wrapperRef$current !== void 0 && _wrapperRef$current.clientWidth) {
      setWrapperOffsetWidth(wrapperRef.current.clientWidth);
    }
  };
  React$4.useEffect(function () {
    getWrapperOffsetWidth();
    setChildOffsetWidth(childRef.current.offsetWidth);
  }, [wrapperOffsetWidth, (_childRef$current = childRef.current) === null || _childRef$current === void 0 ? void 0 : _childRef$current.clientWidth]);
  React$4.useEffect(function () {
    window.addEventListener('resize', getWrapperOffsetWidth);
    return function () {
      return window.removeEventListener('resize', getWrapperOffsetWidth);
    };
  }, []);
  React$4.useEffect(function () {
    if (props.onChangeActive) props.onChangeActive(active);
  }, [active]);
  var fadeSelection = function fadeSelection(e) {
    var direction = 0;
    if (e === 'left') direction = -90;
    if (e === 'right') direction = 90;
    var greenGradient = "linear-gradient(".concat(direction, "deg, rgba(0, 202, 139, 0.001) 0%, rgba(0, 202, 139, 1) 90%)");
    var whiteGradient = "linear-gradient(".concat(direction, "deg, rgba(255, 255, 255, 0.001) 0%, rgba(255, 255, 255, 1) 90%)");
    if (props.colorScheme === 'green') return greenGradient;
    if (props.colorScheme === 'white') return whiteGradient;
    return whiteGradient;
  };
  var delta = 1;
  function calcLastItems() {
    if (props.maxItems !== 1) delta = props.maxItems;
    for (var i = 0; i < props.children.length; i += delta) {
    }
  }
  calcLastItems();
  return React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    style: {
      height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 300,
      width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : '100%',
      display: 'flex',
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: 'transparent'
    }
  }, React$4.createElement("div", {
    ref: wrapperRef,
    style: {
      flex: 1,
      height: '100%',
      width: '100%',
      transform: "translateX(\n              ".concat(childOffsetWidth > props.height ? "calc(-".concat(active, " * (101% / (").concat(props.maxItems, ")")
      : active === props.children.length - props.maxItems && !props.toEnd ? "calc(".concat(wrapperOffsetWidth, "px - (").concat(props.children.length, " * (").concat(childOffsetWidth, "px + 1%) - 1%))")
      : "calc(-".concat(active, " * (").concat(childOffsetWidth, "px + 1%))")
      , "\n            )"),
      transition: 'all ease .5s',
      whiteSpace: 'nowrap'
    }
  }, React$4.Children.map(props.children, function (child) {
    var _props$minWidth;
    return React$4.createElement("div", {
      style: {
        display: 'inline-block',
        marginRight: '1%',
        width: props.maxItems === 1 ? '100%' : "calc(".concat("".concat(100 - (props.maxItems - 1)), "% / ", props.maxItems, ")"),
        minWidth: (_props$minWidth = props.minWidth) !== null && _props$minWidth !== void 0 ? _props$minWidth : props.height,
        maxWidth: props.maxItems === 1 ? '100%' : "calc(".concat("".concat(100 - (props.maxItems - 1)), "% / ", props.maxItems, ")"),
        height: '100%',
        overflow: 'hidden'
      }
    }, React$4.cloneElement(child, {
      ref: childRef,
      style: _objectSpread2({
        maxWidth: '100%',
        whiteSpace: 'normal'
      }, child.props.style)
    }));
  })), React$4.createElement(AnimatePresence, null, active !== 0 && React$4.createElement(motion.div, {
    style: {
      background: props.fade ? fadeSelection('left') : 'transparent',
      position: 'absolute',
      height: '100%',
      width: 45,
      left: 0
    },
    initial: {
      width: 0,
      opacity: 0
    },
    animate: {
      width: 45,
      opacity: 1
    },
    exit: {
      width: 0,
      opacity: 0
    },
    transition: {
      duration: 0.4
    }
  })), React$4.createElement(AnimatePresence, null, active !== 0 && (hover || props.visibleArrows) && !props.disable && React$4.createElement(ArrowButton, {
    left: true,
    ariaLabel: "".concat(_('previous', {
      ns: 'ui'
    }), " ").concat(_('accessibility.button', {
      ns: 'ui'
    }).toLowerCase()),
    colorScheme: getColorScheme(props.colorScheme),
    visible: props.visibleArrows,
    onClick: function onClick() {
      return active !== 0 && setActive(active - 1);
    }
  })), React$4.createElement(AnimatePresence, null, props.children.length >= props.maxItems && active !== props.children.length - props.maxItems && React$4.createElement(motion.div, {
    style: {
      background: props.fade ? fadeSelection('right') : 'transparent',
      position: 'absolute',
      height: '100%',
      width: 45,
      right: 0
    },
    initial: {
      width: 0,
      opacity: 0
    },
    animate: {
      width: 45,
      opacity: 1
    },
    exit: {
      width: 0,
      opacity: 0
    },
    transition: {
      duration: 0.4
    }
  })), React$4.createElement(AnimatePresence, null, (props.toEnd ? active !== props.children.length - 1 && (hover || props.visibleArrows) : props.children.length >= props.maxItems && active !== props.children.length - props.maxItems && !props.disable && (hover || props.visibleArrows)) && React$4.createElement(ArrowButton, {
    right: true,
    ariaLabel: "".concat(_('next', {
      ns: 'ui'
    }), " ").concat(_('accessibility.button', {
      ns: 'ui'
    }).toLowerCase()),
    colorScheme: getColorScheme(props.colorScheme),
    visible: props.visibleArrows,
    onClick:
    function onClick() {
      return (props.toEnd ? active !== props.children.length - 1 : active !== props.children.length - props.maxItems) && setActive(active + 1);
    }
  })));
}

function Title(props) {
  var _props$fontFamily, _props$fontSize, _props$fontWeight, _props$color, _props$textAlign, _props$whiteSpace, _props$fontFamily2, _props$fontSize2, _props$fontWeight2, _props$color2, _props$textAlign2, _props$whiteSpace2, _props$textTransform, _props$textDecoration, _props$lineHeight;
  return props.portableText ? React$4.createElement(PortableTextComponent, {
    content: props.children,
    fontFamily: (_props$fontFamily = props.fontFamily) !== null && _props$fontFamily !== void 0 ? _props$fontFamily : 'Museo-Sans',
    fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '2em',
    fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : 700,
    color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    textAlign: (_props$textAlign = props.textAlign) !== null && _props$textAlign !== void 0 ? _props$textAlign : 'left',
    lineHeight: props.lineHeight,
    textTransform: props.textTransform,
    textDecoration: props.textDecoration,
    whiteSpace: (_props$whiteSpace = props.whiteSpace) !== null && _props$whiteSpace !== void 0 ? _props$whiteSpace : 'normal'
  }) : React$4.createElement("h2", {
    style: {
      fontFamily: (_props$fontFamily2 = props.fontFamily) !== null && _props$fontFamily2 !== void 0 ? _props$fontFamily2 : 'Museo-Sans',
      fontSize: (_props$fontSize2 = props.fontSize) !== null && _props$fontSize2 !== void 0 ? _props$fontSize2 : '2em',
      fontWeight: (_props$fontWeight2 = props.fontWeight) !== null && _props$fontWeight2 !== void 0 ? _props$fontWeight2 : 700,
      color: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
      textAlign: (_props$textAlign2 = props.textAlign) !== null && _props$textAlign2 !== void 0 ? _props$textAlign2 : 'left',
      whiteSpace: (_props$whiteSpace2 = props.whiteSpace) !== null && _props$whiteSpace2 !== void 0 ? _props$whiteSpace2 : 'normal',
      textTransform: (_props$textTransform = props.textTransform) !== null && _props$textTransform !== void 0 ? _props$textTransform : 'none',
      textDecoration: (_props$textDecoration = props.textDecoration) !== null && _props$textDecoration !== void 0 ? _props$textDecoration : 'none',
      lineHeight: (_props$lineHeight = props.lineHeight) !== null && _props$lineHeight !== void 0 ? _props$lineHeight : 'normal'
    }
  }, props.children);
}

function ModuleHeader$1(props) {
  var _props$icon$width, _props$icon$height, _props$icon$color;
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      height: 60,
      width: '100%',
      display: 'flex',
      flexDirection: 'row'
    }
  }, props.icon && size.width > Breakpoint.fd && React$4.createElement("div", {
    style: {
      width: 60,
      height: 60,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    width: (_props$icon$width = props.icon.width) !== null && _props$icon$width !== void 0 ? _props$icon$width : 45,
    height: (_props$icon$height = props.icon.height) !== null && _props$icon$height !== void 0 ? _props$icon$height : 45,
    color: (_props$icon$color = props.icon.color) !== null && _props$icon$color !== void 0 ? _props$icon$color : Colors.GREY
  })), React$4.createElement("div", {
    style: {
      width: 'auto',
      height: 60,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingTop: props.clickable ? 0 : 2
    }
  }, React$4.createElement(Text, {
    fontSize: "1.25em",
    fontWeight: 500
  }, props.title), React$4.createElement("div", {
    style: {
      paddingTop: 3
    }
  }, React$4.createElement(Text, {
    fontSize: "1.1em"
  }, props.subTitle))));
}

function Clickable(props) {
  return React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      props.onClick();
    },
    style: {
      width: '100%',
      height: 'auto',
      maxHeight: 60,
      display: 'flex',
      flexDirection: 'row',
      fontSize: '1em',
      padding: 0,
      margin: 0,
      backgroundColor: 'transparent',
      border: 'solid 1px transparent',
      position: 'relative',
      zIndex: 1
    }
  }, React$4.createElement(ModuleHeader$1, {
    title: props.title,
    subTitle: props.subTitle,
    icon: props.icon,
    clickable: true
  }), React$4.createElement("div", {
    style: {
      height: 60,
      width: 60,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      transform: "rotate(".concat(props.active ? "".concat(180, "deg") : "".concat(0, "deg"), ")")
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    height: 25,
    width: 25,
    color: Colors.GREY
  })));
}

function ModuleHeader(props) {
  return props.onClick ? React$4.createElement(Clickable, {
    title: props.title,
    subTitle: props.subTitle,
    icon: props.icon,
    onClick: props.onClick,
    active: props.active
  }) : React$4.createElement(ModuleHeader$1, {
    title: props.title,
    subTitle: props.subTitle,
    icon: props.icon,
    style: props.style
  });
}

function NavigationItem(props) {
  var _props$icon$height, _props$icon$width, _props$icon$color;
  var size = useDimensions();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      dropdown = _React$useState2[0],
      setDropdown = _React$useState2[1];
  return React$4.createElement("div", {
    style: {
      width: 'auto',
      height: '100%',
      maxHeight: 80,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    }
  }, React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      setDropdown(!dropdown);
    },
    style: {
      width: '100%',
      height: 80,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      fontSize: '1.1em',
      backgroundColor: 'transparent',
      padding: '0',
      border: 'none'
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      marginRight: size.width > Breakpoint.xs && props.title ? 5 : 0,
      paddingTop: 3
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: (_props$icon$height = props.icon.height) !== null && _props$icon$height !== void 0 ? _props$icon$height : 30,
    width: (_props$icon$width = props.icon.width) !== null && _props$icon$width !== void 0 ? _props$icon$width : 30,
    color: (_props$icon$color = props.icon.color) !== null && _props$icon$color !== void 0 ? _props$icon$color : Colors.BLUE
  })), size.width > Breakpoint.xs && props.title && React$4.createElement(Text, {
    color: Colors.BLUE,
    fontWeight: 300,
    fontSize: "1.1em",
    textAlign: "center"
  }, props.title), props.dropdownMenu && React$4.createElement("div", {
    style: {
      marginLeft: size.width > Breakpoint.xs ? 3 : 0,
      paddingTop: 5,
      transform: "rotate(".concat(dropdown ? "".concat(180, "deg") : "".concat(0, "deg"), ")")
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    height: 25,
    width: 25,
    color: Colors.BLUE
  }))), props.dropdownMenu && dropdown && React$4.createElement("div", {
    style: {
      position: 'absolute',
      right: 240,
      zIndex: 2147483004
    }
  }, React$4.createElement(DropdownMenu, {
    onClose: function onClose() {
      return setDropdown(false);
    },
    items: props.dropdownMenu
  })));
}

function Link(props) {
  var _props$href, _props$color, _props$fontSize, _props$fontWeight, _props$title;
  var _React$useState = React$4.useState(),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("a", {
    href: (_props$href = props.href) !== null && _props$href !== void 0 ? _props$href : '/404',
    className: "Hover DisableSelection",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.BLUE,
      fontFamily: 'Museo-Sans',
      fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1em',
      fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : '300',
      textDecoration: hover ? 'underline' : 'none'
    }
  }, (_props$title = props.title) !== null && _props$title !== void 0 ? _props$title : props.href);
}

function RangeMeter(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: props.horizontal ? 'column-reverse' : 'column',
      alignItems: props.horizontal ? 'flex-start' : 'center',
      height: '100%'
    }
  }, React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      height: props.horizontal ? 30 : '100%',
      width: props.horizontal ? '100%' : 30,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      height: props.horizontal ? 10 : '100%',
      minHeight: props.horizontal ? 0 : 200,
      width: props.horizontal ? '100%' : 10,
      borderRadius: 15,
      backgroundColor: Colors.MEDIUM_GREY,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: props.horizontal ? 'center' : 'flex-end'
    }
  }, React$4.createElement("div", {
    style: {
      height: props.horizontal ? 10 : props.value ? "".concat(props.value, "%") : '0%',
      width: props.horizontal ? props.value ? "".concat(props.value, "%") : '0%' : 10,
      backgroundColor: Colors.GREY,
      borderRadius: 15,
      transition: 'all .3s ease'
    }
  })), React$4.createElement(AnimatePresence, null, hover && !props.horizontal && React$4.createElement(motion.div, {
    className: "Hover ContextMenu",
    style: {
      left: 30,
      position: 'absolute',
      height: 30,
      width: 'auto',
      backgroundColor: Colors.GREY,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: 10,
      paddingRight: 10,
      borderRadius: 5,
      boxShadow: "0px 0px 25px 0px ".concat(Colors.GREY, "25"),
      zIndex: 1
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.3,
      delay: 0.1
    }
  }, React$4.createElement(Text, {
    color: Colors.WHITE,
    fontSize: "1.1em"
  }, props.content, props.unit)))), React$4.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'space-between'
    }
  }, props.description && React$4.createElement("div", {
    style: {
      paddingTop: props.horizontal ? 5 : 10,
      paddingBottom: 5,
      paddingLeft: 0,
      width: props.horizontal ? '50%' : '100%'
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    fontWeight: props.active ? 500 : 300,
    textAlign: props.horizontal ? 'left' : 'center'
  }, props.description)), props.horizontal && React$4.createElement("div", {
    style: {
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 0,
      width: '50%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    fontWeight: props.active ? 500 : 300
  }, props.content, props.unit))));
}

const pi$1 = Math.PI,
    tau$1 = 2 * pi$1,
    epsilon$1 = 1e-6,
    tauEpsilon = tau$1 - epsilon$1;
function Path() {
  this._x0 = this._y0 =
  this._x1 = this._y1 = null;
  this._ = "";
}
function path() {
  return new Path;
}
Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;
    if (r < 0) throw new Error("negative radius: " + r);
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }
    else if (!(l01_2 > epsilon$1));
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }
      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;
    if (r < 0) throw new Error("negative radius: " + r);
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }
    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._ += "L" + x0 + "," + y0;
    }
    if (!r) return;
    if (da < 0) da = da % tau$1 + tau$1;
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }
    else if (da > epsilon$1) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$1)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

function constant$1(x) {
  return function constant() {
    return x;
  };
}

const abs = Math.abs;
const atan2 = Math.atan2;
const cos = Math.cos;
const max = Math.max;
const min = Math.min;
const sin = Math.sin;
const sqrt = Math.sqrt;
const epsilon = 1e-12;
const pi = Math.PI;
const halfPi = pi / 2;
const tau = 2 * pi;
function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}
function arcOuterRadius(d) {
  return d.outerRadius;
}
function arcStartAngle(d) {
  return d.startAngle;
}
function arcEndAngle(d) {
  return d.endAngle;
}
function arcPadAngle(d) {
  return d && d.padAngle;
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < epsilon) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}
function arc() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant$1(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;
  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi,
        a1 = endAngle.apply(this, arguments) - halfPi,
        da = abs(a1 - a0),
        cw = a1 > a0;
    if (!context) context = buffer = path();
    if (r1 < r0) r = r1, r1 = r0, r0 = r;
    if (!(r1 > epsilon)) context.moveTo(0, 0);
    else if (da > tau - epsilon) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;
      if (rp > epsilon) {
        var p0 = asin(rp / r0 * sin(ap)),
            p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }
      var x01 = r1 * cos(a01),
          y01 = r1 * sin(a01),
          x10 = r0 * cos(a10),
          y10 = r0 * sin(a10);
      if (rc > epsilon) {
        var x11 = r1 * cos(a11),
            y11 = r1 * sin(a11),
            x00 = r0 * cos(a00),
            y00 = r0 * sin(a00),
            oc;
        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min(rc, (r0 - lc) / (kc - 1));
          rc1 = min(rc, (r1 - lc) / (kc + 1));
        }
      }
      if (!(da1 > epsilon)) context.moveTo(x01, y01);
      else if (rc1 > epsilon) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
      else if (rc0 > epsilon) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }
      else context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer) return context = null, buffer + "" || null;
  }
  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
    return [cos(a) * r, sin(a) * r];
  };
  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
  };
  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
  };
  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
  };
  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
  };
  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
  };
  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
  };
  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
  };
  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };
  return arc;
}

function ascending(a, b) {
  return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function descending(a, b) {
  return a == null || b == null ? NaN
    : b < a ? -1
    : b > a ? 1
    : b >= a ? 0
    : NaN;
}

function bisector(f) {
  let compare1, compare2, delta;
  if (f.length !== 2) {
    compare1 = ascending;
    compare2 = (d, x) => ascending(f(d), x);
    delta = (d, x) => f(d) - x;
  } else {
    compare1 = f === ascending || f === descending ? f : zero$1;
    compare2 = f;
    delta = f;
  }
  function left(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;
      do {
        const mid = (lo + hi) >>> 1;
        if (compare2(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function right(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;
      do {
        const mid = (lo + hi) >>> 1;
        if (compare2(a[mid], x) <= 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function center(a, x, lo = 0, hi = a.length) {
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }
  return {left, center, right};
}
function zero$1() {
  return 0;
}

function number$1(x) {
  return x === null ? NaN : +x;
}

const ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
bisector(number$1).center;
var bisect = bisectRight;

var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);
function ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;
  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
  if (step > 0) {
    let r0 = Math.round(start / step), r1 = Math.round(stop / step);
    if (r0 * step < start) ++r0;
    if (r1 * step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) * step;
  } else {
    step = -step;
    let r0 = Math.round(start * step), r1 = Math.round(stop * step);
    if (r0 / step < start) ++r0;
    if (r1 / step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) / step;
  }
  if (reverse) ticks.reverse();
  return ticks;
}
function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`),
    reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`),
    reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`),
    reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`),
    reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`),
    reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};
define(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m)
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff)
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff)
      : null)
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4])
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4])
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4])
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb$1(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define(Rgb, rgb$1, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex,
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const a = clampa(this.opacity);
  return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}
function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define(Hsl, hsl, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var constant = x => () => x;

function linear$1(a, d) {
  return function(t) {
    return a + t * d;
  };
}
function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}
function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
  };
}
function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant(isNaN(a) ? b : a);
}

var rgb = (function rgbGamma(y) {
  var color = gamma(y);
  function rgb(start, end) {
    var r = color((start = rgb$1(start)).r, (end = rgb$1(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
  rgb.gamma = rgbGamma;
  return rgb;
})(1);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}
function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;
  for (i = 0; i < na; ++i) x[i] = interpolate(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];
  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

function object(a, b) {
  var i = {},
      c = {},
      k;
  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};
  for (k in b) {
    if (k in a) {
      i[k] = interpolate(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }
  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");
function zero(b) {
  return function() {
    return b;
  };
}
function one(b) {
  return function(t) {
    return b(t) + "";
  };
}
function string(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0,
      am,
      bm,
      bs,
      i = -1,
      s = [],
      q = [];
  a = a + "", b = b + "";
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs;
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s[i]) s[i] += bm;
      else s[++i] = bm;
    } else {
      s[++i] = null;
      q.push({i: i, x: interpolateNumber(am, bm)});
    }
    bi = reB.lastIndex;
  }
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs;
    else s[++i] = bs;
  }
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

function interpolate(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant(b)
      : (t === "number" ? interpolateNumber
      : t === "string" ? ((c = color(b)) ? (b = c, rgb) : string)
      : b instanceof color ? rgb
      : b instanceof Date ? date
      : isNumberArray(b) ? numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : interpolateNumber)(a, b);
}

function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

function constants(x) {
  return function() {
    return x;
  };
}

function number(x) {
  return +x;
}

var unit = [0, 1];
function identity$1(x) {
  return x;
}
function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constants(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}
function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }
  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }
  return function(x) {
    var i = bisect(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}
function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}
function transformer() {
  var domain = unit,
      range = unit,
      interpolate$1 = interpolate,
      transform,
      untransform,
      unknown,
      clamp = identity$1,
      piecewise,
      output,
      input;
  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity$1) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate$1)))(transform(clamp(x)));
  }
  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
  };
  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number), rescale()) : domain.slice();
  };
  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };
  scale.rangeRound = function(_) {
    return range = Array.from(_), interpolate$1 = interpolateRound, rescale();
  };
  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity$1, rescale()) : clamp !== identity$1;
  };
  scale.interpolate = function(_) {
    return arguments.length ? (interpolate$1 = _, rescale()) : interpolate$1;
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}
function continuous() {
  return transformer()(identity$1, identity$1);
}

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null;
  var i, coefficient = x.slice(0, i);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;
    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;
function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0];
}

function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
};

function identity(x) {
  return x;
}

var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
function formatLocale(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "−" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;
    if (type === "n") comma = true, type = "g";
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));
    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;
      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim) value = formatTrim(value);
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }
      if (comma && !zero) value = group(value, Infinity);
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }
      return numerals(value);
    }
    format.toString = function() {
      return specifier + "";
    };
    return format;
  }
  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale;
var format;
var formatPrefix;
defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}

function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}

function linearish(scale) {
  var domain = scale.domain;
  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };
  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };
  scale.nice = function(count) {
    if (count == null) count = 10;
    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale;
  };
  return scale;
}
function linear() {
  var scale = continuous();
  scale.copy = function() {
    return copy(scale, linear());
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}

function counter(from, to, duration, toFixed) {
  var _React$useState = React__default.useState(from),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      currentValue = _React$useState2[0],
      setValue = _React$useState2[1];
  React__default.useEffect(function () {
    var controls = animate(from, to, {
      duration: duration !== null && duration !== void 0 ? duration : 1,
      onUpdate: function onUpdate(value) {
        setValue(value.toFixed(toFixed));
      }
    });
    return function () {
      return controls.stop();
    };
  }, [from, to]);
  return currentValue;
}

function CircularArcMeter(props) {
  var _props$width, _props$height, _props$height2, _props$width2, _props$height3, _props$width3;
  var size = useDimensions();
  var value = props.value,
      max = props.max;
  var min = 0;
  var duration = 1000;
  var backgroundColor = Colors.MEDIUM_WHITE;
  var _React$useState = React$4.useState(0),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      previousValue = _React$useState2[0],
      setPreviousValue = _React$useState2[1];
  var backgroundArc = arc().innerRadius(0.6).outerRadius(0.7).startAngle(-Math.PI / 1.3).endAngle(Math.PI / 1.3).cornerRadius(1)();
  var percentScale = linear().domain([min, max]).range([0, 1]);
  var percent = percentScale(counter(previousValue, value, 1, 2));
  setTimeout(function () {
    setPreviousValue(value);
  }, duration);
  var angleScale = linear().domain([0, 1]).range([-Math.PI / 1.3, Math.PI / 1.3]).clamp(true);
  var angle = angleScale(percent);
  var filledArc = arc().innerRadius(0.6).outerRadius(0.7).startAngle(-Math.PI / 1.3).endAngle(angle).cornerRadius(1)();
  var colorScale = linear().domain([0, 1]).range([Colors.MEDIUM_BLUE, Colors.BLUE]);
  var gradientSteps = colorScale.ticks(10)
  .map(function (value) {
    return colorScale(value);
  });
  return React$4.createElement("div", {
    style: {
      width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : props.size,
      height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : props.size,
      position: 'relative'
    }
  }, React$4.createElement("svg", {
    style: {
      overflow: 'visible'
    },
    height: (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : props.size,
    width: (_props$width2 = props.width) !== null && _props$width2 !== void 0 ? _props$width2 : props.size,
    viewBox: [-0.75, -0.6, 1.5, 1].join(' ')
  }, React$4.createElement("defs", null, React$4.createElement("linearGradient", {
    id: "gradient",
    gradientUnits: "userSpaceOnUse",
    x1: -1,
    x2: 1,
    y2: 0
  }, gradientSteps.map(function (color, index) {
    return React$4.createElement("stop", {
      key: color,
      stopColor: color,
      offset: "".concat(index / (gradientSteps.length - 1))
    });
  }))), React$4.createElement("path", {
    d: backgroundArc,
    fill: backgroundColor
  }), React$4.createElement("path", {
    d: filledArc,
    fill: Colors.BLUE,
    style: {
      transition: 'd .3s linear'
    }
  })), React$4.createElement("div", {
    style: {
      position: 'absolute',
      height: (_props$height3 = props.height) !== null && _props$height3 !== void 0 ? _props$height3 : props.size,
      width: (_props$width3 = props.width) !== null && _props$width3 !== void 0 ? _props$width3 : props.size,
      top: 0
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%'
    }
  }, React$4.createElement(Text, {
    fontWeight: 700,
    fontSize: size.width < Breakpoint.sm ? '3em' : '4em'
  }, counter(previousValue, value, 1, 0), "/", props.max), React$4.createElement(Text, {
    fontSize: "1.3em"
  }, props.unit))));
}

function Status(props) {
  var _props$fontSize;
  var _Lang$useTranslation = Lang.useTranslation('chargepoint'),
      _ = _Lang$useTranslation._;
  var renderBackground = function renderBackground(e) {
    switch (e) {
      case 'available':
        return Colors.GREEN;
      case 'charging':
        return Colors.BLUE;
      case 'offline':
        return Colors.GREY;
      case 'unavailable':
        return Colors.ORANGE;
      case 'error':
        return Colors.RED;
      default:
        return Colors.RED;
    }
  };
  return React$4.createElement("div", {
    style: {
      width: props.size === 'small' ? 4 : 'auto',
      height: 30,
      backgroundColor: renderBackground(props.status),
      borderRadius: 5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: props.size === 'small' ? 0 : 15,
      paddingRight: props.size === 'small' ? 0 : 15
    }
  }, props.size !== 'small' && React$4.createElement(Text, {
    fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1.1em',
    fontWeight: 500,
    color: Colors.WHITE
  }, "".concat(_("status.".concat(props.status)))));
}

var Row = React$4.forwardRef(function (props, ref) {
  var _props$height;
  return React$4.createElement("tr", {
    ref: ref,
    style: {
      width: '100%',
      height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 'auto',
      backgroundColor: 'transparent',
      borderRadius: props.styling ? 10 : 0,
      borderTop: "solid ".concat(!props.thead ? "2px ".concat(Colors.MEDIUM_WHITE) : '0px transparent'),
      borderBottom: "solid ".concat(!props.thead ? "2px ".concat(Colors.MEDIUM_WHITE) : '0px transparent')
    }
  }, props.columns.length !== 0 ? React$4.createElement(React$4.Fragment, null, React$4.Children.map(props.children, function (child, i) {
    var _props$columns, _props$columns2, _props$columns3;
    return React$4.createElement(React$4.Fragment, {
      key: child.key
    }, React$4.cloneElement(child, {
      columns: props.columns.map(function (e) {
        return {
          id: e.wrap ? e.id : null,
          wrapTitle: e.wrap ? e.wrapTitle : null,
          width: props.columns[i].width
        };
      }).filter(function (_ref) {
        var id = _ref.id;
        return id;
      }),
      wrap: child.type.name === 'Wrap',
      colspan: (child.type.name === 'Wrap' ? ((_props$columns = props.columns) === null || _props$columns === void 0 ? void 0 : _props$columns.length) === 0 || ((_props$columns2 = props.columns) === null || _props$columns2 === void 0 ? void 0 : _props$columns2.length) === i : ((_props$columns3 = props.columns) === null || _props$columns3 === void 0 ? void 0 : _props$columns3.length) === 0) ? null : child.type.name === 'Wrap' ? props.columns[i].width + props.columns[i + 1].width : i > 1 && props.columns[i - 1].wrap ? props.columns[i + 1].width : props.columns[i].width
    }));
  })) : props.children);
});

function Cell(props) {
  return props.wrap ? React$4.createElement("div", {
    style: {
      boxSizing: 'border-box',
      width: '100%',
      paddingLeft: !props.active && props.index === 1 ? 10 : 0
    }
  }, props.children) : React$4.createElement("td", {
    colSpan: props.colspan,
    style: {
      boxSizing: 'border-box'
    }
  }, props.children);
}

function ColumnTitle(props) {
  var _props$textAlign;
  return React$4.createElement(Text, {
    color: Colors.MEDIUM_GREY,
    fontSize: "1em",
    fontWeight: 500,
    textAlign: (_props$textAlign = props.textAlign) !== null && _props$textAlign !== void 0 ? _props$textAlign : 'left'
  }, props.title);
}

function Table(props) {
  var key = function key(index) {
    return new Date().getTime() + index;
  };
  return React$4.createElement("table", {
    cellSpacing: "0",
    style: {
      width: '100%',
      height: 'auto',
      borderCollapse: 'collapse'
    }
  }, React$4.createElement("colgroup", null, _toConsumableArray$5(Array(20)).map(function (e, i) {
    return React$4.createElement("col", {
      key: key(i),
      width: "5%"
    });
  })), props.thead && React$4.createElement("thead", {
    style: {
      paddingBottom: 0,
      width: '100%',
      paddingLeft: 2,
      paddingRight: 2
    }
  }, React$4.createElement(Row, {
    gap: props.gap,
    columns: [],
    thead: true
  }, props.columns.map(function (e) {
    var _e$wrapTitle;
    return React$4.createElement(Cell, {
      key: e.id,
      colspan: e.width
    }, React$4.createElement("div", {
      style: {
        paddingBottom: 7,
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: e.titleTextAlign === 'right' ? 'flex-end' : 'flex-start'
      }
    }, (!e.wrap || e.wrapTitle) && React$4.createElement(ColumnTitle, {
      title: (_e$wrapTitle = e.wrapTitle) !== null && _e$wrapTitle !== void 0 ? _e$wrapTitle : e.title,
      textAlign: e.titleTextAlign
    })));
  }))), React$4.createElement("tbody", null, React$4.Children.map(props.children, function (child) {
    return React$4.createElement(React$4.Fragment, {
      key: child.key
    }, React$4.cloneElement(child, {
      columns: props.columns
    }));
  })));
}

function Wrap(props) {
  return React$4.createElement("td", {
    colSpan: props.colspan,
    style: _objectSpread2({}, props.style)
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: props.active ? 'column' : 'row',
      width: '100%'
    }
  }, React$4.Children.map(props.children, function (child, i) {
    var _props$columns$i;
    return React$4.createElement(React$4.Fragment, {
      key: child.key
    }, React$4.cloneElement(child, {
      column: (_props$columns$i = props.columns[i]) !== null && _props$columns$i !== void 0 ? _props$columns$i : [],
      index: i,
      wrap: props.wrap,
      active: props.active,
      width: props.width,
      style: {
        minHeight: props.active ? 60 : 'auto'
      }
    }));
  })));
}

function Modal(props) {
  var size = useDimensions$1();
  var onBackgroundClick = function onBackgroundClick(e) {
    if (e.target === e.currentTarget) props.onClose();
  };
  var _onKeyDown = function onKeyDown(e) {
    if (e.key === 'Escape') {
      props.onClose();
    }
  };
  return React$4.createElement(AnimatePresence, null, props.visible && React$4.createElement("div", {
    tabIndex: 0,
    role: "button",
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown(e);
    },
    onClick: onBackgroundClick,
    style: {
      width: '100vw',
      height: '100vh',
      position: 'fixed',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'flex-start',
      zIndex: 2147483003,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }
  }, React$4.createElement(motion.div, {
    className: "Blur",
    style: {
      width: size.width < Breakpoint.sm ? '100%' : '60%',
      maxWidth: size.width < Breakpoint.sm ? '100%' : 640,
      maxHeight: '100%',
      height: '100%',
      minHeight: 120,
      borderTopLeftRadius: size.width < Breakpoint.sm ? 0 : 10,
      borderBottomLeftRadius: size.width < Breakpoint.sm ? 0 : 10,
      overflow: 'hidden',
      zIndex: 2147483004,
      borderLeft: "solid ".concat(size.width < Breakpoint.sm ? '0px transparent' : "2px ".concat(Colors.MEDIUM_WHITE)),
      boxShadow: "0px 0px 25px 0px ".concat(Colors.GREY, "25"),
      backgroundColor: Backgrounds.BLUR
    },
    initial: {
      translateX: 640
    },
    animate: {
      translateX: 0
    },
    exit: {
      translateX: 640
    },
    transition: {
      ease: 'easeInOut',
      duration: 0.3
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      flex: 'auto',
      height: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      height: size.width < Breakpoint.sm ? 60 : 120,
      borderBottom: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: size.width < Breakpoint.sm ? 'center' : 'initial',
      paddingLeft: 15,
      paddingTop: size.width < Breakpoint.sm ? 0 : 30,
      paddingBottom: size.width < Breakpoint.sm ? 0 : 30
    }
  }, props.title && React$4.createElement(Text, {
    fontWeight: size.width < Breakpoint.sm ? 300 : 700,
    fontSize: size.width < Breakpoint.sm ? '1.3em' : '2em'
  }, props.title), size.width >= Breakpoint.sm && props.subTitle && React$4.createElement("div", {
    style: {
      marginTop: 5
    }
  }, React$4.createElement(Text, {
    fontSize: "1.1em"
  }, props.subTitle))), React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      return props.onClose();
    },
    style: {
      height: 58,
      width: 58,
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      borderLeft: "solid ".concat(size.width < Breakpoint.sm ? "2px ".concat(Colors.MEDIUM_WHITE) : '0px transparent'),
      borderRight: 'solid 0px transparent',
      borderTop: 'solid 0px transparent',
      borderBottom: 'solid 0px transparent'
    }
  }, React$4.createElement(Icon, {
    name: "Times",
    height: 25,
    width: 25,
    color: Colors.GREY,
    iconSet: "Feather"
  }))), props.children))));
}

function CustomModal(props) {
  var size = useDimensions$1();
  var onBackgroundClick = function onBackgroundClick(e) {
    if (e.target === e.currentTarget) props.onClose();
  };
  var _onKeyDown = function onKeyDown(e) {
    if (e.key === 'Escape') {
      props.onClose();
    }
  };
  return React$4.createElement("div", {
    tabIndex: 0,
    role: "button",
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown(e);
    },
    onClick: onBackgroundClick,
    style: {
      width: '100vw',
      height: '100vh',
      position: 'fixed',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2147483003,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "".concat(Colors.GREY, "25")
    }
  }, React$4.createElement("div", {
    style: {
      minHeight: 300,
      maxHeight: size.width < Breakpoint.sm ? '90%' : '80%',
      height: '100%',
      width: size.width < Breakpoint.sm ? '100%' : '60%',
      maxWidth: size.width < Breakpoint.sm ? '95%' : 640,
      overflow: 'hidden',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      flex: 'auto',
      height: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      height: 60,
      maxHeight: 60,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      flex: 'auto'
    }
  }, React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      return props.onClose();
    },
    style: {
      height: 58,
      width: 58,
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-end',
      border: 'solid 0px transparent',
      marginRight: 10
    }
  }, React$4.createElement(Icon, {
    name: "Times",
    height: 25,
    width: 25,
    color: Colors.GREY,
    iconSet: "Feather"
  }))), props.children)));
}

function Boolean$1(props) {
  var _props$icon$height, _props$icon$width;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: props.subTitle ? 75 : 35,
      paddingTop: props.subTitle ? 5 : 0,
      paddingBottom: props.subTitle ? 5 : 0
    }
  }, React$4.createElement("div", {
    style: {
      height: 35,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      height: 35,
      alignItems: 'center'
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      height: 35,
      width: 35,
      marginRight: 5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: (_props$icon$height = props.icon.height) !== null && _props$icon$height !== void 0 ? _props$icon$height : 35,
    width: (_props$icon$width = props.icon.width) !== null && _props$icon$width !== void 0 ? _props$icon$width : 35,
    color: props.icon.color,
    iconSet: props.icon.iconSet
  })), React$4.createElement(Text, {
    color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY
  }, props.title)), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, !props.disabled && props.suffix && React$4.createElement("div", {
    style: {
      marginRight: 15
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.GREY
  }, props.suffix)), props.disabled && React$4.createElement("div", {
    style: {
      marginRight: 15
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.MEDIUM_GREY
  }, _('disabled', {
    ns: 'ui'
  }))), React$4.createElement(Input, {
    type: "switch",
    value: props.value,
    onClick: props.onSwitch,
    disabled: props.disabled
  }))), props.subTitle && React$4.createElement("div", {
    style: {
      height: 20,
      marginLeft: props.icon ? 40 : 0
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY
  }, props.subTitle)));
}

function Item$1(props) {
  var _props$justifyContent, _props$fontWeight, _props$fontSize, _props$color;
  return React$4.createElement("div", {
    style: {
      height: 'auto',
      paddingTop: props.justifyContent ? 0.5 : 5,
      paddingBottom: props.justifyContent ? 0.5 : 5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: (_props$justifyContent = props.justifyContent) !== null && _props$justifyContent !== void 0 ? _props$justifyContent : 'space-between'
    }
  }, props.title && React$4.createElement(Text, {
    fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : 500,
    textAlign: props.textAlign,
    fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1.25em',
    color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
  }, props.title), props.subTitle && React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.MEDIUM_GREY,
    textAlign: props.textAlign
  }, props.subTitle));
}

function Items(props) {
  var renderButtons = function renderButtons() {
    switch (props.type) {
      case 'boolean':
        return React$4.createElement(Boolean$1, {
          title: props.title,
          subTitle: props.subTitle,
          suffix: props.suffix,
          value: props.value,
          disabled: props.disabled,
          onSwitch: props.onSwitch,
          colorScheme: getColorScheme$1(props.colorScheme),
          icon: props.icon
        });
      case 'text':
        return React$4.createElement(Item$1, {
          title: props.title,
          subTitle: props.subTitle,
          textAlign: props.textAlign,
          justifyContent: props.justifyContent,
          fontWeight: props.fontWeight,
          fontSize: props.fontSize,
          color: props.color
        });
      default:
        return React$4.createElement(Boolean$1, {
          title: props.title,
          subTitle: props.subTitle,
          suffix: props.suffix,
          value: props.value,
          onSwitch: props.onSwitch,
          disabled: props.disabled,
          colorScheme: getColorScheme$1(props.colorScheme),
          icon: props.icon
        });
    }
  };
  return React$4.createElement(React$4.Fragment, null, renderButtons());
}

function AppStore$2(props) {
  var _props$width, _props$height;
  return React$4.createElement("svg", {
    id: "livetype",
    xmlns: "http://www.w3.org/2000/svg",
    className: "Badge",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 119.66407,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40,
    viewBox: "0 0 119.66407 40"
  }, React$4.createElement("title", null, "Download on the App Store Badge"), React$4.createElement("g", null, React$4.createElement("g", null, React$4.createElement("g", null, React$4.createElement("path", {
    d: "M110.13477,0H9.53468c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.91895.0127A13.21476,13.21476,0,0,0,5.5171.19141a6.66509,6.66509,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232,12.99232,0,0,0,.1792,2.0019,6.58756,6.58756,0,0,0,.625,1.9043A6.20778,6.20778,0,0,0,1.99757,38.001a6.27445,6.27445,0,0,0,1.61865,1.1787,6.70082,6.70082,0,0,0,1.90088.6308,13.45514,13.45514,0,0,0,2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.279,13.279,0,0,0,2-.1768,6.80432,6.80432,0,0,0,1.9082-.6308,6.27742,6.27742,0,0,0,1.6172-1.1787,6.39482,6.39482,0,0,0,1.1816-1.6143,6.60413,6.60413,0,0,0,.6191-1.9043,13.50643,13.50643,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.5071,13.5071,0,0,0-.1856-2.002,6.6177,6.6177,0,0,0-.6191-1.90332,6.46619,6.46619,0,0,0-2.7988-2.7998,6.76754,6.76754,0,0,0-1.9082-.627,13.04394,13.04394,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002Z",
    style: {
      fill: '#a6a6a6'
    }
  }), React$4.createElement("path", {
    d: "M8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.68714,12.68714,0,0,1-1.86914-.1631,5.88381,5.88381,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.32082,5.32082,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41351,12.41351,0,0,1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434S.88185,7.75293.8877,7.5498a12.37039,12.37039,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621A5.37349,5.37349,0,0,1,2.61183,2.61768,5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58589,12.58589,0,0,1,7.543.88721L8.44532.875H111.21387l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59374,5.59374,0,0,1,2.415,2.41993,5.76267,5.76267,0,0,1,.5352,1.64892,12.995,12.995,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73126,12.73126,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48029,5.48029,0,0,1-1.0156,1.3857,5.4129,5.4129,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54218,12.54218,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002Z"
  })), React$4.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, React$4.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, React$4.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, React$4.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M24.76888,20.30068a4.94881,4.94881,0,0,1,2.35656-4.15206,5.06566,5.06566,0,0,0-3.99116-2.15768c-1.67924-.17626-3.30719,1.00483-4.1629,1.00483-.87227,0-2.18977-.98733-3.6085-.95814a5.31529,5.31529,0,0,0-4.47292,2.72787c-1.934,3.34842-.49141,8.26947,1.3612,10.97608.9269,1.32535,2.01018,2.8058,3.42763,2.7533,1.38706-.05753,1.9051-.88448,3.5794-.88448,1.65876,0,2.14479.88448,3.591.8511,1.48838-.02416,2.42613-1.33124,3.32051-2.66914a10.962,10.962,0,0,0,1.51842-3.09251A4.78205,4.78205,0,0,1,24.76888,20.30068Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M22.03725,12.21089a4.87248,4.87248,0,0,0,1.11452-3.49062,4.95746,4.95746,0,0,0-3.20758,1.65961,4.63634,4.63634,0,0,0-1.14371,3.36139A4.09905,4.09905,0,0,0,22.03725,12.21089Z",
    style: {
      fill: '#ffffff'
    }
  }))), React$4.createElement("g", null, React$4.createElement("path", {
    d: "M42.30227,27.13965h-4.7334l-1.13672,3.35645H34.42727l4.4834-12.418h2.083l4.4834,12.418H43.438ZM38.0591,25.59082h3.752l-1.84961-5.44727h-.05176Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M55.15969,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H48.4302v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C53.645,21.34766,55.15969,23.16406,55.15969,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C52.30227,29.01563,53.24953,27.81934,53.24953,25.96973Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M65.12453,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H58.395v1.50586h.03418A3.21162,3.21162,0,0,1,61.312,21.34766C63.60988,21.34766,65.12453,23.16406,65.12453,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C62.26711,29.01563,63.21438,27.81934,63.21438,25.96973Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M71.71047,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51855-3.61426,2.624,0,4.42285,1.47168,4.4834,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60645,1.626,3.60645,3.44238,0,2.32324-1.85059,3.77832-4.79395,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M83.34621,19.2998v2.14258h1.72168v1.47168H83.34621v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80752,5.80752,0,0,0,.61133-.043v1.46289a5.10351,5.10351,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H80.16262V21.44238H81.479V19.2998Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M86.065,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C87.72609,30.6084,86.065,28.82617,86.065,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039,1.16211-2.40039,3.10742c0,1.96191.89453,3.10645,2.40039,3.10645S92.76027,27.93164,92.76027,25.96973Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M96.18606,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59794,2.59794,0,0,0-.835-.1123,1.87264,1.87264,0,0,0-1.93652,2.083v5.37012h-1.8584Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M109.3843,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672h-6.39453v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344Zm-6.28223-2.70215h4.52637a2.1773,2.1773,0,0,0-2.2207-2.29785A2.292,2.292,0,0,0,103.10207,25.13477Z",
    style: {
      fill: '#ffffff'
    }
  })))), React$4.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>"
  }, React$4.createElement("g", null, React$4.createElement("path", {
    d: "M37.82619,8.731a2.63964,2.63964,0,0,1,2.80762,2.96484c0,1.90625-1.03027,3.002-2.80762,3.002H35.67092V8.731Zm-1.22852,5.123h1.125a1.87588,1.87588,0,0,0,1.96777-2.146,1.881,1.881,0,0,0-1.96777-2.13379h-1.125Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M41.68068,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C44.57522,13.99463,45.01369,13.42432,45.01369,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M51.57326,14.69775h-.92187l-.93066-3.31641h-.07031l-.92676,3.31641h-.91309l-1.24121-4.50293h.90137l.80664,3.436h.06641l.92578-3.436h.85254l.92578,3.436h.07031l.80273-3.436h.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M53.85354,10.19482H54.709v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M59.09377,8.437h.88867v6.26074h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M61.21779,12.44434a2.13346,2.13346,0,1,1,4.24756,0,2.1338,2.1338,0,1,1-4.24756,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C64.11232,13.99463,64.5508,13.42432,64.5508,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M66.4009,13.42432c0-.81055.60352-1.27783,1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609,0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953,1.83984-1.26953,1.12891,0,1.76563.562,1.76563,1.51318v3.07666h-.85547v-.63281h-.07031a1.515,1.515,0,0,1-1.35254.707A1.36026,1.36026,0,0,1,66.4009,13.42432Zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941,0,.40527.35156.64111.835.64111A1.0615,1.0615,0,0,0,69.29543,13.03955Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M71.34816,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C72.0718,14.772,71.34816,13.87061,71.34816,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C72.72121,10.91846,72.26613,11.49707,72.26613,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M79.23,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C82.12453,13.99463,82.563,13.42432,82.563,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M84.66945,10.19482h.85547v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915H87.605V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M93.51516,9.07373v1.1416h.97559v.74854h-.97559V13.2793c0,.47168.19434.67822.63672.67822a2.96657,2.96657,0,0,0,.33887-.02051v.74023a2.9155,2.9155,0,0,1-.4834.04541c-.98828,0-1.38184-.34766-1.38184-1.21582v-2.543h-.71484v-.74854h.71484V9.07373Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M95.70461,8.437h.88086v2.48145h.07031a1.3856,1.3856,0,0,1,1.373-.80664,1.48339,1.48339,0,0,1,1.55078,1.67871v2.90723H98.69v-2.688c0-.71924-.335-1.0835-.96289-1.0835a1.05194,1.05194,0,0,0-1.13379,1.1416v2.62988h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M104.76125,13.48193a1.828,1.828,0,0,1-1.95117,1.30273A2.04531,2.04531,0,0,1,100.73,12.46045a2.07685,2.07685,0,0,1,2.07617-2.35254c1.25293,0,2.00879.856,2.00879,2.27V12.688h-3.17969v.0498a1.1902,1.1902,0,0,0,1.19922,1.29,1.07934,1.07934,0,0,0,1.07129-.5459Zm-3.126-1.45117h2.27441a1.08647,1.08647,0,0,0-1.1084-1.1665A1.15162,1.15162,0,0,0,101.63527,12.03076Z",
    style: {
      fill: '#ffffff'
    }
  })))));
}

function AppStore$1(props) {
  var _props$width, _props$height;
  return React$4.createElement("svg", {
    id: "livetype",
    xmlns: "http://www.w3.org/2000/svg",
    className: "Badge",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 119.66407,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40,
    viewBox: "0 0 119.66407 40"
  }, React$4.createElement("title", null, "Download on the App Store"), React$4.createElement("g", null, React$4.createElement("g", null, React$4.createElement("g", null, React$4.createElement("path", {
    d: "M110.13477,0H9.53468c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.91895.0127A13.21476,13.21476,0,0,0,5.5171.19141a6.66509,6.66509,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232,12.99232,0,0,0,.1792,2.0019,6.58756,6.58756,0,0,0,.625,1.9043A6.20778,6.20778,0,0,0,1.99757,38.001a6.27445,6.27445,0,0,0,1.61865,1.1787,6.70082,6.70082,0,0,0,1.90088.6308,13.45514,13.45514,0,0,0,2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.279,13.279,0,0,0,2-.1768,6.80432,6.80432,0,0,0,1.9082-.6308,6.27742,6.27742,0,0,0,1.6172-1.1787,6.39482,6.39482,0,0,0,1.1816-1.6143,6.60413,6.60413,0,0,0,.6191-1.9043,13.50643,13.50643,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.5071,13.5071,0,0,0-.1856-2.002,6.6177,6.6177,0,0,0-.6191-1.90332,6.46619,6.46619,0,0,0-2.7988-2.7998,6.76754,6.76754,0,0,0-1.9082-.627,13.04394,13.04394,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002Z",
    style: {
      fill: '#a6a6a6'
    }
  }), React$4.createElement("path", {
    d: "M8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.68714,12.68714,0,0,1-1.86914-.1631,5.88381,5.88381,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.32082,5.32082,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41351,12.41351,0,0,1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434S.88185,7.75293.8877,7.5498a12.37039,12.37039,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621A5.37349,5.37349,0,0,1,2.61183,2.61768,5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58589,12.58589,0,0,1,7.543.88721L8.44532.875H111.21387l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59374,5.59374,0,0,1,2.415,2.41993,5.76267,5.76267,0,0,1,.5352,1.64892,12.995,12.995,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73126,12.73126,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48029,5.48029,0,0,1-1.0156,1.3857,5.4129,5.4129,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54218,12.54218,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002Z"
  })), React$4.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, React$4.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, React$4.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, React$4.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M24.76888,20.30068a4.94881,4.94881,0,0,1,2.35656-4.15206,5.06566,5.06566,0,0,0-3.99116-2.15768c-1.67924-.17626-3.30719,1.00483-4.1629,1.00483-.87227,0-2.18977-.98733-3.6085-.95814a5.31529,5.31529,0,0,0-4.47292,2.72787c-1.934,3.34842-.49141,8.26947,1.3612,10.97608.9269,1.32535,2.01018,2.8058,3.42763,2.7533,1.38706-.05753,1.9051-.88448,3.5794-.88448,1.65876,0,2.14479.88448,3.591.8511,1.48838-.02416,2.42613-1.33124,3.32051-2.66914a10.962,10.962,0,0,0,1.51842-3.09251A4.78205,4.78205,0,0,1,24.76888,20.30068Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M22.03725,12.21089a4.87248,4.87248,0,0,0,1.11452-3.49062,4.95746,4.95746,0,0,0-3.20758,1.65961,4.63634,4.63634,0,0,0-1.14371,3.36139A4.09905,4.09905,0,0,0,22.03725,12.21089Z",
    style: {
      fill: '#ffffff'
    }
  }))), React$4.createElement("g", null, React$4.createElement("path", {
    d: "M42.30227,27.13965h-4.7334l-1.13672,3.35645H34.42727l4.4834-12.418h2.083l4.4834,12.418H43.438ZM38.0591,25.59082h3.752l-1.84961-5.44727h-.05176Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M55.15969,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H48.4302v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C53.645,21.34766,55.15969,23.16406,55.15969,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C52.30227,29.01563,53.24953,27.81934,53.24953,25.96973Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M65.12453,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H58.395v1.50586h.03418A3.21162,3.21162,0,0,1,61.312,21.34766C63.60988,21.34766,65.12453,23.16406,65.12453,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C62.26711,29.01563,63.21438,27.81934,63.21438,25.96973Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M71.71047,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51855-3.61426,2.624,0,4.42285,1.47168,4.4834,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60645,1.626,3.60645,3.44238,0,2.32324-1.85059,3.77832-4.79395,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M83.34621,19.2998v2.14258h1.72168v1.47168H83.34621v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80752,5.80752,0,0,0,.61133-.043v1.46289a5.10351,5.10351,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H80.16262V21.44238H81.479V19.2998Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M86.065,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C87.72609,30.6084,86.065,28.82617,86.065,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039,1.16211-2.40039,3.10742c0,1.96191.89453,3.10645,2.40039,3.10645S92.76027,27.93164,92.76027,25.96973Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M96.18606,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59794,2.59794,0,0,0-.835-.1123,1.87264,1.87264,0,0,0-1.93652,2.083v5.37012h-1.8584Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M109.3843,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672h-6.39453v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344Zm-6.28223-2.70215h4.52637a2.1773,2.1773,0,0,0-2.2207-2.29785A2.292,2.292,0,0,0,103.10207,25.13477Z",
    style: {
      fill: '#ffffff'
    }
  })))), React$4.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>"
  }, React$4.createElement("g", null, React$4.createElement("path", {
    d: "M37.82619,8.731a2.63964,2.63964,0,0,1,2.80762,2.96484c0,1.90625-1.03027,3.002-2.80762,3.002H35.67092V8.731Zm-1.22852,5.123h1.125a1.87588,1.87588,0,0,0,1.96777-2.146,1.881,1.881,0,0,0-1.96777-2.13379h-1.125Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M41.68068,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C44.57522,13.99463,45.01369,13.42432,45.01369,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M51.57326,14.69775h-.92187l-.93066-3.31641h-.07031l-.92676,3.31641h-.91309l-1.24121-4.50293h.90137l.80664,3.436h.06641l.92578-3.436h.85254l.92578,3.436h.07031l.80273-3.436h.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M53.85354,10.19482H54.709v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M59.09377,8.437h.88867v6.26074h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M61.21779,12.44434a2.13346,2.13346,0,1,1,4.24756,0,2.1338,2.1338,0,1,1-4.24756,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C64.11232,13.99463,64.5508,13.42432,64.5508,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M66.4009,13.42432c0-.81055.60352-1.27783,1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609,0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953,1.83984-1.26953,1.12891,0,1.76563.562,1.76563,1.51318v3.07666h-.85547v-.63281h-.07031a1.515,1.515,0,0,1-1.35254.707A1.36026,1.36026,0,0,1,66.4009,13.42432Zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941,0,.40527.35156.64111.835.64111A1.0615,1.0615,0,0,0,69.29543,13.03955Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M71.34816,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C72.0718,14.772,71.34816,13.87061,71.34816,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C72.72121,10.91846,72.26613,11.49707,72.26613,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M79.33742,8.86328a.57572.57572,0,1,1,.5752.5415A.54735.54735,0,0,1,79.33742,8.86328Zm.13184,1.33154H80.355v4.50293h-.88574Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M81.78859,10.19482h.85547v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M89.20754,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C89.93117,14.772,89.20754,13.87061,89.20754,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C90.58059,10.91846,90.12551,11.49707,90.12551,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M98.67824,13.48193a1.828,1.828,0,0,1-1.95117,1.30273A2.04531,2.04531,0,0,1,94.647,12.46045a2.07685,2.07685,0,0,1,2.07617-2.35254c1.25293,0,2.00879.856,2.00879,2.27V12.688H95.55227v.0498a1.1902,1.1902,0,0,0,1.19922,1.29,1.07934,1.07934,0,0,0,1.07129-.5459Zm-3.126-1.45117h2.27441a1.08647,1.08647,0,0,0-1.1084-1.1665A1.15162,1.15162,0,0,0,95.55227,12.03076Z",
    style: {
      fill: '#ffffff'
    }
  })))));
}

function AppStore(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      i18n = _Lang$useTranslation.i18n;
  var svg = function svg() {
    var _props$width, _props$height, _props$width2, _props$height2, _props$width3, _props$height3;
    switch (i18n.language) {
      case 'en':
        return React$4.createElement(AppStore$2, {
          width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 119.66407,
          height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40
        });
      case 'nl':
        return React$4.createElement(AppStore$1, {
          width: (_props$width2 = props.width) !== null && _props$width2 !== void 0 ? _props$width2 : 119.66407,
          height: (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : 40
        });
      default:
        return React$4.createElement(AppStore$2, {
          width: (_props$width3 = props.width) !== null && _props$width3 !== void 0 ? _props$width3 : 119.66407,
          height: (_props$height3 = props.height) !== null && _props$height3 !== void 0 ? _props$height3 : 40
        });
    }
  };
  return props.interactive ? React$4.createElement("a", {
    className: "Hover",
    target: "_blank",
    href: "https://apps.apple.com/nl/app/bluecurrent/id1447733712",
    rel: "noreferrer"
  }, svg()) : svg();
}

function PlayStore(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._,
      i18n = _Lang$useTranslation.i18n;
  var url = function url() {
    switch (i18n.language) {
      case 'en':
        return 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png';
      case 'nl':
        return 'https://play.google.com/intl/en_us/badges/static/images/badges/nl_badge_web_generic.png';
      default:
        return 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png';
    }
  };
  return props.interactive ? React$4.createElement("a", {
    className: "Hover",
    target: "_blank",
    href: "https://play.google.com/store/apps/details?id=com.bluecurrent.bcuweb",
    rel: "noreferrer"
  }, React$4.createElement("img", {
    className: "Badge",
    alt: _('getOnPlayStore', {
      ns: 'ui'
    }),
    src: url(),
    style: {
      height: '100%',
      width: 'auto',
      marginLeft: -10
    }
  })) : React$4.createElement(React$4.Fragment, null, React$4.createElement("img", {
    className: "Badge",
    alt: _('getOnPlayStore', {
      ns: 'ui'
    }),
    src: url(),
    style: {
      height: '100%',
      width: 'auto',
      marginLeft: -10
    }
  }));
}

function Badge(props) {
  var render = function render() {
    switch (props.store) {
      case 'AppStore':
        return React$4.createElement(AppStore, {
          width: props.width,
          height: props.height,
          interactive: props.interactive
        });
      case 'PlayStore':
        return React$4.createElement(PlayStore, {
          interactive: props.interactive
        });
      default:
        return React$4.createElement("div", null);
    }
  };
  return render();
}

function Toast(props) {
  var icon = function icon(e) {
    switch (e) {
      case 'success':
        return {
          name: 'Check',
          height: 15,
          width: 15,
          color: Colors.GREEN,
          iconSet: 'FA'
        };
      case 'failed':
        return {
          name: 'Times',
          height: 18,
          width: 18,
          color: Colors.RED,
          iconSet: 'Feather'
        };
      case 'info':
        return {
          name: 'Info',
          height: 15,
          width: 15,
          color: Colors.BLUE,
          iconSet: 'FA'
        };
      default:
        return {
          name: false,
          color: false,
          iconSet: false
        };
    }
  };
  return React$4.createElement(AnimatePresence, null, props.visible && React$4.createElement(motion.div, {
    className: props.colorScheme === 'white' ? 'Blur' : '',
    style: {
      position: 'relative',
      height: 'auto',
      width: 400,
      backgroundColor: props.colorScheme === 'white' ? Colors.WHITE : getColorScheme(props.colorScheme).delicate,
      border: "solid 2px ".concat(props.colorScheme === 'white' ? Colors.MEDIUM_WHITE : getColorScheme(props.colorScheme).vibrant),
      borderRadius: 10,
      padding: 15,
      marginTop: 10,
      overflow: 'hidden',
      zIndex: 2147483005
    },
    initial: {
      marginRight: -450
    },
    animate: {
      marginRight: 15
    },
    exit: {
      marginRight: -450
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  }, props.type && React$4.createElement("div", {
    style: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingRight: 15
    }
  }, React$4.createElement("div", {
    style: {
      height: 25,
      width: 25,
      backgroundColor: icon(props.type).color,
      borderRadius: 25,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Icon, {
    name: icon(props.type).name,
    height: icon(props.type).height,
    width: icon(props.type).width,
    color: Colors.WHITE,
    iconSet: icon(props.type).iconSet
  }))), React$4.createElement(Text, {
    animate: true
  }, props.text))));
}

function ItemMenu(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      dropdownMenu = _React$useState4[0],
      setDropdownMenu = _React$useState4[1];
  return React$4.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'flex-end'
    }
  }, React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      setDropdownMenu(!dropdownMenu);
    },
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      border: 'solid 0px transparent',
      backgroundColor: 'transparent',
      height: 60,
      width: 60,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }
  }, React$4.createElement("div", {
    style: {
      width: dropdownMenu ? 30 : 35,
      height: dropdownMenu ? 30 : 35,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      transform: "rotate(".concat(dropdownMenu ? 180 : 0, "deg)")
    }
  }, React$4.createElement(Icon, {
    name: dropdownMenu ? 'AngleDown' : 'Ellipsis-H',
    height: dropdownMenu ? 30 : 35,
    width: dropdownMenu ? 30 : 35,
    color: hover || dropdownMenu ? Colors.GREY : Colors.MEDIUM_GREY
  }))), dropdownMenu && props.items && React$4.createElement("div", {
    style: {
      position: 'absolute',
      top: -20,
      right: 240
    }
  }, React$4.createElement(DropdownMenu, {
    items: props.items,
    onClose: function onClose() {
      setDropdownMenu(false);
    },
    right: props.right
  })));
}

function WrapperFigure(props) {
  var _props$width, _props$height;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : '100%',
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : '100%',
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2
    }
  }, React$4.createElement("path", {
    d: "M378.463 137.923c8.209 0 12.501 4.204 14.472 7.899a32.2 32.2 0 0 1 3.81 15.194c0 17.704-14.325 32.061-32 32.061-17.676 0-32-14.357-32-32.061a32.122 32.122 0 0 1 3.816-15.194c1.964-3.695 6.256-7.899 14.465-7.899h27.437Z",
    fill: "url(#".concat(props.id, ")"),
    transform: "translate(-1709.35 -716.352) scale(5.23476)"
  }), React$4.createElement("defs", null, React$4.createElement("pattern", {
    id: props.id,
    patternUnits: "objectBoundingBox",
    width: "100%",
    height: "100%"
  }, React$4.createElement("image", {
    width: "100%",
    height: "100%",
    href: props.src,
    xlinkHref: props.src,
    x: "0",
    y: "0",
    transform: "translate(-7 0) scale(0.2)"
  }))));
}

function C(props) {
  var _props$width, _props$height, _props$position, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$color;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 54,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 47,
    viewBox: "0 0 54 47",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      zIndex: 1.1,
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1
    }
  }, React__default.createElement("path", {
    d: "M48.263 29.437v6.346a4.782 4.782 0 0 1-4.775 4.775h-32.98a4.782 4.782 0 0 1-4.775-4.775V11.22a4.782 4.782 0 0 1 4.775-4.775h32.98a4.782 4.782 0 0 1 4.775 4.775v5.292h5.735V11.22c0-5.79-4.71-10.512-10.51-10.512h-32.98c-5.79 0-10.51 4.722-10.51 10.512v24.564c0 5.8 4.72 10.51 10.51 10.51h32.98c5.8 0 10.51-4.71 10.51-10.51v-6.346h-5.735Z",
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.BLUE,
    fillRule: "nonzero"
  }));
}

function DotsPath(props) {
  var _props$width, _props$height, _props$position, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$color;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 491,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 274,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491 274",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1
    }
  }, React__default.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : '#FFFFFF',
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M171.175 151.982a2.805 2.805 0 0 1 3.807-1.097 2.8 2.8 0 1 1-2.703 4.904 2.797 2.797 0 0 1-1.104-3.807M184.848 151.673a2.796 2.796 0 0 1 3.8-1.098 2.791 2.791 0 0 1 1.107 3.807 2.802 2.802 0 0 1-3.81 1.097 2.8 2.8 0 0 1-1.097-3.806M198.491 150.417a2.808 2.808 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.806 2.8 2.8 0 0 1-3.804 1.104 2.803 2.803 0 0 1-1.103-3.807M204.483 162.36a2.794 2.794 0 0 1 4.895 2.697 2.79 2.79 0 0 1-3.797 1.101 2.792 2.792 0 0 1-1.098-3.797M191.109 164.843a2.801 2.801 0 0 1 3.806-1.097 2.795 2.795 0 0 1 1.107 3.806 2.807 2.807 0 0 1-3.81 1.104 2.803 2.803 0 0 1-1.103-3.813M176.817 166.023a2.76 2.76 0 1 1 4.835 2.664 2.761 2.761 0 0 1-4.835-2.664M161.878 163.984a2.73 2.73 0 0 1 3.714-1.079 2.74 2.74 0 0 1 1.076 3.72 2.746 2.746 0 0 1-3.717 1.073 2.732 2.732 0 0 1-1.073-3.714M157.456 150.078a2.801 2.801 0 0 1 3.807-1.097 2.802 2.802 0 0 1 1.106 3.807 2.805 2.805 0 0 1-3.81 1.097 2.802 2.802 0 0 1-1.103-3.807M164.517 138.036a2.798 2.798 0 0 1 3.807-1.104 2.802 2.802 0 1 1-2.703 4.91 2.805 2.805 0 0 1-1.104-3.806M171.362 125.829a2.8 2.8 0 1 1 4.907 2.703 2.801 2.801 0 1 1-4.907-2.703M178.628 138.579a2.803 2.803 0 0 1 3.806-1.098 2.807 2.807 0 0 1 1.107 3.807 2.814 2.814 0 0 1-3.816 1.103 2.807 2.807 0 0 1-1.097-3.812M192.65 137.913a2.801 2.801 0 0 1 3.807-1.098 2.8 2.8 0 1 1-2.703 4.904 2.802 2.802 0 0 1-1.103-3.806M186.477 126.08a2.805 2.805 0 0 1 3.813-1.103 2.798 2.798 0 0 1 1.1 3.806 2.812 2.812 0 0 1-3.81 1.104 2.803 2.803 0 0 1-1.103-3.807M200.99 124.468a2.808 2.808 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.806 2.801 2.801 0 1 1-4.907-2.703M213.77 125.613a2.801 2.801 0 0 1 3.806-1.097 2.801 2.801 0 0 1 1.107 3.8 2.802 2.802 0 0 1-3.81 1.104 2.798 2.798 0 0 1-1.103-3.807M206.3 137.557a2.808 2.808 0 0 1 3.806-1.104 2.8 2.8 0 0 1 1.1 3.807 2.8 2.8 0 0 1-3.803 1.103 2.803 2.803 0 0 1-1.104-3.806M212.531 149.886a2.803 2.803 0 0 1 3.807-1.104 2.802 2.802 0 1 1-2.703 4.91 2.803 2.803 0 0 1-1.104-3.806M218.413 161.543a2.617 2.617 0 1 1 4.584 2.53 2.602 2.602 0 0 1-3.55 1.026 2.61 2.61 0 0 1-1.034-3.556M227.518 152.461a2.806 2.806 0 0 1 4.913 2.71 2.802 2.802 0 0 1-3.81 1.103 2.809 2.809 0 0 1-1.103-3.813M234.112 139.174a2.801 2.801 0 0 1 3.806-1.097 2.795 2.795 0 0 1 1.107 3.807 2.807 2.807 0 0 1-3.81 1.103 2.809 2.809 0 0 1-1.103-3.813M220.48 138.836a2.801 2.801 0 0 1 3.807-1.098 2.802 2.802 0 0 1 1.106 3.807 2.805 2.805 0 0 1-3.81 1.097 2.802 2.802 0 0 1-1.103-3.806M227.985 126.775a2.8 2.8 0 0 1 3.807-1.11 2.802 2.802 0 1 1-2.704 4.91 2.798 2.798 0 0 1-1.103-3.8M241.64 125.94a2.807 2.807 0 0 1 3.812-1.097 2.8 2.8 0 0 1 1.1 3.806 2.807 2.807 0 0 1-3.809 1.104 2.81 2.81 0 0 1-1.103-3.813M247.346 138.69a2.8 2.8 0 0 1 3.807-1.098 2.798 2.798 0 0 1 1.1 3.8 2.809 2.809 0 0 1-3.81 1.11 2.808 2.808 0 0 1-1.097-3.812M240.402 151.539a2.801 2.801 0 0 1 3.806-1.098 2.802 2.802 0 0 1 1.107 3.807 2.812 2.812 0 0 1-3.816 1.103 2.812 2.812 0 0 1-1.097-3.812M253.38 151.702a2.801 2.801 0 0 1 3.806-1.097 2.793 2.793 0 0 1 1.1 3.8 2.795 2.795 0 0 1-3.803 1.104 2.798 2.798 0 0 1-1.104-3.807M266.064 154.02a2.803 2.803 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.807 2.801 2.801 0 1 1-4.907-2.703M260.47 139.77a2.802 2.802 0 0 1 3.806-1.103 2.809 2.809 0 0 1 1.106 3.812 2.81 2.81 0 0 1-3.815 1.098 2.8 2.8 0 0 1-1.098-3.807M272.822 142.083a2.803 2.803 0 1 1 4.913 2.7 2.803 2.803 0 0 1-4.913-2.7M284.327 137.422a2.801 2.801 0 0 1 3.807-1.097 2.793 2.793 0 0 1 1.1 3.8 2.798 2.798 0 0 1-3.803 1.104 2.798 2.798 0 0 1-1.104-3.807M297.988 133.252a2.808 2.808 0 0 1 3.806-1.103 2.8 2.8 0 0 1 1.107 3.806 2.8 2.8 0 0 1-3.81 1.104 2.803 2.803 0 0 1-1.103-3.807M307.257 144.577a2.798 2.798 0 0 1 3.806-1.103 2.8 2.8 0 0 1 1.107 3.806 2.81 2.81 0 0 1-3.81 1.098 2.793 2.793 0 0 1-1.103-3.801M300.622 156.252a2.803 2.803 0 0 1 3.807-1.104 2.807 2.807 0 0 1 1.106 3.813 2.805 2.805 0 0 1-3.81 1.098 2.803 2.803 0 0 1-1.103-3.807M293.304 146.726a2.798 2.798 0 0 1 3.807-1.103 2.802 2.802 0 0 1 1.106 3.806 2.807 2.807 0 0 1-3.816 1.104 2.801 2.801 0 0 1-1.097-3.807M281.284 152.058a2.799 2.799 0 0 1 3.807-1.11 2.809 2.809 0 0 1 1.106 3.814 2.81 2.81 0 0 1-3.815 1.097 2.794 2.794 0 0 1-1.098-3.8M289.28 163.529a2.808 2.808 0 0 1 3.806-1.104 2.802 2.802 0 0 1 1.107 3.807 2.807 2.807 0 0 1-3.816 1.103 2.806 2.806 0 0 1-1.097-3.806M303.443 168.365a2.796 2.796 0 0 1 3.8-1.104 2.796 2.796 0 0 1 1.107 3.807 2.798 2.798 0 0 1-3.81 1.097 2.793 2.793 0 0 1-1.097-3.8M306.883 180.992a2.8 2.8 0 0 1 3.806-1.098 2.8 2.8 0 0 1 1.107 3.807 2.814 2.814 0 0 1-3.816 1.103 2.807 2.807 0 0 1-1.097-3.812M309.81 193.63a2.808 2.808 0 0 1 3.806-1.103 2.796 2.796 0 0 1 1.106 3.807 2.807 2.807 0 0 1-3.81 1.103 2.808 2.808 0 0 1-1.103-3.807M293.234 177.704a2.802 2.802 0 1 1 4.907 2.703 2.8 2.8 0 0 1-3.804 1.103 2.798 2.798 0 0 1-1.103-3.806M274.574 163.75a2.794 2.794 0 0 1 3.8-1.097 2.792 2.792 0 0 1 1.101 3.795 2.792 2.792 0 0 1-3.798 1.1 2.799 2.799 0 0 1-1.103-3.797M280.56 175.134a2.794 2.794 0 0 1 3.792-1.098 2.792 2.792 0 0 1-2.694 4.89 2.794 2.794 0 0 1-1.098-3.792M282.692 188.806a2.658 2.658 0 0 1 4.656 2.563 2.667 2.667 0 0 1-3.615 1.046 2.662 2.662 0 0 1-1.041-3.609M296.096 191.218a2.8 2.8 0 0 1 3.806-1.097 2.807 2.807 0 0 1 1.107 3.806 2.808 2.808 0 0 1-3.81 1.104 2.798 2.798 0 0 1-1.103-3.813M299.074 204.68a2.803 2.803 0 0 1 3.807-1.103 2.807 2.807 0 0 1 1.106 3.813 2.812 2.812 0 0 1-3.815 1.097 2.8 2.8 0 0 1-1.098-3.807M285.694 202.21a2.765 2.765 0 0 1 4.841 2.67 2.77 2.77 0 0 1-3.756 1.086 2.767 2.767 0 0 1-1.085-3.756M289.549 216.507a2.715 2.715 0 0 1 3.69-1.068 2.715 2.715 0 0 1 1.07 3.69 2.718 2.718 0 0 1-4.76-2.622M302.251 218.359a2.798 2.798 0 0 1 3.807-1.104 2.807 2.807 0 0 1 1.106 3.813 2.815 2.815 0 0 1-3.815 1.097 2.801 2.801 0 0 1-1.098-3.806M314.668 218.084a2.798 2.798 0 0 1 3.807-1.103 2.796 2.796 0 0 1 1.106 3.806 2.803 2.803 0 0 1-4.913-2.703M312.274 206.053a2.798 2.798 0 0 1 3.806-1.104 2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.103-3.806M323.662 197.356a2.802 2.802 0 0 1 3.801-1.103 2.805 2.805 0 0 1 1.112 3.807 2.808 2.808 0 0 1-3.815 1.103 2.8 2.8 0 0 1-1.098-3.807M333.69 188.45a2.803 2.803 0 0 1 3.807-1.104 2.802 2.802 0 1 1-2.703 4.91 2.808 2.808 0 0 1-1.104-3.806M320.66 183.836a2.803 2.803 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.806 2.795 2.795 0 0 1-3.803 1.104 2.798 2.798 0 0 1-1.104-3.807M317.261 170.613a2.803 2.803 0 1 1 4.907 2.71 2.805 2.805 0 0 1-3.81 1.103 2.812 2.812 0 0 1-1.097-3.813M330.998 173.75a2.809 2.809 0 0 1 3.813-1.104 2.81 2.81 0 0 1 1.1 3.813 2.805 2.805 0 0 1-3.81 1.097 2.803 2.803 0 0 1-1.103-3.806M326.834 160.042a2.803 2.803 0 0 1 3.806-1.103 2.809 2.809 0 0 1 1.107 3.812 2.805 2.805 0 0 1-3.81 1.098 2.798 2.798 0 0 1-1.103-3.807M313.64 157.379a2.803 2.803 0 0 1 3.807-1.103 2.807 2.807 0 0 1 1.106 3.812 2.812 2.812 0 0 1-3.815 1.104 2.813 2.813 0 0 1-1.098-3.813M322.126 146.306a2.798 2.798 0 0 1 3.807-1.104 2.796 2.796 0 0 1 1.106 3.807 2.803 2.803 0 0 1-4.913-2.703M314.277 134.496a2.803 2.803 0 0 1 3.812-1.103 2.798 2.798 0 0 1 1.1 3.807 2.812 2.812 0 0 1-3.809 1.103 2.81 2.81 0 0 1-1.103-3.807M306.912 123.557a2.788 2.788 0 0 1 3.786-1.097 2.784 2.784 0 0 1 1.097 3.783 2.787 2.787 0 1 1-4.883-2.685M295.278 118.073a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.704 4.91 2.798 2.798 0 0 1-1.103-3.807M284.134 110.253a2.798 2.798 0 0 1 3.807-1.104 2.8 2.8 0 0 1 1.107 3.807 2.803 2.803 0 0 1-4.913-2.703M270.281 104.844a2.797 2.797 0 0 1 3.798-1.097 2.787 2.787 0 0 1 1.097 3.795 2.794 2.794 0 1 1-4.895-2.698M274.001 117.524a2.805 2.805 0 0 1 4.913 2.71 2.8 2.8 0 0 1-3.803 1.097 2.799 2.799 0 0 1-1.11-3.807M284.596 125.245a2.801 2.801 0 0 1 3.807-1.097 2.8 2.8 0 0 1 1.106 3.806 2.807 2.807 0 0 1-3.81 1.104 2.803 2.803 0 0 1-1.103-3.813M269.82 129.117a2.803 2.803 0 0 1 3.806-1.103 2.802 2.802 0 1 1-2.703 4.91 2.808 2.808 0 0 1-1.103-3.807M255.523 126.694a2.801 2.801 0 0 1 3.806-1.098 2.8 2.8 0 0 1 1.107 3.807 2.807 2.807 0 0 1-3.81 1.103 2.803 2.803 0 0 1-1.103-3.812M261.439 114.913a2.803 2.803 0 1 1 4.913 2.701 2.803 2.803 0 0 1-4.913-2.7M248.38 113.231a2.809 2.809 0 0 1 3.812-1.103 2.8 2.8 0 0 1 1.1 3.806 2.807 2.807 0 0 1-3.803 1.104 2.802 2.802 0 0 1-1.11-3.807M256.124 101.206a2.705 2.705 0 0 1 4.737 2.61 2.704 2.704 0 1 1-4.737-2.61M240.84 101.434a2.802 2.802 0 0 1 3.8-1.104 2.798 2.798 0 0 1-2.697 4.901 2.8 2.8 0 0 1-1.103-3.797M234.561 113.605a2.798 2.798 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.703 4.91 2.803 2.803 0 0 1-1.104-3.807M224.82 102.946a2.787 2.787 0 1 1 1.097 3.786 2.787 2.787 0 0 1-1.097-3.786M221.123 115.106a2.809 2.809 0 0 1 3.812-1.103 2.8 2.8 0 0 1 1.1 3.806 2.804 2.804 0 1 1-4.912-2.703M209.22 109.914a2.798 2.798 0 0 1 3.806-1.103 2.796 2.796 0 0 1 1.107 3.806 2.805 2.805 0 0 1-3.816 1.098 2.793 2.793 0 0 1-1.097-3.8M194.654 113.681a2.798 2.798 0 0 1 3.806-1.103 2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.103-3.807M178.984 115.369a2.796 2.796 0 0 1 3.807-1.097 2.791 2.791 0 0 1 1.1 3.8 2.8 2.8 0 0 1-3.803 1.104 2.798 2.798 0 0 1-1.104-3.807M163.898 112.133a2.793 2.793 0 0 1 3.8-1.103 2.797 2.797 0 0 1 1.113 3.806 2.81 2.81 0 0 1-3.815 1.098 2.8 2.8 0 0 1-1.098-3.8M157.345 123.966a2.798 2.798 0 0 1 3.807-1.103 2.796 2.796 0 0 1 1.106 3.806 2.802 2.802 0 0 1-3.81 1.104 2.798 2.798 0 0 1-1.103-3.807M150.804 135.553a2.798 2.798 0 0 1 3.8-1.103 2.796 2.796 0 0 1 1.107 3.807 2.801 2.801 0 1 1-4.907-2.703M144.467 146.691a2.796 2.796 0 0 1 3.801-1.103 2.804 2.804 0 0 1 1.112 3.806 2.805 2.805 0 0 1-3.815 1.098 2.793 2.793 0 0 1-1.098-3.8M146.646 159.733a2.554 2.554 0 0 1 4.473 2.464 2.552 2.552 0 0 1-3.469.998 2.55 2.55 0 0 1-1.004-3.462M132.015 149.746a2.75 2.75 0 0 1 3.738-1.086 2.752 2.752 0 0 1 1.074 3.738 2.74 2.74 0 0 1-3.732 1.08 2.743 2.743 0 0 1-1.08-3.732M135.76 135.717a2.795 2.795 0 0 1 3.806-1.097 2.791 2.791 0 0 1 1.1 3.8 2.802 2.802 0 0 1-3.803 1.11 2.806 2.806 0 0 1-1.104-3.813M121.69 138.497a2.796 2.796 0 0 1 3.8-1.103 2.796 2.796 0 0 1 1.107 3.806 2.801 2.801 0 1 1-4.907-2.703M112.351 126.991a2.809 2.809 0 0 1 3.813-1.103 2.805 2.805 0 1 1-3.813 1.103M105.4 114.177a2.762 2.762 0 0 1 3.75-1.08 2.756 2.756 0 0 1 1.08 3.745 2.759 2.759 0 1 1-4.83-2.664M119.394 112.455a2.803 2.803 0 0 1 3.807-1.104 2.8 2.8 0 0 1 1.1 3.807 2.8 2.8 0 0 1-3.803 1.103 2.803 2.803 0 0 1-1.104-3.806M126.929 124.673a2.798 2.798 0 0 1 3.806-1.104 2.802 2.802 0 1 1-2.703 4.91 2.805 2.805 0 0 1-1.103-3.806M133.96 111.55a2.803 2.803 0 0 1 3.801-1.104 2.796 2.796 0 0 1 1.106 3.806 2.801 2.801 0 1 1-4.907-2.703M142.306 123.429a2.802 2.802 0 1 1 4.907 2.703 2.801 2.801 0 1 1-4.907-2.703M148.76 111.73a2.798 2.798 0 0 1 3.806-1.103 2.796 2.796 0 0 1 1.107 3.807 2.803 2.803 0 0 1-4.913-2.703M153.56 100.207a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 0 1 1.107 3.807 2.807 2.807 0 0 1-3.816 1.103 2.806 2.806 0 0 1-1.097-3.807M139.982 98.741a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.704 4.91 2.808 2.808 0 0 1-1.103-3.807M125.848 98.806a2.8 2.8 0 0 1 3.807-1.098 2.798 2.798 0 0 1 1.1 3.807 2.807 2.807 0 0 1-3.81 1.103 2.807 2.807 0 0 1-1.097-3.812M133.844 85.22a2.807 2.807 0 0 1 3.812-1.097 2.803 2.803 0 0 1 1.1 3.807 2.803 2.803 0 0 1-3.809 1.097 2.808 2.808 0 0 1-1.103-3.806M147.68 86.225a2.806 2.806 0 0 1 3.806-1.097 2.795 2.795 0 0 1 1.107 3.8 2.802 2.802 0 0 1-3.81 1.104 2.802 2.802 0 0 1-1.104-3.807M145.297 71.998a2.8 2.8 0 1 1 4.907 2.703 2.801 2.801 0 1 1-4.907-2.703M128.68 72.968a2.805 2.805 0 0 1 3.807-1.098 2.802 2.802 0 1 1-2.703 4.91 2.803 2.803 0 0 1-1.103-3.812M138.101 60.347a2.791 2.791 0 0 1 3.8-1.104 2.795 2.795 0 0 1 1.107 3.807 2.81 2.81 0 0 1-3.81 1.097 2.796 2.796 0 0 1-1.097-3.8M139.217 47.1a2.74 2.74 0 0 1 3.714-1.079 2.742 2.742 0 0 1 1.076 3.72 2.74 2.74 0 0 1-3.717 1.073 2.73 2.73 0 0 1-1.073-3.713M120.557 61.947a2.805 2.805 0 0 1 3.806-1.11 2.809 2.809 0 0 1 1.107 3.813 2.814 2.814 0 0 1-3.816 1.103 2.801 2.801 0 0 1-1.097-3.806M104.817 62.846a2.803 2.803 0 0 1 3.806-1.103 2.802 2.802 0 0 1 1.107 3.806 2.807 2.807 0 0 1-3.816 1.104 2.806 2.806 0 0 1-1.097-3.807M110.529 49.834a2.803 2.803 0 0 1 3.806-1.103 2.8 2.8 0 0 1 1.1 3.806 2.8 2.8 0 1 1-4.906-2.703M125.655 49.156a2.8 2.8 0 0 1 3.807-1.097 2.802 2.802 0 0 1 1.106 3.807 2.805 2.805 0 0 1-3.81 1.097 2.798 2.798 0 0 1-1.103-3.807M130.088 34.374a2.805 2.805 0 0 1 3.807-1.097 2.8 2.8 0 0 1 1.1 3.806 2.805 2.805 0 0 1-3.81 1.104 2.807 2.807 0 0 1-1.097-3.813M115.902 36.798a2.805 2.805 0 1 1 4.913 2.71 2.807 2.807 0 0 1-3.81 1.103 2.809 2.809 0 0 1-1.103-3.813M120.311 21.952a2.798 2.798 0 0 1 4.901 2.697 2.802 2.802 0 0 1-3.803 1.103 2.805 2.805 0 0 1-1.098-3.8M106.785 25.403a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.704 4.91 2.803 2.803 0 0 1-1.103-3.807M105.518 12.368a2.803 2.803 0 0 1 3.806-1.104 2.798 2.798 0 0 1 1.107 3.807 2.803 2.803 0 0 1-4.913-2.703M92.003 5.523a2.806 2.806 0 0 1 4.913 2.709 2.812 2.812 0 0 1-3.81 1.103 2.809 2.809 0 0 1-1.103-3.812M76.106 1.785a2.796 2.796 0 0 1 3.8-1.104 2.798 2.798 0 0 1 1.113 3.807 2.808 2.808 0 0 1-3.816 1.104 2.801 2.801 0 0 1-1.097-3.807M60.564 1.452A2.803 2.803 0 0 1 64.371.35a2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.104-3.807M45.327 1.586A2.795 2.795 0 0 1 49.118.495a2.784 2.784 0 0 1 1.098 3.783 2.793 2.793 0 0 1-3.792 1.1 2.8 2.8 0 0 1-1.097-3.792M32.49 7.362a2.801 2.801 0 0 1 3.806-1.097 2.802 2.802 0 1 1-2.703 4.91 2.809 2.809 0 0 1-1.104-3.813M16.995 7.304A2.56 2.56 0 0 1 20.458 6.3a2.56 2.56 0 0 1 1.004 3.47 2.558 2.558 0 0 1-3.468 1.004 2.556 2.556 0 0 1-1-3.469M23.232 21.928a2.798 2.798 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.106 3.807 2.807 2.807 0 0 1-3.81 1.103 2.798 2.798 0 0 1-1.103-3.807M37.465 23.155a2.802 2.802 0 0 1 3.807-1.103 2.807 2.807 0 0 1 1.106 3.812 2.81 2.81 0 0 1-3.81 1.098 2.798 2.798 0 0 1-1.103-3.807M50.542 16.748a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.704 4.91 2.803 2.803 0 0 1-1.103-3.807M65.768 15.983a2.803 2.803 0 0 1 3.806-1.104 2.796 2.796 0 0 1 1.107 3.807 2.805 2.805 0 0 1-3.81 1.103 2.808 2.808 0 0 1-1.103-3.806M80.456 15.79a2.798 2.798 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.806 2.801 2.801 0 1 1-4.907-2.703M92.16 23.354a2.803 2.803 0 0 1 3.807-1.104 2.8 2.8 0 0 1 1.1 3.807 2.802 2.802 0 1 1-4.906-2.703M100.232 37.487a2.803 2.803 0 0 1 3.807-1.103 2.796 2.796 0 0 1 1.106 3.807 2.803 2.803 0 0 1-4.913-2.703M85.187 38.223a2.797 2.797 0 0 1 3.807-1.103 2.802 2.802 0 0 1 1.106 3.806 2.814 2.814 0 0 1-3.815 1.104 2.801 2.801 0 0 1-1.098-3.807M74.388 29.632a2.803 2.803 0 0 1 3.813-1.103 2.8 2.8 0 0 1 1.1 3.812 2.808 2.808 0 0 1-3.81 1.098 2.803 2.803 0 0 1-1.103-3.807M59.361 31.273a2.795 2.795 0 0 1 3.8-1.103 2.796 2.796 0 0 1 1.107 3.806 2.803 2.803 0 0 1-3.81 1.098 2.794 2.794 0 0 1-1.097-3.801M45.233 35.747a2.805 2.805 0 0 1 4.913 2.703 2.803 2.803 0 0 1-4.913-2.703M29.604 39.128a2.803 2.803 0 1 1 4.914 2.701 2.803 2.803 0 0 1-4.914-2.7M14.916 34.812a2.807 2.807 0 0 1 4.919 2.703 2.81 2.81 0 0 1-3.816 1.104 2.802 2.802 0 0 1-1.103-3.807M7.335 21.192a2.777 2.777 0 0 1 3.767-1.091 2.775 2.775 0 0 1-2.676 4.86 2.782 2.782 0 0 1-1.091-3.769M.951 38.573a1.174 1.174 0 0 1 1.594-.466c.574.314.771 1.026.46 1.594a1.167 1.167 0 0 1-1.593.466 1.177 1.177 0 0 1-.461-1.594M13.374 49.588a2.795 2.795 0 0 1 3.8-1.103 2.796 2.796 0 0 1 1.107 3.807 2.802 2.802 0 1 1-4.907-2.704M27.005 55.803a2.806 2.806 0 0 1 4.913 2.71 2.805 2.805 0 0 1-3.81 1.097 2.802 2.802 0 0 1-1.103-3.807M41.32 52.158a2.801 2.801 0 0 1 3.806-1.097 2.8 2.8 0 0 1 1.107 3.807 2.815 2.815 0 0 1-3.816 1.097 2.806 2.806 0 0 1-1.097-3.807M55.39 47.877a2.802 2.802 0 1 1 4.907 2.704 2.801 2.801 0 1 1-4.907-2.703M68.852 45.635a2.808 2.808 0 0 1 3.806-1.104 2.796 2.796 0 0 1 1.107 3.807 2.803 2.803 0 0 1-4.913-2.703M80.492 52.514a2.803 2.803 0 1 1 1.103 3.8 2.795 2.795 0 0 1-1.103-3.8M95.373 50.406a2.809 2.809 0 0 1 3.812-1.103 2.8 2.8 0 0 1 1.1 3.807 2.802 2.802 0 0 1-3.809 1.103 2.802 2.802 0 0 1-1.103-3.807M90.105 63.477a2.803 2.803 0 0 1 3.806-1.103 2.8 2.8 0 0 1 1.1 3.806 2.798 2.798 0 0 1-3.803 1.104 2.803 2.803 0 0 1-1.103-3.807M96.506 76.022a2.8 2.8 0 0 1 3.812-1.103 2.798 2.798 0 0 1 1.1 3.806 2.805 2.805 0 0 1-3.803 1.104 2.808 2.808 0 0 1-1.11-3.807M112.059 74.97a2.803 2.803 0 0 1 3.807-1.103 2.796 2.796 0 0 1 1.106 3.807 2.803 2.803 0 0 1-4.913-2.703M118.53 86.383a2.803 2.803 0 1 1 4.91 2.705 2.803 2.803 0 0 1-4.91-2.705M111.048 99.851a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 0 1 1.107 3.806 2.812 2.812 0 0 1-3.816 1.104 2.806 2.806 0 0 1-1.098-3.807M101.646 88.159a2.808 2.808 0 0 1 3.806-1.104 2.8 2.8 0 0 1 1.107 3.807 2.796 2.796 0 0 1-3.81 1.103 2.802 2.802 0 0 1-1.103-3.806M97.639 102.117a1.459 1.459 0 0 1 1.973-.571c.703.386.957 1.27.575 1.973a1.46 1.46 0 0 1-1.977.572 1.459 1.459 0 0 1-.571-1.974M296.464 231.412a2.667 2.667 0 0 1 3.62-1.053 2.67 2.67 0 0 1 1.048 3.621 2.664 2.664 0 1 1-4.668-2.568M310.084 230.612a2.803 2.803 0 0 1 3.806-1.104 2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.103-3.806M307.49 243.595a2.784 2.784 0 0 1 3.78-1.092 2.78 2.78 0 0 1 1.098 3.777 2.789 2.789 0 0 1-3.78 1.094 2.782 2.782 0 0 1-1.098-3.78M319.463 253.547a2.768 2.768 0 1 1 4.847 2.676 2.77 2.77 0 0 1-3.755 1.08 2.763 2.763 0 0 1-1.092-3.756M333.305 262.629a2.542 2.542 0 0 1 3.457-.999 2.537 2.537 0 0 1 .998 3.45 2.536 2.536 0 0 1-3.45 1 2.538 2.538 0 0 1-1.005-3.451M349.775 267.786a2.643 2.643 0 0 1 4.626 2.554 2.644 2.644 0 0 1-3.592 1.037 2.639 2.639 0 0 1-1.034-3.591M344.443 255.457a2.806 2.806 0 0 1 3.806-1.098 2.8 2.8 0 0 1 1.1 3.807 2.805 2.805 0 0 1-3.803 1.103 2.809 2.809 0 0 1-1.103-3.812M332.294 248.121a2.803 2.803 0 0 1 3.807-1.103 2.807 2.807 0 0 1 1.107 3.812 2.806 2.806 0 0 1-3.81 1.098 2.797 2.797 0 0 1-1.104-3.807M320.993 239.6a2.803 2.803 0 0 1 3.807-1.103 2.809 2.809 0 0 1 1.106 3.812 2.805 2.805 0 0 1-3.81 1.098 2.802 2.802 0 0 1-1.103-3.807M323.96 225.67a2.798 2.798 0 0 1 3.807-1.103 2.796 2.796 0 0 1 1.106 3.807 2.812 2.812 0 0 1-3.815 1.103 2.806 2.806 0 0 1-1.098-3.806M333.883 233.205a2.802 2.802 0 1 1 4.907 2.703 2.802 2.802 0 1 1-4.907-2.703M344.034 240.593a2.8 2.8 0 0 1 3.806-1.098 2.798 2.798 0 0 1 1.1 3.801 2.809 2.809 0 0 1-3.809 1.11 2.808 2.808 0 0 1-1.097-3.813M354.517 246.866a2.803 2.803 0 0 1 3.807-1.104 2.796 2.796 0 0 1 1.106 3.807 2.802 2.802 0 0 1-3.81 1.103 2.798 2.798 0 0 1-1.103-3.806M359.58 258.447a2.801 2.801 0 0 1 3.807-1.098 2.8 2.8 0 1 1-2.703 4.905 2.802 2.802 0 0 1-1.103-3.807M366.875 269.625a2.741 2.741 0 1 1 4.8 2.647 2.739 2.739 0 0 1-3.72 1.08 2.744 2.744 0 0 1-1.08-3.727M382.142 267.704a2.79 2.79 0 0 1 4.89 2.691 2.786 2.786 0 0 1-3.792 1.095 2.787 2.787 0 0 1-1.098-3.786M373.785 256.38a2.801 2.801 0 0 1 3.806-1.098 2.798 2.798 0 0 1 1.1 3.807 2.796 2.796 0 0 1-3.803 1.097 2.798 2.798 0 0 1-1.103-3.807M387.644 254.084a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.704 4.91 2.803 2.803 0 0 1-1.103-3.807M397.187 265.333a2.697 2.697 0 1 1 4.726 2.603 2.697 2.697 0 0 1-4.726-2.603M410.351 259.183a2.801 2.801 0 0 1 3.807-1.098 2.793 2.793 0 0 1 1.106 3.801 2.808 2.808 0 0 1-3.81 1.103 2.798 2.798 0 0 1-1.103-3.806M400.639 250.06a2.803 2.803 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.806 2.805 2.805 0 0 1-3.81 1.104 2.806 2.806 0 0 1-1.097-3.807M392.287 239.36a2.797 2.797 0 0 1 3.807-1.103 2.805 2.805 0 0 1 1.1 3.807 2.805 2.805 0 0 1-3.81 1.097 2.794 2.794 0 0 1-1.097-3.8M379.38 242.567a2.805 2.805 0 0 1 3.806-1.097 2.802 2.802 0 0 1 1.107 3.806 2.805 2.805 0 0 1-3.81 1.098 2.797 2.797 0 0 1-1.103-3.807M366.671 244.757a2.798 2.798 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.104-3.807M357.128 233.614a2.808 2.808 0 0 1 3.8-1.104 2.812 2.812 0 0 1 1.113 3.813 2.805 2.805 0 0 1-3.816 1.097 2.798 2.798 0 0 1-1.097-3.806M346.545 226.284a2.797 2.797 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.806 2.801 2.801 0 1 1-4.907-2.703M335.816 218.271a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.703 4.91 2.803 2.803 0 0 1-1.104-3.807M325.7 210.52a2.8 2.8 0 0 1 3.807-1.103 2.799 2.799 0 0 1 1.107 3.807 2.812 2.812 0 0 1-3.81 1.103 2.808 2.808 0 0 1-1.103-3.806M337.603 202.636a2.797 2.797 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.104-3.807M347.993 212.495a2.803 2.803 0 0 1 3.807-1.104 2.807 2.807 0 0 1 1.107 3.813 2.81 2.81 0 0 1-3.816 1.097 2.806 2.806 0 0 1-1.098-3.806M360.107 219.422a2.807 2.807 0 0 1 3.812-1.098 2.802 2.802 0 0 1 1.107 3.807 2.812 2.812 0 0 1-3.816 1.103 2.809 2.809 0 0 1-1.103-3.812M373.65 218.312a2.801 2.801 0 0 1 3.807-1.098 2.8 2.8 0 0 1 1.106 3.807 2.81 2.81 0 0 1-3.81 1.098 2.803 2.803 0 0 1-1.103-3.807M369.89 231.167a2.801 2.801 0 0 1 3.806-1.098 2.795 2.795 0 0 1 1.106 3.8 2.802 2.802 0 0 1-3.81 1.104 2.802 2.802 0 0 1-1.103-3.806M383.088 228.778a2.8 2.8 0 0 1 3.807-1.098 2.8 2.8 0 0 1 1.106 3.807 2.812 2.812 0 0 1-3.815 1.104 2.807 2.807 0 0 1-1.098-3.813M396.27 225.098a2.801 2.801 0 0 1 3.807-1.097 2.8 2.8 0 0 1 1.106 3.807 2.807 2.807 0 0 1-3.81 1.103 2.803 2.803 0 0 1-1.103-3.813M387.036 215.105a2.797 2.797 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.807 2.801 2.801 0 1 1-4.907-2.703M399.967 210.643a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.704 4.91 2.798 2.798 0 0 1-1.103-3.807M413.184 206.789a2.8 2.8 0 0 1 3.807-1.098 2.793 2.793 0 0 1 1.1 3.8 2.801 2.801 0 1 1-4.907-2.703M427.335 204.178a2.801 2.801 0 0 1 3.807-1.097 2.802 2.802 0 1 1-2.703 4.91 2.809 2.809 0 0 1-1.104-3.813M442.585 205.002a2.803 2.803 0 1 1 4.91 2.705 2.803 2.803 0 0 1-4.91-2.705M456.648 208.062a2.802 2.802 0 0 1 3.807-1.104 2.802 2.802 0 0 1 1.106 3.807 2.808 2.808 0 0 1-3.815 1.103 2.8 2.8 0 0 1-1.098-3.806M470.227 213.33a2.805 2.805 0 0 1 4.913 2.703 2.803 2.803 0 0 1-4.913-2.703M459.61 222.102a2.801 2.801 0 0 1 3.806-1.097 2.793 2.793 0 0 1 1.1 3.8 2.8 2.8 0 1 1-4.907-2.703M446.369 218.487a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 0 1 1.106 3.806 2.812 2.812 0 0 1-3.816 1.104 2.801 2.801 0 0 1-1.097-3.807M434.174 215.251a2.801 2.801 0 0 1 3.807-1.097 2.799 2.799 0 1 1-2.703 4.904 2.803 2.803 0 0 1-1.104-3.807M433.584 228.44a2.81 2.81 0 0 1 3.813-1.104 2.802 2.802 0 1 1-2.703 4.91 2.8 2.8 0 0 1-1.11-3.807M427.814 242.036a2.794 2.794 0 0 1 3.8-1.098 2.804 2.804 0 0 1 1.113 3.807 2.812 2.812 0 0 1-3.816 1.097 2.8 2.8 0 0 1-1.097-3.806M419.182 231.558a2.797 2.797 0 0 1 3.807-1.104 2.802 2.802 0 0 1 1.106 3.807 2.805 2.805 0 0 1-3.81 1.097 2.791 2.791 0 0 1-1.103-3.8M421.904 217.979a2.801 2.801 0 0 1 3.806-1.098 2.795 2.795 0 0 1 1.107 3.801 2.802 2.802 0 0 1-3.81 1.103 2.802 2.802 0 0 1-1.103-3.806M409.183 221.197a2.802 2.802 0 1 1 4.907 2.703 2.801 2.801 0 1 1-4.907-2.703M405.469 235.36a2.803 2.803 0 0 1 3.806-1.104 2.8 2.8 0 0 1 1.1 3.807 2.8 2.8 0 0 1-3.803 1.103 2.798 2.798 0 0 1-1.103-3.806M414.048 245.505a2.807 2.807 0 0 1 4.919 2.71 2.81 2.81 0 0 1-3.815 1.096 2.803 2.803 0 0 1-1.104-3.806M424.368 254.931a2.794 2.794 0 0 1 3.801-1.097 2.795 2.795 0 1 1-2.697 4.895 2.8 2.8 0 0 1-1.104-3.798M438.882 253.751a2.801 2.801 0 0 1 3.806-1.097 2.795 2.795 0 0 1 1.107 3.8 2.81 2.81 0 0 1-3.81 1.11 2.805 2.805 0 0 1-1.103-3.813M440.768 241.014a2.802 2.802 0 0 1 3.807-1.104 2.807 2.807 0 0 1 1.106 3.813 2.805 2.805 0 0 1-3.81 1.097 2.797 2.797 0 0 1-1.103-3.806M448.408 231.458a2.802 2.802 0 1 1 4.907 2.704 2.802 2.802 0 1 1-4.907-2.704M460.707 236.148a2.803 2.803 0 1 1 4.91 2.706 2.803 2.803 0 0 1-4.91-2.706M453.74 247.368a2.798 2.798 0 0 1 3.806-1.103 2.8 2.8 0 1 1-2.703 4.904 2.791 2.791 0 0 1-1.103-3.801M452.151 260.807a2.72 2.72 0 0 1 3.696-1.062 2.71 2.71 0 0 1 1.07 3.684 2.715 2.715 0 0 1-3.692 1.074 2.727 2.727 0 0 1-1.074-3.696M464.457 258.283a2.796 2.796 0 0 1 3.813-1.097 2.796 2.796 0 0 1 1.1 3.8 2.809 2.809 0 0 1-3.81 1.11 2.806 2.806 0 0 1-1.103-3.813M478.223 259.194a2.42 2.42 0 0 1 3.295-.95 2.423 2.423 0 0 1 .957 3.298 2.43 2.43 0 0 1-3.301.954 2.43 2.43 0 0 1-.951-3.302M484.518 246.655a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 0 1 1.106 3.813 2.81 2.81 0 0 1-3.815 1.097 2.801 2.801 0 0 1-1.098-3.807M470.753 244.833a2.801 2.801 0 0 1 3.806-1.097 2.796 2.796 0 0 1 1.107 3.806 2.803 2.803 0 0 1-3.81 1.098 2.803 2.803 0 0 1-1.103-3.807M472.347 229.07a2.809 2.809 0 0 1 3.813-1.104 2.805 2.805 0 1 1-3.813 1.104M485.05 233.952a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.104-3.807M483.286 219.976a2.737 2.737 0 0 1 4.796 2.64 2.748 2.748 0 0 1-3.722 1.08 2.742 2.742 0 0 1-1.074-3.72"
  })));
}

function Figures(props) {
  var _props$width, _props$height, _props$position, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$color;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 65,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 57,
    viewBox: "0 0 65 57",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      zIndex: 1.1,
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1
    }
  }, React__default.createElement("path", {
    d: "M46.463.923c8.21 0 12.501 4.204 14.472 7.899a32.203 32.203 0 0 1 3.81 15.194c0 17.704-14.325 32.061-32 32.061-17.676 0-32-14.357-32-32.061A32.127 32.127 0 0 1 4.56 8.822c1.964-3.695 6.256-7.9 14.465-7.9ZM42.85 8.184H22.638c-6.047 0-9.209 3.097-10.656 5.82a23.667 23.667 0 0 0-2.811 11.193c0 13.042 10.552 23.619 23.574 23.619 13.021 0 23.573-10.577 23.573-23.62 0-4.05-1.027-7.855-2.806-11.193-1.452-2.722-4.614-5.819-10.661-5.819Z",
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.BLUE,
    fillRule: "nonzero"
  }));
}

function Oval(props) {
  var _props$width, _props$height, _props$position, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$color;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 55,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 55,
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      zIndex: 1.1,
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1
    }
  }, React__default.createElement("ellipse", {
    cx: 487.491,
    cy: 165.5,
    rx: 27,
    ry: 26.985,
    transform: "translate(-460 -138)",
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.BLUE,
    fillRule: "nonzero"
  }));
}

function Stripes(props) {
  var _props$width, _props$height, _props$position, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$color;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 76,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 33,
    viewBox: "0 0 76 33",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      zIndex: 1.1,
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1
    }
  }, React__default.createElement("g", {
    transform: "translate(-572 -149)",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.BLUE
  }, React__default.createElement("path", {
    d: "M592.65 181.5h48.244c3.265 0 5.924-2.625 5.924-5.838 0-3.212-2.659-5.833-5.924-5.833h-48.245V181.5ZM572.737 161.17h48.245c3.265 0 5.924-2.624 5.924-5.837 0-3.213-2.66-5.833-5.924-5.833h-48.245v11.67Z"
  }))));
}

function Confetti(props) {
  var render = function render() {
    switch (props.type) {
      case 'C':
        return React$4.createElement(C, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity
        });
      case 'DotsPath':
        return React$4.createElement(DotsPath, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity
        });
      case 'Figure':
        return React$4.createElement(Figures, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity
        });
      case 'Oval':
        return React$4.createElement(Oval, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity
        });
      case 'Stripes':
        return React$4.createElement(Stripes, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity
        });
      default:
        return React$4.createElement("div", null);
    }
  };
  return render();
}

function Image(props) {
  var renderWrapper = function renderWrapper() {
    var _props$width, _props$height, _props$minHeight, _props$minWidth;
    switch (props.wrapper) {
      case 'Figure':
        return React$4.createElement(WrapperFigure, {
          id: props.id,
          src: props.src,
          width: props.width,
          height: props.height
        });
      default:
        return React$4.createElement("div", {
          id: props.id,
          style: {
            width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : '100%',
            height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : '100%',
            minHeight: (_props$minHeight = props.minHeight) !== null && _props$minHeight !== void 0 ? _props$minHeight : 'auto',
            minWidth: (_props$minWidth = props.minWidth) !== null && _props$minWidth !== void 0 ? _props$minWidth : 'auto',
            backgroundColor: Colors.MEDIUM_WHITE,
            backgroundImage: "url('".concat(props.src, "')"),
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            borderRadius: 10
          }
        });
    }
  };
  return React$4.createElement("div", {
    className: "DisableSelection",
    style: {
      height: '100%',
      width: '100%',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, renderWrapper(), props.confetti && React$4.createElement("div", {
    style: {
      position: 'absolute',
      width: '100%',
      height: '100%'
    }
  }, React$4.createElement(Confetti, {
    type: props.confetti.type,
    height: props.confetti.height,
    width: props.confetti.width,
    color: props.confetti.color,
    marginLeft: props.confetti.marginLeft,
    marginRight: props.confetti.marginRight,
    marginTop: props.confetti.marginTop,
    marginBottom: props.confetti.marginBottom,
    transform: props.confetti.transform,
    position: props.confetti.position,
    top: props.confetti.top,
    left: props.confetti.left,
    right: props.confetti.right,
    bottom: props.confetti.bottom,
    opacity: props.confetti.opacity
  })));
}

function SegmentedControl(props) {
  var size = useDimensions();
  return size.width < Breakpoint.sm ? React$4.createElement("div", {
    style: {
      height: size.width < Breakpoint.fd ? 'auto' : 40,
      width: '100%',
      backgroundColor: Colors.WHITE,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 7,
      display: 'flex',
      flexDirection: size.width < Breakpoint.fd ? 'column' : 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, props.items.map(function (e, i) {
    return React$4.createElement(React$4.Fragment, null, React$4.createElement("button", {
      key: e.id,
      type: "button",
      className: "Hover",
      onClick: e.onClick,
      style: {
        height: 40,
        width: '100%',
        border: 'solid 0px transparent',
        backgroundColor: e.selected ? Colors.WHITE : 'transparent',
        borderRadius: 7,
        fontSize: '1em',
        boxShadow: e.selected ? "0px 0px 10px 1px ".concat(Colors.MEDIUM_GREY) : 'inherit',
        paddingBottom: !e.selected && i + 1 !== props.items.length && !props.items[i + 1].selected ? 0 : 2
      }
    }, React$4.createElement(Text, {
      textAlign: "center",
      fontSize: "1em"
    }, e.title)), React$4.createElement("span", {
      style: {
        width: size.width < Breakpoint.fd ? '90%' : 2,
        minWidth: size.width < Breakpoint.fd ? '90%' : 2,
        maxWidth: size.width < Breakpoint.fd ? '90%' : 2,
        height: size.width < Breakpoint.fd ? 2 : '60%',
        marginTop: size.width < Breakpoint.fd ? 0 : '20%',
        marginBottom: size.width < Breakpoint.fd ? 0 : '20%',
        backgroundColor: !e.selected && i + 1 !== props.items.length && !props.items[i + 1].selected ? Colors.MEDIUM_WHITE : 'transparent'
      }
    }));
  })) : React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start'
    }
  }, props.items.map(function (e, i) {
    return React$4.createElement("div", {
      key: e.id,
      style: {
        marginRight: i + 1 === props.items.length ? 0 : 15,
        width: 'auto'
      }
    }, React$4.createElement(Buttons$1, {
      text: e.title,
      onClick: e.onClick,
      size: "medium",
      colorScheme: "white",
      selectable: true,
      selected: e.selected
    }));
  }));
}

function ScrollDownArrow() {
  return React$4.createElement("div", {
    style: {
      height: 80,
      width: 80,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement("span", {
    className: "ScrollDownLine",
    style: {
      display: 'block',
      position: 'relative',
      paddingTop: 79,
      textAlign: 'center'
    }
  }, React$4.createElement("span", {
    className: "ScrollDownArrow",
    style: {
      display: 'block',
      margin: '0 auto',
      width: 10,
      height: 38
    }
  })));
}

function Tip$1(_ref) {
  var size = _ref.size,
      position = _ref.position,
      content = _ref.content;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];
  var iconRef = React$4.useRef();
  var DEFAULT_SIZE = 25;
  var getPosition = function getPosition() {
    switch (position) {
      case 'right':
        return {
          left: iconRef.current.offsetLeft + 40
        };
      case 'top':
        return {
          bottom: iconRef.current.offsetTop + 40
        };
      case 'bottom':
        return {
          top: iconRef.current.offsetTop + 40
        };
      case 'left':
        return {
          right: iconRef.current.offsetLeft + 40
        };
      default:
        return {
          left: iconRef.current.offsetLeft + 40
        };
    }
  };
  return React$4.createElement("div", null, visible && React$4.createElement("div", {
    style: _objectSpread2(_objectSpread2({
      position: 'absolute'
    }, getPosition()), {}, {
      minHeight: 30,
      minWidth: 100,
      maxWidth: 300,
      background: Colors.WHITE,
      borderColor: Colors.MEDIUM_WHITE,
      borderWidth: 2,
      borderStyle: 'solid',
      borderRadius: 10,
      padding: 15,
      zIndex: 99
    })
  }, React$4.createElement(Text, null, content)), React$4.createElement("div", {
    ref: iconRef,
    onMouseEnter: function onMouseEnter() {
      return setVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setVisible(false);
    },
    style: {
      cursor: 'pointer',
      width: size !== null && size !== void 0 ? size : DEFAULT_SIZE,
      height: size !== null && size !== void 0 ? size : DEFAULT_SIZE
    }
  }, React$4.createElement(Icon, {
    name: "InfoCircle",
    height: size !== null && size !== void 0 ? size : DEFAULT_SIZE,
    width: size !== null && size !== void 0 ? size : DEFAULT_SIZE,
    color: Colors.DARK_WHITE,
    iconSet: "FA"
  })));
}

function Tag(props) {
  return React$4.createElement("div", {
    style: {
      width: 'auto',
      paddingLeft: 15,
      paddingRight: 15,
      paddingTop: 5,
      paddingBottom: 5,
      borderRadius: 7.5,
      backgroundColor: props.backgroundColor
    }
  }, React$4.createElement(Text, {
    color: Colors.WHITE,
    fontSize: "1.1em",
    fontWeight: 500
  }, props.title));
}

function PayAttention(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      backgroundColor: Colors.GRADIENT,
      borderRadius: 10,
      border: "solid 2px ".concat(Colors.BLUE),
      padding: 15
    }
  }, React$4.createElement("div", {
    className: "DisableSelection",
    style: {
      marginBottom: 15
    }
  }, React$4.createElement(Text, {
    color: Colors.BLUE,
    fontWeight: 500
  }, "".concat(_('payAttention', {
    ns: 'ui'
  }), ":"))), React$4.createElement(Text, {
    color: Colors.BLUE
  }, props.text));
}

function Tip(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      backgroundColor: Colors.LIGHT_GREEN,
      borderRadius: 10,
      border: "solid 2px ".concat(Colors.GREEN),
      padding: 15
    }
  }, React$4.createElement("div", {
    className: "DisableSelection",
    style: {
      marginBottom: 15
    }
  }, React$4.createElement(Text, {
    color: Colors.GREEN,
    fontWeight: 500
  }, "".concat(_('tip', {
    ns: 'ui'
  }), ":"))), React$4.createElement(Text, {
    color: Colors.GREEN
  }, props.text));
}

function InfoBlock(props) {
  switch (props.type) {
    case 'payAttention':
      return React$4.createElement(PayAttention, {
        text: props.text
      });
    case 'tip':
      return React$4.createElement(Tip, {
        text: props.text
      });
    default:
      return React$4.createElement("div", null);
  }
}

var globalId = 0;
var Hubspot = function (_React$Component) {
  _inherits$3(Hubspot, _React$Component);
  var _super = _createSuper$4(Hubspot);
  function Hubspot(props) {
    var _this;
    _classCallCheck$3(this, Hubspot);
    _this = _super.call(this, props);
    _this.state = {
      loaded: false
    };
    _this.id = globalId++;
    _this.createForm = _this.createForm.bind(_assertThisInitialized$3(_this));
    _this.findFormElement = _this.findFormElement.bind(_assertThisInitialized$3(_this));
    return _this;
  }
  _createClass$3(Hubspot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!window.hbspt && !this.props.noScript) {
        this.loadScript();
      } else {
        this.createForm();
        this.findFormElement();
      }
    }
  }, {
    key: "createForm",
    value: function createForm() {
      var _this2 = this;
      if (window.hbspt) {
        if (this.el === null) return;
        var props = _objectSpread2({}, this.props);
        delete props.loading;
        delete props.onSubmit;
        delete props.onReady;
        var options = _objectSpread2(_objectSpread2({}, props), {}, {
          target: "#".concat(this.el.getAttribute('id')),
          onFormSubmit: function onFormSubmit($form) {
            var data = $form.serializeArray();
            _this2.props.onSubmit(data);
          }
        });
        window.hbspt.forms.create(options);
      } else {
        setTimeout(this.createForm, 1);
      }
    }
  }, {
    key: "loadScript",
    value: function loadScript() {
      var _this3 = this;
      var script = document.createElement('script');
      script.defer = true;
      script.onload = function () {
        _this3.createForm();
        _this3.findFormElement();
      };
      script.src = '//js.hsforms.net/forms/v2.js';
      document.head.appendChild(script);
    }
  }, {
    key: "findFormElement",
    value: function findFormElement() {
      if (this.el === null) return;
      var form = this.el.querySelector('iframe');
      if (form) {
        this.setState({
          loaded: true
        });
        if (this.props.onReady) {
          this.props.onReady(form);
        }
      } else {
        setTimeout(this.findFormElement, 1);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      return React$4.createElement("div", null, React$4.createElement("div", {
        ref: function ref(el) {
          return _this4.el = el;
        },
        id: "Form".concat(this.id),
        style: {
          display: this.state.loaded ? 'block' : 'none',
          visibility: this.state.loaded ? 'visible' : 'hidden'
        }
      }));
    }
  }]);
  return Hubspot;
}(React$4.Component);

function Form(props) {
  var render = function render() {
    switch (props.type) {
      case 'Hubspot':
        return React$4.createElement(Hubspot, {
          portalId: props.portalId,
          formId: props.formId,
          onSubmit: props.onSubmit,
          onReady: props.onReady,
          loading: props.loading
        });
      default:
        return React$4.createElement("div", null);
    }
  };
  return render();
}

function SearchGroupTitle(props) {
  return React$4.createElement("div", {
    style: {
      paddingTop: 15,
      paddingBottom: 15
    }
  }, React$4.createElement(Text, {
    fontSize: "0.9em",
    fontWeight: 500,
    textTransform: "capitalize"
  }, props.title));
}

function SearchChargePointItem(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      binHover = _React$useState4[0],
      setBinHover = _React$useState4[1];
  return React$4.createElement("button", {
    type: "button",
    className: props.selected ? 'Disabled' : props.onClick !== undefined ? 'Hover' : 'DisableSelection',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: props.onClick !== undefined ? props.onClick : null,
    style: {
      width: '100%',
      height: 70,
      border: props.selected ? "solid 2px ".concat(Colors.BLUE) : "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      marginBottom: 15,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      overflow: 'hidden',
      fontSize: '1em',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 15,
      paddingRight: 15,
      backgroundColor: hover && !props.selected && props.onClick !== undefined ? Colors.LIGHT_WHITE : props.selected ? Colors.LIGHT_BLUE : 'transparent',
      transition: 'all .2s linear'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 70,
      width: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      height: 60,
      width: 'auto',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginRight: 15
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      width: 45,
      height: 45,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 15
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    color: props.icon.color,
    height: props.icon.height,
    width: props.icon.width,
    iconSet: props.icon.iconSet
  })), React$4.createElement("div", {
    style: {
      marginTop: -7
    }
  }, React$4.createElement(ModuleHeader, {
    title: props.title,
    subTitle: props.subTitle
  }))), props.onDelete && React$4.createElement("button", {
    type: "button",
    onClick: props.onDelete,
    className: "Hover",
    onMouseEnter: function onMouseEnter() {
      setBinHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setBinHover(false);
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: 60,
      width: 23,
      backgroundColor: 'transparent',
      border: 'solid 0px transparent'
    }
  }, React$4.createElement(Icon, {
    name: "Bin",
    height: 23,
    width: 23,
    color: binHover ? Colors.RED : Colors.MEDIUM_GREY,
    iconSet: "FA"
  }))), props.selected && React$4.createElement("div", {
    style: {
      width: 'auto',
      paddingRight: 15,
      paddingTop: 10
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.BLUE,
    fontWeight: 500
  }, _('selected', {
    ns: 'ui'
  }))));
}

function SearchPageItem$1(props) {
  var _props$onClick;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    type: "button",
    className: props.onClick !== undefined ? 'Hover' : 'DisableSelection',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: (_props$onClick = props.onClick) !== null && _props$onClick !== void 0 ? _props$onClick : props.onClick,
    style: {
      width: '100%',
      height: 50,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      paddingLeft: 3,
      paddingRight: 15,
      marginBottom: 15,
      backgroundColor: hover && props.onClick !== undefined ? Colors.LIGHT_WHITE : 'transparent',
      transition: 'all .2s linear',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      fontSize: '0.9em'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: 45,
      width: 45
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    color: props.icon.color,
    height: props.icon.height,
    width: props.icon.width,
    iconSet: props.icon.iconSet
  })), React$4.createElement("div", {
    style: {
      paddingTop: 2
    }
  }, React$4.createElement(Text, {
    fontWeight: 300
  }, props.title))), React$4.createElement(AnimatePresence, null, hover && props.onClick !== undefined && React$4.createElement(motion.div, {
    style: {
      height: 45,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    initial: {
      paddingRight: 15,
      opacity: 0
    },
    animate: {
      paddingRight: 0,
      opacity: 1
    },
    exit: {
      paddingRight: 15,
      opacity: 0
    }
  }, React$4.createElement(Icon, {
    name: "ArrowRight",
    color: Colors.GREY,
    height: 13,
    width: 13
  }))));
}

function SearchChargeCardItem(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      binHover = _React$useState4[0],
      setBinHover = _React$useState4[1];
  return React$4.createElement("button", {
    type: "button",
    className: props.selected ? 'Disabled' : props.onClick !== undefined ? 'Hover' : 'DisableSelection',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: props.onClick !== undefined ? props.onClick : null,
    style: {
      width: '100%',
      height: 70,
      border: props.selected ? "solid 2px ".concat(Colors.BLUE) : "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      marginBottom: 15,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      overflow: 'hidden',
      fontSize: '1em',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 15,
      paddingRight: 15,
      backgroundColor: hover && !props.selected && props.onClick !== undefined ? Colors.LIGHT_WHITE : props.selected ? Colors.LIGHT_BLUE : 'transparent',
      transition: 'all .2s linear'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 70,
      width: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      height: 60,
      width: 'auto',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginRight: 15
    }
  }, React$4.createElement("div", {
    style: {
      width: 45,
      height: 45,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 15
    }
  }, React$4.createElement(Icon, {
    name: "Card",
    height: 40,
    width: 40,
    color: Colors.GREY,
    iconSet: "FA"
  })), React$4.createElement("div", {
    style: {
      marginTop: -7
    }
  }, React$4.createElement(ModuleHeader, {
    title: props.title,
    subTitle: props.subTitle
  }))), props.onDelete && React$4.createElement("button", {
    type: "button",
    onClick: props.onDelete,
    className: "Hover",
    onMouseEnter: function onMouseEnter() {
      setBinHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setBinHover(false);
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: 60,
      width: 23,
      backgroundColor: 'transparent',
      border: 'solid 0px transparent'
    }
  }, React$4.createElement(Icon, {
    name: "Bin",
    height: 23,
    width: 23,
    color: binHover ? Colors.RED : Colors.MEDIUM_GREY,
    iconSet: "FA"
  }))), props.selected && React$4.createElement("div", {
    style: {
      width: 'auto',
      paddingRight: 15,
      paddingTop: 10
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.BLUE,
    fontWeight: 500
  }, _('selected', {
    ns: 'ui'
  }))));
}

function SearchGridItem(props) {
  var size = useDimensions();
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    type: "button",
    className: props.disabled ? 'Disabled' : props.onClick !== undefined ? 'Hover' : 'DisableSelection',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: props.onClick !== undefined ? props.onClick : null,
    style: {
      width: '100%',
      height: size.width < Breakpoint.fd && props.selected ? 110 : 85,
      border: props.selected ? "solid 2px ".concat(Colors.BLUE) : "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      marginBottom: 15,
      display: 'flex',
      flexDirection: 'row',
      overflow: 'hidden',
      fontSize: '1em',
      padding: 0,
      backgroundColor: hover && !props.selected && props.onClick !== undefined ? Colors.LIGHT_WHITE : props.selected ? Colors.LIGHT_BLUE : 'transparent',
      transition: 'all .2s linear'
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      paddingLeft: 10,
      display: 'flex',
      flexDirection: size.width < Breakpoint.fd ? props.selected ? 'column-reverse' : 'column' : 'row',
      justifyContent: 'space-between'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: size.width < Breakpoint.fd && props.selected ? 'row-reverse' : 'row',
      justifyContent: size.width < Breakpoint.fd && props.selected ? 'space-between' : 'flex-start',
      minWidth: 200,
      width: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      height: size.width < Breakpoint.fd && props.selected ? 75 : 80,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: size.width < Breakpoint.fd && props.selected ? 'flex-start' : 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(ModuleHeader, {
    title: props.title,
    subTitle: props.subTitle
  }))), props.selected && React$4.createElement("div", {
    style: {
      width: '50%',
      paddingRight: 15,
      height: 80,
      paddingTop: 10
    }
  }, React$4.createElement(Text, {
    textAlign: size.width < Breakpoint.fd ? 'left' : 'right',
    fontSize: "1em",
    color: Colors.BLUE,
    fontWeight: 500
  }, _('selected', {
    ns: 'ui'
  })))));
}

function SearchPageItem(props) {
  var _props$onClick;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    type: "button",
    className: props.onClick !== undefined ? 'Hover' : 'DisableSelection',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: (_props$onClick = props.onClick) !== null && _props$onClick !== void 0 ? _props$onClick : props.onClick,
    style: {
      width: '100%',
      height: 50,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      padding: 15,
      marginBottom: 15,
      backgroundColor: hover && props.onClick !== undefined ? Colors.LIGHT_WHITE : 'transparent',
      transition: 'all .2s linear',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      fontSize: '0.9em'
    }
  }, React$4.createElement(Text, {
    fontWeight: 300
  }, props.title), React$4.createElement(AnimatePresence, null, hover && props.onClick !== undefined && React$4.createElement(motion.div, {
    style: {
      paddingTop: 2
    },
    initial: {
      paddingRight: 15,
      opacity: 0
    },
    animate: {
      paddingRight: 0,
      opacity: 1
    },
    exit: {
      paddingRight: 15,
      opacity: 0
    }
  }, React$4.createElement(Icon, {
    name: "ArrowRight",
    color: Colors.GREY,
    height: 13,
    width: 13
  }))));
}

function OverlaySearch(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var dynamicSort = function dynamicSort(input) {
    var result = input.reduce(function (r, a) {
      r[a.type] = r[a.type] || [];
      if (
      a.type === 'chargepoint' || a.type === 'page' || a.type === 'chargecard' || a.type === 'grid') {
        r[a.type].push(a);
      } else {
        r.default = [];
        r.default.push(a);
      }
      return r;
    }, Object.create(null));
    return result;
  };
  var sortedData = dynamicSort(props.data);
  return React$4.createElement(React$4.Fragment, null, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      height: 48,
      borderBottom: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement("div", {
    style: {
      height: 45,
      width: 30,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }
  }, React$4.createElement(Icon, {
    name: "Search",
    color: Colors.GREY,
    height: 20,
    width: 20,
    iconSet: "FA"
  })), React$4.createElement("div", {
    style: {
      marginTop: -5,
      width: '100%'
    }
  }, React$4.createElement(Input, {
    type: "text",
    styling: false,
    required: true,
    placeholder: "".concat(_('search', {
      ns: 'ui'
    }), "..."),
    backgroundColor: "transparent",
    onChange: props.onSearch
  })), props.selectAll && React$4.createElement("div", {
    style: {
      width: 200,
      marginTop: 3,
      flexShrink: 0
    }
  }, React$4.createElement(Buttons$1, {
    text: _('selectAll', {
      ns: 'ui'
    }),
    size: "medium",
    onClick: props.selectAll
  })), props.deselectAll && React$4.createElement("div", {
    style: {
      width: 200,
      marginTop: 3,
      flexShrink: 0
    }
  }, React$4.createElement(Buttons$1, {
    text: _('deselectAll', {
      ns: 'ui'
    }),
    size: "medium",
    onClick: props.deselectAll,
    colorScheme: "white"
  }))), React$4.createElement("div", {
    style: {
      overflowY: 'scroll',
      height: '100%',
      width: '100%'
    }
  }, sortedData.chargepoint && React$4.createElement("div", {
    style: {
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement(SearchGroupTitle, {
    title: _('chargepoints', {
      ns: 'ui'
    })
  }), sortedData.chargepoint.map(function (e) {
    return React$4.createElement(React$4.Fragment, {
      key: e.id
    }, React$4.createElement(SearchChargePointItem, {
      title: e.name,
      subTitle: e.serial,
      selected: e.selected,
      onClick: e.onClick,
      onDelete: e.onDelete,
      icon: e.icon
    }));
  })), sortedData.page && React$4.createElement("div", {
    style: {
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement(SearchGroupTitle, {
    title: _('pages', {
      ns: 'ui'
    })
  }), sortedData.page.map(function (e) {
    return React$4.createElement(React$4.Fragment, {
      key: e.id
    }, React$4.createElement(SearchPageItem$1, {
      title: e.title,
      onClick: e.onClick,
      icon: e.icon
    }));
  })), sortedData.grid && React$4.createElement("div", {
    style: {
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement(SearchGroupTitle, {
    title: _('grids', {
      ns: 'ui'
    })
  }), sortedData.grid.map(function (e) {
    return React$4.createElement(React$4.Fragment, {
      key: e.id
    }, React$4.createElement(SearchGridItem, {
      title: e.name,
      subTitle: e.serial,
      selected: e.selected,
      onClick: e.onClick
    }));
  })), sortedData.chargecard && React$4.createElement("div", {
    style: {
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement(SearchGroupTitle, {
    title: _('chargeCards', {
      ns: 'ui'
    })
  }), sortedData.chargecard.map(function (e) {
    return React$4.createElement(React$4.Fragment, {
      key: e.id
    }, React$4.createElement(SearchChargeCardItem, {
      title: e.name,
      subTitle: e.serial,
      uid: e.uid,
      selected: e.selected,
      onClick: e.onClick,
      onDelete: e.onDelete
    }));
  })), sortedData.default && React$4.createElement("div", {
    style: {
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement(SearchGroupTitle, {
    title: _('other', {
      ns: 'ui'
    })
  }), sortedData.default.map(function (e) {
    return React$4.createElement(React$4.Fragment, {
      key: e.id
    }, React$4.createElement(SearchPageItem, {
      title: e.title,
      onClick: e.onClick,
      icon: e.icon
    }));
  }))));
}

function Overlay(props) {
  var renderContent = function renderContent() {
    switch (props.type) {
      case 'Search':
        return React$4.createElement(OverlaySearch, {
          data: props.data,
          onSearch: props.onSearch,
          selectAll: props.selectAll
        });
      default:
        return React$4.createElement(OverlaySearch, {
          data: props.data,
          onSearch: props.onSearch,
          selectAll: props.selectAll
        });
    }
  };
  return React$4.createElement(Modal, {
    title: props.title,
    subTitle: props.subTitle,
    onClose: props.onClose,
    visible: props.visible
  }, renderContent());
}

function CookiePopup(props) {
  var size = useDimensions();
  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];
  var _Lang$useTranslation = Lang.useTranslation('ui'),
      _ = _Lang$useTranslation._;
  React__default.useEffect(function () {
    if (props.showDefault === undefined || props.showDefault) {
      setVisible(true);
    }
  }, []);
  if (!visible) return null;
  return React__default.createElement("div", {
    style: {
      position: 'fixed',
      zIndex: 2147483004,
      bottom: size.width < Breakpoint.sm ? 0 : 10,
      left: size.width < Breakpoint.sm ? 0 : 10,
      backgroundColor: Colors.WHITE,
      width: size.width < Breakpoint.sm ? '100%' : 350,
      minHeight: 200,
      height: 'auto',
      borderRadius: size.width < Breakpoint.sm ? 0 : 10,
      WebkitBoxShadow: "0px 3px 15px 2px ".concat(Colors.BLACK, "40"),
      boxShadow: "0px 3px 15px 2px ".concat(Colors.BLACK, "40"),
      overflow: 'hidden',
      padding: 15
    }
  }, React__default.createElement("button", {
    className: "Hover",
    type: "button",
    "aria-label": "".concat(_('cookie.closeCookiePopup'), " ").concat(_('accessibility.button').toLowerCase()),
    style: {
      position: 'absolute',
      right: 10,
      top: 15,
      backgroundColor: 'transparent',
      padding: 0,
      border: 0
    },
    onClick: function onClick() {
      if (props.callback) props.callback(false);
      setVisible(false);
    }
  }, React__default.createElement(Icon, {
    name: "Times",
    width: "20px",
    height: "20px",
    color: Colors.MEDIUM_GREY,
    iconSet: "Feather"
  })), React__default.createElement("p", {
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      fontWeight: 500
    }
  }, _('cookie.title')), React__default.createElement("p", {
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      fontWeight: 300,
      marginTop: 10
    }
  }, _('cookie.text', {
    cookie_link: 'https://www.bluecurrent.nl/legal/cookies'
  })), React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, React__default.createElement("div", {
    style: {
      marginTop: 20
    }
  }, React__default.createElement(Buttons$1, {
    id: "cookies-accept-button",
    text: _('cookie.button'),
    borderColor: Colors.BLUE,
    textColor: Colors.WHITE,
    backgroundColor: Colors.BLUE,
    hoverBackgroundColor: Colors.WHITE,
    hoverTextColor: Colors.BLUE,
    ariaLabel: "".concat(_('cookie.button'), " ").concat(_('accessibility.button')),
    onClick: function onClick() {
      if (props.callback) props.callback(true);
      setVisible(false);
    }
  }))));
}

function SideNavigationItem(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    key: props.path + props.title,
    type: "button",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: props.onClick,
    className: "Hover",
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      padding: 0,
      margin: 0,
      backgroundColor: 'transparent',
      border: 'none',
      position: 'relative'
    }
  }, props.active && React$4.createElement("div", {
    style: {
      height: 50,
      width: 5,
      marginRight: 5,
      backgroundColor: props.colorScheme.vibrant,
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5
    }
  }), React$4.createElement("div", {
    style: {
      height: 50,
      width: 'auto',
      marginBottom: 10,
      marginLeft: props.active ? 0 : 10,
      backgroundColor: props.active ? Colors.LIGHT_WHITE : 'transparent',
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5,
      borderTopRightRadius: props.extended ? 0 : 5,
      borderBottomRightRadius: props.extended ? 0 : 5
    }
  }, React$4.createElement("div", {
    style: {
      height: 50,
      width: 50,
      maxWidth: 50,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: props.icon.height,
    width: props.icon.width,
    color: props.active || hover ? Colors.GREY : Colors.DARK_GREY,
    iconSet: props.icon.iconSet
  }))), React$4.createElement(AnimatePresence, null, props.extended && React$4.createElement(motion.div, {
    style: {
      width: 50,
      height: 50,
      backgroundColor: props.active ? Colors.LIGHT_WHITE : 'transparent',
      position: 'absolute',
      left: 60,
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5
    },
    initial: {
      width: 0
    },
    animate: {
      width: 170
    },
    exit: {
      width: 0
    },
    transition: {
      duration: 0.2,
      type: 'linear'
    }
  }, React$4.createElement(motion.div, {
    style: {
      width: 170,
      position: 'absolute',
      height: 50,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingLeft: 5
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.1
    }
  }, React$4.createElement(Text, {
    color: props.active || hover ? Colors.GREY : Colors.DARK_GREY,
    fontWeight: props.active ? 500 : 300,
    fontSize: "1.5em"
  }, props.title)))));
}

var LogoNormal = function (_React$PureComponent) {
  _inherits$3(LogoNormal, _React$PureComponent);
  var _super = _createSuper$4(LogoNormal);
  function LogoNormal() {
    _classCallCheck$3(this, LogoNormal);
    return _super.apply(this, arguments);
  }
  _createClass$3(LogoNormal, [{
    key: "render",
    value: function render() {
      return React$4.createElement("svg", {
        height: this.props.height || '10px',
        width: this.props.width || '10px',
        fill: this.props.color || Colors.BLUE,
        viewBox: "0 0 200 50",
        xmlns: "http://www.w3.org/2000/svg"
      }, React$4.createElement("g", {
        id: "Brandbook",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, React$4.createElement("g", {
        id: "Brandbook/Logo",
        transform: "translate(-40.000000, -159.000000)",
        fillRule: "nonzero"
      }, React$4.createElement("g", {
        id: "Group",
        transform: "translate(40.333333, 159.000000)"
      }, React$4.createElement("g", {
        fill: "#0098DB",
        id: "Combined-Shape"
      }, React$4.createElement("path", {
        d: "M41.5127497,5.68434189e-14 C48.9669586,5.68434189e-14 52.8640158,3.81010461 54.6536583,7.15856999 C56.8464446,11.2643134 58.1127906,15.9455249 58.1127906,20.9286991 C58.1127906,36.9738243 45.1062633,49.9850944 29.0563953,49.9850944 C13.0065272,49.9850944 1.20792265e-13,36.9738243 1.20792265e-13,20.9286991 C1.20792265e-13,15.9455249 1.26634597,11.2643134 3.46545614,7.15856999 C5.24877482,3.81010461 9.14583202,5.68434189e-14 16.6000408,5.68434189e-14 L16.6000408,5.68434189e-14 Z M39.8889496,7.73071807 L18.2235248,7.73071807 C14.419744,7.73071807 11.3194888,10.8325543 11.3194888,14.6363351 L11.3194888,30.7731557 C11.3194888,34.5832603 14.419744,37.6771917 18.2235248,37.6771917 L39.8889496,37.6771917 C43.6990542,37.6771917 46.7929856,34.5832603 46.7929856,30.7731557 L46.7929856,26.604174 L43.0255668,26.604174 L43.0255668,30.7731557 C43.0255668,32.5027219 41.6169348,33.9097729 39.8889496,33.9097729 L18.2235248,33.9097729 C16.4955396,33.9097729 15.0869076,32.5027219 15.0869076,30.7731557 L15.0869076,14.6363351 C15.0869076,12.9067689 16.4955396,11.4997178 18.2235248,11.4997178 L39.8889496,11.4997178 C41.6169348,11.4997178 43.0255668,12.9067689 43.0255668,14.6363351 L43.0255668,18.1128579 L46.7929856,18.1128579 L46.7929856,14.6363351 C46.7929856,10.8325543 43.6990542,7.73071807 39.8889496,7.73071807 Z M36.0219305,25.1417895 L20.675588,25.1417895 L20.675588,28.9076273 L36.0219305,28.9076273 C37.0606188,28.9076273 37.9064304,28.0681395 37.9064304,27.0310322 C37.9064304,25.9876011 37.0606188,25.1417895 36.0219305,25.1417895 L36.0219305,25.1417895 Z M36.0219305,16.5018635 L20.675588,16.5018635 L20.675588,20.2692822 L36.0219305,20.2692822 C37.0606188,20.2692822 37.9064304,19.4218897 37.9064304,18.3847824 C37.9064304,17.3476751 37.0606188,16.5018635 36.0219305,16.5018635 Z"
      })), React$4.createElement("g", {
        transform: "translate(69.312697, 16.500000)",
        fill: "#37424A",
        id: "Blue-Current"
      }, React$4.createElement("path", {
        d: "M2.16755566,7.04903312 L9.7015596,7.04903312 C11.2485651,7.04903312 11.6753754,7.35541181 11.6753754,8.45605184 L11.6753754,9.30113429 C11.6753754,10.0779713 11.3796672,10.5948945 9.94045686,10.5948945 L2.16755566,10.5948945 L2.16755566,7.04903312 Z M11.6025409,4.02009498 C11.6025409,4.51959389 11.4481317,5.18317238 10.12837,5.18317238 L2.16755566,5.18317238 L2.16755566,2.00177091 L10.2084879,2.00177091 C10.4415584,2.00177091 11.6025409,2.04678389 11.6025409,2.94849558 L11.6025409,4.02009498 Z M12.6950588,5.86998337 C13.3826168,5.50697545 13.7700965,4.86517743 13.7700965,4.03751936 L13.7700965,3.02835733 C13.7700965,1.94514167 13.3258059,0.130102041 10.3556137,0.130102041 L2.79776202e-14,0.130102041 L2.79776202e-14,12.4622073 L10.5202197,12.4622073 C12.7737201,12.4622073 13.8502145,11.3659234 13.8502145,9.6772105 L13.8502145,8.280356 C13.8502145,7.02725264 13.7132856,6.22137505 12.6950588,5.86998337 L12.6950588,5.86998337 Z",
        id: "Fill-1"
      }), React$4.createElement("polygon", {
        id: "Fill-4",
        points: "16.2103447 12.4609005 18.1797904 12.4609005 18.1797904 0.130247244 16.2103447 0.130247244"
      }), React$4.createElement("path", {
        d: "M29.5374616,8.60459468 C29.5374616,10.1916653 29.1849425,10.8842845 25.7995934,10.8842845 L25.4397908,10.8842845 C22.8570784,10.8842845 22.6633385,10.2032816 22.6633385,9.15346267 L22.6633385,3.60670155 L20.6895227,3.60670155 L20.6895227,9.49469012 C20.6895227,10.6519594 21.1789708,12.5918737 24.4273909,12.5918737 L26.5323088,12.5918737 C27.9103382,12.5918737 28.9576987,12.420534 29.6336032,11.68871 L29.6336032,12.4611909 L31.5112774,12.4611909 L31.5112774,3.60670155 L29.5374616,3.60670155 L29.5374616,8.60459468 Z",
        id: "Fill-6"
      }), React$4.createElement("path", {
        d: "M42.6874449,6.59091711 L42.6874449,6.85663892 L35.4491492,6.85663892 C35.5919049,5.42638769 36.0361955,5.18244636 38.0041845,5.18244636 L40.0581183,5.18244636 C41.2598881,5.18244636 42.6874449,5.42638769 42.6874449,6.59091711 M40.0581183,3.47485707 L37.8104447,3.47485707 C35.6545426,3.47485707 33.4461996,3.90611049 33.4461996,7.10493634 L33.4461996,8.90981175 C33.4461996,12.172527 35.6938732,12.5921642 37.6458386,12.5921642 L40.1892205,12.5921642 C42.2722881,12.5921642 44.6612607,12.2799773 44.6612607,9.83330391 L44.6612607,9.39188627 L42.710752,9.39188627 L42.6932717,9.65760808 C42.6248072,10.6522498 42.1979969,10.8845749 40.4164642,10.8845749 L38.4936326,10.8845749 C36.0813529,10.8845749 35.4214721,10.434445 35.4214721,8.79655328 L35.4214721,8.56277617 L44.6612607,8.56277617 L44.6612607,7.34887766 C44.6612607,3.93660316 42.3349258,3.47485707 40.0581183,3.47485707",
        id: "Fill-7"
      }), React$4.createElement("path", {
        d: "M68.6140792,8.96193969 C68.6140792,10.2832885 68.2557333,10.7203501 66.133335,10.7203501 L60.539643,10.7203501 C58.7755906,10.7203501 58.0530721,10.0785521 58.0530721,8.50745376 L58.0530721,4.08892128 C58.0530721,2.51201485 58.7755906,1.87166887 60.539643,1.87166887 L66.0823509,1.87166887 C67.5900257,1.87166887 68.5004573,1.99073547 68.5004573,3.67944834 L68.5004573,4.50275032 L70.4742731,4.50275032 L70.4742731,3.2104421 C70.4742731,0.556128143 68.3067174,-3.19744231e-14 66.4916809,-3.19744231e-14 L60.3808637,-3.19744231e-14 C57.1877979,-3.19744231e-14 55.8913432,1.36055371 55.8913432,4.69006241 L55.8913432,7.9048606 C55.8913432,11.2343693 57.1877979,12.592019 60.3808637,12.592019 L66.4057362,12.592019 C69.9746282,12.592019 70.6854932,11.2300132 70.6854932,9.02437705 L70.6854932,7.94551749 L68.6140792,7.94551749 L68.6140792,8.96193969 Z",
        id: "Fill-8"
      }), React$4.createElement("path", {
        d: "M81.5365274,8.60459468 C81.5365274,10.1916653 81.1840083,10.8842845 77.7986593,10.8842845 L77.4388567,10.8842845 C74.8561442,10.8842845 74.6624043,10.2032816 74.6624043,9.15346267 L74.6624043,3.60670155 L72.6885885,3.60670155 L72.6885885,9.49469012 C72.6885885,10.6519594 73.1722098,12.5918737 76.4264567,12.5918737 L78.5313747,12.5918737 C79.909404,12.5918737 80.9567646,12.420534 81.632669,11.68871 L81.632669,12.4611909 L83.5103432,12.4611909 L83.5103432,3.60670155 L81.5365274,3.60670155 L81.5365274,8.60459468 Z",
        id: "Fill-9"
      }), React$4.createElement("path", {
        d: "M109.111244,6.59091711 L109.111244,6.85663892 L101.867122,6.85663892 C102.015704,5.42638769 102.454168,5.18244636 104.422157,5.18244636 L106.476091,5.18244636 C107.67786,5.18244636 109.111244,5.42638769 109.111244,6.59091711 M106.476091,3.47485707 L104.228417,3.47485707 C102.072515,3.47485707 99.8699987,3.90611049 99.8699987,7.10493634 L99.8699987,8.90981175 C99.8699987,12.172527 102.111846,12.5921642 104.063811,12.5921642 L106.607193,12.5921642 C108.69026,12.5921642 111.08506,12.2799773 111.08506,9.83330391 L111.08506,9.39188627 L109.128724,9.39188627 L109.111244,9.65760808 C109.04278,10.6522498 108.621796,10.8845749 106.835893,10.8845749 L104.911605,10.8845749 C102.505152,10.8845749 101.845271,10.434445 101.845271,8.79655328 L101.845271,8.56277617 L111.08506,8.56277617 L111.08506,7.34887766 C111.08506,3.93660316 108.758725,3.47485707 106.476091,3.47485707",
        id: "Fill-10"
      }), React$4.createElement("path", {
        d: "M120.036424,3.47558309 L117.937333,3.47558309 C116.553476,3.47558309 115.513399,3.6454708 114.830211,4.37729478 L114.830211,3.60626594 L112.958364,3.60626594 L112.958364,12.4607553 L114.926353,12.4607553 L114.926353,7.46286215 C114.926353,5.8757915 115.278872,5.18317238 118.665678,5.18317238 L119.029851,5.18317238 C121.612563,5.18317238 121.806303,5.86998337 121.806303,6.91254214 L121.806303,12.4607553 L123.774292,12.4607553 L123.774292,6.57276672 C123.774292,5.41549745 123.290671,3.47558309 120.036424,3.47558309",
        id: "Fill-11"
      }), React$4.createElement("path", {
        d: "M125.550143,5.31341962 L125.550143,9.69419928 C125.550143,11.6166893 126.738803,12.5924546 129.084075,12.5924546 L129.79494,12.5924546 L129.79494,10.8848653 L129.305492,10.8848653 C127.905612,10.8848653 127.523959,10.5087891 127.523959,9.15404348 L127.523959,5.31341962 L129.824074,5.31341962 L129.824074,3.60583033 L127.523959,3.60583033 L127.523959,1.64558753 L125.550143,1.64558753 L125.550143,5.31341962 Z",
        id: "Fill-12"
      }), React$4.createElement("path", {
        d: "M91.4089568,3.47558309 L90.1008486,3.47558309 C89.110299,3.47558309 88.3426231,3.7369488 87.8123877,4.25242005 L87.8123877,3.60626594 L85.9347134,3.60626594 L85.9347134,12.4607553 L87.9099859,12.4607553 L87.9099859,6.91254214 C87.9099859,6.07326781 88.4096308,5.18317238 89.821164,5.18317238 L90.6864383,5.18317238 C90.9544694,5.18317238 91.1933666,5.1889805 91.4089568,5.19478863 L91.4089568,3.47558309 Z",
        id: "Fill-13"
      }), React$4.createElement("path", {
        d: "M98.4648749,3.47558309 L97.15094,3.47558309 C96.1603903,3.47558309 95.3985411,3.7369488 94.862479,4.25242005 L94.862479,3.60626594 L92.9906315,3.60626594 L92.9906315,12.4607553 L94.9600773,12.4607553 L94.9600773,6.91254214 C94.9600773,6.07326781 95.4655489,5.18317238 96.8770821,5.18317238 L97.7423564,5.18317238 C98.0103874,5.18317238 98.2492847,5.1889805 98.4648749,5.19478863 L98.4648749,3.47558309 Z",
        id: "Fill-14"
      }))))));
    }
  }]);
  return LogoNormal;
}(React$4.PureComponent);

var LogoVerticalDiapositive = function (_React$PureComponent) {
  _inherits$3(LogoVerticalDiapositive, _React$PureComponent);
  var _super = _createSuper$4(LogoVerticalDiapositive);
  function LogoVerticalDiapositive() {
    _classCallCheck$3(this, LogoVerticalDiapositive);
    return _super.apply(this, arguments);
  }
  _createClass$3(LogoVerticalDiapositive, [{
    key: "render",
    value: function render() {
      return React$4.createElement("svg", {
        width: this.props.width || '130px',
        height: this.props.height || '62px',
        viewBox: "0 0 130 62",
        xmlns: "http://www.w3.org/2000/svg"
      }, React$4.createElement("g", {
        fill: "#FFF",
        fillRule: "evenodd"
      }, React$4.createElement("path", {
        d: "M74.61.011c5.964 0 9.081 3.048 10.513 5.727a23.312 23.312 0 0 1 2.767 11.016C87.89 29.59 77.485 40 64.645 40 51.805 40 41.4 29.59 41.4 16.754c0-3.986 1.013-7.731 2.772-11.016C45.6 3.06 48.717.011 54.68.011Zm-1.299 6.185H55.98a5.534 5.534 0 0 0-5.523 5.524v12.91a5.53 5.53 0 0 0 5.523 5.523H73.31a5.526 5.526 0 0 0 5.523-5.523v-3.335H75.82v3.335a2.513 2.513 0 0 1-2.509 2.51H55.98a2.513 2.513 0 0 1-2.51-2.51V11.72a2.513 2.513 0 0 1 2.51-2.509H73.31a2.513 2.513 0 0 1 2.51 2.51v2.78h3.013v-2.78a5.53 5.53 0 0 0-5.523-5.525Zm-3.093 13.929H57.94v3.012h12.278a1.505 1.505 0 1 0 0-3.012Zm0-6.912H57.94v3.014h12.278a1.51 1.51 0 0 0 1.507-1.508 1.51 1.51 0 0 0-1.507-1.506ZM2.168 56.178h7.534c1.547 0 1.973.306 1.973 1.407v.845c0 .777-.295 1.294-1.735 1.294H2.168v-3.546Zm9.435-3.03c0 .5-.155 1.164-1.475 1.164h-7.96V51.13h8.04c.234 0 1.395.045 1.395.947v1.072Zm1.092 1.85c.688-.362 1.075-1.004 1.075-1.832v-1.009c0-1.083-.444-2.898-3.414-2.898H0V61.59h10.52c2.254 0 3.33-1.096 3.33-2.785v-1.397c0-1.253-.137-2.059-1.155-2.41ZM16.21 61.59h1.97V49.259h-1.97zM29.537 57.733c0 1.587-.352 2.28-3.737 2.28h-.36c-2.583 0-2.777-.681-2.777-1.73v-5.548H20.69v5.888c0 1.158.489 3.098 3.737 3.098h2.105c1.378 0 2.426-.172 3.102-.904v.773h1.877v-8.855h-1.974v4.998ZM42.687 55.72v.265H35.45c.143-1.43.587-1.674 2.555-1.674h2.054c1.202 0 2.63.244 2.63 1.409m-2.63-3.116H37.81c-2.155 0-4.364.43-4.364 3.63v1.804c0 3.263 2.248 3.683 4.2 3.683h2.543c2.083 0 4.472-.312 4.472-2.759v-.441h-1.95l-.018.265c-.068.995-.495 1.227-2.277 1.227h-1.922c-2.413 0-3.073-.45-3.073-2.088v-.234h9.24v-1.213c0-3.413-2.326-3.874-4.603-3.874M68.614 58.09c0 1.322-.358 1.759-2.48 1.759H60.54c-1.764 0-2.487-.642-2.487-2.213v-4.418c0-1.577.723-2.218 2.487-2.218h5.542c1.508 0 2.418.12 2.418 1.808v.823h1.974V52.34c0-2.654-2.167-3.21-3.982-3.21H60.38c-3.193 0-4.49 1.36-4.49 4.69v3.215c0 3.33 1.297 4.687 4.49 4.687h6.025c3.569 0 4.28-1.362 4.28-3.568v-1.079h-2.072v1.017ZM81.537 57.733c0 1.587-.353 2.28-3.738 2.28h-.36c-2.583 0-2.777-.681-2.777-1.73v-5.548H72.69v5.888c0 1.158.483 3.098 3.737 3.098h2.105c1.378 0 2.426-.172 3.102-.904v.773h1.877v-8.855h-1.973v4.998ZM109.111 55.72v.265h-7.244c.149-1.43.587-1.674 2.555-1.674h2.054c1.202 0 2.635.244 2.635 1.409m-2.635-3.116h-2.248c-2.155 0-4.358.43-4.358 3.63v1.804c0 3.263 2.242 3.683 4.194 3.683h2.543c2.083 0 4.478-.312 4.478-2.759v-.441h-1.956l-.018.265c-.068.995-.49 1.227-2.275 1.227h-1.924c-2.407 0-3.067-.45-3.067-2.088v-.234h9.24v-1.213c0-3.413-2.326-3.874-4.609-3.874M120.036 52.604h-2.099c-1.384 0-2.424.17-3.107.902v-.771h-1.872v8.854h1.968v-4.997c0-1.588.353-2.28 3.74-2.28h.364c2.583 0 2.776.687 2.776 1.73v5.547h1.968v-5.888c0-1.157-.483-3.097-3.738-3.097M125.55 54.442v4.38c0 1.923 1.189 2.9 3.534 2.9h.71v-1.708h-.489c-1.4 0-1.781-.377-1.781-1.731v-3.84h2.3v-1.708h-2.3v-1.96h-1.974v3.667ZM91.409 52.604h-1.308c-.99 0-1.758.262-2.289.777v-.646h-1.877v8.854h1.975v-5.548c0-.839.5-1.73 1.911-1.73h.865c.268 0 .507.007.723.012v-1.719ZM98.465 52.604H97.15c-.99 0-1.752.262-2.289.777v-.646h-1.871v8.854h1.97v-5.548c0-.839.505-1.73 1.916-1.73h.865c.268 0 .507.007.723.012v-1.719Z"
      })));
    }
  }]);
  return LogoVerticalDiapositive;
}(React$4.PureComponent);

var LogoHorizontalDiapositive = function (_React$PureComponent) {
  _inherits$3(LogoHorizontalDiapositive, _React$PureComponent);
  var _super = _createSuper$4(LogoHorizontalDiapositive);
  function LogoHorizontalDiapositive() {
    _classCallCheck$3(this, LogoHorizontalDiapositive);
    return _super.apply(this, arguments);
  }
  _createClass$3(LogoHorizontalDiapositive, [{
    key: "render",
    value: function render() {
      return React$4.createElement("svg", {
        height: this.props.height || '50px',
        width: this.props.width || '200px',
        viewBox: "0 0 200 50",
        xmlns: "http://www.w3.org/2000/svg"
      }, React$4.createElement("g", {
        fill: "#FFF",
        fillRule: "evenodd"
      }, React$4.createElement("path", {
        d: "M41.513 0c7.454 0 11.351 3.81 13.14 7.159a29.14 29.14 0 0 1 3.46 13.77c0 16.045-13.007 29.056-29.057 29.056C13.006 49.985 0 36.974 0 20.93c0-4.983 1.266-9.665 3.465-13.77C5.25 3.81 9.145 0 16.6 0Zm-1.624 7.73H18.224c-3.804 0-6.905 3.103-6.905 6.906v16.137c0 3.81 3.1 6.904 6.905 6.904h21.665a6.908 6.908 0 0 0 6.904-6.904v-4.169h-3.767v4.17a3.141 3.141 0 0 1-3.137 3.136H18.224a3.141 3.141 0 0 1-3.137-3.137V14.636a3.141 3.141 0 0 1 3.137-3.136h21.665a3.141 3.141 0 0 1 3.137 3.136v3.477h3.767v-3.477c0-3.803-3.094-6.905-6.904-6.905Zm-3.867 17.412H20.676v3.766h15.346c1.039 0 1.884-.84 1.884-1.877 0-1.043-.845-1.89-1.884-1.89Zm0-8.64H20.676v3.767h15.346a1.888 1.888 0 0 0 1.884-1.884 1.887 1.887 0 0 0-1.884-1.883ZM71.387 23.549h7.534c1.547 0 1.973.306 1.973 1.407v.845c0 .777-.295 1.294-1.735 1.294h-7.772v-3.546Zm9.434-3.029c0 .5-.154 1.163-1.474 1.163h-7.96v-3.181h8.04c.234 0 1.394.045 1.394.946v1.072Zm1.093 1.85c.688-.363 1.075-1.005 1.075-1.832v-1.01c0-1.083-.444-2.898-3.414-2.898H69.219v12.332h10.52c2.254 0 3.33-1.096 3.33-2.785V24.78c0-1.253-.137-2.059-1.155-2.41ZM85.43 28.96h1.969V16.63h-1.97zM98.756 25.105c0 1.587-.352 2.28-3.737 2.28h-.36c-2.583 0-2.777-.682-2.777-1.732v-5.546h-1.974v5.888c0 1.157.49 3.097 3.738 3.097h2.105c1.378 0 2.426-.171 3.102-.903v.772h1.877v-8.854h-1.974v4.998ZM111.906 23.09v.267h-7.238c.143-1.43.587-1.675 2.555-1.675h2.054c1.202 0 2.63.244 2.63 1.409m-2.63-3.116h-2.248c-2.156 0-4.364.431-4.364 3.63v1.805c0 3.263 2.248 3.682 4.2 3.682h2.543c2.083 0 4.472-.312 4.472-2.759v-.441h-1.95l-.018.266c-.068.994-.495 1.227-2.277 1.227h-1.922c-2.413 0-3.073-.45-3.073-2.088v-.234h9.24v-1.214c0-3.412-2.326-3.874-4.603-3.874M137.833 25.462c0 1.321-.358 1.758-2.48 1.758h-5.594c-1.764 0-2.487-.641-2.487-2.213V20.59c0-1.577.723-2.217 2.487-2.217h5.542c1.508 0 2.418.119 2.418 1.807v.824h1.974V19.71c0-2.654-2.167-3.21-3.982-3.21H129.6c-3.193 0-4.49 1.36-4.49 4.69v3.215c0 3.33 1.297 4.687 4.49 4.687h6.025c3.569 0 4.28-1.362 4.28-3.568v-1.078h-2.072v1.016ZM150.755 25.105c0 1.587-.352 2.28-3.737 2.28h-.36c-2.583 0-2.777-.682-2.777-1.732v-5.546h-1.973v5.888c0 1.157.483 3.097 3.737 3.097h2.105c1.378 0 2.426-.171 3.102-.903v.772h1.877v-8.854h-1.974v4.998ZM178.33 23.09v.267h-7.244c.149-1.43.587-1.675 2.555-1.675h2.054c1.202 0 2.635.244 2.635 1.409m-2.635-3.116h-2.248c-2.156 0-4.358.431-4.358 3.63v1.805c0 3.263 2.242 3.682 4.194 3.682h2.543c2.083 0 4.478-.312 4.478-2.759v-.441h-1.956l-.018.266c-.068.994-.49 1.227-2.275 1.227h-1.924c-2.407 0-3.067-.45-3.067-2.088v-.234h9.24v-1.214c0-3.412-2.326-3.874-4.609-3.874M189.255 19.976h-2.099c-1.384 0-2.424.17-3.107.901v-.77h-1.872v8.854h1.968v-4.998c0-1.587.353-2.28 3.74-2.28h.364c2.583 0 2.776.687 2.776 1.73v5.548h1.968v-5.888c0-1.158-.483-3.097-3.738-3.097M194.77 21.813v4.381c0 1.923 1.188 2.898 3.533 2.898h.71v-1.707h-.489c-1.4 0-1.781-.376-1.781-1.731v-3.84h2.3v-1.708h-2.3v-1.96h-1.974v3.667ZM160.628 19.976h-1.308c-.99 0-1.758.26-2.289.776v-.646h-1.877v8.855h1.975v-5.548c0-.84.5-1.73 1.911-1.73h.865c.268 0 .507.006.723.012v-1.72ZM167.684 19.976h-1.314c-.99 0-1.753.26-2.289.776v-.646h-1.871v8.855h1.969v-5.548c0-.84.505-1.73 1.917-1.73h.865c.268 0 .507.006.723.012v-1.72Z"
      })));
    }
  }]);
  return LogoHorizontalDiapositive;
}(React$4.PureComponent);

var LogoApp = function (_React$PureComponent) {
  _inherits$3(LogoApp, _React$PureComponent);
  var _super = _createSuper$4(LogoApp);
  function LogoApp() {
    _classCallCheck$3(this, LogoApp);
    return _super.apply(this, arguments);
  }
  _createClass$3(LogoApp, [{
    key: "render",
    value: function render() {
      return React__default.createElement("svg", {
        viewBox: "0 0 1112 1112",
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        height: this.props.height || '10px',
        width: this.props.width || '10px',
        style: {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          strokeLinejoin: 'round',
          strokeMiterlimit: 2
        }
      }, React__default.createElement("path", {
        d: "M74.61 0c6 0 9.08 3.05 10.51 5.73a23.258 23.258 0 0 1 2.775 11.015c0 12.755-10.495 23.25-23.25 23.25s-23.25-10.495-23.25-23.25c0-3.844.954-7.629 2.775-11.015C45.6 3.06 48.72 0 54.68 0h19.93Zm-1.3 6.2H56c-3.026.005-5.515 2.494-5.52 5.52v12.91c0 3.028 2.492 5.52 5.52 5.52h17.31c3.028 0 5.52-2.492 5.52-5.52v-3.34h-3v3.34a2.531 2.531 0 0 1-2.51 2.51H56a2.531 2.531 0 0 1-2.51-2.51V11.72A2.531 2.531 0 0 1 56 9.21h17.31a2.531 2.531 0 0 1 2.51 2.51v2.78h3v-2.78c0-3.024-2.486-5.515-5.51-5.52Zm-3.09 13.92H57.94v3h12.28a1.517 1.517 0 0 0 1.683-1.5 1.517 1.517 0 0 0-1.683-1.5Zm0-6.91H57.94v3h12.28a1.516 1.516 0 0 0 1.337-1.5c0-.763-.579-1.412-1.337-1.5Z",
        style: {
          fill: '#0098db',
          fillRule: 'nonzero'
        },
        transform: "matrix(23.49196 0 0 23.49196 -963.084 85.772)"
      }));
    }
  }]);
  return LogoApp;
}(React__default.PureComponent);

function Logo(props) {
  var render = function render() {
    switch (props.type) {
      case 'Normal':
        return React$4.createElement(LogoNormal, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'VerticalDiapositive':
        return React$4.createElement(LogoVerticalDiapositive, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'HorizontalDiapositive':
        return React$4.createElement(LogoHorizontalDiapositive, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'App':
        return React$4.createElement(LogoApp, {
          height: props.height,
          width: props.width
        });
      default:
        return React$4.createElement("div", null);
    }
  };
  return render();
}

function SideBarNavigation(props) {
  var size = useDimensions();
  var _React$useState = React$4.useState(true),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      extended = _React$useState2[0],
      setExtended = _React$useState2[1];
  React$4.useEffect(function () {
    if (props.alwaysOpen) {
      setExtended(true);
    } else {
      setExtended(false);
    }
  }, [props.alwaysOpen]);
  return React$4.createElement("div", {
    className: "Blur",
    onMouseEnter: function onMouseEnter() {
      if (!props.alwaysOpen) setExtended(true);
    },
    onMouseLeave: function onMouseLeave() {
      if (!props.alwaysOpen) setExtended(false);
    },
    style: {
      width: extended ? 240 : 70,
      height: size.height,
      position: 'absolute',
      transition: 'all .2s linear',
      borderRight: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      paddingTop: 0,
      paddingBottom: 10,
      zIndex: 2147483004,
      overflow: 'hidden',
      backgroundColor: Backgrounds.BLUR
    }
  }, React$4.createElement("div", {
    style: {
      height: 60,
      width: '100%',
      backgroundColor: Colors.WHITE,
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10
    }
  }, React$4.createElement(Logo, {
    type: "Normal",
    height: 50,
    width: 170
  })), React$4.createElement("div", {
    style: {
      position: 'absolute',
      height: 50,
      width: '100%',
      background: "linear-gradient(0deg, ".concat(Colors.WHITE, "15 0%, ").concat(Colors.WHITE, " 70%)"),
      zIndex: 1
    }
  }), React$4.createElement("div", {
    style: {
      height: 'calc(100% - 40px)',
      width: extended ? 253 : 70,
      backgroundColor: 'transparent',
      paddingLeft: 0,
      paddingTop: 100,
      overflowY: 'scroll',
      overflowX: 'hidden',
      paddingRight: 83,
      transition: 'all .2s linear'
    }
  }, props.items.map(function (e) {
    return React$4.createElement(SideNavigationItem, {
      key: e.path,
      title: e.title,
      path: e.path,
      icon: e.icon,
      active: e.active,
      colorScheme: getColorScheme(e.colorScheme),
      extended: extended,
      onClick: e.onClick
    });
  })));
}

function TabNavigationItem(props) {
  return React$4.createElement("div", {
    style: {
      width: '100%',
      transition: 'all .3s ease-in-out .1s'
    }
  }, React$4.createElement("button", {
    onClick: function onClick() {
      props.onClick();
    },
    type: "button",
    style: {
      height: 50,
      width: '100%',
      backgroundColor: 'transparent',
      border: 'none'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'inline-block'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      paddingLeft: 10,
      paddingRight: 10,
      borderRadius: 20,
      paddingTop: 5,
      paddingBottom: 5,
      backgroundColor: 'transparent'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      height: 30,
      widht: 30,
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: props.icon.height,
    width: props.icon.width,
    color: props.active ? props.colorScheme.vibrant : Colors.GREY,
    iconSet: props.icon.iconSet
  }))))));
}

function TabNavigation(props) {
  return React$4.createElement("div", {
    style: {
      height: 60,
      width: '100%',
      backgroundColor: Colors.WHITE,
      position: 'fixed',
      bottom: 0,
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderLeft: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRight: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderTopRightRadius: 15,
      borderTopLeftRadius: 15,
      zIndex: 10000
    }
  }, props.items && props.items.map(function (e) {
    var _e$colorScheme;
    return React$4.createElement(TabNavigationItem, {
      key: e.title,
      title: e.title,
      icon: e.icon,
      active: e.active,
      onClick: e.onClick,
      colorScheme: getColorScheme("".concat((_e$colorScheme = e.colorScheme) !== null && _e$colorScheme !== void 0 ? _e$colorScheme : 'blue'))
    });
  }));
}

function UMOVE(props) {
  var _props$color, _props$color2;
  return React__default.createElement("svg", {
    viewBox: "0 0 450 350",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 1.5,
      position: 'relative',
      zIndex: 1
    },
    width: "100%",
    height: "100%"
  }, React__default.createElement("path", {
    style: {
      fill: 'none'
    },
    d: "M0 0h450v350H0z"
  }), React__default.createElement("g", null, React__default.createElement("use", {
    xlinkHref: "#UMOVE_Body",
    x: 58.025,
    y: 42.349,
    width: 334.221,
    height: 307.693,
    transform: "scale(.99767 .999)"
  }), React__default.createElement("path", {
    d: "M81.904 350V108.35c0-20.541 16.871-34.194 37.193-37.193 42.399-6.256 169.407-6.659 211.806 0 20.293 3.188 37.193 16.652 37.193 37.193V350H81.904Z",
    style: {
      fill: '#fdfdfd'
    }
  }), React__default.createElement("use", {
    xlinkHref: "#UMOVE_TopBody",
    x: 109.111,
    y: 27.806,
    width: 231.886,
    height: 263.25,
    transform: "scale(.9995 .99716)"
  }), React__default.createElement("path", {
    d: "M306.963 67.248c0-.859-.651-1.576-1.505-1.659-53.294-5.141-106.93-5.175-160.915.001-.854.082-1.506.8-1.506 1.659v149.735c0 22.091 17.908 40 40 40h83.926c22.092 0 40-17.909 40-40V67.248Z",
    style: {
      fill: '#fdfdfd',
      stroke: '#fdfdfd',
      strokeWidth: 20
    }
  }), React__default.createElement("path", {
    d: "M271.95 261.941a40 40 0 0 0 40-40V108.963h-8.152a1.845 1.845 0 0 0-1.845 1.845v101.17c0 22.091-17.908 40-40 40h-73.922c-22.092 0-40-17.909-40-40V110.797a1.834 1.834 0 0 0-1.834-1.834h-8.147v112.978a40 40 0 0 0 40 40h93.9Z",
    style: {
      fill: '#EEEEEE',
      stroke: '#EEEEEE',
      strokeWidth: 10,
      strokeLinejoin: 'miter'
    }
  }), React__default.createElement("path", {
    d: "M271.95 261.941a40 40 0 0 0 40-40V108.963h-8.152a1.845 1.845 0 0 0-1.845 1.845v101.17c0 22.091-17.908 40-40 40h-73.922c-22.092 0-40-17.909-40-40V110.797a1.834 1.834 0 0 0-1.834-1.834h-8.147v112.978a40 40 0 0 0 40 40h93.9Z",
    style: {
      fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : '#ef6a6b',
      stroke: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : '#ef6a6b',
      strokeWidth: 10,
      strokeLinejoin: 'miter'
    }
  })), React__default.createElement("defs", null, React__default.createElement("image", {
    id: "UMOVE_Body",
    width: 335,
    height: 308,
    xlinkHref: "data:image/png;base64,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"
  }), React__default.createElement("image", {
    id: "UMOVE_TopBody",
    width: 232,
    height: 264,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOgAAAEICAYAAABVmrhOAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAUsUlEQVR4nO2d7XKkug5F3bnn/R95cn9MMeUo+tiSDYjuvapSGNsYQ7Rahs6c8xrkTl53TwDk++4JfCpPCZCz4X3oycd/MLxrYL7rdRGftxO6eyB3n98KT722t5NgNL6mbkFyx3y63QPykzvkaSPsXcF5xXm7iddtPrvoEsxXzOPya706aFbOd9Vc31Wkp3CVBCvnuUzUs4OxOn53kSnxGmcG+B3inXY9ZwVadtxM/x1z7vrB9HTOziw7xs+MkT3f9uvfHUjoeEi/XX0QrhTq6fJe+Ry261zIOLv6ZPqF7AyWVaGqbZV+u4/teJ6zeKdnRK9ftS07B5fVYFmRMluPnq/St9L/6vG6s1vcM58HK/Jl67N9VM7MOKiAWr+rs+kVH1SfyKq0leOjY7JyyrqqqKV7ccZbVlS4SNSzM2yl/+pxd4+N0PUNa+b4HRkSEROtQ9pUKsGQEWRlP5NZmVXv58psuSpqJFZWVjTLRm2/2JVxquKtCrrjTe8dz6pPlffqrzmQ/tVnQE8qtK0qKnwPdmSUiowr5ex8su1on5X+Z4+zypVfb2T7V4XNZM1d5ex8frG6NKyKhtZp585k0VVZuz2j7hr3rOfMs968nvniJyqjdWg5mtsPdn5NgsiX6WPVWXPqJmpXSTvJeaeY874nIdIWSWzNx6sfY9QFRTPk6hYte3VI24721f5P5+pnyyuy5urWK3t1/6gE5YqcaB1yHmR+SD3anu2367iunPmHBEi/s541tS1ap229slc3xsgHbUVOpOzVWefQ5mfVIe1nCdplqdtlaXvGVyRRe/bZEpEyI6tXtuY8xsgtCaNnzqyUiLDa1it7dZX6ar9q/6vG2y1rF0kr2RPNnKigiKzI/hhjjP+0SoCMnNl9rWydV5azdUgb0l7te+YYFXaIe9WzKLpUtKR8KXVH/VE3l7V9eZ6XKGvbFGhGqS5nvbpIVmQbzdWrW23b0X/38btYFbWTpNWXQFYGjdqGUta20VzHGHoGrQQJImK2fQBbbb47lrxRW6Xf7mOvZEXY1eVstm1V0DnbzaLNvJw2LTuj/MqyyBI3yp6yPfujHSfHRkRF9qN6tD3bb9dxd1MVdYekXjsqaUbMAymrJaZ2Pm/JO0RZJfMMGi17d/6MoGzNIZpzVB+1Ie27jnkKVy1nvfbqy6HohRAio0flWfYHUtDsclETS6uPfr7GbxlXBc0Iu6t91zFPohLAZ0gq6yuCSqH+BPOwzi9/517GdOXNvsW1lrZDqfdEXM2m81aWtf2oPmpD2lf7P52OmTR6/oyy5pfRponrPXtqS12IWdBK8KJiWXIiwg6lLOcULXWj60Pas/12HdcVKwjR46L+Z2VRVFBPyC9RN8uJztUT9V+bl0EjKb02dEmLiCrPWRV0V3u231nHX01VSHk8KqbVD223yhlBDwm/xm9RvZizhPTaVFkzb3G1ZWSUNTUBrbK2L8eL5uPto21Ie7YfSjdp5bPRyjjI8UgmQsWVfS1B5dtbT8wvoyzPo81Re84Ml7uVZ1BE1EwWRZ9Lh7OVZW1fu5aV9l3H3DlutIysnreSbVfk1M4ps6eUQko5Mz97/hm2jEgcah9ypWfQGSQ7SVmjLKpJiUqqjS/npv3ydkpYDdZuWXFmx9y85VzmuFU5LTG0lzdW5tSWuF/Gdp6zlrW1pbj5tlbZH2PEGRS50YiYmQz65Yw5nK03XzQQd/er0EVo9FM+M9/skrn6PGpJqWXPIfbn50wpZRSDnqgWqpgH/02dIqIM5U3aEtB7Hq1kUW+uSNtK3yvGuZJKFqyO6b3N9PpaWdMTxcqeB9Zz52voonrL5yHKw6mTvMYY39Vn0FmUMX5Lg2ZPLZuOkc+ich5RnXVtqzxRxBWi613Jwqi03jOeFBXJnq+hL2VnOa2E4UmKXNsvkD+Wj7KRJaVW58l6VQat9Nt97Kcw36OVbOsdq/XTRLUym5Y9vaWtFo/fSj2yzJWZ9FdmrXwPqrVnpaz+DGeLzDnbb9dxZJ+s3vGWmFo/9A12tJKzxNQ+DLxzlb8HlZMcifKKuNbf5w5lq51fu4YVKOc+EEF2HS+zp5W15F8LRYJ+K/tybl55INew+j2odxHacVk5rXHvEPTqcd+FzAugq5mlkX++Fwmqia5l0JKYB/+N+o2KlpjIUhXNrlp/eT5tP5r7VXQIxjNBnxF3nueMeyrjV5PN+vGyZnXF8Ir+uRk8kCh7okV9IoGHsl2d/67jz2T33FaWmJKr5nbGeV5K+TiXjL9vsY+KmuHHcdU/VLCyZ3QDsyJqdZGk3rx30FniDHddBxK01blZf70jM5lst46xMme0YshkUXc89E/90LZ5gpmfIbZoVkXnlO1HzmPH7yDzHal2Pqt+btO+OkF+Sm9rrbbqf5NoLq/ccG8Ji8h5Zfak3HtZfYuLjCuXr96SVtZFmQ+dp/eXReHY1a9Zqu3eEtYbJ5IzIw9F68HqMhYZ11pmvkS7PNb6LtOKYW0OUbbUzv+L6n+4Wp5o3kcvRBPVGkf2ieSkhO8Lmj2PvtFfE2nHa2Jaz4/RMnclAy//l+V3YGVT2SeS80lSPmmuMzvf/J6Blz3nMpJB5bE75pYeazWDHidG+nhZFc2y2jFnBPtTBTqbs+/LGV/9RG9QrfNqmRBd4lpjpNkhqEdliYssbVE5KdqzOOO5VHv+9Ja6Wlu0xD2NXYJaz6KVY3fPhbw/2tJ217jo97aaA8tz+Yq7mFjLVOTtljVWdGzUl3ISJL4ycSbbKseW49ITNHr229m2A8pJDu6MtUqbecxKBl1h99qdchLJ7vi6JcauEhT55Mg8x1JIkiXzTQHy9d0lMXhXBo14h+86SU8eFVtdBSWEjGsEbfnJRMgGTo9tZlBCGkNBCWkMBSWkMRSUkMZQUEIaQ0EJaQwFJaQxFJSQxlBQQhpDQQlpDAUlpDEUlJDGUFBCGkNBCWkMBSWkMRSUkMZQUEIaQ0EJaQwFJaQxFJSQxlBQQhpDQQlpDAUlpDEUlJDGUFBCGkNBCWkMBSWkMRSUkMZQUEIaQ0EJaQwFJaQxFJSQxlBQQhpDQQlpDAUlpDEUlJDGUFBCGkNBCWkMBSWkMRSUkMZQUEIaQ0EJaQwFJaQxFJSQxlBQQhpDQQlpDAUlpDEUlJDGUFBCGkNBCWkMBSWkMRSUkMZQUEIaQ0EJaQwFJaQxFJSQxlBQQhpDQQlpDAUlpDEUlJDGUFBCGkNBCWkMBSWkMRSUkMZQUEIaQ0EJaQwFJaQxFJSQxlBQQhpDQQlpDAUlpDEUlJDGUFBCGkNBCWkMBSWkMRSUkMZQUEIaQ0EJaQwFJaQxFJSQxlBQQhpDQQlpDAUlpDEUlJDGUFBCGkNBCWkMBSWkMRSUkMZQUEIaQ0EJaQwFJaQxFJSQxlBQQhpDQQlpDAUlpDEUlJDGUFBCGkNBCWkMBSWkMRSUkMZQUEIaQ0EJaQwFJaQxFJSQxlBQQhpDQQlpDAUlpDEUlJDGUFBCGkNBCWkMBSWkMRSUkMZQUEIaQ0EJaQwFJaQxFJSQxlBQQhpzhaDfF5yDkDs4PbbvzqCUl3Tn1hi9W1ALikuupmXMVQStXEjLiydkgUs86JpBZyg3OQs0tm6LQU/QqydFEUkX2sT+SgbVBs18InGpTO6gGkMr2bYct1cucbOT9PpTVJJlZzxdFn87Bf0WW6tP5uIoIjmbbDwiom+L212Cygm1/UQiBGQ1hrfEdFVQ5OSUjnwKp/mwI4OuLmm/jfKuOZDPZEcsIbF76ruSq14SWW+2KBbpjhWnl8TuqqA7X/hED9iUmewiirHMqq96LghLUO2BF11nzz9eOyFPAo3rjCey7hdIBkXW5NHEM+eI9ik3qeLFUeUtbCXuU7EsBa2k7p0XIsvohRLiESWWbAxmE095SXzVv2aZj+UylzyRHXGbPnb1e1Drk6VyMcinDaUmq+z+S6Ao5itj/uMrOHDH2yrku6LK+l/2o7zkoBIXUqRK3GbPGfX9PutP/aw+6KeNNiZlJCtkXhDJtsrKcEuM7vjnZsgyF70BcrzsUpnikkysWC+IsnF7yvJ2DF1QRDzZdyht2rg7Lqi6HCafRzZTWsdUEo52znTcf1kNxgCZ/cySwJp0ZZlLYT8XJCa8OEOfP+c+yOMasq+Nv32JGz04R59GnqgUj+wiWt5q/ZCEg4yZIvuXRFZbJBa69NX2o/Nqc6TMn0e0bMzGU/aRTWtDz2uSzaBZ2ay2KHta4jOTkhVWYi5KOBmpYTKCWuv47NLA6oeMp82HWZRUYiMTw1pdFNfaeNZ8TSJB0U8D9NNHO1b208ZD5aOkn8dKbKAxV4lry4loXj/I/HOz6ATIUtT75NmVba35kfejGpdIVoza5LlW41Ltu/svibJLAuuGeGNadXIuUR15NsjvGY0hK/4ysWuNucT/xP5LKcut5GX0lfXoD3Lu1/Dnas3XugbyLCI5vXIkoVWPZlrvnNFy99eckf/1Q/SJEE1M65u5cO84a67WfJlJnw8qJ7KSk/2zGXModV7WtuZoxmX1H2xbE53bdnw6RZ881o32roeSPpesnFHcVGMQTSzyfAg/+skl7hj2MlFbsmrHaX28paxXr40rz4ksi72lLZe9vfECO5JzbltNFNYxQynLvt58XSJB531ULGuLCoo+h1pztI6hpM9jVc7d2RHNnJlVmts3K+ixjV7AIFJrdVVBvf7W9SBjkWtBAltbPlrbs3+s82j1mWv8R1XQYyul8vrJY7QxVgSNjqmIGp2H5EgFZ3BslEGvlFM7dzR/CETQuS4SC82i3hhaP21e2jmt/tFSl8L1JAp0S1JNEkS6P8U265zW3OGlsCboGHgWtYiy7lz2sqo1XlSP9LGOoaz3YgVtZWl77Eu5/hj1GRG97JkV17rGtKBzOZtFx8BEzC5z0Yxv9Uc/bMg5oFlH29+1tNUEzoqazZ4QlqBjYFkUyVzWMV421cbPPItm5mS17+LdBS89WxXGjMQ8tqiMVlatLmuz0nofPP+oCKqVEbFkG5JJZT9rbh6rWfTdBbubahBLMeYymillnZY5PUnl+a05l7LnGL6gY+SzaJSVPEHnMrLE3SXOjkxKiXWyAYlmzrmMCipFlFutvfIj54Rcp9m3KuhRjpa7lUwq+2t9vTmO4d8cPo/eD/q8pu17y1q578mmLXUjSbU67ZzevFNEgo6BZdG5TVuyav3kFil787Io3ZjCeUiNKGvK/crSNhIuklQeK8+pzd9a1sLZc4w1Qedy9MLIO84axxovI6r3yYtAOa8BDWIre87lSExteYtkz+wyV5tvGkTQMfAsamXQ6HirjDyLIlg3aDW7zlDmn2TuLZIx53I2e6Jy/lHqPAm9DJq9TpVVQeey9XyIPptmt9Y5Z6JP4oidAn8aK/fYy0LWEhNd3iIZ1MvAVqbU5mNdHwwq6Bh4FkQySTVzevPxQH7hsuzVWeeIfpHvxuo1r8oZzcHLnhVZox/0uqw+v/gP6RTwPX7Kou1rxxz8Gb//FxRH3Z/xU1Kt7jV+/sPz76leLrePNms7z0G7huoy9p0lrZAJYCSDWtk08/Kn+ocKyDWUyWTQMWovjKI3utFYXrs11kzmF68tW+Sx754Vz8ILauu+I3LKfU+yVWGtbKllTy+jwvGTFXSM3Asj2S9aAu8QUsO6WZqciKhzPfLJ+glk70ckJpIxkfN6fxmU+bO/6MPa+p0vZdVKsGe/3zy26M+Xs++1RT9DKWtbryzhm1sMLyiRD0+5ReXMSIpmTutDQttq1365oLLOknMur4qaldMSM7Osju4BiUGyjBXkSEatSroiZkZO7x6oVF4SfY/fATrXHeV5O0QZYX55dOzPcs77lSz6LermeQ6lPJS+JE8UtFEWrQrqSdhSzjHqb3GvlHSWUquvCjqM7Ty/aLVg8akZFvndIoHrLR1XBF2R8nI5x1j7miWSVKuTwmaoSrnyHKrJGs390zMseu2WlHP5TEFX5PSudZucY+z5HtRCijljBfFxTPRsevSN/sv4q4LKOXugAn8K0X3YLahWN2fLMZUzWTLKnMi1llkVFM2YVnk1k3pZdQR1w9kOcB9t+0S8360n57zviTmXd2dVa2xtvpWMCnPGXxLJOtk+T7giKZJlI0GRrSxr+xafKiv6u6xmz2O7IijSzzqPdx3b5RxjbyBFL1S0spfZPNGy2TKTPVeyqORTRM0EYiV7yi0qqFaHZsvMsvYUOcfY+wxaWe5WLsLKoLJtKO07BLXqSAwSyDsElW2okJ6Ul8s5xjmBVs2kcotkU7nv9dHG1bbaNVDSdTJyzuVI0LkOzaTevndur+zVlblKUFmPSnpss7JGZW1r1Wn7UT35iRW0UfbU6pBl6E4pM3J69SXOCrBVSY8yImum7G2tOm2+SD35SyaQs4Ie25WyrIvmYc3dqy9zZnChAb2STbW6Hcva6pKWsv4FCdRoebi63EXbva02z8vkHOP8gNohqayrSuxtvbK27/HpkmYCFXkGncvZbIr20fpF80Pql7kqmLKiIllV1u2UMiPopwsZ4QVvVtC5vEvESFJtP6rfxpXBtZJN53J2SRwd65W1fQkF9YmC+GxJo2O9srYf1W/l6uDKvGjZIWqmDtmP6okPGuzWPiraDjGtOq9+O3cFWiWbyv2sjGg5W0fyoDJksulcXn22vF3MgzsDLvNchy5BkcyYXc5W7tGnilwJYETW7HIUlREVM2o7jbsDKft8tyouMmY0r7vv2dPJSrAqa9QWzQlpP40uwZYVYkVc5HhkXh5d7uvVVAO5+mwq6yoitsuaM50CqfK2tJoNmTV7sJpN0bqsmEj7JVT+u7hngohQfROcOYekxS/rzagKsiIucl60zyV0E3SmKmtlucoMeT2roqwKXOlzOd0DE51fVb4d45M6qBTV58Qd49/KkwJvl0wry2hyLjsy3eOlnHlaIJ7xneQZ9+Bp93UXZwT9GS9zHiHnGM8PpOz8V6736feqGyuSZI99jJCSdwm6HdfxLvfiXdgh1WPFPHjXoNx5Xe96j7qwU6LHCyl59+B79+sjf3k7MQ8YwH/hfejJ24qHwsD04f25ho8X0eL/cF3/jluZzJ8AAAAASUVORK5CYII="
  })));
}

function Hidden() {
  return React__default.createElement("svg", {
    viewBox: "0 0 450 350",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
      position: 'relative',
      zIndex: 1
    },
    width: "100%",
    height: "100%"
  }, React__default.createElement("path", {
    d: "M1044.64 3519.86c-268.906-255.34-382.721-755.45-425.729-1324.79-63.39-839.14 322.652-1554.291 837.689-1596.774 601.87-49.644 941.08 786.164 844.87 1596.774-43.64 367.73-136.79 708.92-252.08 974.78 77.66-251.71 132.78-560.06 184.47-886.23 132.01-832.99-378.74-1713.728-780.19-1574.631C956.765 881.158 681.619 1455.15 754.285 2283.62c44.516 507.54 85.829 962.39 290.355 1236.24Z",
    style: {
      fill: '#2472d0'
    },
    transform: "matrix(.19149 0 0 .19149 -55.125 4.715)"
  }), React__default.createElement("path", {
    d: "M764.112 2943.63C602.553 2760.72 475.31 2455.35 505.205 1945c39.072-667.02 475.192-1198.268 952.855-1205.262 505.71-7.405 931.54 508.702 911.01 1205.262-9.1 309.01-78.8 588.29-215.88 807.58 68.02-193.17 75.41-425.73 97.81-667.35 53.58-577.94-156.77-1239.717-792.94-1265.741-477.361-19.527-878.711 591.721-856.519 1265.741 13.768 418.13 78.554 674.87 162.571 858.4Z",
    style: {
      fill: '#2f7bd6'
    },
    transform: "matrix(.1928 0 0 .19149 -45.4 -11.48)"
  }), React__default.createElement("path", {
    d: "M1702.47 753.654c0-87.783-87.06-158.945-194.44-158.945h-.01c-107.39 0-194.44 71.162-194.44 158.945V953.78c0 87.78 87.05 158.95 194.44 158.95h.01c107.38 0 194.44-71.17 194.44-158.95V753.654Z",
    style: {
      fill: '#3c444c'
    },
    transform: "matrix(.20068 0 0 .2455 -65.123 -62.441)"
  }), React__default.createElement("path", {
    d: "M960.699 1070.39h43.211c8.88 0 11.33 1.86 11.33 8.52v5.12c0 4.7-1.7 7.83-9.96 7.83h-44.581v-21.47Zm54.121-18.34c0 3.02-.89 7.04-8.46 7.04h-45.661v-19.27h46.121c1.34 0 8 .28 8 5.74v6.49Zm6.26 11.2c3.95-2.2 6.17-6.09 6.17-11.1v-6.11c0-6.56-2.55-17.55-19.58-17.55h-59.404v74.68h60.344c12.92 0 19.1-6.64 19.1-16.86v-8.46c0-7.59-.79-12.47-6.63-14.6ZM1041.25 1028.48h11.297v74.676h-11.297zM1117.69 1079.81c0 9.61-2.02 13.81-21.44 13.81h-2.06c-14.82 0-15.93-4.13-15.93-10.49v-33.59h-11.32v35.66c0 7.01 2.81 18.76 21.44 18.76h12.07c7.91 0 13.91-1.04 17.79-5.47v4.68h10.77v-53.63h-11.32v30.27ZM1193.12 1067.62v1.61h-41.52c.82-8.66 3.37-10.14 14.66-10.14h11.78c6.89 0 15.08 1.48 15.08 8.53m-15.08-18.87h-12.89c-12.37 0-25.04 2.61-25.04 21.98v10.93c0 19.76 12.9 22.3 24.09 22.3h14.59c11.95 0 25.65-1.89 25.65-16.7v-2.68h-11.19l-.1 1.61c-.39 6.03-2.84 7.43-13.06 7.43h-11.02c-13.84 0-17.63-2.72-17.63-12.64v-1.42h53v-7.35c0-20.66-13.34-23.46-26.4-23.46M1341.83 1081.97c0 8-2.05 10.65-14.23 10.65h-32.08c-10.12 0-14.27-3.89-14.27-13.4v-26.76c0-9.55 4.15-13.43 14.27-13.43h31.79c8.65 0 13.87.72 13.87 10.95v4.98h11.32v-7.82c0-16.08-12.43-19.45-22.84-19.45h-35.05c-18.32 0-25.76 8.24-25.76 28.41v19.47c0 20.16 7.44 28.38 25.76 28.38h34.55c20.47 0 24.55-8.24 24.55-21.6v-6.54h-11.88v6.16ZM1415.95 1079.81c0 9.61-2.02 13.81-21.44 13.81h-2.06c-14.82 0-15.93-4.13-15.93-10.49v-33.59h-11.32v35.66c0 7.01 2.77 18.76 21.44 18.76h12.07c7.91 0 13.91-1.04 17.79-5.47v4.68h10.77v-53.63h-11.32v30.27ZM1574.12 1067.62v1.61h-41.55c.85-8.66 3.37-10.14 14.65-10.14h11.79c6.89 0 15.11 1.48 15.11 8.53m-15.11-18.87h-12.9c-12.36 0-25 2.61-25 21.98v10.93c0 19.76 12.86 22.3 24.06 22.3h14.59c11.94 0 25.68-1.89 25.68-16.7v-2.68h-11.22l-.1 1.61c-.39 6.03-2.81 7.43-13.05 7.43h-11.04c-13.8 0-17.59-2.72-17.59-12.64v-1.42h53v-7.35c0-20.66-13.34-23.46-26.43-23.46M1636.79 1048.75h-12.04c-7.94 0-13.9 1.03-17.82 5.46v-4.67h-10.74v53.62h11.29v-30.26c0-9.61 2.02-13.81 21.45-13.81h2.09c14.81 0 15.92 4.16 15.92 10.48v33.59h11.29v-35.65c0-7.01-2.77-18.76-21.44-18.76M1668.41 1037.66v48.74c0 11.65 6.82 17.56 20.27 17.56h4.08v-10.34h-2.81c-8.03 0-10.22-2.28-10.22-10.49v-23.26h13.19v-10.34h-13.19v-11.87h-11.32ZM1472.58 1048.75h-7.5c-5.69 0-10.09 1.58-13.13 4.7v-3.91h-10.77v53.62h11.33v-33.59c0-5.09 2.87-10.48 10.96-10.48h4.97c1.53 0 2.9.04 4.14.07v-10.41ZM1513.05 1048.75h-7.54c-5.68 0-10.05 1.58-13.12 4.7v-3.91h-10.74v53.62h11.3v-33.59c0-5.09 2.9-10.48 10.99-10.48h4.97c1.53 0 2.9.04 4.14.07v-10.41Z",
    style: {
      fill: '#4b87d1'
    },
    transform: "matrix(.06958 0 0 .06958 150.563 47.723)"
  }), React__default.createElement("path", {
    d: "M806.062 1103.59h24.352c11.944 0 21.848-7.22 21.848-21.38 0-8.41-4.038-15.85-11.156-18.19v-.21c5.191-2.98 8.461-8.83 8.461-16.18 0-12.13-8.27-19.14-19.73-19.14h-23.775v75.1Zm9.519-43.5v-22.46h14.064c6.55 0 10.21 4.47 10.21 11.07 0 6.6-3.853 11.39-10.018 11.39h-14.256Zm0 34.36v-25.65h15.22c7.126 0 11.75 5.22 11.75 12.88 0 7.66-4.335 12.77-11.655 12.77h-15.315ZM858.34 1122.64s3.946 3.29 9.432 3.29c6.834 0 12.802-4.35 15.786-12.64l22.811-63.52h-10.106l-11.839 35.32c-.866 2.77-1.636 6.39-1.636 6.39h-.193s-.866-3.73-1.829-6.49l-12.224-35.22h-10.491l20.405 53.2-2.406 6.17c-1.829 4.89-5.005 7.87-8.759 7.87-2.984 0-5.679-2.23-5.679-2.23l-3.272 7.86Z",
    style: {
      fill: '#fff',
      fillRule: 'nonzero'
    },
    transform: "matrix(.06958 0 0 .06958 150.563 47.723)"
  }), React__default.createElement("path", {
    d: "M1528.43 974.484c-116.4 8.24-87.03-104.622 83.44-82.961 449.1 57.066 729.64 569.217 676.31 1116.687-45.81 470.22-105.29 483.96-80.61 72.2 36.96-616.63-256.8-1135.822-679.14-1105.926Z",
    style: {
      fill: '#3c85dc'
    },
    transform: "matrix(.19149 0 0 .19149 -44.732 -11.48)"
  }), React__default.createElement("g", {
    transform: "matrix(.19149 0 0 .19149 -44.732 -11.48)"
  }, React__default.createElement("path", {
    d: "M675.088 1150.42H501.271c-6.95 0-13.616 1.21-18.531 3.38-4.914 2.17-7.675 5.1-7.675 8.17v109.96c0 3.02 2.726 5.92 7.578 8.06 4.853 2.14 11.435 3.34 18.297 3.34h174.148v-132.91Z",
    style: {
      fill: '#242f39'
    },
    transform: "matrix(.81283 -.5825 1.32136 1.84386 -1523.12 -645.093)"
  }), React__default.createElement("path", {
    d: "M675.088 1185.2c0-19.21-19.117-34.78-42.7-34.78H517.174c-23.256 0-42.109 15.35-42.109 34.3V1248c0 19.52 19.419 35.33 43.374 35.33h113.742c11.379 0 22.293-3.68 30.34-10.23 8.047-6.56 12.568-15.45 12.567-24.72v-63.18Z",
    style: {
      fill: '#121a21'
    },
    transform: "matrix(.1983 -.1421 .17445 .24344 169.577 1048.07)"
  }), React__default.createElement("path", {
    d: "M1249.2 802.581a1184.497 1184.497 0 0 0-264.602 49.07c-57.199 17.353-138.325 42.2-138.436 42.235-1.332.408-2.661.827-3.985 1.259-75.21 24.761-167.01 74.553-275.277 149.235a52.144 52.144 0 0 0-13.027 73.14c37.056 52.39 99.634 140.71 136.903 193.3a52.028 52.028 0 0 0 34.225 21.3 52.05 52.05 0 0 0 39.164-9.54c71.911-52.61 97.604-73.26 137.602-154.31 12.198-24.71 32.249-71.17 66.008-107.54a69.143 69.143 0 0 1 20.369-14.92c9.375-4.62 19.646-7.3 30.586-6.2 61.88 6.22 70.62 12.65 140.2 18.39 38.84 3.19 111.18 7.27 168.63 8.91a51.95 51.95 0 0 0 37.27-14.93 51.979 51.979 0 0 0 15.51-37.04c.02-47.284.02-116.28.02-163.254a52.36 52.36 0 0 0-52.55-52.361c-26.42.324-52.62 1.398-78.61 3.256Z",
    style: {
      fill: '#1b83ec'
    }
  }), React__default.createElement("clipPath", {
    id: "a"
  }, React__default.createElement("path", {
    d: "M1249.2 802.581a1184.497 1184.497 0 0 0-264.602 49.07c-57.199 17.353-138.325 42.2-138.436 42.235-1.332.408-2.661.827-3.985 1.259-75.21 24.761-167.01 74.553-275.277 149.235a52.144 52.144 0 0 0-13.027 73.14c37.056 52.39 99.634 140.71 136.903 193.3a52.028 52.028 0 0 0 34.225 21.3 52.05 52.05 0 0 0 39.164-9.54c71.911-52.61 97.604-73.26 137.602-154.31 12.198-24.71 32.249-71.17 66.008-107.54a69.143 69.143 0 0 1 20.369-14.92c9.375-4.62 19.646-7.3 30.586-6.2 61.88 6.22 70.62 12.65 140.2 18.39 38.84 3.19 111.18 7.27 168.63 8.91a51.95 51.95 0 0 0 37.27-14.93 51.979 51.979 0 0 0 15.51-37.04c.02-47.284.02-116.28.02-163.254a52.36 52.36 0 0 0-52.55-52.361c-26.42.324-52.62 1.398-78.61 3.256Z"
  })), React__default.createElement("g", {
    clipPath: "url(#a)"
  }, React__default.createElement("path", {
    d: "M1166.42 875.941a237.513 237.513 0 0 0-184.581-15.723c-32.152 10.484-67.273 21.952-89.431 29.187a72.17 72.17 0 0 0-40.887 33.91c-32.871 59.95 32.191 72.793 135.605 126.205a52.408 52.408 0 0 0 39.704 3.55c11.81-3.79 21.51-5.39 34.1-3.64a51.905 51.905 0 0 0 33.87-7.53c122.45-76.032 154.48-122.147 71.62-165.959Z",
    style: {
      fill: '#242f39'
    },
    transform: "translate(-28 -5.758)"
  })), React__default.createElement("path", {
    style: {
      fill: '#1b83ec'
    },
    d: "M1501.37 1024.82h32.986v16.483h-32.986z",
    transform: "rotate(-29.339 1517.38 1030.976)"
  }), React__default.createElement("path", {
    d: "m1580.61 891.424-14.4-27.249v139.175l14.4-25.959v-85.967Z",
    style: {
      fill: '#242f39'
    },
    transform: "translate(.217 -.658)"
  }), React__default.createElement("path", {
    d: "M1580.51 875.427c0-21.14-15.93-39.062-37.37-42.048l-109.18-15.208c-12.55-1.747-25.26 1.906-34.83 10.015-9.57 8.108-15.07 19.874-15.07 32.248v147.706c0 12.31 5.46 24.02 14.97 32.1 9.51 8.08 22.14 11.75 34.63 10.05 34-4.63 78.4-10.67 109.44-14.89 21.45-2.91 37.41-20.82 37.41-41.955V875.427Z",
    style: {
      fill: '#242f39'
    },
    transform: "matrix(.9593 0 0 .98261 52.639 15.203)"
  }), React__default.createElement("path", {
    d: "M1513.21 840.442c0-22.307-17.76-40.404-39.69-40.445-.01.156-.02.156-.03.156-10.35-.016-20.28 4.154-27.6 11.593-7.33 7.438-11.45 17.534-11.45 28.061-.14 47.876-.14 138.012-.14 185.073 0 21.85 17.32 39.62 38.8 39.8.01-.21.02-.21.02-.21 10.55.09 20.7-4.12 28.19-11.67 7.48-7.56 11.7-17.85 11.7-28.57.2-47.033.2-135.976.2-183.788Z",
    style: {
      fill: '#1b83ec'
    },
    transform: "matrix(1.01713 0 0 1 -25.931 0)"
  })));
}

function NanoCharge(props) {
  var _props$color, _props$color2;
  return React__default.createElement("svg", {
    viewBox: "0 0 450 350",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
      position: 'relative',
      zIndex: 1
    },
    width: "100%",
    height: "100%"
  }, React__default.createElement("path", {
    d: "M442.773 1023.2C456.002 568.404 838.235 211.629 1250 209.394c421.91-2.29 781.88 345.641 807.23 816.446v968.62H442.772v-968.62l.005-2.64h-.004Z",
    style: {
      fill: '#444',
      stroke: '#dadada',
      strokeWidth: '38.89px'
    },
    transform: "translate(17.602 29.715) scale(.16585)"
  }), React__default.createElement("path", {
    d: "M978.179 1286.78h543.641c258.64 103.33 440.8 349.56 440.8 636.57 0 380-319.32 688.51-712.62 688.51-393.304 0-712.617-308.51-712.617-688.51 0-287.01 182.161-533.24 440.796-636.57Z",
    style: {
      fill: '#63605f'
    },
    transform: "translate(17.602 29.715) scale(.16585)"
  }), React__default.createElement("use", {
    xlinkHref: "#a",
    width: 1408,
    height: 787,
    transform: "matrix(.16582 0 0 .16567 108.178 221.823)"
  }), React__default.createElement("path", {
    d: "M1474.77 1359.24c0 48.1 25.87 92.49 67.72 116.2 177.21 100.26 296.7 288.78 296.7 504.62 0 320.82-264.01 581.29-589.19 581.29-325.19 0-589.201-260.47-589.201-581.29 0-215.92 119.578-404.5 296.917-504.75 41.734-23.62 67.534-67.87 67.534-115.83v-71.14c0-6.24 5.07-11.31 11.32-11.31h426.86c3.01 0 5.89 1.2 8.02 3.32a11.33 11.33 0 0 1 3.32 8.02v70.87Z",
    style: {
      fill: '#63605f'
    },
    transform: "translate(17.602 29.715) scale(.16585)"
  }), React__default.createElement("g", {
    transform: "translate(17.602 29.715) scale(.16585)"
  }, React__default.createElement("circle", {
    cx: 1250.31,
    cy: 757.835,
    r: 22.222,
    style: {
      fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : '#ef6a6b'
    }
  }), React__default.createElement("path", {
    d: "M1434.24 652.815c11.03 13.36 19.76 39.418 24.17 69.588 6.82 46.588 3.02 103.275-23.67 141.386-4.69 6.697-3.06 15.943 3.64 20.633 6.7 4.689 15.95 3.059 20.63-3.639 30.75-43.915 36.58-108.989 28.72-162.673-5.37-36.679-17.23-67.914-30.64-84.156-5.2-6.306-14.55-7.2-20.85-1.995-6.31 5.204-7.2 14.55-2 20.856ZM1372.21 693.766c9.63 9.873 17.27 32.253 19.22 56.77 1.98 24.882-2.13 52.356-18.76 72.197-5.25 6.267-4.42 15.618 1.84 20.87 6.27 5.252 15.62 4.428 20.87-1.839 21.63-25.804 28.16-61.216 25.58-93.575-2.6-32.726-14.68-61.932-27.54-75.111-5.71-5.854-15.09-5.971-20.95-.262-5.85 5.709-5.97 15.096-.26 20.95ZM1313.1 730.479c.27.53 4.02 7.912 5.51 14.226 2.88 12.271 3.52 28.924-5.95 42.45-4.68 6.699-3.05 15.944 3.65 20.632 6.7 4.687 15.94 3.054 20.63-3.645 14.81-21.158 15.02-47.028 10.51-66.223-3.37-14.323-9.69-24.909-13.72-28.694-5.96-5.599-15.34-5.306-20.94.653-5.49 5.841-5.31 14.972.31 20.601ZM1042.91 633.954c-13.41 16.242-25.27 47.477-30.64 84.156-7.86 53.684-2.03 118.758 28.72 162.673 4.69 6.698 13.93 8.328 20.63 3.639 6.7-4.69 8.33-13.936 3.64-20.633-26.69-38.111-30.49-94.798-23.67-141.386 4.42-30.17 13.14-56.228 24.17-69.588 5.21-6.306 4.31-15.652-1.99-20.856-6.31-5.205-15.65-4.311-20.86 1.995ZM1106.58 673.078c-12.85 13.179-24.94 42.385-27.54 75.111-2.58 32.359 3.95 67.771 25.58 93.575 5.25 6.267 14.6 7.091 20.87 1.839 6.26-5.252 7.09-14.603 1.84-20.87-16.63-19.841-20.73-47.315-18.76-72.197 1.95-24.517 9.59-46.897 19.22-56.77 5.71-5.854 5.59-15.241-.26-20.95s-15.24-5.592-20.95.262ZM1187.23 730.479c5.62-5.629 5.8-14.76.31-20.601-5.6-5.959-14.98-6.252-20.94-.653-4.03 3.785-10.35 14.371-13.72 28.694-4.51 19.195-4.3 45.065 10.51 66.223 4.69 6.699 13.93 8.332 20.63 3.645 6.7-4.688 8.33-13.933 3.65-20.632-9.47-13.526-8.83-30.179-5.94-42.45 1.48-6.314 5.23-13.696 5.5-14.226Z",
    style: {
      fill: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : '#ef6a6b'
    }
  })), React__default.createElement("path", {
    d: "M960.699 1070.39h43.211c8.88 0 11.33 1.86 11.33 8.52v5.12c0 4.7-1.7 7.83-9.96 7.83h-44.581v-21.47Zm54.121-18.34c0 3.02-.89 7.04-8.46 7.04h-45.661v-19.27h46.121c1.34 0 8 .28 8 5.74v6.49Zm6.26 11.2c3.95-2.2 6.17-6.09 6.17-11.1v-6.11c0-6.56-2.55-17.55-19.58-17.55h-59.404v74.68h60.344c12.92 0 19.1-6.64 19.1-16.86v-8.46c0-7.59-.79-12.47-6.63-14.6ZM1041.25 1028.48h11.297v74.676h-11.297zM1117.69 1079.81c0 9.61-2.02 13.81-21.44 13.81h-2.06c-14.82 0-15.93-4.13-15.93-10.49v-33.59h-11.32v35.66c0 7.01 2.81 18.76 21.44 18.76h12.07c7.91 0 13.91-1.04 17.79-5.47v4.68h10.77v-53.63h-11.32v30.27ZM1193.12 1067.62v1.61h-41.52c.82-8.66 3.37-10.14 14.66-10.14h11.78c6.89 0 15.08 1.48 15.08 8.53m-15.08-18.87h-12.89c-12.37 0-25.04 2.61-25.04 21.98v10.93c0 19.76 12.9 22.3 24.09 22.3h14.59c11.95 0 25.65-1.89 25.65-16.7v-2.68h-11.19l-.1 1.61c-.39 6.03-2.84 7.43-13.06 7.43h-11.02c-13.84 0-17.63-2.72-17.63-12.64v-1.42h53v-7.35c0-20.66-13.34-23.46-26.4-23.46M1341.83 1081.97c0 8-2.05 10.65-14.23 10.65h-32.08c-10.12 0-14.27-3.89-14.27-13.4v-26.76c0-9.55 4.15-13.43 14.27-13.43h31.79c8.65 0 13.87.72 13.87 10.95v4.98h11.32v-7.82c0-16.08-12.43-19.45-22.84-19.45h-35.05c-18.32 0-25.76 8.24-25.76 28.41v19.47c0 20.16 7.44 28.38 25.76 28.38h34.55c20.47 0 24.55-8.24 24.55-21.6v-6.54h-11.88v6.16ZM1415.95 1079.81c0 9.61-2.02 13.81-21.44 13.81h-2.06c-14.82 0-15.93-4.13-15.93-10.49v-33.59h-11.32v35.66c0 7.01 2.77 18.76 21.44 18.76h12.07c7.91 0 13.91-1.04 17.79-5.47v4.68h10.77v-53.63h-11.32v30.27ZM1574.12 1067.62v1.61h-41.55c.85-8.66 3.37-10.14 14.65-10.14h11.79c6.89 0 15.11 1.48 15.11 8.53m-15.11-18.87h-12.9c-12.36 0-25 2.61-25 21.98v10.93c0 19.76 12.86 22.3 24.06 22.3h14.59c11.94 0 25.68-1.89 25.68-16.7v-2.68h-11.22l-.1 1.61c-.39 6.03-2.81 7.43-13.05 7.43h-11.04c-13.8 0-17.59-2.72-17.59-12.64v-1.42h53v-7.35c0-20.66-13.34-23.46-26.43-23.46M1636.79 1048.75h-12.04c-7.94 0-13.9 1.03-17.82 5.46v-4.67h-10.74v53.62h11.29v-30.26c0-9.61 2.02-13.81 21.45-13.81h2.09c14.81 0 15.92 4.16 15.92 10.48v33.59h11.29v-35.65c0-7.01-2.77-18.76-21.44-18.76M1668.41 1037.66v48.74c0 11.65 6.82 17.56 20.27 17.56h4.08v-10.34h-2.81c-8.03 0-10.22-2.28-10.22-10.49v-23.26h13.19v-10.34h-13.19v-11.87h-11.32ZM1472.58 1048.75h-7.5c-5.69 0-10.09 1.58-13.13 4.7v-3.91h-10.77v53.62h11.33v-33.59c0-5.09 2.87-10.48 10.96-10.48h4.97c1.53 0 2.9.04 4.14.07v-10.41ZM1513.05 1048.75h-7.54c-5.68 0-10.05 1.58-13.12 4.7v-3.91h-10.74v53.62h11.3v-33.59c0-5.09 2.9-10.48 10.99-10.48h4.97c1.53 0 2.9.04 4.14.07v-10.41Z",
    style: {
      fill: '#4b87d1'
    },
    transform: "translate(17.602 29.715) scale(.16585)"
  }), React__default.createElement("path", {
    d: "M806.062 1103.59h24.352c11.944 0 21.848-7.22 21.848-21.38 0-8.41-4.038-15.85-11.156-18.19v-.21c5.191-2.98 8.461-8.83 8.461-16.18 0-12.13-8.27-19.14-19.73-19.14h-23.775v75.1Zm9.519-43.5v-22.46h14.064c6.55 0 10.21 4.47 10.21 11.07 0 6.6-3.853 11.39-10.018 11.39h-14.256Zm0 34.36v-25.65h15.22c7.126 0 11.75 5.22 11.75 12.88 0 7.66-4.335 12.77-11.655 12.77h-15.315ZM858.34 1122.64s3.946 3.29 9.432 3.29c6.834 0 12.802-4.35 15.786-12.64l22.811-63.52h-10.106l-11.839 35.32c-.866 2.77-1.636 6.39-1.636 6.39h-.193s-.866-3.73-1.829-6.49l-12.224-35.22h-10.491l20.405 53.2-2.406 6.17c-1.829 4.89-5.005 7.87-8.759 7.87-2.984 0-5.679-2.23-5.679-2.23l-3.272 7.86Z",
    style: {
      fill: '#4b87d1',
      fillRule: 'nonzero'
    },
    transform: "translate(17.602 29.715) scale(.16585)"
  }), React__default.createElement("defs", null, React__default.createElement("image", {
    id: "a",
    width: 1408,
    height: 787,
    xlinkHref: "data:image/png;base64,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"
  })));
}

function GridItem(props) {
  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React__default.useState(false),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      dropdownMenu = _React$useState4[0],
      setDropdownMenu = _React$useState4[1];
  var lightColor = function lightColor() {
    switch (props.activity) {
      case 'available':
        return Colors.GREEN;
      case 'error':
        return Colors.RED;
      case 'charging':
        return Colors.BLUE;
      case 'offline':
        return Colors.MEDIUM_GREY;
      case 'unavailable':
        return Colors.MEDIUM_GREY;
      default:
        return Colors.MEDIUM_GREY;
    }
  };
  return React__default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, React__default.createElement("div", {
    style: {
      width: props.width,
      height: props.width,
      backgroundColor: Colors.WHITE,
      borderRadius: 10,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      overflow: 'hidden',
      padding: 0,
      position: 'relative'
    }
  }, React__default.createElement("div", {
    style: {
      height: props.width,
      width: props.width,
      backgroundColor: Colors.WHITE,
      paddingLeft: 15,
      paddingRight: 15,
      paddingTop: 15
    }
  }, React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  }, React__default.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: props.onClick,
    style: {
      height: 35,
      width: props.menu ? 'calc(100% - 35px)' : '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 'solid 0px transparent',
      fontSize: '1em'
    }
  }, React__default.createElement(Text, {
    fontSize: "1em"
  }, props.name)), props.menu && React__default.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      setDropdownMenu(!dropdownMenu);
    },
    onMouseEnter: function onMouseEnter() {
      setHover(true);
      setDropdownMenu(dropdownMenu);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
      setDropdownMenu(false);
    },
    style: {
      border: 'solid 0px transparent',
      height: 35,
      width: 35,
      backgroundColor: Colors.WHITE,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React__default.createElement("div", {
    style: {
      width: dropdownMenu ? 30 : 35,
      height: dropdownMenu ? 30 : 35,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      transform: "rotate(".concat(dropdownMenu ? 180 : 0, "deg)")
    }
  }, React__default.createElement(Icon, {
    name: dropdownMenu ? 'AngleDown' : 'Ellipsis-H',
    height: dropdownMenu ? 30 : 35,
    width: dropdownMenu ? 30 : 35,
    color: hover || dropdownMenu ? Colors.GREY : Colors.MEDIUM_GREY
  })))), React__default.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: props.onClick,
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      height: '100%',
      width: '100%',
      backgroundColor: 'transparent',
      border: 'solid 0px transparent',
      position: 'relative',
      padding: 0,
      margin: 0
    }
  }, props.type === 'UMOVE' && React__default.createElement(UMOVE, {
    color: lightColor()
  }), props.type === 'HIDDEN' && React__default.createElement(Hidden, null), props.type === 'NANOCHARGE' && React__default.createElement(NanoCharge, {
    color: lightColor()
  }), React__default.createElement("div", {
    style: {
      position: 'absolute',
      top: 30,
      zIndex: 0
    }
  }, React__default.createElement(DotsPath, {
    color: Colors.MEDIUM_WHITE,
    height: "250%",
    width: "250%",
    marginLeft: "-50%"
  }))))), dropdownMenu && props.menu && React__default.createElement("div", {
    style: {
      position: 'absolute',
      top: -20,
      left: props.width - 240
    }
  }, React__default.createElement(DropdownMenu, {
    items: props.menu,
    onMouseEnter: function onMouseEnter() {
      setDropdownMenu(true);
    },
    onMouseLeave: function onMouseLeave() {
      setDropdownMenu(false);
    },
    onClick: function onClick() {
      setDropdownMenu(false);
    }
  })));
}

function GlobalHeaderItem(props) {
  var e = props.data;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      dropdownMenu = _React$useState4[0],
      setDropdownMenu = _React$useState4[1];
  var _React$useState5 = React$4.useState(false),
      _React$useState6 = _slicedToArray$4(_React$useState5, 2),
      clicked = _React$useState6[0],
      setClicked = _React$useState6[1];
  React$4.useEffect(function () {
    props.onChangeDropdown(dropdownMenu);
  }, [dropdownMenu]);
  return React$4.createElement("div", {
    style: {
      position: 'relative',
      height: '100%'
    }
  }, React$4.createElement("button", {
    className: e.onClick || e.dropdownMenu ? 'Hover' : 'Disabled',
    type: "button",
    onClick: function onClick() {
      if (e.onClick) {
        e.onClick();
      }
      if (e.dropdownMenu) {
        setDropdownMenu(!dropdownMenu);
        setClicked(!dropdownMenu);
      }
    },
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      height: '100%',
      width: 'auto',
      color: Colors.BLUE,
      border: 'solid 0px transparent',
      backgroundColor: 'transparent',
      marginRight: e.align === 'left' ? 30 : 0,
      marginLeft: e.align === 'right' ? 30 : 0,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      fontSize: '1em',
      textDecoration: hover && (e.onClick || e.dropdownMenu) ? 'underline' : 'none'
    }
  }, e.icon && React$4.createElement("div", {
    style: {
      height: '100%',
      width: 27,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }
  }, React$4.createElement(Icon, {
    name: e.icon.name,
    width: e.icon.width,
    height: e.icon.height,
    color: e.icon.color,
    iconSet: e.icon.iconSet
  })), React$4.createElement(Text, {
    fontSize: "0.9em",
    color: Colors.BLUE
  }, e.title), e.dropdownMenu && React$4.createElement("div", {
    style: {
      width: 27,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      transform: "rotate(".concat(clicked ? '180deg' : '0', ")"),
      paddingTop: clicked ? 0 : 3,
      paddingBottom: clicked ? 2 : 0
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    width: 20,
    height: 20,
    color: Colors.BLUE,
    iconSet: "FA"
  })), e.suffix && React$4.createElement("div", {
    style: {
      width: 27,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: hover ? 5 : 0,
      transition: 'all .1s linear'
    }
  }, React$4.createElement(Icon, {
    name: e.suffix.name,
    width: e.suffix.width,
    height: e.suffix.height,
    color: e.suffix.color,
    iconSet: e.suffix.iconSet
  }))), dropdownMenu && React$4.createElement("div", {
    style: {
      position: 'absolute',
      top: -20,
      left: e.align === 'left' ? 0 : 'initial',
      right: e.align === 'right' ? 240 : 'initial',
      zIndex: 2147483005
    }
  }, React$4.createElement(DropdownMenu, {
    items: e.dropdownMenu,
    onClose: function onClose() {
      setDropdownMenu(false);
      setClicked(false);
    },
    right: e.align === 'right'
  })));
}

function GlobalHeader(props) {
  return React__default.createElement("div", {
    style: {
      height: 45,
      width: '100%',
      backgroundColor: Colors.GRADIENT,
      position: 'fixed',
      zIndex: 2147483003
    }
  }, React__default.createElement(MainContainer$1, null, React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 45
    }
  }, props.items.map(function (e) {
    return e.align === 'left' && React__default.createElement(GlobalHeaderItem, {
      key: e.id,
      data: e,
      onChangeDropdown: props.onChangeDropdown
    });
  }), props.items.map(function (e) {
    return e.align === 'right' && React__default.createElement(GlobalHeaderItem, {
      key: e.id,
      data: e,
      onChangeDropdown: props.onChangeDropdown
    });
  }))));
}

function HeaderLink(props) {
  return React$4.createElement("a", {
    href: props.href,
    onClick: props.onClick,
    rel: props.rel,
    className: "Hover HeaderLink DisableSelection",
    style: {
      fontSize: '1em',
      height: 37,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative'
    }
  }, React$4.createElement(Text, {
    fontSize: "1em"
  }, props.text));
}

function Buttons(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("a", {
    href: props.data.href,
    onClick: function onClick() {
      props.data.onClick();
      props.onClose();
    },
    rel: props.data.rel,
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    }
  }, React$4.createElement("button", {
    type: "button",
    className: "Hover DisableSelection",
    style: {
      minHeight: 60,
      height: 'auto',
      width: '100%',
      borderBottom: "solid 2px ".concat(Colors.LIGHT_WHITE),
      borderLeft: 'solid 0px transparent',
      borderRight: 'solid 0px transparent',
      borderTop: 'solid 0px transparent',
      backgroundColor: Colors.WHITE,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'noWrap',
      alignItems: 'center',
      paddingLeft: 10,
      paddingRight: 15,
      fontSize: '1em',
      paddingTop: 5,
      paddingBottom: 5
    }
  }, props.data.icon && React$4.createElement("div", {
    style: {
      height: 30,
      width: 30,
      marginRight: 10,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.data.icon.name,
    width: props.data.icon.width,
    height: props.data.icon.height,
    color: props.data.active || hover ? props.colorScheme.vibrant : props.data.icon.color,
    iconSet: props.data.icon.iconSet
  })), React$4.createElement("div", {
    style: {
      overflowWrap: 'break-word',
      hyphens: 'manual',
      inlineSize: '100%'
    }
  }, React$4.createElement(Text, null, props.data.title))));
}

function Links$1(props) {
  var _React$useState = React$4.useState(),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("a", {
    href: props.data.href
  }, React$4.createElement("button", {
    type: "button",
    className: "Hover DisableSelection",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      height: 40,
      width: '100%',
      backgroundColor: Colors.WHITE,
      border: 'solid 0px transparent',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingLeft: 15
    }
  }, React$4.createElement(Text, {
    color: props.data.color,
    textDecoration: hover ? 'underline' : 'none'
  }, props.data.title), props.data.suffix && React$4.createElement("div", {
    style: {
      height: 30,
      width: 30,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.data.suffix.name,
    width: props.data.suffix.width,
    height: props.data.suffix.height,
    color: props.data.suffix.color,
    iconSet: props.data.suffix.iconSet
  }))));
}

function TopButton(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    type: "button",
    className: "Hover DisableSelection",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: function onClick() {
      props.onClick();
    },
    style: {
      backgroundColor: Colors.WHITE,
      height: 45,
      width: '100%',
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 7,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      transition: 'all 0.3s ease-in-out'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  }, props.data.icon && React$4.createElement("div", {
    style: {
      height: 40,
      width: 30,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.data.icon.name,
    width: props.data.icon.width,
    height: props.data.icon.height,
    color: hover || props.open ? Colors.GREY : props.data.icon.color,
    iconSet: props.data.iconSet
  })), React$4.createElement(Text, {
    color: hover || props.open ? Colors.GREY : Colors.MEDIUM_GREY
  }, props.data.title)), props.data.dropdownMenu && React$4.createElement("div", {
    style: {
      width: 27,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      transform: "rotate(".concat(props.open ? '180deg' : '0', ")"),
      paddingTop: props.open ? 0 : 3,
      paddingBottom: props.open ? 2 : 0
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    width: 20,
    height: 20,
    color: hover || props.open ? Colors.GREY : Colors.MEDIUM_GREY,
    iconSet: "FA"
  })));
}

function HeaderSideBar(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      dropdownMenu = _React$useState2[0],
      setDropdownMenu = _React$useState2[1];
  return React$4.createElement("div", {
    style: {
      height: props.items.length < 1 ? 78 : '100vh',
      width: '100%',
      backgroundColor: Colors.WHITE,
      positon: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      height: props.items.length < 1 ? 78 : 80,
      width: '84%',
      backgroundColor: Colors.WHITE,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      paddingLeft: 15,
      paddingRight: 15
    }
  }, props.topButton && React$4.createElement(TopButton, {
    data: props.topButton,
    onClick: function onClick() {
      if (props.topButton.dropdownMenu) {
        setDropdownMenu(!dropdownMenu);
      }
    },
    open: dropdownMenu
  })), React$4.createElement("div", {
    style: {
      width: '100%',
      marginTop: -2,
      borderBottom: "solid ".concat(props.items.length < 1 ? 0 : 2, "px ").concat(Colors.MEDIUM_WHITE)
    }
  }), React$4.createElement(AnimatePresence, null, dropdownMenu && React$4.createElement(motion.div, {
    style: {
      width: props.items.length < 1 ? 'calc(100% + 2px)' : '100%',
      backgroundColor: Colors.WHITE,
      position: 'absolute',
      zIndex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      height: 'calc(100vh - 80px)',
      borderLeft: props.items.length < 1 ? "solid 2px ".concat(Colors.MEDIUM_WHITE) : 'solid 0px transparent',
      borderTop: props.items.length < 1 ? "solid 2px ".concat(Colors.MEDIUM_WHITE) : 'solid 0px transparent'
    },
    initial: {
      right: '-100%'
    },
    animate: {
      right: 0
    },
    exit: {
      right: '-100%'
    },
    transition: {
      ease: 'easeInOut',
      duration: 0.3
    }
  }, props.topButton.dropdownMenu.map(function (e) {
    return React$4.createElement("div", {
      key: e.id,
      style: {
        height: 60,
        borderBottom: "solid 2px ".concat(Colors.LIGHT_WHITE),
        paddingRight: 15,
        paddingLeft: 15,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start'
      }
    }, React$4.createElement(DropdownItem, {
      title: e.title,
      type: "radio",
      selected: e.selected,
      onClick: function onClick() {
        e.onClick();
        setDropdownMenu(false);
      }
    }));
  }))), React$4.createElement("div", {
    style: {
      width: '100%',
      height: props.items.length < 1 ? 0 : 'calc(100vh - 80px)',
      backgroundColor: Colors.WHITE,
      overflowY: 'auto',
      overflowX: 'hidden',
      zIndex: 0,
      position: 'relative',
      transition: 'all 0.3s linear'
    }
  }, props.items !== undefined && props.items.filter(function (_ref) {
    var sideNav = _ref.sideNav;
    return sideNav;
  }).map(function (e) {
    var _e$colorScheme;
    return React$4.createElement(Buttons, {
      key: e.id,
      data: e,
      colorScheme: getColorScheme("".concat((_e$colorScheme = e.colorScheme) !== null && _e$colorScheme !== void 0 ? _e$colorScheme : 'blue')),
      onClose: props.onClose
    });
  }), props.links && React$4.createElement("div", {
    style: {
      marginTop: 15,
      marginBottom: 15
    }
  }, props.links.map(function (e) {
    return React$4.createElement(Links$1, {
      key: e.id,
      data: e
    });
  }))));
}

function SideNavButton(props) {
  return React$4.createElement("button", {
    type: "button",
    onClick: props.onClick,
    style: {
      height: '2rem',
      width: '2rem',
      position: 'absolute',
      zIndex: 2147483005,
      right: 1,
      backgroundColor: 'transparent',
      border: 'solid 0px transparent',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      alignItems: 'center',
      flexWrap: 'noWrap',
      padding: 0
    }
  }, React$4.createElement("div", {
    style: {
      width: 32.5,
      height: 2,
      backgroundColor: Colors.GREY,
      transformOrigin: 1,
      transition: 'all .3s linear',
      transform: props.active ? 'rotate(45deg)' : 'rotate(0deg)'
    }
  }), React$4.createElement("div", {
    style: {
      width: 32.5,
      height: 2,
      backgroundColor: Colors.GREY,
      transformOrigin: 1,
      transition: 'all .3s linear',
      transform: props.active ? 'translateX(100%)' : 'translateX(0)',
      opacity: props.active ? 0 : 1.0
    }
  }), React$4.createElement("div", {
    style: {
      width: 32.5,
      height: 2,
      backgroundColor: Colors.GREY,
      transformOrigin: 1,
      transition: 'all .3s linear',
      transform: props.active ? 'rotate(-45deg)' : 'rotate(0deg)'
    }
  }));
}

function Header(props) {
  var _props$breakpoint;
  var size = useDimensions();
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      sideNav = _React$useState2[0],
      setSideNav = _React$useState2[1];
  var _React$useState3 = React$4.useState([]),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      sortedOnId = _React$useState4[0],
      setSortedOnId = _React$useState4[1];
  var _React$useState5 = React$4.useState(props.items),
      _React$useState6 = _slicedToArray$4(_React$useState5, 1),
      items = _React$useState6[0];
  var sideNavBreakpoint = (_props$breakpoint = props.breakpoint) !== null && _props$breakpoint !== void 0 ? _props$breakpoint : Breakpoint.lg;
  React$4.useEffect(function () {
    if (items) {
      var sortedItems = items.sort(function (a) {
        return a.type === 'link' ? -1 : 1;
      });
      setSortedOnId(sortedItems.sort(function (a, b) {
        return a.id - b.id;
      }));
    }
  });
  React$4.useEffect(function () {
    document.querySelector('body').style.overflow = sideNav && size.width < sideNavBreakpoint ? 'hidden' : 'auto';
  });
  return React$4.createElement("div", {
    style: {
      position: 'fixed',
      height: 80,
      width: '100%',
      backgroundColor: Colors.WHITE,
      borderBottom: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      zIndex: 2147483003
    }
  }, React$4.createElement(MainContainer$1, null, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: Colors.WHITE,
      height: 78,
      width: '100%',
      position: 'relative'
    }
  }, React$4.createElement("a", {
    href: "https://www.bluecurrent.nl",
    target: "_blank",
    className: "Hover",
    style: {
      minWidth: size.width < Breakpoint.fd ? 160 : 204,
      maxWidth: size.width < Breakpoint.fd ? 160 : 204,
      width: size.width < Breakpoint.fd ? 160 : 204,
      height: 60,
      maxHeight: 60,
      minHeight: 60
    },
    rel: "noreferrer",
    "aria-label": _('blueCurrent', {
      ns: 'branding'
    })
  }, React$4.createElement(Logo, {
    type: "Normal",
    height: 60,
    width: size.width < Breakpoint.fd ? 160 : 204
  })), size.width >= sideNavBreakpoint ? React$4.createElement("div", {
    style: {
      width: 'auto',
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center'
    }
  }, sortedOnId.filter(function (_ref) {
    var header = _ref.header;
    return header;
  }).map(function (e, i) {
    return e.type === 'link' ? React$4.createElement("div", {
      key: i,
      style: {
        marginLeft: 30
      }
    }, React$4.createElement(HeaderLink, {
      text: e.title,
      onClick: e.onClick,
      href: e.href
    })) : React$4.createElement("div", {
      key: i,
      style: {
        marginLeft: 30
      }
    }, React$4.createElement(Buttons$1, {
      text: e.title,
      colorScheme: e.colorScheme,
      onClick: e.onClick,
      fontSize: "1em"
    }));
  })) : items && React$4.createElement("div", {
    style: {
      height: 60,
      width: 60,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(SideNavButton, {
    onClick: function onClick() {
      setSideNav(!sideNav);
    },
    active: sideNav
  })))), React$4.createElement(AnimatePresence, null, size.width < sideNavBreakpoint && sideNav && React$4.createElement(motion.div, {
    style: {
      height: props.items.length < 1 ? 78 : '100vh',
      width: size.width <= 360 ? '100%' : 350,
      backgroundColor: Colors.WHITE,
      borderLeft: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      position: 'fixed',
      zIndex: 2147483003,
      right: 0,
      top: 0
    },
    initial: {
      right: '-100%'
    },
    animate: {
      right: 0
    },
    exit: {
      right: '-100%'
    },
    transition: {
      duration: 0.3,
      ease: 'easeInOut'
    }
  }, React$4.createElement(HeaderSideBar, {
    items: items,
    links: props.links,
    topButton: props.topButton,
    onClose: function onClose() {
      setSideNav(false);
    }
  }))), React$4.createElement(AnimatePresence, null, size.width < sideNavBreakpoint && sideNav && React$4.createElement(motion.div, {
    onClick: function onClick() {
      setSideNav(false);
    },
    style: {
      height: '100vh',
      width: '100%',
      backgroundColor: Colors.GREY,
      position: 'fixed',
      zIndex: 2147483002
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 0.2
    },
    exit: {
      opacity: 0
    }
  })));
}

function TextBlock(props) {
  var _props$breakpoint, _props$align, _props$title$fontSize, _props$title$fontSize2, _props$align2, _props$align3;
  var size = useDimensions();
  var breakpoint = (_props$breakpoint = props.breakpoint) !== null && _props$breakpoint !== void 0 ? _props$breakpoint : Breakpoint.xs;
  return React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      paddingTop: 15
    }
  }, React$4.createElement(Title, {
    textAlign: (_props$align = props.align) !== null && _props$align !== void 0 ? _props$align : 'left',
    fontSize: props.align === 'center' ? (_props$title$fontSize = props.title.fontSize) !== null && _props$title$fontSize !== void 0 ? _props$title$fontSize : '2.8em' : (_props$title$fontSize2 = props.title.fontSize) !== null && _props$title$fontSize2 !== void 0 ? _props$title$fontSize2 : '2.5em',
    fontFamily: props.title.fontFamily,
    fontWeight: props.title.fontWeight,
    color: props.title.color,
    portableText: props.title.portableText
  }, props.title.content)), React$4.createElement("div", {
    style: {
      paddingTop: 15,
      paddingBottom: 15
    }
  }, React$4.createElement(Text, {
    textAlign: (_props$align2 = props.align) !== null && _props$align2 !== void 0 ? _props$align2 : 'left',
    lineHeight: 1.3,
    color: props.text.color,
    portableText: props.text.portableText
  }, props.text.content)), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: props.buttons && props.buttons.length > 1 && size.width < breakpoint ? 'column' : 'row',
      justifyContent: (_props$align3 = props.align) !== null && _props$align3 !== void 0 ? _props$align3 : 'flex-start',
      alignItems: 'center',
      marginTop: 15
    }
  }, props.buttons && props.buttons.map(function (e) {
    return React$4.createElement("div", {
      key: e.id,
      style: {
        width: 'auto',
        marginRight: size.width < breakpoint || props.buttons.length === e.id ? 0 : 15,
        marginBottom: props.buttons.length === e.id ? 0 : 15
      }
    }, React$4.createElement(Buttons$1, {
      id: e.customId,
      text: e.text,
      onClick: e.onClick,
      colorScheme: e.colorScheme
    }));
  })));
}

function Small(props) {
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%',
      overflow: 'hidden'
    }
  }, React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      minHeight: 230,
      minWidth: 230,
      height: 230,
      width: 230,
      position: 'relative',
      zIndex: 3
    }
  }, React$4.createElement(Image, {
    src: props.src,
    wrapper: "Figure",
    id: "ContactCardBig"
  })), React$4.createElement("div", {
    style: {
      height: '50%',
      width: '100%',
      backgroundColor: Colors.GREEN,
      position: 'absolute',
      zIndex: 0,
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15
    }
  })), React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%',
      backgroundColor: Colors.GREEN,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 15,
      borderBottomRightRadius: 15,
      borderTopRightRadius: 0,
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 20,
      position: 'relative',
      zIndex: 1
    }
  }, React$4.createElement("div", {
    style: {
      position: 'relative',
      zIndex: 2
    }
  }, props.children), size.width >= Breakpoint.xs && React$4.createElement("div", {
    style: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      borderRadius: 15,
      top: 0,
      zIndex: 1
    }
  }, React$4.createElement(Confetti, {
    type: "DotsPath",
    height: 700,
    width: 700,
    color: Colors.WHITE,
    right: -250,
    top: -150,
    position: "absolute",
    transform: "scaleX(-1) rotate(60deg)",
    opacity: 0.5
  })))));
}

function Medium(props) {
  var contentRef = React$4.useRef(0);
  var _React$useState = React$4.useState(0),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      height = _React$useState2[0],
      setHeight = _React$useState2[1];
  var getHeight = function getHeight() {
    var _contentRef$current;
    if ((_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.offsetHeight) {
      setHeight(contentRef.current.offsetHeight);
    }
  };
  React$4.useEffect(function () {
    getHeight();
  }, [height]);
  React$4.useEffect(function () {
    window.addEventListener('resize', getHeight);
    return function () {
      window.removeEventListener('resize', getHeight);
    };
  }, []);
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      width: '30%',
      height: height,
      position: 'absolute',
      zIndex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Image, {
    src: props.src,
    wrapper: "Figure",
    id: "ContactCardMedium"
  })), React$4.createElement("div", {
    style: {
      height: height,
      width: '85%',
      backgroundColor: Colors.GREEN,
      borderRadius: 15,
      position: 'relative',
      marginLeft: '15%',
      zIndex: 0,
      overflow: 'hidden'
    }
  }, React$4.createElement("div", {
    style: {
      position: 'relative',
      height: '100%',
      width: '100%',
      borderRadius: 15
    }
  }, React$4.createElement(Confetti, {
    type: "DotsPath",
    height: 700,
    width: 700,
    color: Colors.WHITE,
    right: -400,
    top: -250,
    position: "absolute",
    transform: "scaleX(-1)",
    opacity: 0.5
  }))), React$4.createElement("div", {
    ref: contentRef,
    style: {
      height: 'auto',
      width: '100%',
      position: 'absolute',
      top: 0,
      padding: 20,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      zIndex: 2
    }
  }, props.children));
}

function Item(props) {
  return props.item.href ? React$4.createElement("a", {
    className: "Hover",
    href: props.item.href
  }, React$4.createElement(Text, {
    color: Colors.WHITE,
    textAlign: "center",
    fontWeight: props.fontWeight,
    portableText: props.item.portableText
  }, props.item.text)) : React$4.createElement(Text, {
    color: Colors.WHITE,
    textAlign: "center",
    fontWeight: props.fontWeight,
    portableText: props.item.portableText
  }, props.item.text);
}

function Big(props) {
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      height: 230,
      width: '100%',
      paddingTop: 65
    }
  }, React$4.createElement("div", {
    style: {
      height: 100,
      width: size.width < Breakpoint.xxl ? '100%' : '90%',
      marginLeft: size.width < Breakpoint.xxl ? 0 : '5%',
      marginRight: size.width < Breakpoint.xxl ? 0 : '5%',
      backgroundColor: Colors.GREEN,
      borderRadius: 67.5,
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      position: 'relative',
      zIndex: 2,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 100
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      paddingLeft: 50,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, props.text && React$4.createElement(React$4.Fragment, null, React$4.createElement(Item, {
    item: props.text.topLeft
  }), React$4.createElement("div", {
    style: {
      paddingTop: 10
    }
  }, React$4.createElement(Item, {
    item: props.text.bottomLeft
  })))), React$4.createElement("div", {
    style: {
      minHeight: 230,
      minWidth: 230,
      height: 230,
      width: 230
    }
  }, React$4.createElement(Image, {
    src: props.src,
    wrapper: "Figure",
    id: "ContactCardBig"
  })), React$4.createElement("address", {
    style: {
      width: '100%',
      paddingRight: 50,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, props.text && React$4.createElement(React$4.Fragment, null, React$4.createElement(Item, {
    item: props.text.topRight
  }), React$4.createElement("div", {
    style: {
      paddingTop: 10
    }
  }, React$4.createElement(Item, {
    item: props.text.bottomRight
  }))))), React$4.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      zIndex: 1,
      borderRadius: 67.5,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden'
    }
  }, React$4.createElement(Confetti, {
    type: "DotsPath",
    height: 700,
    width: 700,
    color: Colors.WHITE,
    opacity: 0.5,
    marginLeft: 90
  }))));
}

function Content(props) {
  return React$4.createElement(React$4.Fragment, null, props.text && React$4.createElement(React$4.Fragment, null, React$4.createElement(Item, {
    item: props.text.topLeft,
    fontWeight: 500
  }), React$4.createElement("div", {
    style: {
      marginTop: 10
    }
  }, React$4.createElement(Item, {
    item: props.text.bottomLeft,
    fontWeight: 500
  }))), React$4.createElement("hr", {
    style: {
      height: 0,
      border: "solid 1px ".concat(Colors.LIGHT_GREEN),
      width: '25%',
      color: Colors.LIGHT_GREEN,
      marginTop: 15,
      marginBottom: 15
    }
  }), React$4.createElement("address", null, props.text && React$4.createElement(React$4.Fragment, null, React$4.createElement(Item, {
    item: props.text.topRight
  }), React$4.createElement("div", {
    style: {
      marginTop: 10
    }
  }, React$4.createElement(Item, {
    item: props.text.bottomRight
  })))), props.buttons && React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 20
    }
  }, props.buttons.map(function (e) {
    return React$4.createElement("div", {
      key: e.id,
      style: {
        marginRight: 7.5,
        marginLeft: 7.5,
        width: 'auto'
      }
    }, React$4.createElement(Buttons$1, {
      text: e.text,
      onClick: e.onClick,
      colorScheme: e.colorScheme
    }));
  })));
}

function ContactCard(props) {
  var _Breakpoint$sm, _Breakpoint$md, _Breakpoint$lg;
  var size = useDimensions();
  var breakpoints = {
    small: (_Breakpoint$sm = Breakpoint.sm) !== null && _Breakpoint$sm !== void 0 ? _Breakpoint$sm : props.breakpoints.small,
    medium: (_Breakpoint$md = Breakpoint.md) !== null && _Breakpoint$md !== void 0 ? _Breakpoint$md : props.breakpoints.medium,
    big: (_Breakpoint$lg = Breakpoint.lg) !== null && _Breakpoint$lg !== void 0 ? _Breakpoint$lg : props.breakpoints.big
  };
  var renderContactCard = function renderContactCard() {
    if (size.width < breakpoints.small) {
      return React$4.createElement(Small, {
        src: props.src
      }, React$4.createElement(Content, {
        text: props.text,
        buttons: props.buttons,
        portableText: props.portableText
      }));
    }
    if (size.width >= breakpoints.small && size.width < breakpoints.medium) {
      return React$4.createElement(Medium, {
        src: props.src
      }, React$4.createElement(Content, {
        text: props.text,
        buttons: props.buttons,
        portableText: props.portableText
      }));
    }
    if (size.width >= breakpoints.medium && size.width < breakpoints.big) {
      return React$4.createElement(Big, {
        text: props.text,
        src: props.src,
        portableText: props.portableText
      });
    }
    return React$4.createElement(Big, {
      text: props.text,
      src: props.src,
      portableText: props.portableText
    });
  };
  return renderContactCard();
}

function Bottom(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      minHeight: 40,
      height: 'auto',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: size.width < 1000 ? 'center' : 'space-between'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: size.width < 1000 ? 'column-reverse' : 'row',
      paddingTop: size.width < 1000 ? 7 : 0,
      paddingBottom: size.width < 1000 ? 7 : 0
    }
  }, React$4.createElement(Text, {
    color: Colors.WHITE,
    fontWeight: 100,
    fontSize: "1em",
    textAlign: size.width < 520 ? 'center' : 'left'
  }, "\xA9", " ".concat(new Date().getFullYear(), " ").concat(_('blueCurrent', {
    ns: 'branding'
  }), ", ").concat(_('allRightsReserved', {
    ns: 'legal'
  }))), React$4.createElement("div", {
    style: {
      marginLeft: 7,
      display: 'flex',
      flexDirection: size.width < 480 ? 'column' : 'row',
      justifyContent: 'center',
      paddingBottom: size.width < 1000 ? size.width < 480 ? 10 : 5 : 0
    }
  }, props.links && props.links.map(function (e, i) {
    return React$4.createElement("div", {
      key: e.id,
      style: {
        width: 'auto',
        paddingRight: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: size.width < 480 ? 'center' : 'flex-start',
        paddingTop: size.width < 480 ? 5 : 0
      }
    }, size.width >= 480 && i >= (size.width < 1000 ? 1 : 0) && React$4.createElement("div", {
      style: {
        paddingRight: 10
      }
    }, React$4.createElement(Text, {
      color: Colors.WHITE,
      fontWeight: 100,
      fontSize: "1em"
    }, "\u2022")), React$4.createElement("a", {
      href: e.href,
      className: "Hover",
      target: e.target,
      style: {
        textDecoration: 'underline',
        color: Colors.WHITE
      }
    }, React$4.createElement(Text, {
      color: Colors.WHITE,
      fontWeight: 100,
      fontSize: "1em",
      textTransform: "capitalize"
    }, e.text)));
  }))));
}

function Socials() {
  var size = useDimensions();
  var socials = [{
    id: 0,
    name: 'Instagram',
    height: 30,
    width: 30,
    color: Colors.WHITE,
    iconSet: 'FA',
    href: 'https://www.instagram.com/accounts/login/?next=/bluecurrentbv/'
  }, {
    id: 1,
    name: 'Linkedin',
    height: 25,
    width: 25,
    color: Colors.WHITE,
    iconSet: 'FA',
    href: 'https://www.linkedin.com/company/blue-current-b-v-/'
  }];
  return React$4.createElement("div", {
    style: {
      height: 40,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: size.width < 600 ? 'center' : 'flex-start'
    }
  }, socials.map(function (e) {
    return React$4.createElement("a", {
      key: e.id,
      href: e.href,
      className: "Hover",
      target: "_blank",
      style: {
        marginRight: 5,
        width: 35,
        height: 35,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      },
      rel: "noreferrer"
    }, React$4.createElement(Icon, {
      name: e.name,
      height: e.height,
      width: e.width,
      color: e.color,
      iconSet: e.iconSet
    }));
  }));
}

function AddressLink(props) {
  var size = useDimensions();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("a", {
    href: props.data.href,
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      paddingTop: 10,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: size.width < 600 ? 'center' : 'flex-start'
    }
  }, React$4.createElement("div", {
    style: {
      height: 20,
      width: 20,
      marginRight: 10,
      transform: props.data.icon.name === 'Phone' && hover ? 'rotate(10deg)' : 'rotate(0deg)'
    }
  }, props.data.icon.name === 'Envelope' && hover ? React$4.createElement("div", {
    style: {
      marginTop: -2.55
    }
  }, React$4.createElement(Icon, {
    name: "EnvelopeOpen",
    height: props.data.icon.height,
    width: props.data.icon.width,
    color: props.data.icon.color,
    iconSet: props.data.icon.iconSet
  })) : React$4.createElement(Icon, {
    name: props.data.icon.name,
    height: props.data.icon.height,
    width: props.data.icon.width,
    color: props.data.icon.color,
    iconSet: props.data.icon.iconSet
  })), React$4.createElement(Text, {
    color: Colors.WHITE,
    fontSize: "1.1em"
  }, props.data.text));
}
function Contact() {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var size = useDimensions();
  var data = [{
    id: 0,
    text: _('email', {
      ns: 'branding'
    }),
    href: "mailto:".concat(_('notFormatted.email', {
      ns: 'branding'
    })),
    icon: {
      name: 'Envelope',
      height: 20,
      width: 20,
      color: Colors.WHITE,
      iconSet: 'FA'
    }
  }, {
    id: 1,
    text: _('tel', {
      ns: 'branding'
    }),
    href: "tel:".concat(_('notFormatted.tel', {
      ns: 'branding'
    })),
    icon: {
      name: 'Phone',
      height: 20,
      width: 20,
      color: Colors.WHITE,
      iconSet: 'FA'
    }
  }];
  return React$4.createElement("div", {
    style: {
      width: 'auto',
      height: 'auto'
    }
  }, React$4.createElement("div", {
    style: {
      height: 60,
      width: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end'
    }
  }, React$4.createElement(Text, {
    fontWeight: 500,
    color: Colors.WHITE,
    fontSize: "1.1em",
    textAlign: size.width < 600 ? 'center' : 'left'
  }, "Contact us")), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center'
    }
  }, React$4.createElement("address", {
    style: {
      paddingTop: 2,
      paddingBottom: 15,
      borderBottom: "solid 2px ".concat(Colors.MEDIUM_GREY),
      width: 'auto'
    }
  }, data.map(function (e) {
    return React$4.createElement(AddressLink, {
      key: e.id,
      data: e
    });
  }))), React$4.createElement("div", {
    style: {
      paddingTop: 15
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: size.width < 600 ? 'center' : 'flex-start'
    }
  }, React$4.createElement("div", {
    style: {
      width: 90
    }
  }, React$4.createElement(Text, {
    color: Colors.WHITE,
    fontSize: "1.1em"
  }, "".concat(_('weekdays.mon', {
    ns: 'dates'
  }), "/").concat(_('weekdays.fri', {
    ns: 'dates'
  }), ":"))), React$4.createElement(Text, {
    color: Colors.WHITE,
    fontSize: "1.1em"
  }, "".concat(_('openingHours.week', {
    ns: 'branding'
  })))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: size.width < 600 ? 'center' : 'flex-start',
      marginTop: 5
    }
  }, React$4.createElement("div", {
    style: {
      width: 90
    }
  }, React$4.createElement(Text, {
    color: Colors.WHITE,
    fontSize: "1.1em"
  }, "".concat(_('weekdays.saturday', {
    ns: 'dates'
  }), ":"))), React$4.createElement(Text, {
    color: Colors.WHITE,
    fontSize: "1.1em"
  }, "".concat(_('openingHours.weekend', {
    ns: 'branding'
  }))))));
}

var img$1 = "data:image/webp;base64,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";

var img = "data:image/webp;base64,UklGRoQ3AABXRUJQVlA4WAoAAAAYAAAA8wEAAQEAQUxQSE4SAAABh6AgAIAylW27iAjw75695uislpxiyGDktm0k6f/PTrpMjOk5IiaAi6JgZAOEAJiMFQnB8KejIaeiSpAKUahR52zBgkH7IB03WHFvatwpaf9OmgID+MRXZoMVEze2uaYnHkGzPtuXXtk4vmNx6J1+yIPDMG+3bVW1bdtWRopYxCKk//93eVjHI8wxxvwU0f8J8G3bTl3btm1lAcaAAen/f7dfDEiFhsclhIj+T4D+DzldtdabvrXS+Sv7L81Ysvum7On0x760lTyf1M287mV26YNy1ve/sq3wPR3sujWsuEdE9cvoG0mn+5k++Na9k7fSvziuYL9l/3mkyrSmrdiKHbWNR/8Yg1/2mz6N3Fj2/GewVc+zq8uvOdF3kRqbPW3UrWdLpU961uiqzOzXZ+Fs142yVfZ03BFxJY03y+RMH0XfI63UNlr6sF1kfnOfROajbeS+6Fm/Tk1WZP9F2O+UY/Jm/Tq9sib7TwXwKSWP8VVWZfc9HF/8v5tcZN1GH0C2y44NvXsd616ycjl+pTG+56rspXUcLyXX2UsP67pQ3alY95G1mY5esFsXqqtK6wRZPZ08Z78sdMbwFixcl2M6eP1DW0ky0586yPrp3J189f9m9aKgnzv/dKsh0Xh9BmlaOu9oTFtNF60uFeUbobvx+SmzoqIfu/IpzHBFxnZPkroKcacufWGMpyzju0ui8zp1qh/SuItl6nspSccuta1Go6iIzeXYwfO/aB6DqYnR9dyByj8UwmBq8j0B7s413w6jqcknNZmafHBFPqXTI+rtp0WxvBy3qzOvfo5j09Jho2A3Tili+nXWqLEfJwSx3Z21LF/9uMe2jqPu5XUd5sT2ctbKO/GjsnHXWeMBaVS3reOokwx8BnmxPZ21MKIOum1jOmt+nce2hMM+Ig/qpnU6bW1AHCSmB5z2+x3TGGdbOW7UXyWMDbZJPG243jT6SeJPG+JeI/ymTqcNZ994CD9K8nFTut7JEzDemSfuuI1mGXPte47cH9/NE/dFVPvKF5HsE/og/A+IHwTYvue42eX+pBT9jGKfnDWrnTUXP8z/gHDQQudrDYMU9qVjRo+MzDTG7CunzHcZ29wQVfPqIfMso9kPceb1M+ZZxjONQLJOjhh1mdmGoH5AWeamIdQ/H5PJ7EbA89dTZ1GHwLNlfMCczKch8N2wesDyAnEMqNr1HLC+wDMISGal80Wy4jC4OiNHRdf5Cku4YUCoo4qDU0TnKy4RJgAu92/9dgDQ1DSc76QOQL6etmrldvj7rOb+RqbJLAT8e6fGfSi/pK6k4oBfZsVHtMYT5pfAyHRFB2j1/AklFrUdR3yFPiDd7Lby7WZRfJ2xZ4H8zjofI+35JporznhcILwqfH/Tzi2q2R0y4mkdby9++aYFPaI74pSnafGL4yE8M2qiu+CYE09q+PrI4HOgJrobnTNck/wbL6ObBGqiuxFOep5y420ZhglNdDfCWS8TCl7zuFtFdFfCWac0ruC1l/FRRHfGYb+6jOaI92ECXRVfOOxZxj8YeM/4S2fCWacmMyv9huJw2KnJ3Eavgj2cHY57ldnPK29Px3nPMj+/AZsj4bgFWTG8eex5jltfov8NhZhSSlcI9ggdtiRr3vC5ieVxJX+lVYMhzv9p8CK9ifHPKtmrrMyJFvLPLwJfKxVf3mFbomwiL0Gpy/Ldr8PnNxAXCjZb+R/l2QVx8yixaGRvhtwqoG4JiZ29K7umXSxKOZohRQdlRy47MonyNImKKI5mSNEhYUOSES05QFueQ01URzOkkYpnQx4DaggEAF5bnUJNlGczpJEG2ZBqgAT8bbCsifpihrA/BZ3My2JgMUPYHwL87y6IiY2sEI6HoKe/uWqDNLJCJJ4BfHBmBbGyOTMkbd9jQxugLY0rI2oKc2PhIcLeDCm75zaQB7ZK3j8OC948QtibIYX2zozwoSoLw8K7gjVdGyF8mSGNtk5GxJCV0bD0qmNVaiNEohnSaOseG9pw6eoY/ryKy8DxEIlmCPudu2xgIF1lXH3l10EaI9kMYb9xYDvQVF3rYGEaJMUM4bhrV2Ex5NbEWMcvhGeQFDNE4o5R6mLmhDSVheJKaZQ0MkPSdlFiMXSCoshPeF7VleIwaWSGlM26WUydhKqnYmJ6JddCYZw0Z4YU2ijfxNaQ4KsoDjOudxwsEPZmSKNtSmLtLSXR/GAmvRNJFgh7M6TRHlEVcy+qopndFDwDaOVvQDiYIex3yDexN7CovjH3GgGt6BOJZgj7/fEs9jYW1RWz2xDoUZ9EM0Ti7niW3WSaFgaJ9KhOkh0S98az7CZ7zM+jRHrUJsUOyTvjWbbzwoLUhon0qEyKHVL2hZpsZ8SSjseJ9EuXVDJDHtqVR3aTPRb1PEGkhmVqGSGNVNQ0QhrtyS272TyW9W2GSKZVUEZIIxWII6S5HXG8Gw9hYapThK9VEEcIexWII4T9hlTZS76weJoikldBHCHsVcDzAGG/HVG2khNhed+mSKNFcPEA4aACngeIxM2gvhOcCCojz5BGi8DzAJGoAq6NkLgXSfaxRYJWSjxBGi0C30dIVAFqIyRvBW/EA82UJkhbBdRGDFwDVEcM/GVRdlIV4Mo4yauAmhlA2Zu2FUEX4MowCauAih0oO+NlK5M2wD2j+jJAsQP3xuS9KPqAUMdIXAfZDsR96XtRLQBCHVIXQrQDkTfFy152G4CLB4hbCNEOeN6TezPEClAbEFeCZzPgeUuePxRQe5eXgmczQG1H+p8K/Lu6FnwzA9Q2RP5YUJSBmhmgZzvCblRLLm2gZgZQjlPOw4I6oNiBshlpN/J6qfXbLhQ7EI/Gvd4D8tCY2wLcdiCeDL9cYeR7yPMqq0C0A4GPBWP13CciLbzz8jrqQGQz4PlUlNXSy2a9Xnh+55XAsxnw/VBcq2X59+22Vbo6nzu0wLMZoHYkOha/ZGDc7u7BL7MeuGYGqJ2ItJjjEX+kUwRqZoDKHlxbwbRYk6ULNIGqGUDZgrAVCWtnWdvpAoodyDuAnei0VpC1E7Sh2IG4A30jAtZ+1qrQh2gH4gY8+5CxelqpkQWIdsDz7yG7/I4ITzEAuLehYf3Ql2kEE3CxGfD8W3xusl/vaxeYFACJ13gIRsCzGfDtd1Dssq3soZMSz+MbI7XAsxmg9isSy76yh1pKfVIhWAJqZoDaTwhdNrYRVF+Fh/XkMFgPqJkBlB+QZWcLQX1Ild/V5DFeEajYgWIdNdlYvmCks+J+R8STUgoeducXum/bfJONzYQz7Vi2lYvDoaYmu9oi4VhX2VGu+SIc7CTbGTyOt5ftbDjgbT/SAYuyn/6A9f1oON9R9vM+YHU/mM6Xk/3MON/3hrgD9uwH1xT96eL9+Fsu4WQ52dcez1XYGJHmT9WtpPBvgHSokpJAiX+DVPoSAEr9J0ijTwHA9fwCafQxALhye9fLY4tUZfYA/bFZAeosoC8y4JKCeUgCngmE1GhDBZsUKHKWkpyxPzYxcElHh1sKkGSADwY+sdoB3mvwBrR6KCDPCriMpSRn7I9NjLE/tnqAMgPqYBCSnLE9V/p7+GuI6Y5pTXcgAMUWyapO5mX2An2Dc1Z/hW08cEg64Z5USD8Byk564dVeP7ZullXSzfzQBfcs4PgJcO0A5ywBPBvkb0Avw6UE029bJGh6wc380TRDg3OjTlLfsTEv3o0LTknqtEnj1VBtnF12ViBtPPCmD9SdC4jL7KomHdCLnfctHdAmB4SGauPssrMCx6yaPdBmF7yQNuLDZac34BQQjEK0pWmCV7s3GNSNnobCjtYDZZXhHgKypAw+cS0dTFKArW7oSV+wjQ6X1ga3lg/kwaFMXEsHk1ThnLkkYNZ4Lygb2J5JUoUuADrqAvDdEoqiFzxtdF41+gZleH/1dlpaqBOSEnBLuiD/yHcK9IwXRYjVCaHNA3pZFLiHRtePHHwjQZsYXAc8i7fTfqCAE0BTkVcAPZY0RRfQPc0KFN1wLjqPpAzvho1pEhf46gFJF9AkBU2TamaWd2LjAUxvUoZz4XDtKIBWJgmaJIM6q2ZmeSfAZuEeUCYVDr2QZuFQflDAAWQV1xLAxXZw6ZED9GvyQFKGuqiQpEq/N6Y2U6OnhYNJDSBLUGfTmF1WAppmQOgbddqObaUAaCZJD2SpQp5NY3ZZCWiaTbsNqfNKDmWRGj29s9mlAqtStqMo0lEBbkkH9IgA0uyEotSp/iuDujC4ZFDg1gnnL6YtL54O5RscfKNMsplGCwCTVMCVOq9+Me150SJe4JRUoEW88CxUwIeBFZRlAFesYE1SuoFDctZlpsarAraj9aCAPBM8qjQ1Xt2gmWvp8EYH18ILkN+p0c/JBXUSMJFywCspwasCZeFaOrzR4dbCJZ3wSnpZp4UC4quyyArCQoDLbIIEVVIFkxrdzOyCZ3HD8dL0uwyxCFrqXLrheHl+YspAWalCp3cnvJMM/fii1ECSHjgC0k9MGShbAqQMYWZWoawM6qsX8l/ceh2rx8eCpCZNYjihauyQZhkqXH+AKiwcLjiUweH6kQpQVnqh0SsFTBTQbOOY9FmBG6p+pAJcOxmadMMpSRmelR7kRXog9LdlubgcgCvXV63ktYqa1h6/G3SpQp5UKDM1gLQV043UVwadR9ILcCxajGWlGwhbpI6Ud7bKHXjr3YeDt3rtUIfEaKsWY1npBsKGFhGAS52maYO0OrbeiAB6njlerEHrYZcvzQOIa1UtmXnPSvBqesKzuIGqrfmGfCWAIukCXi3mvqEbKAsZcH1SXSg3lpIzf9OgCjSt5r4hB8owr4QC9+yGa6V7Zx6HlmmxoOZ7+gk6a0TElaTsbjO5u1TcpcPds2TuJqn4UpJ7GZK7l8nl7pJ0uPs5MV+aZO7HIKuRdLibJJ3unlTcJR3uNhzuboN01oiI+5RSeSLiKZpnd7fZ4UuTzP0YZDWSDp97AKf7MTvci+RehuTuRZL5tBzabUtl/Kam5t9Mzws1+lH1QOFahx2+I8RV2MPQeP4Q12APS8Na5UwhrsAeptJa96FC4GnNwdi2lLfFzD5ks/RPDfRMSjA3r8RQa0AZHHxSXsb3XNjD2MrEmUaZGNO32oeAnoYAScbSJGca9zExliY507dMDHwndSBNHCiDg0li2p9oFHD1CdXDXr9S0dXTVmVdJzfrSDtwbwFP+sL9BwH3z+D+RQEoG+0HItK9UUDsg2qAyX2hoAvfuaF7llWgSLqA25QduGeXmQPHrJqVCsQnjr1qY5pUsyuAe1ZtTJPLzIHjBy8vPBv4B7Mrswg7q4Cr8KuePYyO6zQo68fqALLGC5qkDkWjAcfEJFUoM5ek3KF8evZcSweXpAIcE9fSwSRVuL55uB44NnrakwBqIsUuACHFu6jl9rCbeJlLV0BdXXBr3iDLIDSvUDYcfEsFng8V7I+Rg//Iwb9lOApci4D7G4hFTPuhcZUKXR5giwq2uKHI4VoU8I2Ac0/QPxzwblUzs7yXISbVzCzvBJzfmFcHvAsPOL7hEQl/BKhrsNN2QCxix8EHW9jqsiug6UPABzmUnWnsaTWN2WVXQNOnKFzSC8fCIH6Q/hgcL3FDm244/4Dz27TlLy/IGH2WOi1ttIiI+0ctIuKeTVv+9rC8Fqpg/1wQVijQlzptdkNZVDBdcC989UaHqg8J3i8q4Buu5YbBM3EtHd5oUPXpYP2ujs77LeD4Q0CcV2GAHN5JgZilDkkZepo1yBNT7uAfHKqSjcdCjd7+iAfKD0y5g39ycDOzF46FHNqXDE1/jHHWQyaowUQd6pBeqJICIklKFZoWMsC3LuDQ5swYf5Uq9PQTGeBfGl3jBdcqdfhgHfyfAy6eUqB9ca5OoN3+dOhJUu7Qq9cOPW+oAM2GFhEARd8UOy3Ge9IiAuhZkxZjWakAzYYWYzmhTg54VypbEdGAqn+ScQJfsEKxUOnMI2vMjXnL2lEByjBvp35x7MxjMo+s2dw3VIAyzL1CnuiFY6V3Z9pd/yApy/hC0H+425Dd3Qal64mI27QuNSJq0dTcj0HHHYcOn15ZH4v7oOLukg5fFsl8Wg5ND1+aZO7HoOOOQ4cvzd01N/csc7chu/shyeemf5K+yfDi8FV7lsH1JnzW1GRwxZf9yPD0YQWZ6L6rNqN8VkGm0ldV5sSvqs95viqZ2z+qMEn+DxtN4o8Kfc7zVZU591d1zXFfFfqMB591nOG/K9RxGR+241GNvix4HtMI37bnEY3wdVN9lwkfeGl7NeAjP2ubtexxvgFWUDggWiQAAFCpAJ0BKvQBAgE+HQqDQIMH+4AAYDielu/HA5qMADM/Br1WTo/4s/ur/leif2Y7q/uZ/cdjp5lfi35H/XP7L+yX9p///1l/wH9j/ID5Ufab7gH6L/2b+u/tR/dP//3vv2l/wHsE/kf8v/2f+O95L+7/4D2O/rz7AH8r/mPrD/2D2EP2q9gD+Kf2j0if+D/Zvgc/kv9+/5f+b+Ab+Mf0D/Xfnd3AHqKfwD09+lP9Y/GL9e/6V5mf4r8jP1c/u/eX+efan9uPf9yt9kmud8l+5H8v/DefP/R/w3i78wdQj8s/p3ga7JnVv9h6AXuv9o73P/G/wnqL9lv+x7gH89/tv/X9Uv+b4G/2P/iewF/JP7h/u/7l7qn81/5/81+bfs4/KP8t/6v9d8BH8w/sfpV+wj9xfYY/XH/6knx7xe5jN7MPq3aSxrnU7mQ5bTsjR4R+J6oJdfdPp7IGtAGY/veO3o6uMlhu4Htr8Sc6ce8ZG+HVfy+AMV7E1k21M5Sp7zP8Tw9qeD1T5Tcr2r05zp1+B6u28EI7fNgVg47+KeGvpzMxbx3DjrVdwWpVJP1krtD3VVMzmJfOkCDLixjtaFwmpIw3/e/+BmDRtv2P6wMGXoR3FPDXvcpnQ8aLJxaeudt+Q0hOVgvXjK7jq/Yq36+dBlIJRUczdzRY6ti19OZmLeOz++H/A10aeJtWAvGK/pmZgOSbV4wxkYEdrA7To8iIIaLz2y39YMvQjuKeGvpxx7mVY+Q/vqoSOVLylAgIszj4nJgNseVUyEagWD/LAYzxv5LjbbRvsxbx3FPDX05kUGQTKZoVwzy0b3AQfovhU9ATjXCNCbwSxNrDJJ6pB/zwwfKeVLB0SfUTYBI/B+SWGOMyXFPhHwM2t3r4BJUf2Jtf1xZFr6VATnKh0vhQw0opNO2qSwBS21A9gpb1zFRAlzb5P/QDnWI9DTRkY5DTDrzaQ3oge6c+28kp8iV4Vb9F0H4PFO1G/B4AKfALAa91Lz0fWdb5Jdc5I3rn3Q3g+7YV4UvTMQAjn6MZ2nQ83kmjfXPvruKugRAygAgX8xQ5AQotWo12HtaoR2fx6PQJ93oR3FI7+XjtXeApVu8RhtXR7Mg2pJg/Qp7Lt5DXWc+CtzGgJjwWblR9W3Yjdz40caqVqQSa7oe60xSAh5jMxbrsm2sw8MAwt4DkYl5jo1kYDIAkpxxuY6KK5CZw/Ghv4e9oa//xUJ/CYYsw43+A3esqKKJcWfIlrHCZiinR3CCuKeGvbjP0mQUF9retLvqfjq4ED/JsenMgdHyruOjIB3xqLoKKEe/e2CdFwPkrJWdzPACb0dxIb5E2d1mgkQnU5k0d03yXVcoNYBI4QDiY870+5eIJLskaKqO5eVz4Fa072ZH7h9PQeZQdP/WJyxcr4uNW0V25lak6QDN5DehipNAjYqh7qWxrVSDa7DoNJpTLHKcik0ijvVCXdtswYKJFyxnuviDJTk6HvPX7g92RCrhKMw81IhRI8DkLL+FBcvacbbs/gOCxw89qnPulu7eEHRvEKAVBYBFijkwSliZzYmjz+dFi66BJGIR6KBxPgfl7JgQSzz4oShrY2w4EI/HA1XQD94TuSBMG0T7NBbD4yLEQ9SJvDKeNrmDl9Yv+IAqnFLoZM8ZUg0pOU8YTt6pCTogkP7UU/0+p/9hSaAv1v+tYX6//86KZCBeD7hQvkqOIjfoa8frXPGA2oLXrWPsi581bXUT/B2OQ3pYkRXoPTv7JqhGooKNe2/I5TLnTTKh3K1IKNfTmZi3juKeFcwMGXMl46L+fv4lPXa/DX05mYt47inhr6QAA/v9gGJT+UCX+OVyUDcAXqQkHkWNif9D6lYAERSQyf/6vF0U3MzvC41BImvdI5v6j8CoXE+/xIKctinJRWOvD8365DdgAAjOdtQFftpozg9haQmIk3vfJppDTUiA1hc/+T+y7JQiHfhodmJeNFbKW460diulYfMHS0muJlMuBi+vmPmIn9k22V6wS87DtAeQqzJczEsfpZP+ucfxIwF23S9+KOuuwv4DI9MhZGca/R7GSP9qDS4Al6qpOO496HBqbd8ZSTT1ZdazIgETGRMfa5aOMjnBid8LalgUPGnXvmoDZbqzRl+csFhvpE1d9p0AEagnofYuWF+Rss1PBqAC7A5UJ81v7opcNo63sQU3WgE/zvRIjB86qXAsy7oygUDpSjuBQh+7qyWBs6UWoDrVzjr0llNhme2s1QMc4jUpk3dylIY9siB9jGi82kh9G9IIpQ5MKcuY2E9hpP4jbr9NRCKbu1KUJEn8mfK2eJ44gx41Qv1Qyra4vytDFDFdoYpCiws5a7zLS745VK2+wkM/7nB96e260NzrsNrE5SyPE6s6AK9f5zGcfvjAR5JEKhHugFL9WHOYM8voxQYXHXTIAqPyUIgELmpDRIJ5HLHtTFVG2rrv8dZGo/kLEbjwj2XyhzobDROpF5N4DhLJXWiCUFbjRyO2JSnyLAqg6H4WEoAfwc3Wm6WCDkFqb6NNw8000+X4TSnAeuoZuN7jPF/+6pqaIizCQABU/zMixc24VAbhtK6oHTGsCG4NYcsrDZCVdMF0q//FrQwH2qpWxN+0R/9p1KFQt8tL6ujKUvZaJHnB8FuemP1LLpOVkKx/KjWr1hxohND327/TSSXsuQVHL/dZnP3O4Yv59+osna8Fp9B1qDsbP+jdFqw22XzOUAyNZlRgm0X0Nd39D/pWy9qChERSGMG6+Jl+NmtYqlpBCXa5SK6qAQsKNcBHJf7+brhrs3GRBoAhkeikU+P1sUU9AH6xGwNrxtKq6eAwnjOIaXpl3k5rYvGgIQg1MXVdKvVmvJrRLQS8UyclOJrmB49CGM/ftKWr7/gKMW5siImAtg0gnfXQ0ZKIYjxM2H9K+bdTDrmXLDF44ArwpJMfRyIUxH4iKA3Ws3M5nYHomg7ZNBnsnczqi/NCgjLa5k4YznWjTKIGknFxsLYtXjZ47hu6rzS5YREBOQuaOH9H4OWothZwhOJEBL0ahM7zD+e+sWYo2SwCd8z8Q01Ma0nUmUMNmIioyFc/Yni54D9ImKv4R3q59Lc3o2c4sTDXaCQi9UunH06x8HvQBAz9dC4I2ginQqGrcZJZdBTiNdT42Lz3h8W13gEhupJyz7DPz8S/hf/9PcPVFMSbepZTe11KqVZFPwssQcAfLWMcgASn9eia2nObcpx0lrUOMqfjutNiQPyLhfRLP+PgglBoJvDx2lnfbyn8kGf7uhx7vkXPY6Ux+mkD4OAU1in6cgYNiaN12rORRgOg7G8GHlTA/tIgddKAlVUzNKZVkEobWMu0ASzeKmN6BtKCeNKM8D4fuiiruZS79Ue711On5+1bT1e/AogxOIiLjoj6C1S6S4XJwetzcVpae4ZIf8oE7bCUcXPV3RDQSpg/ycJYypvP8s9j2O9XAXEZ5Nt87HsNC0v8Keb+aYFGLduxotjA/PmOxAx65CIC48UPVdzSO586yT7kzXtcEl9NH0awdY9dHgiRzMyxwXLEfg5aDJnFJrGxqDpavPnh1lJeH//DXo2oRo5wJ4YeNXVnlIEhWTGXn6QIIR+ADUP1//bZ9U+dFac8y3rexf/OORvK8yJBQymzHN8NIrdOYY0tpCwMHqtjYhsAKzFvhP4/xMmpgAsIlVkykCK5j7FcBZW2ttxKjDchtFwf9HdeIDSt93wvWUuozMAnhqFYwhIjNbU5lEHtAFeRaZ30ArZVBYDsmSbqBuJjr+M3w6FbUjgb+J2ZS38trkGTg3t074fOrjAjgMA1FFh+jp+xerMGZHwBivS+sHJLRI8wWYKZKN+XwARONXeoEByD+bWxPb5JBbOXhAP88iD2F1Y95dnbgq9ytis1BjAZU2DkMJNaVkBEu2c5hYDagHTymHJX1q+x7F7JtHDaJz62DJ0FuRyIt9TGnAMWlvO1IEACjyRD+er4pS5wZHm+QD6CaA/XJvcwXP+1JeljejFa/X7tTcTXCi3xGV4d2U8770jMHL6FVfr08rLLOZ+bo1mGPDAh7yB5ZevfszZNJwj0znqhtqtmhkfdb2G9ZAFbNDKkUxdukDstlIZLvTR5JmDiVqxwAaD+qeSJdjFwkvA98TbIGUMS7c2ZXipWkUcBufYbU48xi0OYiIDgv/zJoqAHPr8xp0MPBRvaNbgmpCsrP8kJUBsyTZQKxy+OJDpT5OylYo4KBYd7p5q/7S+YummjVrbKolm97WMa6eFUI04EXFoKMDcYCBgNKMrwnPgovCNWQHVYleHUiDkhNd48nyrolRc0tUXehGfnJS2PxwtdkYw+gjOR//4wr5na4+0GB9+P8sIfE5/j95L4z8JDwACY/tCKn6jujA8iTQSXBlj6ESPBV/cQZDEJIZBN9xeYelvsQuZSpe+gRFg2RYVdqXjar9tmvM+h0/MOIcu7UDg4oVT6+Ld8tfpjYGVVwVcff78SEexHbCRIxZwdKlQ7JVeD/nzEPGyimy3izu3YB07hPPHRyN04TrCzB3Uf6OFLdYKQs2+fHcsaJzZm7b4df5wWAfVzSlbuPevb3W/5ntyx7MjGz+ePvN4vR4PSApkjPSJrFx0sQz4dZvuBQeeFz23RnZHKGwlrpV4C7BaCDuT+1YMPBXt8N1gRBD/WxD9Pm9I+yLiM3/F3TKmI5SxQenKk7SdxsB/hkTdsx6ZI/t6pk7w8FUsXVRtMoIgj2vREg0Ssio0p7lI+1WrU2zFlG9xxiB4GaReE2HE29hBebY5UarVRzsknq+FA6CiN41MJEEvEnusCFeYmCRl3+khZ81bnTvWgOHrXSgFg3Ll98ozGvEVcVoisrhdTkgTjV1ilbqeZwBMT13t6mP3a4kh4e8blBYYkg79UVx9ac+wrFxVlOkBW0qsRNqe2bWwVf7GZM9WicnYxgTKzG1UGLwouaNKwelfXL4lJys/BQtvOd9KT6hSGaf7sjw7dlB/uFTNFscWUjIKSVRBrVC4ljAAKucAB1gf51ZvPkK7BhhNM2CeOb9ULx7U9kUL1Uv1yVwgxJsC5qzBLhewKJNUafziX3UbOcUE+wxhIMmpp9KHRR74muU56PtSRfZDXEj0bKttaKiYz2sHQTlpaBa+doPtK3mFx/pRWF2X+nq4sjYYM+zHxI1KSwrsNhsClp8SMzGX+sOZMUoxxLC7Zj0GhrA0kI7cPtvw/zLwRNYB7QFVAthso+5t2ioY2+JO69Csn1F8fF5La6AwoxK5x2OVjISRTfrT1oGlvIZPi///EuyBg/hjuBtQJFHpakcNAuXt2H0NBx1zOUoL/95F51Ch6nJktnlz1T5OafsaxNbJPZYC7sfPwrvup4mjBD28gkxeqtH5uhzH1mNOxaIvWmuiQWgiuuCSpnLd0GLPRGNqeR3XaISoaaDdTACGThi/omRGT9Qn/DbYPkMkjMCR+ZHIzTE8KCF0OwAizsAACc/vI2zJ5h6EgJREF6kj8HSkO7DW1SLwnGbkMwt2Jt5YjnCuIA/uEqjfVjsQwk3ckpFREUI0S2GZkRwl3rKVzJY3Z6wgOmAQDRZuhxpPOmEWno60RtzgxQefExFdOTBKeJklc9p7bE5NmqOllNy2EUI6SSmRK3DChgORopY8ncT/AUpVDD8EFC5xNsDJflqHnJJkVSQoOmz4xRI5qaPM/O7FY3zB+fYWmZMe9doDjJ/fbk4dkan71z7FMaHJlqkAuCunJINQFYL3/4qYdSRPZJEMKGGEwKIuwQA0uOCpTL48/mHnk8QVgoFa+ooSBJXcK5z/+CgHP+3g+GL/jns/uJ29uKf6Lt9YNjX8oY28oXOXcBquPDqyL5FyIqiisEBojXKPtFD8ksHa+hxLJU7W5/PFBL1gqUppaLryaLNL0fKzoJ43vfwmvD+7g7zsR5f+5iWfKRh1IG6YZRbf2Z1rCgRlSH8afs4hjT95pBvYhowZgSuX93KtUHI6NvnVwdCR2oQ+DuSnBdiziSjBndQY4iL55kvBmlJ3RYHmcef/4oYzbhRnhmngntDiEZXTxZki+L6v7V47gqqUPFYWQiklV5kD19EBDdkFt3iUpI6K4biqjlOjruDCIewefEEdgrg6tw284XfoUkbwiTsB7STAaPsqTLfZa28FMGBSbQO5WjVeaMJ/TC9vm0tBUqxAsqoKopW/paKcDEn3oDiqd3kSdI4vYV3ts7Q336a7akaT7JJmcEZ1oPuXpc/MMgrjIl/U1HYynKGu+pETDZR89O7bWYcOp1tCBiRI82L5BMKFBdt6EuIbqHXKBZR8k50xFD5a+b1Yv5RfVjgvvOGVlqkkxqTIpz7CXTxohbs06bFPO5HJZhRSz9J+GGZhrYb9w8lbgruFStieOC1Znyw97B+1TGF0rE2GMZkaX8d6eFf5NByj6R3tfPc2HhgRLf0iybGUBEDw/w3RHIXuUGvdgwIXI1+VSL2vJ9MAJ38ZDqcLnDALtVTs1HqsjODOPYGXm7+wb0xI9fhYBLilK8HJcxPSLHvoOginCMGHudDknLlu5/6kZhjtfdVF0STIoA/1IPPOhcxAZlA3AY6kwjaW/nmFFmoBTsAu7Gtlx5E/Rhmksk9fCHGUziU2MQnH+2tws10FTqI4yyWsN+685zKjaYUjoiCuUAXqhwf3LkuYIfqAsmUdzLPW1K6+cCfkWNa06vrs6x8iGVby/jeD97Iahi/UGtucBPD/IupOmY6wAZaOXYwr4HOAG+04kpz2E/jhIy58W+qQfgyazgjJerYSlwNx1HjUR3rsrIU4yYCofsbnmmEI3rPIbkiFAhamlh8Yun9ZtlUH5tJBmlQK+U8EMysX+5y8bOtA6s0DBXb7hog+bTVFp3L0qJWrTlr01Ke7tqc8GXfIzxBhQlbTiJJJKJOG+EHBocN/vBXVoK7sf5ipSHrlKA458NnwL7MoNeVU10wzVA88Y9iV/xRH4FijkiCj5RvQKErHk04RB+Zi1siLNVsHw8UEjRPqvbiUfM1Wj8cfApzyWZPQHTLJfG9p1irf8c/PyqhgTe0OFNEMi0KRHKvfV3xkukxPg5AY3TMtXUSe2yrcl+He+wqAOrEhhbQFOQQjMIiWDLLUN0u4xWATpKQuzQ6jxxS7LwrzbBlcIASeOeLRl+iW618QKhVLbmsJkTycS/1AjC2du/o3WM6QGclOj2urXWB2alMjxGqDyJZ79TikXbKo1vtgP/AmyqieFdIu/T18qImdENDGf4dtfY2h8bq9C0SfF+DcFydQWoltiqb4xsPjEcKmZJ3fRaP00Oo2QAM2Hc51oAZDDEuXJ49SPssNWg9/4+4Wz7ev/YoOAAgUdmeVxUzpJXILZXafNjxYX93kdYVhFucRpFuxAEXBOW9oxpVSxxV0Ud3QbjNqZNXbBP5WhDrL8P8US7bug/VG+ox/pdY+FTRvmzo6iLuOpnvjcA+IJmH5ZNaNoRxFCNjswq7ggz1Q/wqZbmtYAeFUftlUSK2nhdMWZT/OC1LLBrbmZtmSDQjh6gN6T6jZo7tqXBNopLpuYCkVAnDFitj8DCETMYjqjrX7be3uPS53ocWbHNAVzXiF8sibWO4xFGc8fWlgZFe8MBdRqv0GP9oRA1FgAF9kUggrWYIw2jqyiI0gcfzCsKsP2S39G9tOc+8F990bdThaB0BSJqUvwot0st3H/6X+Jx5GDDP+31fpGny34VvO7WWqf+Qmo7+IIlpKUZMwepTomnzZOG7sjy/Y7F89Lm/sYPUNg1RdeJaOpKCLos+chBOwgMd05rzRgeK/MGmQRVHvRmnI5PBq5n0+cqkipFsVJMfemHEc6uT9wwcpNzAN9cvJn6/KuELt4AcLKUJSVq8aUb8x/KB6DGjQ7P+SyMp1PCObw71M5KffJAIEOiU6yn4NNAHQR48UQM2cIpZgtTyrEGNarG1X5Z98y+LuScDR62xZ+Em78f9jTi6lV6rqwcP2UzrsTqinoXp6/pfhNiUxx3iEGW5+73/0i113NomdUTiNQEGyFs+quE5L1V6OevtAgKftIvUYcso15+I45VNVljtNZTgda/Lfyp86rHhbw9NfpTcVRN2H4TgumkMSYxgFPqwf2mgIDt/EgaMEWeOIOd+R0YBpkfbwkQv2KoIwi5FUe/5srwDqzRh0SjMB4bQxIILNXKnfqPAGbgRTaNmqdDOvXF01x5fReQKRZIENJcEjXm+NTx5rB4hNMKlOJJgFA8RsrP4g9IqChHWRqQM9ctPH82kux3+PvV41KEJh7Sz+Th3TR+nGdZiAqs9+chTxt60QxytoLle/T+maF08DKjYe/YrP9R1Raz3cufHNDDHE6o3Mguyi9Bo8S2nv5qBrBxaXYfMTNHkGW/nkW3sgg/20ihjA2MsSwgYnIXZYJ/jjC99hiErWyl9sg+BD4k5gKaXWzT5ELeL4steIEP+/anjWiR9ImWptO1zurKJwGlq1HEWvSWbitQZmJ93QG7DWVMZr3NJXrcLIjJWhkyxvwrJWcHSBf9vVYxbEVhEPtac4XPZWVLp1nvuVmuGIRHqG3nI9DfrB7ao0N/SSPom0lJzjm8ujxvGVaat2GhS+1wQmuCTsA/Jm1Hy4UyXZDgaaumaczEOT+SptkzTI7Dj63RJniuiyTqSPXKWfEDFDzbONznhE1cgYs5NZ6QekyC9qwiidSvFIQnaJ76YwUo/L2mBmU5dLO5lH8Ub6YsWPvCQ7zJcMuyGBCjXjRybjQ3G4vtud1IVXHCEOx7GL7PqjI+MzFGtiFf+FGe5bNOle7ql3nmq0q+PJABsjYmLIho852wWV5/AwvjUmMU8CDgSLRwl1VW3kzzsfVezokL/ItsmbQgZFkNK4rJnXtrpQk42dcKHxnAEAKdvn/vte+HoUyivZou+zrOSP9dJLuyLgSCFGF/WUOzQKrqDCHkSMIoVW8L5L8QB4FrGcoX5AULQp9iBiR6G3FIGsBMxkl1mGDl7mwEg0xa5eGrKekLObUD1xHLVebmRpgKunLYoSt7hF13rQHSfdzMfe/ibPCR8TJPrtLrCJWFq75+383Q0QVYw9o88+GAU+8A4IHZROBTiyPqs1Th6KJDuKYx12lDAIjoBGTh+PwTHU8ReLnSJuVyZH/4qjwTVFiKZuPrR/zkx0W7fO4pKjkpLMYXtfU+8xevRXbNNypB8fNBdc0U0Bh8W6iumvBpTFJmiFdPS8hSFXt4SbL7Q3e9rZqYAuep67cHA4B0cmAahwzBrbWX4E44rN1/oKkYWIhI282Wxs41jSBoSq2u3Cc05R9oF5TySP8Ww/okrpcW3HcjVpD3fV0BwbdmUc5wu2MptlAzzJRRCTrXMNBXgyVg8on2Ry18a3QXCCST3oj2g2JcWs7UG0fNaURqjW53qfpsw6kIrPbpgJcYyK3fZFdFQxQYnMyxJQs0yTKaPB0GBtFq3b7OnQXYKlr50XbMWEmW1f5hzTn6nNnBleRveMD90tABjtzYCW7kHuC04CG9pyR8AF0M6IdcPhouPF3T9QYxtedClk9xjWMiP1S/Ds7uAli4VDMQs28RlN1Waot83zDECZWDar0kUcdrl6GjEq+lnL+34/jP1dHPQV+LXiEgtDf5/enDb3Hgh1HUIJIMEUosP6zGWfGEdpsKGWnQ+bxHsfo8XYZr+jN2DVvshIHAK+UbFriOjl4VqlbbA5lplOJN1XnBa7DLZgBM8ScDPSGpYas2FqNBIKkAuGPRGixx9XgATW8M55oAUjvahQ/yflyUFncgntJ/NzZcQl7NjkHX1yPBm57tq/i0KEM6CgDetms+/6O1T+FaPnHoxw34X1R3Rce1p8RDaTOKgeLvBCvl/wjRmrwOHyCKW7iWltrrDcK52cE/WTpMwPkbe4+MfE3wsinWmKZzZhsEQu5brFpvIX6EQPywpNeH+bSAMGV/nd3pgdsuZsBmwM53oN6DPI3CskG1COql4qE1gP3N9EndQtIUEsJFfoRbyZH7b+yjF03BrPKY2l13BSgOXDxo/hlfVbdXN4UCMPUbjQ5BwC3eatIyCBTcG6SHCGPFAto3gQH/R+Q96SgqzVwePpKKFrc7iB/hYqsuGujKeKqEyRsJCJe1FnQqE+cxc1ExTopkzZcfT5VFQEnC93CGxiReMga7G1Sbdwx1VaR1PAeZrH2M3qJs6p4+fnuWRBd7KPBxGNsZe1TUFspeac5Smh1ptzTRbbvLuUOmzz/qsguAwU8uq1dUuFvQwlMKqcc8KQHzgzVgDbkY8sXRTQmxntV3+R8iKbOfgdGBBcRQefIXiE60+fhc/uYHikvTwwaTExU0v9GMzkcfq/K70CHvuQ9SKuPi9g0stEjGFCI09IIgAjha5JFqFVaW0XH4lLQuEhvCHivTA2y43Bl4l1xi9ijvzd+nRgZI3FTCy6/YCnkbPn08ncwgde66L6cgn/KuNP1t8KVigs3mpwMiZMv7yPBDfWOZ8Jlpf3ZaLQTfhfypwxxczDmO51zWUIAlNGqMuJdfEKdwYhtCyqLWjSYQGI9+eO/7U0UMcg0WGTJogJblGa8zvPEurO26vIRwdKz2IX0d+tDK9y11G4QS+nUlXlfMUrwz8gljeOKqDNwfw3HU3p+QlJmV/rzq8f3ySSc1fTGfTWIK8tpMhItCR4aquyoKlwK6LuJjDKgALzx4ixQGOM37ypGyyw7ARYFFwvnWdkleT9sXBNrH5a01Ykhc4/QCRBS63c7UjuWY1blYm+HAX/PB0a7/gMgJW5NDe8ijEm+f59n/JxpPHv78ZImPVlPKGAwsjU9y4pDLljCHMoKw8f+5zxjX3mD4eo2W3sy+J8FYDtOpQvGnWHeM4N+ucp9P6LEbTSx9gL8f37M1lFCydn79+jGKgPPcQQ9lYiSlzDbA8LHN4qZfsKspUyqjQ/+KkRiodIJcFqA5Ex5AMjzaXne6Ol8tOVDw5PJr3eCXQ3XsDTz40lUM0UYdzC71AhcLm7k9UKdOJkwv62pQl6LAr2fvUN5kNy2BhWsWb6ruvPskTtqtookPek42oYhibDDaoHuCTcw2b46zPhgc/Vw/mLOFCzw7iPwKC60Uuqj1SnWNm8PCGj0OLHbcMSY+v5+1q6U9qzwfcf9vjTVP52FQbjwE660RRKJsh8IQiAUd3viaK7AupCJ0u2C0MALuVBdqWZf1eYYLVg0t/WrIvOLUYipNOJqDFiqjzYvQNXZ85sbnq5RvvCUMyXWrEOTbSp+KcnOaqQiS/SIWc1yhDRyxIqry3qc8cEHtHnP5bNjEfjUt3aGAK86rFRH5liaZJ0CaYlhvW4yvoxtNBZWU1K+iJPB2avsVvD/wFzYOORx2lIId0tJzkIe6Nmvl0Vq9N1b99Uwmc3HU5GBwTPv6/UZCUvGciNSpGM6vwqhD9D1YtrZV3++Xa+lf8XVsaKD0Hw8eQvDXrh1NUaq4knzVXgxDwRxVfK+n0rwoGxNTYJkTE5WK0lG79LUobWoTui/1WRFEhoRvXK5htJnrBAFrCo3vHH77GLYPiKKDoOpQ0ekhUYkK6xvikC46B6ur2m76GVLGa7n+l1KScTShiBvFxbPmlOtDvcOWTzQf/PpGQuq9LaSJg1aaFE3/BzjMkM1UYsRxTDQk1jR3H6vN0MoTQuQO3R3rdTc1gv17pYG/hUCGXonlqh19rDADvXxCFxBOUoipPBVeiRUZ9vi3pfpnIaGZ2TpPLzgP++e1pH11B+ntPw+E6FeaqNzJesuCpm+aJnap3gM1okBrR8akP+n+WTmEL8FVVKAmwYpJZSXHbPC0aPRrMyj5tv4T/JTEG1TyIs2gstRa7adRwYXaeMvkunyLmUzG4vQdAc75DAvDBNa4mn6JBdbEpYxqRZD015AS914bhJyIeeFXFvWae959xQwOzXkuKv/BFXgaF67KoDowiRi0wKqpA+tkXCqwH+jClBSHGlVj9ukniOndo4ZVqCzNiL4W3ZjbSL0CFs+K7edFo9PHMHf2hyK/QycgNWNM3pbxvakNgOKdSF5VjSl4XpLXV/H5fyWstX6Nv30CA5XaMyfqqnBxEvhry68bihLM+WSX7CsrvJhEQNOqyorGjh84C9Gell6GhGK/yf6ccDUbX64JuDQrHIbTf6+C0QATyYsXwPF4yP1p5CXoNjTeucqxuoQUH6PoKl4Rxfggnw8LpvNivi/gEWbHWPWORrAy6uLP0KO7mJd+vx8xBP9F3SDkuQgkOnBx84UbSmm6UDg/fhoIDhMSmYzowK0BAst9e55FT3WzlEJ4TNiAoe4cnwPRHO1AKHf5tOFL+6LM6Cq9jo0G6ju0gZOayoSK4Z/kMoJl2Mq3aETlBwu19LITgobCUbDxFZaf1FrTnfNZQTAOkExp48srfQXHjh7fvl1AoeqAmTlWX5jiNyFh7R+5gqWwbCJImz5Wjb/YsbQ3Gj1jwmmjJqegPG3HMI7u/eP4rP/YwgMUIAAAAEVYSUauAAAASUkqAAgAAAAGABIBAwABAAAAAQAAABoBBQABAAAAVgAAABsBBQABAAAAXgAAACgBAwABAAAAAgAAADEBAgARAAAAZgAAAGmHBAABAAAAeAAAAAAAAABgAAAAAQAAAGAAAAABAAAAcGFpbnQubmV0IDQuMi4xNgAABAAAkAcABAAAADAyMzABoAMAAQAAAAEAAAACoAQAAQAAAPQBAAADoAQAAQAAAAIBAAAAAAAA";

function Subsidy() {
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      display: 'flex',
      flexDirection: size.width < 600 ? 'column' : 'row',
      alignItems: size.width < 600 ? 'center' : 'flex-end',
      justifyContent: 'center',
      marginTop: size.width < 600 ? 15 : 0
    }
  }, React$4.createElement("a", {
    href: "https://www.bluecurrent.nl/legal/efro",
    target: "_blank",
    className: "Hover",
    style: {
      height: 'auto',
      width: 'auto',
      marginRight: size.width < 600 ? 0 : 15,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center'
    },
    rel: "noreferrer"
  }, React$4.createElement("img", {
    src: img,
    alt: "SNN logo",
    height: size.width < 600 ? 'auto' : 50,
    width: size.width < 600 ? '50%' : 'auto'
  })), React$4.createElement("a", {
    href: "https://www.bluecurrent.nl/legal/efro",
    target: "_blank",
    className: "Hover",
    style: {
      height: 'auto',
      width: 'auto',
      paddingTop: 15,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center'
    },
    rel: "noreferrer"
  }, React$4.createElement("img", {
    src: img$1,
    alt: "EFRO logo",
    height: size.width < 600 ? 'auto' : 50,
    width: size.width < 600 ? '50%' : 'auto'
  })));
}

function LinkItem(props) {
  var size = useDimensions();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("a", {
    href: props.data.href,
    className: "Hover",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      paddingTop: 10,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minWidth: size.width < 1500 ? 0 : 150
    }
  }, React$4.createElement(Text, {
    color: Colors.WHITE,
    fontSize: "1.1em"
  }, props.data.text), React$4.createElement("div", {
    style: {
      width: 20,
      height: 20,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative'
    }
  }, React$4.createElement(AnimatePresence, null, hover && React$4.createElement(motion.div, {
    style: {
      position: 'absolute',
      top: 0
    },
    initial: {
      left: 0,
      opacity: 0
    },
    animate: {
      left: 5,
      opacity: 1
    },
    exit: {
      left: 15,
      opacity: 0
    }
  }, React$4.createElement(Icon, {
    name: "ArrowRight",
    height: 12,
    width: 12,
    color: Colors.WHITE,
    iconSet: "FA"
  })))));
}
function Links(props) {
  return React$4.createElement("div", {
    style: {
      width: 'auto',
      height: 'auto'
    }
  }, React$4.createElement("div", {
    style: {
      height: 60,
      width: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end'
    }
  }, React$4.createElement(Text, {
    fontWeight: 500,
    color: Colors.WHITE,
    fontSize: "1.1em"
  }, props.links.title)), React$4.createElement("div", {
    style: {
      paddingTop: 2
    }
  }, props.links.items.map(function (e) {
    return React$4.createElement(LinkItem, {
      key: e.id,
      data: e
    });
  })));
}

function Footer(props) {
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%',
      backgroundColor: Colors.GREY
    }
  }, React$4.createElement(MainContainer$1, null, React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%',
      display: 'flex',
      flexDirection: size.width < Breakpoint.md || !props.contact && !props.linksLeft && !props.linksRight && !props.linksMiddle ? 'column' : 'row',
      paddingTop: 15
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: size.width < 600 ? 'column' : 'row',
      justifyContent: 'flex-start',
      paddingBottom: 30
    }
  }, React$4.createElement("div", {
    style: {
      minWidth: size.width < 600 || !props.contact && !props.linksLeft && !props.linksRight && !props.linksMiddle ? 0 : 350,
      height: '100%',
      width: !props.contact && !props.linksLeft && !props.linksRight && !props.linksMiddle ? '100%' : 'auto',
      paddingRight: 15,
      display: 'flex',
      flexDirection: 'column',
      alignItems: size.width < 600 || !props.contact && !props.linksLeft && !props.linksRight && !props.linksMiddle ? 'center' : 'flex-start',
      justifyContent: 'flex-start'
    }
  }, React$4.createElement("div", {
    style: {
      height: 60
    }
  }, size.width < 600 || !props.contact && !props.linksLeft && !props.linksRight && !props.linksMiddle ? React$4.createElement(Logo, {
    type: "VerticalDiapositive",
    height: "100%",
    width: "100%"
  }) : React$4.createElement(Logo, {
    type: "HorizontalDiapositive",
    height: 60,
    width: 220
  })), React$4.createElement("div", {
    style: {
      paddingTop: size.width < 600 || !props.contact && !props.linksLeft && !props.linksRight && !props.linksMiddle ? 15 : 10,
      paddingBottom: 15
    }
  }, React$4.createElement(Text, {
    color: Colors.WHITE,
    textAlign: size.width < 600 || !props.contact && !props.linksLeft && !props.linksRight && !props.linksMiddle ? 'center' : 'left'
  }, props.text)), props.socials && React$4.createElement(Socials, null)), props.contact && React$4.createElement(Contact, null)), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: size.width < 1500 ? 'space-between' : 'flex-start',
      width: '100%',
      paddingLeft: size.width < Breakpoint.md ? 0 : 90
    }
  }, size.width >= 600 && props.linksLeft && React$4.createElement(Links, {
    links: props.linksMiddle
  }), size.width >= 600 && props.linksMiddle && React$4.createElement(Links, {
    links: props.linksMiddle
  }), size.width >= 600 && props.linksRight && React$4.createElement(Links, {
    links: props.linksRight
  }))), props.subsidy && React$4.createElement("div", {
    style: {
      paddingBottom: 15,
      marginTop: 30
    }
  }, React$4.createElement(Subsidy, null)), React$4.createElement(Bottom, {
    links: props.linksBottom
  })));
}

function Heart(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 62,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 53,
    viewBox: "0 0 62 53",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    transform: "translate(-335 -256)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React$4.createElement("g", {
    stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    strokeWidth: 3
  }, React$4.createElement("path", {
    d: "M338.47 282.349h-1.528M395.302 282.349h-1.529M348.062 305.504l-1.08 1.08M385.263 258.113l-1.08 1.081M348.062 259.194l-1.08-1.081M385.263 306.584l-1.08-1.08M340.735 294.599l-2.767 1.147M394.276 268.952l-2.767 1.146M340.735 270.098l-2.767-1.146M394.276 295.746l-2.767-1.147M365.744 297.318c-.61-.37-14.935-9.17-14.935-18.489 0-4.496 3.658-8.153 8.153-8.153a8.177 8.177 0 0 1 7.16 4.252 8.177 8.177 0 0 1 7.16-4.252c4.495 0 8.153 3.657 8.153 8.153 0 9.319-14.325 18.119-14.935 18.489l-.378.23-.378-.23Z"
  }), React$4.createElement("path", {
    d: "M373.281 275.69a3.143 3.143 0 0 1 3.14 3.14"
  }))));
}

function Earth(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 76,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 75,
    viewBox: "0 0 76 75",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    fillRule: "evenodd"
  }, React$4.createElement("path", {
    d: "M55.814 56.345c-.477 1.55-.9 2.272-1.144 2.593a2.54 2.54 0 0 1-.09-.118c-.286-.392.14-1.357.423-1.995l.015-.034c.456-1.03.334-1.82.245-2.397-.057-.37-.077-.53-.006-.748.059-.179.409-.353.937-.598.234-.11.491-.229.751-.373l-1.13 3.67zm3.917-8.275a1.48 1.48 0 0 0-1.268-1.06 1.51 1.51 0 0 0-1.49.743c-.165.29-.312.598-.455.896-.24.501-.488 1.02-.746 1.305-.145.16-.517.334-.877.501-.861.4-2.04.948-2.49 2.33-.28.857-.175 1.535-.099 2.03.066.429.081.578-.038.848l-.015.034c-.476 1.074-1.361 3.075-.12 4.777C53.02 61.688 53.95 62 54.673 62c.142 0 .276-.011.4-.03 1.524-.24 2.67-1.768 3.607-4.807l1.758-5.705c.078-.253.083-.523.012-.778l-.72-2.61z"
  }), React$4.createElement("path", {
    d: "M56.843 52.798c-.216.115-.43.215-.62.304-.5.234-.853.409-.904.566-.067.206-.047.36.008.718.089.58.21 1.374-.246 2.41l-.015.033c-.258.586-.689 1.565-.424 1.93l.043.058c.26-.363.646-1.085 1.08-2.5l1.078-3.519zm-2.155 6.196-.044-.054c-.028-.036-.06-.075-.092-.12-.3-.413.129-1.387.413-2.032l.015-.034c.444-1.008.325-1.784.239-2.351-.058-.377-.079-.538-.005-.766.065-.2.404-.37.954-.627.231-.108.486-.227.739-.368l.119-.067-1.157 3.772c-.462 1.51-.874 2.242-1.138 2.591l-.043.056zm3.57-11.888c-.52 0-.998.27-1.25.72-.161.29-.306.593-.446.887-.239.5-.485 1.018-.746 1.308-.15.168-.523.342-.884.51-.84.393-1.993.931-2.43 2.281-.273.84-.17 1.506-.096 1.993.065.428.082.59-.042.87l-.015.034c-.465 1.058-1.332 3.027-.124 4.692.72.99 1.549 1.493 2.465 1.493.128 0 .257-.01.385-.03 1.483-.235 2.602-1.74 3.52-4.735l1.737-5.665c.074-.242.078-.5.01-.744l-.71-2.591a1.4 1.4 0 0 0-1.205-1.013 1.385 1.385 0 0 0-.17-.01zM54.698 62h-.008c-.656 0-1.631-.267-2.554-1.538-1.244-1.713-.361-3.718.113-4.795l.014-.033c.113-.256.1-.39.035-.814-.077-.496-.181-1.176.1-2.04.45-1.393 1.627-1.943 2.486-2.344.351-.164.714-.333.85-.484.25-.279.493-.79.728-1.283.14-.296.286-.602.45-.894.3-.536.9-.835 1.528-.765a1.509 1.509 0 0 1 1.298 1.092l.71 2.591c.073.263.069.54-.011.802L58.7 57.16c-.932 3.039-2.078 4.567-3.607 4.808a2.527 2.527 0 0 1-.396.032zM40.53 18.119l-.099-.035a1.444 1.444 0 0 0-1.849.908c-.265.772.133 1.618.89 1.89l.097.034c.159.057.32.084.48.084.599 0 1.16-.382 1.369-.992.265-.773-.133-1.618-.889-1.89"
  }), React$4.createElement("path", {
    d: "M39.954 18.106c-.557 0-1.079.355-1.273.921-.12.347-.1.721.057 1.052.156.332.429.581.769.703l.094.034c.144.052.294.078.446.078a1.35 1.35 0 0 0 1.272-.922 1.386 1.386 0 0 0-.825-1.754l-.095-.034a1.309 1.309 0 0 0-.445-.078M40.047 21a1.41 1.41 0 0 1-.48-.084l-.095-.034a1.45 1.45 0 0 1-.828-.757 1.498 1.498 0 0 1-.061-1.133 1.445 1.445 0 0 1 1.85-.908l.095.033c.366.132.66.4.828.757.168.357.19.76.061 1.134a1.455 1.455 0 0 1-1.37.992"
  }), React$4.createElement("path", {
    d: "M32.962 26.296c.07.454.35.85.756 1.066.275.147.657.402 1.062.672 1.145.763 2.442 1.628 3.661 1.706 1.109.072 1.726-.56 1.99-.829.021-.021.041-.043.062-.062.15-.122.288-.284.392-.48.234.067.48.133.733.202.867.235 2.481.672 2.838 1.05.634.671 1.127 1.95 1.563 3.077.22.57.429 1.108.662 1.607.1.214.199.435.299.658.675 1.507 1.442 3.216 3.067 4.279.737.481 1.64.62 2.437.742l.32.05c-.473.66-1.147 1.288-1.86 1.95-1.813 1.69-4.07 3.791-3.03 7.144.49 1.583.513 1.754-.276 2.612l-.3.324c-.676.719-1.21 1.287-1.652 2.679-.128.404-.294.591-.596.931-.242.272-.543.61-.82 1.085-.332.569-.442 1.116-.53 1.556-.087.433-.136.65-.306.86a8.523 8.523 0 0 1-1.85 1.634c-.688.437-1.09.497-1.227.489-.156-.168-.722-.901-1.578-3.44-.21-.627-.503-1.271-.786-1.894-.624-1.375-1.269-2.795-.955-3.766.037-.115.073-.227.11-.336.5-1.528.974-2.97.097-5.071-.267-.64-.691-1.108-1.066-1.52-.243-.267-.517-.57-.56-.743-.05-.212-.05-.457-.048-.741.005-.766.013-1.922-1.137-2.999-1.62-1.517-3.511-1.05-4.762-.74-.384.095-.747.185-1.069.222-2.058.242-3.895-.535-5.042-2.13-1.2-1.67-1.374-3.917-.454-5.864.445-.942 1.117-1.699 1.896-2.575.17-.191.342-.384.513-.582.286-.33.6-.775.933-1.247.397-.564 1.136-1.613 1.457-1.812.653-.368 2.17-.422 3.276-.46.444-.016.864-.031 1.238-.063.198-.016.417-.013.624.003a1.458 1.458 0 0 0-.082.756M38 72a34.317 34.317 0 0 1-20.653-6.882l1.287-6.722.633-.205a4.562 4.562 0 0 0 2.926-5.742l-.464-1.428c-.108-.33-.107-.68.001-1.01a4.557 4.557 0 0 0-3.456-5.893l-3.306-.646-6.379-4.85a1.468 1.468 0 0 0-1.34-.227l-3.684 1.197a34.473 34.473 0 0 1-.015-3.945c.124.115.21.199.262.254.073.121.164.233.27.33.305.277.581.403 1.161.403.533 0 1.323-.106 2.626-.299 1.235-.182 2.465-.388 2.477-.39a1.463 1.463 0 0 0 .968-2.27l-1.796-2.634 2.572-1.84c.172-.122.315-.28.42-.463l3.987-6.962 1.608-1.722a6.188 6.188 0 0 0 1.193-6.562 6.726 6.726 0 0 0-2.61-3.105 34.332 34.332 0 0 1 20.879-7.381L34.99 6.238l-9.699 3.4c-.394.138-.71.438-.87.824l-2.708 6.566c-.193.467-.131.999.162 1.41l3.956 5.542c-.567.516-1.118 1.27-1.777 2.204-.289.41-.562.797-.75 1.015-.164.189-.328.373-.49.556-.852.957-1.731 1.947-2.356 3.27-1.375 2.909-1.097 6.29.724 8.824 1.76 2.45 4.664 3.695 7.762 3.33.505-.058.976-.175 1.431-.288 1.256-.31 1.654-.341 2.057.036.196.183.214.218.21.84-.003.396-.006.89.13 1.452.219.9.784 1.522 1.238 2.022.226.248.46.505.532.677.456 1.095.258 1.701-.178 3.03l-.114.349c-.662 2.05.26 4.083 1.075 5.877.265.583.515 1.133.678 1.619 1.317 3.908 2.305 4.803 3.097 5.163.415.189.844.272 1.278.271 2.112 0 4.315-1.96 5.328-3.203.635-.78.792-1.562.906-2.133.057-.284.102-.508.187-.655.131-.223.286-.397.481-.617.393-.442.881-.993 1.198-1.99.24-.758.415-.944.994-1.56l.324-.347c1.95-2.123 1.448-3.745.916-5.462-.448-1.444.335-2.368 2.23-4.132.82-.764 1.669-1.555 2.325-2.505.287-.415 1.16-1.68.62-2.934-.53-1.228-1.877-1.435-2.958-1.6-.428-.066-1.073-.165-1.28-.3-.906-.592-1.46-1.829-1.996-3.025-.107-.238-.212-.473-.319-.701-.19-.407-.38-.9-.582-1.42-.533-1.38-1.137-2.943-2.165-4.033-.924-.98-2.666-1.45-4.203-1.867-.517-.14-1.006-.272-1.327-.39-.27-.1-.563-.119-.842-.053-.748.175-1.215.369-1.561.646a1.827 1.827 0 0 0-.522.702c-.536-.258-1.273-.749-1.727-1.051l-.029-.02a2.073 2.073 0 0 0-.13-1.41c-.818-1.73-3.535-1.595-4.07-1.55-.305.026-.69.04-1.097.054-.64.023-1.347.049-2.047.127l.036-.1a3.745 3.745 0 0 1 3.517-2.475h.833a1.465 1.465 0 0 0 0-2.929h-.833a6.685 6.685 0 0 0-5.67 3.162l-2.185-3.06 2.15-5.21 9.478-3.324c.26-.09.489-.253.66-.469l4.18-5.243c14.542 1.343 26.496 11.747 30.15 25.498l-.58.516a3.912 3.912 0 0 0-1.303 2.846v.035l-1.012-2.782a3.664 3.664 0 0 0-.66-1.131l-1.805-2.113a3.669 3.669 0 0 0-2.795-1.288h-2.208c-.785 0-1.501.429-1.871 1.12-.37.691-.33 1.526.105 2.178l.224.336a16.248 16.248 0 0 1-4.836 2.872l-3.028-5.8v-1.294c0-.4-.163-.783-.453-1.06l-2.727-2.603a1.471 1.471 0 0 0-.526-.322l-2.454-.862a1.464 1.464 0 1 0-.971 2.763l2.157.759 2.045 1.952v1.026c0 .236.057.469.166.678l3.79 7.26a1.464 1.464 0 0 0 1.806.697l1.104-.407a19.18 19.18 0 0 0 6.873-4.399c.494-.494.57-1.267.183-1.848l-.078-.117h.7c.218 0 .425.095.567.262l1.805 2.112a.725.725 0 0 1 .133.23l1.992 5.476a1.468 1.468 0 0 0 1.376.964c.384 0 .759-.151 1.036-.429l.948-.948c.576-.577.978-1.3 1.184-2.103.174 1.402.265 2.828.265 4.276C72.5 56.523 57.024 72 38 72M15.92 56.995l-1.148 5.992c-5.74-5.235-9.71-12.378-10.898-20.415l3.552-1.154 6.04 4.593c.179.135.386.228.606.271l3.64.711c.465.091.853.366 1.092.774.24.409.29.881.143 1.33a4.523 4.523 0 0 0-.004 2.829l.464 1.428a1.628 1.628 0 0 1-1.046 2.05l-1.455.474a1.463 1.463 0 0 0-.986 1.117M3.626 35.415a1.339 1.339 0 0 1 0 .001M14.29 12.46a3.809 3.809 0 0 1 2.299 2.147 3.25 3.25 0 0 1-.627 3.447l-1.723 1.847a1.437 1.437 0 0 0-.2.271l-3.913 6.832-3.478 2.486a1.464 1.464 0 0 0-.358 2.017l1.3 1.907c-.75.112-1.422.204-1.87.253-.086-.083-.176-.166-.269-.253a71.233 71.233 0 0 0-1.521-1.358c1.22-7.66 4.967-14.487 10.36-19.596m61.207 24.9c0-.168-.003-.337-.006-.505-.002-.141-.004-.282-.008-.423l-.012-.32a37.168 37.168 0 0 0-2.92-13.21 37.273 37.273 0 0 0-5.764-9.435l-.12-.142a37.093 37.093 0 0 0-6.973-6.421l-.028-.02c-.198-.14-.397-.277-.597-.413l-.268-.18-.367-.241a31.842 31.842 0 0 0-.53-.339l-.115-.071a37.256 37.256 0 0 0-5.193-2.693A37.226 37.226 0 0 0 38.663.008c-.096-.002-.193-.002-.29-.003C38.25.003 38.125 0 38 0l-.171.002c-.18 0-.36.003-.54.007-.115.002-.23.003-.346.007-.209.005-.418.013-.626.023l-.303.013c-.193.01-.386.023-.58.036l-.383.027c-.14.01-.28.024-.42.036-.19.017-.378.034-.566.054l-.17.018a37.117 37.117 0 0 0-10.492 2.725 37.37 37.37 0 0 0-11.92 8.035l-.24.246-.01.012c-.197.2-.392.402-.583.606l-.116.124a40.39 40.39 0 0 0-.487.533l-.14.157c-.158.179-.315.359-.469.54l-.107.126c-.17.202-.338.404-.503.608l-.037.046a37.25 37.25 0 0 0-5.343 8.922A37.21 37.21 0 0 0 .508 36.85l-.004.288c0 .12-.004.24-.004.361l.002.165c0 .201.003.401.007.602l.006.264c.006.25.016.501.027.752l.008.158c.012.256.029.513.047.77l.012.173c.017.227.037.454.059.68l.027.288c.017.168.037.336.056.504.019.159.037.319.057.477l.035.254a37.088 37.088 0 0 0 2.605 9.51 37.37 37.37 0 0 0 8.035 11.92 37.37 37.37 0 0 0 11.92 8.035 37.18 37.18 0 0 0 13.03 2.914l.107.004c.22.008.441.016.662.02.17.004.338.005.507.007L38 75h.031c.3 0 .598-.004.897-.011l.17-.006c.242-.007.486-.015.729-.027.11-.005.219-.013.329-.019.183-.01.366-.02.549-.034.15-.01.3-.023.45-.035l.408-.036c.186-.017.372-.037.557-.057l.279-.031c.22-.026.44-.054.659-.083l.152-.021c.255-.035.509-.073.763-.114l.016-.002a37.134 37.134 0 0 0 8.608-2.472 37.281 37.281 0 0 0 8.575-5.063l.02-.015a37.21 37.21 0 0 0 7.294-7.63 37.327 37.327 0 0 0 6.94-19.498l.012-.203c.01-.185.02-.37.027-.556l.015-.407c.004-.142.008-.285.01-.428.004-.172.006-.344.007-.515 0-.08.003-.158.003-.237l-.002-.139"
  })));
}

function CarHouse(props) {
  var _props$width, _props$height, _props$color, _props$color2;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 132,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 86,
    viewBox: "0 0 132 86",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React$4.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
  }, React$4.createElement("g", null, React$4.createElement("g", null, React$4.createElement("g", {
    stroke: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY
  }, React$4.createElement("path", {
    d: "M94.394 20.42c-.445-.595-.885-1.003-1.211-1.266-.032-.373-.08-.91-.14-1.49-.055-.532-.118-1.095-.188-1.598-.072-.509-.14-.93-.245-1.293l-.076-.188c-1.41-2.75-3.667-5.727-5.58-8.056-1.912-2.325-3.48-3.98-3.491-3.994l-.105-.095c-.3-.225-1.109-.76-4.654-1.332-3.545-.56-9.828-1.107-21-1.108-20.917.007-33.786 9.863-35.742 11.465-1.264.176-5.901.908-10.618 2.862-2.75 1.144-5.538 2.701-7.693 4.878C1.497 21.375-.007 24.233 0 27.737c.001 1.338.061 2.447.24 3.41.138.72.344 1.365.67 1.937.482.864 1.274 1.503 2.198 1.855.926.363 1.982.511 3.252.592.614.037 1.144-.429 1.182-1.04.037-.612-.43-1.138-1.045-1.176-1.032-.06-1.821-.183-2.371-.367-.416-.138-.692-.3-.905-.491-.311-.286-.55-.688-.732-1.453-.179-.759-.26-1.84-.258-3.267.007-2.868 1.167-5.096 3.01-6.975 2.76-2.81 7.108-4.651 10.763-5.722 1.827-.54 3.477-.896 4.664-1.115.594-.11 1.072-.185 1.398-.233.165-.026.291-.042.374-.052l.12-.016c.227-.027.437-.12.609-.27l.026-.023c.672-.575 13.318-11.119 34.508-11.112 11.097-.002 17.288.548 20.65 1.08 1.681.265 2.652.528 3.168.704.221.077.353.135.425.168l.156.169c.6.65 2.153 2.365 3.838 4.472 1.658 2.073 3.444 4.537 4.556 6.685.04.171.1.503.15.874.096.692.186 1.564.25 2.258.065.693.105 1.205.105 1.206.028.36.23.68.539.866l-.001.001c.002 0 .138.084.35.266.636.568 1.872 1.914 1.88 4.582.002 1.178-.105 2.109-.307 2.818-.203.714-.482 1.2-.86 1.597-.425.443-.41 1.145.035 1.568.446.424 1.151.408 1.577-.034.66-.685 1.12-1.544 1.395-2.531.278-.99.39-2.111.391-3.418.004-2.34-.791-4.049-1.606-5.13",
    transform: "translate(-547.000000, -796.000000) translate(1.000000, 766.000000) translate(547.000000, 30.000000) translate(0.000000, 44.000000)"
  }), React$4.createElement("path", {
    d: "M85.694 37.01c-1.076 1.08-2.547 1.744-4.185 1.744-1.637 0-3.11-.664-4.184-1.744-1.073-1.081-1.733-2.563-1.733-4.21 0-1.647.66-3.128 1.733-4.21 1.074-1.08 2.547-1.743 4.184-1.743 1.638 0 3.11.664 4.185 1.744 1.072 1.08 1.733 2.562 1.733 4.21 0 1.646-.661 3.128-1.733 4.209M81.509 24.6c-4.501 0-8.15 3.671-8.15 8.2s3.649 8.2 8.15 8.2c4.502-.001 8.15-3.67 8.151-8.2 0-4.53-3.649-8.198-8.15-8.2M22.298 37.01c-1.075 1.08-2.547 1.744-4.185 1.744-1.637 0-3.11-.664-4.184-1.744-1.073-1.081-1.733-2.563-1.733-4.21 0-1.647.66-3.128 1.733-4.21 1.074-1.08 2.547-1.743 4.184-1.743 1.638 0 3.11.664 4.185 1.744 1.073 1.08 1.733 2.562 1.733 4.21 0 1.646-.66 3.128-1.733 4.209M18.113 24.6c-4.501.002-8.149 3.67-8.15 8.2.001 4.53 3.649 8.199 8.15 8.2 4.502 0 8.151-3.671 8.151-8.2s-3.65-8.2-8.15-8.2M70.435 32.8H29.187c-.614 0-1.112.612-1.112 1.366 0 .755.498 1.367 1.112 1.367h41.248c.614 0 1.112-.612 1.112-1.367 0-.754-.498-1.366-1.112-1.366M34.346 13.206c5.787-3.197 16.089-5.398 22.643-5.381h.123l-.252 6.22c-3.221.233-6.51.475-9.551.7-6.72.5-12.189.92-13.044 1-.662.064-1.384.198-2.08.31-.617.103-1.208.182-1.633.197.67-.991 1.997-2.068 3.794-3.046m37.101-3.861c1.233.408 2.018.836 2.62 1.242.603.407 1.028.808 1.566 1.214.357.27.62.533.765.726l.075.126c-.211.078-.66.171-1.323.179-.882.015-3.664.191-7.483.45-2.517.17-5.466.379-8.551.6l.245-6.033c6.252.128 9.889.766 12.086 1.496m-42.062 8.95c.353.1.684.123 1.018.124.7-.002 1.436-.116 2.16-.233.717-.119 1.418-.242 1.922-.29 1.053-.1 10.473-.816 19.986-1.51 4.76-.348 9.554-.69 13.356-.948 3.789-.26 6.635-.435 7.36-.445.982-.021 1.749-.14 2.407-.459.327-.161.633-.39.857-.703.227-.31.345-.701.341-1.058-.006-.6-.256-1.081-.565-1.503-.318-.423-.726-.805-1.209-1.17-.394-.292-.9-.766-1.658-1.282-1.141-.775-2.824-1.581-5.645-2.168-2.827-.59-6.818-.986-12.726-.986-4.69.003-10.858.993-16.336 2.66-2.74.836-5.3 1.843-7.421 3.005-2.117 1.168-3.818 2.474-4.782 4.074l-.027.051c-.201.39-.343.767-.347 1.216-.004.293.078.623.263.9.28.419.703.627 1.046.724",
    transform: "translate(-547.000000, -796.000000) translate(1.000000, 766.000000) translate(547.000000, 30.000000) translate(0.000000, 44.000000)"
  })), React$4.createElement("g", null, React$4.createElement("path", {
    d: "M78.998 36.008v38.16c0 1.33-.547 2.54-1.427 3.414-.88.875-2.097 1.418-3.436 1.418H60.35v-3.708h13.784c.309 0 .591-.126.798-.331.206-.205.334-.486.334-.793v-38.16h3.731zM43.5 0c.566-.012 1.132.229 1.509.702l.014.018 41.27 32.418c.805.632.943 1.804.307 2.604-.637.8-1.816.937-2.62.304L43.5 4.25 3.02 36.046c-.804.633-1.983.495-2.62-.304-.636-.8-.498-1.972.306-2.604L41.977.72l.014-.018.119-.135c.37-.384.88-.578 1.39-.567zM21.903 5.927v3.708H11.865V20.7l-3.731 2.93V9.024c0-.854.35-1.628.914-2.189.564-.56 1.343-.908 2.202-.908h10.653z",
    transform: "translate(-547.000000, -796.000000) translate(1.000000, 766.000000) translate(547.000000, 30.000000) translate(44.000000, 0.000000)"
  })))))));
}

function App(props) {
  var _props$width, _props$height, _props$color, _props$color2;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 89,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 93,
    viewBox: "0 0 89 93",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    stroke: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
    fillRule: "evenodd"
  }, React$4.createElement("path", {
    d: "M28.18 3.78a5.409 5.409 0 0 0-5.401 5.404v74.632a5.409 5.409 0 0 0 5.402 5.404H62.82a5.409 5.409 0 0 0 5.402-5.404V9.184A5.409 5.409 0 0 0 62.82 3.78H28.18zM62.82 92H28.18C23.67 92 20 88.329 20 83.816V9.184C20 4.67 23.67 1 28.18 1h34.64C67.33 1 71 4.67 71 9.184v74.632C71 88.33 67.33 92 62.82 92z"
  }), React$4.createElement("path", {
    d: "M69.61 13H21.39c-.768 0-1.39-.672-1.39-1.5s.622-1.5 1.39-1.5h48.22c.768 0 1.39.672 1.39 1.5s-.622 1.5-1.39 1.5m0 64H21.39c-.768 0-1.39-.672-1.39-1.5s.622-1.5 1.39-1.5h48.22c.768 0 1.39.672 1.39 1.5s-.622 1.5-1.39 1.5m-21.93 7h-6.36c-.73 0-1.32-.672-1.32-1.5s.59-1.5 1.319-1.5h6.362c.729 0 1.32.672 1.32 1.5S48.41 84 47.68 84m-9.762-41.28h4.42c.464 0 .896.238 1.15.632.254.394.295.892.109 1.323l-5.42 12.58 12.866-11.744h-3.698c-.437 0-.847-.21-1.106-.567a1.412 1.412 0 0 1-.207-1.24l4.054-13.342L37.918 42.72zM34.374 64c-.281 0-.563-.087-.804-.264a1.408 1.408 0 0 1-.455-1.69l7.123-16.535h-5.636c-.556 0-1.057-.34-1.27-.861a1.41 1.41 0 0 1 .298-1.52l18.432-18.721a1.357 1.357 0 0 1 1.68-.21c.54.332.79.995.604 1.608l-5.14 16.913h5.42c.57 0 1.08.357 1.283.896a1.41 1.41 0 0 1-.364 1.537l-20.253 18.49c-.26.236-.588.357-.918.357zm48.099-8c-.33 0-.663-.108-.935-.33a1.336 1.336 0 0 1-.161-1.943c2.41-2.703 3.739-6.147 3.739-9.697 0-4.043-1.664-7.831-4.684-10.668a1.335 1.335 0 0 1-.018-1.95 1.492 1.492 0 0 1 2.04-.017C86.03 34.755 88 39.242 88 44.03c0 4.206-1.573 8.285-4.43 11.486-.284.32-.69.484-1.097.484m-5.5-7c-.21 0-.423-.061-.62-.19-.62-.404-.845-1.326-.502-2.058.38-.812.58-1.734.58-2.666 0-1.314-.398-2.587-1.122-3.586-.462-.636-.4-1.592.14-2.136s1.35-.47 1.81.166c1.124 1.547 1.74 3.52 1.74 5.556a9.799 9.799 0 0 1-.901 4.132c-.234.5-.673.782-1.125.782M7.558 56c-.365 0-.73-.131-1.01-.395C2.97 52.245 1 47.759 1 42.97c0-4.206 1.573-8.285 4.429-11.486a1.488 1.488 0 0 1 2.033-.154c.606.494.679 1.364.162 1.943-2.411 2.703-3.74 6.147-3.74 9.697 0 4.043 1.664 7.83 4.685 10.668.568.534.576 1.406.018 1.95a1.477 1.477 0 0 1-1.03.412m5.16-7c-.363 0-.723-.18-.977-.53-1.122-1.547-1.74-3.52-1.74-5.556 0-1.443.312-2.872.902-4.131.343-.733 1.125-1 1.745-.593.62.405.846 1.326.503 2.059a6.32 6.32 0 0 0-.582 2.665c0 1.314.4 2.587 1.124 3.586.46.636.398 1.592-.141 2.136-.242.244-.54.364-.834.364"
  })));
}

function LightBulb(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 55,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 61,
    viewBox: "0 0 55 61",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("path", {
    d: "M14.486 26.697c0 3.721 1.821 6.83 4 9.514 3.5 4.314 3.03 9.3 3.03 9.3h12.828s-.471-4.986 3.03-9.3c2.179-2.685 4-5.793 4-9.514 0-7.38-6.024-13.373-13.444-13.373-7.42 0-13.444 5.993-13.444 13.373Zm7.2 22.236h12.488M21.686 52.3h12.488m-12.488 3.368h12.488m-2.197-.037c0 1.859-1.813 3.368-4.047 3.368s-4.048-1.509-4.048-3.368m4.05-48.014V2m13.572 10.142 4.128-4.107m-32.136 4.107L9.367 8.035m37.696 17.778L53 25.71m-45.063.104L2 25.71m40.792 13.157 4.27 4.104m-34.855-4.104-4.27 4.104",
    stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    strokeWidth: 2.488,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function Graph(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 76,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 66,
    viewBox: "0 0 76 66",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    fillRule: "evenodd"
  }, React$4.createElement("path", {
    d: "M9.177 63.845h12.58V46.644H9.176v17.201ZM22.827 66H8.104c-.592 0-1.07-.483-1.07-1.077V45.567c0-.595.478-1.078 1.07-1.078h14.723c.592 0 1.072.483 1.072 1.078v19.356c0 .594-.48 1.077-1.072 1.077Z"
  }), React$4.createElement("path", {
    d: "M23.9 63.845h12.58V38.313H23.9v25.532ZM37.55 66H22.827c-.59 0-1.07-.483-1.07-1.077V37.236c0-.596.48-1.077 1.07-1.077h14.724c.592 0 1.071.481 1.071 1.077v27.687c0 .594-.48 1.077-1.07 1.077Z"
  }), React$4.createElement("path", {
    d: "M38.622 63.845h12.581V29.562h-12.58v34.283ZM52.274 66H37.55a1.075 1.075 0 0 1-1.072-1.077V28.485c0-.595.48-1.077 1.072-1.077h14.723c.592 0 1.072.482 1.072 1.077v36.438c0 .594-.48 1.077-1.072 1.077ZM66.993 49.62a1.074 1.074 0 0 1-1.071-1.077v-3.156c0-1.436 2.143-1.436 2.143 0v3.156c0 .595-.48 1.078-1.072 1.078"
  }), React$4.createElement("path", {
    d: "M66.993 65.996H52.272a1.075 1.075 0 0 1-1.071-1.078V17.032h-6.364c-.955 0-1.433-1.16-.758-1.84L58.875.316a1.068 1.068 0 0 1 1.515 0l14.807 14.878c.674.679.197 1.838-.757 1.84h-6.375v10.104c0 1.437-2.143 1.437-2.143 0V15.954c0-.594.48-1.076 1.071-1.076h4.858L59.637 2.596 47.423 14.878h4.849c.592 0 1.072.482 1.072 1.076v47.887h12.578v-7.746c0-1.436 2.143-1.436 2.143 0v8.823c0 .595-.48 1.078-1.072 1.078"
  }), React$4.createElement("path", {
    d: "M66.993 38.923a1.074 1.074 0 0 1-1.071-1.077v-3.178c0-1.437 2.143-1.437 2.143 0v3.178c0 .595-.48 1.077-1.072 1.077M74.156 66H1.584c-1.429 0-1.429-2.155 0-2.155h72.572c1.429 0 1.429 2.155 0 2.155"
  })));
}

function Battery(props) {
  var _props$width, _props$height, _props$color, _props$colorBattery, _props$color2;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 64,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 35,
    viewBox: "0 0 64 35",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    transform: "translate(2 2)",
    fill: "none",
    fillRule: "evenodd"
  }, React$4.createElement("path", {
    d: "M50.87 31c1.44 0 2.608-1.157 2.608-2.583V2.583C53.478 1.157 52.31 0 50.87 0H2.609C1.169 0 0 1.157 0 2.583v25.834C0 29.843 1.169 31 2.609 31h48.26Z",
    stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    strokeWidth: 2.442
  }), React$4.createElement("rect", {
    fill: (_props$colorBattery = props.colorBattery) !== null && _props$colorBattery !== void 0 ? _props$colorBattery : Colors.GREY,
    x: 6,
    y: 5,
    width: 41,
    height: 21,
    rx: 1
  }), React$4.createElement("path", {
    d: "M53.478 7.75h3.913c1.44 0 2.609 1.157 2.609 2.583v10.334c0 1.426-1.169 2.583-2.609 2.583h-3.913",
    stroke: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
    strokeWidth: 2.442
  })));
}

function CustomIcon(props) {
  var renderCustomIcon = function renderCustomIcon() {
    switch (props.name) {
      case 'Heart':
        return React$4.createElement(Heart, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Earth':
        return React$4.createElement(Earth, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'CarHouse':
        return React$4.createElement(CarHouse, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'App':
        return React$4.createElement(App, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'LightBulb':
        return React$4.createElement(LightBulb, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Graph':
        return React$4.createElement(Graph, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Battery':
        return React$4.createElement(Battery, {
          height: props.height,
          width: props.width,
          color: props.color,
          colorBattery: props.colorBattery
        });
      default:
        return React$4.createElement("div", null);
    }
  };
  return renderCustomIcon();
}

function ChargeCard(props) {
  var _props$borderRadius;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return React__default.createElement("svg", {
    viewBox: "0 0 5278 3334",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
      boxShadow: props.shadow ? '0px 0px 20px 3px rgba(137,139,143,0.2)' : 'inherit',
      borderRadius: (_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : 0
    }
  }, React__default.createElement("path", {
    style: {
      fill: '#ffffff'
    },
    d: "M0 0h4722.22v3333.33H0z"
  }), React__default.createElement("path", {
    style: {
      fill: '#0098db'
    },
    d: "M4722.22 0h555.556v3333.33H4722.22z"
  }), React__default.createElement("path", {
    d: "M4166.67 0H0v2777.78h3944.45a222.219 222.219 0 0 0 157.134-65.088 222.22 222.22 0 0 0 65.088-157.135V.007Z",
    style: {
      fill: '#e5f4fb'
    }
  }), React__default.createElement("text", {
    x: 939.611,
    y: 665.509,
    style: {
      fontFamily: 'Museo-Sans',
      fontWeight: 700,
      fontSize: '388.889px'
    }
  }, _('chargeCard', {
    ns: 'ui'
  })), React__default.createElement("path", {
    d: "M3625.78 1166.66c0-122.724-99.488-222.212-222.212-222.212H763.098c-122.724 0-222.211 99.488-222.211 222.212v.022c0 122.724 99.487 222.211 222.211 222.211h2640.47c122.724 0 222.212-99.487 222.212-222.211v-.022Z",
    style: {
      fill: '#0098db'
    }
  }), React__default.createElement("text", {
    x: 1186.77,
    y: 1227.96,
    style: {
      fontFamily: 'Museo-Sans',
      fontWeigth: 500,
      fontSize: '188.889px',
      fill: '#fff'
    }
  }, props.serial), React__default.createElement("text", {
    x: 8072.28,
    y: 1893.53,
    style: {
      fontFamily: 'Caveat',
      fontSize: '266.667px',
      fill: '#fff'
    },
    transform: "rotate(90 7017.47 -207.78)"
  }, _('pppsstIamHere', {
    ns: 'ui'
  })), React__default.createElement("path", {
    d: "M5143.7 460.917c0 42.861-21.908 65.269-41.161 75.559-23.608 12.608-50.524 19.89-79.177 19.89-92.258 0-167.072-74.787-167.072-167.072s74.814-167.072 167.072-167.072c28.653 0 55.569 7.282 79.177 19.926 19.253 10.254 41.161 32.662 41.161 75.523v143.246Zm-44.451-9.337V327.006c0-21.871-17.835-39.698-39.707-39.698h-92.785c-21.908 0-39.698 17.827-39.698 39.698V451.58c0 21.908 17.79 39.698 39.698 39.698h23.971v-21.662h-23.971c-9.945 0-18.035-8.1-18.035-18.036V327.006c0-9.936 8.09-18.035 18.035-18.035h92.785c9.945 0 18.036 8.099 18.036 18.035V451.58c0 9.936-8.091 18.036-18.036 18.036h-19.989v21.662h19.989c21.872 0 39.707-17.79 39.707-39.698Zm-100.112-22.235v-88.24h-21.653v88.24c0 5.973 4.827 10.836 10.79 10.836 6 0 10.863-4.863 10.863-10.836Zm49.679 0v-88.24h-21.663v88.24c0 5.973 4.873 10.836 10.836 10.836s10.827-4.863 10.827-10.836Z",
    style: {
      fill: '#fff'
    }
  }), React__default.createElement("text", {
    x: 355.968,
    y: 3116.99,
    style: {
      fontFamily: 'Museo-Sans',
      fontSize: '111.111px',
      fill: '#ccc'
    }
  }, "+31 (0) 85 04 66 050"), React__default.createElement("text", {
    x: 3633.14,
    y: 3113.76,
    style: {
      fontFamily: 'Museo-Sans',
      fontSize: '111.111px',
      fill: '#ccc'
    }
  }, "bluecurrent.nl"), React__default.createElement("path", {
    d: "M2038.58 2936.36c41.412 0 63.062 21.167 73.005 39.77 12.182 22.809 19.217 48.816 19.217 76.5 0 89.14-72.258 161.425-161.424 161.425-89.166 0-161.425-72.285-161.425-161.425 0-27.684 7.036-53.691 19.253-76.5 9.907-18.603 31.558-39.77 72.97-39.77h138.404Zm-9.021 42.948h-120.364c-21.132 0-38.356 17.233-38.356 38.365v89.649c0 21.167 17.224 38.355 38.356 38.355h120.364c21.167 0 38.355-17.188 38.355-38.355v-23.161h-20.93v23.161c0 9.608-7.825 17.425-17.425 17.425h-120.364c-9.6 0-17.425-7.817-17.425-17.425v-89.649c0-9.609 7.825-17.426 17.425-17.426h120.364c9.6 0 17.425 7.817 17.425 17.426v19.314h20.93v-19.314c0-21.132-17.188-38.365-38.355-38.365Zm-21.484 96.728h-85.257v20.922h85.257c5.771 0 10.47-4.664 10.47-10.426 0-5.797-4.699-10.496-10.47-10.496Zm0-47.999h-85.257v20.93h85.257c5.771 0 10.47-4.708 10.47-10.47 0-5.761-4.699-10.46-10.47-10.46Z",
    style: {
      fill: '#0098db',
      fillRule: 'nonzero'
    }
  }), React__default.createElement("path", {
    d: "M2205.07 3067.19h41.856c8.594 0 10.965 1.702 10.965 7.816v4.695c0 4.316-1.643 7.188-9.638 7.188h-43.183v-19.699Zm52.417-16.828c0 2.775-.858 6.462-8.19 6.462h-44.227v-17.675h44.672c1.295 0 7.745.25 7.745 5.26v5.953Zm6.069 10.277c3.82-2.016 5.972-5.582 5.972-10.18v-5.606c0-6.018-2.468-16.102-18.969-16.102h-57.531v68.512h58.446c12.519 0 18.5-6.091 18.5-15.472v-7.761c0-6.961-.761-11.438-6.418-13.391ZM2283.08 3028.75h10.941v68.504h-10.941zM2357.12 3075.83c0 8.817-1.958 12.665-20.766 12.665h-1.999c-14.348 0-15.425-3.784-15.425-9.616v-30.815h-10.965v32.711c0 6.429 2.719 17.206 20.766 17.206h11.694c7.655 0 13.474-.952 17.229-5.017v4.291h10.432v-49.191h-10.966v27.766ZM2430.18 3064.64v1.476h-40.212c.793-7.946 3.261-9.301 14.194-9.301h11.411c6.677 0 14.607 1.355 14.607 7.825m-14.607-17.312h-12.487c-11.977 0-24.246 2.396-24.246 20.167v10.027c0 18.127 12.487 20.458 23.332 20.458h14.129c11.573 0 24.845-1.734 24.845-15.327v-2.452h-10.836l-.097 1.476c-.381 5.526-2.752 6.816-12.649 6.816h-10.683c-13.401 0-17.067-2.5-17.067-11.6v-1.299h51.332v-6.743c0-18.958-12.924-21.523-25.573-21.523M2574.21 3077.82c0 7.341-1.991 9.769-13.782 9.769h-31.076c-9.8 0-13.814-3.566-13.814-12.294v-24.547c0-8.761 4.014-12.318 13.814-12.318h30.793c8.376 0 13.434.661 13.434 10.043v4.574h10.966v-7.18c0-14.746-12.042-17.836-22.126-17.836h-33.949c-17.739 0-24.942 7.559-24.942 26.056v17.86c0 18.498 7.203 26.04 24.942 26.04h33.472c19.827 0 23.776-7.567 23.776-19.82v-5.994h-11.508v5.647ZM2646.01 3075.83c0 8.817-1.959 12.665-20.766 12.665h-1.999c-14.349 0-15.425-3.784-15.425-9.616v-30.815h-10.966v32.711c0 6.429 2.687 17.206 20.766 17.206h11.694c7.656 0 13.475-.952 17.23-5.017v4.291h10.431v-49.191h-10.965v27.766ZM2799.2 3064.64v1.476h-40.246c.826-7.946 3.262-9.301 14.195-9.301h11.411c6.676 0 14.64 1.355 14.64 7.825m-14.64-17.312h-12.487c-11.978 0-24.214 2.396-24.214 20.167v10.027c0 18.127 12.455 20.458 23.299 20.458h14.13c11.573 0 24.877-1.734 24.877-15.327v-2.452h-10.868l-.097 1.476c-.381 5.526-2.72 6.816-12.641 6.816h-10.691c-13.369 0-17.035-2.5-17.035-11.6v-1.299h51.332v-6.743c0-18.958-12.924-21.523-25.605-21.523M2859.89 3047.34h-11.662c-7.688 0-13.466.944-17.261 5.01v-4.284h-10.4v49.192h10.934v-27.766c0-8.817 1.958-12.665 20.774-12.665h2.023c14.348 0 15.425 3.815 15.425 9.607v30.824h10.933v-32.711c0-6.429-2.687-17.207-20.766-17.207M2890.53 3037.17v44.714c0 10.681 6.603 16.101 19.633 16.101h3.949v-9.486h-2.719c-7.777 0-9.898-2.089-9.898-9.616v-21.337h12.779v-9.486h-12.779v-10.89h-10.965ZM2700.85 3047.34h-7.267c-5.503 0-9.768 1.452-12.713 4.316v-3.59h-10.432v49.192h10.974v-30.824c0-4.662 2.776-9.607 10.617-9.607h4.807c1.49 0 2.817.032 4.014.064v-9.551ZM2740.05 3047.34h-7.3c-5.503 0-9.735 1.452-12.713 4.316v-3.59h-10.399v49.192h10.941v-30.824c0-4.662 2.808-9.607 10.65-9.607h4.807c1.489 0 2.816.032 4.014.064v-9.551Z",
    style: {
      fill: '#37424a',
      fillRule: 'nonzero'
    }
  }), React__default.createElement("path", {
    d: "M2361.88 2304.5c174.762-156.198 174.698-399.131 0-555.267-6.569-5.872-17.693-5.987-24.507-.309l-36.228 30.187c-6.506 5.413-6.644 14.124-.406 19.749 142.566 128.647 142.598 327.348 0 456.022-6.238 5.625-6.089 14.335.406 19.748l36.228 30.187c6.814 5.669 17.938 5.555 24.507-.317Zm-557.085-555.266c-174.762 156.198-174.698 399.131 0 555.267 6.569 5.872 17.692 5.986 24.507.309l36.228-30.187c6.505-5.413 6.644-14.124.405-19.749-142.565-128.647-142.597-327.348 0-456.022 6.239-5.625 6.09-14.335-.405-19.749l-36.228-30.186c-6.815-5.669-17.938-5.555-24.507.317Zm121.076 98.954c-108.705 101.616-108.588 255.857 0 357.359 6.505 6.083 17.799 6.277 24.688.503l36.25-30.364c6.313-5.289 6.74-13.806.853-19.439-77.394-74.013-77.223-184.913 0-258.75 5.887-5.633 5.471-14.15-.853-19.44l-36.25-30.363c-6.889-5.783-18.193-5.581-24.688.494Zm314.933 357.358c108.705-101.616 108.588-255.857 0-357.359-6.506-6.084-17.799-6.277-24.689-.503l-36.249 30.363c-6.314 5.29-6.74 13.807-.853 19.44 77.393 74.013 77.223 184.913 0 258.75-5.887 5.633-5.471 14.15.853 19.439l36.249 30.364c6.89 5.783 18.194 5.58 24.689-.494Zm-230.35-176.21c0 40.064 32.471 72.534 72.535 72.534s72.534-32.47 72.534-72.534c0-40.064-32.47-72.535-72.534-72.535-40.064 0-72.535 32.471-72.535 72.535Z",
    style: {
      fill: '#fff'
    }
  }), React__default.createElement("path", {
    d: "M3537.84 2588.45a13.4 13.4 0 0 0-13.4-13.4h-27.46a13.4 13.4 0 0 0-13.4 13.4v.015a13.402 13.402 0 0 0 13.4 13.4h27.46a13.399 13.399 0 0 0 13.4-13.4v-.015ZM3613.34 2765.73a13.4 13.4 0 0 0-18.939.684l-18.704 20.105a13.404 13.404 0 0 0 .684 18.938l.011.01a13.4 13.4 0 0 0 18.938-.683l18.705-20.105a13.404 13.404 0 0 0-.684-18.938l-.011-.011ZM3558.43 2679.66a13.404 13.404 0 0 0-18.502-4.102l-12.421 7.913a13.402 13.402 0 0 0-4.102 18.501l.008.013a13.398 13.398 0 0 0 18.501 4.102l12.422-7.913a13.402 13.402 0 0 0 4.094-18.514ZM3703.32 2820.58a13.4 13.4 0 0 0-17.915 6.179l-6.45 13.24a13.4 13.4 0 0 0 6.178 17.915l.014.007a13.4 13.4 0 0 0 17.915-6.178l6.45-13.241a13.4 13.4 0 0 0-6.192-17.922ZM3557.35 2484.1a13.4 13.4 0 0 0-7.539-17.387l-13.697-5.411a13.4 13.4 0 0 0-17.392 7.553 13.397 13.397 0 0 0 7.539 17.386l13.697 5.412a13.4 13.4 0 0 0 17.392-7.553ZM4471.71 2709.95a13.399 13.399 0 0 0 13.4 13.4h27.46a13.4 13.4 0 0 0 13.4-13.4v-.016a13.4 13.4 0 0 0-13.4-13.4h-27.46a13.402 13.402 0 0 0-13.4 13.4v.016ZM4396.21 2532.67a13.4 13.4 0 0 0 18.938-.683l18.704-20.105a13.4 13.4 0 0 0-.683-18.938l-.012-.011a13.4 13.4 0 0 0-18.938.684l-18.704 20.105a13.399 13.399 0 0 0 .684 18.938l.011.01ZM4451.12 2618.74a13.4 13.4 0 0 0 18.501 4.102l12.422-7.913a13.402 13.402 0 0 0 4.102-18.502l-.009-.013a13.4 13.4 0 0 0-18.501-4.102l-12.421 7.913a13.4 13.4 0 0 0-4.102 18.502l.008.013ZM4306.22 2477.82a13.395 13.395 0 0 0 10.237.621 13.395 13.395 0 0 0 7.678-6.799l6.45-13.24a13.4 13.4 0 0 0-6.192-17.922 13.395 13.395 0 0 0-10.237-.621 13.395 13.395 0 0 0-7.678 6.799l-6.45 13.24a13.396 13.396 0 0 0-.621 10.237 13.395 13.395 0 0 0 6.813 7.685ZM4452.2 2814.3a13.4 13.4 0 0 0 7.539 17.386l13.697 5.412a13.4 13.4 0 0 0 17.392-7.553 13.402 13.402 0 0 0-7.539-17.387l-13.697-5.411a13.4 13.4 0 0 0-17.387 7.539l-.005.014Z",
    style: {
      fill: '#37424a'
    }
  }), React__default.createElement("text", {
    x: 2905.36,
    y: 4101.69,
    style: {
      fontFamily: 'Caveat',
      fontSize: 250,
      fill: '#37424a'
    },
    transform: "rotate(-22.158 -272.088 1523.858)"
  }, "Bliep"), React__default.createElement("text", {
    x: 3268.07,
    y: 4265.26,
    style: {
      fontFamily: 'Caveat',
      fontSize: 250,
      fill: '#37424a'
    },
    transform: "rotate(-22.158 90.624 1687.422)"
  }, "Bliep"));
}

function ChargeCards(props) {
  var renderChargeCard = function renderChargeCard(company) {
    switch (company) {
      case 'BlueCurrent':
        return React__default.createElement(ChargeCard, {
          serial: props.serial,
          shadow: props.shadow,
          borderRadius: props.borderRadius
        });
      default:
        return React__default.createElement(ChargeCard, {
          serial: props.serial,
          shadow: props.shadow,
          borderRadius: props.borderRadius
        });
    }
  };
  return React__default.createElement("div", {
    style: {}
  }, renderChargeCard(props.company));
}

function Curved(props) {
  var _props$width, _props$height, _props$position, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$color, _props$color2, _props$color3, _props$color4;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 100,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 50,
    viewBox: "0 0 100 50",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      zIndex: 1.1,
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1,
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2
    }
  }, React__default.createElement("path", {
    d: "M148.353 90.273c7.447-5.765 18.307-15.657 35.067-16.699 22.372-1.391 31.149 3.258 37.405 6.863 4.793 2.762 8.34 4.833 14.347 4.013 13.282-1.813 19.582-13.822 19.334-25.083-.168-7.605-3.358-14.76-9.091-18.253a2.299 2.299 0 0 0-2.392 3.924c4.496 2.739 6.757 8.467 6.889 14.43.2 9.089-4.642 18.966-15.362 20.429-4.814.658-7.59-1.228-11.43-3.441-6.692-3.856-16.057-8.956-39.985-7.468-17.922 1.114-29.632 11.487-37.595 17.652a2.297 2.297 0 0 0 2.813 3.633Z",
    style: {
      fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
    },
    transform: "translate(-102.92 -23.251) scale(.76169)"
  }), React__default.createElement("path", {
    d: "M153.94 75.287c-.058.385-.369 2.308-.84 3.639-.95 2.679-3.373 6.505-3.646 6.933-.306.158-.457.301-.502.339-.135.113-.7 6.254 3.058 4.997 1.79-.598 13.18-4.643 15.755-6.186a2.956 2.956 0 0 0 1.015-4.053 2.955 2.955 0 0 0-4.052-1.015c-1.094.656-3.913 1.785-6.802 2.867a34.82 34.82 0 0 0 .742-1.908c.764-2.155 1.21-4.209 1.196-5.632-.011-1.158-.304-2.075-.71-2.725a2.956 2.956 0 0 0-4.07-.944 2.957 2.957 0 0 0-1.144 3.688Zm-1.685 15.777.1-.055a2.404 2.404 0 0 1-.24.124l.14-.069Z",
    style: {
      fill: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY
    },
    transform: "translate(-105.904 -23.258) scale(.76169)"
  }), React__default.createElement("path", {
    d: "M150.261 101.537c1.624-1.193 6.579-3.377 10.056-4.546.686-.231 1.5-.438 2.006-.558a2.956 2.956 0 0 0 3.961-2.612c.054-.975-.278-1.751-.876-2.375-.398-.414-.986-.815-1.857-.97-.493-.087-1.288-.09-2.297.117-3.204.658-10.388 3.664-13.485 5.523-1.397.838-2.18 1.727-2.43 2.203a2.955 2.955 0 0 0 4.922 3.218Zm10.159-7.4Z",
    style: {
      fill: (_props$color3 = props.color) !== null && _props$color3 !== void 0 ? _props$color3 : Colors.GREY
    },
    transform: "translate(-103.686 -31.776) scale(.76169)"
  }), React__default.createElement("path", {
    d: "M133.379 67.031c-.904 2.394-5.42 13.358-5.81 14.474a2.955 2.955 0 0 0 1.814 3.763 2.955 2.955 0 0 0 3.763-1.814c.386-1.106 4.864-11.964 5.76-14.336a2.955 2.955 0 0 0-5.527-2.087Z",
    style: {
      fill: (_props$color4 = props.color) !== null && _props$color4 !== void 0 ? _props$color4 : Colors.GREY
    },
    transform: "translate(-90.286 -18.664) scale(.76169)"
  }));
}

function Arrows(props) {
  var render = function render() {
    switch (props.type) {
      case 'Curved':
        return React$4.createElement(Curved, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity
        });
      default:
        return React$4.createElement("div", null);
    }
  };
  return render();
}

export { Arrows as Arrow, Backgrounds, Badge, Breakpoint, Buttons$1 as Button, Carousel, Cell, ChargeCards as ChargeCard, GridItem as ChargePointGridItem, CircularArcMeter, ColorSchemes, Colors, ColumnTitle, Confetti, ContactCard, Container, MainContainer as ContentContainer, CookiePopup, CustomIcon, CustomModal, DropdownMenu, Footer, Form, GlobalHeader, Header, Icon, Image, InfoBlock, Input, Items as Item, ItemMenu, Lang, LargeContainer, Link, Loaders as Loader, Logo, MainContainer$1 as MainContainer, Modal, ModuleHeader, NavigationItem, Overlay, OverlaySearch, PortableTextComponent as PortableText, RangeMeter, Row, ScrollDownArrow, SegmentedControl, SideBarNavigation, SmallRound, Status, TabNavigation, Table, Tag, Text, TextBlock, Tip$1 as Tip, Title, Toast, Wrap, counter$1 as counter, currencyFormat, filterBasedOnId, filterBasedOnType, getColorScheme$1 as getColorScheme, getCurrency, getScrollDirection, getScrollHeight, scrollTo as scrollToId, toCapital, truncate, useDidMountEffect, useDimensions$1 as useDimensions, useSweetName };
